
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dPoYT", function(module, exports) {
const $8dbc220cf14fe789$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};
module.exports["ConversationAssistantUIModes"] = $8dbc220cf14fe789$export$bc36ebf73899a71d;

});

parcelRegister("gzMZq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $2a83073b2ae5e0c1$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        slidesContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        aiFeatureContext: {},
        isAIFeatureContextDismissed: false,
        contentTargets: {},
        currentTargetId: undefined,
        pageSmartLinks: undefined,
        isSmartCreationModalOpen: false
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                // Honour the user's explicit "Remove context" action
                if (state.isAIFeatureContextDismissed) return;
                const currentAIFeatureContextState = state.aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        setAIFeatureContextDismissed: (isDismissed)=>({ setState: setState })=>{
                setState(isDismissed ? {
                    aiFeatureContext: {},
                    isAIFeatureContextDismissed: true
                } : {
                    isAIFeatureContextDismissed: false
                });
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getJiraCreateContext: ()=>({ getState: getState })=>getState().jiraCreateContext,
        setJiraCreateContext: (jiraCreateContext)=>({ setState: setState })=>{
                setState({
                    jiraCreateContext: jiraCreateContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        updateEditorContextIsViewMode: (isViewMode)=>({ setState: setState, getState: getState })=>{
                const { editorContext: editorContext } = getState();
                if (editorContext) setState({
                    editorContext: {
                        ...editorContext,
                        isViewMode: isViewMode
                    }
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getSlidesContext: ()=>({ getState: getState })=>getState().slidesContext,
        setSlidesContext: (slidesContext)=>({ setState: setState })=>{
                setState({
                    slidesContext: slidesContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        mergeDatabaseContext: (partial)=>({ getState: getState, setState: setState })=>{
                // If no selected elements published, clean up the database context
                if (!partial?.selectedElementIds) {
                    setState({
                        databaseContext: undefined
                    });
                    return;
                }
                const current = getState().databaseContext;
                setState({
                    databaseContext: current ? {
                        ...current,
                        ...partial
                    } : partial
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        setPageSmartLinks: (pageSmartLinks)=>({ setState: setState })=>{
                setState({
                    pageSmartLinks: pageSmartLinks
                });
            },
        getTarget: (contentContext, activeTargetId)=>({ getState: getState })=>{
                const targets = getState().contentTargets[contentContext];
                if (!targets) return undefined;
                // targets is always an array
                const targetList = targets;
                // If activeTargetId provided, find it; otherwise return first target
                if (activeTargetId) return targetList.find((t)=>t.id === activeTargetId);
                return targetList[0];
            },
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                for (const [context, targets] of entries){
                    const targetList = targets;
                    if (targetList.some((t)=>t.id === contentId)) return context;
                }
                return undefined;
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const state = getState();
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                // `isSmartCreationModalOpen` covers the window before any staging-area content target
                // exists yet (e.g. a clarifying question asked before content generation starts) —
                // without it, this would incorrectly resolve to 'global' for that window.
                if (state.contentTargets['staging-area'] || state.isSmartCreationModalOpen) return 'staging-area';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                const currentTargets = getState().contentTargets;
                // Store as array, append if not already present
                const existing = currentTargets[toAdd];
                const targetList = existing ?? [];
                // Avoid duplicates by checking if target with same id exists
                // & filter out any targets with empty IDs to avoid stale targets
                const filtered = targetList.filter((t)=>t.id !== '' && t.id !== target.id);
                filtered.push(target);
                setState({
                    contentTargets: {
                        ...currentTargets,
                        [toAdd]: filtered
                    }
                });
            },
        clearTarget: (toRemove, targetId)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k !== toRemove) nextState[k] = currentState[k];
                    else if (targetId) {
                        // If a specific targetId is provided, filter out that target
                        const targetList = currentState[k];
                        const filtered = targetList.filter((t)=>t.id !== targetId);
                        if (filtered.length > 0) nextState[k] = filtered;
                    }
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId,
        setIsSmartCreationModalOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isSmartCreationModalOpen: isOpen
                });
            },
        getIsSmartCreationModalOpen: ()=>({ getState: getState })=>getState().isSmartCreationModalOpen
    }
});
const $2a83073b2ae5e0c1$export$53bf948a400e8426 = (0, $kBr4q.createActionsHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9);
const $2a83073b2ae5e0c1$export$9465f65715425f1b = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $2a83073b2ae5e0c1$export$eea520981851a092 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $2a83073b2ae5e0c1$export$c517e9a5e436c401 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.slidesContext
});
const $2a83073b2ae5e0c1$export$debe3dc2612d2a8e = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.databaseContext
});
const $2a83073b2ae5e0c1$export$376b2a7bf70dad8 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $2a83073b2ae5e0c1$export$6280f21050465fe4 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageSmartLinks
});
const $2a83073b2ae5e0c1$export$3794ec8d9f571031 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.aiFeatureContext
});
const $2a83073b2ae5e0c1$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext, useCurrentPageContext: useCurrentPageContext })=>{
    const actions = $2a83073b2ae5e0c1$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $cozmU.useCallback)(async ({ type: type, contentContext: contentContext, activeTargetId: activeTargetId, source: source, prompt: prompt })=>{
        const currentTargetId = getCurrentTargetId();
        const contentTarget = getTarget(contentContext, activeTargetId);
        if (!contentTarget) return undefined;
        // Only use currentTargetId when staging-area doesn't exist
        // to avoid changing any content open behind the staging
        // area modal
        const shouldUseCurrentTargetId = type === 'page' && !getTarget('staging-area');
        const selectedTargetId = shouldUseCurrentTargetId ? currentTargetId || contentTarget.id : contentTarget.id;
        const contentBody = await getContentBody({
            type: type,
            id: selectedTargetId,
            source: source,
            prompt: prompt
        });
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                if (!contentBody.pageBody) return undefined;
                return {
                    contentId: contentBody.contentId,
                    editorStreamingContractVersion: contentBody.editorStreamingContractVersion,
                    hasRealTimeCollab: contentBody.hasRealTimeCollab,
                    useFastPath: contentBody.useFastPath,
                    document: {
                        type: 'text/adf',
                        content: contentBody.pageBody
                    },
                    selection: {
                        type: 'text/markdown',
                        content: contentBody.selectionMarkdown || ''
                    },
                    selectionFragment: contentBody.selectionFragment,
                    selectionLocalIds: contentBody.selectionLocalIds,
                    contentMauiId: contentBody.contentMauiId,
                    dynamicUiSource: contentBody.dynamicUiSource,
                    dynamicUiType: contentBody.dynamicUiType,
                    dynamicUiSubtype: contentBody.dynamicUiSubtype,
                    mediaFileId: contentBody.mediaFileId,
                    mediaCollection: contentBody.mediaCollection,
                    isViewMode: contentBody.isViewMode,
                    isDraftLockedForEditing: contentBody.isDraftLockedForEditing,
                    useGenericEditorSkill: contentBody.useGenericEditorSkill,
                    additionalContext: contentBody.additionalContext
                };
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'slide':
                if (!contentBody.xml) return undefined;
                return {
                    contentId: contentBody.contentId,
                    xml: contentBody.xml,
                    title: contentBody.title,
                    url: contentBody.url,
                    selectedSlideIndex: contentBody.selectedSlideIndex,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url,
                    isViewMode: contentBody.isViewMode
                };
            case 'dashboard':
                if (!contentBody.content) return undefined;
                return {
                    content: contentBody.content,
                    dashboardAri: contentBody.dashboardAri,
                    isEditing: contentBody.isEditing,
                    chartResponseData: contentBody.chartResponseData,
                    location: contentBody.location,
                    products: contentBody.products,
                    subProducts: contentBody.subProducts
                };
            default:
                return undefined;
        }
    }, [
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
   * Fetches the context of a currently live page with Rovo chat open.
   *
   * @description see full list of cases to consider in {@link getContextRequirements}
   */ const getEditorContext = (0, $cozmU.useCallback)(async ({ source: source_0, prompt: prompt_0, contentContext: contentContext_0, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId_0 })=>{
        const isAifcEnabled = (0, $iDrrr.fg)('aifc_create_enabled');
        const shouldProvideContext = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_0,
            source: source_0,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent({
            type: 'page',
            contentContext: contentContext_0,
            activeTargetId: activeTargetId_0,
            source: source_0,
            prompt: prompt_0
        }) : actions.getEditorContext();
    }, [
        actions,
        fetchContent
    ]);
    /**
   * Fetches the context of a currently live page with Rovo chat open.
   *
   * @description see full list of cases to consider in {@link getContextRequirements}
   */ const getWhiteboardContext = (0, $cozmU.useCallback)(async ({ source: source_1, contentContext: contentContext_1, isFirstPrompt: isFirstPrompt_0, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_0, activeTargetId: activeTargetId_1 })=>{
        const isAifcEnabled_0 = (0, $iDrrr.fg)('aifc_create_enabled');
        const shouldProvideContext_0 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_1,
            source: source_1,
            isFirstPrompt: isFirstPrompt_0,
            isAifcEnabled: isAifcEnabled_0,
            userPreference: addCurrentPageAsContextUserPreference_0
        });
        if (!shouldProvideContext_0) return undefined;
        return isAifcEnabled_0 ? await fetchContent({
            type: 'whiteboard',
            contentContext: contentContext_1,
            activeTargetId: activeTargetId_1
        }) : actions.getWhiteboardContext();
    }, [
        actions,
        fetchContent
    ]);
    const getSlidesContext = (0, $cozmU.useCallback)(async ({ source: source_2, contentContext: contentContext_2, isFirstPrompt: isFirstPrompt_1, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_1, activeTargetId: activeTargetId_2 })=>{
        const isAifcEnabled_1 = (0, $cXtTj.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false);
        const shouldProvideContext_1 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_2,
            source: source_2,
            isFirstPrompt: isFirstPrompt_1,
            isAifcEnabled: isAifcEnabled_1,
            userPreference: addCurrentPageAsContextUserPreference_1
        });
        if (!shouldProvideContext_1) return undefined;
        return isAifcEnabled_1 ? await fetchContent({
            type: 'slide',
            contentContext: contentContext_2,
            activeTargetId: activeTargetId_2
        }) : actions.getSlidesContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $cozmU.useCallback)(async ({ source: source_3, contentContext: contentContext_3, isFirstPrompt: isFirstPrompt_2, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_2, activeTargetId: activeTargetId_3 })=>{
        const isAifcEnabled_2 = (0, $iDrrr.fg)('aifc_create_enabled');
        const shouldProvideContext_2 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_3,
            source: source_3,
            isFirstPrompt: isFirstPrompt_2,
            isAifcEnabled: isAifcEnabled_2,
            userPreference: addCurrentPageAsContextUserPreference_2
        });
        if (!shouldProvideContext_2) return undefined;
        return isAifcEnabled_2 ? await fetchContent({
            type: 'database',
            contentContext: contentContext_3,
            activeTargetId: activeTargetId_3
        }) : actions.getDatabaseContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDashboardEditorContext = (0, $cozmU.useCallback)(async ({ contentContext: contentContext_4, activeTargetId: activeTargetId_4 })=>{
        return await fetchContent({
            type: 'dashboard',
            contentContext: contentContext_4,
            activeTargetId: activeTargetId_4
        });
    }, [
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $cozmU.useCallback)(({ contentContext: contentContext_5, isFirstPrompt: isFirstPrompt_3 })=>{
        if (contentContext_5 === 'staging-area' && !isFirstPrompt_3 && (0, $iDrrr.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext_5)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $cozmU.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    /**
   * Whether the chat was launched about one specific linked thing, rather than about the page the
   * user is on. Several flows do this — the Smart Link toolbar, pinned items, onboarding — and all
   * of them put the target in `aiFeatureContext.projectContext`.
   *
   * Rovo Spaces launches populate `projectContext` too, but with `projectUrl: ''`, because a space
   * has no canonical URL. Those should still offer the current page, hence the non-empty check.
   */ const hasEntityContext = (0, $cozmU.useCallback)(()=>{
        const projectContext = actions.getAIFeatureContext()?.projectContext;
        return typeof projectContext?.projectUrl === 'string' && projectContext.projectUrl !== '';
    }, [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $cozmU.useCallback)((addCurrentPageAsContextUserPreference_3)=>{
        // Drive useCurrentBrowsingContext directly from the chat mode store's
        // `useCurrentPageContext` toggle: when the user has current-page context
        // enabled we treat the current page as usable context, and off otherwise.
        if ((0, $iDrrr.fg)('rovo_browsing_context_from_banner')) {
            // A `true` here tells the backend to use `browser_url`, so a chat launched about a
            // link would answer about the host page instead of the link. `useCurrentPageContext`
            // cannot be used to spot that case: such launches force it on, because the context
            // banner only renders while it is true.
            if (hasEntityContext() && (0, $iDrrr.fg)('rovo_chat_smartlink_entity_context_killswitch')) return false;
            return useCurrentPageContext;
        }
        // If the user has explicitly turned off "use current page as context" (e.g.
        // by dismissing the context banner), send false rather than undefined so the
        // backend is explicitly told not to use the browserUrl as context. This is
        // required in edit mode, where useCurrentNonEditingPageAsContext is undefined
        // but the user preference is set to false on dismiss. the value is sent as true
        // when the context is enabled in the chat banner.
        if (addCurrentPageAsContextUserPreference_3) return addCurrentPageAsContextUserPreference_3;
        // undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference_3 && useCurrentNonEditingPageAsContext;
    }, [
        useCurrentNonEditingPageAsContext,
        getIsStagingArea,
        useCurrentPageContext,
        hasEntityContext
    ]);
    const getBrowserContext = (0, $cozmU.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_4, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled && !(0, $cXtTj.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference_4) return undefined;
        const storedBrowserContext = actions.getBrowserContext();
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        if (!browserContextResult) return storedBrowserContext;
        if (browserContextResult.selection) return {
            context: browserContextResult
        };
        const storedSelection = storedBrowserContext?.context?.selection;
        return {
            context: storedSelection ? {
                ...browserContextResult,
                selection: storedSelection
            } : browserContextResult
        };
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $cozmU.useCallback)(async ()=>{
        const isStagingArea = getIsStagingArea();
        if (!isStagingArea) {
            const jiraCreateContext = actions.getJiraCreateContext();
            if (jiraCreateContext?.draftWorkItems) return jiraCreateContext;
        }
        // Fallback to bridge API if available (staging area doesn't have the state in sync with the chat store)
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext,
        actions,
        getIsStagingArea
    ]);
    return {
        ...actions,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSlidesContext: getSlidesContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getDashboardEditorContext: getDashboardEditorContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $2a83073b2ae5e0c1$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
   * If AIFC is not enabled, we default to the user's preference.
   */ if (!isAifcEnabled) return userPreference;
    /**
   * In the staging area, we always want to provide context if the source is the
   * inline editor, from the blank object experience, or if the prompt is not the
   * first in a new conversation.
   */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_MAUI_INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP' || source === 'CONFLUENCE_CWR_TEMPLATE' || source === 'CONFLUENCE_CWR_BLANK_OBJECT';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
     * On real content when AIFC is enabled, we only want to default to true
     * if the source of the content is the inline editing experience. Otherwise,
     * we want to respect the preference chosen by the user.
     */ return sourceEligible || userPreference;
}
module.exports["useChatContextStoreActions"] = $2a83073b2ae5e0c1$export$53bf948a400e8426;
module.exports["useChatContextEditorContext"] = $2a83073b2ae5e0c1$export$9465f65715425f1b;
module.exports["useChatContextDatabaseContext"] = $2a83073b2ae5e0c1$export$debe3dc2612d2a8e;
module.exports["useChatContextBrowserContext"] = $2a83073b2ae5e0c1$export$376b2a7bf70dad8;
module.exports["useChatContextPageSmartLinks"] = $2a83073b2ae5e0c1$export$6280f21050465fe4;
module.exports["useChatContextAIFeatureContext"] = $2a83073b2ae5e0c1$export$3794ec8d9f571031;
module.exports["useChatContextProvider"] = $2a83073b2ae5e0c1$export$904052abb7b98535;

});

parcelRegister("l2exp", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");


var $8lhhf = parcelRequire("8lhhf");

/**
 * URL-based first-party (1P) vs third-party (3P) classifier for links found in
 * finalized CWR (Create With Rovo) ADF content.
 */ function $fc385e4b36cd85fa$export$8c4674ec524aaf2c(resourceUrl) {
    if (!resourceUrl) return false;
    // Coarse URL-substring buckets — kept bug-for-bug in sync with `getLinkType` in the Confluence source of truth.
    const isJira = resourceUrl.includes('/jira/') || resourceUrl.includes('/servicedesk/') || resourceUrl.includes('/helpcenter/') || resourceUrl.includes('/projects/');
    const isConfluence = resourceUrl.includes('/wiki/');
    const isBitbucket = resourceUrl.includes('bitbucket');
    const isOtherAtlassian = resourceUrl.includes('atlassian') || resourceUrl.includes('jira-dev');
    return isJira || isConfluence || isBitbucket || isOtherAtlassian;
}



var $8et9H = parcelRequire("8et9H");

const $55f222983c253e4b$var$countThirdPartySmartLink = (currentValue, url)=>{
    if (!url || (0, $fc385e4b36cd85fa$export$8c4674ec524aaf2c)(url)) return currentValue;
    const count3PSources = currentValue.count3PSources + 1;
    return {
        ...currentValue,
        count3PSources: count3PSources,
        has3PSources: true
    };
};
const $55f222983c253e4b$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            {
                const linkMark = node.marks?.find((mark)=>mark.type === 'link');
                const linkCount = linkMark ? currentValue.linkCount + 1 : currentValue.linkCount;
                const linkHref = typeof linkMark?.attrs?.href === 'string' ? linkMark.attrs.href : undefined;
                return $55f222983c253e4b$var$countThirdPartySmartLink({
                    ...currentValue,
                    textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                    wordCount: currentValue.wordCount + (0, $8et9H.wordCount)(node.text),
                    linkCount: linkCount
                }, linkHref);
            }
        case 'mention':
            return {
                ...currentValue,
                mentionCount: currentValue.mentionCount + 1
            };
        case 'inlineCard':
        case 'embedCard':
        case 'blockCard':
            return $55f222983c253e4b$var$countThirdPartySmartLink({
                ...currentValue,
                linkCount: currentValue.linkCount + 1
            }, typeof node.attrs?.url === 'string' ? node.attrs.url : undefined);
        case 'inlineExtension':
            if (node.attrs?.extensionKey === (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY) && node.attrs?.parameters?.slug) return {
                ...currentValue,
                explicitSkills: [
                    ...currentValue.explicitSkills,
                    node.attrs.parameters.slug
                ]
            };
            return currentValue;
    }
    return currentValue;
};
const $55f222983c253e4b$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        adfLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        linkCount: 0,
        mentionCount: 0,
        explicitSkills: [],
        // Initialised because the reducer only assigns these on a 3P hit — pages with zero/only-1P sources must still emit stable neutral values to Data Portal.
        has3PSources: false,
        count3PSources: 0
    };
    return (0, $4EPzQ.reduce)(adf, (currentValue, node)=>$55f222983c253e4b$var$processADFNode(currentValue, node), initialFeatures);
};
module.exports["extractContentFeatures"] = $55f222983c253e4b$export$a148305df2eb5487;

});

parcelRegister("aYC8J", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7lXV4 = parcelRequire("7lXV4");


var $3wccB = parcelRequire("3wccB");


var $5OXoi = parcelRequire("5OXoi");


var $6isLN = parcelRequire("6isLN");

function $4f22b85ba3ca0c76$export$a4068a52445901dc(data, props) {
    return data !== null && typeof data === 'object' && props.every((prop)=>data.hasOwnProperty(prop));
}
const $4f22b85ba3ca0c76$export$740b9b28cb05ebd6 = 'dynamic-ui-create';
function $4f22b85ba3ca0c76$export$6da360af78d7e3dd(data) {
    return $4f22b85ba3ca0c76$export$a4068a52445901dc(data, [
        'id'
    ]);
}
function $4f22b85ba3ca0c76$export$da7aa926fc604bd7(data) {
    return $4f22b85ba3ca0c76$export$a4068a52445901dc(data, [
        'id',
        'previousMauiId',
        'contentType'
    ]) && data.previousMauiId != null;
}
function $4f22b85ba3ca0c76$export$3147e11228ebc102(action) {
    return $4f22b85ba3ca0c76$export$6da360af78d7e3dd(action.data);
}
const $4f22b85ba3ca0c76$export$440c8d4309cb1c9 = (data)=>{
    if (data?.id) return `${window.location.origin}/remix/ui/${encodeURIComponent(data.id)}`;
    return null;
};
const $4f22b85ba3ca0c76$export$4a9884303bce30ff = 'image-create';
function $4f22b85ba3ca0c76$export$ce86c52462376ef2(data) {
    return $4f22b85ba3ca0c76$export$a4068a52445901dc(data, [
        'mediaFileId'
    ]);
}
function $4f22b85ba3ca0c76$export$3b2fa4f5aa307773(data) {
    return $4f22b85ba3ca0c76$export$a4068a52445901dc(data, [
        'mediaFileId',
        'previousMediaFileId',
        'mediaCollection'
    ]) && data.previousMediaFileId != null;
}
function $4f22b85ba3ca0c76$export$ef033f677befc7d4(action) {
    return action.key === $4f22b85ba3ca0c76$export$4a9884303bce30ff && $4f22b85ba3ca0c76$export$ce86c52462376ef2(action.data);
}
function $4f22b85ba3ca0c76$export$3bb9ace6cd5cc74a(data) {
    return $4f22b85ba3ca0c76$export$a4068a52445901dc(data, [
        'previousMediaFileId'
    ]);
}
const $4f22b85ba3ca0c76$export$3fe1804ad3d5b936 = (remixSubtype)=>{
    if (!(0, $iDrrr.fg)('cc-maui-add-mark-for-remix-generated-images')) return undefined;
    if (!remixSubtype) return 'remix';
    // Unlike remixSubtype, dynamicUiType isn't available on the image-create backend payload or the insert
    // content command. Sourcing it would require either a backend change or importing from malleable-ui-components.
    // This simple inference avoids both while producing the correct result, at least until additional 'image'
    // subtypes are added. Ticket: https://hello.jira.atlassian.cloud/jira/browse/A4C-7193
    const remixType = remixSubtype === 'image' ? 'image' : 'infographic';
    return `remix:${remixType}:${remixSubtype}`;
};
const $4f22b85ba3ca0c76$var$MEDIA_BASE_URL_STAGING = 'https://media.staging.atl-paas.net';
const $4f22b85ba3ca0c76$var$MEDIA_BASE_URL_PROD = 'https://media-cdn.atlassian.com';
const $4f22b85ba3ca0c76$export$4e8e610ccc58ae5b = ({ fileId: fileId, token: token, collection: collection, clientId: clientId, isStaging: isStaging })=>{
    const baseUrl = isStaging ? $4f22b85ba3ca0c76$var$MEDIA_BASE_URL_STAGING : $4f22b85ba3ca0c76$var$MEDIA_BASE_URL_PROD;
    const url = new URL(`${baseUrl}/file/${fileId}/image`);
    url.searchParams.set('token', token);
    url.searchParams.set('issuer', 'micros/convo-ai');
    url.searchParams.set('collection', collection);
    url.searchParams.set('client', clientId);
    return url.toString();
};
const $4f22b85ba3ca0c76$export$7afb9b8acd50eb4e = 'aifc-confluence-page-create';
function $4f22b85ba3ca0c76$export$77c5629325e9aaaf(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'adf' in data && 'contentId' in data;
}
const $4f22b85ba3ca0c76$export$b632d4bc1af2f7d3 = 'aifc-deep-research-confluence-page-create';
function $4f22b85ba3ca0c76$export$3bd74956949aecbc(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'content' in data && 'contentId' in data;
}
function $4f22b85ba3ca0c76$export$d6ad19367a51fe7a(data) {
    return typeof data === 'object' && data !== null && 'contentId' in data;
}
const $4f22b85ba3ca0c76$export$88028308fe524b8a = 'aifc-confluence-page-update';
const $4f22b85ba3ca0c76$export$bb3d6eff667f4678 = 'aifc-adf-update';
const $4f22b85ba3ca0c76$export$7cca3e34118747ef = 'aifc-action-classification-metadata';
function $4f22b85ba3ca0c76$export$4f41f9d38097cf0a(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
function $4f22b85ba3ca0c76$export$1cf42b66f457bc6c(data) {
    return typeof data === 'object' && data !== null && 'toolCalls' in data && 'contentId' in data && typeof data.toolCalls === 'string' && typeof data.contentId === 'string';
}
function $4f22b85ba3ca0c76$export$fbc8213fc156433a(data) {
    return typeof data === 'object' && data !== null && 'promptVersion' in data && typeof data.promptVersion === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$279c9cc61f7f510a = 'aifc-confluence-whiteboard-create';
function $4f22b85ba3ca0c76$export$392158ed2444b56b(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$823e13f43093123d = 'aifc-confluence-slides-create';
function $4f22b85ba3ca0c76$export$ae4ad515c9dd259d(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$49b21a7401bcc85 = 'aifc-confluence-slides-update';
function $4f22b85ba3ca0c76$export$3d6de0a3c3e39cbf(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$d5d2204eeb3fde50 = 'aifc-confluence-whiteboard-update';
function $4f22b85ba3ca0c76$export$35d2029c1a7b307c(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$771989b0afde4911 = 'aifc-confluence-whiteboard-to-page';
const $4f22b85ba3ca0c76$export$325918e7af3a74aa = 'confluence-whiteboard-brainstorming';
function $4f22b85ba3ca0c76$export$48e8bcda6802129c(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$e3c19505945cf210 = 'confluence-whiteboard-diagramming';
const $4f22b85ba3ca0c76$export$c8f288feec1641d9 = 'aifc-confluence-whiteboard-diagramming';
function $4f22b85ba3ca0c76$export$f3a918f4f62365b2(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'diagramType' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c = 'aifc-confluence-database-create';
function $4f22b85ba3ca0c76$export$4dec930442f5ade2(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $4f22b85ba3ca0c76$export$ee0a705006a79cfe = 'aifc-confluence-database-update';
function $4f22b85ba3ca0c76$export$dbed60ca289ab1f3(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
const $4f22b85ba3ca0c76$export$691e9b05e574e32c = 'aifc-confluence-space-create';
function $4f22b85ba3ca0c76$export$545244afe3ae2546(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $4f22b85ba3ca0c76$export$af91dd9bf235f890 = 'aifc-confluence-space-update';
function $4f22b85ba3ca0c76$export$38f648644a8b3072(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $4f22b85ba3ca0c76$export$9f62c3ae716c44b2 = new Set([
    $4f22b85ba3ca0c76$export$7afb9b8acd50eb4e,
    $4f22b85ba3ca0c76$export$771989b0afde4911,
    $4f22b85ba3ca0c76$export$b632d4bc1af2f7d3
]);
const $4f22b85ba3ca0c76$export$aba0c096f5cdcaca = new Set([
    $4f22b85ba3ca0c76$export$279c9cc61f7f510a
]);
const $4f22b85ba3ca0c76$export$b9c5aef93dba02df = new Set([
    $4f22b85ba3ca0c76$export$823e13f43093123d
]);
const $4f22b85ba3ca0c76$export$45a7157715c10f20 = new Set([
    $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c
]);
const $4f22b85ba3ca0c76$var$SPACE_CREATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$691e9b05e574e32c
]);
const $4f22b85ba3ca0c76$var$CREATABLE_ACTION_KEYS = new Set([
    ...$4f22b85ba3ca0c76$export$9f62c3ae716c44b2,
    ...$4f22b85ba3ca0c76$export$aba0c096f5cdcaca,
    ...$4f22b85ba3ca0c76$export$b9c5aef93dba02df,
    ...$4f22b85ba3ca0c76$export$45a7157715c10f20,
    ...$4f22b85ba3ca0c76$var$SPACE_CREATE_ACTIONS
]);
const $4f22b85ba3ca0c76$var$PAGE_UPDATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$88028308fe524b8a,
    $4f22b85ba3ca0c76$export$bb3d6eff667f4678,
    $4f22b85ba3ca0c76$export$740b9b28cb05ebd6,
    $4f22b85ba3ca0c76$export$4a9884303bce30ff
]);
const $4f22b85ba3ca0c76$var$WHITEBOARD_UPDATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$d5d2204eeb3fde50,
    $4f22b85ba3ca0c76$export$325918e7af3a74aa,
    $4f22b85ba3ca0c76$export$e3c19505945cf210,
    $4f22b85ba3ca0c76$export$c8f288feec1641d9
]);
const $4f22b85ba3ca0c76$var$SLIDES_UPDATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$49b21a7401bcc85
]);
const $4f22b85ba3ca0c76$var$DATABASE_UPDATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$ee0a705006a79cfe
]);
const $4f22b85ba3ca0c76$var$SPACE_UPDATE_ACTIONS = new Set([
    $4f22b85ba3ca0c76$export$af91dd9bf235f890
]);
const $4f22b85ba3ca0c76$var$UPDATABLE_ACTION_KEYS = new Set([
    ...$4f22b85ba3ca0c76$var$PAGE_UPDATE_ACTIONS,
    ...$4f22b85ba3ca0c76$var$WHITEBOARD_UPDATE_ACTIONS,
    ...$4f22b85ba3ca0c76$var$SLIDES_UPDATE_ACTIONS,
    ...$4f22b85ba3ca0c76$var$DATABASE_UPDATE_ACTIONS,
    ...$4f22b85ba3ca0c76$var$SPACE_UPDATE_ACTIONS
]);
const $4f22b85ba3ca0c76$export$6c0ed26dac146a75 = (action)=>$4f22b85ba3ca0c76$export$9f62c3ae716c44b2.has(action.key);
const $4f22b85ba3ca0c76$export$eac4577c3e50732a = (action)=>$4f22b85ba3ca0c76$var$CREATABLE_ACTION_KEYS.has(action.key);
const $4f22b85ba3ca0c76$export$a70db46a9e5e9e4a = (action)=>$4f22b85ba3ca0c76$export$eac4577c3e50732a(action) && !!action.data?.metadata?.isExistingContent && (0, $iDrrr.fg)('confluence_aifc_create_on_existing');
const $4f22b85ba3ca0c76$export$79fc6c76b9755410 = (action)=>$4f22b85ba3ca0c76$export$eac4577c3e50732a(action) && !$4f22b85ba3ca0c76$export$a70db46a9e5e9e4a(action);
const $4f22b85ba3ca0c76$export$6b900ddfe8315d64 = (action)=>!!action?.data?.metadata?.serverSideExecution;
const $4f22b85ba3ca0c76$export$53f0114d9f187b14 = (action)=>action.key === $4f22b85ba3ca0c76$export$740b9b28cb05ebd6;
const $4f22b85ba3ca0c76$export$b3dfc475c0b1ff86 = (action)=>action.key === $4f22b85ba3ca0c76$export$4a9884303bce30ff;
const $4f22b85ba3ca0c76$export$dfda1ac7e19cab7b = (action)=>$4f22b85ba3ca0c76$var$PAGE_UPDATE_ACTIONS.has(action.key);
const $4f22b85ba3ca0c76$export$dcbfc8a9b613cd00 = (action)=>$4f22b85ba3ca0c76$var$WHITEBOARD_UPDATE_ACTIONS.has(action.key);
const $4f22b85ba3ca0c76$export$5d2d4e8984b13e00 = (action)=>$4f22b85ba3ca0c76$var$SLIDES_UPDATE_ACTIONS.has(action.key);
const $4f22b85ba3ca0c76$export$399c9116e9984ca3 = (action)=>$4f22b85ba3ca0c76$var$DATABASE_UPDATE_ACTIONS.has(action.key);
const $4f22b85ba3ca0c76$export$73dc9ed6ed2373f = (action)=>$4f22b85ba3ca0c76$var$UPDATABLE_ACTION_KEYS.has(action.key);
const $4f22b85ba3ca0c76$export$54716060fc6e52ee = (action)=>$4f22b85ba3ca0c76$export$eac4577c3e50732a(action) || $4f22b85ba3ca0c76$export$73dc9ed6ed2373f(action);
// ============================================================================
// CONFLUENCE PREVIEW CARDS
// ============================================================================
const $4f22b85ba3ca0c76$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    $4f22b85ba3ca0c76$export$7afb9b8acd50eb4e,
    $4f22b85ba3ca0c76$export$b632d4bc1af2f7d3,
    $4f22b85ba3ca0c76$export$279c9cc61f7f510a,
    $4f22b85ba3ca0c76$export$823e13f43093123d,
    $4f22b85ba3ca0c76$export$771989b0afde4911,
    $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c
]);
const $4f22b85ba3ca0c76$export$5cb5e5f4b4ce0a33 = (action)=>$4f22b85ba3ca0c76$var$PREVIEW_CARD_ACTION_KEYS.has(action.key) && !$4f22b85ba3ca0c76$export$a70db46a9e5e9e4a(action);
const $4f22b85ba3ca0c76$export$681cf9ea58de88fd = (action, selectedPreviewContentId)=>{
    if (!action?.key) return;
    switch(action.key){
        case $4f22b85ba3ca0c76$export$279c9cc61f7f510a:
            return (0, $6isLN.getConfluenceWhiteboardClientId)(selectedPreviewContentId);
        case $4f22b85ba3ca0c76$export$823e13f43093123d:
        case $4f22b85ba3ca0c76$export$49b21a7401bcc85:
            return (0, $3wccB.getConfluenceSlidesClientId)(selectedPreviewContentId);
        case $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c:
            return (0, $7lXV4.getConfluenceDatabaseClientId)(selectedPreviewContentId);
        default:
            return (0, $5OXoi.getConfluenceEditorClientId)(selectedPreviewContentId);
    }
};
const $4f22b85ba3ca0c76$export$bb9f6b0763834612 = (action)=>{
    const actionKey = action.key;
    if ($4f22b85ba3ca0c76$export$9f62c3ae716c44b2.has(actionKey) || $4f22b85ba3ca0c76$var$PAGE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-page';
    if ($4f22b85ba3ca0c76$export$aba0c096f5cdcaca.has(actionKey) || $4f22b85ba3ca0c76$var$WHITEBOARD_UPDATE_ACTIONS.has(actionKey)) return 'confluence-whiteboard';
    if ($4f22b85ba3ca0c76$export$b9c5aef93dba02df.has(actionKey) || $4f22b85ba3ca0c76$var$SLIDES_UPDATE_ACTIONS.has(actionKey)) return 'confluence-slide';
    if ($4f22b85ba3ca0c76$export$45a7157715c10f20.has(actionKey) || $4f22b85ba3ca0c76$var$DATABASE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-database';
    if ($4f22b85ba3ca0c76$var$SPACE_CREATE_ACTIONS.has(actionKey) || $4f22b85ba3ca0c76$var$SPACE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-space';
    return undefined;
};
// This mapping should contain the type guards of those actions that support data
// accumulation as defined below in `getPrimaryAccumulatedValue`.
const $4f22b85ba3ca0c76$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS = {
    [$4f22b85ba3ca0c76$export$7afb9b8acd50eb4e]: $4f22b85ba3ca0c76$export$77c5629325e9aaaf,
    [$4f22b85ba3ca0c76$export$b632d4bc1af2f7d3]: $4f22b85ba3ca0c76$export$3bd74956949aecbc,
    [$4f22b85ba3ca0c76$export$9f1bd612d6abcf5c]: $4f22b85ba3ca0c76$export$4dec930442f5ade2,
    [$4f22b85ba3ca0c76$export$279c9cc61f7f510a]: $4f22b85ba3ca0c76$export$392158ed2444b56b,
    [$4f22b85ba3ca0c76$export$823e13f43093123d]: $4f22b85ba3ca0c76$export$ae4ad515c9dd259d
};
const $4f22b85ba3ca0c76$export$b95f9369e33f3b4a = (key)=>{
    return key in $4f22b85ba3ca0c76$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS;
};
const $4f22b85ba3ca0c76$export$898d9c03b4eb5dd5 = (key)=>{
    return $4f22b85ba3ca0c76$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS[key];
};
const $4f22b85ba3ca0c76$export$240debd921ff9f65 = (action)=>{
    if (!action.data) return undefined;
    if (action.key === $4f22b85ba3ca0c76$export$7afb9b8acd50eb4e && $4f22b85ba3ca0c76$export$77c5629325e9aaaf(action.data)) {
        const key = 'adf';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $4f22b85ba3ca0c76$export$b632d4bc1af2f7d3 && $4f22b85ba3ca0c76$export$3bd74956949aecbc(action.data)) {
        const key = 'content';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $4f22b85ba3ca0c76$export$279c9cc61f7f510a && $4f22b85ba3ca0c76$export$392158ed2444b56b(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $4f22b85ba3ca0c76$export$823e13f43093123d && $4f22b85ba3ca0c76$export$ae4ad515c9dd259d(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c && $4f22b85ba3ca0c76$export$4dec930442f5ade2(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    }
    return undefined;
};
const $4f22b85ba3ca0c76$var$getAccumulatedData = (prevAction, nextAction)=>{
    const prevPrimary = $4f22b85ba3ca0c76$export$240debd921ff9f65(prevAction);
    const nextPrimary = $4f22b85ba3ca0c76$export$240debd921ff9f65(nextAction);
    if (!prevPrimary || !nextPrimary || prevPrimary.key !== nextPrimary.key) return undefined;
    return {
        [nextPrimary.key]: String(prevPrimary.value ?? '') + String(nextPrimary.value ?? '')
    };
};
function $4f22b85ba3ca0c76$export$5b30faa0f696991d(data) {
    return typeof data === 'object' && data !== null && 'isRemixGenerated' in data && data.isRemixGenerated === true;
}
const $4f22b85ba3ca0c76$var$REMIX_GENERATED_ACTION_KEYS = new Set([
    $4f22b85ba3ca0c76$export$740b9b28cb05ebd6,
    $4f22b85ba3ca0c76$export$4a9884303bce30ff
]);
function $4f22b85ba3ca0c76$export$8eb2b74d04c8d455(action) {
    if ($4f22b85ba3ca0c76$var$REMIX_GENERATED_ACTION_KEYS.has(action.key)) return true;
    if (action.key === $4f22b85ba3ca0c76$export$279c9cc61f7f510a || action.key === $4f22b85ba3ca0c76$export$d5d2204eeb3fde50) return $4f22b85ba3ca0c76$export$5b30faa0f696991d(action.data);
    return false;
}
function $4f22b85ba3ca0c76$export$31b2392386905e76(action) {
    if (!action) return undefined;
    const { key: key, data: data } = action;
    if ($4f22b85ba3ca0c76$export$da7aa926fc604bd7(data)) return 'edit';
    if ($4f22b85ba3ca0c76$export$6da360af78d7e3dd(data)) return 'create';
    if ($4f22b85ba3ca0c76$export$3b2fa4f5aa307773(data)) return 'edit';
    if ($4f22b85ba3ca0c76$export$ce86c52462376ef2(data)) return 'create';
    if (key === $4f22b85ba3ca0c76$export$d5d2204eeb3fde50) return 'edit';
    if (key === $4f22b85ba3ca0c76$export$279c9cc61f7f510a) return 'create';
    return undefined;
}
function $4f22b85ba3ca0c76$export$a549b965e1dff398(action) {
    if (action?.key === $4f22b85ba3ca0c76$export$4a9884303bce30ff) return 'infographic';
    if (action?.data?.type === 'whiteboard') return 'diagram';
    return action?.data?.contentType;
}
function $4f22b85ba3ca0c76$export$90cf5cf844c2f3b0(action) {
    return action?.data?.dynamicUiSubtype;
}
function $4f22b85ba3ca0c76$export$ff1c2950f6d5486f({ action: action, selectedRemixMetadata: selectedRemixMetadata }) {
    return {
        metadataActionKey: action?.key,
        metadataActionType: $4f22b85ba3ca0c76$export$31b2392386905e76(action),
        backendDynamicUiType: $4f22b85ba3ca0c76$export$a549b965e1dff398(action),
        backendDynamicUiSubtype: $4f22b85ba3ca0c76$export$90cf5cf844c2f3b0(action),
        ...selectedRemixMetadata
    };
}
const $4f22b85ba3ca0c76$export$64e13fa6a74f5f86 = (prevAction, nextAction)=>{
    if (prevAction.data && nextAction.data) {
        const accumulatedData = $4f22b85ba3ca0c76$var$getAccumulatedData(prevAction, nextAction);
        if (accumulatedData !== undefined) {
            const updatedData = {
                ...nextAction.data,
                ...accumulatedData
            };
            return {
                ...prevAction,
                data: updatedData,
                status: nextAction.status
            };
        }
    }
    return {
        ...prevAction,
        data: nextAction.data,
        status: nextAction.status
    };
};
module.exports["DYNAMIC_UI_CREATE_KEY"] = $4f22b85ba3ca0c76$export$740b9b28cb05ebd6;
module.exports["isDynamicUiCreateData"] = $4f22b85ba3ca0c76$export$6da360af78d7e3dd;
module.exports["isDynamicUiUpdateActionData"] = $4f22b85ba3ca0c76$export$da7aa926fc604bd7;
module.exports["isDynamicUiCreateAction"] = $4f22b85ba3ca0c76$export$3147e11228ebc102;
module.exports["buildDynamicUiPageUrl"] = $4f22b85ba3ca0c76$export$440c8d4309cb1c9;
module.exports["IMAGE_CREATE_KEY"] = $4f22b85ba3ca0c76$export$4a9884303bce30ff;
module.exports["isImageCreateData"] = $4f22b85ba3ca0c76$export$ce86c52462376ef2;
module.exports["isImageUpdateActionData"] = $4f22b85ba3ca0c76$export$3b2fa4f5aa307773;
module.exports["isImageCreateAction"] = $4f22b85ba3ca0c76$export$ef033f677befc7d4;
module.exports["isImageUpdatePrepareData"] = $4f22b85ba3ca0c76$export$3bb9ace6cd5cc74a;
module.exports["getRemixDataConsumerSource"] = $4f22b85ba3ca0c76$export$3fe1804ad3d5b936;
module.exports["buildImageUrl"] = $4f22b85ba3ca0c76$export$4e8e610ccc58ae5b;
module.exports["CONFLUENCE_AIFC_PAGE_CREATE_KEY"] = $4f22b85ba3ca0c76$export$7afb9b8acd50eb4e;
module.exports["isConfluenceAIFCPageCreateActionData"] = $4f22b85ba3ca0c76$export$77c5629325e9aaaf;
module.exports["CONFLUENCE_AIFC_DEEP_RESEARCH_PAGE_CREATE_KEY"] = $4f22b85ba3ca0c76$export$b632d4bc1af2f7d3;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionData"] = $4f22b85ba3ca0c76$export$3bd74956949aecbc;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionPrepare"] = $4f22b85ba3ca0c76$export$d6ad19367a51fe7a;
module.exports["CONFLUENCE_AIFC_PAGE_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$88028308fe524b8a;
module.exports["AIFC_ADF_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$bb3d6eff667f4678;
module.exports["AIFC_ACTION_CLASSIFICATION_METADATA"] = $4f22b85ba3ca0c76$export$7cca3e34118747ef;
module.exports["isAIFCADFUpdateActionData"] = $4f22b85ba3ca0c76$export$1cf42b66f457bc6c;
module.exports["isAIFCADFSetActionClassificationActionData"] = $4f22b85ba3ca0c76$export$fbc8213fc156433a;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY"] = $4f22b85ba3ca0c76$export$279c9cc61f7f510a;
module.exports["isConfluenceAIFCWhiteboardCreateActionData"] = $4f22b85ba3ca0c76$export$392158ed2444b56b;
module.exports["CONFLUENCE_AIFC_SLIDES_CREATE_KEY"] = $4f22b85ba3ca0c76$export$823e13f43093123d;
module.exports["isConfluenceAIFCSlidesCreateActionData"] = $4f22b85ba3ca0c76$export$ae4ad515c9dd259d;
module.exports["CONFLUENCE_AIFC_SLIDES_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$49b21a7401bcc85;
module.exports["isConfluenceAIFCSlidesUpdateActionData"] = $4f22b85ba3ca0c76$export$3d6de0a3c3e39cbf;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$d5d2204eeb3fde50;
module.exports["isConfluenceAIFCWhiteboardUpdateActionData"] = $4f22b85ba3ca0c76$export$35d2029c1a7b307c;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_TO_PAGE_KEY"] = $4f22b85ba3ca0c76$export$771989b0afde4911;
module.exports["CONFLUENCE_WHITEBOARD_BRAINSTORMING_KEY"] = $4f22b85ba3ca0c76$export$325918e7af3a74aa;
module.exports["isConfluenceWhiteboardBrainstormingActionData"] = $4f22b85ba3ca0c76$export$48e8bcda6802129c;
module.exports["LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $4f22b85ba3ca0c76$export$e3c19505945cf210;
module.exports["AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $4f22b85ba3ca0c76$export$c8f288feec1641d9;
module.exports["isConfluenceWhiteboardDiagrammingActionData"] = $4f22b85ba3ca0c76$export$f3a918f4f62365b2;
module.exports["CONFLUENCE_AIFC_DATABASE_CREATE_KEY"] = $4f22b85ba3ca0c76$export$9f1bd612d6abcf5c;
module.exports["isConfluenceAIFCDatabaseCreateActionData"] = $4f22b85ba3ca0c76$export$4dec930442f5ade2;
module.exports["CONFLUENCE_AIFC_DATABASE_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$ee0a705006a79cfe;
module.exports["isConfluenceAIFCDatabaseUpdateActionData"] = $4f22b85ba3ca0c76$export$dbed60ca289ab1f3;
module.exports["CONFLUENCE_AIFC_SPACE_CREATE_KEY"] = $4f22b85ba3ca0c76$export$691e9b05e574e32c;
module.exports["isConfluenceAIFCSpaceCreateActionData"] = $4f22b85ba3ca0c76$export$545244afe3ae2546;
module.exports["CONFLUENCE_AIFC_SPACE_UPDATE_KEY"] = $4f22b85ba3ca0c76$export$af91dd9bf235f890;
module.exports["isConfluenceAIFCSpaceUpdateActionData"] = $4f22b85ba3ca0c76$export$38f648644a8b3072;
module.exports["PAGE_CREATE_ACTIONS"] = $4f22b85ba3ca0c76$export$9f62c3ae716c44b2;
module.exports["WHITEBOARD_CREATE_ACTIONS"] = $4f22b85ba3ca0c76$export$aba0c096f5cdcaca;
module.exports["SLIDES_CREATE_ACTIONS"] = $4f22b85ba3ca0c76$export$b9c5aef93dba02df;
module.exports["DATABASE_CREATE_ACTIONS"] = $4f22b85ba3ca0c76$export$45a7157715c10f20;
module.exports["isConfluencePageCreateAction"] = $4f22b85ba3ca0c76$export$6c0ed26dac146a75;
module.exports["isConfluenceCreatableAction"] = $4f22b85ba3ca0c76$export$eac4577c3e50732a;
module.exports["isConfluenceCreateNewAction"] = $4f22b85ba3ca0c76$export$79fc6c76b9755410;
module.exports["isServerSideExecutionAction"] = $4f22b85ba3ca0c76$export$6b900ddfe8315d64;
module.exports["isDynamicUiCreatableAction"] = $4f22b85ba3ca0c76$export$53f0114d9f187b14;
module.exports["isImageCreatableAction"] = $4f22b85ba3ca0c76$export$b3dfc475c0b1ff86;
module.exports["isConfluencePageUpdateAction"] = $4f22b85ba3ca0c76$export$dfda1ac7e19cab7b;
module.exports["isConfluenceWhiteboardUpdateAction"] = $4f22b85ba3ca0c76$export$dcbfc8a9b613cd00;
module.exports["isConfluenceSlidesUpdateAction"] = $4f22b85ba3ca0c76$export$5d2d4e8984b13e00;
module.exports["isConfluenceDatabaseUpdateAction"] = $4f22b85ba3ca0c76$export$399c9116e9984ca3;
module.exports["isConfluenceUpdatableAction"] = $4f22b85ba3ca0c76$export$73dc9ed6ed2373f;
module.exports["isConfluenceStreamAction"] = $4f22b85ba3ca0c76$export$54716060fc6e52ee;
module.exports["isConfluencePreviewCardAction"] = $4f22b85ba3ca0c76$export$5cb5e5f4b4ce0a33;
module.exports["generateRovoReceiverId"] = $4f22b85ba3ca0c76$export$681cf9ea58de88fd;
module.exports["getConfluenceContentType"] = $4f22b85ba3ca0c76$export$bb9f6b0763834612;
module.exports["isAccumulatedAction"] = $4f22b85ba3ca0c76$export$b95f9369e33f3b4a;
module.exports["getAccumulatedActionTypeGuard"] = $4f22b85ba3ca0c76$export$898d9c03b4eb5dd5;
module.exports["getPrimaryAccumulatedValue"] = $4f22b85ba3ca0c76$export$240debd921ff9f65;
module.exports["isRemixGeneratedAction"] = $4f22b85ba3ca0c76$export$5b30faa0f696991d;
module.exports["isRemixGeneratedFlow"] = $4f22b85ba3ca0c76$export$8eb2b74d04c8d455;
module.exports["getDynamicUiType"] = $4f22b85ba3ca0c76$export$a549b965e1dff398;
module.exports["getDynamicUiSubtype"] = $4f22b85ba3ca0c76$export$90cf5cf844c2f3b0;
module.exports["getRemixMetadata"] = $4f22b85ba3ca0c76$export$ff1c2950f6d5486f;
module.exports["customActionUpdater"] = $4f22b85ba3ca0c76$export$64e13fa6a74f5f86;

});

parcelRegister("3wccB", function(module, exports) {

var $feawE = parcelRequire("feawE");

const $da25b812d7492535$var$CONFLUENCE_SLIDE_CLIENT_ID_PREFIX = 'confluence-slide';
const $da25b812d7492535$export$8ad4475ac322bb70 = (contentId)=>(0, $feawE.client)(`${$da25b812d7492535$var$CONFLUENCE_SLIDE_CLIENT_ID_PREFIX}-${contentId}`);
module.exports["getConfluenceSlidesClientId"] = $da25b812d7492535$export$8ad4475ac322bb70;

});

parcelRegister("hUsog", function(module, exports) {

var $3GWdi = parcelRequire("3GWdi");


var $zBSTr = parcelRequire("zBSTr");


var $c9zHD = parcelRequire("c9zHD");


var $2jzwX = parcelRequire("2jzwX");


var $aPdNQ = parcelRequire("aPdNQ");


var $iDrrr = parcelRequire("iDrrr");

const $330d5ffa0743cdd8$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $330d5ffa0743cdd8$var$citation = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $330d5ffa0743cdd8$var$CITATION_REGEX.test(childToken.content)) {
                /**
           * Example content: `Hello [^1^][^1^].`
           * `parts` will be ['Hello ', '1', '', '1', '.']
           */ const parts = childToken.content.split($330d5ffa0743cdd8$var$CITATION_REGEX);
                const newChildren = [];
                /**
           * we want to remove consecutive citation
           * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
           * should be transformed to `Hello 1. How are you 1 2`
           */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
               * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
               * So it doesn't end up rendering empty space that will end up with multi empty spaces
               * because previous valid citation already added 1 empty space
               *
               * Example: For `[^1^][^1^]`
               * it will be split into parts: ['', '1', '', '1', ''],
               * This code will skip any rendering for the last empty string (index=4)
               * Because the empty string at index=2 already added 1 empty space from the code below
               */ if (isLastCitationDuplicate && part.trim() === '') return;
                        if (part.trim() !== '') /**
                 * if the text part is not an empty string, we want to reset the last citation
                 * because the text part is a valid text, and not a space between citations
                 * so that we can render citation again, even if the next number is the same as the last number
                 *
                 * Example:
                 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                 */ lastCitation = null;
                        const textToken = new state.Token('text', '', 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else textToken.content = part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        const citationToken = new state.Token('status', '', 0);
                        citationToken.content = '';
                        citationToken.block = false;
                        citationToken.level = childToken.level;
                        let citationText = part;
                        citationToken.attrs = [
                            [
                                'color',
                                'blue'
                            ],
                            [
                                'text',
                                citationText
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                'localId',
                                `citation-${citationText}`
                            ]
                        ];
                        citationToken.content = citationText;
                        newChildren.push(citationToken);
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $330d5ffa0743cdd8$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $330d5ffa0743cdd8$var$citation);


const $157bfca8bd99df8f$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
const $157bfca8bd99df8f$var$dataSculptor = (state)=>{
    const tokens = [];
    let sculptorCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $157bfca8bd99df8f$var$SCULPTOR_REGEX.test(childToken.content)) {
                const citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                const parts = childToken.content.split($157bfca8bd99df8f$var$SCULPTOR_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        citationToken.attrs = [
                            [
                                'localId',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'text',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(citationToken);
                        sculptorCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $157bfca8bd99df8f$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('data-sculptor', $157bfca8bd99df8f$var$dataSculptor);


const $7c10b0d620ee72bd$var$entityAnnotationMarkers = {
    start: '\uE000rovo-entity:',
    end: '\uE001',
    endMarker: '\uE000rovo-entity:end\uE001'
};
var $7c10b0d620ee72bd$export$2e2bcd8739ae039 = $7c10b0d620ee72bd$var$entityAnnotationMarkers;


const $5aaa28bb8acc8881$var$findUniqueOffset = (content, query)=>{
    const firstOffset = content.indexOf(query);
    if (firstOffset === -1 || content.indexOf(query, firstOffset + query.length) !== -1) return undefined;
    return firstOffset;
};
const $5aaa28bb8acc8881$var$normalizeWhitespace = (value)=>{
    const originalOffsets = [];
    let text = '';
    let isInWhitespace = false;
    for(let index = 0; index < value.length; index++){
        const character = value[index];
        if (/\s/.test(character)) {
            if (!isInWhitespace) {
                text += ' ';
                originalOffsets.push(index);
                isInWhitespace = true;
            }
            continue;
        }
        text += character;
        originalOffsets.push(index);
        isInWhitespace = false;
    }
    return {
        originalOffsets: originalOffsets,
        text: text
    };
};
const $5aaa28bb8acc8881$var$getNormalizedIndex = (originalOffsets, sourceOffset)=>{
    const index = originalOffsets.findIndex((offset)=>offset >= sourceOffset);
    return index === -1 ? originalOffsets.length : index;
};
const $5aaa28bb8acc8881$var$getSourceRange = ({ content: content, entity: entity, sentence: sentence })=>{
    if (entity.start < 0 || entity.end <= entity.start || entity.end > sentence.length) return undefined;
    const sentenceOffset = $5aaa28bb8acc8881$var$findUniqueOffset(content, sentence);
    if (sentenceOffset !== undefined) {
        const start = sentenceOffset + entity.start;
        const end = sentenceOffset + entity.end;
        if (content.slice(start, end) === entity.mention) return {
            start: start,
            end: end,
            strategy: 'sentence'
        };
    }
    const sentencePrefix = sentence.slice(0, entity.end);
    const prefixOffset = $5aaa28bb8acc8881$var$findUniqueOffset(content, sentencePrefix);
    if (prefixOffset !== undefined) {
        const start = prefixOffset + entity.start;
        const end = prefixOffset + entity.end;
        if (content.slice(start, end) === entity.mention) return {
            start: start,
            end: end,
            strategy: 'sentence-prefix'
        };
    }
    const normalizedContent = $5aaa28bb8acc8881$var$normalizeWhitespace(content);
    const normalizedSentence = $5aaa28bb8acc8881$var$normalizeWhitespace(sentence);
    const normalizedSentenceOffset = $5aaa28bb8acc8881$var$findUniqueOffset(normalizedContent.text, normalizedSentence.text);
    if (normalizedSentenceOffset !== undefined) {
        const normalizedStart = normalizedSentenceOffset + $5aaa28bb8acc8881$var$getNormalizedIndex(normalizedSentence.originalOffsets, entity.start);
        const normalizedEnd = normalizedSentenceOffset + $5aaa28bb8acc8881$var$getNormalizedIndex(normalizedSentence.originalOffsets, entity.end);
        const start = normalizedContent.originalOffsets[normalizedStart];
        const end = normalizedEnd === normalizedContent.originalOffsets.length ? content.length : normalizedContent.originalOffsets[normalizedEnd];
        if (start !== undefined && end !== undefined && content.slice(start, end) === entity.mention) return {
            start: start,
            end: end,
            strategy: 'normalized-sentence'
        };
    }
    const mentionOffset = $5aaa28bb8acc8881$var$findUniqueOffset(content, entity.mention);
    return mentionOffset === undefined ? undefined : {
        start: mentionOffset,
        end: mentionOffset + entity.mention.length,
        strategy: 'unique-mention'
    };
};
const $5aaa28bb8acc8881$var$createStartMarker = (entity)=>`${(0, $7c10b0d620ee72bd$export$2e2bcd8739ae039).start}start:${encodeURIComponent(JSON.stringify(entity))}${(0, $7c10b0d620ee72bd$export$2e2bcd8739ae039).end}`;
function $5aaa28bb8acc8881$export$2e2bcd8739ae039(content, annotationBatches) {
    if (!annotationBatches?.length) return content;
    const ranges = annotationBatches.flatMap(({ entities: entities, sentence: sentence })=>entities.flatMap((entity)=>{
            const range = $5aaa28bb8acc8881$var$getSourceRange({
                content: content,
                entity: entity,
                sentence: sentence
            });
            return range ? [
                {
                    ...range,
                    entity: entity
                }
            ] : [];
        })).sort((first, second)=>second.start - first.start);
    let annotatedContent = content;
    let nextEnd = content.length;
    for (const range of ranges){
        if (range.end > nextEnd) continue;
        annotatedContent = annotatedContent.slice(0, range.start) + $5aaa28bb8acc8881$var$createStartMarker(range.entity) + annotatedContent.slice(range.start, range.end) + (0, $7c10b0d620ee72bd$export$2e2bcd8739ae039).endMarker + annotatedContent.slice(range.end);
        nextEnd = range.start;
    }
    return annotatedContent;
}



var $gW8jj = parcelRequire("gW8jj");


const $951eec697bfb87e5$var$MARKER_START = (0, $7c10b0d620ee72bd$export$2e2bcd8739ae039).start;
const $951eec697bfb87e5$var$MARKER_END = (0, $7c10b0d620ee72bd$export$2e2bcd8739ae039).end;
const $951eec697bfb87e5$var$ENTITY_MARKER_END = (0, $7c10b0d620ee72bd$export$2e2bcd8739ae039).endMarker;
const $951eec697bfb87e5$var$nonBodyBlockTypes = new Set([
    'caption',
    'heading',
    'tableHeader'
]);
const $951eec697bfb87e5$var$parseEntity = (value)=>{
    try {
        const entity = JSON.parse(decodeURIComponent(value));
        return (0, $gW8jj.isEntityAnnotationEntity)(entity) ? entity : undefined;
    } catch  {
        return undefined;
    }
};
const $951eec697bfb87e5$var$createTextToken = (state, content, level)=>{
    const token = new state.Token('text', '', 0);
    token.content = content;
    token.level = level;
    return token;
};
const $951eec697bfb87e5$var$formatMarkOpenTypes = new Set([
    'em_open',
    's_open',
    'strong_open'
]);
const $951eec697bfb87e5$var$createMarkBoundaryToken = (state, source, nesting)=>{
    const type = source.type.replace(/_(?:open|close)$/, nesting === 1 ? '_open' : '_close');
    const token = new state.Token(type, source.tag, nesting);
    token.level = source.level;
    token.markup = source.markup;
    return token;
};
const $951eec697bfb87e5$var$getAccountIdFromIdentityAri = (ari)=>ari.match(/^ari:cloud:identity::user\/([^/]+)$/)?.[1];
const $951eec697bfb87e5$var$createEntityAnnotationToken = (state, entity, level)=>{
    if (entity.type === 'Person') {
        const accountId = $951eec697bfb87e5$var$getAccountIdFromIdentityAri(entity.ari);
        if (!accountId) return undefined;
        const token = new state.Token('mention', '', 0);
        token.block = false;
        token.level = level;
        token.attrs = [
            [
                'id',
                accountId
            ],
            [
                'text',
                `@${entity.mention}`
            ]
        ];
        return token;
    }
    const token = new state.Token('entityAnnotation', '', 0);
    token.block = false;
    token.level = level;
    token.attrs = [
        [
            'extensionType',
            (0, $gW8jj.ENTITY_ANNOTATION_EXTENSION_TYPE)
        ],
        [
            'extensionKey',
            (0, $gW8jj.INFERRED_PROJECT_EXTENSION_KEY)
        ],
        [
            'parameters',
            JSON.stringify({
                name: entity.mention,
                ari: entity.ari,
                canonicalName: entity.canonicalName,
                confidenceScore: entity.confidenceScore
            })
        ],
        [
            'text',
            entity.mention
        ]
    ];
    return token;
};
const $951eec697bfb87e5$var$stripMarkers = (content)=>content.replace(new RegExp(`${$951eec697bfb87e5$var$MARKER_START}start:[^${$951eec697bfb87e5$var$MARKER_END}]*${$951eec697bfb87e5$var$MARKER_END}`, 'g'), '').replace(new RegExp($951eec697bfb87e5$var$ENTITY_MARKER_END, 'g'), '');
const $951eec697bfb87e5$var$replaceEntityMarkers = ({ children: children, isEligibleBlock: isEligibleBlock, state: state })=>{
    const result = [];
    const activeFormatMarks = [];
    let linkDepth = 0;
    for (const child of children){
        if ($951eec697bfb87e5$var$formatMarkOpenTypes.has(child.type)) {
            activeFormatMarks.push(child);
            result.push(child);
            continue;
        }
        if (child.type.endsWith('_close') && activeFormatMarks[activeFormatMarks.length - 1]?.type === child.type.replace('_close', '_open')) {
            activeFormatMarks.pop();
            result.push(child);
            continue;
        }
        if (child.type === 'link_open') {
            linkDepth += 1;
            result.push(child);
            continue;
        }
        if (child.type === 'link_close') {
            linkDepth -= 1;
            result.push(child);
            continue;
        }
        if (child.type !== 'text') {
            if (child.content.includes($951eec697bfb87e5$var$MARKER_START)) child.content = $951eec697bfb87e5$var$stripMarkers(child.content);
            result.push(child);
            continue;
        }
        if (!child.content.includes($951eec697bfb87e5$var$MARKER_START)) {
            result.push(child);
            continue;
        }
        const markerPattern = new RegExp(`${$951eec697bfb87e5$var$MARKER_START}start:([^${$951eec697bfb87e5$var$MARKER_END}]*)${$951eec697bfb87e5$var$MARKER_END}([\\s\\S]*?)${$951eec697bfb87e5$var$ENTITY_MARKER_END}`, 'g');
        let cursor = 0;
        let match = markerPattern.exec(child.content);
        while(match){
            if (match.index > cursor) result.push($951eec697bfb87e5$var$createTextToken(state, child.content.slice(cursor, match.index), child.level));
            const entity = $951eec697bfb87e5$var$parseEntity(match[1]);
            const mention = match[2];
            const annotationToken = entity ? $951eec697bfb87e5$var$createEntityAnnotationToken(state, entity, child.level) : undefined;
            const canConvert = entity && entity.mention === mention && isEligibleBlock && linkDepth === 0;
            if (canConvert && annotationToken) {
                for (const mark of [
                    ...activeFormatMarks
                ].reverse())result.push($951eec697bfb87e5$var$createMarkBoundaryToken(state, mark, -1));
                result.push(annotationToken);
                for (const mark of activeFormatMarks)result.push($951eec697bfb87e5$var$createMarkBoundaryToken(state, mark, 1));
            } else result.push($951eec697bfb87e5$var$createTextToken(state, mention, child.level));
            cursor = match.index + match[0].length;
            match = markerPattern.exec(child.content);
        }
        if (cursor < child.content.length) result.push($951eec697bfb87e5$var$createTextToken(state, $951eec697bfb87e5$var$stripMarkers(child.content.slice(cursor)), child.level));
    }
    return result;
};
const $951eec697bfb87e5$var$entityAnnotations = (state)=>{
    const openBlocks = [];
    for (const token of state.tokens){
        if (token.type.endsWith('_open')) openBlocks.push(token.type.slice(0, -5));
        if (token.type === 'inline' && token.children?.length) token.children = $951eec697bfb87e5$var$replaceEntityMarkers({
            children: token.children,
            isEligibleBlock: !openBlocks.some((type)=>$951eec697bfb87e5$var$nonBodyBlockTypes.has(type)),
            state: state
        });
        if (token.type.endsWith('_close')) openBlocks.pop();
    }
};
function $951eec697bfb87e5$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('entity-annotations', $951eec697bfb87e5$var$entityAnnotations);
}


const $14c428bc00c0e101$var$EXPAND_REGEX = /\[\^(expand)\^\]/;
const $14c428bc00c0e101$var$expandable = (state)=>{
    const tokens = [];
    let expandCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children?.length === 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $14c428bc00c0e101$var$EXPAND_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($14c428bc00c0e101$var$EXPAND_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const expandToken = new state.Token('status', '', 0);
                        expandToken.content = '';
                        expandToken.block = false;
                        expandToken.level = childToken.level;
                        expandToken.attrs = [
                            [
                                'localId',
                                'expandable-' + expandCounter
                            ],
                            [
                                'text',
                                'expandable-' + expandCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(expandToken);
                        expandCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
const $14c428bc00c0e101$var$mdPluginExpandable = (md)=>{
    md.core.ruler.push('expandable', $14c428bc00c0e101$var$expandable);
};
var $14c428bc00c0e101$export$2e2bcd8739ae039 = $14c428bc00c0e101$var$mdPluginExpandable;


const $26c7e36d126f9ad4$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $26c7e36d126f9ad4$var$groupedCitations = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $26c7e36d126f9ad4$var$CITATION_REGEX.test(childToken.content)) {
                /**
           * Example content: `Hello [^1^][^1^].`
           * `parts` will be ['Hello ', '1', '', '1', '.']
           */ const parts = childToken.content.split($26c7e36d126f9ad4$var$CITATION_REGEX);
                const newChildren = [];
                /**
           * we want to remove consecutive citation
           * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
           * should be transformed to `Hello 1. How are you 1 2`
           */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                let citationIndices = [];
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
               * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
               * So it doesn't end up rendering empty space that will end up with multi empty spaces
               * because previous valid citation already added 1 empty space
               *
               * Example: For `[^1^][^1^]`
               * it will be split into parts: ['', '1', '', '1', ''],
               * This code will skip any rendering for the last empty string (index=4)
               * Because the empty string at index=2 already added 1 empty space from the code below
               */ if ((isLastCitationDuplicate || citationIndices.length > 0) && part.trim() === '') return;
                        if (part.trim() !== '') {
                            /**
                 * if the text part is not an empty string, we want to reset the last citation
                 * because the text part is a valid text, and not a space between citations
                 * so that we can render citation again, even if the next number is the same as the last number
                 *
                 * Example:
                 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                 */ lastCitation = null;
                            /**
                 * once we reach a text part, we need to capture the indices of the citations that have occurred up to this point
                 *
                 * Example
                 * `Hello [^1^][^2^] The example continues` -> parts = ['Hello ', '1', '', '2', 'The example continues']
                 * When 'The example continues' is reached, we need to create a status token for the citations prior
                 */ if (citationIndices.length > 0) {
                                const citationToken = new state.Token('status', '', 0);
                                citationToken.content = '';
                                citationToken.block = false;
                                citationToken.level = childToken.level;
                                // localId is used to identify the citation indices in the DOM
                                // this overrides the uuid that is normally used
                                // NOTE: ReactRenderer expects specific props for status nodes and
                                // therefore we cannot pass in custom attributes
                                citationToken.attrs = [
                                    [
                                        'color',
                                        'blue'
                                    ],
                                    [
                                        'text',
                                        'citation'
                                    ],
                                    // citationIndices is used to identify the citation token in the DOM
                                    // this overrides the uuid that is normally used
                                    [
                                        'localId',
                                        JSON.stringify(citationIndices)
                                    ]
                                ];
                                newChildren.push(citationToken);
                                citationIndices = [];
                            }
                        }
                        const textToken = new state.Token('text', '', 0);
                        // don't add trailing space if part already ends with one
                        textToken.content = index === parts.length - 1 ? part : part.endsWith(' ') ? part : part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        if (part !== '') newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        citationIndices.push(parseInt(part));
                    }
                });
                /**
           * Once we've reached the end of parts, we need to create a status token for any citations at the very end
           *
           * Example: `Hello [^1^][^2^]` -> parts = ['Hello ', '1', '', '2', '']
           * When we've iterated through all of parts, 1 and 2 indices exist in citationIndices, and a status token needs to be created
           */ if (citationIndices.length > 0) {
                    const citationToken = new state.Token('status', '', 0);
                    citationToken.content = '';
                    citationToken.block = false;
                    citationToken.level = childToken.level;
                    citationToken.attrs = [
                        [
                            'color',
                            'blue'
                        ],
                        [
                            'text',
                            'citation'
                        ],
                        [
                            'localId',
                            JSON.stringify(citationIndices)
                        ]
                    ];
                    newChildren.push(citationToken);
                    citationIndices = [];
                }
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $26c7e36d126f9ad4$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $26c7e36d126f9ad4$var$groupedCitations);



var $6Bfyn = parcelRequire("6Bfyn");

const $04a93a56598a27a8$var$FOLLOW_UPS_REGEX = /\[\^(actionable-follow-ups)\^\]/;
/**
 * Replaces the `[^actionable-follow-ups^]` placeholder (injected when the `◈`
 * marker is extracted from the assistant response) with a `status` node whose
 * `localId`/`text` is prefixed with `ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX`. The
 * renderer swaps that status node for the actionable follow-up questions UI,
 * pulling the parsed questions from the message's `markdownData`.
 *
 * Mirrors `md-plugin-inline-lumina`.
 */ const $04a93a56598a27a8$var$inlineFollowUps = (state)=>{
    const tokens = [];
    let followUpsCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $04a93a56598a27a8$var$FOLLOW_UPS_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($04a93a56598a27a8$var$FOLLOW_UPS_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const followUpsToken = new state.Token('status', '', 0);
                        followUpsToken.content = '';
                        followUpsToken.block = false;
                        followUpsToken.level = childToken.level;
                        followUpsToken.attrs = [
                            [
                                'localId',
                                (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX) + followUpsCounter
                            ],
                            [
                                'text',
                                (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX) + followUpsCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(followUpsToken);
                        followUpsCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $04a93a56598a27a8$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('inline-follow-ups', $04a93a56598a27a8$var$inlineFollowUps);
}



var $1rNZu = parcelRequire("1rNZu");

const $bbeb09636b3688aa$var$LUMINA_REGEX = /\[\^(lumina)\^\]/;
const $bbeb09636b3688aa$var$inlineLumina = (state)=>{
    const tokens = [];
    let luminaCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $bbeb09636b3688aa$var$LUMINA_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($bbeb09636b3688aa$var$LUMINA_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const luminaToken = new state.Token('status', '', 0);
                        luminaToken.content = '';
                        luminaToken.block = false;
                        luminaToken.level = childToken.level;
                        luminaToken.attrs = [
                            [
                                'localId',
                                (0, $1rNZu.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'text',
                                (0, $1rNZu.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(luminaToken);
                        luminaCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $bbeb09636b3688aa$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('inline-lumina', $bbeb09636b3688aa$var$inlineLumina);
}



var $tALAR = parcelRequire("tALAR");


var $tgKCV = parcelRequire("tgKCV");

// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $d7524ac980d0a478$var$arrayReplaceAt = (src, pos, newElements)=>[].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
const $d7524ac980d0a478$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $d7524ac980d0a478$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $d7524ac980d0a478$export$8cd7d1ec2e6808da = ({ findFilepaths: findFilepaths, isLinkInMatches: isLinkInMatches })=>(state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, $tALAR.default)();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children ?? [];
            let htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($d7524ac980d0a478$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($d7524ac980d0a478$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, $tgKCV.linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    // Now split string to nodes
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = findFilepaths(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $d7524ac980d0a478$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };


const $b9f103c37ce71df9$export$763ac077c9998026 = (params)=>(md)=>md.core.ruler.push('custom-linkify', (0, $d7524ac980d0a478$export$8cd7d1ec2e6808da)(params));


/**
 * This plugin handles blockquotes nested inside list items.
 * Since ADF doesn't support blockquotes as children of listItems,
 * we transform blockquote content into emphasized (italic) paragraphs.
 *
 * Before: 1. Item\n   > "Quote"
 * After:  1. Item\n   _"Quote"_
 *
 * This allows quotes within lists to render gracefully as italicized text
 * rather than failing due to ADF schema constraints.
 */ const $d2188aa6b0aad9ac$var$listBlockquoteFallback = (state)=>{
    const tokens = state.tokens;
    let listDepth = 0;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Track list nesting depth
        if (token.type === 'ordered_list_open' || token.type === 'bullet_list_open') listDepth++;
        else if (token.type === 'ordered_list_close' || token.type === 'bullet_list_close') listDepth--;
        // If we're inside a list and encounter a blockquote, transform it
        if (listDepth > 0 && token.type === 'blockquote_open') {
            // Find the matching blockquote_close
            let closeIndex = -1;
            let depth = 1;
            for(let j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'blockquote_open') depth++;
                else if (tokens[j].type === 'blockquote_close') {
                    depth--;
                    if (depth === 0) {
                        closeIndex = j;
                        break;
                    }
                }
            }
            if (closeIndex !== -1) {
                // Mark the blockquote tokens for removal
                token.type = 'blockquote_fallback_open';
                token.hidden = true;
                tokens[closeIndex].type = 'blockquote_fallback_close';
                tokens[closeIndex].hidden = true;
                // Process the content inside the blockquote
                // We need to wrap the inline content with emphasis marks
                for(let j = i + 1; j < closeIndex; j++){
                    const innerToken = tokens[j];
                    if (innerToken.type === 'inline' && innerToken.children) {
                        // Wrap all children with em marks
                        const emOpen = new state.Token('em_open', 'em', 1);
                        emOpen.block = false;
                        const emClose = new state.Token('em_close', 'em', -1);
                        emClose.block = false;
                        innerToken.children = [
                            emOpen,
                            ...innerToken.children,
                            emClose
                        ];
                    }
                }
            }
        }
    }
    // Filter out the hidden blockquote fallback tokens
    state.tokens = tokens.filter((t)=>t.type !== 'blockquote_fallback_open' && t.type !== 'blockquote_fallback_close');
};
const $d2188aa6b0aad9ac$var$mdPluginListBlockquoteFallback = (md)=>{
    md.core.ruler.push('list_blockquote_fallback', $d2188aa6b0aad9ac$var$listBlockquoteFallback);
};
var $d2188aa6b0aad9ac$export$2e2bcd8739ae039 = $d2188aa6b0aad9ac$var$mdPluginListBlockquoteFallback;


/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $5125c80d561f745e$var$createRule() {
    // Match any images that aren't inside single backticks
    const mdImageRegex = RegExp("(?<!`)!\\[[^\\]]*\\]\\([^\\)]+\\)(?!`)", "g");
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        // Track the difference between original array indices and accumulated tokens indices
        // This is needed because when we skip processed tokens, the indices diverge
        let indexOffset = 0;
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                // Adjust cursor to account for previously skipped/modified tokens
                const adjustedCursor = cursor - indexOffset;
                tokens = [
                    ...tokens.slice(0, adjustedCursor),
                    ...subTree
                ];
                // Update offset: we consumed (i - cursor + 1) original tokens and added subTree.length
                indexOffset += i + 1 - cursor - subTree.length;
            } else if (processedTokens.indexOf(token.type) !== -1) {
                // Ignore token if it's already processed
                processedTokens.splice(processedTokens.indexOf(token.type), 1);
                // We skipped a token, so the offset increases
                indexOffset++;
            } else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $5125c80d561f745e$export$2e2bcd8739ae039 = (md)=>{
    md.core.ruler.before('inline', 'media', $5125c80d561f745e$var$createRule());
};


// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
const $d6cf044b287ff6bb$var$isPeopleLink = (url)=>{
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
const $d6cf044b287ff6bb$var$getAccountId = (url)=>{
    const match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
const $d6cf044b287ff6bb$var$mentionLinks = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        // We're only looking for inline children
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken, i)=>{
            const url = childToken.attrGet('href') ?? '';
            const discardedToken = [
                'link_close',
                'text'
            ].includes(childToken.type) && [
                tokenChildren[i - 1]?.type,
                tokenChildren[i - 2]?.type
            ].includes('mention');
            // Discarded tokens are preserved as `null` so index
            // cross-referencing between processed and raw tokens may
            // be preserved, however null are filtered out later.
            if (discardedToken) {
                tokenChildren.push(null);
                return;
            }
            if (childToken.type === 'link_open' && $d6cf044b287ff6bb$var$isPeopleLink(url)) {
                const mentionText = token.children?.[i + 1]?.content ?? '';
                let mentionToken = new state.Token('mention', '', 0);
                mentionToken.content = '';
                mentionToken.block = false;
                mentionToken.level = childToken.level;
                mentionToken.attrSet('id', `${$d6cf044b287ff6bb$var$getAccountId(url)}`);
                if (mentionText) mentionToken.attrSet('text', `@${mentionText}`);
                tokenChildren.push(mentionToken);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $d6cf044b287ff6bb$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('mention', $d6cf044b287ff6bb$var$mentionLinks);



var $kUcLs = parcelRequire("kUcLs");

const $b36376af2b96b431$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
const $b36376af2b96b431$var$linkPatternEnd = '[^\\s\\]\\)]*';
const $b36376af2b96b431$var$linkRegex = {
    youtube: `${$b36376af2b96b431$var$linkPatternStart}youtube\\.com${$b36376af2b96b431$var$linkPatternEnd}`,
    youtubeShortUrl: `${$b36376af2b96b431$var$linkPatternStart}youtu\\.be${$b36376af2b96b431$var$linkPatternEnd}`,
    loomVideo: `${$b36376af2b96b431$var$linkPatternStart}loom\\.com\\/share\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    figmaFile: `${$b36376af2b96b431$var$linkPatternStart}figma\\.com\\/(file|design)\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    confluenceWhiteboard: `${$b36376af2b96b431$var$linkPatternStart}.*\\/wiki\\/spaces\\/.*\\/whiteboard\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    googlePresentationAndSpreadsheet: `${$b36376af2b96b431$var$linkPatternStart}docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    googleDoc: `${$b36376af2b96b431$var$linkPatternStart}docs\\.google\\.com\\/(document)\\/d\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    googleForm: `${$b36376af2b96b431$var$linkPatternStart}docs\\.google\\.com\\/forms\\/d\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    microsoftForm: `${$b36376af2b96b431$var$linkPatternStart}forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=${$b36376af2b96b431$var$linkPatternEnd}`,
    // this will be removed following project
    analyticsChart: `\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-${$b36376af2b96b431$var$linkPatternEnd}` // this will be removed following project
};
const $b36376af2b96b431$var$newThirdPartyLinkRegex = {
    github: `${$b36376af2b96b431$var$linkPatternStart}github\\.com${$b36376af2b96b431$var$linkPatternEnd}`,
    canvaDesign: `${$b36376af2b96b431$var$linkPatternStart}canva\\.com\\/design\\/[a-zA-Z0-9_\\-.]{1,255}\\/[a-zA-Z0-9_\\-.]{1,255}(?:\\/[^\\s\\]\\)]*)?`,
    canvaShortLink: `${$b36376af2b96b431$var$linkPatternStart}canva\\.link\\/[a-zA-Z0-9]+(?:\\?${$b36376af2b96b431$var$linkPatternEnd})?`,
    rovo: `${$b36376af2b96b431$var$linkPatternStart}[^\\s\\]\\)]*\\.atlassian\\.net\\/rovo${$b36376af2b96b431$var$linkPatternEnd}`,
    amplitude: `${$b36376af2b96b431$var$linkPatternStart}app\\.amplitude\\.com${$b36376af2b96b431$var$linkPatternEnd}`
};
const $b36376af2b96b431$var$buildEmbedRegex = (includeNewThirdParties)=>{
    const patterns = [
        ...Object.values($b36376af2b96b431$var$linkRegex),
        ...includeNewThirdParties ? Object.values($b36376af2b96b431$var$newThirdPartyLinkRegex) : []
    ];
    return new RegExp(patterns.join('|'), 'g');
};
const $b36376af2b96b431$var$embedInlineRegex = [
    // avpRovoSkillsChart
    `${$b36376af2b96b431$var$linkPatternStart}avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+${$b36376af2b96b431$var$linkPatternEnd}`
];
const $b36376af2b96b431$var$avpChartsRegex = `${$b36376af2b96b431$var$linkPatternStart}.*?\\/avpviz\\/c\\/[^\\/]+.*${$b36376af2b96b431$var$linkPatternEnd}`;
/**
 * Checks if there is more than one link in the token stream.
 * Used to determine if all links should be rendered inline instead of as embeds.
 */ const $b36376af2b96b431$var$hasMultipleLinks = (tokens)=>{
    let linkCount = 0;
    for (const token of tokens){
        if (token.type !== 'inline' || !token.children) continue;
        for (const childToken of token.children)if (childToken?.type === 'link_open') {
            linkCount++;
            if (linkCount > 1) return true; // Early exit once we find more than one
        }
    }
    return false;
};
const $b36376af2b96b431$var$createSmartLinks = ({ regexStorage: regexStorage, isExperimentEnabled: isExperimentEnabled, shouldShowAsInline: shouldShowAsInline, xpcWrapUrl: xpcWrapUrl })=>(state)=>{
        const embedRegex = $b36376af2b96b431$var$buildEmbedRegex(isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false) ?? false);
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        const renderedInlineEmbeds = new Set();
        // If there are more than one link or the user opened the chat in mini modal, all links display inline
        const forceAllToInline = $b36376af2b96b431$var$hasMultipleLinks(state.tokens) || shouldShowAsInline;
        // process each token to determine if the link should be converted to a smartlink
        for (const token of state.tokens){
            let processedTokenChildren = [];
            const regexMatchesRaw = token.content?.trim().match(embedRegex);
            const regexMatches = regexMatchesRaw ? Array.from(new Set(regexMatchesRaw)) : [];
            embedMatches = [
                ...embedMatches,
                ...regexMatches
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $kUcLs.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        // This link will be rendered as a smart link (embed or inline card) by the linking
                        // platform, so we only strip the `datasource` param without applying full XPC wrapping.
                        const smartLinkUrl = xpcWrapUrl ? xpcWrapUrl(url, true) : url;
                        // Check if this link should be rendered as an embed card inline (e.g., Loom, YouTube, Figma) at end of result
                        const matchesEmbedRegex = url.match(embedRegex);
                        if (matchesEmbedRegex && !embedMatches.includes(url)) embedMatches.push(url);
                        // handle condition for when link in the token content matches the linkRegex
                        const shouldRenderLinksAsEmbed = matchesEmbedRegex;
                        const shouldRenderAvpRovoSkillsEmbedInline = token.level <= 1 && $b36376af2b96b431$var$embedInlineRegex.some((r)=>url.match(r));
                        const shouldRenderAvpChartsEmbedInline = token.level <= 1 && url.match($b36376af2b96b431$var$avpChartsRegex);
                        const shouldRenderAvpEmbedInline = shouldRenderAvpRovoSkillsEmbedInline || shouldRenderAvpChartsEmbedInline;
                        // Render inline embed if either regex matches and token content is not part of a list
                        const shouldRenderEmbedInline = shouldRenderLinksAsEmbed && token.level <= 1;
                        if (shouldRenderAvpEmbedInline || shouldRenderLinksAsEmbed) {
                            // handle case if it is an analytic chart link or microsoft form link
                            // these should be rendered as inline cards, not embed cards
                            const isMicrosoftFormLink = new RegExp($b36376af2b96b431$var$linkRegex.microsoftForm).test(url);
                            const isAnalyticsChartLink = new RegExp($b36376af2b96b431$var$linkRegex.analyticsChart).test(url);
                            if (!forceAllToInline && shouldRenderEmbedInline && !isMicrosoftFormLink && !isAnalyticsChartLink || shouldRenderAvpEmbedInline) {
                                outputToken.children = processedTokenChildren;
                                tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                                // Capture whether the URL was standalone on its own line
                                // (i.e. there was no preceding text in the same paragraph)
                                const isStandaloneUrl = processedTokenChildren.length === 0;
                                processedTokenChildren = [];
                                let embedToken = new state.Token('embedCard', '', 0);
                                embedToken.content = '';
                                embedToken.block = true;
                                embedToken.attrSet('url', smartLinkUrl);
                                embedToken.attrSet('layout', 'center');
                                // Mark whether this embed came from a standalone-line URL
                                if (isStandaloneUrl && isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false)) embedToken.attrSet('isStandalone', 'true');
                                tokensToAppend.push(embedToken);
                                tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                                outputToken = new state.Token('inline', '', 0);
                                tokensToAppend.push(outputToken);
                                // Track that we've rendered this URL as an inline embed
                                renderedInlineEmbeds.add(url);
                                return;
                            }
                        }
                        // create an inline card for the links that don't qualify
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', smartLinkUrl);
                        processedTokenChildren.push(cardToken);
                        return;
                    } else if (xpcWrapUrl && childToken?.type === 'link_open') // For plain links not supported by the linking platform, apply xpcWrapUrl (with full wrapping) to the href
                    childToken.attrSet('href', xpcWrapUrl(url, false));
                    // pushes non link tokens as is
                    processedTokenChildren.push(childToken);
                });
            }
            // set processed children to the output token
            outputToken.children = processedTokenChildren;
            // Keeps inline tokens that have children and all non-inline tokens.
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        // Remove empty paragraphs otherwise add it to the filteredTokens
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $b36376af2b96b431$export$9625a798761643ac = (params, isExperimentEnabled, shouldShowAsInline, xpcWrapUrl)=>(md)=>md.core.ruler.push('inlineCard', $b36376af2b96b431$var$createSmartLinks({
            ...params,
            isExperimentEnabled: isExperimentEnabled,
            shouldShowAsInline: shouldShowAsInline,
            xpcWrapUrl: xpcWrapUrl
        }));


const $75906c97e0460a14$var$tableBreakTags = (state)=>{
    const tokens = state.tokens;
    // Find all table tokens
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Check if we're inside a table
        if (token.type === 'table_open') {
            // Process all tokens until the matching table_close
            let j = i + 1;
            while(j < tokens.length && tokens[j].type !== 'table_close'){
                // If we're in a table cell content
                if (tokens && tokens[j]?.type === 'inline' && tokens[j]?.children && tokens[j]?.children?.length) {
                    // Process the content of the cell
                    const children = tokens[j]?.children;
                    if (!children) continue;
                    for(let k = 0; k < children.length; k++){
                        const child = children[k];
                        if (!child) continue;
                        // Replace <br>, <br/>, and <br /> tags with newlines
                        // Match different variations of <br> tags
                        const brRegex = /<br\s*\/?>/gi;
                        if (brRegex.test(child.content)) {
                            child.content = child.content.replace(brRegex, '\n');
                            // If the content is now just a newline, change the token type
                            if (child.content === '\n') child.type = 'hardbreak';
                        }
                    }
                }
                j++;
            }
            // Skip to the end of the table
            i = j;
        }
    }
    return;
};
var $75906c97e0460a14$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('table-break-tags', $75906c97e0460a14$var$tableBreakTags);


const $1502a9fc09adec99$var$CHART_REGEX = /\[\^(chart)\^\]/;
const $1502a9fc09adec99$var$visualizationChart = (state)=>{
    const tokens = [];
    let chartCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $1502a9fc09adec99$var$CHART_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($1502a9fc09adec99$var$CHART_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        // Create a new token for each chart match
                        const chartToken = new state.Token('status', '', 0);
                        chartToken.content = '';
                        chartToken.block = false;
                        chartToken.level = childToken.level;
                        chartToken.attrs = [
                            [
                                'localId',
                                'chart-' + chartCounter
                            ],
                            [
                                'text',
                                'loading chart-' + chartCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(chartToken);
                        chartCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $1502a9fc09adec99$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('chart', $1502a9fc09adec99$var$visualizationChart);
}


const $d663afbcbcce9912$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $d663afbcbcce9912$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>{
            const order = +(tok.attrGet('start') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info?.trim() || null
            })
    },
    image: {
        node: 'image',
        attrs: (_tok)=>{
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: (tok)=>{
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    entityAnnotation: {
        node: 'inlineExtension',
        attrs: (token)=>{
            let parameters = {};
            try {
                parameters = JSON.parse(token.attrGet('parameters') ?? '{}');
            } catch  {
            // Invalid plugin metadata should not prevent the response from rendering.
            }
            return {
                extensionType: token.attrGet('extensionType'),
                extensionKey: token.attrGet('extensionKey'),
                parameters: parameters,
                text: token.attrGet('text')
            };
        }
    },
    status: {
        node: 'status',
        attrs: (token)=>({
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            })
    }
};


/**
 * Sanitizes raw markdown content before it reaches the markdown-it block tokenizer.
 *
 * Two constructs cause `ParserBlock.prototype.tokenize` to enter catastrophic
 * backtracking / exponential rule-matching, causing OOM browser crashes:
 *
 * ## 1. Tables indented 2+ spaces (inside a list item)
 *
 * The `markdown-it-table` plugin requires the table header row to start at
 * column 0 (or ≤1 space of indentation). When an AI response places a table
 * inside a list item — a common pattern — the table rows are indented with
 * 2+ spaces and are never recognized as a table block.
 *
 * Instead, each `|---` separator row triggers markdown-it's `lheading`
 * (setext heading) rule which checks whether the preceding paragraph can be
 * promoted to a heading. This check is O(n) against all prior paragraphs,
 * repeated for every `|` row in the table → O(n²) overall. For documents
 * with 200+ lines and multiple tables, this crashes the browser.
 *
 * ## 2. Code fences indented 4+ spaces (inside nested list items)
 *
 * markdown-it's `fence` block rule only recognizes fences with 0–3 spaces of
 * leading indentation. Fences indented with 4+ spaces (common inside nested
 * list items like "     ```jql") are treated as indented code continuation,
 * meaning the opening fence is never paired with its closing fence. The block
 * parser then tries every rule against the remaining content until EOF →
 * effectively infinite loop → OOM.
 *
 * ## Fix
 *
 * Strip excess leading whitespace from table rows and fence delimiters so
 * they are recognized by the parser as valid block-level constructs. A
 * fence-tracking state machine ensures that table rows and fence delimiters
 * *inside* a code fence are never modified.
 */ // Fast pre-check: matches a line starting with 2+ spaces followed by `|` or ` ``` `.
// Uses (^|\n) so it also catches indented constructs on the very first line.
// If the content has neither, skip the full line-by-line pass entirely.
const $75f540d30ffc20bf$var$NEEDS_SANITIZE_RE = /(?:^|\n) {2,}[|`]/;
function $75f540d30ffc20bf$export$20209a1e2cc01cc1(content) {
    if (!$75f540d30ffc20bf$var$NEEDS_SANITIZE_RE.test(content)) return content;
    const lines = content.split('\n');
    const result = [];
    let inFence = false;
    let fenceIndent = 0;
    for (const line of lines){
        const stripped = line.replace(/^\s+/, '');
        const indent = line.length - stripped.length;
        if (!inFence && stripped.startsWith('```')) {
            if (indent >= 4) {
                // Outdent deeply-indented opening fence to column 0 so the parser
                // recognizes it as a fenced code block
                result.push(stripped);
                inFence = true;
                fenceIndent = indent;
            } else {
                result.push(line);
                inFence = true;
                fenceIndent = indent;
            }
        } else if (inFence && stripped.startsWith('```')) {
            if (indent >= 4 && fenceIndent >= 4) // Outdent matching closing fence
            result.push(stripped);
            else result.push(line);
            inFence = false;
            fenceIndent = 0;
        } else if (!inFence && indent >= 2 && stripped.startsWith('|')) // Outdent table rows that are indented inside list items so
        // markdown-it-table recognizes them as a proper table block
        result.push(stripped);
        else result.push(line);
    }
    return result.join('\n');
}
// Matches a markdown table delimiter/separator row, with or without outer pipes,
// e.g. "--- | ---", "| :--- | ---: |", ":-:|:-:". Requires at least one dash.
const $75f540d30ffc20bf$var$SEPARATOR_ROW_RE = /^\s*\|?\s*:?-{3,}:?\s*(?:\|\s*:?-{3,}:?\s*)*\|?\s*$/;
const $75f540d30ffc20bf$var$isSeparatorRow = (line)=>line.includes('-') && $75f540d30ffc20bf$var$SEPARATOR_ROW_RE.test(line);
const $75f540d30ffc20bf$var$isTableRow = (line)=>line.includes('|') && line.trim().length > 0;
function $75f540d30ffc20bf$export$d000c4875e648c8(content) {
    // Fast pre-check: needs at least one line with a pipe.
    if (!content.includes('|')) return content;
    const addOuterPipes = (line)=>{
        let trimmed = line.trim();
        if (!trimmed.startsWith('|')) trimmed = `| ${trimmed}`;
        if (!trimmed.endsWith('|')) trimmed = `${trimmed} |`;
        return trimmed;
    };
    const isFenceDelimiter = (line)=>line.trimStart().startsWith('```');
    const lines = content.split('\n');
    const result = [];
    let inFence = false;
    for(let i = 0; i < lines.length; i++){
        const line = lines[i];
        // Skip fenced code blocks entirely.
        if (isFenceDelimiter(line)) {
            inFence = !inFence;
            result.push(line);
            continue;
        }
        const next = lines[i + 1];
        // A table starts on a row immediately followed by a separator.
        if (!inFence && $75f540d30ffc20bf$var$isTableRow(line) && next !== undefined && $75f540d30ffc20bf$var$isSeparatorRow(next)) {
            let j = i;
            // Consume contiguous, non-blank rows until the table ends.
            while(j < lines.length && lines[j].trim() !== '' && $75f540d30ffc20bf$var$isTableRow(lines[j])){
                result.push(addOuterPipes(lines[j]));
                j++;
            }
            i = j - 1;
        } else result.push(line);
    }
    return result.join('\n');
}



const $f6c1dd52940ddca5$export$155749302793c60c = (schema, map)=>Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
const $f6c1dd52940ddca5$export$a1cf9d9b96e16789 = (md, schema)=>{
    for(const k in 0, $d663afbcbcce9912$export$cd54a56af01ba875){
        const key = k;
        for(const i in (0, $d663afbcbcce9912$export$cd54a56af01ba875)[key]){
            const idx = i;
            if (schema[key][idx]) md.enable((0, $d663afbcbcce9912$export$cd54a56af01ba875)[key][idx]);
        }
    }
};


class $ed41d4af387b8a76$export$614853bf2169db97 extends (0, $c9zHD.MarkdownTransformer) {
    parse(content) {
        // Sanitize the raw markdown string before it reaches the markdown-it block
        // tokenizer (ParserBlock.tokenize). Indented tables and 4+ space-indented
        // fences can cause catastrophic backtracking / OOM; `sanitizeMarkdown`
        // outdents fences with 4+ spaces of indentation so the parser recognises
        // them as fenced code blocks rather than entering an infinite tokenization
        // loop.
        //
        // Note: md.core.ruler cannot be used here — core rules run AFTER block
        // tokenization, which is too late to prevent the crash. The sanitization
        // must happen on the raw string before parse() is called.
        const annotatedContent = (0, $5aaa28bb8acc8881$export$2e2bcd8739ae039)(content, this.entityAnnotationBatches);
        const preprocessed = (0, $75f540d30ffc20bf$export$d000c4875e648c8)(annotatedContent);
        const node = this.parser.parse((0, $75f540d30ffc20bf$export$20209a1e2cc01cc1)(preprocessed));
        if (!node) return new (0, $aPdNQ.Node)();
        return node;
    }
    constructor(schema, pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, useGroupedCitations, xpcWrapUrl, entityAnnotationBatches){
        super();
        this.parser = void 0;
        this.entityAnnotationBatches = void 0;
        this.entityAnnotationBatches = entityAnnotationBatches;
        const md = (0, $3GWdi.default)('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $f6c1dd52940ddca5$export$a1cf9d9b96e16789)(md, schema);
        // Handle blockquotes inside list items - ADF doesn't support this nesting,
        // so we transform them into emphasized paragraphs
        md.use((0, $d2188aa6b0aad9ac$export$2e2bcd8739ae039));
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $b9f103c37ce71df9$export$763ac077c9998026)(pluginConfig.linkify));
        if (useGroupedCitations) md.use((0, $26c7e36d126f9ad4$export$2e2bcd8739ae039));
        else md.use((0, $330d5ffa0743cdd8$export$2e2bcd8739ae039));
        if ((0, $iDrrr.fg)('rovo_enable_data_sculptor')) md.use((0, $157bfca8bd99df8f$export$2e2bcd8739ae039));
        md.use((0, $14c428bc00c0e101$export$2e2bcd8739ae039));
        md.use((0, $1502a9fc09adec99$export$2e2bcd8739ae039));
        if ((0, $iDrrr.fg)('rovo_chat_enable_inline_lumina')) md.use((0, $bbeb09636b3688aa$export$2e2bcd8739ae039));
        // Actionable follow-up questions
        if ((0, $iDrrr.fg)('rovo_chat_actionable_followups_enabled')) md.use((0, $04a93a56598a27a8$export$2e2bcd8739ae039));
        if (entityAnnotationBatches?.length) md.use((0, $951eec697bfb87e5$export$2e2bcd8739ae039));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) // this is where we should separate it into its own plugin called createSmartLinksPluginRefresh
        md.use((0, $b36376af2b96b431$export$9625a798761643ac)(pluginConfig.smartLinks, isExperimentEnabled, shouldShowAsInline, xpcWrapUrl));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $d6cf044b287ff6bb$export$2e2bcd8739ae039));
        // Table support
        if (schema.nodes.table) {
            md.use((0, $zBSTr.markdownItTable));
            md.use((0, $75906c97e0460a14$export$2e2bcd8739ae039));
        }
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $5125c80d561f745e$export$2e2bcd8739ae039));
        const filter = (0, $f6c1dd52940ddca5$export$155749302793c60c)(schema, (0, $d663afbcbcce9912$export$eb83d753215c78a2));
        this.parser = new (0, $2jzwX.MarkdownParser)(schema, md, filter);
    }
}
module.exports["AiMateMarkdownTransformer"] = $ed41d4af387b8a76$export$614853bf2169db97;

});

parcelRegister("gW8jj", function(module, exports) {
const $e7cc35176845e7d3$export$23af9eff748e2aea = 'com.rovo.entity-annotation';
const $e7cc35176845e7d3$export$d963ad3ac5836752 = 'inferred-project';
const $e7cc35176845e7d3$var$ENTITY_ANNOTATION_TYPES = [
    'Person',
    'InferredProject'
];
const $e7cc35176845e7d3$var$entityAnnotationTypeSet = new Set($e7cc35176845e7d3$var$ENTITY_ANNOTATION_TYPES);
const $e7cc35176845e7d3$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $e7cc35176845e7d3$export$849a23eb7f5c802c = (value)=>$e7cc35176845e7d3$var$isRecord(value) && typeof value.type === 'string' && $e7cc35176845e7d3$var$entityAnnotationTypeSet.has(value.type) && typeof value.mention === 'string' && typeof value.start === 'number' && Number.isFinite(value.start) && typeof value.end === 'number' && Number.isFinite(value.end) && typeof value.ari === 'string' && typeof value.canonicalName === 'string' && typeof value.confidenceScore === 'number' && Number.isFinite(value.confidenceScore);
module.exports["ENTITY_ANNOTATION_EXTENSION_TYPE"] = $e7cc35176845e7d3$export$23af9eff748e2aea;
module.exports["INFERRED_PROJECT_EXTENSION_KEY"] = $e7cc35176845e7d3$export$d963ad3ac5836752;
module.exports["isEntityAnnotationEntity"] = $e7cc35176845e7d3$export$849a23eb7f5c802c;

});

parcelRegister("6Bfyn", function(module, exports) {
/**
 * Actionable Follow-Up Questions parsing utilities.
 *
 * The backend appends a follow-up section to the end of an assistant answer using a
 * single section marker followed by prose with inline `<followup>…</followup>` tagged
 * questions interspersed:
 *
 *   Normal answer text...
 *
 *   ◈If you want I can <followup>Convert this to a FAQ</followup>, <followup>Add target personas</followup>, or <followup>Make the tone more formal</followup>
 *
 * There is no end marker — everything after the first `◈` is the follow-up payload and
 * is assumed to be the last thing in the message. The surrounding prose renders as
 * normal text, while each `<followup>…</followup>` renders as an inline clickable link.
 *
 * See LDR: https://hello.atlassian.net/wiki/spaces/AA6/pages/7164582669
 */ /** Section marker (U+25C8) that denotes the start of the follow-up questions payload. */ const $d346e53a09a489f1$export$159e069055621f01 = "\u25C8";
const $d346e53a09a489f1$export$3b3ac8a86d553ab4 = 'actionable-follow-ups-';
const $d346e53a09a489f1$export$5b6a3157002ae3dc = (localId)=>{
    return localId != null && localId.startsWith($d346e53a09a489f1$export$3b3ac8a86d553ab4);
};
/**
 * Matches each `<followup>…</followup>` segment in the follow-up payload. The inner capture
 * is non-greedy and allows any character (including `<`/`>`), so question text containing
 * angle brackets parses correctly. An unterminated `<followup>` with no closing tag simply
 * does not match and is treated as in-flight prose.
 */ const $d346e53a09a489f1$var$FOLLOW_UP_QUESTION_REGEX = /<followup>([\s\S]*?)<\/followup>/g;
const $d346e53a09a489f1$export$7111c271f22de367 = (payload)=>{
    if (!payload) return [];
    // Strip a leading marker if the caller passed the full section including `◈`.
    const markerIndex = payload.indexOf($d346e53a09a489f1$export$159e069055621f01);
    let text = markerIndex === -1 ? payload : payload.slice(markerIndex + $d346e53a09a489f1$export$159e069055621f01.length);
    // Drop an unterminated trailing `<followup>` fragment so a half-streamed question
    // is not rendered as raw text until its closing tag arrives.
    const lastOpen = text.lastIndexOf('<followup>');
    if (lastOpen !== -1 && text.indexOf('</followup>', lastOpen) === -1) text = text.slice(0, lastOpen);
    const segments = [];
    let lastIndex = 0;
    const pushText = (value)=>{
        if (value) segments.push({
            type: 'text',
            value: value
        });
    };
    for (const match of text.matchAll($d346e53a09a489f1$var$FOLLOW_UP_QUESTION_REGEX)){
        const matchIndex = match.index ?? 0;
        // Prose preceding this question (preserved verbatim).
        pushText(text.slice(lastIndex, matchIndex));
        lastIndex = matchIndex + match[0].length;
        const question = match[1]?.trim();
        if (question) segments.push({
            type: 'question',
            value: question
        });
    }
    // Trailing prose after the final question.
    pushText(text.slice(lastIndex));
    return segments;
};
module.exports["ACTIONABLE_FOLLOW_UPS_MARKER"] = $d346e53a09a489f1$export$159e069055621f01;
module.exports["ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX"] = $d346e53a09a489f1$export$3b3ac8a86d553ab4;
module.exports["isActionableFollowUpsStatus"] = $d346e53a09a489f1$export$5b6a3157002ae3dc;
module.exports["parseActionableFollowUps"] = $d346e53a09a489f1$export$7111c271f22de367;

});

parcelRegister("1rNZu", function(module, exports) {
const $90cb542132d5af8c$export$8288860537fb7872 = 'inline-lumina-';
const $90cb542132d5af8c$export$5d9d37bd58628e00 = (localId)=>{
    return localId != null && localId.startsWith($90cb542132d5af8c$export$8288860537fb7872);
};
module.exports["INLINE_LUMINA_STATUS_PREFIX"] = $90cb542132d5af8c$export$8288860537fb7872;
module.exports["isInlineLuminaStatus"] = $90cb542132d5af8c$export$5d9d37bd58628e00;

});

parcelRegister("kUcLs", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $88340c96f33dece1$export$57ad190cdc563df3 = `/gateway/api/object-resolver/providers`;
const $88340c96f33dece1$export$1a30f994aeced995 = `/gateway/api/object-resolver/resolve/batch`;
const $88340c96f33dece1$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $88340c96f33dece1$export$b9858121ed269ff3 = 'aiMateSmartLinkProviderMapping';


const $300d1def19fa699b$export$4b1056d02426889c = (url, regexStorage)=>{
    const cachedProviderRegex = $300d1def19fa699b$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    try {
        const regexPattern = new RegExp(cachedProviderRegex, 'g');
        return regexPattern.test(url);
    } catch  {
        // Malformed joined provider regex (e.g. duplicate named capture groups) — treat as unsupported.
        return false;
    }
};
const $300d1def19fa699b$export$90caa0c170ea581 = (regexStorage)=>{
    if (regexStorage.getItem((0, $88340c96f33dece1$export$56bec2f197c16818))) return JSON.parse(`${regexStorage.getItem((0, $88340c96f33dece1$export$56bec2f197c16818))}`);
    return '';
};
const $300d1def19fa699b$export$5af966b3aa3b1d83 = (regexStorage, providerRegex)=>{
    regexStorage?.setItem((0, $88340c96f33dece1$export$56bec2f197c16818), JSON.stringify(providerRegex));
};
const $300d1def19fa699b$export$d08c351b3b4e4934 = async (regexStorage, baseUrl)=>{
    const providerData = await $300d1def19fa699b$export$dfebbb511ada4128(baseUrl);
    if (providerData) {
        const providerRegex = $300d1def19fa699b$export$b7ac97ae80c7eb5a(providerData);
        $300d1def19fa699b$export$5af966b3aa3b1d83(regexStorage, providerRegex);
        const providerMapping = $300d1def19fa699b$export$8eafd18d19de7df5(providerData);
        $300d1def19fa699b$export$b22dfe84603542b1(regexStorage, providerMapping);
    }
};
const $300d1def19fa699b$export$b7ac97ae80c7eb5a = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return '';
    const sources = data.providers.reduce((acc, provider)=>{
        const providerSources = provider.patterns?.map((pattern)=>pattern.source) || [];
        return [
            ...acc,
            ...providerSources
        ];
    }, []);
    return sources.join('|');
};
const $300d1def19fa699b$export$8eafd18d19de7df5 = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return {
        combinedRegex: '',
        patterns: []
    };
    const patterns = data.providers.flatMap((provider)=>(provider.patterns || []).map((pattern)=>({
                key: provider.key,
                regex: pattern.source
            })));
    const combinedRegex = patterns.map((p)=>p.regex).join('|');
    return {
        combinedRegex: combinedRegex,
        patterns: patterns
    };
};
const $300d1def19fa699b$export$25b8a9cebf834f6e = (regexStorage)=>{
    const stored = regexStorage.getItem((0, $88340c96f33dece1$export$b9858121ed269ff3));
    if (stored) try {
        return JSON.parse(stored);
    } catch  {
        return null;
    }
    return null;
};
const $300d1def19fa699b$export$b22dfe84603542b1 = (regexStorage, providerMapping)=>{
    regexStorage?.setItem((0, $88340c96f33dece1$export$b9858121ed269ff3), JSON.stringify(providerMapping));
};
const $300d1def19fa699b$export$dfebbb511ada4128 = (0, $dOBRD.default)(async (baseUrl = '')=>{
    try {
        const response = await fetch(baseUrl + (0, $88340c96f33dece1$export$57ad190cdc563df3), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'resolve'
            })
        });
        const data = await response.json();
        return data || null;
    } catch  {
        return null;
    }
});
const $300d1def19fa699b$export$ab8eaff0f2d596bd = (0, $dOBRD.default)(async (baseUrl = '')=>{
    const data = await $300d1def19fa699b$export$dfebbb511ada4128(baseUrl);
    return data ? $300d1def19fa699b$export$b7ac97ae80c7eb5a(data) : '';
});
module.exports["isSupportedByLinkingPlatform"] = $300d1def19fa699b$export$4b1056d02426889c;
module.exports["hydrateLinkingPlatformCache"] = $300d1def19fa699b$export$d08c351b3b4e4934;

});

parcelRegister("dTEBe", function(module, exports) {
const $36649e4ee5b3590e$export$5a550907ffbc9119 = 'rovoChat';
const $36649e4ee5b3590e$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt',
    'promptLibraryOpen',
    'openChatMode'
];


const $f229989060597496$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $f229989060597496$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $f229989060597496$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $f229989060597496$export$9748efee331ec573 = (param)=>`${0, $36649e4ee5b3590e$export$5a550907ffbc9119}${$f229989060597496$export$fda91e425d265029(param)}`;
const $f229989060597496$export$f2888183a34644d4 = (param)=>{
    return $f229989060597496$export$858653b7ee3cbb17(param.replace((0, $36649e4ee5b3590e$export$5a550907ffbc9119), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $f229989060597496$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $f229989060597496$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $36649e4ee5b3590e$export$5a550907ffbc9119))) return;
        const paramKey = $f229989060597496$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $f229989060597496$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $f229989060597496$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $f229989060597496$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $f229989060597496$export$ef04687636c850fe(window.location.pathname, params));
};
const $f229989060597496$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $f229989060597496$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $f229989060597496$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $f229989060597496$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$f229989060597496$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$f229989060597496$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $f229989060597496$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $f229989060597496$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
  For products using react-resource-router (e.g Atlas) to
  pass as the value of `query` on the route definition. It ensures that our parameters
  are not stripped from the URL when loading the page, or through redirect hops
  Any new parameters we want to maintain should be added here as well, which means
  only a version bump is needed in those products to support the latest param list
  The !=false simply means that the parameter is supported but is optional, and should
  not contain a value of 'false'
  */ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $36649e4ee5b3590e$export$3cd6b610e7ede579).map((param)=>`${$f229989060597496$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $f229989060597496$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $f229989060597496$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $f229989060597496$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $f229989060597496$export$eddc20a009406015;

});

parcelRegister("bGNkz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $4m5jb = parcelRequire("4m5jb");

const $af081181a641afaf$export$6fdb848aa0eff3d1 = {
    isActive: false
};
const $af081181a641afaf$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false,
    // If productionized will look to move this logic into conversation-assistant-onboarding
    emptyChatLaunchGreeting: undefined,
    emptyChatLaunchProjectContext: undefined,
    emptyChatLaunchInteractionSource: undefined,
    emptyChatLaunchInvokedFrom: undefined,
    emptyChatLaunchConversationActions: undefined,
    emptyChatLaunchReplaceProviderActions: false,
    emptyChatLaunchSkillRegistryTags: undefined,
    emptyChatLaunchId: 0,
    emptyChatLaunchActive: false,
    selectedSpace: undefined,
    selectedPinnedItem: undefined,
    activeTabId: 'suggestions',
    previousTabId: 'suggestions',
    lastTabConversationId: '',
    lastLifecycleConversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
    lastLifecycleLaunchId: undefined,
    smartLink3PPostAuth: $af081181a641afaf$export$6fdb848aa0eff3d1,
    shouldFocusChatSearch: false
};
const $af081181a641afaf$var$store = (0, $8s9DV.createStore)({
    name: 'uiStore',
    initialState: $af081181a641afaf$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$af081181a641afaf$var$initialState,
                    conversationHeader: null,
                    selectedSpace: undefined
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        setSmartLink3PPostAuth: (payload)=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: payload
                });
            },
        clearSmartLink3PPostAuth: ()=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: $af081181a641afaf$export$6fdb848aa0eff3d1
                });
            },
        setConversationHeader: (header)=>({ setState: setState })=>{
                setState({
                    conversationHeader: header
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            },
        setEmptyChatLaunch: (payload)=>({ setState: setState, getState: getState })=>{
                setState({
                    emptyChatLaunchGreeting: payload.customGreeting,
                    emptyChatLaunchConversationActions: payload.customConversationActions,
                    emptyChatLaunchProjectContext: payload.projectContext,
                    emptyChatLaunchInteractionSource: payload.interactionSource,
                    emptyChatLaunchInvokedFrom: payload.invokedFrom,
                    emptyChatLaunchReplaceProviderActions: payload.replaceProviderActions ?? false,
                    emptyChatLaunchSkillRegistryTags: payload.skillRegistryTags,
                    emptyChatLaunchId: getState().emptyChatLaunchId + 1,
                    emptyChatLaunchActive: true
                });
            },
        clearEmptyChatLaunchGreeting: ({ preserveInteractionSource: preserveInteractionSource = false, expectedLaunchId: expectedLaunchId } = {})=>({ setState: setState, getState: getState })=>{
                if (expectedLaunchId !== undefined && getState().emptyChatLaunchId !== expectedLaunchId) return;
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    ...preserveInteractionSource ? {} : {
                        emptyChatLaunchInteractionSource: undefined
                    },
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        clearEmptyChatLaunchAll: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchProjectContext: undefined,
                    emptyChatLaunchInteractionSource: undefined,
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined,
                    emptyChatLaunchActive: false
                });
            },
        setShouldFocusChatSearch: (shouldFocus)=>({ setState: setState })=>{
                setState({
                    shouldFocusChatSearch: shouldFocus
                });
            },
        setSelectedSpace: (space)=>({ setState: setState })=>{
                setState({
                    selectedSpace: space
                });
            },
        clearSelectedSpace: ()=>({ setState: setState })=>{
                setState({
                    selectedSpace: undefined
                });
            },
        setSelectedPinnedItem: (item)=>({ setState: setState })=>{
                setState({
                    selectedPinnedItem: item
                });
            },
        clearSelectedPinnedItem: ()=>({ setState: setState })=>{
                setState({
                    selectedPinnedItem: undefined
                });
            },
        setActiveTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    activeTabId: tabId
                });
            },
        setPreviousTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    previousTabId: tabId
                });
            },
        setLastTabConversationId: (id)=>({ setState: setState })=>{
                setState({
                    lastTabConversationId: id
                });
            },
        checkAndUpdateLifecycleGuard: (conversationId, launchId)=>({ getState: getState, setState: setState })=>{
                const { lastLifecycleConversationId: lastLifecycleConversationId, lastLifecycleLaunchId: lastLifecycleLaunchId } = getState();
                if (lastLifecycleConversationId === conversationId && lastLifecycleLaunchId === launchId) return false;
                setState({
                    lastLifecycleConversationId: conversationId,
                    lastLifecycleLaunchId: launchId
                });
                return true;
            }
    }
});
const $af081181a641afaf$var$useStore = (0, $kBr4q.createHook)($af081181a641afaf$var$store);
const $af081181a641afaf$export$13a6c73a57f1d6a6 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            customGreeting: state.emptyChatLaunchGreeting,
            projectContext: state.emptyChatLaunchProjectContext,
            interactionSource: state.emptyChatLaunchInteractionSource,
            invokedFrom: state.emptyChatLaunchInvokedFrom,
            customConversationActions: state.emptyChatLaunchConversationActions,
            replaceProviderActions: state.emptyChatLaunchReplaceProviderActions,
            skillRegistryTags: state.emptyChatLaunchSkillRegistryTags,
            launchId: state.emptyChatLaunchId,
            isEmptyChatLaunchActive: state.emptyChatLaunchActive
        })
});
const $af081181a641afaf$export$81a40d215ef1c1de = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeTabId: state.activeTabId,
            previousTabId: state.previousTabId,
            lastTabConversationId: state.lastTabConversationId
        })
});
const $af081181a641afaf$export$5f449dc44751be0a = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$5c79552389bcd8c6 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            selectedPinnedItem: state.selectedPinnedItem
        })
});
const $af081181a641afaf$export$78ce19c6cc1eeb16 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            isAgentSelectorMenuOpen: state.isAgentSelectorMenuOpen,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$1bd034c20714e002 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu
        })
});
const $af081181a641afaf$export$762e860bb8461339 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            mounted: state.mounted
        })
});
const $af081181a641afaf$export$b5d8051ebd0ce9b2 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            shouldFocusChatSearch: state.shouldFocusChatSearch
        })
});
const $af081181a641afaf$export$d3b1853c9cb98102 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen
        })
});
const $af081181a641afaf$export$f4c4584d8302c703 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            conversationHeader: state.conversationHeader
        })
});
const $af081181a641afaf$export$1e3791eaae70097a = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$357ffd05205e0c5d = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$9e369d8095358b77 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$8f5523dfac6ff4fa = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$5b2ba9b8ea3b0771 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(29);
    const [t0, t1] = $af081181a641afaf$var$useStore();
    const { activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, selectedPinnedItem: selectedPinnedItem, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth } = t0;
    const { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setSelectedPinnedItem: setSelectedPinnedItem, clearSelectedPinnedItem: clearSelectedPinnedItem, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth } = t1;
    const t2 = conversationHeader ?? null;
    let t3;
    if ($[0] !== activeMenu || $[1] !== activeTabId || $[2] !== clearSelectedPinnedItem || $[3] !== clearSelectedSpace || $[4] !== clearSmartLink3PPostAuth || $[5] !== isAgentSelectorMenuOpen || $[6] !== isChatOnboardingMiniModalOpen || $[7] !== lastTabConversationId || $[8] !== mounted || $[9] !== previousTabId || $[10] !== reset || $[11] !== selectedPinnedItem || $[12] !== selectedSpace || $[13] !== setActiveMenu || $[14] !== setActiveTabId || $[15] !== setConversationHeader || $[16] !== setIsAgentSelectorMenuOpen || $[17] !== setIsChatOnboardingMiniModalOpen || $[18] !== setLastTabConversationId || $[19] !== setMounted || $[20] !== setPreviousTabId || $[21] !== setSelectedPinnedItem || $[22] !== setSelectedSpace || $[23] !== setSmartLink3PPostAuth || $[24] !== setStreamingStatus || $[25] !== smartLink3PPostAuth || $[26] !== streaming || $[27] !== t2) {
        t3 = {
            activeMenu: activeMenu,
            mounted: mounted,
            streaming: streaming,
            isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
            conversationHeader: t2,
            selectedSpace: selectedSpace,
            selectedPinnedItem: selectedPinnedItem,
            reset: reset,
            setActiveMenu: setActiveMenu,
            setMounted: setMounted,
            setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
            setStreamingStatus: setStreamingStatus,
            isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
            setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
            setConversationHeader: setConversationHeader,
            setSelectedSpace: setSelectedSpace,
            clearSelectedSpace: clearSelectedSpace,
            setSelectedPinnedItem: setSelectedPinnedItem,
            clearSelectedPinnedItem: clearSelectedPinnedItem,
            activeTabId: activeTabId,
            previousTabId: previousTabId,
            lastTabConversationId: lastTabConversationId,
            smartLink3PPostAuth: smartLink3PPostAuth,
            setSmartLink3PPostAuth: setSmartLink3PPostAuth,
            clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
            setActiveTabId: setActiveTabId,
            setPreviousTabId: setPreviousTabId,
            setLastTabConversationId: setLastTabConversationId
        };
        $[0] = activeMenu;
        $[1] = activeTabId;
        $[2] = clearSelectedPinnedItem;
        $[3] = clearSelectedSpace;
        $[4] = clearSmartLink3PPostAuth;
        $[5] = isAgentSelectorMenuOpen;
        $[6] = isChatOnboardingMiniModalOpen;
        $[7] = lastTabConversationId;
        $[8] = mounted;
        $[9] = previousTabId;
        $[10] = reset;
        $[11] = selectedPinnedItem;
        $[12] = selectedSpace;
        $[13] = setActiveMenu;
        $[14] = setActiveTabId;
        $[15] = setConversationHeader;
        $[16] = setIsAgentSelectorMenuOpen;
        $[17] = setIsChatOnboardingMiniModalOpen;
        $[18] = setLastTabConversationId;
        $[19] = setMounted;
        $[20] = setPreviousTabId;
        $[21] = setSelectedPinnedItem;
        $[22] = setSelectedSpace;
        $[23] = setSmartLink3PPostAuth;
        $[24] = setStreamingStatus;
        $[25] = smartLink3PPostAuth;
        $[26] = streaming;
        $[27] = t2;
        $[28] = t3;
    } else t3 = $[28];
    return t3;
} : ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, selectedPinnedItem: selectedPinnedItem, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setSelectedPinnedItem: setSelectedPinnedItem, clearSelectedPinnedItem: clearSelectedPinnedItem, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth }] = $af081181a641afaf$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        conversationHeader: conversationHeader ?? null,
        selectedSpace: selectedSpace,
        selectedPinnedItem: selectedPinnedItem,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
        setConversationHeader: setConversationHeader,
        setSelectedSpace: setSelectedSpace,
        clearSelectedSpace: clearSelectedSpace,
        setSelectedPinnedItem: setSelectedPinnedItem,
        clearSelectedPinnedItem: clearSelectedPinnedItem,
        activeTabId: activeTabId,
        previousTabId: previousTabId,
        lastTabConversationId: lastTabConversationId,
        smartLink3PPostAuth: smartLink3PPostAuth,
        setSmartLink3PPostAuth: setSmartLink3PPostAuth,
        clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
        setActiveTabId: setActiveTabId,
        setPreviousTabId: setPreviousTabId,
        setLastTabConversationId: setLastTabConversationId
    };
};
const $af081181a641afaf$export$cd2fc25ddd3752d4 = (0, $kBr4q.createActionsHook)($af081181a641afaf$var$store);
const $af081181a641afaf$var$isRenderStabilizationEnabled = ()=>(0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false);
const $af081181a641afaf$export$f0adc1af32e51b = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>$af081181a641afaf$var$isRenderStabilizationEnabled() ? null : state
});
module.exports["useEmptyChatLaunchSelector"] = $af081181a641afaf$export$13a6c73a57f1d6a6;
module.exports["useActiveTabSelector"] = $af081181a641afaf$export$81a40d215ef1c1de;
module.exports["useSelectedSpaceSelector"] = $af081181a641afaf$export$5f449dc44751be0a;
module.exports["useSelectedPinnedItemSelector"] = $af081181a641afaf$export$5c79552389bcd8c6;
module.exports["useChatHeaderUISelector"] = $af081181a641afaf$export$78ce19c6cc1eeb16;
module.exports["useActiveMenuSelector"] = $af081181a641afaf$export$1bd034c20714e002;
module.exports["useMountedSelector"] = $af081181a641afaf$export$762e860bb8461339;
module.exports["useShouldFocusChatSearchSelector"] = $af081181a641afaf$export$b5d8051ebd0ce9b2;
module.exports["useConversationHeaderSelector"] = $af081181a641afaf$export$f4c4584d8302c703;
module.exports["useChatInputUISelector"] = $af081181a641afaf$export$357ffd05205e0c5d;
module.exports["useSideNavUISelector"] = $af081181a641afaf$export$9e369d8095358b77;
module.exports["useRootUISelector"] = $af081181a641afaf$export$8f5523dfac6ff4fa;
module.exports["useUIStore"] = $af081181a641afaf$export$5b2ba9b8ea3b0771;
module.exports["useUIStoreActions"] = $af081181a641afaf$export$cd2fc25ddd3752d4;
module.exports["useUIStoreSubscription"] = $af081181a641afaf$export$f0adc1af32e51b;

});

parcelRegister("4m5jb", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $igOtY = parcelRequire("igOtY");

const $ee15880d8017ee4c$export$a08ae3ac6db36809 = 'EMPTY_CONVERSATION_ID';
const $ee15880d8017ee4c$export$43475135ab77130a = ()=>({
        conversations: {
            EMPTY_CONVERSATION_ID: {
                id: $ee15880d8017ee4c$export$a08ae3ac6db36809,
                messages: [],
                name: '',
                status: (0, $igOtY.CHAT_STORE_STATUS).idle,
                traces: [],
                timeCreated: new Date().toISOString()
            }
        },
        currentConversationId: $ee15880d8017ee4c$export$a08ae3ac6db36809,
        isConversationsInitialized: false,
        conversationPagination: {
            ...(0, $igOtY.DEFAULT_CONVERSATION_PAGINATION)
        }
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $ee15880d8017ee4c$var$store;
const $ee15880d8017ee4c$export$8572e013e9dc20c3 = (actions)=>{
    if (!$ee15880d8017ee4c$var$store) $ee15880d8017ee4c$var$store = (0, $8s9DV.createStore)({
        name: 'ConversationAssistantStore',
        initialState: $ee15880d8017ee4c$export$43475135ab77130a(),
        actions: actions
    });
    // The module-level `store` is typed as `any` because its action type T is
    // not known at declaration time. The cast here is safe: `createChatStore` is
    // always called with the same concrete actions object.
    return $ee15880d8017ee4c$var$store;
};
module.exports["EMPTY_CONVERSATION_ID"] = $ee15880d8017ee4c$export$a08ae3ac6db36809;
module.exports["createInitialChatState"] = $ee15880d8017ee4c$export$43475135ab77130a;
module.exports["createChatStore"] = $ee15880d8017ee4c$export$8572e013e9dc20c3;

});

parcelRegister("igOtY", function(module, exports) {
var $318bcc25577ef9d7$export$69799355b7de2229 = /*#__PURE__*/ function(StoreActionLoggableName) {
    StoreActionLoggableName["addStoreChatItem"] = "addStoreChatItem";
    StoreActionLoggableName["addHumanMessage"] = "addHumanMessage";
    StoreActionLoggableName["addAssistantMessage"] = "addAssistantMessage";
    StoreActionLoggableName["clearFollowUpMessages"] = "clearFollowUpMessages";
    StoreActionLoggableName["sendMessage"] = "sendMessage";
    StoreActionLoggableName["sendMessageConfirmedTools"] = "sendMessageConfirmedTools";
    StoreActionLoggableName["sendA2UIAction"] = "sendA2UIAction";
    StoreActionLoggableName["removeMessage"] = "removeMessage";
    StoreActionLoggableName["truncateFromLastHumanMessage"] = "truncateFromLastHumanMessage";
    StoreActionLoggableName["fetchConversation"] = "fetchConversation";
    StoreActionLoggableName["prefetchConversationMessages"] = "prefetchConversationMessages";
    StoreActionLoggableName["reconnectToInProgressStream"] = "reconnectToInProgressStream";
    StoreActionLoggableName["abortRequests"] = "abortRequests";
    StoreActionLoggableName["answerNow"] = "answerNow";
    StoreActionLoggableName["addErrorMessage"] = "addErrorMessage";
    StoreActionLoggableName["fetchConversationChannelsData"] = "fetchConversationChannelsData";
    StoreActionLoggableName["loadMoreConversationChannelsData"] = "loadMoreConversationChannelsData";
    StoreActionLoggableName["hydrateConversation"] = "hydrateConversation";
    StoreActionLoggableName["addAgentMessage"] = "addAgentMessage";
    StoreActionLoggableName["handleChatOpenPubsubAction"] = "handleChatOpenPubsubAction";
    StoreActionLoggableName["createConversationOptimistically"] = "createConversationOptimistically";
    StoreActionLoggableName["createSeededConversation"] = "createSeededConversation";
    StoreActionLoggableName["updateActionInvocationStatus"] = "updateActionInvocationStatus";
    StoreActionLoggableName["updateActionData"] = "updateActionData";
    StoreActionLoggableName["resolveConversationAction"] = "resolveConversationAction";
    StoreActionLoggableName["bulkResolveConversationActions"] = "bulkResolveConversationActions";
    StoreActionLoggableName["bulkResolveConversationUIActions"] = "bulkResolveConversationUIActions";
    StoreActionLoggableName["setSelectedConversation"] = "setSelectedConversation";
    StoreActionLoggableName["warmConversationCache"] = "warmConversationCache";
    StoreActionLoggableName["hasConversationMessages"] = "hasConversationMessages";
    StoreActionLoggableName["stopTask"] = "stopTask";
    return StoreActionLoggableName;
}({});
const $318bcc25577ef9d7$export$61e8a5ac076d12b3 = {
    nextCursor: null,
    hasMore: false,
    isLoadingMore: false,
    loadMoreError: null,
    isConversationListMounted: false
};
const $318bcc25577ef9d7$export$8ec4190061b584d5 = (status)=>status?.type === 'AVAILABLE';
const $318bcc25577ef9d7$export$fe950e85847f6d5d = {
    AVAILABLE: 'AVAILABLE',
    SWITCHING: 'SWITCHING',
    SWITCHING_REQUESTED: 'SWITCHING_REQUESTED',
    SWITCHED: 'SWITCHED',
    ERRORED: 'ERRORED'
};
var $318bcc25577ef9d7$export$817d6b1b984afeb7 = /*#__PURE__*/ function(CHAT_STORE_STATUS) {
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["idle"] = 0] = "idle";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["loadingChat"] = 1] = "loadingChat";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["awaitingResponse"] = 2] = "awaitingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["typingResponse"] = 3] = "typingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["deactivatedAgentError"] = 4] = "deactivatedAgentError";
    return CHAT_STORE_STATUS;
}({});
const $318bcc25577ef9d7$var$TERMINAL_TASK_STATES = [
    'Completed',
    'Failed',
    'Cancelled'
];
const $318bcc25577ef9d7$export$e87901ebf76c08a1 = (state)=>$318bcc25577ef9d7$var$TERMINAL_TASK_STATES.includes(state);
const $318bcc25577ef9d7$export$75e97486ff2b4c62 = (message)=>'type' in message && message.type === 'HUMAN';
const $318bcc25577ef9d7$export$d99f52ae2a325014 = (message)=>'type' in message && message.type === 'ASSISTANT';
const $318bcc25577ef9d7$export$9e2d714e96946d26 = (message)=>'type' in message && message.type === 'ERROR';
const $318bcc25577ef9d7$export$f2b8d80523e7041 = (message)=>$318bcc25577ef9d7$export$75e97486ff2b4c62(message) || $318bcc25577ef9d7$export$d99f52ae2a325014(message);
const $318bcc25577ef9d7$export$61c7dbb423a56ae7 = (message)=>'type' in message && message.type === 'MEMORY_UPDATE';
const $318bcc25577ef9d7$export$7c65a4fb7b6131a1 = (message)=>'type' in message && message.type === 'FOLLOW_UP';
const $318bcc25577ef9d7$export$2e85f4812cb59241 = (message)=>'type' in message && message.type === 'LIVE_CHAT';
const $318bcc25577ef9d7$export$20f0f8aded5b11e5 = (message)=>'type' in message && message.type === 'TWILIO_LIVE_CHAT_AGENT';
const $318bcc25577ef9d7$export$908578fde1b22b55 = (message)=>$318bcc25577ef9d7$export$75e97486ff2b4c62(message) && message.source === 'TWILIO_LIVE_CHAT';
const $318bcc25577ef9d7$export$3db8a80b25c44828 = (message)=>$318bcc25577ef9d7$export$20f0f8aded5b11e5(message) || $318bcc25577ef9d7$export$908578fde1b22b55(message);
const $318bcc25577ef9d7$export$d15e7fe0f58ee5d0 = (message)=>message.type === 'ACTION_PREPARE';
const $318bcc25577ef9d7$export$533a80cec0f4f28f = (message)=>message.type === 'GUARD_BLOCK';
const $318bcc25577ef9d7$export$155f16100a67670d = (message)=>'type' in message && message.type === 'USAGE_HINT';
const $318bcc25577ef9d7$export$3070678f252266e3 = (invocationId, invokedActions)=>invokedActions && invokedActions[invocationId] || 'idle';
module.exports["StoreActionLoggableName"] = $318bcc25577ef9d7$export$69799355b7de2229;
module.exports["DEFAULT_CONVERSATION_PAGINATION"] = $318bcc25577ef9d7$export$61e8a5ac076d12b3;
module.exports["isAnswerNowAvailable"] = $318bcc25577ef9d7$export$8ec4190061b584d5;
module.exports["AnswerNowStatusType"] = $318bcc25577ef9d7$export$fe950e85847f6d5d;
module.exports["CHAT_STORE_STATUS"] = $318bcc25577ef9d7$export$817d6b1b984afeb7;
module.exports["isTerminalTaskState"] = $318bcc25577ef9d7$export$e87901ebf76c08a1;
module.exports["isStoreHuman"] = $318bcc25577ef9d7$export$75e97486ff2b4c62;
module.exports["isStoreAssistant"] = $318bcc25577ef9d7$export$d99f52ae2a325014;
module.exports["isStoreError"] = $318bcc25577ef9d7$export$9e2d714e96946d26;
module.exports["isStoreMessage"] = $318bcc25577ef9d7$export$f2b8d80523e7041;
module.exports["isStoreFollowUp"] = $318bcc25577ef9d7$export$7c65a4fb7b6131a1;
module.exports["isStoreUsageHint"] = $318bcc25577ef9d7$export$155f16100a67670d;
module.exports["getActionInvocationStatus"] = $318bcc25577ef9d7$export$3070678f252266e3;

});

parcelRegister("6rwn6", function(module, exports) {
/* eslint-disable @atlaskit/platform/one-value-export-per-file -- This file predates the rule and is a shared subpath entry point consumed by many packages; splitting would require coordinated changes across the entire monorepo. */ 
var $4wRTw = parcelRequire("4wRTw");


var $6FNab = parcelRequire("6FNab");


var $hUsog = parcelRequire("hUsog");


var $8lhhf = parcelRequire("8lhhf");

const $c360078fe01b00e3$export$d801201dc544181 = (content)=>{
    /*
  This try-catch is a necessary guard rail against broken content to prevent higher level
  error boundaries from displaying the error and breaking the experience.
  */ try {
        return typeof content !== 'string' && 'type' in content && content.type === 'doc';
    } catch  {
        return false;
    }
};
const $c360078fe01b00e3$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($c360078fe01b00e3$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $c360078fe01b00e3$var$pluginConfig = {
    linkify: {
        findFilepaths: $4wRTw.findFilepaths,
        isLinkInMatches: $4wRTw.isLinkInMatches
    },
    smartLinks: {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        regexStorage: globalThis.localStorage
    }
};
const $c360078fe01b00e3$export$3374c63d7715b4ce = new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, false));
const $c360078fe01b00e3$var$streamingAdfEncoder = new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, true));
const $c360078fe01b00e3$export$53ded0b846f45216 = (content, streaming = false, isExperimentEnabled, shouldShowAsInline, useGroupedCitations, xpcWrapUrl, entityAnnotationBatches)=>{
    if ($c360078fe01b00e3$export$d801201dc544181(content)) return content;
    if (isExperimentEnabled || shouldShowAsInline || xpcWrapUrl || entityAnnotationBatches?.length) return new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, useGroupedCitations, xpcWrapUrl, entityAnnotationBatches)).encode(content);
    else if (useGroupedCitations) return streaming ? new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, true, undefined, undefined, true)).encode(content) : new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, useGroupedCitations)).encode(content);
    else return streaming ? $c360078fe01b00e3$var$streamingAdfEncoder.encode(content) : $c360078fe01b00e3$export$3374c63d7715b4ce.encode(content);
};
const $c360078fe01b00e3$export$cc924f6f2bb49b7c = (content)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let match;
    let promptLength = 0;
    // Find all skill tag matches
    const matches = [];
    while((match = (0, $8lhhf.ROVO_SKILL_TAG_PATTERN).exec(content)) !== null)matches.push({
        index: match.index,
        skillSlug: match[1],
        // The skill name without the slash
        length: match[0].length // Length of "/skill-name"
    });
    // Process the string segment by segment
    for(let i = 0; i < matches.length; i++){
        const currentMatch = matches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textBefore = content.substring(lastIndex, matchStart);
            if (textBefore) {
                contentNodes.push({
                    type: 'text',
                    text: textBefore
                });
                promptLength += textBefore.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.skillSlug
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text after the last match (if any)
    if (lastIndex < content.length) {
        const textAfter = content.substring(lastIndex);
        if (textAfter) {
            contentNodes.push({
                type: 'text',
                text: textAfter
            });
            promptLength += textAfter.length;
        }
    }
    // If no matches were found, return the entire string as text
    if (contentNodes.length === 0) {
        contentNodes.push({
            type: 'text',
            text: content
        });
        promptLength += content.length;
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength
    };
};
const $c360078fe01b00e3$export$b663bc0d84e6eaa6 = '`';
// encodeAdf removes leading spaces, so prepend a text node with the segment's leading spaces to preserve them.
const $c360078fe01b00e3$var$preserveLeadingSpaces = (textSegment, nodes)=>{
    const leading = textSegment.match(/^\s*/)?.[0] ?? '';
    if (leading.length === 0) return nodes;
    return [
        {
            type: 'text',
            text: leading
        },
        ...nodes
    ];
};
// Collect all content nodes from all top-level blocks, since encodeAdf can return multiple paragraphs for e.g. "line1\n\nline2".
const $c360078fe01b00e3$var$getAllNodesFromSegmentAdf = (segmentAdf, fallbackSegment)=>{
    const blocks = segmentAdf.content ?? [];
    if (blocks.length === 0) return [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
    const nodes = blocks.flatMap((block)=>block.content ?? []);
    return nodes.length > 0 ? nodes : [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
};
const $c360078fe01b00e3$var$detectSkills = (content, skillMetadata)=>{
    if (!skillMetadata) return [];
    const regex = new RegExp((0, $8lhhf.ROVO_SKILL_TAG_PATTERN).source, 'g');
    const matches = [
        ...content.matchAll(regex)
    ];
    if (matches.length === 0) return [];
    return matches.filter((m)=>m[1] in skillMetadata).map((m)=>({
            index: m.index ?? 0,
            slug: m[1],
            length: m[0].length
        }));
};
// The conversation input editor only supports a limited set of block node types.
// Convert unsupported block nodes to paragraph nodes so that prompts containing
// markdown headings (e.g. "## Title") or horizontal rules (e.g. "---") do not
// trigger "This editor does not support displaying this content: <type>" when inserted.
const $c360078fe01b00e3$var$sanitizeAdfForPromptInput = (adf)=>{
    if (!adf.content) return adf;
    return {
        ...adf,
        content: adf.content.flatMap((node)=>{
            if (node.type === 'heading') // Convert heading to paragraph, preserving inner text content
            return [
                {
                    type: 'paragraph',
                    content: node.content
                }
            ];
            if (node.type === 'rule') // Drop horizontal rules entirely — they have no content to preserve
            return [];
            return [
                node
            ];
        })
    };
};
const $c360078fe01b00e3$export$20cf1197bba4fe47 = (content, skillMetadata, shouldShowAsInline)=>{
    const skillMatches = $c360078fe01b00e3$var$detectSkills(content, skillMetadata);
    if (skillMatches.length === 0) {
        const { placeholderRange: placeholderRange } = $c360078fe01b00e3$var$getPlaceholderRange(content, 0);
        return {
            adf: $c360078fe01b00e3$var$sanitizeAdfForPromptInput($c360078fe01b00e3$export$53ded0b846f45216(content, false, undefined, shouldShowAsInline)),
            promptLength: content.length,
            ...placeholderRange && {
                placeholderRange: placeholderRange
            }
        };
    }
    return $c360078fe01b00e3$var$encodePromptWithSkills(content, skillMatches, skillMetadata);
};
const $c360078fe01b00e3$var$encodePromptWithSkills = (content, skillMatches, skillMetadata)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let promptLength = 0;
    let placeholderRange;
    for(let i = 0; i < skillMatches.length; i++){
        const currentMatch = skillMatches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text and placeholder range before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textSegment = content.substring(lastIndex, matchStart);
            if (textSegment) {
                const { placeholderRange: range } = $c360078fe01b00e3$var$getPlaceholderRange(textSegment, promptLength);
                if (range) placeholderRange = range;
                const segmentAdf = $c360078fe01b00e3$export$53ded0b846f45216(textSegment);
                const nodes = $c360078fe01b00e3$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
                contentNodes.push(...$c360078fe01b00e3$var$preserveLeadingSpaces(textSegment, nodes));
                promptLength += textSegment.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.slug,
                    ...skillMetadata?.[currentMatch.slug]
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text and placeholder range after the last match (if any)
    if (lastIndex < content.length) {
        const textSegment = content.substring(lastIndex);
        if (textSegment) {
            const { placeholderRange: range } = $c360078fe01b00e3$var$getPlaceholderRange(textSegment, promptLength);
            if (range) placeholderRange = range;
            const segmentAdf = $c360078fe01b00e3$export$53ded0b846f45216(textSegment);
            const nodes = $c360078fe01b00e3$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
            contentNodes.push(...$c360078fe01b00e3$var$preserveLeadingSpaces(textSegment, nodes));
            promptLength += textSegment.length;
        }
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength,
        ...placeholderRange && {
            placeholderRange: placeholderRange
        }
    };
};
// Returns the placeholder range for link typeahead when content has `label` backticks.
const $c360078fe01b00e3$var$getPlaceholderRange = (segment, currentContentIndex)=>{
    const firstBacktick = segment.indexOf($c360078fe01b00e3$export$b663bc0d84e6eaa6);
    const lastBacktick = segment.lastIndexOf($c360078fe01b00e3$export$b663bc0d84e6eaa6);
    if (firstBacktick !== -1 && lastBacktick !== -1 && firstBacktick !== lastBacktick) {
        const label = segment.slice(firstBacktick + 1, lastBacktick);
        const start = currentContentIndex + firstBacktick + 1;
        return {
            placeholderRange: {
                start: start,
                end: start + label.length,
                label: label
            }
        };
    }
    return {};
};
module.exports["isAdfContent"] = $c360078fe01b00e3$export$d801201dc544181;
module.exports["appendContent"] = $c360078fe01b00e3$export$a236f395afded7e0;
module.exports["adfEncoder"] = $c360078fe01b00e3$export$3374c63d7715b4ce;
module.exports["encodeAdf"] = $c360078fe01b00e3$export$53ded0b846f45216;
module.exports["encodeSkillPromptToAdf"] = $c360078fe01b00e3$export$cc924f6f2bb49b7c;
module.exports["PROMPT_PLACEHOLDER_CHAR"] = $c360078fe01b00e3$export$b663bc0d84e6eaa6;
module.exports["encodePromptToAdf"] = $c360078fe01b00e3$export$20cf1197bba4fe47;

});

parcelRegister("2yWJZ", function(module, exports) {

var $as9lu = parcelRequire("as9lu");

const $7f640ed30a5677e6$export$62a80b577b02c670 = 'ai_mate_agent';
const $7f640ed30a5677e6$export$eaedd3c4d259c3db = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
const $7f640ed30a5677e6$export$d4e191820de5cb9e = $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$cf40b355c500b3f7 = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
const $7f640ed30a5677e6$export$84f2221dfd1486e2 = 'SYSTEM';
const $7f640ed30a5677e6$export$d54b716922cade63 = (value)=>{
    const trimmed = value?.trim();
    return trimmed ? trimmed : undefined;
};
const $7f640ed30a5677e6$export$4529494ee013eb50 = ({ agentId: agentId, agentNamedId: agentNamedId })=>$7f640ed30a5677e6$export$d54b716922cade63(agentId) === $7f640ed30a5677e6$export$eaedd3c4d259c3db || $7f640ed30a5677e6$export$d54b716922cade63(agentNamedId) === $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$71c4912d3c1bf3e3 = (value)=>{
    const normalizedValue = $7f640ed30a5677e6$export$d54b716922cade63(value);
    if (!normalizedValue) return undefined;
    if (!normalizedValue.includes('ari:')) return normalizedValue;
    try {
        return $7f640ed30a5677e6$export$d54b716922cade63((0, $as9lu.IdentityUserAri).parse(normalizedValue).userId);
    } catch  {
        return undefined;
    }
};
module.exports["ROVO_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$62a80b577b02c670;
module.exports["ROVO_AGENT_UUID"] = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
module.exports["DEFAULT_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$d4e191820de5cb9e;
module.exports["DEFAULT_AGENT_UUID"] = $7f640ed30a5677e6$export$cf40b355c500b3f7;
module.exports["DEFAULT_AGENT_CREATOR_TYPE"] = $7f640ed30a5677e6$export$84f2221dfd1486e2;
module.exports["trimToUndefined"] = $7f640ed30a5677e6$export$d54b716922cade63;
module.exports["isDefaultRovoChat"] = $7f640ed30a5677e6$export$4529494ee013eb50;
module.exports["normalizeAccountIdFromIdentityAri"] = $7f640ed30a5677e6$export$71c4912d3c1bf3e3;

});

parcelRegister("oV0CU", function(module, exports) {
const $b9ae9242f3c4f5b9$export$4b225aae27e9366b = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $b9ae9242f3c4f5b9$export$c87b1e2e3344192f = 1000;
const $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e = 60;
const $b9ae9242f3c4f5b9$export$cd6b7e688e614eeb = $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * 60;
const $b9ae9242f3c4f5b9$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $b9ae9242f3c4f5b9$export$e8114853eca81277 = 'ai-mate';
const $b9ae9242f3c4f5b9$export$45d167a0ef5aef8d = '/gateway/api/directory/graphql';
const $b9ae9242f3c4f5b9$export$1ea9613e3e37d315 = 30 * $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
const $b9ae9242f3c4f5b9$export$501af059da333e01 = 5 * $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
const $b9ae9242f3c4f5b9$export$f8d883b8f9181b19 = 'rovoChatLastMessageSentAt';
const $b9ae9242f3c4f5b9$export$85d90d98449e85fd = 140;
const $b9ae9242f3c4f5b9$export$cad0f6e78cd99203 = '600px';
const $b9ae9242f3c4f5b9$export$73f6568f4f3fdeda = 380;
const $b9ae9242f3c4f5b9$export$2c094f7f70c376e3 = 480;
const $b9ae9242f3c4f5b9$export$2e9abc2f500a1704 = 280;
const $b9ae9242f3c4f5b9$export$ac95424456cde4ce = 760;
const $b9ae9242f3c4f5b9$export$1a72156daebf0ea3 = 'conversation-assistant.split-layout.right-width';
module.exports["FEEDBACK_COLLECTOR_ENTRYPOINT_ID"] = $b9ae9242f3c4f5b9$export$4b225aae27e9366b;
module.exports["MS_IN_SECOND"] = $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
module.exports["SECONDS_IN_HR"] = $b9ae9242f3c4f5b9$export$cd6b7e688e614eeb;
module.exports["AI_MATE_EXPERIENCE_ID"] = $b9ae9242f3c4f5b9$export$e8114853eca81277;
module.exports["SHORTER_TIMEOUT_BEFORE_NEW_CHAT"] = $b9ae9242f3c4f5b9$export$501af059da333e01;
module.exports["LS_LAST_MESSAGE_SENT_AT"] = $b9ae9242f3c4f5b9$export$f8d883b8f9181b19;
module.exports["MINI_MODAL_GREETING_HEIGHT"] = $b9ae9242f3c4f5b9$export$85d90d98449e85fd;
module.exports["MINI_MODAL_EXPANDED_HEIGHT"] = $b9ae9242f3c4f5b9$export$cad0f6e78cd99203;
module.exports["SPLIT_LAYOUT_INITIAL_WIDTH"] = $b9ae9242f3c4f5b9$export$73f6568f4f3fdeda;
module.exports["SPLIT_LAYOUT_MIN_WIDTH"] = $b9ae9242f3c4f5b9$export$2c094f7f70c376e3;
module.exports["SPLIT_LAYOUT_ADJACENT_MIN_WIDTH"] = $b9ae9242f3c4f5b9$export$2e9abc2f500a1704;
module.exports["SPLIT_LAYOUT_MIN_PANEL_WIDTH"] = $b9ae9242f3c4f5b9$export$ac95424456cde4ce;
module.exports["SPLIT_LAYOUT_STORAGE_KEY"] = $b9ae9242f3c4f5b9$export$1a72156daebf0ea3;

});

parcelRegister("lx3cN", function(module, exports) {

var $4m5jb = parcelRequire("4m5jb");


var $8OiFS = parcelRequire("8OiFS");


var $igOtY = parcelRequire("igOtY");


var $byYzg = parcelRequire("byYzg");


var $l6xCb = parcelRequire("l6xCb");


var $icBz6 = parcelRequire("icBz6");

const $371ae8b5b22d3b46$export$217edc90936e0581 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).addAgentMessage, ({ conversationId: conversationId, agentNamedId: agentNamedId, content: content })=>({ dispatch: dispatch })=>{
        dispatch((0, $byYzg.addAssistantMessage)({
            id: (0, $icBz6.generateId)(),
            content: content,
            conversationId: conversationId,
            agentNamedId: agentNamedId
        }));
    });






var $fQYiO = parcelRequire("fQYiO");





var $eBgZa = parcelRequire("eBgZa");

const $20d942c7fe0333b7$export$1824e64235e4b973 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).addErrorMessage, ({ error: error, conversationId: conversationId, errorPrefix: errorPrefix })=>({ dispatch: dispatch })=>{
        dispatch((0, $fQYiO.addStoreChatItem)({
            message: (0, $eBgZa.createStoreError)(error, errorPrefix),
            conversationId: conversationId
        }));
    });



var $irnO2 = parcelRequire("irnO2");








var $fS02I = parcelRequire("fS02I");

const $3e2d3625545c1ea9$export$d5b8fce20f45b1bf = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).answerNow, ({ conversationId: conversationIdParam, tmpMessageId: tmpMessageId, remoteMessageId: remoteMessageId })=>async ({ getState: getState, setState: setState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        // Helper to update conversation traces
        const updateConversationTrace = (traceMessage)=>{
            const state = getState();
            const conversation = state.conversations[conversationId];
            if (conversation) setState({
                conversations: {
                    ...state.conversations,
                    [conversationId]: {
                        ...conversation,
                        traces: [
                            {
                                messageContent: traceMessage
                            }
                        ]
                    }
                }
            });
        };
        // Verify the message exists and has answerNowStatus === AVAILABLE
        // Also prevents duplicate requests if status is already SWITCHING
        const messages = getMessages(conversationId);
        const targetMessage = messages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
        if (!targetMessage || !(0, $igOtY.isStoreAssistant)(targetMessage) || !(0, $igOtY.isAnswerNowAvailable)(targetMessage.answerNowStatus)) return;
        // Optimistic update: Set SWITCHING status first and update trace message
        const updatedMessages = (0, $fS02I.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpMessageId, {
            type: (0, $igOtY.AnswerNowStatusType).SWITCHING
        });
        setMessages(conversationId, updatedMessages);
        updateConversationTrace('Generating answer now!');
        // Start experience tracking
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).ANSWER_NOW,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                remoteMessageId: remoteMessageId,
                tmpMessageId: tmpMessageId
            }
        });
        try {
            // Call the Answer Now API with the remote (BE-provided) message ID
            await assistanceService.answerNow(conversationId, remoteMessageId);
            // Only set SWITCHING_REQUESTED if status is still SWITCHING (race condition guard)
            const currentMessages = getMessages(conversationId);
            const currentMessage = currentMessages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
            if (currentMessage && (0, $igOtY.isStoreAssistant)(currentMessage) && currentMessage.answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).SWITCHING) {
                const successMessages = (0, $fS02I.updateStoreAssistantMessageAnswerNowStatus)(currentMessages, tmpMessageId, {
                    type: (0, $igOtY.AnswerNowStatusType).SWITCHING_REQUESTED
                });
                setMessages(conversationId, successMessages);
            }
            // Track success
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).ANSWER_NOW
            });
        } catch (error) {
            // Only set ERRORED if status is still SWITCHING (race condition guard)
            const currentMessages = getMessages(conversationId);
            const currentMessage = currentMessages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
            if (currentMessage && (0, $igOtY.isStoreAssistant)(currentMessage) && currentMessage.answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).SWITCHING) {
                const erroredMessages = (0, $fS02I.updateStoreAssistantMessageAnswerNowStatus)(currentMessages, tmpMessageId, {
                    type: (0, $igOtY.AnswerNowStatusType).ERRORED
                });
                setMessages(conversationId, erroredMessages);
                updateConversationTrace('Generating faster answer failed, continuing with current mode');
            }
            // Track failure
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).ANSWER_NOW,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
    });















var $dw75i = parcelRequire("dw75i");


var $bxkJA = parcelRequire("bxkJA");













function $10538755bc091414$export$5ab2d78f2e4dba11(message, context) {
    if (!(0, $bxkJA.isActionExecutedSuccessfully)(message)) return 'errored';
    return (0, $bxkJA.isActionResolutionCancelled)(context) ? 'cancelled' : 'finished';
}



var $hHBvs = parcelRequire("hHBvs");


var $k1kN6 = parcelRequire("k1kN6");

function $c0cd6f2cbb67842d$export$af362cbb514e3d36(message) {
    const raw = message.message_metadata?.rRule;
    if (raw === undefined || raw === null) return undefined;
    const s = typeof raw === 'string' ? raw.trim() : String(raw);
    return s.length > 0 ? s : undefined;
}


function $0359aee38edfc454$export$dd847ca3d24d641(message) {
    const raw = message.message_metadata?.ruleIdUuid;
    if (raw === undefined || raw === null) return undefined;
    const s = typeof raw === 'string' ? raw.trim() : String(raw);
    return s.length > 0 ? s : undefined;
}









var $cWP9O = parcelRequire("cWP9O");

const $a0b2f7abaad194ec$export$ad76867f670ba93f = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).updateActionData, ({ conversationId: conversationId, messageId: messageId, invocationId: invocationId, data: data })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cWP9O.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedMessages = [
            ...messages
        ];
        agentMessage.result.content.message.message.actions?.forEach((action)=>{
            if (action.invocationId === invocationId) action.data = {
                ...action.data,
                ...data
            };
        });
        updatedMessages[agentMessage.index] = agentMessage.result;
        setMessages(conversationId, updatedMessages);
    });











const $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).updateActionInvocationStatus, ({ conversationId: conversationId, messageId: messageId, invocationId: invocationId, status: status })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cWP9O.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedMessages = [
            ...messages
        ];
        updatedMessages[agentMessage.index] = {
            ...agentMessage.result,
            invokedActions: {
                ...agentMessage.result.invokedActions,
                [invocationId]: status
            }
        };
        setMessages(conversationId, updatedMessages);
    });


const $6ebccb4cae0d59cc$export$11688a59b4c1bf2b = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).resolveConversationAction, ({ conversationId: conversationId, messageId: messageId, payload: payload, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false, skipExperienceTracking: skipExperienceTracking = false })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, trackAIMAUEvent: trackAIMAUEvent, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, broadcastConfirmedActions: broadcastConfirmedActions, chatContextStoreActions: chatContextStoreActions })=>{
        let actionCallbackData;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const humanMessageId = (0, $k1kN6.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
        const featureArea = chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown';
        const attributes = {
            conversationId: conversationId,
            resolution: payload.context.resolution,
            actionKey: payload.context.key
        };
        if (!skipExperienceTracking) experienceTracker.start({
            name: (0, $irnO2.ExperienceName).RESOLVE_CONVERSATION_ACTION,
            id: conversationId,
            attributes: attributes
        });
        try {
            const { invocationId: invocationId } = payload.context;
            // Set actions loading state
            dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: invocationId,
                status: 'started'
            }));
            const response = await assistanceService.resolveConversationAction(conversationId, payload);
            const { message: message } = response;
            dispatch((0, $a0b2f7abaad194ec$export$ad76867f670ba93f)({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: invocationId,
                data: payload.context.data
            }));
            const ruleIdUuidFromExecution = payload.context.key === (0, $dw75i.SCHEDULED_CHAT_KEY) && (0, $bxkJA.isAssistantMessage)(message) ? (0, $0359aee38edfc454$export$dd847ca3d24d641)(message) : undefined;
            const rRuleFromExecution = payload.context.key === (0, $dw75i.SCHEDULED_CHAT_KEY) && (0, $bxkJA.isAssistantMessage)(message) ? (0, $c0cd6f2cbb67842d$export$af362cbb514e3d36)(message) : undefined;
            if (ruleIdUuidFromExecution || rRuleFromExecution) {
                const previousData = payload.context.data;
                const harvested = {
                    ...ruleIdUuidFromExecution ? {
                        ruleIdUuid: ruleIdUuidFromExecution
                    } : {},
                    ...rRuleFromExecution ? {
                        rRule: rRuleFromExecution
                    } : {}
                };
                dispatch((0, $a0b2f7abaad194ec$export$ad76867f670ba93f)({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    data: typeof previousData === 'object' && previousData !== null ? {
                        ...previousData,
                        ...harvested
                    } : harvested
                }));
            }
            const isMessageWithContent = !!message.content;
            // Display a new agent message from the response to reflect the change in chat history
            if ((0, $bxkJA.isAssistantMessage)(message) && (isMessageWithContent || (0, $bxkJA.isActionExecutedSuccessfully)(message))) {
                if (isMessageWithContent && !skipSuccessOptimisticAssistantResponse) dispatch((0, $byYzg.addAssistantMessage)({
                    agentNamedId: message.author?.named_id,
                    content: message.content,
                    conversationId: conversationId,
                    id: message.id
                }));
                actionCallbackData = actionContentProcessor?.(message) ?? undefined;
                dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    status: (0, $10538755bc091414$export$5ab2d78f2e4dba11)(message, payload.context)
                }));
                if ((0, $bxkJA.isActionExecutedSuccessfully)(message)) broadcastConfirmedActions?.(conversationId, [
                    payload.context
                ]);
                sendAnalyticsEvent({
                    eventType: 'ui',
                    action: 'success',
                    actionSubject: 'rovoChatMessageAction',
                    attributes: {
                        recipientAgentNamedId: payload.context.recipient_agent_named_id,
                        actionKey: payload.context.key,
                        resolutionType: payload.context.resolution.type,
                        featureArea: featureArea,
                        humanMessageId: humanMessageId,
                        messageId: messageId
                    }
                });
            } else {
                dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: payload.context.invocationId,
                    status: 'errored'
                }));
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'error',
                    actionSubject: 'rovoChatMessageAction',
                    attributes: {
                        recipientAgentNamedId: payload.context.recipient_agent_named_id,
                        actionKey: payload.context.key,
                        resolutionType: payload.context.resolution.type,
                        featureArea: featureArea,
                        humanMessageId: humanMessageId,
                        messageId: messageId
                    }
                });
            }
        } catch (error) {
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            if (!skipExperienceTracking) experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).RESOLVE_CONVERSATION_ACTION,
                error: normalizedError,
                attributes: attributes
            });
            trackAIMAUEvent({
                type: 'error',
                userGenerated: true,
                source: 'messageActionsResolver',
                subjectId: payload.context.resolution.type,
                singleInstrumentationID: messageId
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'error',
                actionSubject: 'rovoChatMessageAction',
                attributes: {
                    recipientAgentNamedId: payload.context.recipient_agent_named_id,
                    actionKey: payload.context.key,
                    resolutionType: payload.context.resolution.type,
                    featureArea: featureArea,
                    humanMessageId: humanMessageId,
                    messageId: messageId
                }
            });
            dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                status: 'errored'
            }));
            throw new (0, $hHBvs.MessageActionError)({
                message: `Message action error: ${normalizedError.message} for actionKey: ${payload.context.key}`,
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                actionKey: payload.context.key,
                cause: normalizedError
            });
        }
        if (!skipExperienceTracking) experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).RESOLVE_CONVERSATION_ACTION,
            attributes: attributes
        });
        return actionCallbackData;
    }, {
    actionErrorHandler: (context)=>{
        const { onError: onError, ...args } = context.args?.[0] ?? {};
        return onError ? onError({
            ...context,
            args: args
        }) : {
            proceedToDefaultHandling: true
        };
    }
});


const $8c8e302bbc2551a3$export$d5f51c6d14729a9d = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).bulkResolveConversationActions, ({ conversationId: conversationId, messageId: messageId, payloads: payloads, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false })=>async ({ dispatch: dispatch, getState: getState }, { experienceTracker: experienceTracker })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        // Execute all actions sequentially
        const actionCallbackResults = [];
        const successfulActions = [];
        let hasErrors = false;
        let successCount = 0;
        for (const payload of payloads){
            const result = await dispatch((0, $6ebccb4cae0d59cc$export$11688a59b4c1bf2b)({
                conversationId: conversationId,
                messageId: messageId,
                payload: payload,
                actionContentProcessor: actionContentProcessor,
                skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse,
                skipExperienceTracking: true
            }));
            actionCallbackResults.push(result);
            // Track success: result is defined means action succeeded
            if (result !== undefined) {
                successCount++;
                successfulActions.push(payload.context);
            } else if (!actionContentProcessor) // Action with no processor returns undefined on success
            successCount++;
            else // Action with processor returned undefined = failure
            hasErrors = true;
        }
        if (hasErrors) experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            error: new Error('Some bulk actions failed'),
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length,
                successCount: successCount,
                failureCount: payloads.length - successCount
            }
        });
        else experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        return actionCallbackResults;
    });























const $5505ac2578341bfa$export$e99fa5687f622cbf = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).bulkResolveConversationUIActions, ({ conversationId: conversationId, messageId: messageId, payloads: payloads, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, broadcastConfirmedActions: broadcastConfirmedActions, chatContextStoreActions: chatContextStoreActions })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        const humanMessageId = (0, $k1kN6.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
        const featureArea = chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown';
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        // Set all invocation statuses to 'started'
        for (const payload of payloads)dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
            conversationId: conversationId,
            messageId: messageId,
            invocationId: payload.context.invocationId,
            status: 'started'
        }));
        try {
            const responses = await assistanceService.bulkResolveConversationUIActions(conversationId, messageId, {
                items: payloads
            });
            const actionCallbackResults = [];
            const successfulActions = [];
            let hasErrors = false;
            let successCount = 0;
            // Process each response paired with its corresponding payload
            for(let i = 0; i < payloads.length; i++){
                const payload = payloads[i];
                const response = responses[i];
                const { invocationId: invocationId } = payload.context;
                if (!response) {
                    // No response for this item - mark as errored
                    dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: 'errored'
                    }));
                    hasErrors = true;
                    actionCallbackResults.push(undefined);
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'error',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                    continue;
                }
                const { message: message } = response;
                dispatch((0, $a0b2f7abaad194ec$export$ad76867f670ba93f)({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    data: payload.context.data
                }));
                const isMessageWithContent = !!message.content;
                if ((0, $bxkJA.isAssistantMessage)(message) && (isMessageWithContent || (0, $bxkJA.isActionExecutedSuccessfully)(message))) {
                    if (isMessageWithContent && !skipSuccessOptimisticAssistantResponse) dispatch((0, $byYzg.addAssistantMessage)({
                        agentNamedId: message.author?.named_id,
                        content: message.content,
                        conversationId: conversationId,
                        id: message.id
                    }));
                    const callbackData = actionContentProcessor?.(message) ?? undefined;
                    actionCallbackResults.push(callbackData);
                    dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: (0, $10538755bc091414$export$5ab2d78f2e4dba11)(message, payload.context)
                    }));
                    if ((0, $bxkJA.isActionExecutedSuccessfully)(message)) successfulActions.push(payload.context);
                    successCount++;
                    sendAnalyticsEvent({
                        eventType: 'ui',
                        action: 'success',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                } else {
                    dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: 'errored'
                    }));
                    hasErrors = true;
                    actionCallbackResults.push(undefined);
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'error',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                }
            }
            // Broadcast all successful confirmed actions at once
            if (successfulActions.length > 0) broadcastConfirmedActions?.(conversationId, successfulActions);
            if (hasErrors) experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                error: new Error('Some bulk actions failed'),
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length,
                    successCount: successCount,
                    failureCount: payloads.length - successCount
                }
            });
            else experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length
                }
            });
            return actionCallbackResults;
        } catch (error) {
            // If the entire bulk request fails, mark all invocations as errored
            for (const payload of payloads)dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                status: 'errored'
            }));
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                error: error instanceof Error ? error : new Error('Bulk resolve failed'),
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length,
                    successCount: 0,
                    failureCount: payloads.length
                }
            });
            throw error;
        }
    });



var $izhU8 = parcelRequire("izhU8");


var $6geN3 = parcelRequire("6geN3");

const $41db72a9378f94af$export$1562f8e01d4b447c = ({ conversationId: conversationId })=>({ dispatch: dispatch })=>{
        dispatch((0, $6geN3.setConversationData)({
            conversationId: conversationId,
            data: {
                targetTaskMessageId: null
            }
        }));
    };



var $djNSU = parcelRequire("djNSU");

/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing chat-store actions gate feature behavior from runtime flags. */ 
var $cXtTj = parcelRequire("cXtTj");








var $7td41 = parcelRequire("7td41");











var $lOO5l = parcelRequire("lOO5l");


var $gjWe2 = parcelRequire("gjWe2");


var $6MYo6 = parcelRequire("6MYo6");


var $c8Sl1 = parcelRequire("c8Sl1");

const $ac50e9856e9d0021$export$916d50c71d1097fc = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).createSeededConversation, (options)=>async ({ dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, setMessages: setMessages, getChatInitiator: getChatInitiator, onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage })=>{
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL,
            id: (0, $irnO2.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
        });
        const createConversationOptions = options.rovoSpaceId && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? {
            ...options,
            name: null
        } : options;
        const optimisticConversationName = options.name ?? (0, $7td41.generateConversationName)();
        const createdConversation = await assistanceService.createConversationChannel(createConversationOptions);
        const humanMessage = createdConversation.messages?.find((message)=>(0, $bxkJA.isHumanMessage)(message));
        const assistantMessage = createdConversation.messages?.find((message)=>(0, $bxkJA.isAssistantMessage)(message));
        const humanMessageId = humanMessage ? humanMessage.id : '';
        const assistantMessageId = assistantMessage ? assistantMessage.id : '';
        const conversationTags = createdConversation.tags ?? options.tags;
        // The header reads the displayed agent only from `conversation.agent.agent_id`,
        // so the chat-new/seeded flow must seed it from the known agent id (preferring a
        // backend-returned agent). Without this, a seeded conversation opened with a
        // specific agent shows default Rovo.
        const seededConversationAgent = (0, $6MYo6.resolveConversationSeedAgent)({
            backendAgent: createdConversation.agent,
            agentId: options.agentId,
            legacyAgent: createdConversation.agent
        });
        const seededConversationAgentFields = seededConversationAgent ? {
            agent: seededConversationAgent
        } : {};
        dispatch((0, $lOO5l.initializeConversationData)({
            conversationId: createdConversation.id,
            data: {
                id: createdConversation.id,
                name: createdConversation.name?.trim() || optimisticConversationName,
                timeCreated: createdConversation.time_created,
                status: (0, $igOtY.CHAT_STORE_STATUS).idle,
                traces: [],
                sourceId: options.sourceId ?? undefined,
                sourceAgentId: options.agentId,
                agentVersion: options.agentVersion,
                resultAttributionContext: options.resultAttributionContext,
                // Set explicitly (including `undefined`) rather than conditionally spread:
                // `initializeConversationData` shallow-merges over any existing slot, so
                // omitting the key would let a stale entry point from a previous launch
                // leak onto this conversation and mis-attribute it.
                chatEntryPoint: options.chatEntryPoint,
                // Same reasoning: a stale 3P cohort would otherwise be mirrored onto this
                // conversation's events, including AI-MAU events the experiment does not own.
                thirdPartyPrompt: undefined,
                messages: [],
                ...seededConversationAgentFields,
                ...conversationTags !== undefined ? {
                    tags: conversationTags
                } : {},
                ...options.skipNextFetch ? {
                    skipNextFetch: true
                } : {},
                // Scope the seeded conversation to a Rovo Space when applicable so the
                // nav and landing page can immediately render it under the correct space.
                ...options.rovoSpaceId ? (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? {
                    rovoSpaceId: options.rovoSpaceId
                } : {} : {}
            }
        }));
        const chatInitiator = getChatInitiator();
        // Build synthetic ChatMessage[] from the seeded dialogues and pass directly to
        // processConversationMessages, which handles all boundary content extraction
        // (lumina, chart, expand, sculptor) consistently with fetchConversation —
        // without an extra getChat network call.
        const syntheticMessages = options.dialogues.flatMap((dialogue)=>{
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'sent',
                actionSubject: 'message',
                attributes: {
                    messageId: humanMessageId,
                    interactionSource: 'movedOver',
                    followUpSource: options.followUpSource,
                    timestamp: new Date().toISOString(),
                    initiator: chatInitiator
                }
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'received',
                actionSubject: 'agentMessage',
                attributes: {
                    messageId: assistantMessageId,
                    humanMessageId: humanMessageId,
                    pluginsInvoked: [],
                    hasSources: false,
                    timestamp: new Date().toISOString(),
                    initiator: chatInitiator
                }
            });
            // When mimeType is 'text/adf', parse the ADF JSON string into a DocNode
            // so encodeAdf's isAdfContent check can pass it through natively.
            let agentContent = dialogue.agent_message.content;
            if (dialogue.agent_message.mimeType === 'text/adf') try {
                agentContent = JSON.parse(dialogue.agent_message.content);
            } catch  {
            // If parsing fails, fall back to raw string content
            }
            // Use raw ChatMessage types (not createStoreHuman/createStoreAssistant) so that
            // processConversationMessages can apply all boundary content extraction
            // (lumina, chart, expand, sculptor) before producing the final StoreChatItem[].
            const humanMessage = {
                role: 'HUMAN',
                id: (0, $icBz6.generateId)(),
                content: dialogue.human_message.content,
                time_created: new Date().toISOString(),
                user_ari: 'unknown',
                plugin_invocations: [],
                isFromSeededConversation: true
            };
            const assistantStreamResponse = {
                type: 'FINAL_RESPONSE',
                message: {
                    message: {
                        role: 'ASSISTANT',
                        id: (0, $icBz6.generateId)(),
                        conversation_channel_id: createdConversation.id,
                        content: agentContent,
                        time_created: new Date().toISOString(),
                        user_ari: 'unknown',
                        plugin_invocations: [],
                        author: {
                            named_id: 'ai_mate_agent',
                            name: 'unknown',
                            actor_type: 'AGENT',
                            ari: null,
                            id: 'unknown'
                        }
                    }
                }
            };
            return [
                humanMessage,
                assistantStreamResponse
            ];
        });
        const processedMessages = (0, $gjWe2.processConversationMessages)({
            latestMessages: syntheticMessages,
            conversationId: createdConversation.id,
            sendAnalyticsEvent: sendAnalyticsEvent
        });
        setMessages(createdConversation.id, processedMessages);
        if (options.mode && onNewConversationStartingWithSendMessage) // Initialize per-conversation mode before selection so the first render
        // cannot briefly fall back to default controls and context.
        onNewConversationStartingWithSendMessage(createdConversation.id, options.mode);
        if (options.selectConversation !== false) dispatch((0, $c8Sl1.setSelectedConversation)({
            conversationId: createdConversation.id
        }));
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
        });
        return createdConversation.id;
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
});






var $7eGGZ = parcelRequire("7eGGZ");

const $77b987c9b91a6f83$export$53f4d2378049701e = ({ conversationId: conversationId })=>({ getState: getState, setState: setState })=>{
        const { [conversationId]: _, ...otherConversations } = getState().conversations;
        setState({
            conversations: otherConversations
        });
    };


const $f27a0f1ad9682674$export$64c838ca85b298d9 = ({ conversationId: conversationId })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker })=>{
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).CLEAR_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        await getState().conversations[conversationId]?.storeAbortController?.abort();
        try {
            await assistanceService.deleteChat(conversationId);
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).CLEAR_CHAT,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
        // Remove the deleted conversation from the local store prior to refetching channels.
        // fetchConversationChannelsData preserves any local conversation whose ID is missing
        // from the API response (to keep optimistic / in-flight conversations alive). Without
        // this explicit removal, the just-deleted conversation would be treated as
        // "optimistic" and re-added to the store, causing it to reappear in the UI.
        dispatch((0, $77b987c9b91a6f83$export$53f4d2378049701e)({
            conversationId: conversationId
        }));
        await dispatch((0, $7eGGZ.fetchConversationChannelsData)({
            reconcileFirstPage: true
        }));
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).CLEAR_CHAT
        });
    };



var $iDrrr = parcelRequire("iDrrr");











var $jyZaR = parcelRequire("jyZaR");


var $kNR5a = parcelRequire("kNR5a");













const $287b89b445b82017$export$9c99f879b5701ba2 = (latestMessages)=>{
    if (!(0, $iDrrr.fg)('rovo_agent_versioning_enabled')) return undefined;
    for (const message of latestMessages)if ((0, $bxkJA.isStreamResponse)(message)) {
        const agentAuthor = message.message?.message?.agent_author;
        if (agentAuthor?.versionId || agentAuthor?.versionType) return {
            versionId: agentAuthor.versionId,
            versionType: agentAuthor.versionType,
            versionNumber: agentAuthor.versionNumber
        };
        return undefined;
    }
    return undefined;
};



var $dCJIZ = parcelRequire("dCJIZ");


var $4Y0no = parcelRequire("4Y0no");


var $dTEBe = parcelRequire("dTEBe");





var $idzM5 = parcelRequire("idzM5");





const $95aa319c6be31138$export$3af2463ee5fae65d = ({ conversationId: conversationId, dispatch: dispatch, sendAnalyticsEvent: sendAnalyticsEvent, showFlag: showFlag })=>{
    const rovoParams = (0, $dTEBe.getRovoParams)();
    const isConversationIdInRovoParams = !!rovoParams?.conversationId;
    sendAnalyticsEvent({
        eventType: 'track',
        action: 'forbidden',
        actionSubject: 'rovoChatFetchConversation',
        attributes: {
            isConversationIdInRovoParams: isConversationIdInRovoParams
        }
    });
    dispatch((0, $77b987c9b91a6f83$export$53f4d2378049701e)({
        conversationId: conversationId
    }));
    dispatch((0, $c8Sl1.setSelectedConversation)({
        conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
    }));
    if (isConversationIdInRovoParams) (0, $dTEBe.updatePageRovoParams)({
        conversationId: undefined
    });
    showFlag?.((0, $idzM5.StoreErrorFlagId).CONVERSATION_FORBIDDEN);
};



var $1IZrU = parcelRequire("1IZrU");


var $8A2GO = parcelRequire("8A2GO");

const $d658c35e0bf26137$export$a36711287d720d2b = (error)=>error instanceof (0, $8A2GO.ApiError) && error.errorAttributes?.statusCode === 403;









var $3Cuhs = parcelRequire("3Cuhs");

const $d2bec76a2cf3a32e$export$78825c8f4b3c575c = (previousMessages, networkMessages)=>{
    // Only the contiguous run at the very end is eligible. A FOLLOW_UP stranded mid-transcript is
    // already an invariant violation; do not propagate it.
    let firstTrailingIndex = previousMessages.length;
    while(firstTrailingIndex > 0 && (0, $igOtY.isStoreFollowUp)(previousMessages[firstTrailingIndex - 1]))firstTrailingIndex--;
    const trailingFollowUps = previousMessages.slice(firstTrailingIndex);
    if (trailingFollowUps.length === 0) return networkMessages;
    // The server transcript must still end on an assistant turn...
    const lastNetworkMessage = networkMessages.at(-1);
    if (!lastNetworkMessage || !(0, $igOtY.isStoreAssistant)(lastNetworkMessage)) return networkMessages;
    // ...and it must be the same assistant message these follow-ups were generated for.
    const anchorMessageId = trailingFollowUps[0].agentMessageId ?? (0, $3Cuhs.getLastAgentMessageID)(previousMessages);
    if (!anchorMessageId || anchorMessageId !== (0, $3Cuhs.getLastAgentMessageID)(networkMessages)) return networkMessages;
    return [
        ...networkMessages,
        ...trailingFollowUps
    ];
};



var $1wTWY = parcelRequire("1wTWY");





const $013a275e4d21eace$export$d22a0f57a9fae6c9 = ({ conversationId: conversationId, traces: traces, sourceAgentId: sourceAgentId })=>({ getState: getState, setState: setState })=>{
        const existing = getState().conversations[conversationId];
        if (!existing) return;
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...existing,
                    status: (0, $igOtY.CHAT_STORE_STATUS).loadingChat,
                    messages: [],
                    traces: traces,
                    sourceAgentId: sourceAgentId
                }
            }
        });
    };












var $6Hbrh = parcelRequire("6Hbrh");

const $692b8c108a723517$export$505adb47a68d73e6 = ({ conversationId: conversationId, messages: messages })=>({ getState: getState }, { setReasoningMode: setReasoningMode, unifiedTasksActions: unifiedTasksActions })=>{
        if (!(0, $iDrrr.fg)('rovo_chat_enable_tasks') || !unifiedTasksActions) return;
        const activeTask = unifiedTasksActions.getActiveTaskForConversation(conversationId);
        const lastAgentMsgId = (0, $3Cuhs.getLastAgentMessageID)(messages);
        if (activeTask && !(0, $igOtY.isTerminalTaskState)(activeTask.progressState) && lastAgentMsgId && activeTask.currentMessageId === lastAgentMsgId && (0, $6Hbrh.shouldRestoreMaxModeFromLastRequestedMode)(getState().conversations[conversationId]?.lastRequestedMode)) setReasoningMode(conversationId, 'task');
    };






var $6OcY6 = parcelRequire("6OcY6");

const $b25327492a2eafbb$export$5c7afebc13b5b6d7 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).fetchConversation, ({ conversationId: conversationIdParam, messageIdSelectedForPreview: messageIdSelectedForPreview, skipIfConversationAlreadyLoaded: skipIfConversationAlreadyLoaded = false })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, setMessages: setMessages, showFlag: showFlag, setReasoningMode: setReasoningMode, capabilities: capabilities })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const conversation = getState().conversations[conversationId];
        if (conversation?.status !== (0, $igOtY.CHAT_STORE_STATUS).idle || (0, $1IZrU.isEmptyConversation)(conversationId)) return;
        if (conversation.skipNextFetch) {
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: {
                    skipNextFetch: false
                }
            }));
            return;
        }
        if (skipIfConversationAlreadyLoaded && !messageIdSelectedForPreview && conversation.lastAgentMessageStatus !== 'FAILED' && (getMessages(conversationId).length > 0 || conversation.messages.length > 0)) return;
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).FETCH_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        if (conversation.storeAbortController) await conversation.storeAbortController?.abort();
        const messagesBeforeReload = getMessages(conversationId);
        dispatch((0, $013a275e4d21eace$export$d22a0f57a9fae6c9)({
            conversationId: conversationId,
            traces: messageIdSelectedForPreview && (0, $iDrrr.fg)('aifc_create_enabled') ? [] : [
                {
                    messageContent: 'Reloading chat',
                    status: 'loading'
                }
            ],
            sourceAgentId: (0, $4Y0no.getSourceAgentId)(getMessages(conversationId), (0, $dCJIZ.getConversation)(getState(), conversationId))
        }));
        let serviceChat;
        try {
            serviceChat = await assistanceService.getChat(conversationId, capabilities);
        } catch (e) {
            if ((0, $bxkJA.isChannelNotFoundError)(e)) {
                //We succeed this event because in sendMessage, we create a new channel if we receive a 404 response
                // Users will not see this error, so exclude it from Sentry
                //This is a fix due to an incompatible BE API change
                sendAnalyticsEvent({
                    eventType: 'operational',
                    action: 'notFound',
                    actionSubject: 'rovoChatFetchConversation'
                });
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_CHAT
                });
                dispatch((0, $djNSU.createConversationOptimistically)({
                    sourceAgentId: (0, $4Y0no.getSourceAgentId)(getMessages(conversationId), (0, $dCJIZ.getConversation)(getState(), conversationId))
                }));
                dispatch((0, $77b987c9b91a6f83$export$53f4d2378049701e)({
                    conversationId: conversationId
                }));
                return;
            }
            if ((0, $d658c35e0bf26137$export$a36711287d720d2b)(e)) {
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FETCH_CHAT,
                    error: e
                });
                (0, $95aa319c6be31138$export$3af2463ee5fae65d)({
                    conversationId: conversationId,
                    dispatch: dispatch,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    showFlag: showFlag
                });
                return;
            }
            throw e;
        }
        // There's a bug currently in the playwright pubsub test where when adding in a new
        // async function to sendMessageStream it causes the message to be dropped
        const status = getState().conversations[conversationId]?.status;
        if (status !== (0, $igOtY.CHAT_STORE_STATUS).loadingChat) return;
        const latestMessages = serviceChat;
        const messages = (0, $gjWe2.processConversationMessages)({
            latestMessages: latestMessages,
            conversationId: conversationId,
            sendAnalyticsEvent: sendAnalyticsEvent,
            shouldPreprocessDetails: (0, $6OcY6.shouldPreprocessDetailsForConversation)(getState(), conversationId)
        });
        const fetchedAgentVersion = (0, $287b89b445b82017$export$9c99f879b5701ba2)(latestMessages);
        dispatch((0, $6geN3.setConversationData)({
            conversationId: conversationId,
            data: {
                ...(0, $jyZaR.clearStatus)({
                    lastAgentMessageStatus: 'SUCCESSFUL'
                }),
                sourceAgentId: (0, $4Y0no.getSourceAgentId)(getMessages(conversationId), (0, $dCJIZ.getConversation)(getState(), conversationId)),
                ...fetchedAgentVersion ? {
                    agentVersion: fetchedAgentVersion
                } : {}
            }
        }));
        // Check if the last message has async_status 'IN_PROGRESS' and reconnect to the stream
        const lastMessage = latestMessages.at(-1);
        const isDeepResearch = lastMessage?.message?.message?.message_metadata?.deep_research;
        if ((0, $bxkJA.isInProgressStreamResponse)(lastMessage)) {
            const messageId = lastMessage.message.message.id;
            // Clear the "Message is in progress" content of the last agent message
            const updatedMessages = (0, $kNR5a.clearStoreAssistantMessageContent)(messages, messageId);
            // Do not preserve follow-ups while reconnecting: the resumed stream emits its own
            // FOLLOW_UP_QUERIES part, so re-attaching here could duplicate the chips.
            setMessages(conversationId, updatedMessages);
            dispatch((0, $1wTWY.reconnectToInProgressStream)({
                conversationId: conversationId,
                messageId: messageId,
                isDeepResearch: isDeepResearch
            }));
        } else setMessages(conversationId, (0, $iDrrr.fg)('rovo_chat_preserve_follow_ups_on_refetch') ? (0, $d2bec76a2cf3a32e$export$78825c8f4b3c575c)(messagesBeforeReload, messages) : messages);
        dispatch((0, $692b8c108a723517$export$505adb47a68d73e6)({
            conversationId: conversationId,
            messages: messages
        }));
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).FETCH_CHAT
        });
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).FETCH_CHAT
});






var $4o0zT = parcelRequire("4o0zT");


var $8fLSN = parcelRequire("8fLSN");

















const $7924d5732284eb54$export$6914a4ee7f8cbe2c = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).handleChatOpenPubsubAction, ({ conversationId: conversationId, agentId: agentId })=>async ({ getState: getState, dispatch: dispatch })=>{
        // IF convo id is the current chat
        // refetch the chat, do not create new one
        if (conversationId === getState().currentConversationId) {
            const shouldStoreChatNewAgentId = !!agentId && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
            if (shouldStoreChatNewAgentId) {
                const conversationAgentFromChatNew = (0, $8fLSN.createProvisionalConversationAgent)(agentId);
                const conversationAgentFieldsFromChatNew = conversationAgentFromChatNew ? {
                    agent: conversationAgentFromChatNew
                } : {};
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversationId,
                    data: {
                        sourceAgentId: agentId,
                        ...conversationAgentFieldsFromChatNew
                    }
                }));
            }
            dispatch((0, $b25327492a2eafbb$export$5c7afebc13b5b6d7)({
                conversationId: conversationId
            }));
            return;
        }
        // IF chat already exist in conversation
        // switch to that convo -> and it will trigger refetch when ChatHistory is rendered
        if (getState().conversations[conversationId]) {
            const shouldStoreChatNewAgentId = !!agentId && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
            if (shouldStoreChatNewAgentId) {
                const conversationAgentFromChatNew = (0, $8fLSN.createProvisionalConversationAgent)(agentId);
                const conversationAgentFieldsFromChatNew = conversationAgentFromChatNew ? {
                    agent: conversationAgentFromChatNew
                } : {};
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversationId,
                    data: {
                        sourceAgentId: agentId,
                        ...conversationAgentFieldsFromChatNew
                    }
                }));
            }
            dispatch((0, $c8Sl1.setSelectedConversation)({
                conversationId: conversationId
            }));
            return;
        }
        // IF chat does not exist yet
        // Create conversation optimistically, which will switch to that conversation
        // By switching conversation, it will render ChatHistory
        // ChatHistory will auto fetch the chat data
        // if not found during `sendMessage`, it will auto create one and retry when encountered `404`
        // Create conversation optimistically and store sourceAgentId
        const sourceAgentIdFromChatNew = agentId && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? agentId : undefined;
        dispatch((0, $djNSU.createConversationOptimistically)({
            id: conversationId,
            sourceAgentId: sourceAgentIdFromChatNew
        }));
    });



var $dHz2q = parcelRequire("dHz2q");








var $awqa1 = parcelRequire("awqa1");








var $9bLpG = parcelRequire("9bLpG");


var $f1ZpQ = parcelRequire("f1ZpQ");


var $hQJOO = parcelRequire("hQJOO");

const $dbfaf0ab050513fc$export$95850e3f7783749e = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).loadMoreConversationChannelsData, ()=>async ({ setState: setState, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, unifiedTasksActions: unifiedTasksActions })=>{
        if (!(0, $f1ZpQ.isConversationListPaginationEnabled)()) return;
        const { conversationPagination: conversationPagination } = getState();
        if (conversationPagination.isLoadingMore || !conversationPagination.hasMore || !conversationPagination.nextCursor) return;
        setState({
            conversationPagination: {
                ...conversationPagination,
                isLoadingMore: true,
                loadMoreError: null
            }
        });
        experienceTracker.start({
            id: (0, $irnO2.ExperienceName).LOAD_MORE_CONVERSATION_CHANNELS,
            name: (0, $irnO2.ExperienceName).LOAD_MORE_CONVERSATION_CHANNELS
        });
        try {
            const conversationChannelsResponse = await assistanceService.getConversationChannels({
                limit: (0, $awqa1.CONVERSATION_LIST_LOAD_MORE_PAGE_SIZE),
                cursor: conversationPagination.nextCursor
            });
            const channelsFromAPI = conversationChannelsResponse.items;
            const { conversations: conversations } = getState();
            const processedChannels = (0, $9bLpG.getProcessedConversationChannels)({
                channelsFromAPI: channelsFromAPI,
                conversations: conversations
            });
            (0, $hQJOO.mergeConversationChannelTasks)(channelsFromAPI, unifiedTasksActions);
            setState({
                conversations: {
                    ...conversations,
                    ...processedChannels
                },
                conversationPagination: {
                    ...getState().conversationPagination,
                    nextCursor: conversationChannelsResponse.cursor,
                    hasMore: conversationChannelsResponse.hasNext,
                    isLoadingMore: false,
                    loadMoreError: null
                }
            });
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).LOAD_MORE_CONVERSATION_CHANNELS
            });
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).LOAD_MORE_CONVERSATION_CHANNELS,
                error: error instanceof Error ? error : new Error(String(error))
            });
            setState({
                conversationPagination: {
                    ...getState().conversationPagination,
                    isLoadingMore: false,
                    loadMoreError: (0, $eBgZa.createStoreError)(error, undefined, (0, $igOtY.StoreActionLoggableName).loadMoreConversationChannelsData)
                }
            });
        }
    });


















































const $b0af940bfa1b3612$export$b798bd7f9b4e76a0 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).prefetchConversationMessages, ({ conversationId: conversationId, skipNextFetch: skipNextFetch = false, onStart: onStart, onSuccess: onSuccess, onError: onError })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, setMessages: setMessages, showFlag: showFlag, capabilities: capabilities })=>{
        const conversation = getState().conversations[conversationId];
        // Bail without emitting if the conversation isn't selectable, is
        // in flight, or is already loaded
        if ((0, $1IZrU.isEmptyConversation)(conversationId) || !conversation || conversation.status !== (0, $igOtY.CHAT_STORE_STATUS).idle || conversation.messages.length > 0) return;
        onStart?.();
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).PREFETCH_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        const messagesBeforeReload = getMessages(conversationId);
        dispatch((0, $013a275e4d21eace$export$d22a0f57a9fae6c9)({
            conversationId: conversationId,
            traces: [],
            sourceAgentId: conversation.sourceAgentId ?? ''
        }));
        try {
            const serviceChat = await assistanceService.getChat(conversationId, capabilities);
            const status = getState().conversations[conversationId]?.status;
            if (status !== (0, $igOtY.CHAT_STORE_STATUS).loadingChat) // Something else (e.g. a user-initiated send or an explicit
            // `fetchConversation`) raced ahead; surrender the response.
            return;
            const messages = (0, $gjWe2.processConversationMessages)({
                latestMessages: serviceChat,
                conversationId: conversationId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                shouldPreprocessDetails: (0, $6OcY6.shouldPreprocessDetailsForConversation)(getState(), conversationId)
            });
            const fetchedAgentVersion = (0, $287b89b445b82017$export$9c99f879b5701ba2)(serviceChat);
            // Mirror fetchConversation's reconnect check.
            const lastMessage = serviceChat.at(-1);
            const isDeepResearch = lastMessage?.message?.message?.message_metadata?.deep_research;
            const shouldReconnect = (0, $bxkJA.isInProgressStreamResponse)(lastMessage);
            if (shouldReconnect) {
                const messageId = lastMessage.message.message.id;
                const updatedMessages = (0, $kNR5a.clearStoreAssistantMessageContent)(messages, messageId);
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversationId,
                    data: {
                        ...(0, $jyZaR.clearStatus)({
                            lastAgentMessageStatus: 'SUCCESSFUL'
                        }),
                        sourceAgentId: (0, $4Y0no.getSourceAgentId)(messages, (0, $dCJIZ.getConversation)(getState(), conversationId)),
                        ...fetchedAgentVersion ? {
                            agentVersion: fetchedAgentVersion
                        } : {}
                    }
                }));
                // Do not preserve follow-ups while reconnecting: the resumed stream emits its own
                // FOLLOW_UP_QUERIES part, so re-attaching here could duplicate the chips.
                setMessages(conversationId, updatedMessages);
                dispatch((0, $692b8c108a723517$export$505adb47a68d73e6)({
                    conversationId: conversationId,
                    messages: messages
                }));
                dispatch((0, $1wTWY.reconnectToInProgressStream)({
                    conversationId: conversationId,
                    messageId: messageId,
                    isDeepResearch: isDeepResearch
                }));
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).PREFETCH_CHAT
                });
                onSuccess?.();
                return;
            }
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: {
                    ...(0, $jyZaR.clearStatus)({
                        lastAgentMessageStatus: 'SUCCESSFUL'
                    }),
                    sourceAgentId: (0, $4Y0no.getSourceAgentId)(messages, (0, $dCJIZ.getConversation)(getState(), conversationId)),
                    ...fetchedAgentVersion ? {
                        agentVersion: fetchedAgentVersion
                    } : {},
                    ...skipNextFetch ? {
                        skipNextFetch: true
                    } : {}
                }
            }));
            setMessages(conversationId, (0, $iDrrr.fg)('rovo_chat_preserve_follow_ups_on_refetch') ? (0, $d2bec76a2cf3a32e$export$78825c8f4b3c575c)(messagesBeforeReload, messages) : messages);
            dispatch((0, $692b8c108a723517$export$505adb47a68d73e6)({
                conversationId: conversationId,
                messages: messages
            }));
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).PREFETCH_CHAT
            });
            onSuccess?.();
        } catch (error) {
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).PREFETCH_CHAT,
                error: normalizedError
            });
            if ((0, $d658c35e0bf26137$export$a36711287d720d2b)(error)) {
                (0, $95aa319c6be31138$export$3af2463ee5fae65d)({
                    conversationId: conversationId,
                    dispatch: dispatch,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    showFlag: showFlag
                });
                onError?.(normalizedError);
                return;
            }
            // Roll back warm loading state; do not set `skipNextFetch` on failure.
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: (0, $jyZaR.clearStatus)({})
            }));
            onError?.(normalizedError);
        }
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).PREFETCH_CHAT,
    actionErrorHandler: ()=>{
        // Errors are surfaced via `onError`; keep the silent warm path silent.
        return;
    }
});












const $6279909d4ebd325a$export$f9a3c275d8ffdac0 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).removeMessage, ({ messageId: messageId, conversationId: conversationIdParam })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const filteredMessages = messages.filter((message)=>{
            if ((0, $igOtY.isStoreError)(message) || (0, $igOtY.isStoreFollowUp)(message)) return message.id !== messageId;
            else if ((0, $igOtY.isStoreHuman)(message)) return message.content.id !== String(messageId);
            else return true;
        });
        setMessages(conversationId, filteredMessages);
    });




var $eQl6Z = parcelRequire("eQl6Z");







const $fef4f32b3ef3f920$export$1a0f0d45b9f5743b = ({ conversationId: conversationId, skipNextFetch: skipNextFetch })=>({ getState: getState, setState: setState })=>{
        const time = new Date().toISOString();
        // Register in conversations map
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId],
                    id: conversationId,
                    name: (0, $7td41.generateConversationName)(),
                    status: (0, $igOtY.CHAT_STORE_STATUS).idle,
                    timeCreated: time,
                    lastMessageTimestamp: time,
                    traces: [],
                    messages: [],
                    lastMessageType: [],
                    ...skipNextFetch ? {
                        skipNextFetch: true
                    } : {}
                }
            },
            // Also set as active conversation
            currentConversationId: conversationId
        });
    };






var $ieeJu = parcelRequire("ieeJu");











var $coqKO = parcelRequire("coqKO");


var $cv4dJ = parcelRequire("cv4dJ");


var $ayOmn = parcelRequire("ayOmn");











var $6WeLa = parcelRequire("6WeLa");


var $kncFb = parcelRequire("kncFb");


var $hwHCO = parcelRequire("hwHCO");


var $bbXwY = parcelRequire("bbXwY");


var $j5JhI = parcelRequire("j5JhI");


var $fANCm = parcelRequire("fANCm");


var $8GeCh = parcelRequire("8GeCh");


var $fA89f = parcelRequire("fA89f");








var $1Nzi3 = parcelRequire("1Nzi3");

const $0b1976f4f4504448$var$A2UI_ACTION_MIME_TYPE = 'text/json';
const $0b1976f4f4504448$var$toStructuredActionContent = (action, hostMessageId)=>({
        data_parts_mime_type: 'application/json+a2ui',
        structured: true,
        data_parts: [
            {
                userAction: {
                    actionName: action.eventName,
                    context: {
                        ...action.context ?? action.dataModel ?? {},
                        assistantMessageId: hostMessageId
                    }
                }
            }
        ]
    });
const $0b1976f4f4504448$export$3c932f8ca2641253 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).sendA2UIAction, ({ action: action, hostMessageId: hostMessageId, conversationId: conversationIdParam, agentId: agentId, webSearchEnabled: webSearchEnabled, useCurrentBrowsingContext: useCurrentBrowsingContext, appFilters: appFilters, messageSources: messageSources })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages, trackAIMAUEvent: trackAIMAUEvent, sendAnalyticsEvent: sendAnalyticsEvent })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const mentionAgentsEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
        const tmpAssistantMessageId = (0, $j5JhI.generateTmpMessageId)(conversationId);
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $1Nzi3.createStoreAbortController)();
        let hasInsertedTurnAssistantMessage = false;
        let agentMessageId;
        let requestId;
        let humanMessageId;
        let streamMeta;
        let initiatedTimestamp;
        let hasLoggedInitiated = false;
        let hasReceivedFinalResponse = false;
        const updateCurrentConversation = (data)=>{
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: data
            }));
        };
        const instrumentationId = ()=>agentMessageId ?? tmpAssistantMessageId;
        const trackInitiated = ()=>{
            if (hasLoggedInitiated) return;
            hasLoggedInitiated = true;
            trackAIMAUEvent({
                type: 'initiated',
                subjectId: messageSources?.interactionSource,
                proactive: false,
                userGenerated: true,
                timestamp: initiatedTimestamp,
                singleInstrumentationID: instrumentationId(),
                webSearchEnabled: webSearchEnabled,
                attributes: {
                    sendMessageReason: 'A2UI_ACTION',
                    actionName: action.eventName
                }
            });
        };
        const trackViewed = ()=>{
            trackAIMAUEvent({
                type: 'viewed',
                proactive: false,
                userGenerated: true,
                source: messageSources?.interactionSource,
                subjectId: messageSources?.followUpSource,
                messageId: agentMessageId,
                singleInstrumentationID: instrumentationId(),
                timestamp: new Date().toISOString(),
                webSearchEnabled: webSearchEnabled,
                citedProductList: streamMeta?.citedProductList ?? {},
                sourceProducts: streamMeta?.sourceProducts ?? {},
                connectorInfo: streamMeta?.connectorInfo,
                responseSources: streamMeta?.responseSources,
                usesJsm: streamMeta?.usesJsm,
                messageActions: streamMeta?.messageActions,
                messageDynamicUIData: streamMeta?.messageDynamicUIData,
                invokedFrom: streamMeta?.invokedFrom,
                pluginsInvoked: streamMeta?.pluginsInvoked,
                skillsInvoked: streamMeta?.skillsInvoked,
                executedStratusSkill: streamMeta?.executedStratusSkill,
                attributes: {
                    sendMessageReason: 'A2UI_ACTION',
                    actionName: action.eventName,
                    /** Whether the response updated the surface only, without opening a message. */ surfaceOnlyResponse: !hasInsertedTurnAssistantMessage,
                    ...streamMeta?.interactionModeExecuted ? {
                        interactionModeExecuted: streamMeta.interactionModeExecuted
                    } : {}
                }
            });
        };
        const trackTerminal = (type)=>{
            trackInitiated();
            trackAIMAUEvent({
                type: type,
                userGenerated: true,
                messageId: requestId,
                subjectId: messageSources?.interactionSource,
                singleInstrumentationID: instrumentationId(),
                timestamp: new Date().toISOString(),
                webSearchEnabled: webSearchEnabled,
                attributes: {
                    sendMessageReason: 'A2UI_ACTION',
                    actionName: action.eventName
                }
            });
        };
        /**
   * Inserts this turn's assistant message, once, on the first reply text to arrive.
   */ const insertTurnAssistantMessage = ()=>{
            if (hasInsertedTurnAssistantMessage) return;
            hasInsertedTurnAssistantMessage = true;
            dispatch((0, $byYzg.addAssistantMessage)({
                id: tmpAssistantMessageId,
                content: '',
                conversationId: conversationId,
                ...mentionAgentsEnabled ? {
                    agentAuthorId: agentId
                } : {
                    agentNamedId: agentId
                }
            }));
        };
        // Rewrites `<details>`/`<summary>` into the Rovo-native expand boundary — third-party
        // agents lean on it heavily. Built on the first chunk rather than here so the
        // conversation's agent metadata is settled by the time it decides.
        let markdownMultiTagProcessor = null;
        const getMarkdownMultiTagProcessor = ()=>{
            if (!markdownMultiTagProcessor) markdownMultiTagProcessor = (0, $6WeLa.createStreamMarkdownMultiTagProcessor)({
                shouldPreprocessDetails: (0, $6OcY6.shouldPreprocessDetailsForConversation)(getState(), conversationId)
            });
            return markdownMultiTagProcessor;
        };
        try {
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION,
                id: conversationId,
                attributes: {
                    conversationId: conversationId,
                    interactionSource: messageSources?.interactionSource
                }
            });
            updateCurrentConversation({
                storeAbortController: storeAbortController,
                status: (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse,
                lastAgentMessageStatus: 'IN_PROGRESS'
            });
            initiatedTimestamp = new Date().toISOString();
            const { generator: generator, responseData: responseData } = await assistanceService.sendMessageStream({
                conversationId: conversationId,
                // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing A2UI baseline: structured action content is adapted to the send pipeline's prompt type.
                message: $0b1976f4f4504448$var$toStructuredActionContent(action, hostMessageId),
                mimeType: $0b1976f4f4504448$var$A2UI_ACTION_MIME_TYPE,
                agentId: agentId,
                controller: abortController,
                storeMessage: false,
                citationsEnabled: true,
                webSearchEnabled: webSearchEnabled,
                useCurrentBrowsingContext: useCurrentBrowsingContext,
                appFilters: appFilters,
                optInSSEStream: true
            });
            for await (const streamObj of generator){
                const streamMessage = (0, $bxkJA.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
                /**
       * Surface ops render into the message that hosts the surface, never into this
       * turn's own message — that is what keeps the action attributed to its round.
       */ if ((0, $bxkJA.isStreamAgenticUi)(streamObj)) {
                    const agenticUiMessage = {
                        ...streamObj.data,
                        type: 'AGENTIC_UI'
                    };
                    setMessages(conversationId, (0, $coqKO.addAgenticUiMessage)(getMessages(conversationId), hostMessageId, agenticUiMessage));
                    continue;
                }
                if ((0, $bxkJA.isConversationChannelDataMessage)(streamMessage)) {
                    agentMessageId = streamMessage.assistant_message_id;
                    trackInitiated();
                }
                if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) {
                    insertTurnAssistantMessage();
                    const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = getMarkdownMultiTagProcessor()(streamMessage);
                    const hasMarkdownData = Object.keys(markdownData).length > 0;
                    setMessages(conversationId, hasMarkdownData ? (0, $ayOmn.addAnswerPartWithMarkdownDataMap)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        markdownData: markdownData
                    }) : (0, $cv4dJ.addAnswerPart)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage
                    }));
                }
                if ((0, $bxkJA.isStreamResponse)(streamMessage)) {
                    hasReceivedFinalResponse = true;
                    requestId = streamMessage.metadata?.request_id ?? requestId;
                    streamMeta = (0, $bbXwY.extractStreamMeta)(streamMessage, undefined, (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true));
                    humanMessageId = streamMeta.humanMessageId;
                    const finalResponseMessageId = streamMessage.message?.message?.id?.toString();
                    // Once `initiated` has been paired against an id, `viewed` has to carry the
                    // same one, so the final response only supplies it when nothing has fired yet.
                    if (!hasLoggedInitiated) agentMessageId = finalResponseMessageId ?? agentMessageId;
                    const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = (0, $8GeCh.processStreamResponseMarkdown)({
                        streamMessage: streamMessage,
                        messageId: finalResponseMessageId,
                        conversationId: conversationId,
                        sendAnalyticsEvent: sendAnalyticsEvent,
                        shouldPreprocessDetails: (0, $6OcY6.shouldPreprocessDetailsForConversation)(getState(), conversationId)
                    });
                    /**
         * A reply whose text only arrives here still needs a message; one that
         * carried nothing but surface ops must not get one.
         */ if (processedStreamMessage.message?.message?.content) insertTurnAssistantMessage();
                    if (hasInsertedTurnAssistantMessage) setMessages(conversationId, (0, $fA89f.replaceAnswerData)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        content: processedStreamMessage,
                        humanMessageId: humanMessageId,
                        markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined,
                        traceId: responseData?.traceId
                    }));
                }
                if ((0, $bxkJA.isStreamError)(streamMessage)) {
                    const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                    // AUP violations are a valid outcome, so the experience still succeeds.
                    if ((0, $bxkJA.isStreamAUPError)(streamMessage)) experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION
                    });
                    throw new (0, $hwHCO.StreamErrorException)(message?.content || 'Unknown', {
                        detail: {
                            message: message,
                            metadata: metadata,
                            millisOffset: millisOffset,
                            type: type
                        },
                        traceId: responseData?.traceId
                    });
                }
            }
        } catch (error) {
            if (error instanceof Error && error.name === 'AbortError') {
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION,
                    reason: 'Aborted'
                });
                confirmAbort();
                trackTerminal('dismissed');
                return;
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION,
                error: error instanceof Error ? error : new Error(String(error))
            });
            trackTerminal('error');
            throw error;
        } finally{
            updateCurrentConversation((0, $jyZaR.clearStatus)({}));
            setMessages(conversationId, (0, $fANCm.markStreamingMessagesAsComplete)(getMessages(conversationId)));
        }
        // A programmatic abort ends the generator cleanly rather than throwing.
        if (abortController.signal.aborted) {
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION,
                reason: 'Aborted'
            });
            confirmAbort();
            trackTerminal('dismissed');
            return;
        }
        if (!hasReceivedFinalResponse) {
            const error = new (0, $kncFb.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                traceId: undefined
            });
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION,
                error: error
            });
            trackTerminal('error');
            throw error;
        }
        trackInitiated();
        trackViewed();
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION
        });
    });



var $ffjMi = parcelRequire("ffjMi");











var $6yl1r = parcelRequire("6yl1r");








var $hlvTd = parcelRequire("hlvTd");


var $hRx4b = parcelRequire("hRx4b");


var $fCunh = parcelRequire("fCunh");








var $9vNm5 = parcelRequire("9vNm5");





var $b6N3q = parcelRequire("b6N3q");


var $cYKsm = parcelRequire("cYKsm");


var $9BBUU = parcelRequire("9BBUU");


var $4tJut = parcelRequire("4tJut");


var $eMs38 = parcelRequire("eMs38");


var $biBci = parcelRequire("biBci");

const $a9bd253ecf93f89c$var$MCP_TOOL_SOURCE = 'MCP_TOOL';
const $a9bd253ecf93f89c$export$af4bad69aa3a06c5 = ({ toolDefinitionSource: toolDefinitionSource, key: key })=>toolDefinitionSource === $a9bd253ecf93f89c$var$MCP_TOOL_SOURCE ? undefined : key;


const $7129583fe1d7779b$var$UNKNOWN_TOOL_ID = 'UNKNOWN_TOOL_ID';
const $7129583fe1d7779b$var$buildBaseToolAttribute = ({ toolId: toolId, toolKey: toolKey, toolDefinitionSource: toolDefinitionSource })=>({
        toolId: toolId ?? $7129583fe1d7779b$var$UNKNOWN_TOOL_ID,
        toolKey: (0, $a9bd253ecf93f89c$export$af4bad69aa3a06c5)({
            toolDefinitionSource: toolDefinitionSource,
            key: toolKey
        }),
        toolDefinitionSource: toolDefinitionSource ?? null
    });
const $7129583fe1d7779b$export$376e622a1b976e6e = (confirmedTools)=>confirmedTools.tools.map((tool)=>({
            ...$7129583fe1d7779b$var$buildBaseToolAttribute({
                toolId: tool.tool_id,
                toolKey: tool.key,
                toolDefinitionSource: tool.tool_source
            }),
            resolutionType: tool.resolution?.type ?? 'UNKNOWN_RESOLUTION_TYPE'
        }));







var $bkEBw = parcelRequire("bkEBw");


var $fMCXf = parcelRequire("fMCXf");

const $ab7f520530423da1$export$4287833726c64095 = ({ chat: chat, answerId: answerId, answerPart: answerPart, markdownData: markdownData, useIndex: useIndex })=>{
    const { key: key, content: content, loading: loading } = markdownData;
    const loadingKey = `${key}-loading`;
    return (0, $fMCXf.updateStoreAssistant)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $bkEBw.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                },
                markdownData: {
                    ...storeAssistant.markdownData,
                    [key]: (storeAssistant.markdownData?.[key] || '') + content,
                    [loadingKey]: loading ? 'true' : 'false'
                }
            }),
        updateType: 'Add Answer Part With Markdown Data',
        useIndex: useIndex
    });
};



var $6CHtN = parcelRequire("6CHtN");





var $3Bvlb = parcelRequire("3Bvlb");








var $hMXhO = parcelRequire("hMXhO");


var $lXC3X = parcelRequire("lXC3X");





var $l5TuZ = parcelRequire("l5TuZ");


var $f3OgL = parcelRequire("f3OgL");


var $7MYAM = parcelRequire("7MYAM");

const $86bc580e83e9fcdd$export$f0a9473b2d3b8f30 = (options)=>{
    // We pass a lazy supplier so the processor reads current feature flag values on each call.
    // createMarkdownProcessor keeps state (currentLoadingKeys / previousKeys) across calls,
    // while components are re-evaluated every invocation to reflect live flag values.
    const processor = (0, $f3OgL.createMarkdownProcessor)((0, $7MYAM.getStreamableComponents));
    // Per-message preprocessor that rewrites HTML `<details><summary>` blocks
    // into the Rovo-native `▞…▚` boundary before they reach the component
    // extractor. Maintains its own cross-chunk buffer so partial tags spanning
    // chunk boundaries resolve correctly. The caller decides whether to enable
    // it (typically gated on 3P agents via
    // `shouldPreprocessDetailsForConversation`).
    const detailsPreprocessor = options?.shouldPreprocessDetails ? (0, $l5TuZ.createDetailsPreprocessor)() : null;
    return (streamMessage)=>{
        const messageContent = streamMessage.message.content;
        const text = typeof messageContent === 'string' ? messageContent : '';
        const preprocessedText = detailsPreprocessor ? detailsPreprocessor.process(text) : text;
        const { processedText: processedText, markdownData: markdownData, processedComponentType: processedComponentType } = processor(preprocessedText);
        streamMessage.message.content = processedText;
        return {
            processedStreamMessage: streamMessage,
            markdownData: markdownData,
            processedComponentType: processedComponentType
        };
    };
};



var $dxl4c = parcelRequire("dxl4c");








var $4BHwn = parcelRequire("4BHwn");





var $bFeyZ = parcelRequire("bFeyZ");


var $i9o8a = parcelRequire("i9o8a");





var $kZEW9 = parcelRequire("kZEW9");


var $aKQ2h = parcelRequire("aKQ2h");


var $lS0Jk = parcelRequire("lS0Jk");





var $2WWTW = parcelRequire("2WWTW");





var $cC5sC = parcelRequire("cC5sC");

const $1176649d0a5ed8f2$export$32a54ad404e10819 = async (chatContextStoreActions, isFirstPrompt, addCurrentPageAsContextUserPreference, contentContextValue, productKey, sendAnalyticsEvent, isEmptyStagingArea)=>{
    const context = await (0, $cC5sC.populateSendMessageContext)(chatContextStoreActions, isEmptyStagingArea || isFirstPrompt, undefined, undefined, addCurrentPageAsContextUserPreference, contentContextValue, isEmptyStagingArea ? {
        experience: 'cwr'
    } : undefined, productKey, sendAnalyticsEvent);
    return {
        editorContext: context.editorContext,
        whiteboardContext: context.whiteboardContext,
        slidesContext: context.slidesContext,
        databaseContext: context.databaseContext,
        dashboardEditorContext: context.dashboardEditorContext,
        browserContext: context.browserContext,
        additionalContext: context.additionalContext,
        jiraWorkflowContext: context.jiraWorkflowContext,
        dashboardContext: context.dashboardContext,
        useCurrentBrowsingContext: context.useCurrentBrowsingContext
    };
};



var $3qJlQ = parcelRequire("3qJlQ");


var $cWQeI = parcelRequire("cWQeI");


var $55rUT = parcelRequire("55rUT");






















const $818a9d135eec7bf6$export$7ebb0e028855aeb0 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).updateActionInvocationStatus, ({ conversationId: conversationId, messageId: messageId, tools: tools, status: status })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cWP9O.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedInvokedActions = {
            ...agentMessage.result.invokedActions
        };
        for (const tool of tools){
            const resolvedStatus = status === 'fromResolution' ? tool.resolution?.type === 'cancelled' ? 'cancelled' : 'finished' : status;
            updatedInvokedActions[tool.invocation_id] = resolvedStatus;
        }
        const updatedMessages = [
            ...messages
        ];
        updatedMessages[agentMessage.index] = {
            ...agentMessage.result,
            invokedActions: updatedInvokedActions
        };
        setMessages(conversationId, updatedMessages);
    });



var $NbBdO = parcelRequire("NbBdO");

const $3fbe59e6722fdc18$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS = 120000;
const $3fbe59e6722fdc18$var$NO_FINAL_RESPONSE_ERROR_MESSAGE = 'The response took too long and timed out';
const $3fbe59e6722fdc18$export$a520ca869831c96e = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).sendMessageConfirmedTools, ({ conversationId: conversationIdParam, agentId: agentId, confirmed_tools: confirmed_tools, messageSources: messageSources, storeUserMessages: storeUserMessages = false, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, includeAIFeatureContext: includeAIFeatureContext, agentVersion: agentVersion, actionedAnalyticsAttributes: actionedAnalyticsAttributes, resolutionType: resolutionType, productKey: productKey, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, browserContextSanitizer: browserContextSanitizer, hasStagedContent: hasStagedContent })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, chatContextStoreActions: chatContextStoreActions, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages, trackAIMAUEvent: trackAIMAUEvent, trackAgentEvent: trackAgentEvent, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, clearMessageResearch: clearMessageResearch, updateResearchMessageId: updateResearchMessageId, markIncompleteResearchesErrored: markIncompleteResearchesErrored, sendAnalyticsEvent: sendAnalyticsEvent, getIsChatMounted: getIsChatMounted, capabilities: capabilities, unifiedTasksActions: unifiedTasksActions, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, onTempMessageIdReplaced: onTempMessageIdReplaced, broadcastConfirmedActions: broadcastConfirmedActions })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const mentionAgentsEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
        const resolvedAgentVersion = agentVersion ?? getState().conversations[conversationId]?.agentVersion;
        const confirmedToolsExperienceName = taskModeEnabled ? (0, $irnO2.ExperienceName).SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE : (0, $irnO2.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE;
        // Collection of callbacks for experience and performance tracking
        const expAndPerfTrackers = {
            start: ()=>{
                experienceTracker.start({
                    name: confirmedToolsExperienceName,
                    id: conversationId,
                    attributes: {
                        conversationId: conversationId,
                        interactionSource: messageSources?.interactionSource
                    }
                });
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.start();
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.start();
            },
            firstAnswerPartReceived: ()=>{
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            },
            succeed: ()=>{
                experienceTracker.succeed({
                    name: confirmedToolsExperienceName
                });
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
            },
            aupError: ()=>{
                experienceTracker.succeed({
                    name: confirmedToolsExperienceName
                });
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            },
            agentDeactivated: ({ error: error })=>{
                experienceTracker.fail({
                    name: confirmedToolsExperienceName,
                    error: error
                });
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.cancel();
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.cancel();
            },
            abort: ()=>{
                experienceTracker.abort({
                    name: confirmedToolsExperienceName,
                    reason: 'Aborted'
                });
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.cancel();
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.cancel();
            },
            fail: ({ error: error })=>{
                experienceTracker.fail({
                    name: confirmedToolsExperienceName,
                    error: error
                });
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            }
        };
        const requestedModeAttributes = (0, $lS0Jk.interactionModeRequestedAttributes)((0, $i9o8a.getInteractionModeRequested)({
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            taskModeEnabled: taskModeEnabled
        }));
        const trackingAttributes = {
            isRovoCustomAgent: (0, $biBci.isRovoCustomAgent)(agentId),
            sendMessageReason: 'TOOLS_CONFIRMATION',
            aiFeatureName: messageSources?.aiFeatureName
        };
        // Source executed mode from the originating assistant message (the one this
        // confirmed-tools action is being executed against). `confirmed_tools.message_id`
        // is the assistant message id whose tool calls the user just confirmed.
        const originatingAssistantMessage = getMessages(conversationId).find((item)=>(0, $igOtY.isStoreAssistant)(item) && item.content?.message?.message?.id === confirmed_tools.message_id);
        const interactionModeExecutedFromOriginatingAssistantMessage = (0, $bFeyZ.getInteractionModeExecutedFromStoreAssistant)(originatingAssistantMessage);
        const isCancelled = resolutionType === 'cancelled';
        const tools = (0, $7129583fe1d7779b$export$376e622a1b976e6e)(confirmed_tools);
        const mciKrIdentifiers = tools.map((tool)=>tool.toolKey).filter((value)=>Boolean(value));
        const agentAnalyticsAttributes = {
            touchPoint: 'chatSendMessageConfirmedTools',
            tools: tools
        };
        // Collection of callbacks for analytics tracking
        const analyticsTrackers = {
            /**
     * There are 2 AIMAU events here, because in resumption we're doing 2 things
     * 1. We're confirming the previous tools result
     * 2. And the confirmation triggers a LLM chat streaming
     */ initiated: ({ timestamp: timestamp })=>{
                const actionKey = (0, $a9bd253ecf93f89c$export$af4bad69aa3a06c5)({
                    toolDefinitionSource: confirmed_tools.tools[0]?.tool_source,
                    key: confirmed_tools.tools[0]?.key
                });
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'actioned',
                    actionResult: isCancelled ? 'toolsExecutionCancelled' : 'toolsExecutionConfirmed',
                    proactive: false,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    attributes: {
                        ...(0, $6yl1r.isPlanWorkItemTechChangesEnabled)() || (0, $iDrrr.fg)('jira-ai-agents-improvements') ? actionedAnalyticsAttributes : {},
                        ...interactionModeExecutedFromOriginatingAssistantMessage ? {
                            interactionModeExecuted: interactionModeExecutedFromOriginatingAssistantMessage
                        } : {},
                        ...actionKey ? {
                            actionKey: actionKey
                        } : {},
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        }
                    },
                    // override the messageId to the confirmed_tools.message_id and not what's in trackingAttributes,
                    // because action is on the original message not this message
                    messageId: confirmed_tools.message_id
                });
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: timestamp,
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $biBci.isRovoCustomAgent)(agentId)) trackAgentEvent({
                    action: isCancelled ? 'toolsExecutionCancelled' : 'toolsExecutionConfirmed',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId,
                        ...((0, $6yl1r.isPlanWorkItemTechChangesEnabled)() || (0, $iDrrr.fg)('jira-ai-agents-improvements')) && actionedAnalyticsAttributes
                    }
                });
            },
            aborted: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'dismissed',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    messageId: trackingAttributes.messageId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $biBci.isRovoCustomAgent)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionStreamStopped',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId
                    }
                });
            },
            viewed: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'viewed',
                    proactive: false,
                    userGenerated: true,
                    source: messageSources?.interactionSource,
                    messageId: trackingAttributes.messageId,
                    subjectId: messageSources?.followUpSource,
                    citedProductList: {},
                    sourceProducts: {},
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    attributes: {
                        ...trackingAttributes.interactionModeExecuted ? {
                            interactionModeExecuted: trackingAttributes.interactionModeExecuted
                        } : {},
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        },
                        ...(0, $iDrrr.fg)('add_mci_kr_attributes_to_rovo_chat_analytics') ? (0, $hRx4b.mciKrAttributesFromSkillsAndPlugins)([], mciKrIdentifiers, trackingAttributes.agentExternalConfigReference) : {}
                    }
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $biBci.isRovoCustomAgent)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionResultViewed',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId,
                        scenarioId: trackingAttributes.scenarioId
                    }
                });
            },
            error: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'error',
                    proactive: false,
                    userGenerated: true,
                    messageId: trackingAttributes.requestId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $biBci.isRovoCustomAgent)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionResultError',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId
                    }
                });
            }
        };
        const updateCurrentConversation = (data)=>{
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: data
            }));
        };
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $1Nzi3.createStoreAbortController)();
        let hasReceivedFinalResponse = false;
        let generator;
        let responseData;
        let hasLoggedInitiatedEvent = false;
        // Hoisted so it is accessible in the catch block for clearMessageResearch
        let tmpAssistantMessageId = (0, $j5JhI.generateTmpMessageId)(conversationId);
        // Reconnect state — populated once we receive the conversation channel data message
        let agentMessageId;
        let isReconnectSupported = false;
        const handleAbort = ()=>{
            expAndPerfTrackers.abort();
            confirmAbort();
            clearMessageResearch({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.aborted();
            // Call the cancel API to stop backend processing
            if (trackingAttributes.messageId && trackingAttributes.messageId !== tmpAssistantMessageId) assistanceService.cancelMessageStream({
                conversationId: conversationId,
                messageId: trackingAttributes.messageId
            }).catch(()=>{
                // Log but don't throw - the abort is already happening
                (0, $hlvTd.addSentryBreadcrumb)({
                    message: 'Failed to cancel message stream after abort in sendMessageConfirmedTools',
                    data: {
                        conversationId: conversationId,
                        messageId: trackingAttributes.messageId
                    }
                });
            });
        };
        try {
            expAndPerfTrackers.start();
            // change the conversation status
            updateCurrentConversation({
                storeAbortController: storeAbortController,
                status: (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse,
                lastAgentMessageStatus: 'IN_PROGRESS'
            });
            if (unifiedTasksActions && (0, $iDrrr.fg)('rovo_chat_enable_tasks')) {
                // Optimistic update goes directly to the tasks store. Explicitly clears
                // current_step / result_summary / error_message so the row resets to a
                // fresh "now running" state.
                const activeTask = unifiedTasksActions.getActiveTaskForConversation(conversationId);
                if (activeTask?.taskId) unifiedTasksActions.setTaskProgressState({
                    taskId: activeTask.taskId,
                    progressState: 'Running',
                    title: activeTask.title ?? '',
                    updatedAt: new Date().toISOString(),
                    currentStep: null,
                    resultSummary: null,
                    errorMessage: null
                });
            }
            // Only add assistant message
            dispatch((0, $byYzg.addAssistantMessage)({
                id: tmpAssistantMessageId,
                content: '',
                conversationId: conversationId,
                ...mentionAgentsEnabled ? {
                    agentAuthorId: agentId
                } : {
                    agentNamedId: agentId
                }
            }));
            dispatch((0, $izhU8.clearFollowUpMessages)({
                conversationId: conversationId
            }));
            trackingAttributes.messageId = tmpAssistantMessageId;
            trackingAttributes.instrumentationId = tmpAssistantMessageId;
            // Assumed the insert is successful and inserts at the last position
            const answerIndex = getMessages(conversationId).length - 1;
            // Behind the `rovo-include-full-context-on-confirmed-tools` experiment, build the
            // same full request context that `sendMessage` sends (creationContext +
            // page/whiteboard/slides/database/dashboard/browser/jira context) so the backend
            // routes tool confirmation through the same code paths as a regular send.
            // Derived to mirror a regular follow-up send: existing conversation
            // (`isFirstPrompt: false`) with content context resolved from the staging-area
            // signal. Failures degrade gracefully to the slim context below.
            let fullConfirmedToolsContext;
            if ((0, $cXtTj.default).getExperimentValue('rovo-include-full-context-on-confirmed-tools', 'isEnabled', false)) try {
                const isFirstPrompt = (0, $1IZrU.isEmptyConversation)(conversationId);
                const contentContextValue = chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global';
                const isEmptyStagingArea = contentContextValue === 'staging-area' && hasStagedContent === false && (0, $ieeJu.expValEquals)('cc-disambiguation-in-cwr', 'isEnabled', true);
                fullConfirmedToolsContext = await (0, $1176649d0a5ed8f2$export$32a54ad404e10819)(chatContextStoreActions, isFirstPrompt, addCurrentPageAsContextUserPreference, contentContextValue, productKey, sendAnalyticsEvent, isEmptyStagingArea);
            } catch (error) {
                (0, $hlvTd.addSentryBreadcrumb)({
                    message: 'Failed to populate full context for sendMessageConfirmedTools; falling back to slim context',
                    data: {
                        conversationId: conversationId
                    }
                });
            }
            // Call the BE endpoint
            trackingAttributes.initiatedTimestamp = new Date().toISOString();
            const response = await assistanceService.sendMessageConfirmedTools({
                conversationId: conversationId,
                agentId: agentId,
                confirmed_tools: confirmed_tools,
                controller: abortController,
                optInSSEStream: true,
                storeMessage: storeUserMessages,
                webSearchEnabled: webSearchEnabled,
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                fastModeEnabled: fastModeEnabled,
                ...taskModeEnabled ? {
                    planModeEnabled: taskModeEnabled
                } : {},
                ...includeAIFeatureContext && {
                    aiFeatureContext: chatContextStoreActions.getAIFeatureContext()
                },
                ...fullConfirmedToolsContext ? {
                    editorContext: fullConfirmedToolsContext.editorContext,
                    whiteboardContext: fullConfirmedToolsContext.whiteboardContext,
                    slidesContext: fullConfirmedToolsContext.slidesContext,
                    databaseContext: fullConfirmedToolsContext.databaseContext,
                    dashboardEditorContext: fullConfirmedToolsContext.dashboardEditorContext,
                    browserContext: fullConfirmedToolsContext.browserContext,
                    additionalContext: fullConfirmedToolsContext.additionalContext,
                    // aiFeatureContext is intentionally NOT spread here — it stays owned by the
                    // `includeAIFeatureContext` guard above so callers that opt out are respected.
                    jiraWorkflowContext: fullConfirmedToolsContext.jiraWorkflowContext,
                    dashboardContext: fullConfirmedToolsContext.dashboardContext,
                    useCurrentBrowsingContext: fullConfirmedToolsContext.useCurrentBrowsingContext,
                    browserContextSanitizer: browserContextSanitizer
                } : {},
                ...resolvedAgentVersion ? {
                    agentVersion: resolvedAgentVersion
                } : {},
                optInToDeepResearchV2: true,
                optInThinkDeeperMessages: true,
                optInAnsNow: true,
                optInNewToolTraces: true,
                optInNewTeamworkTraceIcons: (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26'),
                capabilities: capabilities
            });
            generator = response.generator;
            responseData = response.responseData;
            // Update action invocation statuses based on the confirmed_tools payload
            if ((0, $iDrrr.fg)('rovo_chat_enable_tasks')) dispatch((0, $818a9d135eec7bf6$export$7ebb0e028855aeb0)({
                conversationId: conversationId,
                messageId: confirmed_tools.message_id,
                tools: confirmed_tools.tools,
                status: 'fromResolution'
            }));
            /**
     * --------
     * Stream processing START
     * --------
     */ updateCurrentConversation({
                status: (0, $igOtY.CHAT_STORE_STATUS).typingResponse
            });
            // Research store state shared across stream messages
            const researchState = {
                clientRoundCounter: 0,
                hasAccumulatedAnswerContent: false
            };
            const processStreamMarkdown = (0, $86bc580e83e9fcdd$export$f0a9473b2d3b8f30)();
            const isFullContextOnConfirmedToolsEnabled = (0, $cXtTj.default).getExperimentValue('rovo-include-full-context-on-confirmed-tools', 'isEnabled', false);
            // Tracks whether an AIFC action has started streaming. Mutated in place by
            // processAifcActionStreamMessage.
            const streamActionInfo = {
                isAction: false
            };
            const actionClassificationInvocationIds = new Set();
            const actionCompleteInvocationIds = new Set();
            let isBackendCreationRequest = false;
            const streamToIterate = (0, $lXC3X.createChatReconnectableStream)({
                generator: generator,
                conversationId: conversationId,
                abortController: abortController,
                assistanceService: assistanceService,
                sendAnalyticsEvent: sendAnalyticsEvent,
                experienceTracker: experienceTracker,
                getMessageId: ()=>agentMessageId,
                canReconnect: ()=>!!(agentMessageId && isReconnectSupported),
                updateCurrentConversation: updateCurrentConversation,
                getIsChatMounted: getIsChatMounted,
                analyticsAttributes: {
                    isDeepResearch: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    fastModeEnabled: fastModeEnabled
                },
                onBeforeFirstReconnect: ()=>{
                    if (agentMessageId) {
                        const chat = getMessages(conversationId);
                        const alreadySwapped = (0, $4BHwn.findStoreMessageIndex)(chat, agentMessageId) >= 0;
                        if (!alreadySwapped) {
                            // Swap the tmp message ID → real agent message ID in the
                            // message store so addAnswerPart/replaceAnswerData ID
                            // validation doesn't throw on the replayed stream chunks.
                            setMessages(conversationId, (0, $NbBdO.updateStoreAssistantMessageId)({
                                chat: chat,
                                oldId: tmpAssistantMessageId,
                                newId: agentMessageId
                            }));
                            updateResearchMessageId({
                                messageId: tmpAssistantMessageId,
                                newMessageId: agentMessageId
                            });
                        }
                        // Reassign so subsequent processResearchStreamMessage calls
                        // and addAnswerPart/replaceAnswerData use the real agent
                        // message ID as the key.
                        tmpAssistantMessageId = agentMessageId;
                    }
                }
            });
            const isStreamTimeoutEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'isEnabled', false);
            const streamIdleTimeoutMs = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'timeoutMs', $3fbe59e6722fdc18$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS);
            const streamWithTimeout = isStreamTimeoutEnabled ? (0, $cYKsm.withAsyncGeneratorTimeout)(streamToIterate, {
                timeoutMs: streamIdleTimeoutMs,
                // Don't time out while offline – the reconnect layer waits for the
                // client to come back online, so timing out would lose the reconnect.
                isPaused: ()=>typeof navigator !== 'undefined' && !navigator.onLine,
                onTimeout: ()=>{
                    if (hasReceivedFinalResponse || abortController.signal.aborted) return undefined;
                    abortController.abort();
                    const timeoutError = new (0, $b6N3q.RovoChatStreamTimeoutError)($3fbe59e6722fdc18$var$NO_FINAL_RESPONSE_ERROR_MESSAGE, {
                        requestId: trackingAttributes.requestId,
                        traceId: responseData?.traceId
                    });
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'timedOut',
                        actionSubject: 'rovoChatStream',
                        attributes: {
                            conversationChannelId: conversationId,
                            experienceName: confirmedToolsExperienceName,
                            requestId: trackingAttributes.requestId,
                            timeoutMs: streamIdleTimeoutMs,
                            timeoutType: 'idle',
                            traceId: responseData?.traceId
                        }
                    });
                    return timeoutError;
                }
            }) : streamToIterate;
            for await (const streamObj of streamWithTimeout){
                const streamMessage = (0, $bxkJA.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
                (0, $cWQeI.processInteractionConclusion)({
                    streamObj: streamObj,
                    streamMessage: streamMessage,
                    conversationId: conversationId,
                    answerIndex: answerIndex,
                    requestId: trackingAttributes.requestId,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    sendAnalyticsEvent: sendAnalyticsEvent
                });
                /**
       * Research store processing — handles think-deeper traces, implicit round
       * detection, and research plan updates for all message types.
       */ (0, $55rUT.processResearchStreamMessage)({
                    streamMessage: streamMessage,
                    tmpAssistantMessageId: tmpAssistantMessageId,
                    conversationId: conversationId,
                    deepResearchEnabled: deepResearchEnabled,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    processStreamResearch: processStreamResearch,
                    addImplicitResearchPlan: addImplicitResearchPlan,
                    resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                    researchState: researchState
                });
                /**
       * Conversation channel data processing (usually the first stream part)
       */ if ((0, $bxkJA.isConversationChannelDataMessage)(streamMessage)) {
                    agentMessageId = streamMessage.assistant_message_id;
                    trackingAttributes.instrumentationId = agentMessageId;
                    trackingAttributes.messageId = agentMessageId;
                    analyticsTrackers.initiated({
                        timestamp: trackingAttributes.initiatedTimestamp
                    });
                    hasLoggedInitiatedEvent = true;
                    // Update the research store with the real message ID once we have it
                    updateResearchMessageId({
                        messageId: tmpAssistantMessageId,
                        newMessageId: agentMessageId
                    });
                }
                /**
       * Reconnect support detection
       */ if ((0, $bxkJA.isStreamReconnectSupportPart)(streamMessage)) isReconnectSupported = true;
                /**
       * Trace processing
       */ if ((0, $bxkJA.isStreamTrace)(streamMessage)) {
                    if (!trackingAttributes.requestId) trackingAttributes.requestId = streamMessage.metadata?.request_id;
                    updateCurrentConversation({
                        traces: (0, $dxl4c.dedupeTraceMessagesWithLatest)([
                            ...getState().conversations[conversationId]?.traces ?? [],
                            (0, $kZEW9.getTraceFromStreamMessage)(streamMessage)
                        ])
                    });
                }
                /**
       * AIFC action processing — streams generated content into the page via the
       * editor bridge and emits AIFC experiences. Shared with the send-message
       * flow. Gated behind the confirmed-tools full-context experiment.
       */ if (isFullContextOnConfirmedToolsEnabled) {
                    const aifcActionResult = (0, $3qJlQ.processAifcActionStreamMessage)({
                        streamMessage: streamMessage,
                        conversationId: conversationId,
                        tmpAssistantMessageId: tmpAssistantMessageId,
                        traceId: responseData?.traceId,
                        productKey: productKey,
                        deepResearchEnabled: deepResearchEnabled,
                        storeUserMessages: storeUserMessages,
                        streamActionInfo: streamActionInfo,
                        trackingAttributes: trackingAttributes,
                        experienceTracker: experienceTracker,
                        chatContextStoreActions: chatContextStoreActions,
                        getMessages: getMessages,
                        setMessages: setMessages,
                        sendAnalyticsEvent: sendAnalyticsEvent,
                        getIsChatMounted: getIsChatMounted,
                        processMessageStreamAction: processMessageStreamAction,
                        processMessageStreamComplete: processMessageStreamComplete,
                        processMessageStreamActionClassification: processMessageStreamActionClassification,
                        promptStreamHook: undefined,
                        openChat: undefined,
                        messageSources: messageSources,
                        creationContextParams: undefined,
                        agentId: agentId,
                        agentName: undefined,
                        agentIdentityAccountId: null,
                        stopInteractionMetricsTimeToFirstActionPart: ()=>{}
                    });
                    if (aifcActionResult.actionClassificationInvocationId) actionClassificationInvocationIds.add(aifcActionResult.actionClassificationInvocationId);
                    if (aifcActionResult.actionCompleteInvocationId) actionCompleteInvocationIds.add(aifcActionResult.actionCompleteInvocationId);
                    isBackendCreationRequest || (isBackendCreationRequest = aifcActionResult.isBackendCreationAction);
                }
                /**
       * Answer part processing
       */ if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) {
                    expAndPerfTrackers.firstAnswerPartReceived();
                    (0, $hMXhO.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                    let processedStreamMessage = streamMessage;
                    const processedStreamResult = processStreamMarkdown(processedStreamMessage);
                    processedStreamMessage = processedStreamResult.processedStreamMessage;
                    if (processedStreamResult.markdownData) setMessages(conversationId, (0, $ab7f520530423da1$export$4287833726c64095)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        markdownData: processedStreamResult.markdownData,
                        useIndex: answerIndex
                    }));
                    else setMessages(conversationId, (0, $cv4dJ.addAnswerPart)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        useIndex: answerIndex
                    }));
                }
                if ((0, $bxkJA.isStreamEntityAnnotations)(streamMessage) && ((0, $iDrrr.fg)('rovo_chat_inferred_project_hover_cards') || (0, $iDrrr.fg)('rovo_chat_people_entity_hover_cards'))) setMessages(conversationId, (0, $6CHtN.appendEntityAnnotationBatch)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    entityAnnotationBatch: (0, $bxkJA.normalizeEntityAnnotationsMessage)(streamMessage.message)
                }));
                /**
       * Final response processing
       */ if ((0, $bxkJA.isStreamResponse)(streamMessage)) {
                    // A confirmed-tools turn either resolves (→ done) or ends returning an action
                    // awaiting the user's confirmation (→ needs-input).
                    (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, (0, $2WWTW.isFinalResponseAwaitingConfirmation)(streamMessage.message?.message?.actions) ? 'needs-input' : 'done');
                    trackingAttributes.interactionModeExecuted = streamMessage.message?.message?.message_metadata?.interaction_mode_executed;
                    hasReceivedFinalResponse = true;
                    const shouldUseBackendCreationExperienceLifecycle = isBackendCreationRequest && (0, $4o0zT.isExperimentEnabled)('cwr-be-based-multi-creation-v0');
                    const hasActionClassificationOrCompletion = actionClassificationInvocationIds.size > 0 || actionCompleteInvocationIds.size > 0;
                    if (shouldUseBackendCreationExperienceLifecycle && hasActionClassificationOrCompletion) // Backend creation responses do not require opening a preview to reach a terminal state.
                    (0, $9BBUU.completeAifcActionExperience)(experienceTracker, (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED, actionClassificationInvocationIds, actionCompleteInvocationIds, isBackendCreationRequest);
                    // Always succeed AIFC_MESSAGE from FINAL_RESPONSE for backend multi-create events, or when
                    // the parity experiment is enabled to streamline frontend and backend handling.
                    // Ensure that isFullContextOnConfirmedToolsEnabled is enabled,
                    // given this is otherwise only succeeded in processAifcActionStreamMessage
                    if (isFullContextOnConfirmedToolsEnabled && hasActionClassificationOrCompletion && (shouldUseBackendCreationExperienceLifecycle || (0, $4o0zT.isExperimentEnabled)('cwr-fe-be-experience-analytics-streamline'))) (0, $9BBUU.completeAifcActionExperience)(experienceTracker, (0, $irnO2.ExperienceName).AIFC_MESSAGE, actionClassificationInvocationIds, actionCompleteInvocationIds, isBackendCreationRequest);
                    const humanMessageId = streamMessage?.message?.human_message?.id.toString();
                    const finalAgentMessageId = streamMessage?.message?.message?.id.toString();
                    (0, $hMXhO.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                    const { processedStreamMessage: processedFinalMessage, markdownData: markdownData } = (0, $8GeCh.processStreamResponseMarkdown)({
                        streamMessage: streamMessage,
                        messageId: finalAgentMessageId,
                        conversationId: conversationId,
                        sendAnalyticsEvent: sendAnalyticsEvent
                    });
                    setMessages(conversationId, (0, $fA89f.replaceAnswerData)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        content: processedFinalMessage,
                        useIndex: answerIndex,
                        humanMessageId: humanMessageId,
                        markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined,
                        onMessageIdChanged: isFullContextOnConfirmedToolsEnabled ? onTempMessageIdReplaced : undefined
                    }));
                    // Update the research store key so rounds persist after the message ID changes
                    if (finalAgentMessageId && finalAgentMessageId !== tmpAssistantMessageId) updateResearchMessageId({
                        messageId: tmpAssistantMessageId,
                        newMessageId: finalAgentMessageId
                    });
                    trackingAttributes.humanMessageId = humanMessageId;
                    trackingAttributes.scenarioId = streamMessage.message.message?.scenario?.id;
                    trackingAttributes.agentExternalConfigReference = (0, $iDrrr.fg)('add_mci_kr_attributes_to_rovo_chat_analytics') ? streamMessage.message.message?.author?.external_config_reference : undefined;
                    if (!hasLoggedInitiatedEvent) {
                        trackingAttributes.messageId = finalAgentMessageId;
                        trackingAttributes.instrumentationId = finalAgentMessageId;
                    }
                }
                /**
       * Follow up processing
       */ if ((0, $bxkJA.isFollowUpMessage)(streamMessage)) {
                    const messages = getMessages(conversationId);
                    (0, $hMXhO.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                    setMessages(conversationId, [
                        ...messages,
                        {
                            type: 'FOLLOW_UP',
                            content: streamMessage,
                            id: (0, $eMs38.randomIntFromInterval)(0, 1000000),
                            agentMessageId: (0, $3Cuhs.getLastAgentMessageID)(messages),
                            humanMessageId: trackingAttributes.humanMessageId
                        }
                    ]);
                }
                /**
       * Task status processing
       */ if ((0, $bxkJA.isStreamTaskStatus)(streamMessage)) {
                    if (unifiedTasksActions && (0, $iDrrr.fg)('rovo_chat_enable_tasks')) (0, $aKQ2h.handleStreamTaskStatus)({
                        conversationId: conversationId,
                        taskMessage: streamMessage.message,
                        messageId: trackingAttributes.messageId,
                        target: (0, $3Bvlb.buildUnifiedStreamTaskTarget)(unifiedTasksActions)
                    });
                }
                /**
       * Todo snapshot processing
       */ if ((0, $bxkJA.isStreamTodoSnapshot)(streamMessage)) {
                    if (unifiedTasksActions && (0, $iDrrr.fg)('rovo_chat_enable_tasks')) unifiedTasksActions.setTaskTodoSnapshot({
                        conversationId: conversationId,
                        todoSnapshot: {
                            todos: streamMessage.message.todos
                        }
                    });
                }
                /**
       * Error processing
       */ if ((0, $bxkJA.isStreamError)(streamMessage)) {
                    const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                    // AUP violations are still considered successful
                    if ((0, $bxkJA.isStreamAUPError)(streamMessage)) expAndPerfTrackers.aupError();
                    throw new (0, $hwHCO.StreamErrorException)(message?.content || 'Unknown', {
                        detail: {
                            message: message,
                            metadata: metadata,
                            millisOffset: millisOffset,
                            type: type
                        },
                        traceId: response.responseData?.traceId
                    });
                }
            }
        } catch (error) {
            const isAgentDeactivated = error instanceof (0, $8A2GO.ApiError) && error.errorAttributes.errorCode?.includes((0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED);
            const isNoAgentPermission = error instanceof (0, $8A2GO.ApiError) && error.errorAttributes.errorCode?.includes((0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN) && (0, $iDrrr.fg)('convo-ai-enable-agents-use-permission');
            if (isAgentDeactivated || isNoAgentPermission) {
                expAndPerfTrackers.agentDeactivated({
                    error: error
                });
                updateCurrentConversation({
                    status: (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError,
                    traces: [],
                    errorCode: (0, $iDrrr.fg)('convo-ai-enable-agents-use-permission') ? error.errorAttributes.errorCode : undefined
                });
                // Mark all confirmed tool actions as errored
                if ((0, $iDrrr.fg)('rovo_chat_enable_tasks')) dispatch((0, $818a9d135eec7bf6$export$7ebb0e028855aeb0)({
                    conversationId: conversationId,
                    messageId: confirmed_tools.message_id,
                    tools: confirmed_tools.tools,
                    status: 'errored'
                }));
                !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                    timestamp: trackingAttributes.initiatedTimestamp
                });
                analyticsTrackers.error();
                return;
            }
            if (error instanceof Error && error.name === 'AbortError') {
                handleAbort();
                return;
            }
            // Mark all confirmed tool actions as errored
            if ((0, $iDrrr.fg)('rovo_chat_enable_tasks')) dispatch((0, $818a9d135eec7bf6$export$7ebb0e028855aeb0)({
                conversationId: conversationId,
                messageId: confirmed_tools.message_id,
                tools: confirmed_tools.tools,
                status: 'errored'
            }));
            expAndPerfTrackers.fail({
                error: error instanceof Error ? error : new Error(String(error))
            });
            markIncompleteResearchesErrored({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.error();
            throw error;
        } finally{
            updateCurrentConversation((0, $jyZaR.clearStatus)({}));
            setMessages(conversationId, (0, $fANCm.markStreamingMessagesAsComplete)(getMessages(conversationId)));
            // Safety net for the agent-run bridge: clear a run left in flight by an abort or
            // dropped request so its node does not stay active. No-op once settled.
            (0, $9vNm5.endActiveAgentRun)(conversationId);
        }
        /**
   * --------
   * Stream processing END
   * --------
   */ // Handle programmatic abort — the generator may exit cleanly without throwing AbortError
        // when the abort controller is signalled. Check the signal to detect this case.
        if (abortController.signal.aborted) {
            handleAbort();
            return;
        }
        // if stream finishes without FINAL_RESPONSE, BE is hanging
        if (!hasReceivedFinalResponse) {
            const error = new (0, $kncFb.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                traceId: responseData?.traceId
            });
            experienceTracker.fail({
                name: confirmedToolsExperienceName,
                error: error
            });
            markIncompleteResearchesErrored({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.error();
            throw error;
        }
        !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
            timestamp: trackingAttributes.initiatedTimestamp
        });
        analyticsTrackers.viewed();
        expAndPerfTrackers.succeed();
        // Re-emit the confirmed-action broadcast that the legacy resolveConversationAction
        // path used to send, so content-bridge subscribers (e.g. Jira Plans) still refresh
        // after tools are confirmed via the resumption flow. See use-rovo-confirmed-actions.
        if ((0, $iDrrr.fg)('rovo_chat_broadcast_confirmed_tools_actions')) {
            const confirmedActionContexts = confirmed_tools.tools.filter((tool)=>tool.resolution?.type !== 'cancelled').map((tool)=>({
                    key: tool.key,
                    invocationId: tool.invocation_id,
                    messageId: confirmed_tools.message_id,
                    data: tool.data.arguments,
                    resolution: {
                        type: 'confirm'
                    }
                }));
            if (confirmedActionContexts.length > 0) broadcastConfirmedActions?.(confirmed_tools.message_id, confirmedActionContexts);
        }
        if ((0, $iDrrr.fg)('rovo_chat_chat_history_refresh')) //If user is viewing a different conversation or not viewing ConversationAssitant, optimistically set conversation to unread
        {
            if (getState().currentConversationId !== conversationId) dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: {
                    readStatus: false
                }
            }));
        }
    });





const $3db73ca32f481fa4$export$7c39c589455db491 = (isConversationListMounted)=>({ setState: setState, getState: getState })=>{
        setState({
            conversationPagination: {
                ...getState().conversationPagination,
                isConversationListMounted: isConversationListMounted
            }
        });
    };




















const $51c7bf2c092024a3$export$d9d592371c2a2f98 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).stopTask, ({ conversationId: conversationId })=>({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, unifiedTasksActions: unifiedTasksActions })=>{
        if (!(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
        const conversation = getState().conversations[conversationId];
        if (conversation?.storeAbortController) {
            dispatch((0, $8OiFS.abortRequests)({
                conversationId: conversationId,
                taskModeEnabled: true
            }));
            return;
        }
        if (!unifiedTasksActions) return;
        const task = unifiedTasksActions.getActiveTaskForConversation(conversationId);
        if (!task?.taskId || (0, $igOtY.isTerminalTaskState)(task.progressState)) return;
        unifiedTasksActions.setTaskProgressState({
            taskId: task.taskId,
            progressState: 'Cancelled',
            updatedAt: new Date().toISOString()
        });
        assistanceService.cancelTask(task.taskId).catch((err)=>{
            (0, $hlvTd.logException)({
                name: 'rovoCancelTaskFromStopTask',
                exception: err,
                tags: {
                    taskId: task.taskId
                }
            });
        });
    });









var $jcJSP = parcelRequire("jcJSP");

const $fc4eff2d3971ee33$export$a1b6e610fd39072e = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).truncateFromLastHumanMessage, ({ conversationId: conversationIdParam })=>({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        const messages = getMessages(conversationId);
        const lastHumanIdx = (0, $jcJSP.findLastIndex)(messages, (0, $igOtY.isStoreHuman));
        if (lastHumanIdx < 0) return [];
        const tail = messages.slice(lastHumanIdx);
        setMessages(conversationId, messages.slice(0, lastHumanIdx));
        return tail;
    });











const $030fab6f8e6adbfc$export$f020542e7ec82374 = ({ conversationId: conversationId, data: data })=>async ({ dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker })=>{
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        let updatedConversation;
        try {
            updatedConversation = await assistanceService?.updateConversationChannel(conversationId, data);
        } catch (error) {
            const pinLimitErrorData = data.isPinned ? (0, $8A2GO.getPinnedConversationLimitErrorData)(error) : undefined;
            if (pinLimitErrorData !== undefined) experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
                reason: 'pinned_conversation_limit_reached',
                attributes: {
                    conversationId: conversationId,
                    ...pinLimitErrorData
                }
            });
            else experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
        const nextData = {
            ...data
        };
        if (updatedConversation) {
            if (updatedConversation.name !== undefined) nextData.name = updatedConversation.name;
            if (updatedConversation.readStatus !== undefined) nextData.readStatus = updatedConversation.readStatus;
            if (typeof updatedConversation.isPinned === 'boolean') nextData.isPinned = updatedConversation.isPinned;
            if (updatedConversation.pinnedAt !== undefined) nextData.pinnedAt = updatedConversation.pinnedAt;
        }
        dispatch((0, $6geN3.setConversationData)({
            conversationId: conversationId,
            data: nextData
        }));
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).UPDATE_CONVERSATION_CHANNEL
        });
    };




























var $f2kj3 = parcelRequire("f2kj3");











const $cd0a4aea4e48093b$export$b1e09d46e687e819 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).warmConversationCache, ({ conversation: conversationParams, forceRefresh: forceRefresh, onSuccess: onSuccess, onError: onError })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, setMessages: setMessages, capabilities: capabilities })=>{
        const conversationId = conversationParams.id;
        const existingConversation = getState().conversations[conversationId];
        // Skip if conversation is actively in-flight
        if (existingConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).loadingChat || existingConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse || existingConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).typingResponse) return;
        // Skip if conversation is already loaded (idle with messages) unless forceRefresh
        if (existingConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && !forceRefresh) return;
        try {
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).WARM_CONVERSATION_CACHE,
                id: conversationId,
                attributes: {
                    conversationId: conversationId,
                    forceRefresh: Boolean(forceRefresh)
                }
            });
            // Bootstrap conversation in store with provided metadata or client defaults.
            const conversationAgentForWarmLoadingReset = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? existingConversation?.agent ?? (0, $8fLSN.createProvisionalConversationAgent)(conversationParams.agentId ?? existingConversation?.sourceAgentId) : undefined;
            const conversationAgentFieldsForWarmLoadingReset = conversationAgentForWarmLoadingReset ? {
                agent: conversationAgentForWarmLoadingReset
            } : {};
            const messagesBeforeReload = getMessages(conversationId);
            dispatch((0, $lOO5l.initializeConversationData)({
                conversationId: conversationId,
                data: {
                    id: conversationId,
                    name: conversationParams.name ?? existingConversation?.name ?? '',
                    timeCreated: conversationParams.timeCreated ?? existingConversation?.timeCreated ?? new Date().toISOString(),
                    status: (0, $igOtY.CHAT_STORE_STATUS).loadingChat,
                    traces: [],
                    sourceAgentId: conversationParams.agentId ?? existingConversation?.sourceAgentId ?? '',
                    ...conversationAgentFieldsForWarmLoadingReset,
                    messages: []
                }
            }));
            // If metadata params not fully provided, fetch from API in parallel (silent failure)
            const hasFullMetadata = conversationParams.name != null && conversationParams.timeCreated != null;
            const metadataPromise = hasFullMetadata ? Promise.resolve() : assistanceService.fetchConversationMetadata(conversationId).then((metadata)=>{
                const fetchedConversationAgentFields = metadata.agent && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? {
                    agent: metadata.agent
                } : {};
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversationId,
                    data: {
                        name: metadata.name ?? conversationParams.name ?? '',
                        timeCreated: metadata.time_created ?? conversationParams.timeCreated ?? existingConversation?.timeCreated ?? new Date().toISOString(),
                        sourceAgentId: (0, $iDrrr.fg)('jira_ai_task_level_planning_ootb_agent') || (0, $iDrrr.fg)('jira-ai-fix-refine-in-chat-with-ootb-agent') ? metadata.agent?.agent_id ?? metadata.agent?.agent_named_id ?? conversationParams.agentId ?? existingConversation?.sourceAgentId ?? '' : metadata.agent?.agent_named_id ?? conversationParams.agentId ?? existingConversation?.sourceAgentId ?? '',
                        ...fetchedConversationAgentFields,
                        ...metadata.tags !== undefined ? {
                            tags: metadata.tags
                        } : {},
                        lastRequestedMode: (0, $f2kj3.normalizeRestorableRequestedMode)(metadata.last_requested_mode)
                    }
                }));
            }).catch(()=>{
            // Silent failure — keep client defaults
            });
            // Run messages fetch and metadata fetch in parallel; wait for both
            const chatPromise = assistanceService.getChat(conversationId, capabilities);
            const [chatResult] = await Promise.allSettled([
                chatPromise,
                metadataPromise
            ]);
            if (chatResult.status === 'rejected') {
                const normalizedError = chatResult.reason instanceof Error ? chatResult.reason : new Error(String(chatResult.reason));
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).WARM_CONVERSATION_CACHE,
                    error: normalizedError
                });
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversationId,
                    data: (0, $jyZaR.clearStatus)({})
                }));
                onError?.(normalizedError);
                return;
            }
            const serviceChat = chatResult.value;
            const status = getState().conversations[conversationId]?.status;
            if (status !== (0, $igOtY.CHAT_STORE_STATUS).loadingChat) return;
            const messages = (0, $gjWe2.processConversationMessages)({
                latestMessages: serviceChat,
                conversationId: conversationId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                shouldPreprocessDetails: (0, $6OcY6.shouldPreprocessDetailsForConversation)(getState(), conversationId)
            });
            const fetchedAgentVersion = (0, $287b89b445b82017$export$9c99f879b5701ba2)(serviceChat);
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: {
                    ...(0, $jyZaR.clearStatus)({
                        lastAgentMessageStatus: 'SUCCESSFUL'
                    }),
                    ...fetchedAgentVersion ? {
                        agentVersion: fetchedAgentVersion
                    } : {}
                }
            }));
            setMessages(conversationId, (0, $iDrrr.fg)('rovo_chat_preserve_follow_ups_on_refetch') ? (0, $d2bec76a2cf3a32e$export$78825c8f4b3c575c)(messagesBeforeReload, messages) : messages);
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).WARM_CONVERSATION_CACHE
            });
            onSuccess?.();
        } catch (e) {
            const normalizedError = e instanceof Error ? e : new Error(String(e));
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).WARM_CONVERSATION_CACHE,
                error: normalizedError
            });
            onError?.(normalizedError);
        }
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).WARM_CONVERSATION_CACHE,
    actionErrorHandler: ()=>{
        // Suppress all default error handling for cache warming
        return;
    }
});


const $91133bed95970fa4$var$registerHumanMessageIdReplacementHandler = (handler)=>(_state, { registerHumanMessageIdReplacementHandler: registerHandler })=>registerHandler?.(handler) ?? (()=>{});
const $91133bed95970fa4$export$e324594224ef24da = {
    abortRequests: $8OiFS.abortRequests,
    addAgentMessage: $371ae8b5b22d3b46$export$217edc90936e0581,
    addErrorMessage: $20d942c7fe0333b7$export$1824e64235e4b973,
    answerNow: $3e2d3625545c1ea9$export$d5b8fce20f45b1bf,
    bulkResolveConversationActions: $8c8e302bbc2551a3$export$d5f51c6d14729a9d,
    bulkResolveConversationUIActions: $5505ac2578341bfa$export$e99fa5687f622cbf,
    clearFollowUpMessages: $izhU8.clearFollowUpMessages,
    stopTask: $51c7bf2c092024a3$export$d9d592371c2a2f98,
    clearTargetTaskMessageId: $41db72a9378f94af$export$1562f8e01d4b447c,
    createConversationOptimistically: $djNSU.createConversationOptimistically,
    createSeededConversation: $ac50e9856e9d0021$export$916d50c71d1097fc,
    deleteConversation: $f27a0f1ad9682674$export$64c838ca85b298d9,
    getChat: (0, $b25327492a2eafbb$export$5c7afebc13b5b6d7),
    handleChatOpenPubsubAction: $7924d5732284eb54$export$6914a4ee7f8cbe2c,
    hydrateConversationWithExternalParams: $dHz2q.hydrateConversationWithExternalParams,
    fetchConversationChannelsData: $7eGGZ.fetchConversationChannelsData,
    loadMoreConversationChannelsData: $dbfaf0ab050513fc$export$95850e3f7783749e,
    setConversationListMounted: $3db73ca32f481fa4$export$7c39c589455db491,
    setConversationData: $6geN3.setConversationData,
    removeMessage: $6279909d4ebd325a$export$f9a3c275d8ffdac0,
    truncateFromLastHumanMessage: $fc4eff2d3971ee33$export$a1b6e610fd39072e,
    resolveConversationAction: $6ebccb4cae0d59cc$export$11688a59b4c1bf2b,
    sendA2UIAction: $0b1976f4f4504448$export$3c932f8ca2641253,
    sendMessage: $ffjMi.sendMessage,
    sendMessageConfirmedTools: $3fbe59e6722fdc18$export$a520ca869831c96e,
    setSelectedConversation: $c8Sl1.setSelectedConversation,
    updateConversation: $030fab6f8e6adbfc$export$f020542e7ec82374,
    removeConversationFromStore: $77b987c9b91a6f83$export$53f4d2378049701e,
    reconnectToInProgressStream: $1wTWY.reconnectToInProgressStream,
    registerHumanMessageIdReplacementHandler: $91133bed95970fa4$var$registerHumanMessageIdReplacementHandler,
    restoreTaskModeIfNeeded: $eQl6Z.restoreTaskModeIfNeeded,
    warmConversationCache: $cd0a4aea4e48093b$export$b1e09d46e687e819,
    prefetchConversationMessages: $b0af940bfa1b3612$export$b798bd7f9b4e76a0,
    seedConversation: $fef4f32b3ef3f920$export$1a0f0d45b9f5743b
};


const $bb9b6d1522218f88$export$b3bf59e98866a2c9 = (0, $4m5jb.createChatStore)((0, $91133bed95970fa4$export$e324594224ef24da));
module.exports["chatStore"] = $bb9b6d1522218f88$export$b3bf59e98866a2c9;

});

parcelRegister("8OiFS", function(module, exports) {
/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing chat-store actions gate feature behavior from runtime flags. */ 
var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $irnO2 = parcelRequire("irnO2");


var $igOtY = parcelRequire("igOtY");


var $jyZaR = parcelRequire("jyZaR");


var $l6xCb = parcelRequire("l6xCb");


var $16g08 = parcelRequire("16g08");




const $3505e3e9b34506aa$export$304863f72794c019 = (chat)=>{
    const isInFlight = (action)=>{
        const lower = action.status?.toLowerCase();
        return lower === 'streaming' || lower === 'preparing';
    };
    const hasInFlightAction = chat.some((message)=>(0, $igOtY.isStoreAssistant)(message) && message.content.message.message.actions?.some(isInFlight));
    if (!hasInFlightAction) return chat;
    return chat.map((message)=>{
        if (!(0, $igOtY.isStoreAssistant)(message) || !message.content.message.message.actions?.some(isInFlight)) return message;
        return {
            ...message,
            content: {
                ...message.content,
                message: {
                    ...message.content.message,
                    message: {
                        ...message.content.message.message,
                        actions: message.content.message.message.actions.map((action)=>isInFlight(action) ? {
                                ...action,
                                status: 'cancelled'
                            } : action)
                    }
                }
            }
        };
    });
};



var $6geN3 = parcelRequire("6geN3");

const $99be9b013bc211a2$export$39589cf038b415bc = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).abortRequests, ({ conversationId: conversationId, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, deepResearchEnabled: deepResearchEnabled } = {})=>({ getState: getState, dispatch: dispatch }, { experienceTracker: experienceTracker, setReasoningMode: setReasoningMode, isReconnecting: isReconnecting, unifiedTasksActions: unifiedTasksActions, markIncompleteResearchesErrored: markIncompleteResearchesErrored, clearMessageResearch: clearMessageResearch, getMessages: getMessages, setMessages: setMessages })=>{
        const conversations = getState().conversations;
        const abortConversationStream = (conversation)=>{
            const shouldSynchronouslyCancelRemix = conversation?.isViewModeRemix === true && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_5');
            if (conversation?.id && ((0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true) || shouldSynchronouslyCancelRemix)) {
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversation.id,
                    data: (0, $jyZaR.clearStatus)({
                        lastAgentMessageStatus: 'CANCELLED'
                    })
                }));
                // Only clear research when answer streaming has started.
                if (conversation.status === (0, $igOtY.CHAT_STORE_STATUS).typingResponse) {
                    const activeAssistantMessageIds = getMessages(conversation.id).filter((message)=>(0, $igOtY.isStoreAssistant)(message) && message.content.streamingComplete !== true).map((message)=>message.content.message.message.id);
                    activeAssistantMessageIds.forEach((messageId)=>{
                        markIncompleteResearchesErrored({
                            messageId: messageId
                        });
                        clearMessageResearch({
                            messageId: messageId
                        });
                    });
                }
            }
            if (conversation?.storeAbortController) {
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).ABORT_AGENT_STREAM,
                    id: conversation?.id,
                    attributes: {
                        conversationId: conversation?.id,
                        isReconnecting: isReconnecting(conversation?.id ?? '')
                    }
                });
                conversation.storeAbortController.abort();
                if ((0, $iDrrr.fg)('cc-cwr-fix-finalizing-cancelled-request') && conversation.id && !isReconnecting(conversation.id)) {
                    const currentMessages = getMessages(conversation.id);
                    const nextMessages = (0, $3505e3e9b34506aa$export$304863f72794c019)(currentMessages);
                    if (nextMessages !== currentMessages) setMessages(conversation.id, nextMessages);
                }
                experienceTracker.abort({
                    name: (0, $16g08.getSendMessageExperienceName)({
                        deepResearchEnabled: deepResearchEnabled,
                        thinkDeeperEnabled: thinkDeeperEnabled,
                        taskModeEnabled: taskModeEnabled,
                        fastModeEnabled: fastModeEnabled
                    }),
                    reason: 'Aborted',
                    attributes: {
                        isProgrammaticAbort: true
                    }
                });
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).ABORT_AGENT_STREAM
                });
                if (taskModeEnabled && conversation?.id && unifiedTasksActions && (0, $iDrrr.fg)('rovo_chat_enable_tasks')) unifiedTasksActions.setTaskProgressState({
                    conversationId: conversation.id,
                    progressState: 'Cancelled',
                    updatedAt: new Date().toISOString()
                });
            }
        };
        if (conversationId) abortConversationStream(conversations[conversationId]);
        else Object.values(conversations).forEach(abortConversationStream);
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).ABORT_AGENT_STREAM
});
module.exports["abortRequests"] = $99be9b013bc211a2$export$39589cf038b415bc;

});

parcelRegister("eBgZa", function(module, exports) {

var $8A2GO = parcelRequire("8A2GO");


var $b6N3q = parcelRequire("b6N3q");


var $bMRok = parcelRequire("bMRok");


var $hHBvs = parcelRequire("hHBvs");


var $kncFb = parcelRequire("kncFb");


var $hwHCO = parcelRequire("hwHCO");


var $bQxqB = parcelRequire("bQxqB");


var $icBz6 = parcelRequire("icBz6");

const $2bb3767adaced59b$export$5782d74d68fa92c6 = (error, prefix = '', actionLoggableNameIfActionExecutionFailed)=>{
    let status_code, message_template, timeout;
    const message = error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unknown error';
    let prefixedMessage = prefix ? `${prefix}: ${message}` : message;
    let errorType;
    let traceId;
    if (error instanceof (0, $hwHCO.StreamErrorException)) {
        status_code = error.detail.message.status_code;
        message_template = error.detail.message.message_template;
        timeout = error.detail.metadata?.timeout;
        errorType = 'StreamErrorException';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $8A2GO.ApiError)) {
        status_code = error.errorAttributes.statusCode;
        message_template = error.errorAttributes.errorCode;
        errorType = 'ApiError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $hHBvs.MessageActionError)) {
        // Prefer showing only the raw API error message (without codes) to end users
        const rawErrorMessage = error.cause && 'errorAttributes' in error.cause && typeof error.cause.errorAttributes === 'object' && error.cause.errorAttributes !== null && 'rawErrorMessage' in error.cause.errorAttributes ? error.cause.errorAttributes.rawErrorMessage : undefined;
        if (typeof rawErrorMessage === 'string') prefixedMessage = prefix ? `${prefix}: ${rawErrorMessage}` : rawErrorMessage;
    }
    if (error instanceof (0, $bQxqB.StreamGeneratorError)) {
        errorType = 'StreamGeneratorError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $kncFb.NoFinalResponseError)) {
        errorType = 'NoFinalResponseError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $b6N3q.RovoChatStreamTimeoutError)) {
        errorType = 'RovoChatStreamTimeoutError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $bMRok.DeepResearchError)) {
        message_template = error.message_template;
        errorType = 'DeepResearchError';
        traceId = error.errorAttributes.traceId;
    }
    return {
        type: 'ERROR',
        content: prefixedMessage,
        time_created: new Date().toLocaleString(),
        status_code: status_code,
        message_template: message_template,
        timeout: timeout,
        id: (0, $icBz6.generateId)(),
        errorType: errorType,
        traceId: traceId,
        storeActionExecutionError: actionLoggableNameIfActionExecutionFailed ? {
            actionLoggableName: actionLoggableNameIfActionExecutionFailed
        } : undefined
    };
};
module.exports["createStoreError"] = $2bb3767adaced59b$export$5782d74d68fa92c6;

});

parcelRegister("1IZrU", function(module, exports) {

var $4m5jb = parcelRequire("4m5jb");

const $1e88240d2a144a7a$export$b178621992ef9541 = (conversationId)=>conversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID) || conversationId === undefined;
module.exports["isEmptyConversation"] = $1e88240d2a144a7a$export$b178621992ef9541;

});

parcelRegister("fjUOt", function(module, exports) {

var $bkEBw = parcelRequire("bkEBw");


var $igOtY = parcelRequire("igOtY");

const $c4fd37cdefb60c84$export$6fc20c9b92c92c1c = (storeMessage)=>{
    if ((0, $igOtY.isStoreAssistant)(storeMessage)) return (0, $bkEBw.getId)(storeMessage.content);
    return storeMessage.content.id;
};
module.exports["getStoreMessageId"] = $c4fd37cdefb60c84$export$6fc20c9b92c92c1c;

});

parcelRegister("dw75i", function(module, exports) {
const $298e232207fb2253$export$4081752c8da17394 = {
    // Atlassian Projects
    CreateProjectProgressUpdate: 'atlassian-project-atlassian-atlassian-project-create-progress-up',
    // Jira
    UpdateWorkItemFields: 'jira-atlassian-work-item-update-single-field',
    UpdateWorkItemAllFieldTypes: 'jira-atlassian-work-item-update-all-field-types-bulk',
    JiraFindIssues: 'jira-find-issues',
    JiraSmartIssueCreateAllField: 'jira-atlassian-work-item-create-all-field-types',
    JiraAdminAgent: 'JiraAdminAgentActionableTool',
    JiraIssueTransition: 'jira-issue-transition-bulk',
    JiraEpicsSuggest: 'jira-epics-suggest',
    JiraIssueDelete: 'jira-issue-delete',
    JiraIssueMove: 'jira-issue-move',
    JiraIssueAssign: 'jira-issue-assign-bulk',
    JiraVersionCreate: 'jira-version-create',
    JiraViewCreateAndConfigure: 'jira-view-create-and-configure',
    RovoWhenAssignedTool: 'RovoWhenAssignedTool',
    RovoJiraDelegationIntentTool: 'RovoJiraDelegationIntentTool',
    // Work organizer sprint actions
    JiraCreateSprint: 'jira-atlassian-work-item-create-sprint',
    JiraStartSprint: 'jira-atlassian-board-start-sprint',
    JiraMoveToSprint: 'jira-atlassian-workspace-move-to-sprint-work-item',
    JiraWorkflowEditor: 'jira-workflow-operations',
    // Confluence
    ConfluenceFolderCreate: 'confluence-atlassian-workspace-create-folder',
    ConfluencePageCreate: 'confluence-page-create',
    ConfluencePageComment: 'confluence-page-comment',
    ConfluencePageAddLabel: 'confluence-label-create',
    ConfluencePageAddLabelIS: 'confluence-atlassian-workspace-create-label',
    // Integration Service tool name variant
    ConfluencePageRename: 'confluence-page-rename',
    ConfluencePageMove: 'confluence-page-move',
    // JSM
    JsmJourneyBuilder: 'jsm-invoke-orchestrator-agent',
    JsmCreateRequest: 'jsm-create-request',
    JsmCreateRequestV2: 'jsm-create-request-v2',
    CreateRequest: 'create-request',
    JsmCreateEmbeddedRequest: 'help-form-submit',
    JsmCreateSurvey: 'jsm-create-survey',
    JsmCreateFormTemplate: 'jsm-atlassian-project-create-form-template',
    JsmLivechat: 'jsm-livechat',
    JsmSolutionComposerPlanSummary: 'jsm-solution-composer-plan-summary',
    // Deep Research
    DeepResearchCreatePageAction: 'deep-research-report-confluence-export',
    // Studio
    StudioTriggerSolutionPlan: 'studio-trigger-solution-plan',
    StudioUpdateAgentDraft: 'studio-atlassian-studio-update-agent-draft',
    StudioWorkspaceUpdateAgentDraft: 'studio-atlassian-workspace-update-draft-agent',
    StudioAutomationTriggerRuleBuild: 'studio-automation-trigger-rule-build',
    StudioAutomationCreateRule: 'automation-platform-atlassian-automation-create-rule',
    UpdateAgentConfigurationTool: 'UpdateAgentConfigurationTool',
    StudioCreateAgent: 'CreateAgentTool',
    StudioLandingPageRedirect: 'studio-landing-page-redirect',
    // Plans
    JiraPlansUpdateWorkSource: 'jira-atlassian-plan-update-work-sources',
    JiraPlansCreateProgramBoard: 'jira-plan-add-program-board-plugin',
    JiraPlansDeleteProgramBoard: 'Jira-Plan-Delete-Program-Board-Plugin',
    JiraPlansCreateWorkItem: 'jira-atlassian-plan-create-work-item',
    JiraPlansCreateRelease: 'Jira-Plan-Create-Release-Plugin',
    JiraPlansManageFeatures: 'jira-atlassian-plan-set-release-enabled',
    JiraPlansAddDependency: 'jira-atlassian-plan-add-work-item-dependencies',
    JiraPlansRemoveDependency: 'jira-atlassian-plan-remove-work-item-dependencies',
    // Capacity Planning
    ManageCapacityPlan: 'capacity-plan-update-single-action',
    // Allocation Planning
    ManagePlanAllocations: 'manage-plan-allocations',
    // Atlassian Teams
    AtlassianTeamUpdateArchive: 'atlassian-team-atlassian-team-update-archive',
    // Focus Asks
    FocusCreateAsk: 'passionfruit-atlassian-workspace-create-asks',
    FocusCreateAskAnthropic: 'ari:cloud:platform::skill/b3f8a1c2-7e4d-4a9b-8c6f-2d1e5b9a3f7es',
    // Bitbucket
    BitbucketPullRequestComment: 'bitbucket-pull-request-comment',
    // Slack
    SlackSendChannelMessage: 'slack-send-channel-message',
    // Others
    StoreRecommendationCard: 'store-recommendation-card',
    RequireInformationTool: 'RequireInformationTool',
    HiringManagerTool: 'HiringManagerTool',
    JsmSuggestAndAddFieldsToRequestType: 'SuggestAndAddFieldsToRequestType',
    JsmAtlassianProjectCreateJsmRequestType: 'jsm-atlassian-project-create-jsm-request-type',
    JsmAtlassianProjectCreateJsmRequestTypeWithFields: 'jsm-atlassian-project-create-jsm-request-type-with-fields',
    // Google Docs
    GoogleDocCreate: 'google-doc-create',
    // Convo AI agent tools
    ExecutePython: 'execute_python',
    PlanComplete: 'plan_complete',
    AskQuestion: 'ask_question',
    JsmAtlassianProjectCreateJsmQueue: 'jsm-atlassian-project-create-jsm-queue',
    JsmAtlassianProjectCreateJsmQueueGroup: 'jsm-atlassian-project-create-jsm-queue-group',
    JsmAtlassianProjectUpdateJsmQueue: 'jsm-atlassian-project-update-jsm-queue',
    JsmAtlassianProjectUpdateJsmQueueGroup: 'jsm-atlassian-project-update-jsm-queue-group',
    JsmAtlassianProjectUpdateRequestTypePortalGroups: 'jsm-atlassian-project-update-request-type-groups',
    JsmAtlassianRequestTypeUpdateWorkflow: 'jsm-atlassian-request-type-update-workflow',
    JsmSelectHardwareTypes: 'ham-onboarding-hardware-assets-types',
    JsmSelectHardwareTypesSkill: 'ham-onboarding-hardware-assets-types-skill',
    HamOnboardingSetupComplete: 'ham-onboarding-setup-complete',
    HamOnboardingSetupCompleteSkill: 'ham-onboarding-setup-complete-skill',
    JsmCreateSlaPlugin: 'jsm-create-sla-plugin',
    JsmUpdateSlaPlugin: 'jsm-update-sla-plugin',
    // Confluence AIFC
    AifcAdfUpdate: 'aifc-adf-update',
    // Google Calendar
    GoogleCalendarEventCreate: 'google-calendar-event-create',
    // Add other keys here as needed
    ScheduledChat: 'ScheduleRovoChatTool',
    ImageSearch: 'image-search',
    MultipleChoiceQuestionsTool: 'MultipleChoiceQuestionsTool',
    AgenticPlanTool: 'AgenticPlanTool',
    RepositoryChoiceTool: 'RepositoryChoiceTool',
    CreateKBCard: 'jsm-atlassian-jsm-kb-bulk-create-draft-topics',
    CreateKbArticlesCard: 'jsm-atlassian-jsm-kb-validate-draft-articles',
    // Custom Skills
    CreateCustomSkillTool: 'CreateCustomSkillTool',
    UpdateCustomSkillTool: 'UpdateCustomSkillTool'
};
const $298e232207fb2253$export$c5959ebd02278fb3 = $298e232207fb2253$export$4081752c8da17394.FocusCreateAsk;
const $298e232207fb2253$export$13a3c9f5b74f4587 = $298e232207fb2253$export$4081752c8da17394.FocusCreateAskAnthropic;
const $298e232207fb2253$export$a43abf6a24956d01 = $298e232207fb2253$export$4081752c8da17394.GoogleDocCreate;
const $298e232207fb2253$export$98251f227f05fc03 = 'execute_python';
const $298e232207fb2253$export$2cf48170a90af7e3 = 'plan_complete';
const $298e232207fb2253$export$52c76e2fb6c72799 = 'ask_question';
const $298e232207fb2253$export$d3fc7569bcc4e4e7 = new Set([
    $298e232207fb2253$export$52c76e2fb6c72799,
    $298e232207fb2253$export$2cf48170a90af7e3
]);
const $298e232207fb2253$export$f4709e6eb43898ae = {
    DynamicAction: 'dynamicAction',
    Resumption: 'resumption'
};
const $298e232207fb2253$export$dc0b7ce6d28cc1a4 = Object.values($298e232207fb2253$export$4081752c8da17394);
const $298e232207fb2253$export$a70752a3aa5d7b44 = 'generic-external-action-error';
const $298e232207fb2253$export$4017c867f2f7bb4 = 'jira-find-issues';
const $298e232207fb2253$export$d94c92560b8e6d9 = 'jira-atlassian-work-item-create-all-field-types';
const $298e232207fb2253$export$ae7170c1349b8d03 = 'jsm-create-request';
const $298e232207fb2253$export$bd97f2d43b42e54b = 'jsm-create-request-v2';
const $298e232207fb2253$export$ce5ab65c94ba90a5 = 'create-request';
const $298e232207fb2253$export$d8b6e8d910775d71 = 'help-form-submit';
const $298e232207fb2253$export$63066a4ea024d6dc = 'jsm-livechat';
const $298e232207fb2253$export$12df73851574d597 = 'jira-issue-transition-bulk';
const $298e232207fb2253$export$3409cf7709732f7a = 'jira-epics-suggest';
const $298e232207fb2253$export$28eab0a47cd4bdb7 = 'jira-issue-delete';
const $298e232207fb2253$export$7814024c83fb6ff0 = 'jira-issue-move';
const $298e232207fb2253$export$1621b7bb3a34aaf8 = 'jira-issue-assign-bulk';
const $298e232207fb2253$export$5d140de35a141589 = 'jira-version-create';
const $298e232207fb2253$export$5930d4956edc85a0 = 'jira-view-create-and-configure';
const $298e232207fb2253$export$9fd86b62c760a9f1 = 'RovoWhenAssignedTool';
const $298e232207fb2253$export$8ca833ea85a8fbca = 'RovoJiraDelegationIntentTool';
const $298e232207fb2253$export$9c43c5b52e38bd7b = 'capacity-plan-update-single-action';
const $298e232207fb2253$export$5822a2e7b967ba2a = 'manage-plan-allocations';
const $298e232207fb2253$export$7daabf9beae1e394 = 'jira-workflow-operations';
const $298e232207fb2253$export$b34d7535a3731e6 = 'confluence-page-create';
const $298e232207fb2253$export$5eead95dddb4d85e = 'confluence-page-comment';
const $298e232207fb2253$export$dd1d4f1078af0323 = 'confluence-page-rename';
const $298e232207fb2253$export$ea076e5315cd0441 = 'confluence-label-create';
const $298e232207fb2253$export$2d6387634f79866d = 'confluence-page-move';
const $298e232207fb2253$export$c35e156d5b3ba839 = 'deep-research-report-confluence-export';
const $298e232207fb2253$export$4e69e2bf4f236f9 = 'image-search';
const $298e232207fb2253$export$6509c2efb7cf2a1a = 'RequireInformationTool';
const $298e232207fb2253$export$32fdd722a8ead9f4 = 'HiringManagerTool';
const $298e232207fb2253$export$1b06fd861ab5ff79 = 'studio-trigger-solution-plan';
const $298e232207fb2253$export$7f87d37407a70a70 = 'studio-atlassian-studio-update-agent-draft';
const $298e232207fb2253$export$e118b34b65e65120 = 'studio-atlassian-workspace-update-draft-agent';
const $298e232207fb2253$export$1d1c24f8fb60d008 = 'UpdateAgentConfigurationTool';
const $298e232207fb2253$export$5f46fda2a8a95615 = 'jsm-invoke-orchestrator-agent';
const $298e232207fb2253$export$a1766d72cd6b3386 = 'jsm-atlassian-project-create-jsm-survey';
const $298e232207fb2253$export$898c044e7b2c7e3a = 'jsm-atlassian-project-create-form-template';
const $298e232207fb2253$export$97632a370497b953 = 'jsm-atlassian-project-create-jsm-queue';
const $298e232207fb2253$export$d1d21bf838e2f79 = 'jsm-atlassian-project-create-jsm-queue-group';
const $298e232207fb2253$export$7343cca51c2f764f = 'jsm-atlassian-project-update-jsm-queue';
const $298e232207fb2253$export$263c9dbbd6f9736b = 'jsm-atlassian-project-update-jsm-queue-group';
const $298e232207fb2253$export$f72bc47d7a557fac = 'jsm-atlassian-project-update-request-type-groups';
const $298e232207fb2253$export$ccb0750b3728dfc8 = 'jsm-atlassian-request-type-update-workflow';
const $298e232207fb2253$export$b26feecb387f3cdd = 'jsm-create-sla-plugin';
const $298e232207fb2253$export$2ebc939020585965 = 'jsm-update-sla-plugin';
const $298e232207fb2253$export$c24d173ae081691 = 'jsm-atlassian-project-create-jsm-request-type';
const $298e232207fb2253$export$85f4644ed1882358 = 'jsm-atlassian-project-create-jsm-request-type-with-fields';
const $298e232207fb2253$export$a95d95d149961c0e = 'SuggestAndAddFieldsToRequestType';
const $298e232207fb2253$export$20f16b1101429bc = 'jsm-atlassian-jsm-kb-bulk-create-draft-topics';
const $298e232207fb2253$export$4c4ea6fd8cbe01a5 = 'jsm-atlassian-jsm-kb-validate-draft-articles';
const $298e232207fb2253$export$459b808fe2e5243c = 'studio-automation-trigger-rule-build';
const $298e232207fb2253$export$a812c5f6a163b49c = 'automation-platform-atlassian-automation-create-rule';
const $298e232207fb2253$export$7ec0908a542c881f = 'CreateAgentTool';
const $298e232207fb2253$export$5b672baa753f5e11 = 'jira-atlassian-plan-update-work-sources';
const $298e232207fb2253$export$cbc8657dfb60324e = 'jira-plan-add-program-board-plugin';
const $298e232207fb2253$export$5eaeb9a94b1424d1 = 'Jira-Plan-Delete-Program-Board-Plugin';
const $298e232207fb2253$export$aa0b02e94003e760 = 'jira-atlassian-plan-create-work-item';
const $298e232207fb2253$export$fc48d7aa308f4ddd = 'jira-atlassian-plan-set-release-enabled';
const $298e232207fb2253$export$82a76d32e0a5ed52 = 'jira-atlassian-plan-add-work-item-dependencies';
const $298e232207fb2253$export$a27ffbabb22373cc = 'jira-atlassian-plan-remove-work-item-dependencies';
const $298e232207fb2253$export$17ce344f9afefd3f = 'Jira-Plan-Create-Release-Plugin';
const $298e232207fb2253$export$b392dc810180e703 = 'store-recommendation-card';
const $298e232207fb2253$export$1d10a8f57c7c69ae = 'jira-ham-ai-insights-preview';
const $298e232207fb2253$export$37572672766b68ab = 'atlassian-team-atlassian-team-update-archive';
const $298e232207fb2253$export$88c32cc437966d51 = 'ScheduleRovoChatTool';
const $298e232207fb2253$export$a60c2f7f22cc5a42 = 'MultipleChoiceQuestionsTool';
const $298e232207fb2253$export$d4c7224b1c4ad942 = 'AgenticPlanTool';
const $298e232207fb2253$export$ef8aa45067b257a9 = [
    $298e232207fb2253$export$4017c867f2f7bb4,
    $298e232207fb2253$export$3409cf7709732f7a,
    $298e232207fb2253$export$28eab0a47cd4bdb7,
    $298e232207fb2253$export$7814024c83fb6ff0
];
module.exports["ActionKeys"] = $298e232207fb2253$export$4081752c8da17394;
module.exports["FOCUS_CREATE_ASK_KEY"] = $298e232207fb2253$export$c5959ebd02278fb3;
module.exports["FOCUS_CREATE_ASK_ANTHROPIC_KEY"] = $298e232207fb2253$export$13a3c9f5b74f4587;
module.exports["ASK_QUESTION_KEY"] = $298e232207fb2253$export$52c76e2fb6c72799;
module.exports["ACTIONS_HIDING_FOOTER_BUTTONS"] = $298e232207fb2253$export$d3fc7569bcc4e4e7;
module.exports["ActionPredicateKeys"] = $298e232207fb2253$export$f4709e6eb43898ae;
module.exports["JIRA_FIND_ISSUES_KEY"] = $298e232207fb2253$export$4017c867f2f7bb4;
module.exports["JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY"] = $298e232207fb2253$export$d94c92560b8e6d9;
module.exports["JSM_CREATE_REQUEST_KEY"] = $298e232207fb2253$export$ae7170c1349b8d03;
module.exports["JSM_CREATE_REQUEST_V2_KEY"] = $298e232207fb2253$export$bd97f2d43b42e54b;
module.exports["CREATE_REQUEST_KEY"] = $298e232207fb2253$export$ce5ab65c94ba90a5;
module.exports["JSM_CREATE_EMBEDDED_REQUEST_KEY"] = $298e232207fb2253$export$d8b6e8d910775d71;
module.exports["JIRA_ISSUE_TRANSITION_KEY"] = $298e232207fb2253$export$12df73851574d597;
module.exports["JIRA_EPICS_SUGGEST_KEY"] = $298e232207fb2253$export$3409cf7709732f7a;
module.exports["JIRA_ISSUE_DELETE_KEY"] = $298e232207fb2253$export$28eab0a47cd4bdb7;
module.exports["JIRA_ISSUE_MOVE_KEY"] = $298e232207fb2253$export$7814024c83fb6ff0;
module.exports["JIRA_ISSUE_ASSIGN_KEY"] = $298e232207fb2253$export$1621b7bb3a34aaf8;
module.exports["JIRA_VERSION_CREATE_KEY"] = $298e232207fb2253$export$5d140de35a141589;
module.exports["JIRA_VIEW_CREATE_AND_CONFIGURE_KEY"] = $298e232207fb2253$export$5930d4956edc85a0;
module.exports["CONFLUENCE_PAGE_CREATE_KEY"] = $298e232207fb2253$export$b34d7535a3731e6;
module.exports["CONFLUENCE_PAGE_COMMENT_KEY"] = $298e232207fb2253$export$5eead95dddb4d85e;
module.exports["CONFLUENCE_PAGE_RENAME_KEY"] = $298e232207fb2253$export$dd1d4f1078af0323;
module.exports["CONFLUENCE_PAGE_ADD_LABEL_KEY"] = $298e232207fb2253$export$ea076e5315cd0441;
module.exports["CONFLUENCE_PAGE_MOVE_KEY"] = $298e232207fb2253$export$2d6387634f79866d;
module.exports["IMAGE_SEARCH_KEY"] = $298e232207fb2253$export$4e69e2bf4f236f9;
module.exports["REQUIRE_INFORMATION_TOOL"] = $298e232207fb2253$export$6509c2efb7cf2a1a;
module.exports["HIRING_MANAGER_TOOL_KEY"] = $298e232207fb2253$export$32fdd722a8ead9f4;
module.exports["STUDIO_TRIGGER_SOLUTION_PLAN_KEY"] = $298e232207fb2253$export$1b06fd861ab5ff79;
module.exports["JSM_CREATE_SURVEY_KEY"] = $298e232207fb2253$export$a1766d72cd6b3386;
module.exports["JSM_CREATE_FORM_TEMPLATE_KEY"] = $298e232207fb2253$export$898c044e7b2c7e3a;
module.exports["JSM_QUEUE_CREATE_KEY"] = $298e232207fb2253$export$97632a370497b953;
module.exports["JSM_QUEUE_GROUP_CREATE_KEY"] = $298e232207fb2253$export$d1d21bf838e2f79;
module.exports["JSM_QUEUE_UPDATE_KEY"] = $298e232207fb2253$export$7343cca51c2f764f;
module.exports["JSM_QUEUE_GROUP_UPDATE_KEY"] = $298e232207fb2253$export$263c9dbbd6f9736b;
module.exports["JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY"] = $298e232207fb2253$export$f72bc47d7a557fac;
module.exports["JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY"] = $298e232207fb2253$export$ccb0750b3728dfc8;
module.exports["JSM_SLA_CREATE_KEY"] = $298e232207fb2253$export$b26feecb387f3cdd;
module.exports["JSM_SLA_UPDATE_KEY"] = $298e232207fb2253$export$2ebc939020585965;
module.exports["JSM_REQUEST_TYPE_UPDATED_KEY"] = $298e232207fb2253$export$85f4644ed1882358;
module.exports["JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY"] = $298e232207fb2253$export$a95d95d149961c0e;
module.exports["JSM_CREATE_KB_TOPICS_KEY"] = $298e232207fb2253$export$20f16b1101429bc;
module.exports["JSM_CREATE_KB_ARTICLES_KEY"] = $298e232207fb2253$export$4c4ea6fd8cbe01a5;
module.exports["STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY"] = $298e232207fb2253$export$459b808fe2e5243c;
module.exports["JIRA_PLANS_UPDATE_WORK_SOURCE_KEY"] = $298e232207fb2253$export$5b672baa753f5e11;
module.exports["JIRA_PLANS_ADD_PROGRAM_BOARD_KEY"] = $298e232207fb2253$export$cbc8657dfb60324e;
module.exports["JIRA_PLANS_DELETE_PROGRAM_BOARD_KEY"] = $298e232207fb2253$export$5eaeb9a94b1424d1;
module.exports["JIRA_PLANS_CREATE_WORK_ITEM_KEY"] = $298e232207fb2253$export$aa0b02e94003e760;
module.exports["JIRA_PLANS_MANAGE_FEATURES_KEY"] = $298e232207fb2253$export$fc48d7aa308f4ddd;
module.exports["JIRA_PLANS_ADD_DEPENDENCY_KEY"] = $298e232207fb2253$export$82a76d32e0a5ed52;
module.exports["JIRA_PLANS_REMOVE_DEPENDENCY_KEY"] = $298e232207fb2253$export$a27ffbabb22373cc;
module.exports["JIRA_PLANS_CREATE_RELEASE_KEY"] = $298e232207fb2253$export$17ce344f9afefd3f;
module.exports["STORE_RECOMMENDATION_ACTION_KEY"] = $298e232207fb2253$export$b392dc810180e703;
module.exports["JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY"] = $298e232207fb2253$export$1d10a8f57c7c69ae;
module.exports["ATLASSIAN_TEAM_UPDATE_ARCHIVE_KEY"] = $298e232207fb2253$export$37572672766b68ab;
module.exports["SCHEDULED_CHAT_KEY"] = $298e232207fb2253$export$88c32cc437966d51;

});

parcelRegister("k1kN6", function(module, exports) {

var $igOtY = parcelRequire("igOtY");

const $60b66865acc994c3$export$3dfca8d0ecaaf31f = ({ messages: messages, messageId: messageId, searchType: searchType })=>{
    const startIndex = messages.findIndex((item)=>{
        switch(item.type){
            case 'HUMAN':
                return item.content.id === messageId;
            case 'ASSISTANT':
                return item.content.message.message.id === messageId;
            case 'FOLLOW_UP':
                return String(item.id) === messageId;
            default:
                return false;
        }
    });
    for(let i = startIndex; i >= 0; i--){
        if (messages[i].type === searchType) return messages[i];
    }
    return undefined;
};



var $cWP9O = parcelRequire("cWP9O");

const $bdba74cd3dd86c9c$export$1a288f9aecfed8b4 = (messages, agentMessageId)=>{
    try {
        const agentMessage = (0, $cWP9O.getAgentMessageById)(messages, agentMessageId).result;
        if (agentMessage && (0, $igOtY.isStoreAssistant)(agentMessage)) {
            const foundId = (0, $60b66865acc994c3$export$3dfca8d0ecaaf31f)({
                messages: messages,
                messageId: agentMessageId,
                searchType: 'HUMAN'
            })?.content.id;
            return foundId ? String(foundId) : undefined;
        }
    } catch  {
        return undefined;
    }
};
module.exports["getAssociatedHumanMessageId"] = $bdba74cd3dd86c9c$export$1a288f9aecfed8b4;

});

parcelRegister("b2pOf", function(module, exports) {
/* eslint-disable @atlaskit/platform/one-value-export-per-file -- this controller exposes one cohesive persistence boundary plus its pure codec and eligibility helpers */ 
var $iDrrr = parcelRequire("iDrrr");


var $4m5jb = parcelRequire("4m5jb");


var $8VLb5 = parcelRequire("8VLb5");


var $iWk4y = parcelRequire("iWk4y");




const $295a18506815ec6a$export$e5a3af287978673c = (siteId)=>siteId ? `${0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY}_${siteId}` : (0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY);





const $61a0979f42bdaa38$export$23660cbd62c35e47 = (siteId)=>siteId ? `${0, $8VLb5.LS_RECENT_CONVERSATION_ACTIVITY_KEY}_${siteId}` : (0, $8VLb5.LS_RECENT_CONVERSATION_ACTIVITY_KEY);



var $oV0CU = parcelRequire("oV0CU");

const $1d759ad68861991d$export$589976df4d188aac = (timestamp)=>{
    if (timestamp === null) {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.removeItem((0, $oV0CU.LS_LAST_MESSAGE_SENT_AT));
        return;
    }
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem((0, $oV0CU.LS_LAST_MESSAGE_SENT_AT), timestamp.toString());
};


const $d66b70ee5b7a48e6$export$a9deb0d4eb645dd2 = 'rovo_chat_persisted_conversation_restoration';
const $d66b70ee5b7a48e6$export$c70d328fcf26ea56 = 60000;
const $d66b70ee5b7a48e6$var$getBrowserLocalStorage = ()=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- all reads and writes are protected by the non-essential storage kill switch at their call sites
    return typeof localStorage === 'undefined' ? null : localStorage;
};
const $d66b70ee5b7a48e6$var$isPersistedConversationActivity = (value)=>{
    if (typeof value !== 'object' || value === null || Array.isArray(value)) return false;
    const candidate = value;
    return candidate.version === 1 && typeof candidate.conversationId === 'string' && candidate.conversationId.trim().length > 0 && (candidate.lastMessageSentAt === null || typeof candidate.lastMessageSentAt === 'number' && Number.isFinite(candidate.lastMessageSentAt));
};
const $d66b70ee5b7a48e6$export$2d5a1db6906f058e = (rawValue)=>{
    if (!rawValue) return null;
    try {
        const parsed = JSON.parse(rawValue);
        return $d66b70ee5b7a48e6$var$isPersistedConversationActivity(parsed) ? parsed : null;
    } catch  {
        return null;
    }
};
const $d66b70ee5b7a48e6$export$cc8cd4a22284d76 = (activity)=>$d66b70ee5b7a48e6$var$isPersistedConversationActivity(activity) ? JSON.stringify(activity) : null;
const $d66b70ee5b7a48e6$export$9ea55b949b04fb81 = ()=>(0, $iDrrr.fg)($d66b70ee5b7a48e6$export$a9deb0d4eb645dd2);
const $d66b70ee5b7a48e6$export$39ed32c8dc854042 = (siteId)=>(0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY), ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
        return $d66b70ee5b7a48e6$var$getBrowserLocalStorage()?.getItem((0, $295a18506815ec6a$export$e5a3af287978673c)(siteId)) ?? null;
    });
const $d66b70ee5b7a48e6$var$getPersistedConversationActivityWithoutGateCheck = (siteId)=>{
    const rawValue = (0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_RECENT_CONVERSATION_ACTIVITY_KEY), ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
        return $d66b70ee5b7a48e6$var$getBrowserLocalStorage()?.getItem((0, $61a0979f42bdaa38$export$23660cbd62c35e47)(siteId)) ?? null;
    });
    return $d66b70ee5b7a48e6$export$2d5a1db6906f058e(rawValue);
};
const $d66b70ee5b7a48e6$export$22a1db86992546d2 = (siteId)=>$d66b70ee5b7a48e6$export$9ea55b949b04fb81() ? $d66b70ee5b7a48e6$var$getPersistedConversationActivityWithoutGateCheck(siteId) : null;
const $d66b70ee5b7a48e6$var$writeLegacyConversationId = (siteId, conversationId)=>{
    (0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY), ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
        $d66b70ee5b7a48e6$var$getBrowserLocalStorage()?.setItem((0, $295a18506815ec6a$export$e5a3af287978673c)(siteId), conversationId);
    });
};
const $d66b70ee5b7a48e6$var$writePersistedConversationActivity = (siteId, activity)=>{
    const serialized = $d66b70ee5b7a48e6$export$cc8cd4a22284d76(activity);
    if (serialized === null) return;
    (0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_RECENT_CONVERSATION_ACTIVITY_KEY), ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
        $d66b70ee5b7a48e6$var$getBrowserLocalStorage()?.setItem((0, $61a0979f42bdaa38$export$23660cbd62c35e47)(siteId), serialized);
    });
};
const $d66b70ee5b7a48e6$export$9f594350969a7227 = (event)=>{
    const isRestorationEnabled = $d66b70ee5b7a48e6$export$9ea55b949b04fb81();
    if (event.type === 'conversation-selected') {
        const existingActivity = isRestorationEnabled ? $d66b70ee5b7a48e6$var$getPersistedConversationActivityWithoutGateCheck(event.siteId) : null;
        $d66b70ee5b7a48e6$var$writeLegacyConversationId(event.siteId, event.conversationId);
        if (event.clearLegacyLastMessageSentAt) (0, $1d759ad68861991d$export$589976df4d188aac)(null);
        if (isRestorationEnabled) $d66b70ee5b7a48e6$var$writePersistedConversationActivity(event.siteId, {
            version: 1,
            conversationId: event.conversationId,
            lastMessageSentAt: event.conversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID) && existingActivity?.conversationId === event.conversationId ? existingActivity.lastMessageSentAt : null
        });
        return;
    }
    if (!isRestorationEnabled) {
        (0, $1d759ad68861991d$export$589976df4d188aac)(event.lastMessageSentAt);
        return;
    }
    $d66b70ee5b7a48e6$var$writeLegacyConversationId(event.siteId, event.conversationId);
    (0, $1d759ad68861991d$export$589976df4d188aac)(event.lastMessageSentAt);
    $d66b70ee5b7a48e6$var$writePersistedConversationActivity(event.siteId, {
        version: 1,
        conversationId: event.conversationId,
        lastMessageSentAt: event.lastMessageSentAt
    });
};
const $d66b70ee5b7a48e6$export$8dc7d0c9532ed7e9 = ({ selectedConversationId: selectedConversationId, activity: activity, now: now, timeout: timeout })=>{
    if (selectedConversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID) || !activity || activity.conversationId !== selectedConversationId || activity.lastMessageSentAt === null || !Number.isFinite(now) || !Number.isFinite(timeout) || timeout <= 0) return false;
    const futureOffset = activity.lastMessageSentAt - now;
    if (futureOffset > $d66b70ee5b7a48e6$export$c70d328fcf26ea56) return false;
    const activityAge = Math.max(0, now - activity.lastMessageSentAt);
    return activityAge < timeout;
};
module.exports["isPersistedConversationRestorationEnabled"] = $d66b70ee5b7a48e6$export$9ea55b949b04fb81;
module.exports["getPersistedRecentConversationId"] = $d66b70ee5b7a48e6$export$39ed32c8dc854042;
module.exports["getPersistedConversationActivity"] = $d66b70ee5b7a48e6$export$22a1db86992546d2;
module.exports["persistRecentConversation"] = $d66b70ee5b7a48e6$export$9f594350969a7227;
module.exports["isPersistedConversationActivityRestorable"] = $d66b70ee5b7a48e6$export$8dc7d0c9532ed7e9;

});

parcelRegister("8VLb5", function(module, exports) {
/**
 * Registry of non-essential Rovo Chat localStorage keys.
 *
 * Add new non-essential keys here to allow them to be selectively disabled
 * via the Statsig dynamic config `rovo_chat_disabled_non_essential_ls_keys`
 * during an incident — without requiring a code deploy.
 *
 * A key is "non-essential" if Rovo Chat can function correctly without it
 * (e.g. a UI preference or optimisation). Wrap all accesses to these keys
 * with `withNonEssentialLocalStorage`.
 */ const $fb7e48e43c24c35d$export$a0d33d6e93abfb90 = 'aiMateChatLoadPreference';
const $fb7e48e43c24c35d$export$94d37e3eb83c6a20 = 'rovoChatRecentConversationActivity';
const $fb7e48e43c24c35d$export$97d0beb2ccc70a4d = 'aiMateUserPreferences';
const $fb7e48e43c24c35d$export$291a0efcaf2bb286 = 'is-rovo-sidenav-collapsed';
const $fb7e48e43c24c35d$export$a757cb7dc7c3e00c = 'rovo-sidenav-width';
const $fb7e48e43c24c35d$export$8068ec1dd5e92a56 = [
    $fb7e48e43c24c35d$export$a0d33d6e93abfb90,
    $fb7e48e43c24c35d$export$94d37e3eb83c6a20,
    $fb7e48e43c24c35d$export$97d0beb2ccc70a4d,
    $fb7e48e43c24c35d$export$291a0efcaf2bb286,
    $fb7e48e43c24c35d$export$a757cb7dc7c3e00c
];
module.exports["LS_CHAT_LOAD_PREFERENCE_KEY"] = $fb7e48e43c24c35d$export$a0d33d6e93abfb90;
module.exports["LS_RECENT_CONVERSATION_ACTIVITY_KEY"] = $fb7e48e43c24c35d$export$94d37e3eb83c6a20;
module.exports["LS_SIDE_NAV_COLLAPSED_KEY"] = $fb7e48e43c24c35d$export$291a0efcaf2bb286;
module.exports["LS_SIDE_NAV_WIDTH_KEY"] = $fb7e48e43c24c35d$export$a757cb7dc7c3e00c;

});

parcelRegister("iWk4y", function(module, exports) {
/**
 * Selective dynamic-config-protected wrapper for non-essential Rovo Chat localStorage access.
 *
 * Background (HOT-303866): a corrupt value in a localStorage key broke Rovo Chat
 * for ~23,000 users. During the incident, there was no way to quickly disable the
 * code reading that key, so the fix took days to ship.
 *
 * When `rovo_chat_disabled_nonessential_ls_keys` is enabled, this wrapper checks
 * the Statsig dynamic config `rovo_chat_disabled_non_essential_ls_keys` before
 * executing the provided callback. The config value is a `string[]` of localStorage key names that are currently
 * disabled. If the given `key` appears in that list, the callback is skipped and `null`
 * is returned. If the key is not in the list (default), the callback is executed normally.
 *
 * This allows individual localStorage keys to be selectively disabled during an incident
 * without affecting others — no code deploy required.
 *
 * ```ts
 * import { withNonEssentialLocalStorage } from
 *   '@atlassian/conversation-assistant-utils/nonEssentialLocalStorage/withNonEssentialLocalStorage';
 *
 * // Read
 * const value = withNonEssentialLocalStorage(
 *   'aiMateChatLoadPreference',
 *   () => localStorage.getItem(getChatLoadPreferenceKey(siteId))
 * );
 *
 * // Write (return value ignored)
 * withNonEssentialLocalStorage(
 *   'aiMateChatLoadPreference',
 *   () => localStorage.setItem(getChatLoadPreferenceKey(siteId), conversationId)
 * );
 * ```
 */ 
var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $76e028d2d11d3b36$var$DYNAMIC_CONFIG_NAME = 'rovo_chat_disabled_non_essential_ls_keys';
const $76e028d2d11d3b36$var$DYNAMIC_CONFIG_PARAM = 'value';
const $76e028d2d11d3b36$export$870e7f78af43b2fe = (key, callback)=>{
    if (!(0, $iDrrr.fg)('rovo_chat_disabled_nonessential_ls_keys')) return callback();
    const disabledKeys = (0, $cXtTj.default).getExperimentValue($76e028d2d11d3b36$var$DYNAMIC_CONFIG_NAME, $76e028d2d11d3b36$var$DYNAMIC_CONFIG_PARAM, [], {
        fireExperimentExposure: false
    });
    if (Array.isArray(disabledKeys) && disabledKeys.includes(key)) return null;
    return callback();
};
module.exports["withNonEssentialLocalStorage"] = $76e028d2d11d3b36$export$870e7f78af43b2fe;

});

parcelRegister("gjWe2", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $bxkJA = parcelRequire("bxkJA");


var $bJKB2 = parcelRequire("bJKB2");


var $cOOC6 = parcelRequire("cOOC6");


var $aXdbm = parcelRequire("aXdbm");


var $3iEfv = parcelRequire("3iEfv");


var $5XX4K = parcelRequire("5XX4K");


var $8bsmP = parcelRequire("8bsmP");


var $eK93A = parcelRequire("eK93A");

const $df6690dcbb70581e$export$31bb5ed5e2cc3184 = ({ latestMessages: latestMessages, conversationId: conversationId, sendAnalyticsEvent: sendAnalyticsEvent, shouldPreprocessDetails: shouldPreprocessDetails = false })=>{
    const messages = [];
    for (const message of latestMessages){
        if ((0, $bxkJA.isHumanMessage)(message)) {
            // Human messages should only have application/json+a2ui if they have sent an action
            // we skip this message as there is nothing to render but this is persisted for flexibility
            // there should be no cases where a human renders A2UI from their messages
            if (typeof message.content === 'object' && message.content !== null && 'data_parts_mime_type' in message.content && message.content.data_parts_mime_type === 'application/json+a2ui' && (0, $iDrrr.fg)('jira_ai_rendering_a2ui')) continue;
            messages.push((0, $cOOC6.createStoreHumanWithContent)(message));
        } else if ((0, $bxkJA.isStreamResponse)(message)) {
            if ((0, $iDrrr.fg)('rovo_chat_history_lift')) {
                const normalizedPresentation = (0, $8bsmP.normalizeFinalizedMessagePresentation)({
                    message: message,
                    options: {
                        shouldExtractA2UI: (0, $iDrrr.fg)('jira_ai_rendering_a2ui'),
                        shouldExtractActionableFollowUps: (0, $iDrrr.fg)('rovo_chat_actionable_followups_enabled'),
                        shouldExtractDataSculptor: (0, $iDrrr.fg)('rovo_enable_data_sculptor'),
                        shouldExtractInlineLumina: (0, $iDrrr.fg)('rovo_chat_enable_inline_lumina'),
                        shouldExtractLegacyChartBoundaries: true,
                        shouldPreprocessDetails: shouldPreprocessDetails
                    }
                });
                if (normalizedPresentation.extractionCounts.legacyChart > 0) sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'extracted',
                    actionSubject: 'vizPluginChartNonUnicode',
                    attributes: {
                        messageId: message.message.message.id.toString(),
                        conversationId: conversationId,
                        chartCount: normalizedPresentation.extractionCounts.legacyChart,
                        timestamp: new Date().toISOString()
                    }
                });
                const storeAssistant = (0, $bJKB2.createStoreAssistantWithContent)(normalizedPresentation.message);
                if (Object.keys(normalizedPresentation.markdownData).length > 0) storeAssistant.markdownData = normalizedPresentation.markdownData;
                storeAssistant.isHistorical = true;
                if (normalizedPresentation.agenticUiMessages) storeAssistant.agenticUiMessages = normalizedPresentation.agenticUiMessages;
                messages.push(storeAssistant);
            } else {
                // Process boundary content for historical assistant messages
                let processedMessage = message;
                const markdownData = {};
                // Rewrite HTML `<details><summary>` blocks into the Rovo-native `▞…▚`
                // boundary before the existing extractor runs so historical messages
                // render identically to their streamed form. Must happen BEFORE the
                // expand extractor below (which consumes `▞…▚`).
                if (shouldPreprocessDetails) processedMessage = (0, $eK93A.preprocessStreamResponseDetails)(processedMessage);
                // Apply the same boundary content extraction logic as streaming messages
                if ((0, $iDrrr.fg)('rovo_enable_data_sculptor')) {
                    const sculptorMsg = (0, $5XX4K.extractMarkdownContent)({
                        streamMessage: processedMessage,
                        boundaryStart: '[^sculptor:start^]',
                        boundaryEnd: '[^sculptor:end^]',
                        replacementContent: '[^sculptor^]'
                    });
                    processedMessage = sculptorMsg.processedStreamMessage;
                    sculptorMsg.boundaryContents.forEach((content, index)=>{
                        markdownData[`sculptor-${index}`] = content;
                    });
                }
                const expandOpenTag = "\u259E";
                const expandCloseTag = "\u259A";
                const expandPlaceholder = '[^expand^]';
                const expandMsg = (0, $5XX4K.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: expandOpenTag,
                    boundaryEnd: expandCloseTag,
                    replacementContent: expandPlaceholder
                });
                processedMessage = expandMsg.processedStreamMessage;
                expandMsg.boundaryContents.forEach((content, index)=>{
                    markdownData[`expand-${index}`] = content;
                });
                const chartPlaceholder = '[^chart^]';
                // When processing conversation history, process both unicode and non-unicode tags
                // to handle previous conversations that used the non-unicode tag
                // Once di_chat_chart_tag_unicode is rolled out, chartMsg can be removed after 30 days
                let chartIndex = 0;
                const chartMsg = (0, $5XX4K.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: '[^chart:start^]',
                    boundaryEnd: '[^chart:end^]',
                    replacementContent: chartPlaceholder
                });
                processedMessage = chartMsg.processedStreamMessage;
                chartMsg.boundaryContents.forEach((content)=>{
                    markdownData[`chart-${chartIndex}`] = content;
                    chartIndex++;
                });
                if (chartMsg?.boundaryContents && chartMsg.boundaryContents.length > 0) sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'extracted',
                    actionSubject: 'vizPluginChartNonUnicode',
                    attributes: {
                        messageId: message?.message?.message?.id.toString(),
                        conversationId: conversationId,
                        chartCount: chartMsg.boundaryContents.length,
                        timestamp: new Date().toISOString()
                    }
                });
                const unicodeChartMsg = (0, $5XX4K.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: "\u25F4",
                    boundaryEnd: "\u25F6",
                    replacementContent: chartPlaceholder
                });
                processedMessage = unicodeChartMsg.processedStreamMessage;
                unicodeChartMsg.boundaryContents.forEach((content)=>{
                    markdownData[`chart-${chartIndex}`] = content;
                    chartIndex++;
                });
                if ((0, $iDrrr.fg)('rovo_chat_enable_inline_lumina')) {
                    const luminaMsg = (0, $5XX4K.extractMarkdownContent)({
                        streamMessage: processedMessage,
                        boundaryStart: "\u25D0",
                        boundaryEnd: "\u25D1",
                        replacementContent: '\n\n[^lumina^]\n\n'
                    });
                    processedMessage = luminaMsg.processedStreamMessage;
                    luminaMsg.boundaryContents.forEach((content, index)=>{
                        markdownData[`lumina-${index}`] = content;
                    });
                }
                // Extract actionable follow-ups so history-loaded messages render the
                // same as their streamed form. Without this, the raw `◈<followup>…`
                // marker renders literally when reopening a past conversation. No-ops
                // when the experiment is in the `control` cohort.
                processedMessage = (0, $3iEfv.extractActionableFollowUpsMarkdownData)({
                    streamMessage: processedMessage,
                    markdownData: markdownData
                });
                // When the backend returns structured content (A2UI messages), normalize
                // it back to a plain text string and extract data_parts for A2UI rendering.
                let extractedA2UIMessages;
                if ((0, $iDrrr.fg)('jira_ai_rendering_a2ui')) {
                    const a2uiResult = (0, $aXdbm.extractA2UIFromStructuredContent)(processedMessage.message?.message?.content);
                    if (a2uiResult) {
                        processedMessage.message.message.content = a2uiResult.textContent;
                        extractedA2UIMessages = a2uiResult.a2uiMessages;
                    }
                }
                // Create StoreAssistant with processed boundary data
                const storeAssistant = (0, $bJKB2.createStoreAssistantWithContent)(processedMessage);
                if (Object.keys(markdownData).length > 0) storeAssistant.markdownData = markdownData;
                // Mark message as historical since it's loaded from conversation history
                storeAssistant.isHistorical = true;
                if (extractedA2UIMessages) storeAssistant.agenticUiMessages = extractedA2UIMessages;
                messages.push(storeAssistant);
            }
        }
    }
    return messages;
};
module.exports["processConversationMessages"] = $df6690dcbb70581e$export$31bb5ed5e2cc3184;

});

parcelRegister("bJKB2", function(module, exports) {
const $2641735f46fe8ec3$export$bd3c429f5e3d2c3e = (content)=>({
        type: 'ASSISTANT',
        content: content
    });
module.exports["createStoreAssistantWithContent"] = $2641735f46fe8ec3$export$bd3c429f5e3d2c3e;

});

parcelRegister("cOOC6", function(module, exports) {
const $07ee5b55b0e8ec6c$export$fa05b63813f8a225 = (content)=>({
        type: 'HUMAN',
        content: content
    });
module.exports["createStoreHumanWithContent"] = $07ee5b55b0e8ec6c$export$fa05b63813f8a225;

});

parcelRegister("f3OgL", function(module, exports) {
/**
 * Generic, dependency-free markdown stream parsing utilities.
 *
 * These utilities handle the extraction and processing of special-tag content
 * from streaming markdown text (e.g., `<lumina>...</lumina>`, `◴...◶`).
 * They operate on plain strings only — no conversation-assistant-specific
 * types or store dependencies.
 */ function $1e446058f30c9027$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
const $1e446058f30c9027$export$1edc769cb607aa0f = (text, boundaryStart, boundaryEnd, replacementContent = '')=>{
    const boundaryContents = [];
    if (!text) return {
        processedText: text,
        boundaryContents: boundaryContents
    };
    // An empty boundaryEnd denotes an open-ended component: everything from the
    // start tag to the end of the message is captured (e.g. actionable follow-ups,
    // which have a start marker but no end marker).
    const regex = boundaryEnd === '' ? new RegExp(`${$1e446058f30c9027$var$escapeRegExp(boundaryStart)}([\\s\\S]*)$`, 'g') : new RegExp(`${$1e446058f30c9027$var$escapeRegExp(boundaryStart)}(.*?)${$1e446058f30c9027$var$escapeRegExp(boundaryEnd)}`, 'gs');
    let newText = text;
    let match;
    let found = false;
    while((match = regex.exec(text)) !== null){
        boundaryContents.push(match[1]);
        newText = newText.replace(match[0], replacementContent);
        found = true;
    }
    return {
        processedText: found ? newText : text,
        boundaryContents: boundaryContents
    };
};
const $1e446058f30c9027$export$c6f5269a29d1a6df = (text, currentLoadingKey, previousKey, componentConfig)=>{
    const { startTag: startTag, endTag: endTag, placeholderTag: placeholderTag, key: key } = componentConfig;
    let streamingMarkdownContent = '';
    let newLoadingKey = currentLoadingKey;
    let newPreviousKey = previousKey;
    let markdownData = null;
    let processedText = text;
    if (typeof text === 'string') {
        // An empty endTag denotes an open-ended component (start tag, no end tag):
        // content is captured until the stream ends, so a close tag is never matched
        // mid-stream. `text.includes('')` is always true, hence the explicit guard.
        const hasCloseTag = endTag !== '' && text.includes(endTag);
        if (hasCloseTag && currentLoadingKey && currentLoadingKey.startsWith(`${key}-`)) {
            const [contentBeforeCloseTag, contentAfterCloseTag] = text.split(endTag);
            streamingMarkdownContent = contentBeforeCloseTag;
            processedText = contentAfterCloseTag;
            markdownData = {
                key: currentLoadingKey,
                content: streamingMarkdownContent,
                loading: false
            };
            newPreviousKey = currentLoadingKey;
            newLoadingKey = null;
        } else if (text.includes(startTag) && !currentLoadingKey) {
            const currentCount = previousKey == null ? -1 : parseInt(previousKey.substring(`${key}-`.length), 10);
            newLoadingKey = `${key}-${currentCount + 1}`;
            const [contentBeforeOpenTag, contentAfterOpenTag] = text.split(startTag);
            processedText = contentBeforeOpenTag + placeholderTag;
            streamingMarkdownContent = contentAfterOpenTag;
            markdownData = {
                key: newLoadingKey,
                content: streamingMarkdownContent,
                loading: true
            };
            newPreviousKey = newLoadingKey;
        } else if (currentLoadingKey) {
            streamingMarkdownContent = text;
            processedText = '';
            markdownData = {
                key: currentLoadingKey,
                content: streamingMarkdownContent,
                loading: true
            };
            newPreviousKey = currentLoadingKey;
        }
    }
    return {
        processedText: processedText,
        currentLoadingKey: newLoadingKey,
        previousKey: newPreviousKey,
        markdownData: markdownData
    };
};
const $1e446058f30c9027$export$1fc44797755f1907 = (getComponents)=>{
    let currentLoadingKeys = {};
    let previousKeys = {};
    return (text)=>{
        let processedText = text;
        let newCurrentLoadingKeys = {
            ...currentLoadingKeys
        };
        let newPreviousKeys = {
            ...previousKeys
        };
        let markdownData = null;
        let processedComponentType = null;
        for (const component of getComponents()){
            if (!component.isEnabled) continue;
            const currentLoadingKey = currentLoadingKeys[component.key] || null;
            const previousKey = previousKeys[component.key] || null;
            const result = $1e446058f30c9027$export$c6f5269a29d1a6df(processedText, currentLoadingKey, previousKey, component);
            if (result.markdownData) {
                processedText = result.processedText;
                newCurrentLoadingKeys[component.key] = result.currentLoadingKey;
                newPreviousKeys[component.key] = result.previousKey;
                markdownData = result.markdownData;
                processedComponentType = component.key;
                break; // Only process one component type per call
            }
        }
        currentLoadingKeys = newCurrentLoadingKeys;
        previousKeys = newPreviousKeys;
        return {
            processedText: processedText,
            markdownData: markdownData,
            processedComponentType: processedComponentType
        };
    };
};
const $1e446058f30c9027$export$87723f8a010c233f = (text, currentLoadingKey, previousKey, componentConfig)=>{
    const { startTag: startTag, endTag: endTag, placeholderTag: placeholderTag, key: key } = componentConfig;
    let newLoadingKey = currentLoadingKey;
    let newPreviousKey = previousKey;
    let markdownData = null;
    let processedText = text;
    let unprocessedText = '';
    if (typeof text === 'string') {
        // An empty endTag denotes an open-ended component (start tag, no end tag):
        // content is captured until the stream ends, so a close tag is never matched
        // mid-stream. `''.indexOf` returns 0, hence the explicit guard.
        const closeTagIndex = endTag === '' ? -1 : text.indexOf(endTag);
        if (closeTagIndex !== -1 && currentLoadingKey && currentLoadingKey.startsWith(`${key}-`)) {
            const contentBeforeCloseTag = text.substring(0, closeTagIndex);
            const contentAfterCloseTag = text.substring(closeTagIndex + endTag.length);
            processedText = '';
            unprocessedText = contentAfterCloseTag;
            markdownData = {
                key: currentLoadingKey,
                content: contentBeforeCloseTag,
                loading: false
            };
            newPreviousKey = currentLoadingKey;
            newLoadingKey = null;
        } else if (text.includes(startTag) && !currentLoadingKey) {
            const currentCount = previousKey == null ? -1 : parseInt(previousKey.substring(`${key}-`.length), 10);
            newLoadingKey = `${key}-${currentCount + 1}`;
            const openTagIndex = text.indexOf(startTag);
            const contentBeforeOpenTag = text.substring(0, openTagIndex);
            const contentAfterOpenTag = text.substring(openTagIndex + startTag.length);
            processedText = contentBeforeOpenTag + placeholderTag;
            unprocessedText = contentAfterOpenTag;
            markdownData = {
                key: newLoadingKey,
                content: '',
                loading: true
            };
            newPreviousKey = newLoadingKey;
        } else if (currentLoadingKey) {
            // Mid-stream branch: no boundary in this chunk; the whole text is
            // streamed content for the active component.
            processedText = '';
            unprocessedText = '';
            markdownData = {
                key: currentLoadingKey,
                content: text,
                loading: true
            };
            newPreviousKey = currentLoadingKey;
        }
    }
    return {
        processedText: processedText,
        unprocessedText: unprocessedText,
        currentLoadingKey: newLoadingKey,
        previousKey: newPreviousKey,
        markdownData: markdownData
    };
};
const $1e446058f30c9027$export$e234f678a7b6108d = (getComponents)=>{
    let currentLoadingKeys = {};
    let previousKeys = {};
    const processRecursive = (text, markdownData)=>{
        for (const component of getComponents()){
            if (!component.isEnabled) continue;
            const currentLoadingKey = currentLoadingKeys[component.key] ?? null;
            const prevKey = previousKeys[component.key] ?? null;
            const result = $1e446058f30c9027$export$87723f8a010c233f(text, currentLoadingKey, prevKey, component);
            if (!result.markdownData) continue;
            const { key: key, content: content, loading: loading } = result.markdownData;
            currentLoadingKeys[component.key] = result.currentLoadingKey;
            previousKeys[component.key] = result.previousKey;
            const existing = markdownData[key];
            markdownData[key] = {
                content: (existing?.content ?? '') + content,
                loading: loading
            };
            if (result.unprocessedText) {
                const inner = processRecursive(result.unprocessedText, markdownData);
                return {
                    ...inner,
                    processedText: result.processedText + inner.processedText
                };
            }
            return {
                processedText: result.processedText,
                markdownData: markdownData
            };
        }
        // No component matched — return text unchanged.
        return {
            processedText: text,
            markdownData: markdownData
        };
    };
    return (text)=>{
        return processRecursive(text, {});
    };
};
module.exports["extractMarkdownText"] = $1e446058f30c9027$export$1edc769cb607aa0f;
module.exports["createMarkdownProcessor"] = $1e446058f30c9027$export$1fc44797755f1907;
module.exports["createMarkdownProcessorMultiTags"] = $1e446058f30c9027$export$e234f678a7b6108d;

});

parcelRegister("8bsmP", function(module, exports) {

var $6Bfyn = parcelRequire("6Bfyn");


var $4vH8u = parcelRequire("4vH8u");


var $aXdbm = parcelRequire("aXdbm");


var $5XX4K = parcelRequire("5XX4K");


var $eK93A = parcelRequire("eK93A");

const $70aedeea0dcf1043$var$cloneStreamResponse = (message)=>({
        ...message,
        message: {
            ...message.message,
            message: {
                ...message.message.message
            }
        }
    });
const $70aedeea0dcf1043$export$45f48bc1dd3f22b5 = ({ message: message, options: options })=>{
    let processedMessage = $70aedeea0dcf1043$var$cloneStreamResponse(message);
    const markdownData = {};
    const extractionCounts = {
        actionableFollowUps: 0,
        dataSculptor: 0,
        expand: 0,
        inlineLumina: 0,
        legacyChart: 0,
        unicodeChart: 0
    };
    if (options.shouldPreprocessDetails) processedMessage = (0, $eK93A.preprocessStreamResponseDetails)(processedMessage);
    if (options.shouldExtractDataSculptor) {
        const sculptorMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedMessage,
            boundaryStart: '[^sculptor:start^]',
            boundaryEnd: '[^sculptor:end^]',
            replacementContent: '[^sculptor^]'
        });
        processedMessage = sculptorMsg.processedStreamMessage;
        sculptorMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`sculptor-${index}`] = content;
        });
        extractionCounts.dataSculptor = sculptorMsg.boundaryContents.length;
    }
    const expandOpenTag = "\u259E";
    const expandCloseTag = "\u259A";
    const expandPlaceholder = '[^expand^]';
    const expandMsg = (0, $5XX4K.extractMarkdownContent)({
        streamMessage: processedMessage,
        boundaryStart: expandOpenTag,
        boundaryEnd: expandCloseTag,
        replacementContent: expandPlaceholder
    });
    processedMessage = expandMsg.processedStreamMessage;
    expandMsg.boundaryContents.forEach((content, index)=>{
        markdownData[`expand-${index}`] = content;
    });
    extractionCounts.expand = expandMsg.boundaryContents.length;
    let chartIndex = 0;
    if (options.shouldExtractLegacyChartBoundaries) {
        const chartMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedMessage,
            boundaryStart: '[^chart:start^]',
            boundaryEnd: '[^chart:end^]',
            replacementContent: '[^chart^]'
        });
        processedMessage = chartMsg.processedStreamMessage;
        chartMsg.boundaryContents.forEach((content)=>{
            markdownData[`chart-${chartIndex}`] = content;
            chartIndex++;
        });
        extractionCounts.legacyChart = chartMsg.boundaryContents.length;
    }
    const unicodeChartMsg = (0, $5XX4K.extractMarkdownContent)({
        streamMessage: processedMessage,
        boundaryStart: "\u25F4",
        boundaryEnd: "\u25F6",
        replacementContent: '[^chart^]'
    });
    processedMessage = unicodeChartMsg.processedStreamMessage;
    unicodeChartMsg.boundaryContents.forEach((content)=>{
        markdownData[`chart-${chartIndex}`] = content;
        chartIndex++;
    });
    extractionCounts.unicodeChart = unicodeChartMsg.boundaryContents.length;
    if (options.shouldExtractInlineLumina) {
        const luminaMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedMessage,
            boundaryStart: "\u25D0",
            boundaryEnd: "\u25D1",
            replacementContent: '\n\n[^lumina^]\n\n'
        });
        processedMessage = luminaMsg.processedStreamMessage;
        luminaMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`lumina-${index}`] = content;
        });
        extractionCounts.inlineLumina = luminaMsg.boundaryContents.length;
    }
    if (options.shouldExtractActionableFollowUps) {
        const followUpsMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedMessage,
            boundaryStart: (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_MARKER),
            boundaryEnd: '',
            replacementContent: `\n\n[^${(0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY)}^]\n\n`
        });
        processedMessage = followUpsMsg.processedStreamMessage;
        followUpsMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`${0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY}-${index}`] = content;
        });
        extractionCounts.actionableFollowUps = followUpsMsg.boundaryContents.length;
    }
    let agenticUiMessages;
    if (options.shouldExtractA2UI) {
        const a2uiResult = (0, $aXdbm.extractA2UIFromStructuredContent)(processedMessage.message.message.content);
        if (a2uiResult) {
            processedMessage.message.message.content = a2uiResult.textContent;
            agenticUiMessages = a2uiResult.a2uiMessages;
        }
    }
    return {
        agenticUiMessages: agenticUiMessages,
        extractionCounts: extractionCounts,
        markdownData: markdownData,
        message: processedMessage
    };
};
module.exports["normalizeFinalizedMessagePresentation"] = $70aedeea0dcf1043$export$45f48bc1dd3f22b5;

});

parcelRegister("7eGGZ", function(module, exports) {
/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing chat-store actions gate feature behavior from runtime flags. */ 
var $iDrrr = parcelRequire("iDrrr");


var $irnO2 = parcelRequire("irnO2");


var $4m5jb = parcelRequire("4m5jb");


var $igOtY = parcelRequire("igOtY");


var $7H855 = parcelRequire("7H855");


var $idzM5 = parcelRequire("idzM5");


var $awqa1 = parcelRequire("awqa1");


var $l6xCb = parcelRequire("l6xCb");


var $9bLpG = parcelRequire("9bLpG");


var $f1ZpQ = parcelRequire("f1ZpQ");


var $1IZrU = parcelRequire("1IZrU");


var $hQJOO = parcelRequire("hQJOO");


var $eQl6Z = parcelRequire("eQl6Z");


var $c8Sl1 = parcelRequire("c8Sl1");




const $88107b54786dc500$export$bc2e4bcadf63b119 = ({ shouldUsePagination: shouldUsePagination, conversationChannelsResponse: conversationChannelsResponse })=>shouldUsePagination ? conversationChannelsResponse.hasNext : conversationChannelsResponse.items.length > (0, $awqa1.CONVERSATION_LIST_PAGE_SIZE);


const $7dc4b12cf023d92e$export$767e11ac0b9abe0b = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).fetchConversationChannelsData, ({ isInitialLoad: isInitialLoad = false, reconcileFirstPage: reconcileFirstPage = false } = {})=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, unifiedTasksActions: unifiedTasksActions })=>{
        // Visibility/delete reconciliation still runs in legacy mode, but paginated mode
        // skips it while the list is unmounted. Read that assignment without exposure
        // because this branch can bail before any measurable paginated work happens.
        const isUnmountedFirstPageReconciliation = reconcileFirstPage && !getState().conversationPagination.isConversationListMounted;
        if (isUnmountedFirstPageReconciliation && (0, $f1ZpQ.isConversationListPaginationEnabled)({
            fireExperimentExposure: false
        })) return;
        const shouldUsePagination = isUnmountedFirstPageReconciliation ? false : (0, $f1ZpQ.isConversationListPaginationEnabled)({
            fireExperimentExposure: false
        });
        // A concurrent load-more may be in flight; skip the first-page reconciliation
        // rather than stomping its cursor/hasMore metadata. Best-effort: the next
        // visibility event will reconcile correctly.
        if (shouldUsePagination && reconcileFirstPage && getState().conversationPagination.isLoadingMore) return;
        if (isInitialLoad) experienceTracker.start({
            id: (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD,
            name: (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD
        });
        else experienceTracker.start({
            id: (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS,
            name: (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS
        });
        // Capture conversation IDs before API call to detect changes during the call
        const conversationsBeforeAPICall = new Set(Object.keys(getState().conversations));
        let conversationChannelsResponse;
        try {
            conversationChannelsResponse = shouldUsePagination ? await assistanceService.getConversationChannels({
                limit: (0, $awqa1.CONVERSATION_LIST_PAGE_SIZE)
            }) : await assistanceService.getConversationChannels();
        } catch (error) {
            if (isInitialLoad && (0, $iDrrr.fg)('rovo_chat_non_blocking_conversation_history_failure')) setState({
                isConversationsInitialized: true,
                conversationPagination: {
                    ...getState().conversationPagination,
                    isLoadingMore: false,
                    loadMoreError: null
                }
            });
            throw error;
        }
        if ((0, $88107b54786dc500$export$bc2e4bcadf63b119)({
            shouldUsePagination: shouldUsePagination,
            conversationChannelsResponse: conversationChannelsResponse
        })) (0, $f1ZpQ.isConversationListPaginationEnabled)();
        const channelsFromAPI = conversationChannelsResponse.items;
        const { conversations: conversations, currentConversationId: currentConversationId } = getState();
        const channelIds = new Set(channelsFromAPI.map((channel)=>channel.id));
        // Identify conversations deleted during the API call (were there before but aren't now)
        const conversationsDeletedDuringCall = new Set(Array.from(conversationsBeforeAPICall).filter((id)=>!conversations[id] && !(0, $1IZrU.isEmptyConversation)(id)));
        // Identify conversations created during the API call (exist in state but weren't there before and aren't in API response)
        const conversationsCreatedDuringCall = new Set(Object.keys(conversations).filter((id)=>!conversationsBeforeAPICall.has(id) && !channelIds.has(id)));
        // Preserve all local conversations not yet on the server
        // (they may have just finished processing or be in-flight)
        // e.g. optimistic conversation when URL params are used to open a chat
        const optimisticConversationsToPreserve = new Set(Object.keys(conversations).filter((id)=>!channelIds.has(id) && !(0, $1IZrU.isEmptyConversation)(id)));
        const conversationIdsToPreserve = new Set([
            ...conversationsCreatedDuringCall,
            ...optimisticConversationsToPreserve
        ]);
        const conversationsToPreserve = Object.fromEntries(Array.from(conversationIdsToPreserve, (id)=>[
                id,
                conversations[id]
            ]));
        const processedChannels = (0, $9bLpG.getProcessedConversationChannels)({
            channelsFromAPI: channelsFromAPI,
            conversations: conversations,
            conversationsDeletedDuringCall: conversationsDeletedDuringCall
        });
        (0, $hQJOO.mergeConversationChannelTasks)(channelsFromAPI, unifiedTasksActions);
        // Hydrate the store with the fetched conversation channels
        // whilst preserving the empty state and and any conversations created during the API call, so drafts are never lost
        // due to rehydration (e.g window refocus) when this is called
        setState({
            conversations: {
                EMPTY_CONVERSATION_ID: conversations[0, $4m5jb.EMPTY_CONVERSATION_ID],
                ...processedChannels,
                ...conversationsToPreserve
            },
            isConversationsInitialized: true,
            conversationPagination: {
                ...getState().conversationPagination,
                nextCursor: shouldUsePagination ? conversationChannelsResponse.cursor : null,
                hasMore: shouldUsePagination ? conversationChannelsResponse.hasNext : false,
                isLoadingMore: false,
                loadMoreError: null
            }
        });
        const currentConversationDeleted = !(0, $1IZrU.isEmptyConversation)(currentConversationId) && !channelIds.has(currentConversationId) && !conversationIdsToPreserve.has(currentConversationId);
        if (currentConversationDeleted && !isInitialLoad) dispatch((0, $c8Sl1.setSelectedConversation)({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        }));
        const selectedConversationTasks = channelsFromAPI.find((channel)=>channel.id === currentConversationId)?.tasks ?? [];
        const shouldRestoreTaskMode = selectedConversationTasks.some((task)=>!(0, $igOtY.isTerminalTaskState)((0, $7H855.mapApiTaskStatusToProgressState)(task.status)));
        if (isInitialLoad && (0, $iDrrr.fg)('rovo_chat_enable_tasks') && shouldRestoreTaskMode) dispatch((0, $eQl6Z.restoreTaskModeIfNeeded)());
        experienceTracker.succeed({
            name: isInitialLoad ? (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS
        });
    }, {
    experienceName: (args)=>args?.[0]?.isInitialLoad ? (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS,
    actionErrorHandler: (context)=>{
        const { onError: onError, ...args } = context.args?.[0] ?? {};
        if (args.isInitialLoad) {
            if ((0, $iDrrr.fg)('rovo_chat_non_blocking_conversation_history_failure')) {
                context.containerProps.showFlag?.((0, $idzM5.StoreErrorFlagId).CONVERSATION_HISTORY_LOAD_FAILED);
                return undefined;
            }
            return {
                proceedToDefaultHandling: true
            };
        }
        return onError ? onError({
            ...context,
            args: args
        }) : {
            proceedToDefaultHandling: true
        };
    }
});
module.exports["fetchConversationChannelsData"] = $7dc4b12cf023d92e$export$767e11ac0b9abe0b;

});

parcelRegister("idzM5", function(module, exports) {
var $f43618a8171c9b35$export$33c7ec07de4be904 = /*#__PURE__*/ function(StoreErrorFlagId) {
    StoreErrorFlagId["CONVERSATION_FORBIDDEN"] = "conversationForbidden";
    StoreErrorFlagId["CONVERSATION_HISTORY_LOAD_FAILED"] = "conversationHistoryLoadFailed";
    StoreErrorFlagId["FOLLOW_UP_AGENT_UNAVAILABLE"] = "followUpAgentUnavailable";
    return StoreErrorFlagId;
}({});
module.exports["StoreErrorFlagId"] = $f43618a8171c9b35$export$33c7ec07de4be904;

});

parcelRegister("3Cuhs", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $2g97a = parcelRequire("2g97a");

const $14776b99fc344204$export$2813a13604911e2d = (messages)=>{
    try {
        const last = (0, $2g97a.findLast)(messages, (0, $igOtY.isStoreAssistant));
        return last?.content.message.message.id;
    } catch  {
        return undefined;
    }
};
module.exports["getLastAgentMessageID"] = $14776b99fc344204$export$2813a13604911e2d;

});

parcelRegister("2g97a", function(module, exports) {
// findLast polyfill since it's a newer ECMAScript feature.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findLast
// The type-guard overload lets callers narrow the result (e.g. to a specific
// StoreChatItem subtype) without an intermediate array allocation.
function $b4936b98e2cb53b7$export$296de88ccac4bedb(array, predicate) {
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i])) return array[i];
    }
    return undefined;
}
module.exports["findLast"] = $b4936b98e2cb53b7$export$296de88ccac4bedb;

});

parcelRegister("6xccU", function(module, exports) {
//list from https://hello.atlassian.net/wiki/spaces/rocx/pages/6474505700/Knowledge+Sources+list+connectors
const $ec1658c6c2772c29$var$products1PListKnowleage = [
    'Atlassian Support Docs',
    'Confluence Data Centre',
    'Jira Data Center'
];
// platform/packages/search/search-ai/src/ai-answer-dialog/analytics-helpers.tsx
// list from https://atlassian.slack.com/archives/C08VA0N40A2/p1749172242825969?thread_ts=1749088363.059769&cid=C08VA0N40A2
const $ec1658c6c2772c29$var$products1PList = new Set([
    'Assets',
    'Atlas',
    'Confluence',
    'Atlassian Analytics',
    'Atlassian Cloud',
    'Automation for Jira',
    'Bamboo',
    'Bitbucket',
    'Compass',
    'Goals',
    'Jira',
    'Jira Product Discovery',
    'Jira Service Management',
    'Jira Software',
    'Jira Work Management',
    'Jira Align',
    'Migration',
    'Loom',
    'Opsgenie',
    'Platform Experiences',
    'Projects',
    'Rovo',
    'Statuspage',
    'Trello',
    'webSearch',
    'web-page',
    'Fisheye and Crucible',
    'Crowd',
    'Sourcetree',
    'Unknown',
    'Focus',
    'file-upload',
    'Advanced Roadmaps For Jira',
    'Questions for Confluence',
    'csm',
    'Dewey Support',
    'Dewey JAC Support',
    'Help Aggregator',
    ...$ec1658c6c2772c29$var$products1PListKnowleage
]);
const $ec1658c6c2772c29$export$2777e093c10fa93d = (productName)=>!$ec1658c6c2772c29$var$products1PList.has(productName);
module.exports["is3pApp"] = $ec1658c6c2772c29$export$2777e093c10fa93d;

});

parcelRegister("4eyID", function(module, exports) {
const $5c37fa1bb8ea7f45$export$48acf215f1610b8e = (sources)=>{
    const connectorInfo = sources?.map((source)=>{
        const { ari: ari } = source;
        const { provider_id: provider_id, connector_product: connector_product, connector_type: connector_type, searchRetrievalType: searchRetrievalType, sourceProduct: sourceProduct } = source.connector_info ?? source.connectorInfo ?? {};
        if (!provider_id && !connector_product && !connector_type && !searchRetrievalType && !sourceProduct) return undefined;
        return {
            ...ari && {
                ari: ari
            },
            ...provider_id && {
                provider_id: provider_id
            },
            ...connector_product && {
                connector_product: connector_product
            },
            ...connector_type && {
                connector_type: connector_type
            },
            ...searchRetrievalType && {
                search_retrieval_type: searchRetrievalType
            },
            ...sourceProduct && {
                source_product: sourceProduct
            }
        };
    }).filter((value)=>Boolean(value));
    return connectorInfo?.length ? connectorInfo : undefined;
};
module.exports["extractConnectorInfo"] = $5c37fa1bb8ea7f45$export$48acf215f1610b8e;

});

parcelRegister("4BHwn", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $fjUOt = parcelRequire("fjUOt");

const $ed14f64875699056$export$64b557ae352795d6 = (chat, messageId)=>chat.findIndex((storeMessage)=>(0, $igOtY.isStoreMessage)(storeMessage) && (messageId ? (0, $fjUOt.getStoreMessageId)(storeMessage) === messageId : true));
module.exports["findStoreMessageIndex"] = $ed14f64875699056$export$64b557ae352795d6;

});

parcelRegister("foVqg", function(module, exports) {

var $2yWJZ = parcelRequire("2yWJZ");

const $fe75fa81a4258faa$var$normalizeString = (value)=>typeof value === 'string' && value.trim() ? value.trim() : undefined;
const $fe75fa81a4258faa$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $fe75fa81a4258faa$export$5e9f4827a7d04fed = (storeAssistant)=>{
    if (storeAssistant?.type !== 'ASSISTANT') return undefined;
    const message = storeAssistant?.content?.message?.message;
    if (!$fe75fa81a4258faa$var$isRecord(message) || message.role !== 'ASSISTANT') return undefined;
    const author = $fe75fa81a4258faa$var$isRecord(message.author) ? message.author : undefined;
    const canonicalAgentId = $fe75fa81a4258faa$var$normalizeString(author?.id);
    const identityAccountId = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)($fe75fa81a4258faa$var$normalizeString(author?.ari));
    if (!canonicalAgentId) return undefined;
    return {
        id: canonicalAgentId,
        ...identityAccountId ? {
            identityAccountId: identityAccountId
        } : {}
    };
};
module.exports["deriveFollowUpSendAgentIdentity"] = $fe75fa81a4258faa$export$5e9f4827a7d04fed;

});

parcelRegister("kNXXO", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $2g97a = parcelRequire("2g97a");

const $02966cdc09a260a9$export$24c718731d9a7b6a = (messages, predicate)=>{
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $igOtY.isStoreAssistant)(msg)) {
            const actionParts = msg.content.message?.message?.actions ?? [];
            const action = (0, $2g97a.findLast)(actionParts, predicate);
            if (action) return action;
        }
    }
    return undefined;
};
module.exports["findLastAssistantAction"] = $02966cdc09a260a9$export$24c718731d9a7b6a;

});

parcelRegister("dHz2q", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $gXfti = parcelRequire("gXfti");


var $dTEBe = parcelRequire("dTEBe");


var $6rwn6 = parcelRequire("6rwn6");


var $irnO2 = parcelRequire("irnO2");


var $4m5jb = parcelRequire("4m5jb");


var $igOtY = parcelRequire("igOtY");


var $oV0CU = parcelRequire("oV0CU");

const $40c25f53fe39b33d$export$1afac255ab1e880e = ()=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const lastMessageSentAt = localStorage.getItem((0, $oV0CU.LS_LAST_MESSAGE_SENT_AT));
    if (!lastMessageSentAt) return null;
    const timestamp = parseInt(lastMessageSentAt);
    if (isNaN(timestamp)) return null;
    return timestamp;
};



var $b2pOf = parcelRequire("b2pOf");


var $djNSU = parcelRequire("djNSU");


var $l6xCb = parcelRequire("l6xCb");




const $7b5c7e5fb885c250$export$69a500a38d2b93ab = ()=>{
    return 0, $oV0CU.SHORTER_TIMEOUT_BEFORE_NEW_CHAT;
};



var $1IZrU = parcelRequire("1IZrU");




const $fc5e957f3a72b1d1$export$b77ba8e4ec693266 = (jsonString)=>{
    try {
        const parsed = JSON.parse(jsonString);
        if ((0, $6rwn6.isAdfContent)(parsed)) return true;
        return false;
    } catch  {
        return false;
    }
};



var $58Xbw = parcelRequire("58Xbw");


var $ffjMi = parcelRequire("ffjMi");


var $6geN3 = parcelRequire("6geN3");


var $c8Sl1 = parcelRequire("c8Sl1");




const $c390b46d98b6474a$export$1b532e69dded7033 = (hasConsumedPreserveIntent, currentConversationId, inMemoryConversation)=>{
    if (!hasConsumedPreserveIntent || !currentConversationId || currentConversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID)) return false;
    return Boolean(inMemoryConversation);
};





const $e2f5ab4cfced7f8a$export$cb6ccc30d1a390cc = (currentConversationId, inMemoryConversation)=>{
    if (!currentConversationId || currentConversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID)) return false;
    return Boolean(inMemoryConversation?.rovoSpaceId);
};


const $359ad6370a73004a$export$f8c82f179628191f = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).hydrateConversation, ({ autoSelectConversation: autoSelectConversation })=>async ({ getState: getState, dispatch: dispatch }, { siteId: siteId, experienceTracker: experienceTracker, setChatStatus: setChatStatus, initChatInitiator: initChatInitiator, insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder, setStagingAreaMode: setStagingAreaMode, setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, getStoreUserMessagesPreference: getStoreUserMessagesPreference })=>{
        const hasConsumedModeSwitchPreserveIntent = (0, $58Xbw.modeSwitchConversationPreservation).consume();
        const shouldConsiderModeSwitchPreservation = (0, $iDrrr.fg)('rovo_chat_preserve_conversation_on_mode_switch') && hasConsumedModeSwitchPreserveIntent;
        experienceTracker.start({
            id: (0, $irnO2.ExperienceName).HYDRATE_CONVERSATION,
            name: (0, $irnO2.ExperienceName).HYDRATE_CONVERSATION
        });
        const rovoParamsUnsanitized = (0, $dTEBe.getRovoParams)();
        const rovoParams = Object.fromEntries(Object.entries(rovoParamsUnsanitized).filter(([, v])=>v !== 'undefined'));
        let initWithParams = autoSelectConversation && rovoParams.pathway === 'chat';
        const { currentConversationId: currentConversationId } = getState();
        if (rovoParams.stagingAreaOpen && (0, $iDrrr.fg)('aifc_create_enabled')) {
            setStagingAreaMode('inline', 'rovoChat');
            (0, $dTEBe.updatePageRovoParams)({
                stagingAreaOpen: undefined
            });
        }
        if (rovoParams.messageIdSelectedForPreview && (0, $iDrrr.fg)('aifc_create_enabled')) {
            setMessageIdSelectedForPreview(rovoParams.messageIdSelectedForPreview);
            (0, $dTEBe.updatePageRovoParams)({
                messageIdSelectedForPreview: undefined
            });
            // Start experience on Home side — the originating tab (e.g. Bitbucket) can't track it cross-tab.
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).PREVIEW_CONTENT,
                id: rovoParams.messageIdSelectedForPreview,
                timeout: 30000,
                attributes: {
                    source: 'hydrateConversationWithExternalParams'
                }
            });
        }
        if (rovoParams.triggerOpen) // if the rovo chat was actually open with url param
        initChatInitiator(rovoParams.initiator);
        // Process params as a priority
        if (initWithParams) {
            if (rovoParams.prompt) // URL prompts are one-shot inputs. Remove the prompt before selecting,
            // creating, or sending so any Appification remount reads a URL with no
            // prompt left to replay.
            (0, $dTEBe.updatePageRovoParams)({
                prompt: undefined,
                insertPrompt: undefined
            });
            const localConversation = rovoParams.conversationId ? getState().conversations[rovoParams.conversationId] : undefined;
            if (rovoParams.conversationId && localConversation) {
                dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: rovoParams.conversationId,
                    sourceAgentId: rovoParams.agentId
                }));
                // Clear conversationId from URL after consuming it so subsequent chat opens
                // don't reuse it and get stuck in the same conversation.
                (0, $dTEBe.updatePageRovoParams)({
                    conversationId: undefined
                });
            } else dispatch((0, $djNSU.createConversationOptimistically)({
                id: rovoParams.conversationId,
                sourceAgentId: rovoParams.agentId
            }));
            if (rovoParams.prompt) {
                // For cases where the prompt is a json string containing ADF, we need to parse it
                const shouldParse = (0, $fc5e957f3a72b1d1$export$b77ba8e4ec693266)(rovoParams.prompt);
                const prompt = shouldParse ? JSON.parse(rovoParams.prompt) : rovoParams.prompt;
                const urlPromptProvenance = (0, $iDrrr.fg)('rovo_chat_prompt_url_warning') ? {
                    source: 'url-param',
                    conversationId: getState().currentConversationId
                } : undefined;
                if (rovoParams.insertPrompt === 'highlight-action') insertHighlightActionsEditorPlaceholder(prompt, urlPromptProvenance);
                else if ((0, $iDrrr.fg)('rovo_chat_disable_url_prompt_auto_send')) // Security (VULN-1804729): never auto-send a prompt supplied via the
                // `rovoChatPrompt` URL query param. A crafted link could otherwise inject
                // and one-click execute an arbitrary prompt as the signed-in user
                // (prompt injection / data exfiltration). Instead, pre-fill the prompt
                // into the chat input as an editable draft so the user must explicitly
                // review and send it, keeping a human in the loop.
                insertHighlightActionsEditorPlaceholder((0, $6rwn6.encodeAdf)(prompt, false, undefined, true), {
                    skipPlaceholderPrompt: true,
                    ...urlPromptProvenance
                });
                else dispatch((0, $ffjMi.sendMessage)({
                    prompt: (0, $6rwn6.encodeAdf)(prompt, false, undefined, true),
                    agentId: rovoParams.agentId,
                    // Use the user's preference for storing messages
                    // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                    // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                    storeUserMessages: getStoreUserMessagesPreference?.() ?? false,
                    messageSources: {
                        interactionSource: 'urlParam'
                    }
                }));
            }
            // for UFO performance tracking dimensions
            (0, $gXfti.addUFOCustomData)({
                isEmptyConversation: !rovoParams.conversationId,
                hasInitialPrompt: !!rovoParams.prompt
            });
        } else if (autoSelectConversation) {
            if ((0, $c390b46d98b6474a$export$1b532e69dded7033)(shouldConsiderModeSwitchPreservation, currentConversationId, getState().conversations[currentConversationId ?? ''])) {
                // Scope the refetch-skip to exactly this mode-switch remount rather than
                // broadly skipping refetches on every mount: flag the preserved
                // conversation so the imminent ChatHistory getChat() is a one-shot no-op,
                // which avoids blanking the already-loaded messages and flashing the
                // "Reloading chat" spinner. `skipNextFetch` is consumed (reset to false)
                // by the very next fetchConversation, so it cannot suppress later,
                // legitimate fetches. `currentConversationId` is guaranteed non-empty here
                // by shouldPreserveConversationOnModeSwitch; the guard is just for TS.
                if (currentConversationId) dispatch((0, $6geN3.setConversationData)({
                    conversationId: currentConversationId,
                    data: {
                        skipNextFetch: true
                    }
                }));
                (0, $gXfti.addUFOCustomData)({
                    isEmptyConversation: false
                });
                setChatStatus('online');
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).HYDRATE_CONVERSATION
                });
                return;
            }
            const timeoutBeforeNewChat = (0, $7b5c7e5fb885c250$export$69a500a38d2b93ab)();
            const isAssociationRestorationEnabled = (0, $b2pOf.isPersistedConversationRestorationEnabled)();
            // HOT-303866: a since-reverted change stored a stringified JSON object under
            // this key instead of a plain conversation ID. If we detect that corrupt object
            // shape, self-heal by overwriting the key and start a new conversation.
            const getSafeStoredConversationId = ()=>{
                const raw = (0, $b2pOf.getPersistedRecentConversationId)(siteId);
                if (!raw) return 0, $4m5jb.EMPTY_CONVERSATION_ID;
                let isCorruptObject = false;
                try {
                    const parsed = JSON.parse(raw);
                    isCorruptObject = typeof parsed === 'object' && parsed !== null;
                } catch  {
                // Not JSON — a plain conversation ID string, use it as-is.
                }
                if (isCorruptObject) {
                    (0, $b2pOf.persistRecentConversation)({
                        type: 'conversation-selected',
                        siteId: siteId,
                        conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
                    });
                    return 0, $4m5jb.EMPTY_CONVERSATION_ID;
                }
                return raw;
            };
            const targetConversationId = (0, $iDrrr.fg)('rovo_chat_safe_conversation_id_from_ls') || isAssociationRestorationEnabled ? getSafeStoredConversationId() : (0, $b2pOf.getPersistedRecentConversationId)(siteId) ?? (0, $4m5jb.EMPTY_CONVERSATION_ID);
            // Preserve in-memory space chat across container remount.
            // See `shouldPreserveSpaceChatOnHydrate` for full rationale.
            if ((0, $e2f5ab4cfced7f8a$export$cb6ccc30d1a390cc)(currentConversationId, getState().conversations[currentConversationId ?? ''])) {
                (0, $gXfti.addUFOCustomData)({
                    isEmptyConversation: false
                });
                setChatStatus('online');
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).HYDRATE_CONVERSATION
                });
                return;
            }
            const hasTargetChanged = targetConversationId !== currentConversationId;
            const isTargetConversationEmpty = (0, $1IZrU.isEmptyConversation)(targetConversationId);
            const hasLocalTargetConversation = Boolean(getState().conversations[targetConversationId]);
            if (isAssociationRestorationEnabled) {
                const isTargetRestorable = (0, $b2pOf.isPersistedConversationActivityRestorable)({
                    selectedConversationId: targetConversationId,
                    activity: (0, $b2pOf.getPersistedConversationActivity)(siteId),
                    now: Date.now(),
                    timeout: timeoutBeforeNewChat
                });
                if (!isTargetRestorable) dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
                }));
                else if (hasTargetChanged && hasLocalTargetConversation) dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: targetConversationId
                }));
                else if (hasTargetChanged) dispatch((0, $djNSU.createConversationOptimistically)({
                    id: targetConversationId
                }));
                (0, $gXfti.addUFOCustomData)({
                    isEmptyConversation: !isTargetRestorable
                });
            } else {
                const lastMessageSentAt = (0, $40c25f53fe39b33d$export$1afac255ab1e880e)();
                const isTargetExpired = lastMessageSentAt && Date.now() - lastMessageSentAt >= timeoutBeforeNewChat;
                // start new conversation: if recent expired
                if (isTargetExpired) dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                    clearLegacyLastMessageSentAt: true
                }));
                else if (hasTargetChanged && isTargetConversationEmpty) dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
                }));
                else if (hasTargetChanged && hasLocalTargetConversation) dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: targetConversationId
                }));
                else if (hasTargetChanged) dispatch((0, $djNSU.createConversationOptimistically)({
                    id: targetConversationId
                }));
                // for UFO performance tracking dimensions
                (0, $gXfti.addUFOCustomData)({
                    isEmptyConversation: !isTargetExpired && hasTargetChanged
                });
            }
        }
        // Set online status later, to ensure that pubsub listener doesn't race condition with store init state
        setChatStatus('online');
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).HYDRATE_CONVERSATION
        });
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).HYDRATE_CONVERSATION
});
module.exports["hydrateConversationWithExternalParams"] = $359ad6370a73004a$export$f8c82f179628191f;

});

parcelRegister("58Xbw", function(module, exports) {
let $eb5776e63adf4bb5$var$preserveConversationOnNextHydrate = false;
const $eb5776e63adf4bb5$export$aaf1586aa3f2b604 = {
    mark: ()=>{
        $eb5776e63adf4bb5$var$preserveConversationOnNextHydrate = true;
    },
    consume: ()=>{
        const shouldPreserve = $eb5776e63adf4bb5$var$preserveConversationOnNextHydrate;
        $eb5776e63adf4bb5$var$preserveConversationOnNextHydrate = false;
        return shouldPreserve;
    },
    clear: ()=>{
        $eb5776e63adf4bb5$var$preserveConversationOnNextHydrate = false;
    }
};
module.exports["modeSwitchConversationPreservation"] = $eb5776e63adf4bb5$export$aaf1586aa3f2b604;

});

parcelRegister("lUXDc", function(module, exports) {

var $dw75i = parcelRequire("dw75i");


var $igOtY = parcelRequire("igOtY");


var $aYC8J = parcelRequire("aYC8J");

const $f883fc6caf827ec4$var$getActions = (message)=>message.content?.message?.message?.actions ?? [];
const $f883fc6caf827ec4$var$isConfluenceCreateAction = (action)=>(0, $aYC8J.isConfluenceCreatableAction)({
        key: action.key
    });
const $f883fc6caf827ec4$var$isConfluenceEditAction = (action)=>(0, $aYC8J.isConfluenceUpdatableAction)({
        key: action.key
    });
const $f883fc6caf827ec4$var$getActionContentId = (action)=>{
    const data = action.data;
    const contentId = data?.contentId ?? data?.metadata?.contentId;
    return contentId === undefined ? undefined : String(contentId);
};
const $f883fc6caf827ec4$var$getPreviousAssistantActions = (messages, beforeIndex)=>{
    for(let i = beforeIndex - 1; i >= 0; i--){
        const message = messages[i];
        if (!(0, $igOtY.isStoreAssistant)(message)) continue;
        const actions = $f883fc6caf827ec4$var$getActions(message);
        if (actions.length) return actions;
    }
    return [];
};
const $f883fc6caf827ec4$var$getCreateMessageIndexByContentId = (messages, contentId)=>{
    for(let i = messages.length - 1; i >= 0; i--){
        const message = messages[i];
        if (!(0, $igOtY.isStoreAssistant)(message)) continue;
        const selectedAction = $f883fc6caf827ec4$var$getActions(message)[0];
        if (selectedAction && $f883fc6caf827ec4$var$isConfluenceCreateAction(selectedAction) && $f883fc6caf827ec4$var$getActionContentId(selectedAction) === contentId) return i;
    }
    return -1;
};
const $f883fc6caf827ec4$var$hasAskQuestionBeforeMessageAtIndex = (messages, messageIndex)=>$f883fc6caf827ec4$var$getPreviousAssistantActions(messages, messageIndex).some((action)=>action.key === (0, $dw75i.ASK_QUESTION_KEY));
const $f883fc6caf827ec4$var$wasDisambiguationUsedOnCreation = (messages, contentId)=>{
    const selectedIndex = $f883fc6caf827ec4$var$getCreateMessageIndexByContentId(messages, contentId);
    if (selectedIndex < 0) return false;
    return $f883fc6caf827ec4$var$hasAskQuestionBeforeMessageAtIndex(messages, selectedIndex);
};
const $f883fc6caf827ec4$var$wasDisambiguationUsedOnEdit = (messages, contentId)=>{
    return messages.some((message, index)=>{
        if (!(0, $igOtY.isStoreAssistant)(message)) return false;
        const actions = $f883fc6caf827ec4$var$getActions(message);
        const hasMatchingEdit = actions.some((action)=>$f883fc6caf827ec4$var$isConfluenceEditAction(action) && $f883fc6caf827ec4$var$getActionContentId(action) === contentId);
        return hasMatchingEdit && $f883fc6caf827ec4$var$hasAskQuestionBeforeMessageAtIndex(messages, index);
    });
};
function $f883fc6caf827ec4$export$af0b9b8df489c05d({ messages: messages, contentId: contentId }) {
    if (!contentId) return {
        disambiguationUsedOnCreation: false,
        disambiguationUsedOnEdit: false
    };
    return {
        disambiguationUsedOnCreation: $f883fc6caf827ec4$var$wasDisambiguationUsedOnCreation(messages, contentId),
        disambiguationUsedOnEdit: $f883fc6caf827ec4$var$wasDisambiguationUsedOnEdit(messages, contentId)
    };
}
module.exports["getConfluenceResultAcceptanceAttributesForAskQuestion"] = $f883fc6caf827ec4$export$af0b9b8df489c05d;

});

parcelRegister("9vNm5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");

/**
 * States that end the run's turn. Once a record reaches one, later emits on the same conversation are
 * ignored so a trailing backend event can't revive it. `needs-input` is excluded: the run pauses for
 * the user and resumes on the same conversation, so a follow-up state must still apply.
 */ const $a9d5e82290950109$var$TURN_END_STATES = new Set([
    'done',
    'failed',
    'blocked'
]);
/**
 * States where a turn is in flight. A run left in one of these when its stream ends (abort, timeout,
 * dropped request) never settled and should be cleared. `needs-input` is a valid resting state, so
 * it is not here.
 */ const $a9d5e82290950109$var$ACTIVE_STATES = new Set([
    'thinking',
    'working',
    'editing'
]);
const $a9d5e82290950109$var$store = (0, $8s9DV.createStore)({
    name: 'agentMentionRunState',
    initialState: {
        runByConversationId: {}
    },
    actions: {
        setRun: (conversationId, record)=>({ setState: setState, getState: getState })=>{
                setState({
                    runByConversationId: {
                        ...getState().runByConversationId,
                        [conversationId]: record
                    }
                });
            },
        clearRun: (conversationId)=>({ setState: setState, getState: getState })=>{
                const next = {
                    ...getState().runByConversationId
                };
                delete next[conversationId];
                setState({
                    runByConversationId: next
                });
            }
    }
});
const $a9d5e82290950109$var$getRun = (conversationId)=>(0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).storeState.getState().runByConversationId[conversationId];
const $a9d5e82290950109$var$applyRun = (conversationId, record)=>{
    (0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).actions.setRun(conversationId, record);
};
const $a9d5e82290950109$export$942c558e1f0d1197 = (conversationId, localId)=>{
    if (!conversationId || !localId) return;
    const runs = (0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).storeState.getState().runByConversationId;
    Object.keys(runs).forEach((priorConversationId)=>{
        if (priorConversationId !== conversationId && runs[priorConversationId].invokedByNodeLocalId === localId) (0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).actions.clearRun(priorConversationId);
    });
    $a9d5e82290950109$var$applyRun(conversationId, {
        state: 'working',
        invokedByNodeLocalId: localId
    });
};
const $a9d5e82290950109$export$26a3487b4a5c9ed7 = (conversationId, runState)=>{
    const current = $a9d5e82290950109$var$getRun(conversationId);
    if (!current || $a9d5e82290950109$var$TURN_END_STATES.has(current.state)) return;
    if (current.state === runState) // Same state re-emitted (the stream reports e.g. `working`/`editing` more than once) — nothing
    // changed, so skip the write
    return;
    $a9d5e82290950109$var$applyRun(conversationId, {
        ...current,
        state: runState
    });
};
const $a9d5e82290950109$export$b1e88479c5d1c49d = (conversationId)=>{
    if (!conversationId) return;
    (0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).actions.clearRun(conversationId);
};
const $a9d5e82290950109$export$8feb5c3fccc062d8 = (conversationId)=>{
    const current = $a9d5e82290950109$var$getRun(conversationId);
    if (current && $a9d5e82290950109$var$ACTIVE_STATES.has(current.state)) (0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).actions.clearRun(conversationId);
};
// Some invocation paths insert the prompt as a draft, so the user sends it manually and the invoking
// node localId can't ride the send call. Stash it when the chat is opened; the send action consumes
// it when the run actually starts.
let $a9d5e82290950109$var$pendingInvocationLocalId = null;
const $a9d5e82290950109$export$6e28f2eaa4376143 = (localId)=>{
    $a9d5e82290950109$var$pendingInvocationLocalId = localId || null;
};
const $a9d5e82290950109$export$77f394cf411f3457 = ()=>{
    const localId = $a9d5e82290950109$var$pendingInvocationLocalId;
    $a9d5e82290950109$var$pendingInvocationLocalId = null;
    return localId;
};
// Wrapped in explicitly-typed functions so the public API satisfies --isolatedDeclarations.
const $a9d5e82290950109$var$useRunsInternal = (0, $kBr4q.createStateHook)($a9d5e82290950109$var$store, {
    selector: (state)=>state.runByConversationId
});
const $a9d5e82290950109$var$useRunStateForConversationInternal = (0, $kBr4q.createStateHook)($a9d5e82290950109$var$store, {
    selector: (state, conversationId)=>state.runByConversationId[conversationId]?.state
});
const $a9d5e82290950109$var$useRunStateForNodeInternal = (0, $kBr4q.createStateHook)($a9d5e82290950109$var$store, {
    selector: (state, localId)=>Object.values(state.runByConversationId).find((r)=>r.invokedByNodeLocalId === localId)?.state
});
const $a9d5e82290950109$export$287e00800c881bcb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $a9d5e82290950109$var$useRunsInternal();
} : ()=>$a9d5e82290950109$var$useRunsInternal();
const $a9d5e82290950109$export$64d7c3f05a87cb99 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (conversationId)=>{
    return $a9d5e82290950109$var$useRunStateForConversationInternal(conversationId);
} : (conversationId)=>$a9d5e82290950109$var$useRunStateForConversationInternal(conversationId);
const $a9d5e82290950109$export$160dcbab0bbffcf5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (localId)=>{
    return $a9d5e82290950109$var$useRunStateForNodeInternal(localId);
} : (localId)=>$a9d5e82290950109$var$useRunStateForNodeInternal(localId);
module.exports["beginAgentRun"] = $a9d5e82290950109$export$942c558e1f0d1197;
module.exports["notifyAgentRunStateForConversation"] = $a9d5e82290950109$export$26a3487b4a5c9ed7;
module.exports["endActiveAgentRun"] = $a9d5e82290950109$export$8feb5c3fccc062d8;
module.exports["stashAgentRunInvocation"] = $a9d5e82290950109$export$6e28f2eaa4376143;
module.exports["consumeAgentRunInvocation"] = $a9d5e82290950109$export$77f394cf411f3457;
module.exports["useAgentRuns"] = $a9d5e82290950109$export$287e00800c881bcb;

});

parcelRegister("7cSoR", function(module, exports) {
const $0b9759dec9b305d8$var$HARD_COOLDOWN_MS = 2592000000;
const $0b9759dec9b305d8$var$SOFT_COOLDOWN_MS = 604800000;
const $0b9759dec9b305d8$export$5aaadd2e417f4743 = (data)=>{
    const now = Date.now();
    if (data.lastInteractedAt && now - data.lastInteractedAt < $0b9759dec9b305d8$var$HARD_COOLDOWN_MS) return true;
    if (data.lastShownAt && now - data.lastShownAt < $0b9759dec9b305d8$var$SOFT_COOLDOWN_MS) return true;
    return false;
};
module.exports["isInCooldown"] = $0b9759dec9b305d8$export$5aaadd2e417f4743;

});

parcelRegister("1iIcq", function(module, exports) {
// Minimum number of qualifying new conversations (after any cooldown ends)
// before the CSAT survey becomes eligible to show.
const $6cb65bfda955433a$export$2e112147d8be0194 = 3;
module.exports["MIN_QUALIFYING_CONVERSATIONS"] = $6cb65bfda955433a$export$2e112147d8be0194;

});

parcelRegister("8cKM4", function(module, exports) {

var $7dBf8 = parcelRequire("7dBf8");


var $6sUl4 = parcelRequire("6sUl4");

const $e102cce557cd98e4$var$DEFAULTS = {
    lastShownAt: 0,
    lastInteractedAt: 0,
    qualifyingConversations: 0
};
const $e102cce557cd98e4$var$isPlainObject = (value)=>{
    return typeof value === 'object' && value !== null && !Array.isArray(value);
};
const $e102cce557cd98e4$var$isCsatEligibilityData = (value)=>{
    return $e102cce557cd98e4$var$isPlainObject(value) && typeof value.lastShownAt === 'number' && typeof value.lastInteractedAt === 'number' && typeof value.qualifyingConversations === 'number';
};
const $e102cce557cd98e4$export$cb9c82dc91ab7587 = ()=>{
    try {
        const raw = (0, $7dBf8.AtlBrowserStorageLocal).getItem((0, $6sUl4.STORAGE_KEY));
        if (raw) {
            const parsed = JSON.parse(raw);
            if ($e102cce557cd98e4$var$isCsatEligibilityData(parsed)) return parsed;
        }
    } catch  {
    // Storage unavailable or JSON corrupt — fall through to defaults.
    }
    return $e102cce557cd98e4$var$DEFAULTS;
};
module.exports["readFromStorage"] = $e102cce557cd98e4$export$cb9c82dc91ab7587;

});

parcelRegister("714Yd", function(module, exports) {

var $7dBf8 = parcelRequire("7dBf8");


var $6sUl4 = parcelRequire("6sUl4");

const $69289527408bdf70$export$f8d2a9e770514970 = (data)=>{
    try {
        (0, $7dBf8.AtlBrowserStorageLocal).setItem((0, $6sUl4.STORAGE_KEY), JSON.stringify(data));
    } catch  {
    // Best-effort: storage might be denied (no consent) or full.
    }
};
module.exports["writeToStorage"] = $69289527408bdf70$export$f8d2a9e770514970;

});

parcelRegister("6iQ4q", function(module, exports) {
const $1264174a0720175f$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC',
    actor_type: 'AGENT',
    user_defined_conversation_starters: [],
    favourite: false,
    deactivated: false
};
module.exports["DEFAULT_AGENT"] = $1264174a0720175f$export$48783720d93c2d26;

});

parcelRegister("jb3zd", function(module, exports) {
/**
 * Enum representing the different lifecycle states of a message stream.
 */ var $d434bd349610b667$export$680ab500cb1105eb = /*#__PURE__*/ function(StreamLifecycleState) {
    StreamLifecycleState["SEND_CONTEXT_READY"] = "send-context-ready";
    StreamLifecycleState["COMPLETED"] = "completed";
    StreamLifecycleState["ERRORED"] = "errored";
    StreamLifecycleState["ABORTED"] = "aborted";
    return StreamLifecycleState;
}({});
module.exports["StreamLifecycleState"] = $d434bd349610b667$export$680ab500cb1105eb;

});

parcelRegister("5odSY", function(module, exports) {
function $d2af83c72660dee3$export$2e053248db1c2516({ sourceMode: sourceMode, spaceId: spaceId }) {
    return spaceId ? sourceMode : undefined;
}
module.exports["getSpaceScopedSourceMode"] = $d2af83c72660dee3$export$2e053248db1c2516;

});

parcelRegister("9qJ1N", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");

/**
 * Tasks SSE Connection Manager
 *
 * A plain TS module (no React, no store) that manages a single shared SSE connection
 * to the Tasks stream endpoint (`GET /rovo/v1/tasks/stream`).
 *
 * Key design properties:
 * - **Single connection**: only one SSE connection is open at a time, regardless of
 *   how many consumers are subscribed.
 * - **Reference-counted**: connection opens when the first subscriber arrives,
 *   closes when the last subscriber leaves.
 * - **Tab-visibility aware**: connection is dropped when the tab becomes hidden and
 *   re-established when the tab becomes visible again. This is fully managed here,
 *   not by any React component.
 * - **Decoupled from React lifecycle**: module-level state survives component
 *   mount/unmount cycles.
 * - **External trigger support**: can subscribe
 *  by providing `getService` explicitly — no component mounting required.
 */ 
var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $hlvTd = parcelRequire("hlvTd");


var $bxkJA = parcelRequire("bxkJA");

// ─── Module-level state (singleton) ──────────────────────────────────────────
/** Active SSE fetch abort controller. Null when disconnected. */ let $3931780bbccb0af6$var$abortController = null;
/** The AssistanceService instance used for the current (or next) connection. */ let $3931780bbccb0af6$var$serviceRef = null;
/** All active subscribers. Connection is open iff this Set is non-empty. */ const $3931780bbccb0af6$var$subscribers = new Set();
/** Cleanup function for the visibilitychange listener. Null when unbound. */ let $3931780bbccb0af6$var$visibilityUnbind = null;
// ─── Internal helpers ─────────────────────────────────────────────────────────
/**
 * Opens the SSE connection using the stored `serviceRef`.
 * Fans out each incoming event to all current subscribers.
 * Safe to call if a connection is already open (no-op guard via abortController).
 */ async function $3931780bbccb0af6$var$openConnection() {
    if (!$3931780bbccb0af6$var$serviceRef) return;
    // Prevent duplicate connections
    if ($3931780bbccb0af6$var$abortController) return;
    $3931780bbccb0af6$var$abortController = new AbortController();
    const localAbort = $3931780bbccb0af6$var$abortController;
    try {
        const { generator: generator } = await $3931780bbccb0af6$var$serviceRef.getTasksStream(localAbort);
        for await (const message of generator){
            // Bail out if connection was closed while we were iterating
            if (localAbort.signal.aborted) break;
            // The SSE stream yields ParsedSSEMessage<ApiTaskSSEUpdate> wrappers.
            // The event_type is carried in the SSE `event:` envelope line → message.eventType.
            if (!(0, $bxkJA.isSSEMessage)(message)) continue;
            const event = message.data;
            const eventType = message.eventType ?? 'task_status';
            if (event) $3931780bbccb0af6$var$subscribers.forEach((listener)=>listener(event, eventType));
        }
    } catch (error) {
        // AbortError is expected on intentional disconnect — swallow it silently
        if (error instanceof DOMException && error.name === 'AbortError') return;
        // Report unexpected errors to Sentry. We deliberately do NOT re-throw:
        // `openConnection` is invoked via `void openConnection()` at every call
        // site, so a thrown error would surface as an unhandled promise rejection
        // — which can crash strict hosts and would otherwise tear down the chat
        // session for what is only a side-channel failure.
        (0, $hlvTd.logException)({
            name: 'rovoTasksSSEConnection',
            exception: error
        });
    } finally{
        // Ensure controller is cleared once the loop exits for any reason
        if ($3931780bbccb0af6$var$abortController === localAbort) $3931780bbccb0af6$var$abortController = null;
    }
}
/**
 * Aborts the current SSE connection.
 * Safe to call when already disconnected.
 */ function $3931780bbccb0af6$var$closeConnection() {
    if ($3931780bbccb0af6$var$abortController) {
        $3931780bbccb0af6$var$abortController.abort();
        $3931780bbccb0af6$var$abortController = null;
    }
}
/**
 * Binds a `visibilitychange` listener on the document.
 * - Tab hidden  → close connection
 * - Tab visible → re-open connection (reuses stored serviceRef)
 *
 * Binding is done once per subscriber session (first subscriber triggers it).
 */ function $3931780bbccb0af6$var$bindVisibility() {
    if ($3931780bbccb0af6$var$visibilityUnbind) // Already bound — nothing to do
    return;
    const doc = (0, $1hQ0e.getDocument)();
    if (!doc) return;
    $3931780bbccb0af6$var$visibilityUnbind = (0, $cbY7C.bind)(doc, {
        type: 'visibilitychange',
        listener: ()=>{
            if (doc.hidden) $3931780bbccb0af6$var$closeConnection();
            else // Re-open connection when tab becomes visible again
            $3931780bbccb0af6$var$openConnection();
        }
    });
}
/**
 * Removes the `visibilitychange` listener.
 * Called when the last subscriber unsubscribes.
 */ function $3931780bbccb0af6$var$unbindVisibility() {
    $3931780bbccb0af6$var$visibilityUnbind?.();
    $3931780bbccb0af6$var$visibilityUnbind = null;
}
function $3931780bbccb0af6$export$285816b4ea71cce1(getService, onEvent) {
    $3931780bbccb0af6$var$subscribers.add(onEvent);
    if ($3931780bbccb0af6$var$subscribers.size === 1) {
        // First subscriber — resolve service, open connection, bind visibility
        $3931780bbccb0af6$var$serviceRef = getService();
        $3931780bbccb0af6$var$bindVisibility();
        // Only open connection if tab is currently visible
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc || !doc.hidden) $3931780bbccb0af6$var$openConnection();
    }
    return function unsubscribe() {
        $3931780bbccb0af6$var$subscribers.delete(onEvent);
        if ($3931780bbccb0af6$var$subscribers.size === 0) {
            // Last subscriber left — tear everything down
            $3931780bbccb0af6$var$closeConnection();
            $3931780bbccb0af6$var$unbindVisibility();
            $3931780bbccb0af6$var$serviceRef = null;
        }
    };
}



var $7H855 = parcelRequire("7H855");

/**
 * Task notices: subscribers subscribe to notices about task status.
 *
 * A notice is raised when a task reaches a state worth telling the user about. Every consumer —
 * inbox list, menu badge, notifications — derives from this selector, so they cannot disagree.
 * Notices are derived state, not delivered events: they appear, disappear when the task moves on,
 * and can be raised again later.
 */ /** The single place that decides whether a task status warrants a notice. */ const $094743d67f51b17f$var$NOTICE_REASON_BY_PROGRESS_STATE = {
    AwaitingDisambiguation: 'needs-input',
    AwaitingPlanConfirmation: 'needs-input',
    AwaitingActionConfirmation: 'needs-input'
};
/**
 * Contract gap: no task field means "entered the current state" — only `created_at`,
 * `started_at`, `updated_at` and `completed_at` exist. Substituting `updatedAt` would claim
 * precision the contract lacks, so age stays unknown until a dedicated field lands. This is the
 * single place to populate it; ordering and row age then pick it up automatically.
 */ const $094743d67f51b17f$var$resolveVerifiedRaisedAt = (task)=>{
    return undefined;
};
/**
 * Maps a task to its notice, or `undefined` when none applies.
 *
 * Tasks missing the identifiers needed to open the blocking message raise no notice rather than
 * appearing as dead ends. Every reason needs a target today; revisit if a purely informational
 * reason is added.
 */ const $094743d67f51b17f$var$toTaskNotice = (task)=>{
    const { progressState: progressState, conversationId: conversationId, currentMessageId: currentMessageId } = task;
    const reason = $094743d67f51b17f$var$NOTICE_REASON_BY_PROGRESS_STATE[progressState];
    if (!reason || !conversationId || !currentMessageId) return undefined;
    return {
        taskId: task.taskId,
        conversationId: conversationId,
        currentMessageId: currentMessageId,
        agentId: task.agentId,
        title: task.title,
        reason: reason,
        progressState: progressState,
        raisedAt: $094743d67f51b17f$var$resolveVerifiedRaisedAt(task),
        updatedAt: task.updatedAt
    };
};
/** Unparseable timestamps compare equal so they fall through to the next tie-break. */ const $094743d67f51b17f$var$toComparableTime = (iso)=>{
    const ms = Date.parse(iso);
    return Number.isNaN(ms) ? 0 : ms;
};
/**
 * Newest raised notice first, then newest store update, then `taskId`. Notices with a known
 * `raisedAt` always rank above those without.
 */ const $094743d67f51b17f$var$compareTaskNotices = (a, b)=>{
    const aRaisedAt = a.raisedAt;
    const bRaisedAt = b.raisedAt;
    if (aRaisedAt !== undefined || bRaisedAt !== undefined) {
        if (aRaisedAt === undefined) return 1;
        if (bRaisedAt === undefined) return -1;
        const raisedDelta = $094743d67f51b17f$var$toComparableTime(bRaisedAt) - $094743d67f51b17f$var$toComparableTime(aRaisedAt);
        if (raisedDelta !== 0) return raisedDelta;
    }
    const updatedDelta = $094743d67f51b17f$var$toComparableTime(b.updatedAt) - $094743d67f51b17f$var$toComparableTime(a.updatedAt);
    if (updatedDelta !== 0) return updatedDelta;
    if (a.taskId === b.taskId) return 0;
    return a.taskId < b.taskId ? -1 : 1;
};
const $094743d67f51b17f$export$fd731d6c9b6341fb = (tasks)=>{
    const noticesByTaskId = new Map();
    for (const task of tasks){
        const notice = $094743d67f51b17f$var$toTaskNotice(task);
        if (notice) noticesByTaskId.set(notice.taskId, notice);
        else noticesByTaskId.delete(task.taskId);
    }
    return Array.from(noticesByTaskId.values()).sort($094743d67f51b17f$var$compareTaskNotices);
};


const $52c66879efe97862$var$initialState = {
    tasksByTaskId: new Map(),
    allTasksNextCursor: null,
    hasLoadedAllTasksPage: false,
    activeConversationId: null,
    activeConversationLastAgentMessageId: null,
    activeConversationStatus: null,
    sseSubscriberCount: 0,
    sseConnected: false
};
// ─── Terminal status constants ────────────────────────────────────────────────
const $52c66879efe97862$var$TERMINAL_STATUSES = new Set([
    'COMPLETED',
    'FAILED',
    'CANCELLED'
]);
const $52c66879efe97862$var$TERMINAL_PROGRESS_STATES = new Set([
    'Completed',
    'Failed',
    'Cancelled'
]);
const $52c66879efe97862$var$isTerminalStatus = (status)=>$52c66879efe97862$var$TERMINAL_STATUSES.has(status);
const $52c66879efe97862$var$isTerminalProgressState = (state)=>$52c66879efe97862$var$TERMINAL_PROGRESS_STATES.has(state);
/**
 * Progress states that carry a pending-prompt `activeInvocationId`. The id is
 * only meaningful while the task stays in one of these states; once it leaves
 * (to RUNNING, a terminal status, or a *different* awaiting state) the prompt is
 * gone and the id must be cleared so a dead invocation can't later rebind an
 * overlay on a fresh mount.
 */ const $52c66879efe97862$var$INVOCATION_BEARING_PROGRESS_STATES = new Set([
    'AwaitingDisambiguation',
    'AwaitingPlanConfirmation'
]);
const $52c66879efe97862$var$shouldPreserveActiveInvocationId = (existing, resolvedProgressState)=>!!existing && existing.progressState === resolvedProgressState && $52c66879efe97862$var$INVOCATION_BEARING_PROGRESS_STATES.has(resolvedProgressState);
// ─── Status mapping ───────────────────────────────────────────────────────────
// Sourced from the shared `tasks-shared/task-helpers` module.
// ─── Merge helpers ────────────────────────────────────────────────────────────
/**
 * Returns true if `incoming` should overwrite `existing` for the same taskId.
 *
 * Monotonic rules:
 *   1. No existing → always accept incoming.
 *   2. Existing is terminal → only accept a strictly newer terminal update.
 *   3. Otherwise → accept if incoming.updated_at >= existing.updated_at.
 */ function $52c66879efe97862$var$shouldOverwrite(existing, incomingUpdatedAt, incomingStatus) {
    if (!existing) return true;
    if ($52c66879efe97862$var$isTerminalStatus(existing.rawStatus)) return $52c66879efe97862$var$isTerminalStatus(incomingStatus) && incomingUpdatedAt > existing.updatedAt;
    return incomingUpdatedAt >= existing.updatedAt;
}
function $52c66879efe97862$export$609ffd14cb121e86(raw) {
    if (!raw) return null;
    try {
        return Object.values(raw).map((value)=>{
            const parsed = JSON.parse(value);
            return {
                startedAt: parsed.startedAt,
                ...parsed.endedAt ? {
                    endedAt: parsed.endedAt
                } : {}
            };
        });
    } catch  {
        return null;
    }
}
function $52c66879efe97862$export$27c41772233f8b90(raw) {
    if (!raw) return undefined;
    try {
        const todos = Object.values(raw).map((value)=>{
            const parsed = JSON.parse(value);
            return {
                id: parsed.id,
                content: parsed.content,
                status: parsed.status,
                priority: parsed.priority,
                active_form: parsed.activeForm ?? parsed.active_form
            };
        });
        return {
            todos: todos
        };
    } catch  {
        return undefined;
    }
}
// ─── Module-level SSE deduplication ──────────────────────────────────────────
/**
 * Reference-equality dedup tracker. Since subscribeToTasksSSE fans the same
 * event object reference to every subscriber, we track the last ingested
 * reference to avoid writing to the store N times for N mounted subscribers.
 */ let $52c66879efe97862$var$lastIngestedSSEEvent = null;
const $52c66879efe97862$var$store = (0, $8s9DV.createStore)({
    name: 'tasks',
    initialState: $52c66879efe97862$var$initialState,
    actions: {
        // ─── SSE Lifecycle ────────────────────────────────────────────────────
        mountSSESubscriber: (getService)=>({ getState: getState, setState: setState })=>{
                const { sseSubscriberCount: sseSubscriberCount } = getState();
                const newCount = sseSubscriberCount + 1;
                setState({
                    sseSubscriberCount: newCount
                });
                if (newCount === 1) {
                    // First subscriber — open SSE connection via existing ref-counted manager.
                    // The module-level subscribeToTasksSSE handles tab-visibility and reconnect.
                    const unsubscribe = (0, $3931780bbccb0af6$export$285816b4ea71cce1)(getService, (event, eventType)=>{
                        // Deduplicate store ingestion across multiple mounted subscribers
                        if ($52c66879efe97862$var$lastIngestedSSEEvent?.event !== event) {
                            (0, $c6StJ.defaultRegistry).getStore($52c66879efe97862$var$store).actions.ingestTasksSSEEvent(event, eventType);
                            $52c66879efe97862$var$lastIngestedSSEEvent = {
                                event: event,
                                eventType: eventType
                            };
                        }
                    });
                    // Store the unsubscribe fn at module level so unmountSSESubscriber can call it
                    $52c66879efe97862$var$sseUnsubscribe = unsubscribe;
                }
            },
        unmountSSESubscriber: ()=>({ getState: getState, setState: setState })=>{
                const { sseSubscriberCount: sseSubscriberCount } = getState();
                const newCount = Math.max(0, sseSubscriberCount - 1);
                setState({
                    sseSubscriberCount: newCount
                });
                if (newCount === 0 && $52c66879efe97862$var$sseUnsubscribe) {
                    $52c66879efe97862$var$sseUnsubscribe();
                    $52c66879efe97862$var$sseUnsubscribe = null;
                    $52c66879efe97862$var$lastIngestedSSEEvent = null;
                }
            },
        _setSSEConnected: (connected)=>({ setState: setState })=>{
                setState({
                    sseConnected: connected
                });
            },
        // ─── Active Conversation Context ──────────────────────────────────────
        setActiveConversationContext: ({ conversationId: conversationId, lastAgentMessageId: lastAgentMessageId, status: status })=>({ setState: setState })=>{
                setState({
                    activeConversationId: conversationId,
                    activeConversationLastAgentMessageId: lastAgentMessageId,
                    activeConversationStatus: status
                });
            },
        // ─── SSE Ingestion ────────────────────────────────────────────────────
        ingestTasksSSEEvent: (event, eventType)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                if (eventType === 'connected') {
                    setState({
                        sseConnected: true
                    });
                    return;
                }
                if (eventType === 'task_snapshot') {
                    const snapshot = event;
                    const tasks = snapshot.tasks ?? [];
                    if (tasks.length === 0) return;
                    const next = new Map(state.tasksByTaskId);
                    let changed = false;
                    for (const incoming of tasks){
                        const existing = next.get(incoming.task_id);
                        if (!$52c66879efe97862$var$shouldOverwrite(existing, incoming.updated_at, incoming.status)) continue;
                        next.set(incoming.task_id, $52c66879efe97862$var$mergeSSEUpdateIntoTask(existing, incoming));
                        changed = true;
                    }
                    if (changed) setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                if (eventType === 'task_status') {
                    const update = event;
                    const conversationId = update.conversation_id ?? null;
                    // Guard A: reject if the owning conversation is actively streaming
                    // (CHAT_STORE_STATUS.idle = 0; non-idle means streaming/loading)
                    if (conversationId && conversationId === state.activeConversationId && state.activeConversationStatus !== null && state.activeConversationStatus !== 0 // CHAT_STORE_STATUS.idle
                    ) return;
                    // Guard B: reject stale SSE reconnect replays by currentMessageId mismatch
                    if (conversationId && conversationId === state.activeConversationId && update.current_message_id && state.activeConversationLastAgentMessageId && update.current_message_id !== state.activeConversationLastAgentMessageId) return;
                    const existing = state.tasksByTaskId.get(update.task_id);
                    const progressState = (0, $7H855.mapApiTaskStatusToProgressState)(update.status);
                    // Skip if already applied (same state from stream)
                    if (existing && existing.progressState === progressState && existing.currentMessageId === (update.current_message_id ?? null) && existing.updatedAt >= update.updated_at) return;
                    if (!$52c66879efe97862$var$shouldOverwrite(existing, update.updated_at, update.status)) return;
                    const next = new Map(state.tasksByTaskId);
                    if (!existing) // Create-if-missing: task arrived via SSE before stream
                    next.set(update.task_id, $52c66879efe97862$var$mergeSSEUpdateIntoTask(undefined, update));
                    else next.set(update.task_id, $52c66879efe97862$var$mergeSSEUpdateIntoTask(existing, update));
                    setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                if (eventType === 'task_todo_update') {
                    const update = event;
                    const conversationId = update.conversation_id ?? null;
                    // Guard A (parity with task_status): reject if the owning conversation
                    // is actively streaming. The in-flight stream will deliver a fresher
                    // todo snapshot momentarily.
                    if (conversationId && conversationId === state.activeConversationId && state.activeConversationStatus !== null && state.activeConversationStatus !== 0 // CHAT_STORE_STATUS.idle
                    ) return;
                    // Guard B (parity with task_status): reject stale SSE reconnect
                    // replays by currentMessageId mismatch.
                    if (conversationId && conversationId === state.activeConversationId && update.current_message_id && state.activeConversationLastAgentMessageId && update.current_message_id !== state.activeConversationLastAgentMessageId) return;
                    const existing = state.tasksByTaskId.get(update.task_id);
                    if (!existing || $52c66879efe97862$var$isTerminalProgressState(existing.progressState)) return;
                    const todoSnapshot = $52c66879efe97862$export$27c41772233f8b90(update.todo_list ?? undefined);
                    if (!todoSnapshot) return;
                    const next = new Map(state.tasksByTaskId);
                    next.set(update.task_id, {
                        ...existing,
                        todoSnapshot: todoSnapshot
                    });
                    setState({
                        tasksByTaskId: next
                    });
                }
            },
        // ─── Task Mutations from Stream ───────────────────────────────────────
        createTaskFromStream: ({ taskId: taskId, conversationId: conversationId, title: title, updatedAt: updatedAt, messageId: messageId, currentMessageId: currentMessageId, createdAt: createdAt, startedAt: startedAt, completedAt: completedAt, executionSegments: executionSegments })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                // Idempotency guard — skip if task already exists
                if (tasksByTaskId.has(taskId)) return;
                const newTask = {
                    taskId: taskId,
                    conversationId: conversationId,
                    agentId: null,
                    triggerType: null,
                    progressState: 'Draft',
                    rawStatus: 'DRAFT',
                    activeInvocationId: null,
                    title: title,
                    plan: null,
                    resultSummary: null,
                    errorMessage: null,
                    todoSnapshot: undefined,
                    currentStep: null,
                    executionSegments: executionSegments ?? null,
                    messageId: messageId ?? null,
                    completionMessageId: null,
                    currentMessageId: currentMessageId ?? null,
                    seekingCompletedAck: false,
                    createdAt: createdAt ?? null,
                    startedAt: startedAt ?? null,
                    // Prefer the supplied updatedAt, then fall back to createdAt so the
                    // initial monotonic comparison in `shouldOverwrite` doesn't reject a
                    // real BE update that arrives with an older timestamp than `Date.now()`.
                    updatedAt: updatedAt ?? createdAt ?? new Date().toISOString(),
                    completedAt: completedAt ?? null
                };
                const next = new Map(tasksByTaskId);
                next.set(taskId, newTask);
                setState({
                    tasksByTaskId: next
                });
            },
        setTaskProgressState: ({ taskId: taskId, conversationId: conversationId, progressState: progressState, title: title, seekingCompletedAck: seekingCompletedAck, messageId: messageId, completionMessageId: completionMessageId, updatedAt: updatedAt, currentMessageId: currentMessageId, createdAt: createdAt, startedAt: startedAt, completedAt: completedAt, executionSegments: executionSegments, activeInvocationId: activeInvocationId, currentStep: currentStep, resultSummary: resultSummary, errorMessage: errorMessage })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const resolvedTaskId = taskId ?? (conversationId ? $52c66879efe97862$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) : undefined);
                // Auto-create when there is no active task yet for the conversation.
                // Allows the chat-store to drive optimistic state changes
                // (e.g. AwaitingPlanConfirmation) before
                // the BE has issued a real task_id.
                if (!resolvedTaskId) {
                    if (!conversationId) return;
                    const localTaskId = `task-${Date.now()}`;
                    const newTask = {
                        taskId: localTaskId,
                        conversationId: conversationId,
                        agentId: null,
                        triggerType: null,
                        progressState: progressState,
                        rawStatus: $52c66879efe97862$var$progressStateToApiStatus(progressState),
                        activeInvocationId: activeInvocationId ?? null,
                        title: title ?? '',
                        plan: null,
                        resultSummary: resultSummary ?? null,
                        errorMessage: errorMessage ?? null,
                        todoSnapshot: undefined,
                        currentStep: currentStep ?? null,
                        executionSegments: executionSegments ?? null,
                        messageId: messageId ?? null,
                        completionMessageId: completionMessageId ?? null,
                        currentMessageId: currentMessageId ?? null,
                        seekingCompletedAck: seekingCompletedAck ?? false,
                        createdAt: createdAt ?? new Date().toISOString(),
                        startedAt: startedAt ?? null,
                        updatedAt: updatedAt ?? createdAt ?? new Date().toISOString(),
                        completedAt: completedAt ?? null
                    };
                    const next = new Map(tasksByTaskId);
                    next.set(localTaskId, newTask);
                    setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                const existing = tasksByTaskId.get(resolvedTaskId);
                if (!existing) return;
                // Terminal state protection
                if ($52c66879efe97862$var$isTerminalProgressState(existing.progressState)) return;
                const merged = {
                    ...existing,
                    progressState: progressState,
                    rawStatus: $52c66879efe97862$var$progressStateToApiStatus(progressState),
                    // `null` is meaningful — explicit clear; `undefined` leaves field unchanged.
                    ...activeInvocationId !== undefined ? {
                        activeInvocationId: activeInvocationId
                    } : {},
                    ...title !== undefined ? {
                        title: title
                    } : {},
                    ...seekingCompletedAck !== undefined ? {
                        seekingCompletedAck: seekingCompletedAck
                    } : {},
                    ...messageId !== undefined ? {
                        messageId: messageId
                    } : {},
                    ...completionMessageId !== undefined ? {
                        completionMessageId: completionMessageId
                    } : {},
                    ...updatedAt !== undefined ? {
                        updatedAt: updatedAt
                    } : {},
                    ...currentMessageId !== undefined ? {
                        currentMessageId: currentMessageId
                    } : {},
                    ...createdAt !== undefined ? {
                        createdAt: createdAt
                    } : {},
                    ...startedAt !== undefined ? {
                        startedAt: startedAt
                    } : {},
                    ...completedAt !== undefined ? {
                        completedAt: completedAt
                    } : {},
                    ...executionSegments !== undefined ? {
                        executionSegments: (0, $7H855.mergeExecutionSegments)(existing.executionSegments, executionSegments)
                    } : {},
                    // `null` is meaningful — explicit clear; `undefined` leaves field unchanged.
                    ...currentStep !== undefined ? {
                        currentStep: currentStep
                    } : {},
                    ...resultSummary !== undefined ? {
                        resultSummary: resultSummary
                    } : {},
                    ...errorMessage !== undefined ? {
                        errorMessage: errorMessage
                    } : {}
                };
                const next = new Map(tasksByTaskId);
                next.set(resolvedTaskId, merged);
                setState({
                    tasksByTaskId: next
                });
            },
        setTaskTodoSnapshot: ({ taskId: taskId, conversationId: conversationId, todoSnapshot: todoSnapshot })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const resolvedTaskId = taskId ?? (conversationId ? $52c66879efe97862$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) : undefined);
                if (!resolvedTaskId) return;
                const existing = tasksByTaskId.get(resolvedTaskId);
                if (!existing || $52c66879efe97862$var$isTerminalProgressState(existing.progressState)) return;
                const next = new Map(tasksByTaskId);
                next.set(resolvedTaskId, {
                    ...existing,
                    todoSnapshot: todoSnapshot
                });
                setState({
                    tasksByTaskId: next
                });
            },
        ackTaskCompleted: ({ taskId: taskId })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing) return;
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    seekingCompletedAck: false
                });
                setState({
                    tasksByTaskId: next
                });
            },
        clearTask: ({ taskId: taskId })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                if (!tasksByTaskId.has(taskId)) return;
                const next = new Map(tasksByTaskId);
                next.delete(taskId);
                setState({
                    tasksByTaskId: next
                });
            },
        // ─── REST Merge ───────────────────────────────────────────────────────
        mergeConversationChannelTasks: (remoteTasks)=>({ getState: getState, setState: setState })=>{
                if (!remoteTasks || remoteTasks.length === 0) return;
                // Sort ascending by created_at (oldest first, newest last = active)
                const sorted = [
                    ...remoteTasks
                ].sort((a, b)=>new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                for (const remote of sorted){
                    const existing = next.get(remote.task_id);
                    const merged = $52c66879efe97862$var$mergeChannelTaskIntoUnified(existing, remote);
                    next.set(remote.task_id, merged);
                    changed = true;
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        mergeAllTasksSnapshot: (tasks)=>({ getState: getState, setState: setState })=>{
                if (!tasks) return;
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                // 1. Upsert all tasks from the snapshot (REST is authoritative for tasks it returns).
                const snapshotIds = new Set();
                for (const incoming of tasks){
                    snapshotIds.add(incoming.task_id);
                    const existing = next.get(incoming.task_id);
                    if (!$52c66879efe97862$var$shouldOverwrite(existing, incoming.updated_at, incoming.status)) continue;
                    next.set(incoming.task_id, $52c66879efe97862$var$mergeSSEUpdateIntoTask(existing, incoming));
                    changed = true;
                }
                // 2. Reconcile: remove any task absent from the REST snapshot **only** when
                //    it's already in a terminal state. Non-terminal (in-flight) tasks may
                //    legitimately be present locally but not yet visible in REST (race), so
                //    we preserve them and rely on SSE to deliver their final state.
                for (const [taskId, task] of tasksByTaskId){
                    if (snapshotIds.has(taskId)) continue;
                    if ($52c66879efe97862$var$isTerminalProgressState(task.progressState)) {
                        next.delete(taskId);
                        changed = true;
                    }
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        mergeAllTasksPage: (tasks, nextCursor)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                for (const incoming of tasks){
                    const existing = next.get(incoming.task_id);
                    if (!$52c66879efe97862$var$shouldOverwrite(existing, incoming.updated_at, incoming.status)) continue;
                    next.set(incoming.task_id, $52c66879efe97862$var$mergeSSEUpdateIntoTask(existing, incoming));
                    changed = true;
                }
                if (changed || nextCursor !== undefined) setState({
                    ...changed ? {
                        tasksByTaskId: next
                    } : {},
                    ...nextCursor !== undefined ? {
                        allTasksNextCursor: nextCursor,
                        hasLoadedAllTasksPage: true
                    } : {}
                });
            },
        // ─── Optimistic mutations from UI (tasks-list, etc.) ─────────────────
        /**
     * Removes a single task by taskId. Used for optimistic delete from
     * the tasks-list screen before the API call resolves.
     */ removeTaskById: (taskId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                if (!tasksByTaskId.has(taskId)) return;
                const next = new Map(tasksByTaskId);
                next.delete(taskId);
                setState({
                    tasksByTaskId: next
                });
            },
        /**
     * Optimistically marks a task as Cancelled (terminal state). Used by the
     * tasks-list stop action before the API call resolves.
     */ markTaskCancelled: (taskId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing) return;
                const now = new Date().toISOString();
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    progressState: 'Cancelled',
                    rawStatus: 'CANCELLED',
                    updatedAt: now,
                    completedAt: existing.completedAt ?? now
                });
                setState({
                    tasksByTaskId: next
                });
            },
        /**
     * Optimistically updates a task's title. Used by the tasks-list rename
     * action before the API call resolves.
     */ setTaskTitle: (taskId, title)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing || existing.title === title) return;
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    title: title,
                    updatedAt: new Date().toISOString()
                });
                setState({
                    tasksByTaskId: next
                });
            },
        // ─── Conversation cleanup ─────────────────────────────────────────────
        removeTasksForConversation: (conversationId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                for (const [taskId, task] of tasksByTaskId)if (task.conversationId === conversationId) {
                    next.delete(taskId);
                    changed = true;
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        // Read-only accessor — used by chat-store actions that need the latest
        // active task synchronously without going through React.
        getActiveTaskForConversation: (conversationId)=>({ getState: getState })=>{
                return $52c66879efe97862$var$findActiveTaskForConversation(getState().tasksByTaskId, conversationId);
            },
        // Read-only accessor — single-task lookup by id. Same imperative shape as
        // `getActiveTaskForConversation` so chat-store callers don't need any
        // React state plumbing.
        getTaskById: (taskId)=>({ getState: getState })=>{
                return getState().tasksByTaskId.get(taskId);
            }
    }
});
// ─── Module-level SSE unsubscribe reference ───────────────────────────────────
// Stored outside the store state (not serializable, not reactive).
let $52c66879efe97862$var$sseUnsubscribe = null;
/**
 * Finds the active task for a conversation.
 * Prefers the most recent **non-terminal** task; falls back to the most recent
 * task overall if all tasks for the conversation are in terminal state.
 *
 * "Active" semantics: a conversation has at most one in-flight task at any
 * point in time. Older tasks (terminal) remain associated with the conversation
 * for history but should not be treated as the current active task.
 */ /**
 * Internal selector helper. Use the `useActiveTaskForConversation` /
 * `useActiveTasksForConversations` hooks (React) or the
 * `getActiveTaskForConversation` action (non-React) instead.
 */ function $52c66879efe97862$var$findActiveTaskForConversation(tasksByTaskId, conversationId) {
    let latestNonTerminal;
    let latestAny;
    for (const task of tasksByTaskId.values()){
        if (task.conversationId !== conversationId) continue;
        if (!latestAny || (task.createdAt ?? '') > (latestAny.createdAt ?? '')) latestAny = task;
        if (!$52c66879efe97862$var$isTerminalProgressState(task.progressState)) {
            if (!latestNonTerminal || (task.createdAt ?? '') > (latestNonTerminal.createdAt ?? '')) latestNonTerminal = task;
        }
    }
    return latestNonTerminal ?? latestAny;
}
function $52c66879efe97862$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) {
    return $52c66879efe97862$var$findActiveTaskForConversation(tasksByTaskId, conversationId)?.taskId;
}
// ─── Internal merge helpers ───────────────────────────────────────────────────
function $52c66879efe97862$var$progressStateToApiStatus(state) {
    const map = {
        Draft: 'DRAFT',
        Queued: 'QUEUED',
        Running: 'RUNNING',
        AwaitingDisambiguation: 'AWAITING_DISAMBIGUATION',
        AwaitingPlanConfirmation: 'AWAITING_PLAN_CONFIRMATION',
        AwaitingActionConfirmation: 'AWAITING_ACTION_CONFIRMATION',
        Completed: 'COMPLETED',
        Failed: 'FAILED',
        Cancelled: 'CANCELLED'
    };
    return map[state];
}
function $52c66879efe97862$var$mergeSSEUpdateIntoTask(existing, incoming) {
    const progressState = (0, $7H855.mapApiTaskStatusToProgressState)(incoming.status);
    // `current_step` only exists on the SSE shape; REST snapshots don't carry it.
    const incomingCurrentStep = 'current_step' in incoming ? incoming.current_step ?? null : existing?.currentStep ?? null;
    // `agent_id` and `trigger_type` are on the REST shape but not on every SSE update.
    const incomingAgentId = 'agent_id' in incoming ? incoming.agent_id : existing?.agentId ?? null;
    const incomingTriggerType = 'trigger_type' in incoming ? incoming.trigger_type : existing?.triggerType ?? null;
    const incomingPlan = 'plan' in incoming ? incoming.plan ?? null : existing?.plan ?? null;
    const incomingCompletedAt = 'completed_at' in incoming ? incoming.completed_at ?? existing?.completedAt ?? null : existing?.completedAt ?? null;
    return {
        taskId: incoming.task_id,
        conversationId: incoming.conversation_id ?? existing?.conversationId ?? null,
        agentId: incomingAgentId,
        triggerType: incomingTriggerType,
        progressState: progressState,
        rawStatus: incoming.status,
        // Not carried on the SSE/REST wire shape. Preserve the local value only while
        // the task stays in the same invocation-bearing awaiting state; otherwise clear
        // it so a dead invocation id can't outlive its prompt.
        activeInvocationId: $52c66879efe97862$var$shouldPreserveActiveInvocationId(existing, progressState) ? existing?.activeInvocationId ?? null : null,
        title: incoming.title,
        plan: incomingPlan,
        resultSummary: incoming.result_summary,
        errorMessage: incoming.error_message,
        todoSnapshot: existing?.todoSnapshot,
        currentStep: incomingCurrentStep,
        executionSegments: $52c66879efe97862$export$609ffd14cb121e86(incoming.execution_segments ?? undefined),
        messageId: incoming.message_id ?? existing?.messageId ?? null,
        completionMessageId: incoming.completion_message_id ?? existing?.completionMessageId ?? null,
        currentMessageId: incoming.current_message_id ?? existing?.currentMessageId ?? null,
        // Local-only UI state: preserve from existing
        seekingCompletedAck: existing?.seekingCompletedAck ?? false,
        createdAt: incoming.created_at ?? existing?.createdAt ?? null,
        startedAt: incoming.started_at ?? existing?.startedAt ?? null,
        updatedAt: incoming.updated_at,
        completedAt: incomingCompletedAt
    };
}
function $52c66879efe97862$var$mergeChannelTaskIntoUnified(existing, remote) {
    const progressState = (0, $7H855.mapApiTaskStatusToProgressState)(remote.status);
    const remoteExecutionSegments = $52c66879efe97862$export$609ffd14cb121e86(remote.execution_segments ?? undefined);
    const remoteTodoSnapshot = $52c66879efe97862$export$27c41772233f8b90(remote.todo_list ?? undefined);
    // Local wins for progressState and todoSnapshot when local is strictly newer
    const localIsNewer = existing?.updatedAt && existing.updatedAt > remote.updated_at;
    const resolvedProgressState = localIsNewer ? existing?.progressState ?? progressState : progressState;
    return {
        taskId: remote.task_id,
        conversationId: remote.conversation_id,
        agentId: remote.agent_id,
        triggerType: remote.trigger_type,
        progressState: resolvedProgressState,
        rawStatus: localIsNewer ? existing?.rawStatus ?? remote.status : remote.status,
        // Not carried on the channel wire shape. Preserve the local value only while
        // the task stays in the same invocation-bearing awaiting state (compared
        // against the FINAL resolved progressState, which accounts for localIsNewer);
        // otherwise clear it so a dead invocation id can't outlive its prompt.
        activeInvocationId: $52c66879efe97862$var$shouldPreserveActiveInvocationId(existing, resolvedProgressState) ? existing?.activeInvocationId ?? null : null,
        title: remote.title,
        plan: remote.plan,
        resultSummary: remote.result_summary,
        errorMessage: remote.error_message,
        todoSnapshot: localIsNewer ? existing?.todoSnapshot : remoteTodoSnapshot ?? existing?.todoSnapshot,
        currentStep: existing?.currentStep ?? null,
        executionSegments: (0, $7H855.mergeExecutionSegments)(existing?.executionSegments, remoteExecutionSegments),
        messageId: remote.message_id,
        completionMessageId: remote.completion_message_id,
        currentMessageId: remote.current_message_id,
        // Local-only: seekingCompletedAck NEVER overwritten by REST
        seekingCompletedAck: existing?.seekingCompletedAck ?? false,
        createdAt: remote.created_at,
        startedAt: remote.started_at,
        updatedAt: remote.updated_at,
        completedAt: remote.completed_at
    };
}
const $52c66879efe97862$export$c2ad39067c031726 = (0, $kBr4q.createHook)($52c66879efe97862$var$store);
const $52c66879efe97862$export$e398e9c82ae1ea3e = (0, $kBr4q.createActionsHook)($52c66879efe97862$var$store);
const $52c66879efe97862$export$4a89b1af24c66aec = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state, conversationId)=>{
        if (!conversationId) return undefined;
        return $52c66879efe97862$var$findActiveTaskForConversation(state.tasksByTaskId, conversationId);
    }
});
const $52c66879efe97862$export$37ef8d89dd7c4479 = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state)=>Array.from(state.tasksByTaskId.values())
});
const $52c66879efe97862$export$ccf22665055675b = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state)=>(0, $094743d67f51b17f$export$fd731d6c9b6341fb)(state.tasksByTaskId.values())
});
const $52c66879efe97862$export$294781cac1da1fda = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state)=>({
            allTasksNextCursor: state.allTasksNextCursor,
            hasLoadedAllTasksPage: state.hasLoadedAllTasksPage
        })
});
const $52c66879efe97862$export$86ae895223d55438 = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state, conversationIds)=>{
        const result = new Map();
        for (const id of conversationIds)result.set(id, $52c66879efe97862$var$findActiveTaskForConversation(state.tasksByTaskId, id));
        return result;
    }
});
const $52c66879efe97862$export$8adc54d746bc9a7f = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state, taskId)=>state.tasksByTaskId.get(taskId)
});
const $52c66879efe97862$export$2a84773e9f93301a = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state)=>state.sseConnected
});
const $52c66879efe97862$export$f68962e2c5dae5a0 = (task)=>({
        task_id: task.taskId,
        title: task.title,
        status: task.rawStatus,
        current_step: task.currentStep,
        result_summary: task.resultSummary,
        error_message: task.errorMessage,
        conversation_id: task.conversationId,
        message_id: task.messageId,
        completion_message_id: task.completionMessageId,
        current_message_id: task.currentMessageId,
        created_at: task.createdAt,
        started_at: task.startedAt,
        updated_at: task.updatedAt,
        // Preserve raw shape for execution_segments and todo_list (Record<string,string>).
        // We do not have the raw representation any more after parsing, so leave as null.
        execution_segments: null,
        todo_list: null
    });
module.exports["parseExecutionSegments"] = $52c66879efe97862$export$609ffd14cb121e86;
module.exports["useTasksStoreActions"] = $52c66879efe97862$export$e398e9c82ae1ea3e;
module.exports["useActiveTaskForConversation"] = $52c66879efe97862$export$4a89b1af24c66aec;
module.exports["useAllTasks"] = $52c66879efe97862$export$37ef8d89dd7c4479;
module.exports["useAllTasksPaginationState"] = $52c66879efe97862$export$294781cac1da1fda;
module.exports["useActiveTasksForConversations"] = $52c66879efe97862$export$86ae895223d55438;
module.exports["unifiedTaskToApiSSE"] = $52c66879efe97862$export$f68962e2c5dae5a0;

});

parcelRegister("iEKWu", function(module, exports) {
const $acee56d2cf65b7f0$export$420f5414c6aecb85 = (interactionModeExecuted)=>interactionModeExecuted ? {
        interactionModeExecuted: interactionModeExecuted
    } : {};
module.exports["interactionModeExecutedAttributes"] = $acee56d2cf65b7f0$export$420f5414c6aecb85;

});

parcelRegister("cC5sC", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");

function $a608bfd48681563a$export$780f1f00b9b71ec({ editorContext: editorContext, whiteboardContext: whiteboardContext, databaseContext: databaseContext, slidesContext: slidesContext }) {
    if (editorContext) return 'page';
    if (whiteboardContext) return 'whiteboard';
    if (databaseContext) return 'database';
    if (slidesContext) return 'slide';
    return undefined;
}


/**
 * Per-experience creation context contracts.
 *
 * Add a row as each experience is migrated. An experience with no row here is passed through
 * untouched, so this is safe to extend one experience at a time.
 */ const $d754fa0337b217c7$var$CREATION_CONTEXT_CONTRACTS = {
    remix_edit: {
        omit: [
            'contentTypes'
        ],
        // A remix edit always targets existing content: a MAUI app or a generated image.
        oneOf: [
            'contentMauiId',
            'mediaFileId'
        ],
        // 'image' is not in the published contract table, but image remixes are a real block type
        // and must not be reported as one of the others.
        blocks: [
            'chart',
            'diagram',
            'visual-aid',
            'infographic',
            'image'
        ]
    }
};
function $d754fa0337b217c7$export$11b60038f3efc9bb(creationContext) {
    const experience = creationContext.experience;
    const contract = typeof experience === 'string' ? $d754fa0337b217c7$var$CREATION_CONTEXT_CONTRACTS[experience] : undefined;
    if (!contract) return creationContext;
    const result = {};
    for (const [key, value] of Object.entries(creationContext))if (!contract.omit.includes(key)) result[key] = value;
    if (contract.oneOf) {
        const [kept] = contract.oneOf.filter((key)=>result[key] !== undefined && result[key] !== '');
        for (const key of contract.oneOf)if (key !== kept) delete result[key];
    }
    if (contract.blocks) {
        const allowed = contract.blocks;
        const isAllowed = (value)=>typeof value === 'string' && allowed.includes(value);
        // The block being edited is authoritative: a call site can derive `blocks` from the
        // presence of a media id, which mislabels a visual aid as an image.
        const declared = Array.isArray(result.blocks) ? result.blocks.filter(isAllowed) : [];
        const resolved = isAllowed(result.dynamicUiType) ? [
            result.dynamicUiType
        ] : declared.length > 0 ? declared : undefined;
        if (resolved) result.blocks = resolved;
        else delete result.blocks;
    }
    return result;
}


const $281fa3f29881e068$var$REMIX_EDIT_BLOCKS = [
    'chart',
    'diagram',
    'visual-aid',
    'infographic',
    'image'
];
function $281fa3f29881e068$export$e1dc015944c90cb9({ existingBlocks: existingBlocks, experience: experience, source: source, contentMauiId: contentMauiId, mediaFileId: mediaFileId, dynamicUiType: dynamicUiType, isRemixExperienceContextEnabled: isRemixExperienceContextEnabled = true, isCreationContextContractEnabled: isCreationContextContractEnabled = false }) {
    if (!isRemixExperienceContextEnabled) return undefined;
    if (existingBlocks && existingBlocks.length > 0) return existingBlocks;
    if (isCreationContextContractEnabled && experience === 'remix_edit') {
        if (dynamicUiType && $281fa3f29881e068$var$REMIX_EDIT_BLOCKS.includes(dynamicUiType)) return [
            dynamicUiType
        ];
        // The contract requires a block on every remix edit. The exact value matters less than its
        // presence: the MAUI types are handled by one subagent and the image types by another, so
        // fall back to the block family implied by the content reference.
        return mediaFileId && !contentMauiId ? [
            'image'
        ] : [
            'chart'
        ];
    }
    if (source === 'remix' && experience === 'remix_edit' && mediaFileId) return [
        'image'
    ];
    return undefined;
}


function $859bfbfa800411c6$export$e5ce245ce709fc21({ contentContextValue: contentContextValue, isFirstPrompt: isFirstPrompt, source: source, creationContextSource: creationContextSource, existingExperience: existingExperience, existingContentTypes: existingContentTypes, chatContextContentType: chatContextContentType, isRemixAction: isRemixAction, isViewMode: isViewMode, contentMauiId: contentMauiId, mediaFileId: mediaFileId, isRemixExperienceContextEnabled: isRemixExperienceContextEnabled = true, isCreationContextContractEnabled: isCreationContextContractEnabled = false }) {
    const resolvedContentTypes = existingContentTypes && existingContentTypes.length > 0 ? existingContentTypes : chatContextContentType ? [
        chatContextContentType
    ] : undefined;
    if (isRemixExperienceContextEnabled && existingExperience === 'inline_edit' && (contentMauiId || mediaFileId)) {
        // A remix edit is identified by the block being edited, not by the content hosting it, so
        // it must still be reported when no content type can be resolved.
        if (isCreationContextContractEnabled) return {
            experience: 'remix_edit'
        };
        return resolvedContentTypes ? {
            experience: 'remix_edit',
            contentTypes: resolvedContentTypes
        } : undefined;
    }
    if (existingExperience === 'cwr_edit') {
        if (resolvedContentTypes) return {
            experience: 'cwr_edit',
            contentTypes: resolvedContentTypes
        };
        return {
            experience: 'cwr'
        };
    }
    if (existingExperience) return undefined;
    const isCwrStagingAreaFollowUp = contentContextValue === 'staging-area' && !isFirstPrompt && source !== 'remix' && creationContextSource !== 'remix' && !isRemixAction;
    if (isCwrStagingAreaFollowUp) {
        if (chatContextContentType) return {
            experience: 'cwr_edit',
            contentTypes: [
                chatContextContentType
            ]
        };
        return {
            experience: 'cwr'
        };
    }
    if (contentContextValue === 'global' && chatContextContentType) return {
        experience: isViewMode ? 'chat_view' : 'chat_edit',
        contentTypes: [
            chatContextContentType
        ]
    };
    return undefined;
}





const $8e750f2baceb2078$export$bcaf715379dd74b = ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, userPreference: userPreference, sendAnalyticsEvent: sendAnalyticsEvent, activeTargetId: activeTargetId, isStagingArea: stagingAreaFromStore })=>{
    // If AIFC is not enabled, we should not send analytics
    if (!(0, $iDrrr.fg)('aifc_create_enabled')) return;
    const inStagingArea = contentContext === 'staging-area';
    // Source values for Inline Rovo
    const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_MAUI_INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP';
    const shouldProvideContext = // Inline Rovo
    sourceEligible || // Within staging area & not the first prompt
    inStagingArea && !isFirstPrompt || // Not within staging area, default to user preference
    !inStagingArea && !!userPreference;
    // If there's no editor context when we should be providing it,
    // something went wrong so send analytics to track
    if (shouldProvideContext) sendAnalyticsEvent({
        eventType: 'operational',
        action: 'missing',
        actionSubject: 'editorContext',
        attributes: {
            contentContext: contentContext,
            source: source,
            userPreference: userPreference,
            isFirstPrompt: isFirstPrompt,
            activeTargetId: activeTargetId,
            isStagingArea: stagingAreaFromStore
        }
    });
};


const $d0254ff0647fc0e0$export$e038cea4925a1058 = async (chatContextStoreActions, isFirstPrompt, source, prompt, addCurrentPageAsContextUserPreference, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, activeTargetId, lastAssistantMessageDynamicUiType, skipEditorContext, isRemixAction, searchArtifact)=>{
    // Scoped to Confluence: the contract comes from the Confluence experience routing spec, and
    // Jira runs its own remix-edit rollout with a different payload shape.
    const isCreationContextContractEnabled = productKey === 'confluence' && (0, $iDrrr.fg)('confluence_aifc_experience_rearchitecture');
    const editorContext = skipEditorContext ? undefined : await chatContextStoreActions.getEditorContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId,
        prompt: prompt
    });
    const currentTarget = chatContextStoreActions.getTarget(contentContextValue, activeTargetId);
    // If there's no editor context available and the current target CAN
    // provide context, send analytics to track this error state
    if (!editorContext && !skipEditorContext && currentTarget?.canProvideContext) (0, $8e750f2baceb2078$export$bcaf715379dd74b)({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        userPreference: !!addCurrentPageAsContextUserPreference,
        sendAnalyticsEvent: sendAnalyticsEvent,
        activeTargetId: !!activeTargetId,
        isStagingArea: chatContextStoreActions.getIsStagingArea()
    });
    const whiteboardContext = await chatContextStoreActions.getWhiteboardContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const slidesContext = await chatContextStoreActions.getSlidesContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const databaseContext = await chatContextStoreActions.getDatabaseContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const dashboardEditorContext = await chatContextStoreActions.getDashboardEditorContext({
        contentContext: contentContextValue,
        activeTargetId: activeTargetId
    });
    const browserContext = await chatContextStoreActions.getBrowserContext({
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        enabled: true
    });
    const jiraContext = await (async ()=>{
        // Only fetch Jira context when in staging area and product is Jira
        // and not the first prompt (refinement messages)
        if (!isFirstPrompt && contentContextValue === 'staging-area' && productKey === 'jira' && (0, $iDrrr.fg)('jira_aifc_enabled')) return chatContextStoreActions.getJiraContext?.();
        return undefined;
    })();
    const additionalCreationContext = editorContext?.additionalContext;
    const additionalCreationContextParams = creationContextParams?.additionalContext;
    if (editorContext && editorContext.additionalContext) delete editorContext.additionalContext;
    const useGenericEditorSkill = editorContext?.useGenericEditorSkill;
    if (editorContext && 'useGenericEditorSkill' in editorContext) delete editorContext.useGenericEditorSkill;
    const isViewMode = contentContextValue === 'staging-area' ? !!editorContext?.isViewMode : !!(editorContext?.isViewMode || whiteboardContext?.isViewMode || slidesContext?.isViewMode || databaseContext?.isViewMode);
    // On a Confluence page in view mode, the editor bridge is not active so editorContext
    // is undefined. We detect this case by checking that productKey is 'confluence', that
    // skipEditorContext is false (we did try to fetch context), and that no other Confluence
    // doc-type context (whiteboard, slides, database) is present — meaning this is a page.
    const isConfluencePageViewMode = productKey === 'confluence' && !skipEditorContext && !whiteboardContext && !slidesContext && !databaseContext ? editorContext === undefined : false;
    const creationContextIsViewMode = (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? creationContextParams?.isViewMode !== undefined ? creationContextParams.isViewMode : isViewMode || isConfluencePageViewMode : isViewMode;
    const isDraftLockedForEditing = !!editorContext?.isDraftLockedForEditing;
    const editorContentType = (0, $a608bfd48681563a$export$780f1f00b9b71ec)({
        editorContext: editorContext,
        whiteboardContext: whiteboardContext,
        databaseContext: databaseContext,
        slidesContext: slidesContext
    });
    const contentMauiId = editorContext?.contentMauiId ?? creationContextParams?.contentMauiId;
    const mediaFileId = editorContext?.mediaFileId ?? creationContextParams?.mediaFileId;
    // The collection id for the selected media node, sent so the backend can resolve the
    // current media's collection when editing an existing image (image-create action).
    // Only populated for the editor/page flow via read-content-command.
    const mediaCollection = editorContext?.mediaCollection;
    const creationContextSource = contentMauiId || mediaFileId ? 'remix' : // If source is explicitly passed, use that, otherwise rely on creationContextParams.source which is set at creation entry point (e.g. 'remix', 'ai-first-creation')
    source ?? creationContextParams?.source;
    const isRemixExperienceContextEnabled = (0, $ieeJu.expValEquals)('rovo_remix_experience_context', 'isEnabled', true) || // `rovo_remix_experience_context` only targets confluence_web; enable the remix
    // experience for the Jira remix-edit path via its own rollout flag.
    productKey !== 'confluence' && (0, $iDrrr.fg)('platform_editor_maui_jira_remix_edit');
    // The context store returns the raw content context; the outbound
    // creationContext experience/contentTypes are attached here when the request is built.
    const creationContextExperience = (0, $859bfbfa800411c6$export$e5ce245ce709fc21)({
        contentContextValue: contentContextValue,
        isFirstPrompt: isFirstPrompt,
        source: source,
        creationContextSource: creationContextParams?.source,
        existingExperience: creationContextParams?.experience,
        existingContentTypes: creationContextParams?.contentTypes,
        chatContextContentType: editorContentType,
        isRemixAction: isRemixAction,
        isViewMode: creationContextIsViewMode,
        contentMauiId: contentMauiId,
        mediaFileId: mediaFileId,
        isRemixExperienceContextEnabled: isRemixExperienceContextEnabled,
        isCreationContextContractEnabled: isCreationContextContractEnabled
    });
    // A remix edit must always carry the block being edited and its source, so these cannot stay
    // behind an unrelated experiment once the contract is enforced.
    const isRemixEditContract = isCreationContextContractEnabled && (creationContextExperience?.experience ?? creationContextParams?.experience) === 'remix_edit';
    const creationContextBlocks = (0, $281fa3f29881e068$export$e1dc015944c90cb9)({
        existingBlocks: creationContextParams?.blocks,
        experience: creationContextExperience?.experience ?? creationContextParams?.experience,
        source: creationContextSource,
        contentMauiId: contentMauiId,
        mediaFileId: mediaFileId,
        dynamicUiType: editorContext?.dynamicUiType ?? creationContextParams?.dynamicUiType,
        isRemixExperienceContextEnabled: isRemixExperienceContextEnabled,
        isCreationContextContractEnabled: isCreationContextContractEnabled
    });
    const creationContext = {
        ...creationContextParams ? creationContextParams : {},
        isStagingArea: contentContextValue === 'staging-area',
        productKey: productKey,
        // When `contentMauiId` or `mediaFileId` is present, we don't need to send the source
        // Ideally we want to set it upstream, but we need to ensure we don't break existing functionality
        source: creationContextSource,
        isViewMode: creationContextIsViewMode,
        isDraftLockedForEditing: isDraftLockedForEditing,
        useGenericEditorSkill: useGenericEditorSkill,
        additionalContext: additionalCreationContext || additionalCreationContextParams || mediaCollection ? {
            ...additionalCreationContext,
            ...additionalCreationContextParams,
            ...mediaCollection ? {
                mediaCollection: mediaCollection
            } : {}
        } : undefined,
        ...jiraContext && {
            jiraContext: jiraContext
        },
        ...((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) || isRemixEditContract) && {
            ...editorContext?.dynamicUiSource && {
                dynamicUiSource: {
                    ...editorContext.dynamicUiSource,
                    ...creationContextParams?.dynamicUiSource?.fragmentAdf && {
                        fragmentAdf: creationContextParams.dynamicUiSource.fragmentAdf
                    }
                }
            },
            ...(isRemixAction || source === 'remix' || creationContextParams?.source === 'remix' || isRemixEditContract) && {
                dynamicUiType: editorContext?.dynamicUiType || creationContextParams?.dynamicUiType || lastAssistantMessageDynamicUiType
            },
            ...editorContext?.dynamicUiSubtype && {
                dynamicUiSubtype: editorContext.dynamicUiSubtype
            },
            contentMauiId: contentMauiId,
            mediaFileId: mediaFileId
        },
        ...creationContextBlocks && {
            blocks: creationContextBlocks
        },
        // Derive experience and contentTypes for CWR staging-area follow-ups and global chat context.
        ...creationContextExperience
    };
    // A remix edit targets a block, not the content hosting it, so the contract requires every
    // surface context to be absent. The context is still resolved above, because it carries the
    // MAUI identifiers that classify the edit in the first place.
    const sendsSurfaceContext = !isRemixEditContract;
    // Bookmark
    return {
        browserContext: browserContext,
        editorContext: sendsSurfaceContext ? editorContext : undefined,
        whiteboardContext: sendsSurfaceContext ? whiteboardContext : undefined,
        slidesContext: sendsSurfaceContext ? slidesContext : undefined,
        databaseContext: sendsSurfaceContext ? databaseContext : undefined,
        dashboardEditorContext: dashboardEditorContext,
        additionalContext: {
            spaceCreateContext: await chatContextStoreActions.getSpaceCreateContext({
                isFirstPrompt: isFirstPrompt,
                contentContext: contentContextValue
            }),
            creationContext: isCreationContextContractEnabled ? (0, $d754fa0337b217c7$export$11b60038f3efc9bb)(creationContext) : creationContext,
            userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            search_artifact: searchArtifact
        },
        aiFeatureContext: chatContextStoreActions.getAIFeatureContext(),
        jiraWorkflowContext: chatContextStoreActions.getJiraWorkflowContext(),
        dashboardContext: chatContextStoreActions.getDashboardContext(),
        useCurrentBrowsingContext: chatContextStoreActions.useCurrentBrowsingContext(!!addCurrentPageAsContextUserPreference)
    };
};
module.exports["populateSendMessageContext"] = $d0254ff0647fc0e0$export$e038cea4925a1058;

});

parcelRegister("kc9aB", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");


var $8et9H = parcelRequire("8et9H");

const $4d3a981e5d8e63af$export$d6a1a695ea643f8e = (fragmentNodes)=>fragmentNodes.reduce((total, node)=>(0, $4EPzQ.reduce)(node, (count, n)=>n.type === 'text' ? count + (0, $8et9H.wordCount)(n.text) : count, total), 0);
module.exports["countFragmentWords"] = $4d3a981e5d8e63af$export$d6a1a695ea643f8e;

});

parcelRegister("fC0nb", function(module, exports) {
/**
 * Checks whether a top-level adf block has a given localId anywhere in its subtree.
 */ const $ab72d10cf1425a37$var$containsLocalId = (node, localId)=>{
    if (node.attrs?.localId === localId) return true;
    return (node.content ?? []).some((child)=>$ab72d10cf1425a37$var$containsLocalId(child, localId));
};
const $ab72d10cf1425a37$var$EXTENSION_NODE_TYPES = new Set([
    'extension',
    'bodiedExtension',
    'inlineExtension',
    'multiBodiedExtension'
]);
const $ab72d10cf1425a37$var$getTopLevelNodeAnatomy = (node)=>{
    if (!$ab72d10cf1425a37$var$EXTENSION_NODE_TYPES.has(node.type)) return node.type;
    const extensionKey = node.attrs?.extensionKey;
    if (typeof extensionKey !== 'string' || !extensionKey) return node.type;
    const extensionType = node.attrs?.extensionType;
    const isMacro = typeof extensionType === 'string' && extensionType.includes('macro');
    return `${isMacro ? 'macro' : 'extension'}:${extensionKey}`;
};
const $ab72d10cf1425a37$export$1e86d752377e082a = (fullAdf, startLocalId, endLocalId, options = {})=>{
    if (!startLocalId || !endLocalId) return [];
    try {
        const topLevelNodes = fullAdf?.content ?? [];
        // A selection anchor can be anywhere in the doc tree, not just at the top level. We need to know which top-level ADF component the selection belongs to.
        let startNodeIndex;
        let endNodeIndex;
        for(let i = 0; i < topLevelNodes.length; i++){
            if (startNodeIndex === undefined && $ab72d10cf1425a37$var$containsLocalId(topLevelNodes[i], startLocalId)) startNodeIndex = i;
            if (endNodeIndex === undefined && $ab72d10cf1425a37$var$containsLocalId(topLevelNodes[i], endLocalId)) endNodeIndex = i;
            if (startNodeIndex !== undefined && endNodeIndex !== undefined) break;
        }
        if (startNodeIndex === undefined || endNodeIndex === undefined) return [];
        // The editor gives IDs in selection direction (can be right-to-left), so we use
        // min/max to get everything between the two anchors regardless of order.
        const from = Math.min(startNodeIndex, endNodeIndex);
        const to = Math.max(startNodeIndex, endNodeIndex);
        return [
            ...new Set(topLevelNodes.slice(from, to + 1).filter(options.includeNode ?? (()=>true)).map($ab72d10cf1425a37$var$getTopLevelNodeAnatomy).filter((nodeAnatomy)=>Boolean(nodeAnatomy)))
        ];
    } catch  {
        // swallow the error and return nothing since this is just for analytics.
        return [];
    }
};
module.exports["getTopLevelNodeTypes"] = $ab72d10cf1425a37$export$1e86d752377e082a;

});

parcelRegister("coqKO", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $fjUOt = parcelRequire("fjUOt");

const $e59cbb2cf8d7a17c$export$3a4ed3ae96502e9e = (messages, messageId, agenticUiMessage)=>{
    return messages.map((chatItem)=>{
        if ((0, $igOtY.isStoreAssistant)(chatItem) && (0, $fjUOt.getStoreMessageId)(chatItem) === messageId) return {
            ...chatItem,
            agenticUiMessages: [
                ...chatItem.agenticUiMessages || [],
                ...agenticUiMessage.message.content
            ]
        };
        return chatItem;
    });
};
module.exports["addAgenticUiMessage"] = $e59cbb2cf8d7a17c$export$3a4ed3ae96502e9e;

});

parcelRegister("gulpi", function(module, exports) {
/** Display label and dedup key for the synthetic suggestion (not the prompt sent on click). */ const $5a4419e3b28274bd$export$43489e04a87de7d0 = 'Create a Confluence page from this response';
module.exports["CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT"] = $5a4419e3b28274bd$export$43489e04a87de7d0;

});

parcelRegister("cWJWG", function(module, exports) {
/**
 * Minimum interval threshold in milliseconds.
 * Intervals at or below this threshold are excluded from dead air tracking.
 */ const $659fb01017b58587$export$a47f8ff651baafd3 = 20;


const $748bcb1250622518$export$1dad78007a379433 = (intervalMs)=>{
    return intervalMs <= (0, $659fb01017b58587$export$a47f8ff651baafd3);
};
module.exports["shouldExcludeInterval"] = $748bcb1250622518$export$1dad78007a379433;

});

parcelRegister("i7OAD", function(module, exports) {
// ============================================================================
// ACTIONS that are shared between Confluence and Jira
// ============================================================================

var $iDrrr = parcelRequire("iDrrr");


var $dw75i = parcelRequire("dw75i");


var $igOtY = parcelRequire("igOtY");


var $eTCWv = parcelRequire("eTCWv");


var $aYC8J = parcelRequire("aYC8J");


var $9yffN = parcelRequire("9yffN");


var $1uJIC = parcelRequire("1uJIC");

const $5d644ffadb303a3b$export$992a8e659d5a1252 = (action)=>typeof action === 'object' && action !== null && 'key' in action;
const $5d644ffadb303a3b$export$74f7c5137689c9a9 = (action)=>(0, $aYC8J.isConfluenceCreateNewAction)(action) || (0, $9yffN.isJiraCreatableAction)(action) || (0, $1uJIC.isJsmCreatableAction)(action) || (0, $aYC8J.isDynamicUiCreatableAction)(action) || (0, $aYC8J.isImageCreatableAction)(action) || (0, $eTCWv.isAvpPreviewCardAction)(action);
const $5d644ffadb303a3b$export$8244c8e5412f2a57 = (message)=>(0, $aYC8J.isDynamicUiCreatableAction)(message) && !(0, $aYC8J.isDynamicUiUpdateActionData)(message.data) || (0, $aYC8J.isImageCreatableAction)(message) && !(0, $aYC8J.isImageUpdateActionData)(message.data);
const $5d644ffadb303a3b$export$95acec44a3c80403 = (action)=>(0, $aYC8J.isConfluenceUpdatableAction)(action) || (0, $9yffN.isJiraUpdatableAction)(action) || (0, $1uJIC.isJsmUpdatableAction)(action);
const $5d644ffadb303a3b$export$473ed8cdfdfcd6f4 = (action)=>$5d644ffadb303a3b$export$74f7c5137689c9a9(action) || $5d644ffadb303a3b$export$95acec44a3c80403(action);
const $5d644ffadb303a3b$export$a4e95791cb217646 = (action)=>{
    return (0, $aYC8J.getConfluenceContentType)(action) ?? (0, $9yffN.getJiraContentType)(action) ?? (0, $1uJIC.getJsmContentType)(action) ?? 'unknown';
};
const $5d644ffadb303a3b$export$29736db3162547c8 = (action)=>(0, $dw75i.ACTIONS_HIDING_FOOTER_BUTTONS).has(action.key);
const $5d644ffadb303a3b$export$83f1ae88eb290a18 = (action)=>action.key === (0, $dw75i.IMAGE_SEARCH_KEY);
const $5d644ffadb303a3b$export$154eb84770532af2 = (action)=>(0, $aYC8J.isConfluenceStreamAction)(action) || (0, $9yffN.isJiraStreamAction)(action) || (0, $1uJIC.isJsmStreamAction)(action) || (0, $eTCWv.isAvpStreamAction)(action) || $5d644ffadb303a3b$export$83f1ae88eb290a18(action) && (0, $iDrrr.fg)('rovo_chat_image_search_fe');
const $5d644ffadb303a3b$export$1382aef9948f8fc7 = (action)=>(0, $aYC8J.isConfluencePreviewCardAction)(action) || (0, $9yffN.isJiraPreviewCardAction)(action) || (0, $1uJIC.isJsmPreviewCardAction)(action) || (0, $aYC8J.isDynamicUiCreatableAction)(action) || (0, $aYC8J.isImageCreatableAction)(action) || (0, $eTCWv.isAvpPreviewCardAction)(action);
const $5d644ffadb303a3b$export$681cf9ea58de88fd = (action, identifier)=>{
    if (!(0, $iDrrr.fg)('jira_aifc_enabled')) return (0, $aYC8J.generateRovoReceiverId)(action, identifier ?? '');
    if (!$5d644ffadb303a3b$export$992a8e659d5a1252(action)) return undefined;
    if ((0, $9yffN.isJiraAction)(action)) return (0, $9yffN.generateJiraReceiverId)(action);
    if ((0, $1uJIC.isJsmAction)(action) && (0, $iDrrr.fg)('surveys-aifc')) return (0, $1uJIC.generateJsmReceiverId)(action);
    return (0, $aYC8J.generateRovoReceiverId)(action, identifier ?? '');
};
const $5d644ffadb303a3b$export$ea699f0d7930d4d4 = ({ action: action, isContentPreviewSupported: isContentPreviewSupported })=>{
    if ((0, $iDrrr.fg)('aifc_create_enabled')) return !$5d644ffadb303a3b$export$154eb84770532af2({
        key: action.key
    }) && !(0, $9yffN.isJiraCreatableAction)({
        key: action.key
    }) && !(0, $1uJIC.isJsmCreatableAction)({
        key: action.key
    }) && !(0, $eTCWv.isAvpPreviewCardAction)({
        key: action.key
    });
    if (!isContentPreviewSupported && !(0, $iDrrr.fg)('aifc_create_enabled')) return !$5d644ffadb303a3b$export$1382aef9948f8fc7(action);
    return true;
};
function $5d644ffadb303a3b$export$d94ea083820ef679(messages, invocationId) {
    return messages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && !!msg.content.message.message.actions?.some((action)=>action.invocationId === invocationId));
}
module.exports["isCreatableAction"] = $5d644ffadb303a3b$export$74f7c5137689c9a9;
module.exports["isEphemeralCreateAction"] = $5d644ffadb303a3b$export$8244c8e5412f2a57;
module.exports["isUpdatableAction"] = $5d644ffadb303a3b$export$95acec44a3c80403;
module.exports["isAIFCAction"] = $5d644ffadb303a3b$export$473ed8cdfdfcd6f4;
module.exports["getAIFCContentType"] = $5d644ffadb303a3b$export$a4e95791cb217646;
module.exports["isActionHidingFooterButtons"] = $5d644ffadb303a3b$export$29736db3162547c8;
module.exports["isSupportedStreamAction"] = $5d644ffadb303a3b$export$154eb84770532af2;
module.exports["isPreviewCardAction"] = $5d644ffadb303a3b$export$1382aef9948f8fc7;
module.exports["generateRovoReceiverId"] = $5d644ffadb303a3b$export$681cf9ea58de88fd;
module.exports["findMessageByInvocationId"] = $5d644ffadb303a3b$export$d94ea083820ef679;

});

parcelRegister("eTCWv", function(module, exports) {
const $3b90c63f679ea6c2$export$3e0063b4c9eccd95 = 'avp_chart_create';
function $3b90c63f679ea6c2$export$144269edab6271d9(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    const chartData = d.chartData;
    if (typeof chartData !== 'object' || chartData === null) return false;
    const cd = chartData;
    return typeof d.dashboardAri === 'string' && typeof cd.chart === 'object' && cd.chart !== null && typeof cd.canvasLayout === 'object' && cd.canvasLayout !== null;
}
const $3b90c63f679ea6c2$export$2faa8f3a24d96e39 = 'avp_chart_delete';
function $3b90c63f679ea6c2$export$9f17310825a1a178(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.chartId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $3b90c63f679ea6c2$export$a01e31e7aead77c1 = 'avp_chart_update';
function $3b90c63f679ea6c2$export$db13f09592330b3b(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    if (typeof d.dashboardAri !== 'string' || typeof d.chartId !== 'string') return false;
    const chartData = d.chartData;
    if (typeof chartData !== 'object' || chartData === null) return false;
    const cd = chartData;
    return typeof cd.chart === 'object' && cd.chart !== null;
}
const $3b90c63f679ea6c2$var$isStringArray = (value)=>Array.isArray(value) && value.every((item)=>typeof item === 'string');
const $3b90c63f679ea6c2$var$isAvpFilterExpressionPayload = (data)=>{
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && (d.filterExpression === null || typeof d.filterExpression === 'object' && d.filterExpression !== null);
};
const $3b90c63f679ea6c2$export$37d8bc8514392efa = 'avp_dashboard_create_filter';
function $3b90c63f679ea6c2$export$a21637e45432b3cd(data) {
    if (!$3b90c63f679ea6c2$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return d.expressionIds === undefined || $3b90c63f679ea6c2$var$isStringArray(d.expressionIds);
}
const $3b90c63f679ea6c2$export$1e6353bd95c91843 = 'avp_dashboard_delete_filter';
function $3b90c63f679ea6c2$export$9a3f223399a3708c(data) {
    if (!$3b90c63f679ea6c2$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return $3b90c63f679ea6c2$var$isStringArray(d.expressionIds);
}
const $3b90c63f679ea6c2$export$72caf49a260f725e = 'avp_dashboard_update_filter';
function $3b90c63f679ea6c2$export$c6efee5e04349169(data) {
    if (!$3b90c63f679ea6c2$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return typeof d.expressionId === 'string';
}
const $3b90c63f679ea6c2$export$e36a63f9bc6ec9d9 = 'avp_dashboard_remove_row';
function $3b90c63f679ea6c2$export$b8981fb8c2b2ceae(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.rowId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $3b90c63f679ea6c2$export$e21300173aaa5a75 = 'avp_dashboard_remove_element';
function $3b90c63f679ea6c2$export$393c0a783fee1203(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.elementId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $3b90c63f679ea6c2$export$5860e19fc7aa5d00 = 'avp_dashboard_create';
function $3b90c63f679ea6c2$export$eca0d9c93fb8ccc3(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardUrl === 'string' && typeof d.dashboardAri === 'string';
}
// ============================================================================
// AVP ACTION CLASSIFICATION
// ============================================================================
const $3b90c63f679ea6c2$var$AVP_CREATABLE_ACTION_KEYS = new Set([
    $3b90c63f679ea6c2$export$3e0063b4c9eccd95,
    $3b90c63f679ea6c2$export$5860e19fc7aa5d00,
    $3b90c63f679ea6c2$export$37d8bc8514392efa
]);
const $3b90c63f679ea6c2$var$AVP_PREVIEW_CARD_ACTION_KEYS = new Set([
    $3b90c63f679ea6c2$export$5860e19fc7aa5d00
]);
const $3b90c63f679ea6c2$export$6b9e1da20a0f005c = (action)=>$3b90c63f679ea6c2$var$AVP_PREVIEW_CARD_ACTION_KEYS.has(action.key);
const $3b90c63f679ea6c2$var$AVP_DELETABLE_ACTION_KEYS = new Set([
    $3b90c63f679ea6c2$export$2faa8f3a24d96e39,
    $3b90c63f679ea6c2$export$e21300173aaa5a75,
    $3b90c63f679ea6c2$export$e36a63f9bc6ec9d9,
    $3b90c63f679ea6c2$export$1e6353bd95c91843
]);
const $3b90c63f679ea6c2$var$AVP_UPDATABLE_ACTION_KEYS = new Set([
    $3b90c63f679ea6c2$export$a01e31e7aead77c1,
    $3b90c63f679ea6c2$export$72caf49a260f725e
]);
const $3b90c63f679ea6c2$export$d69ccc6d462afdf8 = (action)=>$3b90c63f679ea6c2$var$AVP_CREATABLE_ACTION_KEYS.has(action.key);
const $3b90c63f679ea6c2$export$edc9f9dece97635 = (action)=>$3b90c63f679ea6c2$var$AVP_DELETABLE_ACTION_KEYS.has(action.key);
const $3b90c63f679ea6c2$export$a2d39e4b08e0e68d = (action)=>$3b90c63f679ea6c2$var$AVP_UPDATABLE_ACTION_KEYS.has(action.key);
const $3b90c63f679ea6c2$export$ebb904732b24f004 = (action)=>$3b90c63f679ea6c2$export$d69ccc6d462afdf8(action) || $3b90c63f679ea6c2$export$edc9f9dece97635(action) || $3b90c63f679ea6c2$export$a2d39e4b08e0e68d(action);
module.exports["AVP_CHART_CREATE_KEY"] = $3b90c63f679ea6c2$export$3e0063b4c9eccd95;
module.exports["isAvpChartCreateActionData"] = $3b90c63f679ea6c2$export$144269edab6271d9;
module.exports["AVP_CHART_DELETE_KEY"] = $3b90c63f679ea6c2$export$2faa8f3a24d96e39;
module.exports["isAvpChartDeleteActionData"] = $3b90c63f679ea6c2$export$9f17310825a1a178;
module.exports["AVP_CHART_UPDATE_KEY"] = $3b90c63f679ea6c2$export$a01e31e7aead77c1;
module.exports["isAvpChartUpdateActionData"] = $3b90c63f679ea6c2$export$db13f09592330b3b;
module.exports["AVP_FILTER_EXPRESSION_CREATE_KEY"] = $3b90c63f679ea6c2$export$37d8bc8514392efa;
module.exports["isAvpFilterExpressionCreateActionData"] = $3b90c63f679ea6c2$export$a21637e45432b3cd;
module.exports["AVP_FILTER_EXPRESSION_DELETE_KEY"] = $3b90c63f679ea6c2$export$1e6353bd95c91843;
module.exports["isAvpFilterExpressionDeleteActionData"] = $3b90c63f679ea6c2$export$9a3f223399a3708c;
module.exports["AVP_FILTER_EXPRESSION_UPDATE_KEY"] = $3b90c63f679ea6c2$export$72caf49a260f725e;
module.exports["isAvpFilterExpressionUpdateActionData"] = $3b90c63f679ea6c2$export$c6efee5e04349169;
module.exports["AVP_DASHBOARD_REMOVE_ROW_KEY"] = $3b90c63f679ea6c2$export$e36a63f9bc6ec9d9;
module.exports["isAvpDashboardRemoveRowActionData"] = $3b90c63f679ea6c2$export$b8981fb8c2b2ceae;
module.exports["AVP_DASHBOARD_REMOVE_ELEMENT_KEY"] = $3b90c63f679ea6c2$export$e21300173aaa5a75;
module.exports["isAvpDashboardRemoveElementActionData"] = $3b90c63f679ea6c2$export$393c0a783fee1203;
module.exports["AVP_DASHBOARD_CREATE_KEY"] = $3b90c63f679ea6c2$export$5860e19fc7aa5d00;
module.exports["isAvpDashboardCreateActionData"] = $3b90c63f679ea6c2$export$eca0d9c93fb8ccc3;
module.exports["isAvpPreviewCardAction"] = $3b90c63f679ea6c2$export$6b9e1da20a0f005c;
module.exports["isAvpStreamAction"] = $3b90c63f679ea6c2$export$ebb904732b24f004;

});

parcelRegister("9yffN", function(module, exports) {
// ============================================================================
// JIRA SMART ISSUE CREATE
// ============================================================================

var $dw75i = parcelRequire("dw75i");


var $4MASx = parcelRequire("4MASx");

const $da7c2fc593a3d043$export$5f099b7754a7652a = [
    (0, $dw75i.JIRA_FIND_ISSUES_KEY),
    (0, $dw75i.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY),
    (0, $dw75i.JSM_CREATE_REQUEST_KEY),
    (0, $dw75i.JSM_CREATE_REQUEST_V2_KEY),
    (0, $dw75i.JSM_CREATE_EMBEDDED_REQUEST_KEY),
    (0, $dw75i.JIRA_ISSUE_TRANSITION_KEY),
    (0, $dw75i.JIRA_EPICS_SUGGEST_KEY),
    (0, $dw75i.JIRA_ISSUE_DELETE_KEY),
    (0, $dw75i.JIRA_ISSUE_MOVE_KEY),
    (0, $dw75i.JIRA_ISSUE_ASSIGN_KEY),
    (0, $dw75i.JIRA_VERSION_CREATE_KEY),
    (0, $dw75i.JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY)
];
const $da7c2fc593a3d043$export$29b82f3d15178d30 = new Set($da7c2fc593a3d043$export$5f099b7754a7652a);
const $da7c2fc593a3d043$export$211f4719f56285e9 = new Set([
    (0, $dw75i.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY)
]);
const $da7c2fc593a3d043$export$d75519ce8257cbe3 = new Set([
    (0, $dw75i.JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY)
]);
const $da7c2fc593a3d043$export$530aa0daf5811c30 = (action)=>{
    return typeof action === 'object' && action !== null && 'key' in action && $da7c2fc593a3d043$export$29b82f3d15178d30.has(action?.['key']);
};
const $da7c2fc593a3d043$export$b4d5023312147fc4 = (action)=>$da7c2fc593a3d043$export$530aa0daf5811c30(action) && $da7c2fc593a3d043$export$211f4719f56285e9.has(action.key);
const $da7c2fc593a3d043$export$69c28e373f39b349 = (action)=>$da7c2fc593a3d043$export$530aa0daf5811c30(action) && $da7c2fc593a3d043$export$d75519ce8257cbe3.has(action.key);
const $da7c2fc593a3d043$export$b5050b797265a8be = (action)=>false;
const $da7c2fc593a3d043$export$a1a30289a72c78b1 = (action)=>false;
const $da7c2fc593a3d043$export$6fe601f4a243e8f4 = (action)=>{
    if (!$da7c2fc593a3d043$export$530aa0daf5811c30(action)) return undefined;
    if ($da7c2fc593a3d043$export$b4d5023312147fc4(action)) return 0, $4MASx.JIRA_SMART_CREATE_TABLE_CLIENT_ID;
    return undefined;
};
const $da7c2fc593a3d043$export$1643c639e4c073b8 = (action)=>{
    const actionKey = action.key;
    if ($da7c2fc593a3d043$export$211f4719f56285e9.has(actionKey)) return 'jira-issue-table';
    return undefined;
};
// ============================================================================
// JIRA PREVIEW CARDS
// ============================================================================
const $da7c2fc593a3d043$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    (0, $dw75i.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY)
]);
const $da7c2fc593a3d043$export$4a1398b92436f797 = (action)=>$da7c2fc593a3d043$var$PREVIEW_CARD_ACTION_KEYS.has(action.key);
module.exports["isJiraAction"] = $da7c2fc593a3d043$export$530aa0daf5811c30;
module.exports["isJiraCreatableAction"] = $da7c2fc593a3d043$export$b4d5023312147fc4;
module.exports["isJiraPreviewableAction"] = $da7c2fc593a3d043$export$69c28e373f39b349;
module.exports["isJiraUpdatableAction"] = $da7c2fc593a3d043$export$b5050b797265a8be;
module.exports["isJiraStreamAction"] = $da7c2fc593a3d043$export$a1a30289a72c78b1;
module.exports["generateJiraReceiverId"] = $da7c2fc593a3d043$export$6fe601f4a243e8f4;
module.exports["getJiraContentType"] = $da7c2fc593a3d043$export$1643c639e4c073b8;
module.exports["isJiraPreviewCardAction"] = $da7c2fc593a3d043$export$4a1398b92436f797;

});

parcelRegister("1uJIC", function(module, exports) {
// ============================================================================
// JSM CREATE SURVEY
// ============================================================================

var $iDrrr = parcelRequire("iDrrr");


var $dw75i = parcelRequire("dw75i");


var $9Wwnb = parcelRequire("9Wwnb");


var $feawE = parcelRequire("feawE");

const $8b07e7ececb313be$export$4d5c499af23159fb = (0, $feawE.client)('jsm-queue-settings');





const $df0502af8f3c12f2$export$c1a656e72d7a4bcc = (0, $feawE.client)('jsm-request-type-settings');





const $abaaa1f0b0fee63a$export$bd769f5be4601367 = (0, $feawE.client)('jsm-sla-settings');



var $jNcTh = parcelRequire("jNcTh");


var $gFu06 = parcelRequire("gFu06");

const $f92035d15fc99246$var$JSM_EMBED_VIEW_MAP = {
    [(0, $dw75i.JSM_QUEUE_CREATE_KEY)]: {
        clientId: (0, $8b07e7ececb313be$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $dw75i.JSM_QUEUE_UPDATE_KEY)]: {
        clientId: (0, $8b07e7ececb313be$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $dw75i.JSM_QUEUE_GROUP_CREATE_KEY)]: {
        clientId: (0, $8b07e7ececb313be$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $dw75i.JSM_QUEUE_GROUP_UPDATE_KEY)]: {
        clientId: (0, $8b07e7ececb313be$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $dw75i.JSM_REQUEST_TYPE_UPDATED_KEY)]: {
        clientId: (0, $df0502af8f3c12f2$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    },
    [(0, $dw75i.JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY)]: {
        clientId: (0, $df0502af8f3c12f2$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    },
    [(0, $dw75i.JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY)]: {
        clientId: (0, $df0502af8f3c12f2$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    },
    [(0, $dw75i.JSM_SLA_CREATE_KEY)]: {
        clientId: (0, $abaaa1f0b0fee63a$export$bd769f5be4601367),
        contentType: 'jsm-sla-updated'
    },
    [(0, $dw75i.JSM_SLA_UPDATE_KEY)]: {
        clientId: (0, $abaaa1f0b0fee63a$export$bd769f5be4601367),
        contentType: 'jsm-sla-updated'
    },
    [(0, $dw75i.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)]: {
        clientId: (0, $df0502af8f3c12f2$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    }
};
const $f92035d15fc99246$export$fd2af7ce2e351879 = [
    (0, $dw75i.JSM_CREATE_EMBEDDED_REQUEST_KEY),
    (0, $dw75i.JSM_CREATE_FORM_TEMPLATE_KEY),
    (0, $dw75i.JSM_CREATE_REQUEST_KEY),
    (0, $dw75i.JSM_CREATE_REQUEST_V2_KEY),
    (0, $dw75i.JSM_CREATE_SURVEY_KEY),
    (0, $dw75i.JSM_QUEUE_CREATE_KEY),
    (0, $dw75i.JSM_QUEUE_GROUP_CREATE_KEY),
    (0, $dw75i.JSM_QUEUE_GROUP_UPDATE_KEY),
    (0, $dw75i.JSM_QUEUE_UPDATE_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_UPDATED_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY),
    (0, $dw75i.JSM_SLA_CREATE_KEY),
    (0, $dw75i.JSM_SLA_UPDATE_KEY),
    (0, $dw75i.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)
];
const $f92035d15fc99246$export$7b875f28b9805c0c = new Set($f92035d15fc99246$export$fd2af7ce2e351879);
const $f92035d15fc99246$export$3fcc5475955435c4 = new Set([
    (0, $dw75i.JSM_CREATE_SURVEY_KEY),
    (0, $dw75i.JSM_QUEUE_CREATE_KEY),
    (0, $dw75i.JSM_QUEUE_GROUP_CREATE_KEY),
    (0, $dw75i.JSM_QUEUE_GROUP_UPDATE_KEY),
    (0, $dw75i.JSM_QUEUE_UPDATE_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_UPDATED_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY),
    (0, $dw75i.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)
]);
const $f92035d15fc99246$var$isFormTemplateActionEnabled = (actionKey)=>actionKey === (0, $dw75i.JSM_CREATE_FORM_TEMPLATE_KEY) && (0, $iDrrr.fg)('soju-5536-forms-skill');
const $f92035d15fc99246$var$isKbFromScratchActionKey = (actionKey)=>(actionKey === (0, $dw75i.JSM_CREATE_KB_TOPICS_KEY) || actionKey === (0, $dw75i.JSM_CREATE_KB_ARTICLES_KEY)) && (0, $iDrrr.fg)('jsm_kb_from_scratch');
const $f92035d15fc99246$export$98885adfb17a807b = (action)=>{
    return typeof action === 'object' && action !== null && 'key' in action && ($f92035d15fc99246$export$7b875f28b9805c0c.has(action?.['key']) || $f92035d15fc99246$var$isKbFromScratchActionKey(action?.['key']));
};
const $f92035d15fc99246$export$29f39e9429d6b955 = (action)=>$f92035d15fc99246$export$98885adfb17a807b(action) && ($f92035d15fc99246$export$3fcc5475955435c4.has(action.key) || $f92035d15fc99246$var$isFormTemplateActionEnabled(action.key) || $f92035d15fc99246$var$isKbFromScratchActionKey(action.key));
const $f92035d15fc99246$export$ae7904ebe7bd5bb0 = (action)=>false;
const $f92035d15fc99246$export$f4d25026329e5a91 = (action)=>false;
const $f92035d15fc99246$export$af2b121ccb8f1449 = (action)=>{
    if (!$f92035d15fc99246$export$98885adfb17a807b(action)) return undefined;
    if ((0, $iDrrr.fg)('solution_composer_master')) {
        // Embed view actions — driven by lookup map
        const embedView = $f92035d15fc99246$var$JSM_EMBED_VIEW_MAP[action.key];
        if (embedView) return embedView.clientId;
    }
    if ($f92035d15fc99246$var$isKbFromScratchActionKey(action.key)) return 0, $9Wwnb.JSM_CREATE_KB_STAGING_AREA_CLIENT_ID;
    if ($f92035d15fc99246$var$isFormTemplateActionEnabled(action.key)) return 0, $jNcTh.JSM_CREATE_FORM_TEMPLATE_CLIENT_ID;
    if ($f92035d15fc99246$export$29f39e9429d6b955(action)) return 0, $gFu06.JSM_CREATE_SURVEY_CLIENT_ID;
    return undefined;
};
const $f92035d15fc99246$export$292f03726a3f6528 = (action)=>{
    const actionKey = action.key;
    if ($f92035d15fc99246$var$isFormTemplateActionEnabled(actionKey)) return 'jsm-create-form-template';
    if ((0, $iDrrr.fg)('solution_composer_master')) {
        // Embed view actions — driven by lookup map
        const embedView = $f92035d15fc99246$var$JSM_EMBED_VIEW_MAP[actionKey];
        if (embedView) return embedView.contentType;
    }
    if ($f92035d15fc99246$export$3fcc5475955435c4.has(actionKey) || $f92035d15fc99246$var$isKbFromScratchActionKey(actionKey)) return 'jsm-create-survey';
    return undefined;
};
// ============================================================================
// JSM PREVIEW CARDS
// ============================================================================
const $f92035d15fc99246$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    (0, $dw75i.JSM_CREATE_FORM_TEMPLATE_KEY),
    (0, $dw75i.JSM_CREATE_SURVEY_KEY)
]);
const $f92035d15fc99246$export$c8683ba29b03d037 = (action)=>$f92035d15fc99246$var$PREVIEW_CARD_ACTION_KEYS.has(action.key);
module.exports["isJsmAction"] = $f92035d15fc99246$export$98885adfb17a807b;
module.exports["isJsmCreatableAction"] = $f92035d15fc99246$export$29f39e9429d6b955;
module.exports["isJsmUpdatableAction"] = $f92035d15fc99246$export$ae7904ebe7bd5bb0;
module.exports["isJsmStreamAction"] = $f92035d15fc99246$export$f4d25026329e5a91;
module.exports["generateJsmReceiverId"] = $f92035d15fc99246$export$af2b121ccb8f1449;
module.exports["getJsmContentType"] = $f92035d15fc99246$export$292f03726a3f6528;
module.exports["isJsmPreviewCardAction"] = $f92035d15fc99246$export$c8683ba29b03d037;

});

parcelRegister("9Wwnb", function(module, exports) {

var $feawE = parcelRequire("feawE");

const $c3f2915889576348$export$91e704c2411cb3f5 = (0, $feawE.client)('jsm-create-kb');
const $c3f2915889576348$export$ee04bc09e7068b43 = (0, $feawE.client)('jsm-create-kb-staging-area');
const $c3f2915889576348$export$c608186adcac93ad = (0, $feawE.client)('jsm-create-kb-card');
module.exports["JSM_CREATE_KB_CLIENT_ID"] = $c3f2915889576348$export$91e704c2411cb3f5;
module.exports["JSM_CREATE_KB_STAGING_AREA_CLIENT_ID"] = $c3f2915889576348$export$ee04bc09e7068b43;
module.exports["JSM_KB_CARD_CLIENT_ID"] = $c3f2915889576348$export$c608186adcac93ad;

});

parcelRegister("jNcTh", function(module, exports) {

var $feawE = parcelRequire("feawE");

const $10851820f252f808$export$d570778e9983245b = (0, $feawE.client)('jsm-create-form-template');
module.exports["JSM_CREATE_FORM_TEMPLATE_CLIENT_ID"] = $10851820f252f808$export$d570778e9983245b;

});

parcelRegister("jr1ne", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iW40i = parcelRequire("iW40i");


var $c7So7 = parcelRequire("c7So7");

const $34f4f9147dd524c7$export$4124b3cbf6d26820 = ({ useSmartCreationChatStoreApi: useSmartCreationChatStoreApi })=>{
    const { activeConversation: activeConversation } = useSmartCreationChatStoreApi();
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: activeConversation?.id
    });
    return (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('aifc_show_connected_apps_auth_login_screen')) return null;
        if (chatMessages.length === 0) return null;
        const lastAssistantMessage = (0, $c7So7.findLastAssistantMessage)(chatMessages);
        if (!lastAssistantMessage) return null;
        return $34f4f9147dd524c7$export$74c2c8fe0412025(lastAssistantMessage?.content?.message?.message?.content ?? '');
    }, [
        chatMessages
    ]);
};
function $34f4f9147dd524c7$export$74c2c8fe0412025(content) {
    if (!content) return null;
    let textContent;
    if (typeof content === 'object') textContent = JSON.stringify(content);
    else textContent = content;
    const regex = /https:\/\/id\.(stg\.internal\.)?atlassian\.com\/outboundAuth\/start[^\s)"]*/g;
    const matches = textContent.match(regex);
    return matches ? matches[0] : null;
}
module.exports["useLastAssistantMessageAuthLink"] = $34f4f9147dd524c7$export$4124b3cbf6d26820;
module.exports["extractOutboundAuthLink"] = $34f4f9147dd524c7$export$74c2c8fe0412025;

});

parcelRegister("iW40i", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $5edf756ec3878422$var$store = (0, $8s9DV.createStore)({
    name: 'chatUseMessages',
    initialState: {},
    actions: {
        setMessages: (conversationId, messages)=>({ setState: setState })=>{
                setState({
                    [conversationId]: messages
                });
            },
        getMessages: (conversationId)=>({ getState: getState })=>{
                return getState()[conversationId] ?? [];
            }
    }
});
const $5edf756ec3878422$export$d5c60118ea64ef24 = (0, $kBr4q.createHook)($5edf756ec3878422$var$store, {
    selector: (state, { conversationId: conversationId })=>state[conversationId] ?? []
});
const $5edf756ec3878422$export$fcbbecdca7d55350 = (0, $kBr4q.createActionsHook)($5edf756ec3878422$var$store);
module.exports["useChatMessages"] = $5edf756ec3878422$export$d5c60118ea64ef24;
module.exports["useChatMessagesActions"] = $5edf756ec3878422$export$fcbbecdca7d55350;

});

parcelRegister("c7So7", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $nStJY = parcelRequire("nStJY");


var $i7OAD = parcelRequire("i7OAD");


var $9yffN = parcelRequire("9yffN");


var $dw75i = parcelRequire("dw75i");


var $igOtY = parcelRequire("igOtY");

function $8def780e3a1ebdcf$export$17828fb10c7c5928(messages, messageId) {
    return messages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && msg.content.message.message.id === messageId);
}
function $8def780e3a1ebdcf$export$c5f84c389beb0191(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $igOtY.isStoreAssistant)(msg) && (msg.content.message.message.actions || []).some((action)=>(0, $i7OAD.isCreatableAction)(action) || (0, $9yffN.isJiraPreviewableAction)(action))) return msg;
    }
    return undefined;
}
function $8def780e3a1ebdcf$export$551dda091e9d40ca(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $igOtY.isStoreAssistant)(msg) && (msg.content.message.message.actions || []).some((0, $i7OAD.isAIFCAction))) return msg;
    }
    return undefined;
}
function $8def780e3a1ebdcf$export$6f9d326b409b8a89(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $igOtY.isStoreAssistant)(msg)) return msg;
    }
    return undefined;
}
function $8def780e3a1ebdcf$export$ae4c648272f0b05(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $igOtY.isStoreAssistant)(msg) && msg.content.message.message.actions?.length) return msg.content.message.message.actions.some((action)=>action.key === (0, $dw75i.ASK_QUESTION_KEY));
    }
    return false;
}
function $8def780e3a1ebdcf$export$cde501ceecd81c44(message, invocationId) {
    if (!message || !invocationId) return message;
    const actions = message.content.message.message.actions;
    if (!actions || actions.length < 2) return message;
    const index = actions.findIndex((action)=>action.invocationId === invocationId);
    if (index <= 0) return message;
    const reorderedActions = [
        actions[index],
        ...actions.slice(0, index),
        ...actions.slice(index + 1)
    ];
    // Clone only the path down to `actions`; everything else (notably the streamed action `data`) is
    // shared by reference so we don't deep-copy potentially large ADF on every card switch.
    const assistantMessage = {
        ...message.content.message.message,
        actions: reorderedActions
    };
    return {
        ...message,
        content: {
            ...message.content,
            message: {
                ...message.content.message,
                message: assistantMessage
            }
        }
    };
}
// Resolves the creatable action a preview should use: the one matching `invocationId` when given
// (a message can hold several creatable actions), otherwise the first creatable action.
function $8def780e3a1ebdcf$var$findPreviewAction(message, invocationId) {
    const actions = message?.content?.message?.message?.actions;
    if (invocationId) {
        const byInvocation = actions?.find((action)=>action.invocationId === invocationId && (0, $i7OAD.isCreatableAction)(action));
        if (byInvocation) return byInvocation;
    }
    return actions?.find((0, $i7OAD.isCreatableAction));
}
function $8def780e3a1ebdcf$export$e839ab847bfd35fb(message, invocationId) {
    const action = $8def780e3a1ebdcf$var$findPreviewAction(message, invocationId);
    const contentId = action?.data?.contentId;
    // always make it a string since the final response sometimes returns a number and re-renders the iframe.
    return contentId === undefined ? undefined : String(contentId);
}
function $8def780e3a1ebdcf$export$460905b2c4dc18c9(message) {
    return message?.content?.message?.message?.actions?.[0];
}
function $8def780e3a1ebdcf$export$b05803156e5015b6(message, invocationId) {
    const action = $8def780e3a1ebdcf$var$findPreviewAction(message, invocationId);
    return action?.data?.title;
}
function $8def780e3a1ebdcf$export$4382776317fc294f(message, invocationId) {
    if (!message) return undefined;
    const actions = message?.content?.message?.message?.actions;
    const aifcAction = invocationId ? actions?.find((action)=>action.invocationId === invocationId && (0, $i7OAD.isAIFCAction)(action)) : actions?.find((0, $i7OAD.isAIFCAction));
    if (aifcAction) {
        const status = aifcAction?.status?.toLowerCase();
        if (status === 'preparing' || status === 'streaming') return status;
        // 'Planned' is the same as a final response. If we see it, assume streaming is complete.
        if (status === 'planned' || status === 'finished' || status === 'cancelled' || message.content.streamingComplete) return 'complete';
    }
    return undefined;
}
function $8def780e3a1ebdcf$var$getStableMessageParts(message) {
    const action = message.content.message.message.actions?.find((0, $i7OAD.isCreatableAction));
    const actionData = action?.data;
    // We just pick the parts we care about directly from the message
    // We avoid ADF since that is streamed and changes all the time.
    return {
        messageId: message.content.message.message.id,
        streamingComplete: message.content.streamingComplete,
        action: actionData ? (0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(actionData, [
            'contentId',
            'title',
            'mediaFileId'
        ]) : undefined,
        status: action?.status,
        traceId: message.traceId
    };
}
function $8def780e3a1ebdcf$export$c90c71e0e0065a6(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))($8def780e3a1ebdcf$var$getStableMessageParts(a), $8def780e3a1ebdcf$var$getStableMessageParts(b));
}
module.exports["findMessageById"] = $8def780e3a1ebdcf$export$17828fb10c7c5928;
module.exports["findLastMessageWithCreateAction"] = $8def780e3a1ebdcf$export$c5f84c389beb0191;
module.exports["findLastMessageWithAIFCAction"] = $8def780e3a1ebdcf$export$551dda091e9d40ca;
module.exports["findLastAssistantMessage"] = $8def780e3a1ebdcf$export$6f9d326b409b8a89;
module.exports["isLatestActionMessageAskQuestion"] = $8def780e3a1ebdcf$export$ae4c648272f0b05;
module.exports["withSelectedActionFirst"] = $8def780e3a1ebdcf$export$cde501ceecd81c44;
module.exports["extractContentId"] = $8def780e3a1ebdcf$export$e839ab847bfd35fb;
module.exports["getFirstMessageAction"] = $8def780e3a1ebdcf$export$460905b2c4dc18c9;
module.exports["extractTitle"] = $8def780e3a1ebdcf$export$b05803156e5015b6;
module.exports["getAIFCActionStatus"] = $8def780e3a1ebdcf$export$4382776317fc294f;
module.exports["areMessagesEqual"] = $8def780e3a1ebdcf$export$c90c71e0e0065a6;

});

parcelRegister("1dlVf", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $hpOyG = parcelRequire("hpOyG");


var $1Tpom = parcelRequire("1Tpom");

const $502ee9e70a8bf8b6$export$24a03a39abc3110e = ()=>{
    const additionalAttributes = {
        isInitialDataReceived: null
    };
    const subExperienceCollect = (0, $hpOyG.collectAllWithSubExperienceAttributes)([
        (0, $irnO2.ExperienceName).AIFC_MESSAGE,
        (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED
    ], additionalAttributes);
    return (events, experience)=>{
        for (const event of events)if (event.name === (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED) {
            if (event.action === 'taskSuccess') additionalAttributes.isInitialDataReceived = true;
            else if (event.action === 'taskFail') additionalAttributes.isInitialDataReceived = false;
        }
        // If AIFC_INITIAL_DATA_RECEIVED fails, fail AIFC_GENERATE_CONTENT
        (0, $1Tpom.failExperienceOnSubExperienceFail)((0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED, experience, events, additionalAttributes);
        subExperienceCollect(events, experience);
    };
};
module.exports["createAifcExperienceCollect"] = $502ee9e70a8bf8b6$export$24a03a39abc3110e;

});

parcelRegister("4KNZy", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");

const $1a12400c97e2750c$var$latestUserSubmissionByConversation = new Map();
const $1a12400c97e2750c$export$7054fc0c83e73365 = {
    recordLatestUserSubmission (submission, { abortSignal: abortSignal } = {}) {
        $1a12400c97e2750c$var$latestUserSubmissionByConversation.set(submission.conversationId, submission);
        const clearIfStillLatest = ()=>{
            if ($1a12400c97e2750c$var$latestUserSubmissionByConversation.get(submission.conversationId) === submission) $1a12400c97e2750c$var$latestUserSubmissionByConversation.delete(submission.conversationId);
        };
        if (abortSignal?.aborted) clearIfStillLatest();
        else if (abortSignal) (0, $cbY7C.bind)(abortSignal, {
            type: 'abort',
            listener: clearIfStillLatest,
            options: {
                once: true
            }
        });
        return clearIfStillLatest;
    },
    getLatestUserSubmission (conversationId) {
        return $1a12400c97e2750c$var$latestUserSubmissionByConversation.get(conversationId);
    },
    replaceHumanMessageId ({ conversationId: conversationId, oldId: oldId, newId: newId }) {
        const submission = $1a12400c97e2750c$var$latestUserSubmissionByConversation.get(conversationId);
        if (submission?.humanMessageId === oldId) submission.humanMessageId = newId;
    },
    clearLatestUserSubmission ({ conversationId: conversationId, humanMessageId: humanMessageId }) {
        const submission = $1a12400c97e2750c$var$latestUserSubmissionByConversation.get(conversationId);
        if (!humanMessageId || submission?.humanMessageId === humanMessageId) $1a12400c97e2750c$var$latestUserSubmissionByConversation.delete(conversationId);
    }
};
module.exports["userSubmissionLifecycle"] = $1a12400c97e2750c$export$7054fc0c83e73365;

});

parcelRegister("6yl1r", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $db3c42afc4fa6735$export$c928e016dc251d41 = ()=>(0, $iDrrr.fg)('jira_ai_task_level_planning_ootb_agent') || (0, $iDrrr.fg)('jira-ai-agentic-planning-technical-changes') || (0, $iDrrr.fg)('jira-ai-repo-selection-technical-extraction');
module.exports["isPlanWorkItemTechChangesEnabled"] = $db3c42afc4fa6735$export$c928e016dc251d41;

});

parcelRegister("4tJut", function(module, exports) {

var $iDdTC = parcelRequire("iDdTC");

const $d8449325d3bd5f74$export$86db56030b57ba34 = {
    initializeChannels: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.initialize-channels'
    }),
    timeToRenderMessageContent: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.time-to-render-message-content'
    }),
    timeToRenderFinalResponse: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.time-to-render-final-response'
    }),
    sendConfirmedToolsTimeToFinishStream: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.send-confirmed-tools.time-to-finish-stream'
    }),
    sendConfirmedToolsTimeToFirstAnswerPart: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.send-confirmed-tools.time-to-first-answer-part'
    }),
    messageCompositionTime: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.message-composition-time'
    })
};
module.exports["interactionMetrics"] = $d8449325d3bd5f74$export$86db56030b57ba34;

});

parcelRegister("bFeyZ", function(module, exports) {

var $iqkMb = parcelRequire("iqkMb");

const $62c65da6b8eb1f61$export$bab8a3e4fa0b7d89 = (storeAssistant)=>(0, $iqkMb.getInteractionModeExecutedFromStreamResponse)(storeAssistant?.content);
module.exports["getInteractionModeExecutedFromStoreAssistant"] = $62c65da6b8eb1f61$export$bab8a3e4fa0b7d89;

});

parcelRegister("jcJSP", function(module, exports) {
// findLastIndex polyfill since it's a newer ECMAScript feature
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findLastIndex
const $ec7fe81370ed0fdb$export$8855a8be7bd3e9f8 = (array, predicate)=>{
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i])) return i;
    }
    return -1;
};
module.exports["findLastIndex"] = $ec7fe81370ed0fdb$export$8855a8be7bd3e9f8;

});

parcelRegister("3TxKn", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $lx3cN = parcelRequire("lx3cN");

const $78444cf71927560a$export$b8d7540a5f22fede = (0, $kBr4q.createActionsHook)((0, $lx3cN.chatStore));
module.exports["useChatStoreActions"] = $78444cf71927560a$export$b8d7540a5f22fede;

});

parcelRegister("kQqCc", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $d52db76b74818184$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $d52db76b74818184$export$64aee74ba59709e5 = 439; // px
const $d52db76b74818184$export$1c07393c5bb1bc27 = 439; // px
const $d52db76b74818184$export$aa3478deee7adbeb = 350; // px
const $d52db76b74818184$export$21e515a86cd1733b = 'Chat';
const $d52db76b74818184$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $d52db76b74818184$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $d52db76b74818184$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $d52db76b74818184$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $d52db76b74818184$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $d52db76b74818184$export$e942bf04e23ff966;

});

parcelRegister("93Gae", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $7c0481f515a47ac9$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};


const $081573ec09156b80$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    isFullScreenModalAvailable: false,
    initialPrompt: undefined,
    openWithChatHistory: false,
    targetConversationId: null,
    autoFocusInput: true,
    wasAutoOpened: false,
    editorHadFocusBeforeChatOpen: false
};
const $081573ec09156b80$var$store = (0, $8s9DV.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $081573ec09156b80$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($081573ec09156b80$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode,
                    wasAutoOpened: false
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        setOpenWithChatHistory: (openWithChatHistory)=>({ setState: setState })=>{
                setState({
                    openWithChatHistory: openWithChatHistory
                });
            },
        setTargetConversationId: (targetConversationId)=>({ setState: setState })=>{
                setState({
                    targetConversationId: targetConversationId
                });
            },
        setWasAutoOpened: (wasAutoOpened)=>({ setState: setState })=>{
                setState({
                    wasAutoOpened: wasAutoOpened
                });
            },
        setEditorHadFocusBeforeChatOpen: (editorHadFocusBeforeChatOpen)=>({ setState: setState })=>{
                setState({
                    editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined,
                        autoFocusInput: true,
                        wasAutoOpened: false
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
              which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).MINI_MODAL:
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).FULL_SCREEN_MODAL:
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                }
            },
        openConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // Already in the desired mode — ensure the sidebar is actually
                // visible (it may have been displaced by another panel) but
                // otherwise treat this as a no-op.
                if (currentMode === targetMode) {
                    if (targetMode === (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).SIDEBAR && !sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                    return;
                }
                // Switch to the target mode
                switch(targetMode){
                    case (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        // wasAutoOpened is managed by the dedicated setWasAutoOpened action and reset on close/toggle/setMode.
                        setState({
                            mode: (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput
                        });
                        return;
                    case (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $7c0481f515a47ac9$export$bc36ebf73899a71d).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            },
        setIsFullScreenModalAvailable: (isFullScreenModalAvailable)=>({ setState: setState })=>{
                setState({
                    isFullScreenModalAvailable: isFullScreenModalAvailable
                });
            }
    }
});
const $081573ec09156b80$var$useStore = (0, $kBr4q.createHook)($081573ec09156b80$var$store);
const $081573ec09156b80$export$37440b51449f7ac6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(22);
    const [t0, t1] = $081573ec09156b80$var$useStore();
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, targetConversationId: targetConversationId, autoFocusInput: autoFocusInput, wasAutoOpened: wasAutoOpened, editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen } = t0;
    const { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId, setWasAutoOpened: setWasAutoOpened, setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable } = t1;
    let t2;
    if ($[0] !== autoFocusInput || $[1] !== clearInitialPrompt || $[2] !== editorHadFocusBeforeChatOpen || $[3] !== initialPrompt || $[4] !== isFullScreenModalAvailable || $[5] !== isMiniModalAvailable || $[6] !== isSidebarAvailable || $[7] !== mode || $[8] !== openConversationAssistantUIMode || $[9] !== openWithChatHistory || $[10] !== reset || $[11] !== setEditorHadFocusBeforeChatOpen || $[12] !== setIsFullScreenModalAvailable || $[13] !== setIsMiniModalAvailable || $[14] !== setIsSidebarAvailable || $[15] !== setOpenWithChatHistory || $[16] !== setTargetConversationId || $[17] !== setWasAutoOpened || $[18] !== targetConversationId || $[19] !== toggleConversationAssistantUIMode || $[20] !== wasAutoOpened) {
        t2 = {
            mode: mode,
            initialPrompt: initialPrompt,
            openWithChatHistory: openWithChatHistory,
            targetConversationId: targetConversationId,
            autoFocusInput: autoFocusInput,
            wasAutoOpened: wasAutoOpened,
            editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen,
            reset: reset,
            clearInitialPrompt: clearInitialPrompt,
            setOpenWithChatHistory: setOpenWithChatHistory,
            setTargetConversationId: setTargetConversationId,
            setWasAutoOpened: setWasAutoOpened,
            setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen,
            toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
            openConversationAssistantUIMode: openConversationAssistantUIMode,
            setIsMiniModalAvailable: setIsMiniModalAvailable,
            setIsSidebarAvailable: setIsSidebarAvailable,
            setIsFullScreenModalAvailable: setIsFullScreenModalAvailable,
            isMiniModalAvailable: isMiniModalAvailable,
            isSidebarAvailable: isSidebarAvailable,
            isFullScreenModalAvailable: isFullScreenModalAvailable
        };
        $[0] = autoFocusInput;
        $[1] = clearInitialPrompt;
        $[2] = editorHadFocusBeforeChatOpen;
        $[3] = initialPrompt;
        $[4] = isFullScreenModalAvailable;
        $[5] = isMiniModalAvailable;
        $[6] = isSidebarAvailable;
        $[7] = mode;
        $[8] = openConversationAssistantUIMode;
        $[9] = openWithChatHistory;
        $[10] = reset;
        $[11] = setEditorHadFocusBeforeChatOpen;
        $[12] = setIsFullScreenModalAvailable;
        $[13] = setIsMiniModalAvailable;
        $[14] = setIsSidebarAvailable;
        $[15] = setOpenWithChatHistory;
        $[16] = setTargetConversationId;
        $[17] = setWasAutoOpened;
        $[18] = targetConversationId;
        $[19] = toggleConversationAssistantUIMode;
        $[20] = wasAutoOpened;
        $[21] = t2;
    } else t2 = $[21];
    return t2;
} : ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, targetConversationId: targetConversationId, autoFocusInput: autoFocusInput, wasAutoOpened: wasAutoOpened, editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen }, { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId, setWasAutoOpened: setWasAutoOpened, setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable }] = $081573ec09156b80$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        openWithChatHistory: openWithChatHistory,
        targetConversationId: targetConversationId,
        autoFocusInput: autoFocusInput,
        wasAutoOpened: wasAutoOpened,
        editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        setOpenWithChatHistory: setOpenWithChatHistory,
        setTargetConversationId: setTargetConversationId,
        setWasAutoOpened: setWasAutoOpened,
        setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        openConversationAssistantUIMode: openConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        setIsFullScreenModalAvailable: setIsFullScreenModalAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable,
        isFullScreenModalAvailable: isFullScreenModalAvailable
    };
};
const $081573ec09156b80$export$66cf76b7e04da11f = (0, $kBr4q.createActionsHook)($081573ec09156b80$var$store);
module.exports["useRovoExperienceAPIStore"] = $081573ec09156b80$export$37440b51449f7ac6;

});

parcelRegister("2bR8c", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kQqCc = parcelRequire("kQqCc");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $cozmU.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("jyZaR", function(module, exports) {

var $igOtY = parcelRequire("igOtY");

const $45b4795bcee59329$export$b53f205a52449551 = ({ lastAgentMessageStatus: lastAgentMessageStatus })=>({
        status: (0, $igOtY.CHAT_STORE_STATUS).idle,
        traces: [],
        storeAbortController: undefined,
        ...lastAgentMessageStatus !== undefined && {
            lastAgentMessageStatus: lastAgentMessageStatus
        }
    });
module.exports["clearStatus"] = $45b4795bcee59329$export$b53f205a52449551;

});

parcelRegister("l6xCb", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hlvTd = parcelRequire("hlvTd");


var $6geN3 = parcelRequire("6geN3");


var $8zf2J = parcelRequire("8zf2J");

const $aa6ef2d1d495b174$var$isFromPreviousSite = (api, containerProps)=>{
    const actionSiteId = containerProps.siteId;
    if (!actionSiteId) return false;
    const { hydratedSiteId: hydratedSiteId } = api.getState();
    return hydratedSiteId !== undefined && hydratedSiteId !== actionSiteId;
};
const $aa6ef2d1d495b174$var$withSiteGuard = (api, containerProps, actionLoggableName)=>{
    const actionSiteId = containerProps.siteId;
    if (!actionSiteId) return api;
    const dropped = (what)=>{
        (0, $hlvTd.addSentryBreadcrumb)(`createSafeAction: dropped ${actionLoggableName} ${what} from a previous site`);
    };
    return {
        getState: api.getState,
        setState: (partialState)=>{
            if ($aa6ef2d1d495b174$var$isFromPreviousSite(api, containerProps)) {
                dropped('state update');
                return;
            }
            api.setState(partialState);
        },
        dispatch: (actionThunk)=>{
            if ($aa6ef2d1d495b174$var$isFromPreviousSite(api, containerProps)) {
                dropped('dispatch');
                return undefined;
            }
            return api.dispatch(actionThunk);
        }
    };
};
const $aa6ef2d1d495b174$export$f65ce059a9114838 = (actionLoggableName, actionHOF, props)=>(...args)=>async (api, containerProps)=>{
            const guardedApi = (0, $iDrrr.fg)('rovo_chat_site_switch_reset') ? $aa6ef2d1d495b174$var$withSiteGuard(api, containerProps, actionLoggableName) : api;
            /*
    Add custom logic here
   */ // General try/catch statement to handle unexpected errors
            try {
                (0, $hlvTd.addSentryBreadcrumb)(`createSafeAction: executing ${actionLoggableName}`);
                // Here we call the action callback
                // Same as dispatch(actionHOF)
                const action = actionHOF(...args);
                // Here we execute the action i.e. what happens internally when the action is dispatched
                const result = await action(guardedApi, containerProps);
                return result;
            } catch (error) {
                // `storeErrorHandler` reports through `containerProps`, which the guarded api cannot
                // reach, so a late rejection would return the new site to the error state the switch
                // just cleared.
                if ((0, $iDrrr.fg)('rovo_chat_site_switch_reset') && $aa6ef2d1d495b174$var$isFromPreviousSite(api, containerProps)) {
                    (0, $hlvTd.addSentryBreadcrumb)(`createSafeAction: dropped ${actionLoggableName} error handling from a previous site`);
                    // Abort, not fail: the request was abandoned by the site change.
                    if (props?.experienceName) containerProps.experienceTracker.abort({
                        name: props.experienceName(args),
                        reason: 'site changed'
                    });
                    return undefined;
                }
                (0, $8zf2J.storeErrorHandler)({
                    args: args,
                    api: guardedApi,
                    actionLoggableName: actionLoggableName,
                    error: error,
                    containerProps: containerProps,
                    setConversationData: $6geN3.setConversationData,
                    experienceName: props?.experienceName,
                    getRateLimitState: props?.getRateLimitState,
                    actionErrorHandler: props?.actionErrorHandler
                });
                return undefined;
            }
        };
module.exports["createSafeAction"] = $aa6ef2d1d495b174$export$f65ce059a9114838;

});

parcelRegister("16g08", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");

const $f6dab18fdd29edf9$export$4bae3e18e89647a6 = (params)=>{
    if (params.isCustomRovoAgent) return (0, $irnO2.ExperienceName).SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (params.deepResearchEnabled) return (0, $irnO2.ExperienceName).SEND_DR_MESSAGE;
    if (params.thinkDeeperEnabled) return (0, $irnO2.ExperienceName).SEND_TD_MESSAGE;
    if (params.taskModeEnabled) return (0, $irnO2.ExperienceName).SEND_TASK_MODE_MESSAGE;
    return (0, $irnO2.ExperienceName).SEND_MESSAGE;
};
module.exports["getSendMessageExperienceName"] = $f6dab18fdd29edf9$export$4bae3e18e89647a6;

});

parcelRegister("6geN3", function(module, exports) {
const $f69dde7553530487$export$5f5161e42606b2f1 = ({ conversationId: conversationId, data: data })=>({ getState: getState, setState: setState })=>{
        if (!getState().conversations[conversationId]) return;
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId],
                    ...data
                }
            }
        });
    };
module.exports["setConversationData"] = $f69dde7553530487$export$5f5161e42606b2f1;

});

parcelRegister("b6N3q", function(module, exports) {
const $e6fbdb99a6cf72b1$var$generateTraceId = ()=>`${Date.now().toString(16)}-${Math.floor(Math.random() * 1e4).toString(16)}`;
class $e6fbdb99a6cf72b1$export$63af9387abd4676e extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            requestId: params.requestId,
            traceId: params.traceId ?? params.requestId ?? `RovoChatStreamTimeout-${$e6fbdb99a6cf72b1$var$generateTraceId()}`
        };
    }
}
module.exports["RovoChatStreamTimeoutError"] = $e6fbdb99a6cf72b1$export$63af9387abd4676e;

});

parcelRegister("bMRok", function(module, exports) {

var $64wzj = parcelRequire("64wzj");

class $60d28b90aa6f9524$export$f2869f2905168ef1 extends Error {
    constructor(message, params = {}){
        super(message);
        this.errorAttributes = void 0;
        this.message_template = void 0;
        this.name = this.constructor.name;
        this.message_template = 'DEEP_RESEARCH_ERROR';
        this.errorAttributes = {
            errorCode: 'DEEP_RESEARCH_ERROR',
            traceId: params.traceId ?? `DeepResearch-${(0, $64wzj.generateTraceId)()}`,
            requestId: params.requestId
        };
    }
}
module.exports["DeepResearchError"] = $60d28b90aa6f9524$export$f2869f2905168ef1;

});

parcelRegister("hHBvs", function(module, exports) {
class $2db34f132729276a$export$a4ff042cd5c23500 extends Error {
    constructor(params){
        super(params.message);
        this.errorAttributes = void 0;
        this.cause = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            conversationId: params.conversationId,
            messageId: params.messageId,
            invocationId: params.invocationId,
            actionKey: params.actionKey
        };
        if (params.cause) this.cause = params.cause;
    }
}
module.exports["MessageActionError"] = $2db34f132729276a$export$a4ff042cd5c23500;

});

parcelRegister("kncFb", function(module, exports) {

var $64wzj = parcelRequire("64wzj");

class $75b7e2ed8237dfd5$export$cdcaebd3b25a3ac3 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            traceId: params.traceId ?? `NoFinalResponse-${(0, $64wzj.generateTraceId)()}`
        };
    }
}
module.exports["NoFinalResponseError"] = $75b7e2ed8237dfd5$export$cdcaebd3b25a3ac3;

});

parcelRegister("hwHCO", function(module, exports) {

var $64wzj = parcelRequire("64wzj");

class $fa6e1ddcaead349c$export$7ed16f132715a198 extends Error {
    constructor(message, params){
        const { detail: detail, traceId: traceId } = params;
        super(message);
        this.detail = void 0;
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        this.detail = detail;
        this.errorAttributes = {
            errorCode: this.detail.message.message_template,
            statusCode: this.detail.message.status_code,
            rawErrorMessage: this.detail.message.content,
            // in case there is no traceId, we generate one in FE
            // and make it distinguishable from BE generated traceId
            // appended by random 5 digit number
            traceId: traceId ?? `StreamError-${(0, $64wzj.generateTraceId)()}`,
            requestId: this.detail.metadata?.request_id,
            latestStreamMessageType: this.detail.type,
            latestStreamMessageMillisOffset: this.detail.millisOffset
        };
    }
}
module.exports["StreamErrorException"] = $fa6e1ddcaead349c$export$7ed16f132715a198;

});

parcelRegister("bQxqB", function(module, exports) {

var $64wzj = parcelRequire("64wzj");

class $66c03daf42c2e3ec$export$7a01d8a5a5a1ae0a extends Error {
    constructor(message, params, cause){
        super(message);
        this.errorAttributes = void 0;
        this.cause = void 0;
        this.name = this.constructor.name;
        this.cause = cause;
        this.errorAttributes = {
            traceId: params.traceId ?? `StreamGenerator-${(0, $64wzj.generateTraceId)()}`,
            latestStreamMessageType: params.detail?.type,
            latestStreamMessageMillisOffset: params.detail?.millisOffset
        };
    }
}
module.exports["StreamGeneratorError"] = $66c03daf42c2e3ec$export$7a01d8a5a5a1ae0a;

});

parcelRegister("icBz6", function(module, exports) {
const $44b6de0f59a4542f$export$567fc7097e064344 = ()=>String(Math.floor(Math.random() * 1000000));
module.exports["generateId"] = $44b6de0f59a4542f$export$567fc7097e064344;

});

parcelRegister("cWP9O", function(module, exports) {

var $bkEBw = parcelRequire("bkEBw");


var $igOtY = parcelRequire("igOtY");

const $19ee74b7a1ea01da$export$7fd69d5cdd838542 = (messages, messageId)=>{
    let index = -1;
    const result = messages.find((item, i)=>{
        index = i;
        return (0, $igOtY.isStoreAssistant)(item) && (0, $bkEBw.getId)(item.content) === messageId;
    });
    return result ? {
        result: result,
        index: index
    } : {
        result: false,
        index: index
    };
};
module.exports["getAgentMessageById"] = $19ee74b7a1ea01da$export$7fd69d5cdd838542;

});

parcelRegister("3iEfv", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6Bfyn = parcelRequire("6Bfyn");


var $4vH8u = parcelRequire("4vH8u");


var $5XX4K = parcelRequire("5XX4K");

const $792d422e77036578$export$b7cc8b01149baaeb = ({ streamMessage: streamMessage, markdownData: markdownData })=>{
    if (!(0, $iDrrr.fg)('rovo_chat_actionable_followups_enabled')) return streamMessage;
    const followUpsMsg = (0, $5XX4K.extractMarkdownContent)({
        streamMessage: streamMessage,
        boundaryStart: (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_MARKER),
        boundaryEnd: '',
        replacementContent: `\n\n[^${(0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY)}^]\n\n`
    });
    followUpsMsg.boundaryContents.forEach((content, index)=>{
        markdownData[`${0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY}-${index}`] = content;
    });
    return followUpsMsg.processedStreamMessage;
};
module.exports["extractActionableFollowUpsMarkdownData"] = $792d422e77036578$export$b7cc8b01149baaeb;

});

parcelRegister("5XX4K", function(module, exports) {

var $f3OgL = parcelRequire("f3OgL");


var $bxkJA = parcelRequire("bxkJA");

const $bb8517d09864aa83$export$bb73d89e7217c465 = ({ streamMessage: streamMessage, boundaryStart: boundaryStart, boundaryEnd: boundaryEnd, replacementContent: replacementContent })=>{
    const messageContent = (0, $bxkJA.isStreamResponse)(streamMessage) ? streamMessage.message.message.content : streamMessage.message.content;
    if (!messageContent || typeof messageContent !== 'string') return {
        processedStreamMessage: streamMessage,
        boundaryContents: []
    };
    const { processedText: processedText, boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(messageContent, boundaryStart, boundaryEnd, replacementContent);
    if (boundaryContents.length > 0) {
        if ((0, $bxkJA.isStreamResponse)(streamMessage)) streamMessage.message.message.content = processedText;
        else streamMessage.message.content = processedText;
    }
    return {
        processedStreamMessage: streamMessage,
        boundaryContents: boundaryContents
    };
};
module.exports["extractMarkdownContent"] = $bb8517d09864aa83$export$bb73d89e7217c465;

});

parcelRegister("eK93A", function(module, exports) {

var $l5TuZ = parcelRequire("l5TuZ");

const $6e31fae473633a0a$export$823ed9c8e3d751f5 = (streamMessage)=>{
    const content = streamMessage.message.message.content;
    if (typeof content !== 'string') return streamMessage;
    return {
        ...streamMessage,
        message: {
            ...streamMessage.message,
            message: {
                ...streamMessage.message.message,
                content: (0, $l5TuZ.preprocessDetails)(content)
            }
        }
    };
};
module.exports["preprocessStreamResponseDetails"] = $6e31fae473633a0a$export$823ed9c8e3d751f5;

});

parcelRegister("4vH8u", function(module, exports) {

var $6Bfyn = parcelRequire("6Bfyn");

const $9ca8138617329dd1$export$8b6420a9ad4c28a1 = (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX).replace(/-$/, '');
module.exports["ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY"] = $9ca8138617329dd1$export$8b6420a9ad4c28a1;

});

parcelRegister("aXdbm", function(module, exports) {
const $6501787cbfb565d1$export$1c0805bd5fc59c20 = (content)=>{
    if (content == null || typeof content !== 'object' || !('structured' in content)) return null;
    const { text_parts: text_parts, data_parts: data_parts } = content;
    const textContent = text_parts?.map((part)=>part.text ?? '').join('').trim() || '';
    const a2uiMessages = data_parts?.filter((part)=>part?.metadata?.mimeType === 'application/json+a2ui' && part?.data != null).map((part)=>part.data);
    return {
        textContent: textContent,
        a2uiMessages: a2uiMessages && a2uiMessages.length > 0 ? a2uiMessages : undefined
    };
};
module.exports["extractA2UIFromStructuredContent"] = $6501787cbfb565d1$export$1c0805bd5fc59c20;

});

parcelRegister("awqa1", function(module, exports) {
const $407144c16139718a$export$e5fd1b788c68cb23 = 25;
const $407144c16139718a$export$6a4c5f0f0d581946 = 75;
const $407144c16139718a$export$cdeec60e6c5f7424 = 'rovo_chat_conversation_list_pagination';
const $407144c16139718a$export$f0248a5607f066a8 = 'Action execution failed';
module.exports["CONVERSATION_LIST_PAGE_SIZE"] = $407144c16139718a$export$e5fd1b788c68cb23;
module.exports["CONVERSATION_LIST_LOAD_MORE_PAGE_SIZE"] = $407144c16139718a$export$6a4c5f0f0d581946;
module.exports["CONVERSATION_LIST_PAGINATION_EXPERIMENT"] = $407144c16139718a$export$cdeec60e6c5f7424;
module.exports["ACTION_EXECUTION_FAILED"] = $407144c16139718a$export$f0248a5607f066a8;

});

parcelRegister("9bLpG", function(module, exports) {

var $8ssI02 = parcelRequire("8ssI02");

const $b47f1c04462aca8a$export$221a61151a747a40 = ({ channelsFromAPI: channelsFromAPI, conversations: conversations, conversationsDeletedDuringCall: conversationsDeletedDuringCall = new Set() })=>{
    const localConversationByBackendId = new Map(Object.values(conversations).filter((c)=>Boolean(c.backendConversationId)).map((c)=>[
            c.backendConversationId,
            c
        ]));
    return channelsFromAPI.filter((channel)=>!conversationsDeletedDuringCall.has(channel.id)).reduce((acc, channel)=>{
        const localConversation = conversations[channel.id] ?? localConversationByBackendId.get(channel.id);
        acc[channel.id] = (0, $8ssI02.mergeConversationWithNetworkPriority)(channel, localConversation);
        return acc;
    }, {});
};
module.exports["getProcessedConversationChannels"] = $b47f1c04462aca8a$export$221a61151a747a40;

});

parcelRegister("f1ZpQ", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $awqa1 = parcelRequire("awqa1");

const $3b50b88d27aea269$export$291e69895ac901d7 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    if (fireExperimentExposure) return (0, $cXtTj.default).getExperimentValue((0, $awqa1.CONVERSATION_LIST_PAGINATION_EXPERIMENT), 'isEnabled', false);
    return (0, $cXtTj.default).getExperimentValue((0, $awqa1.CONVERSATION_LIST_PAGINATION_EXPERIMENT), 'isEnabled', false, {
        fireExperimentExposure: false
    });
};
module.exports["isConversationListPaginationEnabled"] = $3b50b88d27aea269$export$291e69895ac901d7;

});

parcelRegister("hQJOO", function(module, exports) {
const $4745959a462aeb63$export$3bb35e4b7521ba6c = (channelsFromAPI, unifiedTasksActions)=>{
    if (!unifiedTasksActions) return;
    const allChannelTasks = channelsFromAPI.flatMap((channel)=>channel.tasks ?? []);
    if (allChannelTasks.length > 0) unifiedTasksActions.mergeConversationChannelTasks(allChannelTasks);
};
module.exports["mergeConversationChannelTasks"] = $4745959a462aeb63$export$3bb35e4b7521ba6c;

});

parcelRegister("eQl6Z", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $igOtY = parcelRequire("igOtY");


var $6Hbrh = parcelRequire("6Hbrh");

const $2b8e200878e063c4$export$5ca6cb2fe3cf209c = ()=>({ getState: getState }, { setReasoningMode: setReasoningMode, unifiedTasksActions: unifiedTasksActions })=>{
        if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
        const { conversations: conversations, currentConversationId: currentConversationId } = getState();
        const task = unifiedTasksActions.getActiveTaskForConversation(currentConversationId);
        if (task && !(0, $igOtY.isTerminalTaskState)(task.progressState) && (0, $6Hbrh.shouldRestoreMaxModeFromLastRequestedMode)(conversations[currentConversationId]?.lastRequestedMode)) setReasoningMode(currentConversationId, 'task');
    };
module.exports["restoreTaskModeIfNeeded"] = $2b8e200878e063c4$export$5ca6cb2fe3cf209c;

});

parcelRegister("c8Sl1", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $4o0zT = parcelRequire("4o0zT");


var $4m5jb = parcelRequire("4m5jb");


var $8fLSN = parcelRequire("8fLSN");


var $igOtY = parcelRequire("igOtY");


var $b2pOf = parcelRequire("b2pOf");


var $8z5uc = parcelRequire("8z5uc");


var $l6xCb = parcelRequire("l6xCb");


var $lOO5l = parcelRequire("lOO5l");


var $6geN3 = parcelRequire("6geN3");

const $15f48e1bd7e00399$export$c954041354ede17c = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).setSelectedConversation, ({ conversationId: conversationId, sourceAgentId: sourceAgentId, conversationMetadata: conversationMetadata, targetMessageId: targetMessageId, clearLegacyLastMessageSentAt: clearLegacyLastMessageSentAt })=>({ setState: setState, getState: getState, dispatch: dispatch }, { siteId: siteId })=>{
        let resolvedConversationId = conversationId;
        if (!getState().conversations[conversationId]) {
            if (conversationMetadata?.id === conversationId) dispatch((0, $lOO5l.initializeConversationData)({
                conversationId: conversationId,
                data: {
                    ...(0, $8z5uc.conversationMetadataForStore)(conversationMetadata),
                    ...targetMessageId ? {
                        targetTaskMessageId: targetMessageId
                    } : {}
                }
            }));
            else resolvedConversationId = (0, $4m5jb.EMPTY_CONVERSATION_ID);
        } else if (targetMessageId) dispatch((0, $6geN3.setConversationData)({
            conversationId: conversationId,
            data: {
                targetTaskMessageId: targetMessageId
            }
        }));
        setState({
            currentConversationId: resolvedConversationId
        });
        // Keep the agent id provided when selecting this conversation; gate-on also seeds `conversation.agent` for the header.
        if (sourceAgentId) {
            const conversationAgentFromSource = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? (0, $8fLSN.createProvisionalConversationAgent)(sourceAgentId) : undefined;
            const conversationAgentSourceData = conversationAgentFromSource ? {
                agent: conversationAgentFromSource
            } : {};
            dispatch((0, $6geN3.setConversationData)({
                conversationId: resolvedConversationId,
                data: {
                    sourceAgentId: sourceAgentId,
                    ...conversationAgentSourceData
                }
            }));
        }
        // Store preference.
        // For space-scoped conversations, store EMPTY_CONVERSATION_ID instead of the
        // client-generated UUID. The client UUID is never returned by the backend /conversations
        // API, so restoring it on refresh creates an orphaned optimistic entry that has no
        // rovoSpaceId and cannot be matched to any API channel — causing a ghost item to
        // appear in the regular conversation list. Starting fresh (empty chat) on refresh
        // is the correct behaviour for space conversations.
        const conversationForStorage = getState().conversations[resolvedConversationId];
        const localStorageConversationId = conversationForStorage?.rovoSpaceId && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? (0, $4m5jb.EMPTY_CONVERSATION_ID) : resolvedConversationId;
        (0, $b2pOf.persistRecentConversation)({
            type: 'conversation-selected',
            siteId: siteId,
            conversationId: localStorageConversationId,
            clearLegacyLastMessageSentAt: clearLegacyLastMessageSentAt
        });
    });
module.exports["setSelectedConversation"] = $15f48e1bd7e00399$export$c954041354ede17c;

});

parcelRegister("djNSU", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $7td41 = parcelRequire("7td41");


var $4m5jb = parcelRequire("4m5jb");


var $igOtY = parcelRequire("igOtY");


var $l6xCb = parcelRequire("l6xCb");


var $lOO5l = parcelRequire("lOO5l");


var $6MYo6 = parcelRequire("6MYo6");


var $c8Sl1 = parcelRequire("c8Sl1");

const $c61cad8d9ccd4ab2$export$91a9628d52e15401 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).createConversationOptimistically, (options)=>async ({ dispatch: dispatch }, { setMessages: setMessages })=>{
        const conversationId = options?.id ?? (0, $4m5jb.EMPTY_CONVERSATION_ID);
        const time = new Date().toISOString();
        // Seed `conversation.agent` from the known optimistic conversation identity.
        const agentForOptimisticConversation = (0, $6MYo6.resolveConversationSeedAgent)({
            backendAgent: options?.agent,
            agentId: options?.sourceAgentId,
            legacyAgent: options?.agent
        });
        // Under the selected-agent gate the header derives the displayed agent
        // solely from `conversation.agent`. When this optimistic creation re-uses an
        // existing conversation slot (e.g. EMPTY_CONVERSATION_ID) the data is
        // shallow-merged, so omitting the `agent` key would leave a previously-seeded
        // specialist agent in place. Selecting "Chat with Rovo" (no agent id) must
        // therefore explicitly clear `conversation.agent` back to the default Rovo
        // agent rather than silently preserving the stale one.
        const optimisticConversationAgentData = agentForOptimisticConversation ? {
            agent: agentForOptimisticConversation
        } : (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? {
            agent: undefined
        } // explicit clear so "Chat with Rovo" resets a stale specialist
         : {};
        dispatch((0, $lOO5l.initializeConversationData)({
            conversationId: conversationId,
            data: {
                id: conversationId,
                lastMessageTimestamp: options.lastMessageTimestamp ?? time,
                name: options.name ?? (0, $7td41.generateConversationName)(),
                sourceAgentId: options.sourceAgentId,
                sourceId: options.sourceId ?? undefined,
                status: options?.status ?? (0, $igOtY.CHAT_STORE_STATUS).idle,
                timeCreated: options?.timeCreated ?? time,
                traces: [],
                messages: [],
                lastMessageType: options?.lastMessageType ?? [],
                lastAgentMessageStatus: options?.lastAgentMessageStatus,
                resultAttributionContext: options?.resultAttributionContext,
                // Explicitly set rovoSpaceId (including undefined) so that re-initialising
                // EMPTY_CONVERSATION_ID without a space clears any stale rovoSpaceId left
                // from a previous space-scoped conversation.
                rovoSpaceId: options?.rovoSpaceId,
                // Same reasoning as rovoSpaceId: this action commonly re-initialises the
                // EMPTY_CONVERSATION_ID slot, and the data is shallow-merged, so the key
                // must be set even when undefined. Otherwise a chat launched from a
                // product surface would keep attributing later, unrelated chats to it.
                chatEntryPoint: options?.chatEntryPoint,
                isViewModeRemix: options?.isViewModeRemix,
                // Same reasoning again: a stale 3P cohort left on a re-initialised slot would
                // be mirrored onto an unrelated conversation's events, including the org-wide
                // AI-MAU events this experiment does not own (CCINT-8714).
                thirdPartyPrompt: undefined,
                ...optimisticConversationAgentData,
                ...options?.agentVersion ? {
                    agentVersion: options.agentVersion
                } : {},
                ...options?.scopes ? {
                    scopes: options.scopes
                } : {}
            }
        }));
        setMessages(conversationId, []);
        dispatch((0, $c8Sl1.setSelectedConversation)({
            conversationId: conversationId
        }));
    });
module.exports["createConversationOptimistically"] = $c61cad8d9ccd4ab2$export$91a9628d52e15401;

});

parcelRegister("ffjMi", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $byYzg = parcelRequire("byYzg");


var $9twrG = parcelRequire("9twrG");


var $izhU8 = parcelRequire("izhU8");


var $djNSU = parcelRequire("djNSU");


var $l6xCb = parcelRequire("l6xCb");


var $16g08 = parcelRequire("16g08");


var $1wTWY = parcelRequire("1wTWY");


var $6sMX9 = parcelRequire("6sMX9");


var $6geN3 = parcelRequire("6geN3");


var $c8Sl1 = parcelRequire("c8Sl1");

const $7c8a1ce87ec5e959$export$465cb47180de50f0 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).sendMessage, (props)=>(0, $6sMX9.sendMessageActionProvider)({
        ...props,
        setConversationData: $6geN3.setConversationData,
        createConversationOptimistically: $djNSU.createConversationOptimistically,
        addHumanMessage: $9twrG.addHumanMessage,
        addAssistantMessage: $byYzg.addAssistantMessage,
        clearFollowUpMessages: $izhU8.clearFollowUpMessages,
        setSelectedConversation: $c8Sl1.setSelectedConversation,
        reconnectToInProgressStream: $1wTWY.reconnectToInProgressStream
    }), {
    experienceName: (args)=>(0, $16g08.getSendMessageExperienceName)({
            deepResearchEnabled: args[0]?.deepResearchEnabled,
            thinkDeeperEnabled: args[0]?.thinkDeeperEnabled,
            taskModeEnabled: args[0]?.taskModeEnabled,
            fastModeEnabled: args[0]?.fastModeEnabled
        }),
    getRateLimitState: (args)=>({
            isDeepResearchAttempt: args[0]?.deepResearchEnabled
        })
});
module.exports["sendMessage"] = $7c8a1ce87ec5e959$export$465cb47180de50f0;

});

parcelRegister("6sUl4", function(module, exports) {
// localStorage key for the Rovo Chat CSAT survey eligibility record. Kept
// private to this directory (not the flat common/utils/STORAGE_KEY) to avoid a
// name collision with the auto-conversation storage key.
const $10fb0021661128a8$export$86880b4b2e1a2384 = 'rovoChatCsatEligibility';
module.exports["STORAGE_KEY"] = $10fb0021661128a8$export$86880b4b2e1a2384;

});

parcelRegister("7H855", function(module, exports) {
// ─── API status → progress state mapping ──────────────────────────────────────
const $c0fc28e9ab853b0e$var$API_STATUS_TO_PROGRESS_STATE = {
    DRAFT: 'Draft',
    QUEUED: 'Queued',
    RUNNING: 'Running',
    AWAITING_DISAMBIGUATION: 'AwaitingDisambiguation',
    AWAITING_PLAN_CONFIRMATION: 'AwaitingPlanConfirmation',
    AWAITING_ACTION_CONFIRMATION: 'AwaitingActionConfirmation',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    CANCELLED: 'Cancelled'
};
const $c0fc28e9ab853b0e$export$f0ca788f58c1a6a9 = (status)=>$c0fc28e9ab853b0e$var$API_STATUS_TO_PROGRESS_STATE[status];
const $c0fc28e9ab853b0e$export$d5ce4d18fe97a26a = (existing, incoming)=>{
    if (!incoming || incoming.length === 0) return existing ?? null;
    if (!existing || existing.length === 0) return incoming;
    const toMs = (iso)=>new Date(iso).getTime();
    const incomingRanges = incoming.map((seg)=>({
            start: toMs(seg.startedAt),
            end: seg.endedAt ? toMs(seg.endedAt) : Date.now()
        }));
    const overlaps = (seg)=>{
        const start = toMs(seg.startedAt);
        const end = seg.endedAt ? toMs(seg.endedAt) : Date.now();
        return incomingRanges.some((r)=>start < r.end && end > r.start);
    };
    const retained = existing.filter((seg)=>!overlaps(seg));
    const merged = [
        ...retained,
        ...incoming
    ];
    return merged.sort((a, b)=>toMs(a.startedAt) - toMs(b.startedAt));
};
module.exports["mapApiTaskStatusToProgressState"] = $c0fc28e9ab853b0e$export$f0ca788f58c1a6a9;
module.exports["mergeExecutionSegments"] = $c0fc28e9ab853b0e$export$d5ce4d18fe97a26a;

});

parcelRegister("8et9H", function(module, exports) {

var $2Z4XK = parcelRequire("2Z4XK");

const $fe0c133b8a00207b$export$24d5ff955141c347 = (text)=>{
    if (!text) return 0;
    // We use Intl here since it is locale-aware and accurately handles word counts across all languages. The regex will undercount non-English languages.
    if (0, $2Z4XK.segmenter) return [
        ...(0, $2Z4XK.segmenter).segment(text)
    ].filter((s)=>s.isWordLike).length;
    return text.match(/\S+/g)?.length ?? 0;
};
module.exports["wordCount"] = $fe0c133b8a00207b$export$24d5ff955141c347;

});

parcelRegister("hpOyG", function(module, exports) {
const $fee6bf724b914a99$export$da415d22ae15cf08 = (subExperiences, additionalAttributes)=>{
    const subExperienceNameSet = new Set(subExperiences);
    const mergedAttributes = {};
    return (events, experience)=>{
        // all subExperiences must succeed for the parent experience to succeed
        // a failure/abort to any subExperience will fail/abort the parent experience
        events.forEach((event)=>{
            if (subExperienceNameSet.has(event.name)) switch(event.action){
                case 'taskSuccess':
                    if (subExperienceNameSet.delete(event.name)) Object.assign(mergedAttributes, event.attributes ?? {});
                    break;
                case 'taskFail':
                    if ('error' in event) experience.fail({
                        error: event.error,
                        attributes: {
                            ...additionalAttributes,
                            ...event.attributes
                        }
                    });
                    break;
                case 'taskAbort':
                    experience.abort({
                        reason: `${event.name} aborted`,
                        attributes: {
                            ...additionalAttributes,
                            ...event.attributes,
                            childAbortReason: event.reason
                        }
                    });
                    break;
            }
        });
        if (subExperienceNameSet.size === 0) experience.succeed({
            ...additionalAttributes,
            ...mergedAttributes
        });
    };
};
module.exports["collectAllWithSubExperienceAttributes"] = $fee6bf724b914a99$export$da415d22ae15cf08;

});

parcelRegister("1Tpom", function(module, exports) {
const $004bf9e6a327298d$export$51ee55de82fed0a0 = (subExperienceNameToCheck, mainExperienceToFail, events, additionalAttributes)=>{
    const subExperienceFailEvent = events.find((event)=>event.action === 'taskFail' && event.name === subExperienceNameToCheck);
    if (subExperienceFailEvent) mainExperienceToFail.fail({
        error: subExperienceFailEvent.error,
        attributes: {
            ...additionalAttributes,
            ...subExperienceFailEvent.attributes
        }
    });
};
module.exports["failExperienceOnSubExperienceFail"] = $004bf9e6a327298d$export$51ee55de82fed0a0;

});

parcelRegister("iqkMb", function(module, exports) {

var $8XbBy = parcelRequire("8XbBy");

const $eb24afa4da9a6ecc$export$c13c17c66364de2d = (streamResponse)=>(0, $8XbBy.getInteractionModeExecutedFromMessage)(streamResponse?.message?.message);
module.exports["getInteractionModeExecutedFromStreamResponse"] = $eb24afa4da9a6ecc$export$c13c17c66364de2d;

});

parcelRegister("8zf2J", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $irnO2 = parcelRequire("irnO2");


var $hlvTd = parcelRequire("hlvTd");


var $fCunh = parcelRequire("fCunh");


var $bxkJA = parcelRequire("bxkJA");


var $igOtY = parcelRequire("igOtY");


var $jyZaR = parcelRequire("jyZaR");


var $eBgZa = parcelRequire("eBgZa");


var $hwHCO = parcelRequire("hwHCO");


var $1IZrU = parcelRequire("1IZrU");

const $82c770e2b2e5e9f1$var$getErrorReason = ({ error: error, storeError: storeError, currentConversationId: currentConversationId, conversations: conversations })=>{
    if ((0, $bxkJA.isHipaaError)(error)) return 'hipaa';
    if ((0, $bxkJA.isAUPViolationError)(error)) return 'aupViolation';
    if ((0, $bxkJA.isChannelNotFoundError)(error)) return 'channelNotFound';
    if (!conversations?.[currentConversationId] || (0, $1IZrU.isEmptyConversation)(currentConversationId)) return 'noActiveConversation';
    if (storeError.status_code === 429 || (0, $bxkJA.isRateLimitedError)(error)) return 'rateLimited';
    return 'generic';
};
const $82c770e2b2e5e9f1$var$reportChatError = (sendAnalyticsEvent, reason, storeError)=>{
    if (!(0, $iDrrr.fg)('ai_mate_unhandled_error_reporting')) return;
    sendAnalyticsEvent({
        eventType: 'operational',
        action: 'unhandledError',
        actionSubject: 'aiMate',
        attributes: {
            reason: reason,
            statusCode: storeError.status_code,
            messageTemplate: storeError.message_template,
            errorType: storeError.errorType,
            traceId: storeError.traceId,
            errorContent: storeError.content,
            ...storeError.storeActionExecutionError ? {
                actionLoggableName: storeError.storeActionExecutionError.actionLoggableName
            } : {}
        }
    });
};
const $82c770e2b2e5e9f1$export$769f721a7d2183c3 = (props)=>{
    const { args: args, api: api, actionLoggableName: actionLoggableName, error: error, containerProps: containerProps, actionErrorHandler: actionErrorHandler, setConversationData: setConversationData } = props;
    const { getState: getState, setState: setState, dispatch: dispatch } = api;
    (0, $hlvTd.addSentryBreadcrumb)(`createSafeAction: ${actionLoggableName} errored`);
    const storeError = (0, $eBgZa.createStoreError)(error, undefined, actionLoggableName);
    const errorReason = $82c770e2b2e5e9f1$var$getErrorReason({
        error: error,
        storeError: storeError,
        currentConversationId: getState().currentConversationId,
        conversations: getState().conversations
    });
    // ============================================
    // PHASE 1: Mandatory checks (cannot be overridden)
    // ============================================
    // Handle experience tracking
    // Rate limits are ignored because they trigger a retry, not an experience termination
    if (props?.experienceName && errorReason !== 'rateLimited') {
        if (errorReason === 'aupViolation') {
            const aupError = error;
            containerProps.experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
                reason: aupError.detail.message.message_template,
                attributes: {
                    ...aupError.errorAttributes,
                    errorType: error instanceof (0, $hwHCO.StreamErrorException) ? 'StreamErrorException' : ''
                }
            });
        } else containerProps.experienceTracker.fail({
            name: props.experienceName(args),
            error: error instanceof Error ? error : new Error(String(error))
        });
    }
    // Handle restricted use errors
    if (errorReason === 'hipaa') {
        containerProps.setConversationError({
            type: 'hipaa',
            underlyingError: storeError
        });
        $82c770e2b2e5e9f1$var$reportChatError(containerProps.sendAnalyticsEvent, 'hipaa', storeError);
        return;
    }
    // ============================================
    // PHASE 2: Action-specific error handling (optional)
    // ============================================
    if (actionErrorHandler) {
        const result = actionErrorHandler({
            args: args,
            error: error,
            storeError: storeError,
            containerProps: containerProps,
            errorReason: errorReason
        });
        if (!result?.proceedToDefaultHandling) return;
    }
    // ============================================
    // PHASE 3: Default error handlers
    // ============================================
    if (errorReason === 'channelNotFound') {
        containerProps.setConversationError({
            type: 'conversationNotFound',
            underlyingError: storeError
        });
        $82c770e2b2e5e9f1$var$reportChatError(containerProps.sendAnalyticsEvent, 'channelNotFound', storeError);
        return;
    }
    if (errorReason === 'noActiveConversation') {
        containerProps.setConversationError({
            type: 'conversationEmptyOrNotPresentInStore',
            underlyingError: storeError
        });
        $82c770e2b2e5e9f1$var$reportChatError(containerProps.sendAnalyticsEvent, 'noActiveConversation', storeError);
        if (storeError.message_template === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).ROVO_PRODUCT_NOT_ACTIVE) containerProps.setRovoEnabled(false, storeError.message_template);
        return;
    }
    const currentConversationId = getState().currentConversationId;
    if (errorReason === 'rateLimited') {
        const rateLimitState = props?.getRateLimitState?.(args) ?? {};
        setState({
            conversations: {
                ...getState().conversations,
                [currentConversationId]: {
                    ...getState().conversations[currentConversationId],
                    ...(0, $jyZaR.clearStatus)({
                        lastAgentMessageStatus: 'FAILED'
                    })
                }
            }
        });
        containerProps.setConversationError({
            type: 'rateLimited',
            underlyingError: storeError,
            rateLimitedActionType: rateLimitState.isDeepResearchAttempt ? 'deep-research' : 'generic'
        });
        $82c770e2b2e5e9f1$var$reportChatError(containerProps.sendAnalyticsEvent, 'rateLimited', storeError);
        return;
    }
    dispatch(setConversationData({
        conversationId: currentConversationId,
        data: {
            ...(0, $jyZaR.clearStatus)({
                lastAgentMessageStatus: 'FAILED'
            })
        }
    }));
    const currentMessages = containerProps.getMessages(currentConversationId);
    const lastMessage = currentMessages[currentMessages.length - 1];
    const isDuplicateError = lastMessage && (0, $igOtY.isStoreError)(lastMessage) && lastMessage.content === storeError.content;
    if (!isDuplicateError) containerProps.setMessages(currentConversationId, [
        ...currentMessages,
        storeError
    ]);
    const errorAttributes = error?.errorAttributes;
    containerProps.experienceTracker.fail({
        name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
        error: error instanceof Error ? error : new Error(String(error)),
        attributes: {
            latestStreamMessageType: errorAttributes?.latestStreamMessageType,
            latestStreamMessageMillisOffset: errorAttributes?.latestStreamMessageMillisOffset
        }
    });
    $82c770e2b2e5e9f1$var$reportChatError(containerProps.sendAnalyticsEvent, 'generic', storeError);
};
module.exports["storeErrorHandler"] = $82c770e2b2e5e9f1$export$769f721a7d2183c3;

});

parcelRegister("64wzj", function(module, exports) {
const $286c7f27b5852cf3$export$dc6d7ea554bcce10 = ()=>`${Date.now().toString(16)}-${Math.floor(Math.random() * 1e4).toString(16)}`;
module.exports["generateTraceId"] = $286c7f27b5852cf3$export$dc6d7ea554bcce10;

});

parcelRegister("l5TuZ", function(module, exports) {
/**
 * Rewrites HTML `<details>` / `<summary>` collapsed sections embedded in
 * markdown into the Rovo-native boundary format that the rest of the stream
 * pipeline already understands.
 *
 *   <details><summary>Title</summary>Body</details>  →  ▞Title\nBody▚
 *
 * Downstream, the existing `expand` streamable component (see
 * `getStreamableComponents` in `chat-store/utils.ts`) picks up `▞…▚`, swaps
 * in the `[^expand^]` placeholder, and renders the body out-of-band through
 * `markdownData`.
 *
 * Spec reference: the HTML `<details>` element (rendered as a disclosure
 * widget) and its `<summary>` child, as documented by MDN and supported by
 * common markdown renderers.
 *
 * Known limitations (V1):
 *  - Code-fence aware rewriting is not implemented. A `<details>` block
 *    embedded inside a ``` code fence will still be rewritten. Agents
 *    producing collapsed sections generally don't do this, but if it becomes
 *    a real problem the fence-tracking state machine from
 *    `sanitize-markdown.ts` can be ported here.
 *  - Nested `<details>` are passed through unchanged.
 */ const $5fc0b06474009091$var$DETAILS_OPEN_BOUNDARY = "\u259E";
const $5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY = "\u259A";
const $5fc0b06474009091$var$DEFAULT_TITLE = 'Details';
// Complete-tag matchers. Case-insensitive, allow attributes on open tags.
const $5fc0b06474009091$var$DETAILS_OPEN_RE = /^<details(?:\s[^>]*)?>$/i;
const $5fc0b06474009091$var$SUMMARY_OPEN_RE = /^<summary(?:\s[^>]*)?>$/i;
const $5fc0b06474009091$var$SUMMARY_CLOSE_RE = /^<\/summary\s*>$/i;
const $5fc0b06474009091$var$DETAILS_CLOSE_RE = /^<\/details\s*>$/i;
// Fast-path probe: if the text cannot possibly contain a relevant tag, skip
// the scan entirely.
const $5fc0b06474009091$var$HAS_RELEVANT_TAG_RE = /<\/?(?:details|summary)\b/i;
/**
 * Shared scan used by both the streaming and one-shot paths.
 *
 * When `allowBuffer` is `true`, a trailing incomplete tag (i.e. a `<` with
 * no subsequent `>`) is stashed on `state.buffer` for the next call instead
 * of being emitted. When `false` (flush / one-shot), the partial text is
 * emitted as literal.
 */ const $5fc0b06474009091$var$scan = (input, state, allowBuffer)=>{
    let out = '';
    let i = 0;
    const emitText = (text)=>{
        if (state.mode === 'IN_DETAILS_PRE_SUMMARY') // Silently discard text between `<details>` and `<summary>` (in
        // practice this is whitespace / newlines the agent formats for
        // readability).
        return;
        if (state.mode === 'IN_SUMMARY') {
            // Collapse newlines inside the summary so the downstream
            // `splitHeaderAndContent` (first-newline split) still sees a
            // single-line title.
            out += text.replace(/\r?\n/g, ' ');
            return;
        }
        out += text;
    };
    while(i < input.length){
        const lt = input.indexOf('<', i);
        if (lt === -1) {
            emitText(input.slice(i));
            break;
        }
        if (lt > i) emitText(input.slice(i, lt));
        const gt = input.indexOf('>', lt);
        if (gt === -1) {
            if (allowBuffer) {
                state.buffer = input.slice(lt);
                return out;
            }
            // One-shot path: emit the dangling partial tag as literal.
            emitText(input.slice(lt));
            break;
        }
        const tag = input.slice(lt, gt + 1);
        if ($5fc0b06474009091$var$DETAILS_OPEN_RE.test(tag)) {
            if (state.mode === 'NORMAL') state.mode = 'IN_DETAILS_PRE_SUMMARY';
            else // Nested or unexpected — pass through so we don't eat user text.
            emitText(tag);
        } else if ($5fc0b06474009091$var$SUMMARY_OPEN_RE.test(tag)) {
            if (state.mode === 'IN_DETAILS_PRE_SUMMARY') {
                state.mode = 'IN_SUMMARY';
                out += $5fc0b06474009091$var$DETAILS_OPEN_BOUNDARY;
            } else emitText(tag);
        } else if ($5fc0b06474009091$var$SUMMARY_CLOSE_RE.test(tag)) {
            if (state.mode === 'IN_SUMMARY') {
                state.mode = 'IN_DETAILS_BODY';
                out += '\n';
            } else emitText(tag);
        } else if ($5fc0b06474009091$var$DETAILS_CLOSE_RE.test(tag)) {
            if (state.mode === 'IN_DETAILS_BODY') {
                state.mode = 'NORMAL';
                out += $5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY;
            } else if (state.mode === 'IN_DETAILS_PRE_SUMMARY') {
                // `<details>…</details>` with no `<summary>`. Synthesise a
                // default header so the renderer has something to show.
                state.mode = 'NORMAL';
                out += `${$5fc0b06474009091$var$DETAILS_OPEN_BOUNDARY}${$5fc0b06474009091$var$DEFAULT_TITLE}\n${$5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY}`;
            } else if (state.mode === 'IN_SUMMARY') {
                // Malformed: `</details>` while still inside `<summary>`. Close
                // the summary implicitly and close the details.
                state.mode = 'NORMAL';
                out += `\n${$5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY}`;
            } else emitText(tag);
        } else // Unrelated tag (e.g. `<span>`, `<a href=…>`) — pass through.
        emitText(tag);
        i = gt + 1;
    }
    state.buffer = '';
    return out;
};
const $5fc0b06474009091$var$synthesiseClosers = (state)=>{
    let out = '';
    if (state.mode === 'IN_DETAILS_PRE_SUMMARY') out += `${$5fc0b06474009091$var$DETAILS_OPEN_BOUNDARY}${$5fc0b06474009091$var$DEFAULT_TITLE}\n${$5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY}`;
    else if (state.mode === 'IN_SUMMARY') out += `\n${$5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY}`;
    else if (state.mode === 'IN_DETAILS_BODY') out += $5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY;
    state.mode = 'NORMAL';
    return out;
};
const $5fc0b06474009091$export$c00e46a308694bc9 = (text)=>{
    if (!text || !$5fc0b06474009091$var$HAS_RELEVANT_TAG_RE.test(text)) return text;
    const state = {
        mode: 'NORMAL',
        buffer: ''
    };
    let out = $5fc0b06474009091$var$scan(text, state, /* allowBuffer */ false);
    out += $5fc0b06474009091$var$synthesiseClosers(state);
    return out;
};
const $5fc0b06474009091$export$88c7624283baadd3 = ()=>{
    const state = {
        mode: 'NORMAL',
        buffer: ''
    };
    return {
        process (chunk) {
            const combined = state.buffer + (chunk ?? '');
            state.buffer = '';
            // Fast-path: when we are not inside a details block and the combined
            // text contains no `<` at all, a tag is impossible — skip the scan.
            // We deliberately do NOT use a name-level regex here: a partial tag
            // like `<det` spanning a chunk boundary must still be buffered for
            // the next chunk to complete it.
            if (!combined || state.mode === 'NORMAL' && !combined.includes('<')) return combined;
            return $5fc0b06474009091$var$scan(combined, state, /* allowBuffer */ true);
        },
        flush () {
            let out = '';
            if (state.buffer) {
                const leftover = state.buffer;
                state.buffer = '';
                out += $5fc0b06474009091$var$scan(leftover, state, /* allowBuffer */ false);
            }
            out += $5fc0b06474009091$var$synthesiseClosers(state);
            return out;
        }
    };
};
module.exports["preprocessDetails"] = $5fc0b06474009091$export$c00e46a308694bc9;
module.exports["createDetailsPreprocessor"] = $5fc0b06474009091$export$88c7624283baadd3;

});

parcelRegister("8ssI02", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $7td41 = parcelRequire("7td41");


var $igOtY = parcelRequire("igOtY");


var $f2kj3 = parcelRequire("f2kj3");

const $15d69fdc4e9e25c3$export$60a662127f30e1e1 = (remoteConversation, localConversation)=>{
    const remoteParticipants = Array.isArray(remoteConversation.participants) ? remoteConversation.participants : undefined;
    const isMentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    return {
        id: remoteConversation.id,
        // Prioritize API data if present, otherwise use local or generate new
        name: remoteConversation.name ?? localConversation?.name ?? (0, $7td41.generateConversationName)(),
        timeCreated: remoteConversation.time_created ?? localConversation?.timeCreated,
        lastMessage: remoteConversation.last_message ?? localConversation?.lastMessage ?? undefined,
        lastMessageType: remoteConversation.last_message_type ?? localConversation?.lastMessageType ?? [],
        lastMessageTimestamp: remoteConversation.last_message_timestamp ?? localConversation?.lastMessageTimestamp,
        lastAgentMessageStatus: remoteConversation.last_agent_message_status ?? localConversation?.lastAgentMessageStatus,
        ...remoteConversation.agentSessionState ? {
            agentSessionState: remoteConversation.agentSessionState
        } : {},
        readStatus: remoteConversation.readStatus ?? localConversation?.readStatus,
        isPinned: remoteConversation.isPinned ?? localConversation?.isPinned,
        pinnedAt: remoteConversation.pinnedAt ?? localConversation?.pinnedAt,
        tags: remoteConversation.tags ?? localConversation?.tags,
        // Omission is authoritative: CAP uses it to clear a previously-restorable mode.
        lastRequestedMode: (0, $f2kj3.normalizeRestorableRequestedMode)(remoteConversation.last_requested_mode),
        // Use local state data if it exists (messages, status are maintained locally)
        messages: localConversation?.messages ?? [],
        status: localConversation?.status ?? (0, $igOtY.CHAT_STORE_STATUS).idle,
        traces: localConversation?.traces ?? [],
        ...localConversation?.sourceAgentId ? {
            sourceAgentId: localConversation.sourceAgentId
        } : {},
        ...localConversation?.sourceId ? {
            sourceId: localConversation.sourceId
        } : {},
        ...localConversation?.resultAttributionContext ? {
            resultAttributionContext: localConversation.resultAttributionContext
        } : {},
        // `chatEntryPoint` is front-end-only state — the backend channel never returns it — so it
        // must be carried over from local state or a channel rehydration (init / refocus) would
        // silently drop entry-point attribution mid-conversation.
        ...localConversation?.chatEntryPoint ? {
            chatEntryPoint: localConversation.chatEntryPoint
        } : {},
        // Same reasoning as `chatEntryPoint`: front-end-only, so a rehydration would otherwise
        // drop it and the conversation would stop reporting its cohort mid-flight.
        ...localConversation?.thirdPartyPrompt ? {
            thirdPartyPrompt: localConversation.thirdPartyPrompt
        } : {},
        // Preserve runtime abort controller so Stop button works after channels rehydration (e.g. refocus)
        ...localConversation?.storeAbortController != null ? {
            storeAbortController: localConversation.storeAbortController
        } : {},
        ...localConversation?.rovoSpaceId ? {
            rovoSpaceId: localConversation.rovoSpaceId
        } : {},
        sourceMode: remoteConversation.sourceMode === 'STRICT' ? 'STRICT' : 'GENERAL',
        // `agent` is optional on ConversationChannel, so the server-sourced channel can
        // Preserve the former all-flags-off behavior while retaining the local seed in
        // the experiment variation when the server omits the agent.
        agent: isMentionAgentsExperimentEnabled ? remoteConversation.agent ?? localConversation?.agent : remoteConversation.agent,
        scopes: remoteConversation.scopes ?? localConversation?.scopes,
        ...remoteParticipants !== undefined && isMentionAgentsExperimentEnabled ? {
            participants: remoteParticipants
        } : {}
    };
};
module.exports["mergeConversationWithNetworkPriority"] = $15d69fdc4e9e25c3$export$60a662127f30e1e1;

});

parcelRegister("6Hbrh", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $63f6a798d3de12fd$export$2389649a7be8eb77 = (lastRequestedMode)=>!(0, $iDrrr.fg)('rovo_chat_restore_max_from_last_requested_mode') || lastRequestedMode === 'MAX';
module.exports["shouldRestoreMaxModeFromLastRequestedMode"] = $63f6a798d3de12fd$export$2389649a7be8eb77;

});

parcelRegister("8fLSN", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

const $9c1a3c9bb4b54fb7$export$fc6a9cdad8ea90e0 = (agentId)=>{
    if (!agentId) return undefined;
    return {
        agent_id: agentId,
        agent_named_id: agentId,
        agent_name: '',
        creator_type: ''
    };
};
const $9c1a3c9bb4b54fb7$export$9e56ee965c896858 = ({ conversation: conversation, fallbackAgentId: fallbackAgentId })=>{
    const storedConversationAgentId = conversation?.agent?.agent_id || undefined;
    return storedConversationAgentId && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? storedConversationAgentId : fallbackAgentId;
};
module.exports["createProvisionalConversationAgent"] = $9c1a3c9bb4b54fb7$export$fc6a9cdad8ea90e0;
module.exports["resolveConversationAgentIdForRouting"] = $9c1a3c9bb4b54fb7$export$9e56ee965c896858;

});

parcelRegister("8z5uc", function(module, exports) {
const $6527329df61749d1$export$8d14a3ee8564ea0e = (conversation)=>{
    const { isEmpty: _isEmpty, currentTask: _currentTask, ...storeConversation } = conversation;
    return storeConversation;
};
module.exports["conversationMetadataForStore"] = $6527329df61749d1$export$8d14a3ee8564ea0e;

});

parcelRegister("lOO5l", function(module, exports) {
const $973523ae4fef70e5$export$7124b61407e3c15b = ({ conversationId: conversationId, data: data })=>({ getState: getState, setState: setState })=>{
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId],
                    ...data
                }
            }
        });
    };
module.exports["initializeConversationData"] = $973523ae4fef70e5$export$7124b61407e3c15b;

});

parcelRegister("6MYo6", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $8fLSN = parcelRequire("8fLSN");

const $3e220ccac9a02b6e$export$f9d99d78335a8a06 = ({ backendAgent: backendAgent, agentId: agentId, legacyAgent: legacyAgent })=>{
    if ((0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')) return backendAgent ?? (0, $8fLSN.createProvisionalConversationAgent)(agentId);
    return legacyAgent && (0, $iDrrr.fg)('rovo_chat_chat_history_refresh') ? legacyAgent : undefined;
};
module.exports["resolveConversationSeedAgent"] = $3e220ccac9a02b6e$export$f9d99d78335a8a06;

});

parcelRegister("byYzg", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $fQYiO = parcelRequire("fQYiO");


var $l6xCb = parcelRequire("l6xCb");


var $RwpfW = parcelRequire("RwpfW");

const $7b222e9f3b67e786$export$ce06e1b90807a0c0 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).addAssistantMessage, ({ id: id, content: content, conversationId: conversationIdParam, agentNamedId: agentNamedId, agentAuthorId: agentAuthorId, agentAuthorIdentityAccountId: agentAuthorIdentityAccountId })=>({ getState: getState, dispatch: dispatch })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const assistantMessageParams = {
            id: id,
            content: content,
            agentNamedId: agentNamedId,
            agentAuthorId: agentAuthorId,
            agentAuthorIdentityAccountId: agentAuthorIdentityAccountId,
            conversationId: conversationId
        };
        dispatch((0, $fQYiO.addStoreChatItem)({
            message: (0, $RwpfW.createStoreAssistant)(assistantMessageParams),
            conversationId: conversationId
        }));
    });
module.exports["addAssistantMessage"] = $7b222e9f3b67e786$export$ce06e1b90807a0c0;

});

parcelRegister("9twrG", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $fQYiO = parcelRequire("fQYiO");


var $l6xCb = parcelRequire("l6xCb");


var $blqV9 = parcelRequire("blqV9");

const $ccf70d20a8a5d0a4$export$9888dd09dd4e0151 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).addHumanMessage, ({ id: id, content: content, conversationId: conversationIdParam, isFromSeededConversation: isFromSeededConversation = false, requestId: requestId, fileUploads: fileUploads, displayContext: displayContext, followUpAgentIdentity: followUpAgentIdentity })=>({ getState: getState, dispatch: dispatch })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        dispatch((0, $fQYiO.addStoreChatItem)({
            message: {
                ...(0, $blqV9.createStoreHuman)(id, content, isFromSeededConversation, requestId, fileUploads, displayContext),
                ...followUpAgentIdentity ? {
                    followUpAgentIdentity: followUpAgentIdentity
                } : {}
            },
            conversationId: conversationId
        }));
    });
module.exports["addHumanMessage"] = $ccf70d20a8a5d0a4$export$9888dd09dd4e0151;

});

parcelRegister("izhU8", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $l6xCb = parcelRequire("l6xCb");

const $1385698a2f418aa1$export$bc07ddf1de8d78e4 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).clearFollowUpMessages, ({ conversationId: conversationIdParam })=>({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const filteredMessages = messages.filter((message)=>!(0, $igOtY.isStoreFollowUp)(message));
        setMessages(conversationId, filteredMessages);
    });
module.exports["clearFollowUpMessages"] = $1385698a2f418aa1$export$bc07ddf1de8d78e4;

});

parcelRegister("1wTWY", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $igOtY = parcelRequire("igOtY");


var $l6xCb = parcelRequire("l6xCb");


var $aXVnT = parcelRequire("aXVnT");


var $6geN3 = parcelRequire("6geN3");

const $7a4a093d6dd23d1c$export$873fca975736004b = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).reconnectToInProgressStream, ({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, isDeepResearch: isDeepResearch, abortCurrentRequest: abortCurrentRequest, answerIndex: answerIndex, onComplete: onComplete })=>(0, $aXVnT.reconnectToInProgressStreamProvider)({
        conversationId: conversationId,
        messageId: messageId,
        lastEventId: lastEventId,
        isDeepResearch: isDeepResearch,
        abortCurrentRequest: abortCurrentRequest,
        answerIndex: answerIndex,
        onComplete: onComplete,
        setConversationData: $6geN3.setConversationData
    }), {
    experienceName: ()=>(0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM
});
module.exports["reconnectToInProgressStream"] = $7a4a093d6dd23d1c$export$873fca975736004b;

});

parcelRegister("6sMX9", function(module, exports) {
/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing stream processing gates feature behavior from runtime flags. */ 
var $1hQ0e = parcelRequire("1hQ0e");


var $cXtTj = parcelRequire("cXtTj");


var $cha5E = parcelRequire("cha5E");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $aYC8J = parcelRequire("aYC8J");


var $lUXDc = parcelRequire("lUXDc");


var $6xccU = parcelRequire("6xccU");


var $irnO2 = parcelRequire("irnO2");


var $hlvTd = parcelRequire("hlvTd");


var $hRx4b = parcelRequire("hRx4b");


var $fCunh = parcelRequire("fCunh");


var $5XWbo = parcelRequire("5XWbo");


var $bxkJA = parcelRequire("bxkJA");


var $8A2GO = parcelRequire("8A2GO");


var $bQQtO = parcelRequire("bQQtO");


var $7td41 = parcelRequire("7td41");


var $9vNm5 = parcelRequire("9vNm5");


var $8fLSN = parcelRequire("8fLSN");


var $cVUTD = parcelRequire("cVUTD");


var $igOtY = parcelRequire("igOtY");


var $2yWJZ = parcelRequire("2yWJZ");


var $bER8M = parcelRequire("bER8M");


var $l2exp = parcelRequire("l2exp");


var $baWyq = parcelRequire("baWyq");


var $eMs38 = parcelRequire("eMs38");


var $biBci = parcelRequire("biBci");


var $6iQ4q = parcelRequire("6iQ4q");


var $jb3zd = parcelRequire("jb3zd");


var $b2pOf = parcelRequire("b2pOf");


var $3Bvlb = parcelRequire("3Bvlb");


var $jyZaR = parcelRequire("jyZaR");


var $hMXhO = parcelRequire("hMXhO");


var $iMppo = parcelRequire("iMppo");


var $bMRok = parcelRequire("bMRok");


var $kncFb = parcelRequire("kncFb");


var $kNXXO = parcelRequire("kNXXO");


var $icBz6 = parcelRequire("icBz6");


var $j5JhI = parcelRequire("j5JhI");


var $Q8n54 = parcelRequire("Q8n54");


var $4cgYj = parcelRequire("4cgYj");


var $dCJIZ = parcelRequire("dCJIZ");


var $i9o8a = parcelRequire("i9o8a");


var $gB8YL = parcelRequire("gB8YL");


var $lpYvl = parcelRequire("lpYvl");


var $bETzY = parcelRequire("bETzY");


var $ks26f = parcelRequire("ks26f");


var $354x3 = parcelRequire("354x3");


var $3GbnU = parcelRequire("3GbnU");


var $5odSY = parcelRequire("5odSY");


var $aKQ2h = parcelRequire("aKQ2h");


var $iEKWu = parcelRequire("iEKWu");


var $1IZrU = parcelRequire("1IZrU");


var $fANCm = parcelRequire("fANCm");


var $cC5sC = parcelRequire("cC5sC");


var $8P1Kw = parcelRequire("8P1Kw");


var $iX60o = parcelRequire("iX60o");


var $1Nzi3 = parcelRequire("1Nzi3");


var $4KNZy = parcelRequire("4KNZy");

const $732002bd2dba0f68$var$getSendMessageExperienceName = (params)=>{
    if (params.isCustomRovoAgent) return (0, $irnO2.ExperienceName).SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (params.deepResearchEnabled) return (0, $irnO2.ExperienceName).SEND_DR_MESSAGE;
    if (params.thinkDeeperEnabled) return (0, $irnO2.ExperienceName).SEND_TD_MESSAGE;
    if (params.taskModeEnabled) return (0, $irnO2.ExperienceName).SEND_TASK_MODE_MESSAGE;
    return (0, $irnO2.ExperienceName).SEND_MESSAGE;
};
const $732002bd2dba0f68$var$getInitialTrackingAttributes = (agentId, instrumentationId, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, taskModeEnabled, webSearchEnabled, messageSources, isFirstPrompt, prompt, files, appFilters, selectedCloudIds, template, forcedContentType)=>{
    return {
        pluginsInvoked: new Set(),
        skillsInvoked: [],
        executedStratusSkill: false,
        hasSources: false,
        hasAuthoritativeSources: false,
        messageId: '',
        humanMessageId: '',
        requestId: undefined,
        messageActions: [],
        messageDynamicUIData: [],
        invokedFrom: undefined,
        instrumentationId: instrumentationId,
        messageSentTimeStamp: new Date().toISOString(),
        citedProductList: {},
        sourceProducts: {},
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        taskModeEnabled: taskModeEnabled,
        webSearchEnabled: webSearchEnabled,
        interactionSource: messageSources?.interactionSource,
        followUpSource: messageSources?.followUpSource ?? 'none',
        // Assigned by the caller from `conversation.chatEntryPoint` once the conversation is known.
        chatEntryPoint: undefined,
        aiFeatureName: messageSources?.aiFeatureName,
        isFirstPrompt: isFirstPrompt,
        promptFeatures: (0, $l2exp.extractContentFeatures)(prompt),
        fileCount: files?.length ?? 0,
        appFilters: appFilters ?? [],
        appFilterCount: appFilters?.length ?? 0,
        selectedCloudIds: selectedCloudIds ?? [],
        selectedCloudIdCount: selectedCloudIds?.length ?? 0,
        template: template,
        deepResearchInvoked: false,
        forcedContentType: forcedContentType,
        interactionModeRequested: (0, $i9o8a.getInteractionModeRequested)({
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            taskModeEnabled: taskModeEnabled
        })
    };
};
const $732002bd2dba0f68$var$getOptimisticMessageTypes = (deepResearchEnabled, webSearchEnabled)=>{
    const messageType = [];
    if ((0, $iDrrr.fg)('rovo_chat_chat_history_refresh')) {
        if (deepResearchEnabled) messageType.push('DEEP_RESEARCH');
        if (webSearchEnabled) messageType.push('WEB_SEARCH');
    }
    return {
        messageType: messageType
    };
};
const $732002bd2dba0f68$var$initLatencyMetrics = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, agentId: agentId })=>{
    const rovoCustomAgent = (0, $biBci.isRovoCustomAgent)(agentId);
    const sendMessageLatencyMetrics = (0, $bER8M.messageLatencyMetrics).createSendMessageMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToFirstAnswerPartLatencyMetrics = (0, $bER8M.messageLatencyMetrics).createTimeToFirstAnswerPartMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToFirstActionPartLatencyMetrics = (0, $bER8M.messageLatencyMetrics).createTimeToFirstActionPartMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToActionCompletionLatencyMetrics = (0, $bER8M.messageLatencyMetrics).createTimeToActionCompletionMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const metricsStartTime = window.performance.now();
    sendMessageLatencyMetrics.start({
        startTime: metricsStartTime
    });
    timeToFirstAnswerPartLatencyMetrics.start({
        startTime: metricsStartTime
    });
    if ((0, $iDrrr.fg)('aifc_create_enabled') || (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
        timeToFirstActionPartLatencyMetrics.start();
        timeToActionCompletionLatencyMetrics.start();
    }
    const stopInteractionMetricsTimeToFirstAnswerPart = (0, $lpYvl.getMetricEndHelper)(timeToFirstAnswerPartLatencyMetrics);
    const stopInteractionMetricsTimeToFirstActionPart = (0, $lpYvl.getMetricEndHelper)(timeToFirstActionPartLatencyMetrics);
    const stopInteractionMetricsTimeToActionCompletion = (0, $lpYvl.getMetricEndHelper)(timeToActionCompletionLatencyMetrics);
    const cancelStreamingMetrics = ()=>{
        stopInteractionMetricsTimeToFirstAnswerPart('cancel');
        stopInteractionMetricsTimeToFirstActionPart('cancel');
        stopInteractionMetricsTimeToActionCompletion('cancel');
    };
    return {
        sendMessageLatencyMetrics: sendMessageLatencyMetrics,
        timeToFirstAnswerPartLatencyMetrics: timeToFirstAnswerPartLatencyMetrics,
        timeToFirstActionPartLatencyMetrics: timeToFirstActionPartLatencyMetrics,
        timeToActionCompletionLatencyMetrics: timeToActionCompletionLatencyMetrics,
        stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart,
        stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart,
        stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion,
        cancelStreamingMetrics: cancelStreamingMetrics,
        metricsStartTime: metricsStartTime
    };
};
const $732002bd2dba0f68$var$deriveOptimisticAssistantAuthorIdentity = ({ messageAgentIdentity: messageAgentIdentity, messageRoutingAgentId: messageRoutingAgentId })=>{
    if (!messageAgentIdentity?.agentId) return {
        agentAuthorId: messageRoutingAgentId
    };
    return {
        agentAuthorId: messageAgentIdentity.agentId,
        agentAuthorIdentityAccountId: messageAgentIdentity.identityAccountId
    };
};
const $732002bd2dba0f68$var$hydrateStoreWithNewMessage = (dispatch, conversationId, messageType, tmpHumanMessageId, tmpAssistantMessageId, prompt, files, displayContext, sourceAgentIdForTemporaryLocalConversation, setConversationData, addHumanMessage, addAssistantMessage, clearFollowUpMessages, messageRoutingAgentId, messageAgentIdentity, followUpAgentIdentity)=>{
    const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $1Nzi3.createStoreAbortController)();
    const updateCurrentConversation = (data)=>{
        dispatch(setConversationData({
            conversationId: conversationId,
            data: data
        }));
    };
    const mentionAgentsEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    const gatedFollowUpAgentIdentity = mentionAgentsEnabled ? followUpAgentIdentity : undefined;
    const optimisticAssistantIdentity = mentionAgentsEnabled ? $732002bd2dba0f68$var$deriveOptimisticAssistantAuthorIdentity({
        messageAgentIdentity: messageAgentIdentity,
        messageRoutingAgentId: messageRoutingAgentId
    }) : {
        // Remove this named-id control branch with `rovo_chat_mention_agents` cleanup.
        agentNamedId: sourceAgentIdForTemporaryLocalConversation
    };
    updateCurrentConversation({
        status: (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse,
        storeAbortController: storeAbortController,
        lastMessageType: messageType,
        lastAgentMessageStatus: 'IN_PROGRESS'
    });
    dispatch(addHumanMessage({
        id: tmpHumanMessageId,
        content: prompt,
        conversationId: conversationId,
        fileUploads: files,
        displayContext: displayContext,
        ...gatedFollowUpAgentIdentity ? {
            followUpAgentIdentity: gatedFollowUpAgentIdentity
        } : {}
    }));
    dispatch(addAssistantMessage({
        id: tmpAssistantMessageId,
        content: '',
        conversationId: conversationId,
        ...optimisticAssistantIdentity
    }));
    dispatch(clearFollowUpMessages({
        conversationId: conversationId
    }));
    return {
        abortController: abortController,
        storeAbortController: storeAbortController,
        confirmAbort: confirmAbort,
        updateCurrentConversation: updateCurrentConversation
    };
};
const $732002bd2dba0f68$var$handleSendMessageServiceCallFailure = (error, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, streamActionInfo, chatContextStoreActions, experienceTracker, sendMessageExperienceNameCompiled, trackingAttributes, updateCurrentConversation, sendMessageLatencyMetrics, cancelStreamingMetrics, broadcastStreamLifecycle, confirmAbort, trackAIMAUEvent, messageSources, abortController, hasLoggedInitiatedEvent, tmpAssistantMessageId, clearMessageResearch, getState, conversationId, storeUserMessages, remixRegenerateRequestAttributes)=>{
    const apiError = error instanceof (0, $8A2GO.ApiError) ? error : undefined;
    const normalizedError = error instanceof Error ? error : new Error(String(error));
    // Convert deep research related errors to DeepResearchError when deep research is enabled
    let convertedError = error;
    if (deepResearchEnabled) convertedError = new (0, $bMRok.DeepResearchError)(normalizedError.message, {
        traceId: apiError?.errorAttributes?.traceId,
        requestId: apiError?.errorAttributes?.requestId
    });
    // Returns bad request error because agent is deactivated or user has no permission
    const isAgentDeactivated = error instanceof (0, $8A2GO.ApiError) && error.errorAttributes.errorCode?.includes((0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED);
    const isNoAgentPermission = error instanceof (0, $8A2GO.ApiError) && error.errorAttributes.errorCode?.includes((0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN) && (0, $iDrrr.fg)('convo-ai-enable-agents-use-permission');
    if (isAgentDeactivated || isNoAgentPermission) {
        experienceTracker.fail({
            name: sendMessageExperienceNameCompiled,
            error: normalizedError,
            attributes: {
                conversationId: conversationId,
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                webSearchEnabled: webSearchEnabled,
                llmDebugLogsEnabled: storeUserMessages,
                isStreamAction: streamActionInfo.isAction,
                actionKey: streamActionInfo.actionKey,
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                ...remixRegenerateRequestAttributes
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...(0, $354x3.getRequestedModeAttributes)(trackingAttributes),
                ...trackingAttributes.chatEntryPoint ? {
                    chatEntryPoint: trackingAttributes.chatEntryPoint
                } : {}
            }
        });
        trackAIMAUEvent({
            type: 'error',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: (0, $354x3.getRequestedModeAttributes)(trackingAttributes)
        });
        updateCurrentConversation({
            status: (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError,
            traces: [],
            errorCode: (0, $iDrrr.fg)('convo-ai-enable-agents-use-permission') ? apiError?.errorAttributes.errorCode : undefined
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
        return;
    } else if (error instanceof Error && error.name === 'AbortError') {
        // Check if the abort was programmatic or not. `abortController.signal.aborted` is a readonly field that is only set to true when called programmatically
        // The browser can abort requests to free up resources & save power (esp. on background tabs). When it does this, it **does not** set `abortController.signal.aborted` to true
        const isProgrammaticAbort = abortController.signal.aborted;
        experienceTracker.abort({
            name: sendMessageExperienceNameCompiled,
            reason: 'Aborted',
            attributes: {
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                isProgrammaticAbort: isProgrammaticAbort
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...(0, $354x3.getRequestedModeAttributes)(trackingAttributes),
                ...trackingAttributes.chatEntryPoint ? {
                    chatEntryPoint: trackingAttributes.chatEntryPoint
                } : {}
            }
        });
        trackAIMAUEvent({
            type: 'dismissed',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            subjectId: trackingAttributes.interactionSource,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: (0, $354x3.getRequestedModeAttributes)(trackingAttributes)
        });
        updateCurrentConversation((0, $jyZaR.clearStatus)({
            lastAgentMessageStatus: isProgrammaticAbort ? 'CANCELLED' : 'FAILED'
        }));
        (0, $hMXhO.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
        clearMessageResearch({
            messageId: tmpAssistantMessageId
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ABORTED);
        confirmAbort();
        return;
    } else {
        experienceTracker.fail({
            name: sendMessageExperienceNameCompiled,
            error: normalizedError,
            attributes: {
                conversationId: conversationId,
                deepResearchEnabled: deepResearchEnabled,
                fastModeEnabled: fastModeEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                webSearchEnabled: webSearchEnabled,
                llmDebugLogsEnabled: storeUserMessages,
                isStreamAction: streamActionInfo.isAction,
                actionKey: streamActionInfo.actionKey,
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                ...remixRegenerateRequestAttributes
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...(0, $354x3.getRequestedModeAttributes)(trackingAttributes),
                ...trackingAttributes.chatEntryPoint ? {
                    chatEntryPoint: trackingAttributes.chatEntryPoint
                } : {}
            }
        });
        trackAIMAUEvent({
            type: 'error',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: (0, $354x3.getRequestedModeAttributes)(trackingAttributes)
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
        throw convertedError;
    }
};
/**
 * Compute the per-send routing identity for a send.
 *
 * Wraps `deriveAgentSendRequestIdentity` with the shared inputs (default agent,
 * explicit caller agent id, and the draft-only-on-chatInput override rule) so the
 * outer early-handler fallback and the inner per-send path stay in lockstep.
 *
 * With the experiment enabled, `conversationAgentForRequest` is the resolved canonical UUID:
 * Rovo for a new conversation or `conversation.agent.id` for a later turn. The control keeps
 * the legacy caller identity so its request shape is unchanged. See ai-mate AGENTS.md
 * "Rovo Chat agent identity, routing, and display".
 */ const $732002bd2dba0f68$var$deriveSendRoutingIdentity = ({ conversationAgentForRequest: conversationAgentForRequest, agentIdParam: agentIdParam, inputSelectedAgentIds: inputSelectedAgentIds, messageSources: messageSources, omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields })=>(0, $cVUTD.deriveAgentSendRequestIdentity)({
        conversationAgent: conversationAgentForRequest,
        defaultAgent: (0, $6iQ4q.DEFAULT_AGENT),
        explicitAgentId: agentIdParam,
        omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields,
        inputSelectedAgentIds: inputSelectedAgentIds,
        // The unsent agent-selector draft only routes when the send originates with
        // `messageSources.interactionSource === 'chatInput'`; cross-surface handoffs
        // (e.g. the Confluence inline Rovo input) must not inherit the sidebar's draft.
        allowSelectedAgentOverride: messageSources?.interactionSource === 'chatInput'
    });
/**
 * Build the optimistic `conversation.agent` metadata used when a send creates the
 * conversation. Prefers the already-stored conversation agent, then the caller's
 * rich agent metadata when it matches the resolved conversation agent id, then a
 * provisional placeholder built from that id (the header hydrates the rest).
 */ const $732002bd2dba0f68$var$buildOptimisticConversationAgent = ({ agent: agent, currentConversation: currentConversation, conversationAgentId: conversationAgentId })=>{
    const callerAgentConversationMetadata = agent?.id === conversationAgentId ? {
        agent_id: agent.id,
        agent_named_id: agent.external_config_reference ?? agent.named_id,
        agent_name: agent.name,
        creator_type: agent.creator_type,
        identity_account_id: agent.identity_account_id ?? undefined,
        is_default: agent.is_default,
        forge_url: agent.icon ?? undefined,
        execution_config: agent.execution_config
    } : undefined;
    return currentConversation?.agent ?? callerAgentConversationMetadata ?? (0, $8fLSN.createProvisionalConversationAgent)(conversationAgentId);
};
const $732002bd2dba0f68$export$9558791053c77c34 = ({ prompt: prompt, agent: agent, agentId: agentIdParam, agentIdentityAccountId: agentIdentityAccountIdParam, conversationId: conversationIdParam, storeUserMessages: storeUserMessages, messageSources: messageSources, files: files, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, webSearchEnabled: webSearchEnabled, sourceMode: sourceMode, appFilters: appFilters, selectedCloudIds: selectedCloudIds, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, productKey: productKey, source: source, promptStreamHook: promptStreamHook, creationContextParams: creationContextParams, unsupportedRemixNodeTypes: unsupportedRemixNodeTypes, additionalAnalyticAttributes: additionalAnalyticAttributes, contentContext: contentContext, writingStyleContext: writingStyleContext, minionAlias: minionAlias, onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride, onNewConversationIdAvailable: onNewConversationIdAvailable, contentId: contentId, openChat: openChat, openChatOnError: openChatOnError, agentVersion: agentVersion, spaceId: spaceId, searchArtifact: searchArtifact, skillSelectionSource: skillSelectionSource, skipEditorContext: skipEditorContext, shouldExtractConversationScopes: shouldExtractConversationScopes, parentMessageId: parentMessageId, editRollback: editRollback, inputSelectedAgentIds: inputSelectedAgentIds, messageAgentIdentity: messageAgentIdentity, followUpAgentIdentity: followUpAgentIdentity, invokedByNodeLocalId: invokedByNodeLocalId, setConversationData: setConversationData, createConversationOptimistically: createConversationOptimistically, addHumanMessage: addHumanMessage, addAssistantMessage: addAssistantMessage, clearFollowUpMessages: clearFollowUpMessages, setSelectedConversation: setSelectedConversation, reconnectToInProgressStream: reconnectToInProgressStream })=>async ({ dispatch: dispatch, getState: getState, setState: setState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, chatContextStoreActions: chatContextStoreActions, trackAIMAUEvent: trackAIMAUEvent, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, completeAllSteps: completeAllSteps, updateResearchMessageId: updateResearchMessageId, clearMessageResearch: clearMessageResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, getChatInitiator: getChatInitiator, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamError: processMessageStreamError, processMessageStreamActionClassification: processMessageStreamActionClassification, broadcastStreamStatus: broadcastStreamStatus, siteId: siteId, onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage, onTempMessageIdReplaced: containerOnTempMessageIdReplaced, onHumanMessageIdReplaced: containerOnHumanMessageIdReplaced, browserContextSanitizer: browserContextSanitizer, viewDeadAirBroker: viewDeadAirBroker, getIsChatMounted: getIsChatMounted, capabilities: capabilities, unifiedTasksActions: unifiedTasksActions, onSpaceSourceRecommendations: onSpaceSourceRecommendations, onPromptSent: onPromptSent })=>{
        const mentionAgentsEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
        const implicitRovoAgentId = mentionAgentsEnabled ? (0, $2yWJZ.ROVO_AGENT_UUID) : (0, $2yWJZ.ROVO_AGENT_NAMED_ID);
        // Keep the legacy default-agent object available for all gate-off local behavior while
        // allowing gate-on sends with no caller agent to resolve from conversation state.
        const legacyAgent = agent ?? (0, $6iQ4q.DEFAULT_AGENT);
        const agentForCurrentSendMetadata = mentionAgentsEnabled ? agent : legacyAgent;
        const initialConversationForRouting = (0, $dCJIZ.getConversation)(getState(), conversationIdParam ?? getState().currentConversationId);
        const conversationAgentIdForRoutingFallback = (0, $8fLSN.resolveConversationAgentIdForRouting)({
            conversation: initialConversationForRouting,
            fallbackAgentId: mentionAgentsEnabled ? agent?.id ?? implicitRovoAgentId : legacyAgent.id
        });
        // `sourceAgentId` for the temporary local conversation; per-turn routing is computed by `deriveSendRoutingIdentity`.
        const sourceAgentIdForTemporaryLocalConversation = agentIdParam ?? (mentionAgentsEnabled ? agent?.id ?? implicitRovoAgentId : legacyAgent.id);
        const { messageType: messageType } = $732002bd2dba0f68$var$getOptimisticMessageTypes(deepResearchEnabled, webSearchEnabled);
        let pageContext;
        // Snapshot captured right before the optimistic add when `editRollback` is set,
        // so that a terminal failure can restore the conversation to its pre-edit state
        // by slicing back to this length and re-appending `editRollback.restoreMessages`.
        let rollbackSnapshot;
        const performEditRollback = ()=>{
            if (!editRollback || !rollbackSnapshot) return;
            const { conversationId: rollbackConvId, lengthBeforeOptimistic: lengthBeforeOptimistic } = rollbackSnapshot;
            const current = getMessages(rollbackConvId);
            setMessages(rollbackConvId, [
                ...current.slice(0, lengthBeforeOptimistic),
                ...editRollback.restoreMessages
            ]);
        };
        const sendMessageFn = async ({ conversationId: conversationId })=>{
            const getContentIdForAskQuestionAttributes = ()=>contentId === undefined ? undefined : String(contentId);
            const getResultAttributesForAskQuestion = ()=>{
                if (!(0, $ieeJu.expValEquals)('cc-disambiguation-in-cwr', 'isEnabled', true)) return undefined;
                const confluenceContentId = getContentIdForAskQuestionAttributes();
                if (!confluenceContentId) return undefined;
                return (0, $lUXDc.getConfluenceResultAcceptanceAttributesForAskQuestion)({
                    messages: getMessages(conversationId),
                    contentId: confluenceContentId
                });
            };
            const currentConversation = (0, $dCJIZ.getConversation)(getState(), conversationId);
            const isCreateWithRovoSend = creationContextParams?.source === 'ai-first-creation' || creationContextParams?.source === 'chat-only-creation-modal' || creationContextParams?.experience === 'cwr' || creationContextParams?.experience === 'cwr_type' || creationContextParams?.experience === 'cwr_edit';
            // Resolve Space context before optimistic creation so the local chat-mode store and
            // backend request use the same source mode for entity-driven empty-chat launches.
            // CWR should not send within a space.
            const resolvedSpaceId = spaceId ?? (!isCreateWithRovoSend ? chatContextStoreActions.getAIFeatureContext()?.projectContext?.spaceId : undefined);
            const spaceScopedSourceMode = (0, $5odSY.getSpaceScopedSourceMode)({
                sourceMode: sourceMode,
                spaceId: resolvedSpaceId ?? currentConversation?.rovoSpaceId
            });
            const currentConversationAgentId = (0, $8fLSN.resolveConversationAgentIdForRouting)({
                conversation: currentConversation,
                fallbackAgentId: conversationAgentIdForRoutingFallback
            });
            const conversationAgentForOptimisticCreation = $732002bd2dba0f68$var$buildOptimisticConversationAgent({
                agent: agent,
                currentConversation: currentConversation,
                conversationAgentId: currentConversationAgentId
            });
            const { routedSelectedAgentId: routedSelectedAgentId, routingAgentId: messageRoutingAgentId, agentIdForRequest: agentIdForRequest, agentNamedIdForRequest: agentNamedIdForRequest } = $732002bd2dba0f68$var$deriveSendRoutingIdentity({
                conversationAgentForRequest: mentionAgentsEnabled ? {
                    id: agent?.id ?? currentConversationAgentId
                } : {
                    id: legacyAgent.id,
                    named_id: legacyAgent.named_id
                },
                agentIdParam: agentIdParam,
                inputSelectedAgentIds: inputSelectedAgentIds,
                messageSources: messageSources,
                omitConversationDefaultAgentRequestFields: !mentionAgentsEnabled
            });
            const sendMessageExperienceNameCompiled = $732002bd2dba0f68$var$getSendMessageExperienceName({
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                taskModeEnabled: taskModeEnabled,
                fastModeEnabled: fastModeEnabled,
                isCustomRovoAgent: (0, $biBci.isRovoCustomAgent)(messageRoutingAgentId)
            });
            const resolvedAgentVersion = agentVersion ?? currentConversation?.agentVersion;
            if (currentConversation?.storeAbortController) // Silently aborting if there is another operation in progress
            return;
            const tmpHumanMessageId = (0, $icBz6.generateId)();
            const tmpAssistantMessageId = (0, $j5JhI.generateTmpMessageId)(conversationId);
            let generator;
            let responseData;
            let hasLoggedInitiatedEvent = false;
            const isFirstPrompt = (0, $1IZrU.isEmptyConversation)(conversationId);
            const contentContextFromStore = chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global';
            const contentContextValue = contentContext ?? contentContextFromStore;
            const isSitesSourceFilterEnabled = (0, $iDrrr.fg)((0, $5XWbo.ROVO_CHAT_SITES_SOURCE_FILTER_GATE));
            const selectedCloudIdsForGatedFeature = isSitesSourceFilterEnabled ? selectedCloudIds : undefined;
            let trackingAttributes = $732002bd2dba0f68$var$getInitialTrackingAttributes(messageRoutingAgentId, tmpAssistantMessageId, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, taskModeEnabled, webSearchEnabled, messageSources, isFirstPrompt, prompt, files, appFilters, selectedCloudIdsForGatedFeature, {
                templateId: creationContextParams?.templateInput?.templateId,
                templateType: creationContextParams?.templateInput?.templateType
            }, creationContextParams?.forcedContentType);
            // Read from the conversation so entry-point attribution persists across turns.
            trackingAttributes.chatEntryPoint = currentConversation?.chatEntryPoint;
            // Prepare fields for the temporary local conversation created before the backend returns one.
            const conversationAgentForTemporaryLocalConversation = mentionAgentsEnabled ? conversationAgentForOptimisticCreation : undefined;
            const conversationAgentFieldsForTemporaryLocalConversation = conversationAgentForTemporaryLocalConversation ? {
                agent: conversationAgentForTemporaryLocalConversation
            } : {};
            // Participant membership is backend-authoritative. We intentionally avoid
            // optimistic participant writes here because matching backend semantics would
            // require duplicating dedupe, edit/fork, branch-pruning, and multi-turn
            // recomputation rules in the frontend.
            if (isFirstPrompt) {
                conversationId = crypto.randomUUID();
                onNewConversationStartingWithSendMessage(conversationId, {
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                    fastModeEnabled: fastModeEnabled,
                    ...taskModeEnabled ? {
                        planModeEnabled: taskModeEnabled
                    } : {},
                    webSearchEnabled: webSearchEnabled,
                    sourceMode: spaceScopedSourceMode,
                    useCurrentPageContext: addCurrentPageAsContextUserPreference,
                    appFilters: appFilters,
                    selectedCloudIds: selectedCloudIdsForGatedFeature ?? []
                });
                onNewConversationIdAvailable?.(conversationId);
                // Create the conversation with its initial identity; first-turn routing may
                // refine `conversation.agent` below.
                dispatch(createConversationOptimistically({
                    id: conversationId,
                    status: (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse,
                    sourceAgentId: currentConversation?.sourceAgentId ?? sourceAgentIdForTemporaryLocalConversation,
                    lastMessageType: messageType,
                    lastAgentMessageStatus: 'IN_PROGRESS',
                    resultAttributionContext: currentConversation?.resultAttributionContext,
                    chatEntryPoint: currentConversation?.chatEntryPoint,
                    // Immediately associate the optimistic conversation with the space.
                    ...resolvedSpaceId ? (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? {
                        rovoSpaceId: resolvedSpaceId
                    } : {} : {},
                    ...resolvedAgentVersion && (0, $iDrrr.fg)('rovo_agent_versioning_enabled') ? {
                        agentVersion: resolvedAgentVersion
                    } : {},
                    ...conversationAgentFieldsForTemporaryLocalConversation
                }));
                (0, $baWyq.recordValidMessage)();
                // First-turn routing can refine display identity; keep `sourceAgentId` as history.
                const normalizedRoutingAgentId = messageRoutingAgentId || undefined;
                const provisionalRoutedConversationAgent = (0, $8fLSN.createProvisionalConversationAgent)(normalizedRoutingAgentId);
                const routedIdentityAccountId = messageAgentIdentity && messageAgentIdentity.agentId === normalizedRoutingAgentId ? messageAgentIdentity.identityAccountId : undefined;
                const routedConversationAgent = provisionalRoutedConversationAgent && routedIdentityAccountId ? {
                    ...provisionalRoutedConversationAgent,
                    identity_account_id: routedIdentityAccountId
                } : provisionalRoutedConversationAgent;
                if (mentionAgentsEnabled && routedConversationAgent && normalizedRoutingAgentId !== currentConversationAgentId) dispatch(setConversationData({
                    conversationId: conversationId,
                    data: {
                        agent: routedConversationAgent
                    }
                }));
            }
            (0, $b2pOf.persistRecentConversation)({
                type: 'message-sent',
                siteId: siteId,
                conversationId: conversationId,
                lastMessageSentAt: Date.now()
            });
            const { sendMessageLatencyMetrics: sendMessageLatencyMetrics, stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart, stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion, cancelStreamingMetrics: cancelStreamingMetrics, metricsStartTime: metricsStartTime } = $732002bd2dba0f68$var$initLatencyMetrics({
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                agentId: messageRoutingAgentId
            });
            const remixRegenerateRequestAttributes = (0, $ks26f.getRemixRegenerateRequestAttributes)({
                creationContextParams: creationContextParams,
                messageSources: messageSources
            });
            const remixCreateRequestAttributes = (0, $bETzY.getRemixCreateRequestAttributes)({
                creationContextParams: creationContextParams,
                messageSources: messageSources
            });
            experienceTracker.start({
                name: sendMessageExperienceNameCompiled,
                id: conversationId,
                attributes: {
                    conversationId: conversationId,
                    interactionSource: messageSources?.interactionSource,
                    resendSource: messageSources?.resendSource,
                    featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                    ...remixRegenerateRequestAttributes,
                    ...remixCreateRequestAttributes
                }
            });
            const chatInitiator = getChatInitiator();
            const { isRemixFollowUp: isRemixFollowUp, lastAssistantMessageDynamicUiType: lastAssistantMessageDynamicUiType } = (()=>{
                const lastAction = (0, $kNXXO.findLastAssistantAction)(getMessages(conversationId), ()=>true);
                if (!lastAction || !(0, $aYC8J.isRemixGeneratedFlow)(lastAction)) return {
                    isRemixFollowUp: false,
                    lastAssistantMessageDynamicUiType: undefined
                };
                // BE stores dynamicUiType under `contentType` in action data
                const contentType = lastAction.data?.contentType;
                return {
                    isRemixFollowUp: true,
                    lastAssistantMessageDynamicUiType: contentType
                };
            })();
            let sendMessageContext;
            try {
                sendMessageContext = await (0, $cC5sC.populateSendMessageContext)(chatContextStoreActions, isFirstPrompt, source, prompt, addCurrentPageAsContextUserPreference, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, contentId, lastAssistantMessageDynamicUiType, skipEditorContext, isRemixFollowUp, searchArtifact);
            } catch (error) {
                experienceTracker.fail({
                    name: sendMessageExperienceNameCompiled,
                    error: error,
                    attributes: {
                        conversationId: conversationId,
                        deepResearchEnabled: deepResearchEnabled,
                        fastModeEnabled: fastModeEnabled,
                        thinkDeeperEnabled: thinkDeeperEnabled,
                        webSearchEnabled: webSearchEnabled,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        failureSource: 'populateSendMessageContext',
                        ...remixRegenerateRequestAttributes
                    }
                });
                // Note: We don't track error in error event as discussed here:
                // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/341408/overview#comment-2004687398
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                return;
            }
            let aiFeatureContextForBackend = sendMessageContext.aiFeatureContext;
            if (isCreateWithRovoSend && sendMessageContext.aiFeatureContext?.projectContext) {
                const { spaceId: _spaceId, ...projectContextWithoutSpaceId } = sendMessageContext.aiFeatureContext.projectContext;
                aiFeatureContextForBackend = {
                    ...sendMessageContext.aiFeatureContext,
                    projectContext: projectContextWithoutSpaceId
                };
            }
            const storeState = chatContextStoreActions.getAllContext();
            trackingAttributes.contextProvided = Object.entries(storeState).reduce((acc, [key, value])=>{
                acc[key] = Boolean(value);
                return acc;
            }, {});
            trackingAttributes.contextProvided.editorContext = Boolean(sendMessageContext.editorContext);
            trackingAttributes.contextProvided.whiteboardContext = Boolean(sendMessageContext.whiteboardContext);
            trackingAttributes.contextProvided.slidesContext = Boolean(sendMessageContext.slidesContext);
            trackingAttributes.contextProvided.databaseContext = Boolean(sendMessageContext.databaseContext);
            trackingAttributes.contextProvided.browserContext = Boolean(sendMessageContext.browserContext);
            trackingAttributes.contextProvided.dashboardContext = Boolean(sendMessageContext.dashboardContext);
            trackingAttributes.contextProvided.aiFeatureContext = Boolean(sendMessageContext.aiFeatureContext);
            trackingAttributes.contextProvided.jiraWorkflowContext = Boolean(sendMessageContext.jiraWorkflowContext);
            trackingAttributes.contextProvided.domContext = Boolean(sendMessageContext.browserContext?.context?.htmlBody);
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'sent',
                actionSubject: 'message',
                attributes: {
                    timestamp: undefined,
                    messageId: trackingAttributes.humanMessageId,
                    interactionSource: trackingAttributes.interactionSource,
                    resendSource: messageSources?.resendSource,
                    followUpSource: trackingAttributes.followUpSource,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    maxModeEnabled: trackingAttributes.taskModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    contextProvided: trackingAttributes.contextProvided,
                    initiator: chatInitiator,
                    isFirstPrompt: trackingAttributes.isFirstPrompt,
                    promptFeatures: trackingAttributes.promptFeatures,
                    fileCount: trackingAttributes.fileCount,
                    appFilters: trackingAttributes.appFilters,
                    appFilterCount: trackingAttributes.appFilterCount,
                    ...isSitesSourceFilterEnabled ? {
                        selectedCloudIds: trackingAttributes.selectedCloudIds,
                        selectedCloudIdCount: trackingAttributes.selectedCloudIdCount
                    } : {},
                    has3pApps: trackingAttributes.appFilters?.some((app)=>(0, $6xccU.is3pApp)(app.friendlyName)),
                    template: trackingAttributes.template,
                    deepResearchInvoked: trackingAttributes.deepResearchInvoked,
                    conversationChannelId: conversationId
                }
            });
            if (editRollback && !rollbackSnapshot) rollbackSnapshot = {
                conversationId: conversationId,
                lengthBeforeOptimistic: getMessages(conversationId).length
            };
            // Seed the agent-run-state correlation now that the run's conversationId is final and
            // streaming has not started. Prefer the value threaded through the auto-send flow; fall
            // back to the stash set at chat-new time (the draft → manual-send path). No-op for
            // non-mention runs. Always consume the stash so a stale value can't leak into a later send.
            const stashedInvocationLocalId = (0, $9vNm5.consumeAgentRunInvocation)();
            const runInvokedByNodeLocalId = invokedByNodeLocalId ?? stashedInvocationLocalId;
            if (runInvokedByNodeLocalId) (0, $9vNm5.beginAgentRun)(conversationId, runInvokedByNodeLocalId);
            const shouldResolveOptimisticBrowserContext = (0, $iDrrr.fg)('rovo_chat_prompt_context_display_render') && sendMessageContext.useCurrentBrowsingContext === true;
            const optimisticBrowserUrl = shouldResolveOptimisticBrowserContext ? (0, $bQQtO.resolveMessageStreamBrowserUrl)({
                browserContext: sendMessageContext.browserContext,
                browserContextSanitizer: browserContextSanitizer,
                product: assistanceService.getConfig().product
            }).browserUrl : undefined;
            const isOptimisticBrowserUrlBlocklisted = Boolean(optimisticBrowserUrl && browserContextSanitizer?.isBlocklisted(optimisticBrowserUrl));
            const optimisticDisplayContext = optimisticBrowserUrl && optimisticBrowserUrl !== 'NO-URL' && !isOptimisticBrowserUrlBlocklisted ? {
                references: [
                    {
                        type: 'BROWSER_URL',
                        browser_url: optimisticBrowserUrl
                    }
                ]
            } : undefined;
            const { abortController: abortController, confirmAbort: confirmAbort, updateCurrentConversation: updateCurrentConversation } = $732002bd2dba0f68$var$hydrateStoreWithNewMessage(dispatch, conversationId, messageType, tmpHumanMessageId, tmpAssistantMessageId, prompt, files, optimisticDisplayContext, sourceAgentIdForTemporaryLocalConversation, setConversationData, addHumanMessage, addAssistantMessage, clearFollowUpMessages, messageRoutingAgentId, messageAgentIdentity, followUpAgentIdentity);
            const clearRetainedUserSubmission = (0, $4KNZy.userSubmissionLifecycle).recordLatestUserSubmission({
                conversationId: conversationId,
                humanMessageId: tmpHumanMessageId
            }, {
                abortSignal: abortController.signal
            });
            // Assumed the insert is successful and inserts at the last position
            const answerIndex = getMessages(conversationId).length - 1;
            // Broadcast stream status to content targets for state sharing
            const broadcastStreamLifecycle = (0, $iMppo.createBroadcastStreamLifecycle)({
                broadcastStreamStatus: broadcastStreamStatus,
                chatContextStoreActions: chatContextStoreActions,
                contentContextValue: contentContextValue,
                targetId: contentId,
                assistantMessageId: tmpAssistantMessageId
            });
            broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).SEND_CONTEXT_READY);
            // Initialize action tracking
            let streamActionInfo = {
                isAction: false
            };
            // Create message stream
            try {
                // Derive page context for analytics from the available context objects
                pageContext = (0, $Q8n54.getPageContext)({
                    editorContext: sendMessageContext.editorContext,
                    whiteboardContext: sendMessageContext.whiteboardContext,
                    databaseContext: sendMessageContext.databaseContext,
                    aiFeatureContext: sendMessageContext.aiFeatureContext,
                    browserUrl: sendMessageContext.browserContext?.context?.browserUrl
                });
                // `contentId` is an optional, caller-supplied `SendMessageParams` field: only the
                // inline input box (`bridge-api/handlers`) and the staging-area flows pass one. The
                // chat input and the pubsub/agent-mention routes leave it undefined, so requiring it
                // here suppressed the callback on the sidebar surfaces this exists for. It is passed
                // through as optional payload instead, and consumers that need content identity
                // resolve it from their own product context.
                if (onPromptSent && (0, $cXtTj.default).getExperimentValue('platform_teflon_chat_on_prompt_sent', 'isEnabled', false) && typeof pageContext === 'string' && pageContext !== 'unknown') {
                    sendAnalyticsEvent({
                        eventType: 'operational',
                        action: 'onPromptSentInvoked',
                        actionSubject: 'aiMate',
                        attributes: {
                            pageContext: pageContext
                        }
                    });
                    const promptContentId = contentId;
                    const promptPageContext = pageContext;
                    Promise.resolve().then(()=>onPromptSent({
                            pageContext: promptPageContext,
                            contentId: promptContentId,
                            agentIdentityAccountId: agentForCurrentSendMetadata?.identity_account_id ?? undefined
                        })).catch((error)=>{
                        sendAnalyticsEvent({
                            eventType: 'operational',
                            action: 'onPromptSentError',
                            actionSubject: 'aiMate',
                            attributes: {
                                failureReason: 'callbackRejected',
                                errorName: error instanceof Error ? error.name : undefined,
                                pageContext: pageContext
                            }
                        });
                    });
                }
                trackingAttributes.pageContext = pageContext;
                trackingAttributes.viewContext = (0, $4cgYj.getViewContext)({
                    aiFeatureContext: sendMessageContext.aiFeatureContext
                });
                trackingAttributes.invokedFrom = (0, $gB8YL.getInvokedFrom)({
                    messageActionKey: streamActionInfo?.actionKey
                });
                // Check if the Jira refresh experiment is enabled but default is set to `true` to pass all non-Jira products
                // Omit caller source controls only for sends routed by `routedSelectedAgentId`;
                // see `getSourceControlValueForBackend`.
                const webSearchEnabledForBackend = (0, $3GbnU.getSourceControlValueForBackend)({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: webSearchEnabled
                });
                const appFiltersForBackend = (0, $3GbnU.getSourceControlValueForBackend)({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: appFilters
                });
                const selectedCloudIdsForBackend = (0, $3GbnU.getSourceControlValueForBackend)({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: selectedCloudIdsForGatedFeature
                });
                const sourceModeForBackend = (0, $3GbnU.getSourceControlValueForBackend)({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: spaceScopedSourceMode
                });
                // Experiment-on requests are UUID-only. Remove the control-only named-id request
                // field with `rovo_chat_mention_agents` cleanup.
                const isFollowUpSend = mentionAgentsEnabled && followUpAgentIdentity !== undefined;
                const agentIdForBackend = isFollowUpSend ? followUpAgentIdentity.id : agentIdForRequest;
                const agentNamedIdForBackend = mentionAgentsEnabled ? undefined : agentNamedIdForRequest;
                const result = await assistanceService.sendMessageStream({
                    message: prompt,
                    agentId: agentIdForBackend,
                    ...mentionAgentsEnabled ? {} : {
                        agentNamedId: agentNamedIdForBackend
                    },
                    controller: abortController,
                    conversationId: conversationId,
                    storeMessage: storeUserMessages,
                    citationsEnabled: true,
                    fileIds: files?.map((file)=>file.id),
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    planModeEnabled: taskModeEnabled,
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                    fastModeEnabled: fastModeEnabled,
                    webSearchEnabled: webSearchEnabledForBackend,
                    sourceMode: sourceModeForBackend,
                    appFilters: appFiltersForBackend?.map((app)=>app.source),
                    selectedCloudIds: selectedCloudIdsForBackend,
                    ...minionAlias && (0, $cha5E.expVal)('cc_contextual_agent_creation_v2', 'isEnabled', false) ? {
                        minionAliasConfig: {
                            stratus_config: {
                                minion_alias: minionAlias
                            }
                        }
                    } : {},
                    browserContext: sendMessageContext.browserContext,
                    editorContext: sendMessageContext.editorContext,
                    whiteboardContext: sendMessageContext.whiteboardContext,
                    slidesContext: sendMessageContext.slidesContext,
                    databaseContext: sendMessageContext.databaseContext,
                    additionalContext: sendMessageContext.additionalContext,
                    writingStyleContext: writingStyleContext,
                    aiFeatureContext: aiFeatureContextForBackend,
                    jiraWorkflowContext: sendMessageContext.jiraWorkflowContext,
                    dashboardContext: sendMessageContext.dashboardContext,
                    dashboardEditorContext: sendMessageContext.dashboardEditorContext,
                    useCurrentBrowsingContext: sendMessageContext.useCurrentBrowsingContext,
                    browserContextSanitizer: browserContextSanitizer,
                    optInToDeepResearchV2: true,
                    optInThinkDeeperMessages: true,
                    optInAnsNow: true,
                    optInNewToolTraces: true,
                    optInNewTeamworkTraceIcons: (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26'),
                    optInSSEStream: true,
                    ...resolvedAgentVersion ? {
                        agentVersion: resolvedAgentVersion
                    } : {},
                    ...resolvedSpaceId ? {
                        spaceId: resolvedSpaceId
                    } : {},
                    capabilities: capabilities,
                    shouldExtractConversationScopes: shouldExtractConversationScopes,
                    parentMessageId: parentMessageId
                });
                generator = result.generator;
                responseData = result.responseData;
            } catch (error) {
                clearRetainedUserSubmission();
                if ((0, $iDrrr.fg)('aifc_show_error_ui_for_inline_rovo')) promptStreamHook?.onError?.(error, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId
                });
                performEditRollback();
                $732002bd2dba0f68$var$handleSendMessageServiceCallFailure(error, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, streamActionInfo, chatContextStoreActions, experienceTracker, sendMessageExperienceNameCompiled, trackingAttributes, updateCurrentConversation, sendMessageLatencyMetrics, cancelStreamingMetrics, broadcastStreamLifecycle, confirmAbort, trackAIMAUEvent, messageSources, abortController, hasLoggedInitiatedEvent, tmpAssistantMessageId, clearMessageResearch, getState, conversationId, storeUserMessages, remixRegenerateRequestAttributes);
                return;
            }
            const { hasReceivedFinalResponse: hasReceivedFinalResponse, hasLoggedInitiatedEvent: hasLoggedInitiatedEventForStream, hasAbortedForImplicitThinkDeeper: hasAbortedForImplicitThinkDeeper, implicitThinkDeeperSendMessageMetrics: implicitThinkDeeperSendMessageMetrics, implicitThinkDeeperExperienceName: implicitThinkDeeperExperienceName, guardEventReceived: wasGuardTerminated, assistantMessageId: assistantMessageId } = await (0, $8P1Kw.processStream)({
                prompt: prompt,
                generator: generator,
                productKey: productKey,
                answerIndex: answerIndex,
                tmpHumanMessageId: tmpHumanMessageId,
                tmpAssistantMessageId: tmpAssistantMessageId,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                deepResearchEnabled: deepResearchEnabled,
                webSearchEnabled: webSearchEnabled,
                sendMessageExperienceNameCompiled: sendMessageExperienceNameCompiled,
                traceId: responseData?.traceId,
                updateCurrentConversation: updateCurrentConversation,
                trackingAttributes: trackingAttributes,
                conversationId: conversationId,
                getState: getState,
                promptStreamHook: promptStreamHook,
                openChat: openChat,
                openChatOnError: openChatOnError,
                experienceTracker: experienceTracker,
                setMessages: setMessages,
                getMessages: getMessages,
                processStreamResearch: processStreamResearch,
                processMessageStreamAction: processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                processMessageStreamError: processMessageStreamError,
                processMessageStreamActionClassification: processMessageStreamActionClassification,
                onSpaceSourceRecommendations: onSpaceSourceRecommendations,
                containerOnTempMessageIdReplaced: containerOnTempMessageIdReplaced,
                containerOnHumanMessageIdReplaced: containerOnHumanMessageIdReplaced,
                updateResearchMessageId: updateResearchMessageId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                chatContextStoreActions: chatContextStoreActions,
                stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart,
                stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart,
                stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion,
                broadcastStreamLifecycle: broadcastStreamLifecycle,
                sendMessageLatencyMetrics: sendMessageLatencyMetrics,
                cancelStreamingMetrics: cancelStreamingMetrics,
                onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride,
                streamActionInfo: streamActionInfo,
                trackAIMAUEvent: trackAIMAUEvent,
                messageSources: messageSources,
                additionalAnalyticAttributes: additionalAnalyticAttributes,
                unsupportedRemixNodeTypes: unsupportedRemixNodeTypes,
                hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
                clearMessageResearch: clearMessageResearch,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                viewDeadAirBroker: viewDeadAirBroker,
                creationContextParams: creationContextParams,
                minionAlias: minionAlias && (0, $cha5E.expVal)('cc_contextual_agent_creation_v2', 'isEnabled', false) ? minionAlias : assistanceService.getConfig().minionAlias,
                agentId: messageRoutingAgentId,
                // Only surface name/identity from the optional `agent` metadata when it
                // actually describes the routed agent. Prefer the explicitly threaded
                // identity account id from the @mention handoff.
                agentName: agentForCurrentSendMetadata?.id === messageRoutingAgentId ? agentForCurrentSendMetadata.name : undefined,
                // This guard prevents the default agent identity from leaking into the telepointer when the routed specialist agent object has not hydrated yet.
                agentIdentityAccountId: agentIdentityAccountIdParam ?? (agentForCurrentSendMetadata?.id === messageRoutingAgentId ? agentForCurrentSendMetadata.identity_account_id : undefined),
                storeUserMessages: storeUserMessages,
                skillSelectionSource: skillSelectionSource,
                assistanceService: assistanceService,
                abortController: abortController,
                getIsChatMounted: getIsChatMounted,
                metricsStartTime: metricsStartTime,
                onTaskStatusUpdate: (streamMessage)=>{
                    if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
                    (0, $aKQ2h.handleStreamTaskStatus)({
                        conversationId: conversationId,
                        taskMessage: streamMessage.message,
                        messageId: trackingAttributes.messageId,
                        target: (0, $3Bvlb.buildUnifiedStreamTaskTarget)(unifiedTasksActions)
                    });
                },
                onTodoSnapshot: ({ todos: todos })=>{
                    if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.setTaskTodoSnapshot({
                        conversationId: conversationId,
                        todoSnapshot: {
                            todos: todos
                        }
                    });
                },
                onPromptBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $eMs38.randomIntFromInterval)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                },
                onPromptRedacted: (streamMessage)=>{
                    // Only update the human message with the redacted prompt.
                    // Keep the assistant placeholder — the stream continues with the actual response.
                    const chat = getMessages(conversationId);
                    let lastHumanIdx = -1;
                    chat.forEach((m, i)=>{
                        if ((0, $igOtY.isStoreHuman)(m)) lastHumanIdx = i;
                    });
                    if (lastHumanIdx === -1) return;
                    const newChat = [
                        ...chat
                    ];
                    newChat[lastHumanIdx] = {
                        ...chat[lastHumanIdx],
                        redactedPrompt: streamMessage.message.redacted_prompt
                    };
                    setMessages(conversationId, newChat);
                },
                onResponseRedacted: (streamMessage)=>{
                    // Set redactedResponse on the latest assistant message so the scribble UI renders.
                    // Do NOT set guardEventReceived — the stream continues after response redaction.
                    const chat = getMessages(conversationId);
                    let lastAssistantIdx = -1;
                    chat.forEach((m, i)=>{
                        if ((0, $igOtY.isStoreAssistant)(m)) lastAssistantIdx = i;
                    });
                    if (lastAssistantIdx === -1) return;
                    const newChat = [
                        ...chat
                    ];
                    newChat[lastAssistantIdx] = {
                        ...chat[lastAssistantIdx],
                        redactedResponse: streamMessage.message.redacted_response
                    };
                    setMessages(conversationId, newChat);
                },
                onResponseBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $eMs38.randomIntFromInterval)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                },
                onAttachmentBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $eMs38.randomIntFromInterval)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                }
            }).finally(clearRetainedUserSubmission);
            hasLoggedInitiatedEvent = hasLoggedInitiatedEventForStream;
            // TODO: This should be behind the !aborted logic, but due to a bug in the BE service, aborted requests
            // will client connection with the server yet still complete in the background. This results in the UI showing
            // no message updates, until reload when the actual resolved message can be sesen.
            // Once that is fixed, we can place this behind the !aborted logic.
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'received',
                actionSubject: 'agentMessage',
                attributes: {
                    // messageId must remain the ID received from the server in the FINAL_RESPONSE
                    // in order to map correctly to our event funnel, e.g `agentMessage received` -> `agentResponse content copied`
                    messageId: trackingAttributes.messageId,
                    humanMessageId: trackingAttributes.humanMessageId,
                    pluginsInvoked: Array.from(trackingAttributes.pluginsInvoked),
                    requestId: trackingAttributes.requestId,
                    hasSources: trackingAttributes.hasSources,
                    // Non-UGC authoritative-answer descriptors, populated during the
                    // stream (gated on rovo_authoritative_answer_attribution).
                    ...trackingAttributes.hasAuthoritativeSources ? {
                        hasAuthoritativeSources: true,
                        authorityLevel: trackingAttributes.authorityLevel,
                        isHighlyAuthoritative: trackingAttributes.isHighlyAuthoritative,
                        overallConfidence: trackingAttributes.overallConfidence,
                        authoritativeSourceCount: trackingAttributes.authoritativeSourceCount,
                        authoritativeExpertCount: trackingAttributes.authoritativeExpertCount
                    } : {},
                    citedProductList: trackingAttributes.citedProductList,
                    connectorInfo: trackingAttributes.connectorInfo,
                    sourceProducts: trackingAttributes.sourceProducts,
                    has3pApps: Object.keys(trackingAttributes.sourceProducts ?? {}).some((0, $6xccU.is3pApp)),
                    timestamp: new Date().toISOString(),
                    messageActions: trackingAttributes.messageActions,
                    messageDynamicUIData: trackingAttributes.messageDynamicUIData,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    initiator: chatInitiator,
                    deepResearchInvoked: trackingAttributes.deepResearchInvoked,
                    scenarioId: trackingAttributes.scenarioId,
                    // Lumina content descriptors (see trackingAttributes.hasLumina).
                    // Joined on messageId against the
                    // `luminaComponent shown` render event to detect Lumina returned
                    // by the backend but never rendered.
                    ...trackingAttributes.hasLumina ? {
                        hasLumina: true,
                        luminaType: trackingAttributes.luminaType,
                        luminaCount: trackingAttributes.luminaCount
                    } : {}
                }
            });
            const wasProgrammaticallyAborted = abortController.signal.aborted;
            updateCurrentConversation((0, $jyZaR.clearStatus)({
                lastAgentMessageStatus: wasProgrammaticallyAborted ? 'CANCELLED' : 'SUCCESSFUL'
            }));
            setMessages(conversationId, (0, $fANCm.markStreamingMessagesAsComplete)(getMessages(conversationId)));
            if (abortController.signal.aborted) {
                if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
                // Delaying the initiated event firing allows us to create the pairing appropriately,
                // for any initiated events leading up to an error or dismiss state with a
                // hashed ID
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: trackingAttributes.messageSentTimeStamp,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    attributes: {
                        ...(0, $354x3.getRequestedModeAttributes)(trackingAttributes),
                        ...trackingAttributes.chatEntryPoint ? {
                            chatEntryPoint: trackingAttributes.chatEntryPoint
                        } : {}
                    }
                });
                trackAIMAUEvent({
                    type: 'dismissed',
                    userGenerated: true,
                    messageId: trackingAttributes.messageId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    subjectId: trackingAttributes.interactionSource,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    attributes: {
                        ...(0, $354x3.getRequestedModeAttributes)(trackingAttributes),
                        ...messageSources?.entryPoint && {
                            entryPoint: messageSources.entryPoint
                        }
                    }
                });
                confirmAbort();
                broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ABORTED);
                // Call the cancel API if we have a message ID
                if (trackingAttributes.messageId) assistanceService.cancelMessageStream({
                    conversationId: conversationId,
                    messageId: trackingAttributes.messageId
                }).catch((error)=>{
                    // Log but don't throw - the abort is already happening
                    (0, $hlvTd.logException)({
                        name: 'rovoCancelMessageStream',
                        exception: error,
                        tags: {
                            conversationId: conversationId,
                            messageId: trackingAttributes.messageId
                        }
                    });
                });
                // For implicit think-deeper, the auto-mode experience was already aborted inside processStream;
                // abort the re-attributed think-deeper experience instead.
                experienceTracker.abort({
                    name: hasAbortedForImplicitThinkDeeper ? implicitThinkDeeperExperienceName ?? (0, $irnO2.ExperienceName).SEND_TD_MESSAGE : sendMessageExperienceNameCompiled,
                    reason: 'Aborted',
                    attributes: {
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        isProgrammaticAbort: true // always true because we're within abortController.signal.aborted (further explained in similar abort for AbortError case)
                    }
                });
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
                    reason: 'stream aborted'
                });
                completeAllSteps({
                    messageId: assistantMessageId
                });
                return;
            } else {
                if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
                // Delaying the initiated event firing allows us to create the pairing appropriately,
                // for any initiated events leading up to an error or dismiss state with a
                // hashed ID
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: trackingAttributes.messageSentTimeStamp,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    attributes: {
                        ...(0, $354x3.getRequestedModeAttributes)(trackingAttributes),
                        ...trackingAttributes.chatEntryPoint ? {
                            chatEntryPoint: trackingAttributes.chatEntryPoint
                        } : {}
                    }
                });
                //If we're done processing the stream and no answer part has been processed, then it means that the BE is hanging. Throw an error
                if (!hasReceivedFinalResponse && !wasGuardTerminated) {
                    const agentDetails = await assistanceService.getAgentDetails(messageRoutingAgentId);
                    if (agentDetails.deactivated) {
                        // If agent is deactivated, throw correct error
                        const agentError = new (0, $kncFb.NoFinalResponseError)('The selected agent may no longer be available.', {
                            traceId: responseData?.traceId
                        });
                        experienceTracker.fail({
                            name: sendMessageExperienceNameCompiled,
                            error: agentError,
                            attributes: {
                                conversationId: conversationId,
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                llmDebugLogsEnabled: storeUserMessages,
                                isStreamAction: streamActionInfo.isAction,
                                actionKey: streamActionInfo.actionKey,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                                traceId: responseData?.traceId,
                                ...remixRegenerateRequestAttributes
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: true,
                            messageId: trackingAttributes.requestId,
                            timestamp: new Date().toISOString(),
                            singleInstrumentationID: trackingAttributes.instrumentationId,
                            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                            fastModeEnabled: trackingAttributes.fastModeEnabled,
                            webSearchEnabled: trackingAttributes.webSearchEnabled,
                            attributes: {
                                ...creationContextParams?.dynamicUiType && {
                                    dynamicUiType: creationContextParams.dynamicUiType
                                },
                                ...creationContextParams?.dynamicUiSubtype && {
                                    dynamicUiSubtype: creationContextParams.dynamicUiSubtype
                                },
                                ...trackingAttributes?.invokedFrom && {
                                    invokedFrom: trackingAttributes.invokedFrom
                                },
                                ...streamActionInfo?.actionKey && {
                                    actionKey: streamActionInfo.actionKey
                                },
                                ...(0, $354x3.getRequestedModeAttributes)(trackingAttributes)
                            }
                        });
                        updateCurrentConversation({
                            status: (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError,
                            traces: []
                        });
                        sendMessageLatencyMetrics.cancel();
                        cancelStreamingMetrics();
                        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
                        return;
                    } else {
                        // Agent is active, BE hanging
                        const timeoutError = new (0, $kncFb.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                            traceId: responseData?.traceId
                        });
                        experienceTracker.fail({
                            name: sendMessageExperienceNameCompiled,
                            error: timeoutError,
                            attributes: {
                                conversationId: conversationId,
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                llmDebugLogsEnabled: storeUserMessages,
                                isStreamAction: streamActionInfo.isAction,
                                actionKey: streamActionInfo.actionKey,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                                traceId: responseData?.traceId,
                                ...remixRegenerateRequestAttributes
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: true,
                            messageId: trackingAttributes.requestId,
                            timestamp: new Date().toISOString(),
                            singleInstrumentationID: trackingAttributes.instrumentationId,
                            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                            fastModeEnabled: trackingAttributes.fastModeEnabled,
                            webSearchEnabled: trackingAttributes.webSearchEnabled,
                            attributes: {
                                ...creationContextParams?.dynamicUiType && {
                                    dynamicUiType: creationContextParams.dynamicUiType
                                },
                                ...creationContextParams?.dynamicUiSubtype && {
                                    dynamicUiSubtype: creationContextParams.dynamicUiSubtype
                                },
                                ...trackingAttributes?.invokedFrom && {
                                    invokedFrom: trackingAttributes.invokedFrom
                                },
                                ...streamActionInfo?.actionKey && {
                                    actionKey: streamActionInfo.actionKey
                                },
                                ...(0, $354x3.getRequestedModeAttributes)(trackingAttributes)
                            }
                        });
                        sendMessageLatencyMetrics.cancel();
                        cancelStreamingMetrics();
                        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
                        throw timeoutError;
                    }
                }
                /**
       * IMPORTANT: CRITICAL ANALYTICS EVENT
       *
       * This event is essential for business metrics and monitoring.
       *
       * DO NOT MODIFY the structure, content, or emission logic of this event without:
       *   - Careful review of potential impacts on data quality, privacy, and business reporting.
       *   - Explicit approval from both analytics and security stakeholders.
       *
       * Reference: Incident HOT-120175 (UGC page title and URLs leak)
       * Event Registry: https://data-portal.internal.atlassian.com/analytics/registry/68936?tabIndex=Details
       */ const dynamicUiType = creationContextParams?.dynamicUiType ?? sendMessageContext?.editorContext?.dynamicUiType;
                const conversationForResultAttribution = (0, $dCJIZ.getConversation)(getState(), conversationId) ?? currentConversation;
                const resultAttributionAnalytics = (0, $iX60o.applyResultAttributionContext)({
                    resultAttributionContext: conversationForResultAttribution?.resultAttributionContext,
                    routingAgentId: messageRoutingAgentId,
                    messageSources: messageSources,
                    additionalAnalyticAttributes: additionalAnalyticAttributes
                });
                if (resultAttributionAnalytics.shouldClearResultAttributionContext) dispatch(setConversationData({
                    conversationId: conversationId,
                    data: {
                        resultAttributionContext: undefined
                    }
                }));
                trackAIMAUEvent({
                    type: 'viewed',
                    subjectId: resultAttributionAnalytics.messageSources?.followUpSource,
                    messageId: trackingAttributes.messageId,
                    source: resultAttributionAnalytics.messageSources?.interactionSource,
                    messageActions: trackingAttributes.messageActions,
                    messageDynamicUIData: trackingAttributes.messageDynamicUIData,
                    invokedFrom: trackingAttributes.invokedFrom,
                    proactive: false,
                    userGenerated: true,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    citedProductList: trackingAttributes.citedProductList,
                    connectorInfo: trackingAttributes.connectorInfo,
                    sourceProducts: trackingAttributes.sourceProducts,
                    pluginsInvoked: Array.from(trackingAttributes.pluginsInvoked),
                    skillsInvoked: trackingAttributes.skillsInvoked,
                    executedStratusSkill: trackingAttributes.executedStratusSkill,
                    responseSources: trackingAttributes.sources,
                    usesJsm: trackingAttributes.usesJsm,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    conversationChannelId: conversationId,
                    scenarioId: trackingAttributes.scenarioId,
                    pageContext: trackingAttributes.pageContext,
                    attributes: {
                        ...(0, $iEKWu.interactionModeExecutedAttributes)(trackingAttributes.interactionModeExecuted),
                        ...dynamicUiType && {
                            dynamicUiType: dynamicUiType
                        },
                        ...creationContextParams?.dynamicUiSubtype && {
                            dynamicUiSubtype: creationContextParams.dynamicUiSubtype
                        },
                        isTabVisible: (0, $1hQ0e.getDocument)()?.visibilityState === 'visible',
                        ...resultAttributionAnalytics.additionalAnalyticAttributes && resultAttributionAnalytics.additionalAnalyticAttributes,
                        ...getResultAttributesForAskQuestion() ?? {},
                        ...creationContextParams?.dynamicUiSource && {
                            remixNodeTypes: trackingAttributes.remixNodeTypes,
                            ...trackingAttributes.unsupportedRemixNodeTypes !== undefined && {
                                unsupportedRemixNodeTypes: trackingAttributes.unsupportedRemixNodeTypes
                            },
                            ...trackingAttributes.remixWordCount !== undefined && {
                                remixWordCount: trackingAttributes.remixWordCount
                            }
                        },
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        },
                        ...resultAttributionAnalytics.messageSources?.entryPoint && {
                            entryPoint: resultAttributionAnalytics.messageSources.entryPoint
                        },
                        ...trackingAttributes.chatEntryPoint && {
                            chatEntryPoint: trackingAttributes.chatEntryPoint
                        },
                        ...(0, $iDrrr.fg)('add_mci_kr_attributes_to_rovo_chat_analytics') ? (0, $hRx4b.mciKrAttributesFromSkillsAndPlugins)(trackingAttributes.skillsInvoked, trackingAttributes.pluginsInvoked, trackingAttributes.agentExternalConfigReference) : {}
                    }
                });
                // Experience is aborted in `abortRequests`
                // For implicit think-deeper, succeed the re-attributed think-deeper reliability SLO instead
                experienceTracker.succeed({
                    name: hasAbortedForImplicitThinkDeeper ? implicitThinkDeeperExperienceName ?? (0, $irnO2.ExperienceName).SEND_TD_MESSAGE : sendMessageExperienceNameCompiled
                });
                // Broadcast that the stream has completed successfully
                broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).COMPLETED);
                if ((0, $iDrrr.fg)('rovo_chat_chat_history_refresh')) //If user is viewing a different conversation or not viewing ConversationAssitant, optimistically set conversation to unread
                {
                    if (getState().currentConversationId !== conversationId) dispatch(setConversationData({
                        conversationId: conversationId,
                        data: {
                            readStatus: false
                        }
                    }));
                }
            }
            // For implicit think-deeper, stop the re-attributed think-deeper metric instead
            if (!hasAbortedForImplicitThinkDeeper) sendMessageLatencyMetrics.stop({
                customData: messageSources?.interactionSource ? {
                    interactionSource: messageSources.interactionSource
                } : undefined
            });
            else implicitThinkDeeperSendMessageMetrics?.stop({
                customData: messageSources?.interactionSource ? {
                    interactionSource: messageSources.interactionSource
                } : undefined
            });
        };
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        try {
            await sendMessageFn({
                conversationId: conversationId
            });
        } catch (error) {
            if ((0, $bxkJA.isChannelNotFoundError)(error)) {
                const createdChannel = await assistanceService.createConversationChannel();
                onNewConversationIdAvailable?.(createdChannel.id);
                setState({
                    conversations: {
                        ...getState().conversations,
                        [createdChannel.id]: {
                            id: createdChannel.id,
                            name: createdChannel.name ?? (0, $7td41.generateConversationName)(),
                            timeCreated: createdChannel.time_created,
                            status: (0, $igOtY.CHAT_STORE_STATUS).idle,
                            traces: [],
                            messages: [],
                            ...createdChannel.agent && (0, $iDrrr.fg)('rovo_chat_chat_history_refresh') ? {
                                agent: createdChannel.agent
                            } : {}
                        }
                    }
                });
                setMessages(createdChannel.id, []);
                dispatch(setSelectedConversation({
                    conversationId: createdChannel.id
                }));
                await sendMessageFn({
                    conversationId: createdChannel.id
                });
            } else {
                performEditRollback();
                throw error;
            }
        }
    };
module.exports["sendMessageActionProvider"] = $732002bd2dba0f68$export$9558791053c77c34;

});

parcelRegister("2Z4XK", function(module, exports) {

var $62wRL = parcelRequire("62wRL");

const $c8a4fb02a7704daf$export$2057cd6e00c107b4 = (0, $62wRL.createSegmenter)();
module.exports["segmenter"] = $c8a4fb02a7704daf$export$2057cd6e00c107b4;

});

parcelRegister("8XbBy", function(module, exports) {

var $2YVJu = parcelRequire("2YVJu");

const $4f4d12a710043968$export$41ee2caec24cebc0 = (message)=>(0, $2YVJu.getInteractionModeExecutedFromMetadata)(message?.message_metadata);
module.exports["getInteractionModeExecutedFromMessage"] = $4f4d12a710043968$export$41ee2caec24cebc0;

});

parcelRegister("f2kj3", function(module, exports) {
const $f3deeaf7274014cf$export$521dc6882b67f1aa = (mode)=>{
    if (mode === 'MAX' || mode === 'MARATHON' || mode === 'DEEP_RESEARCH') return mode;
    return undefined;
};
module.exports["normalizeRestorableRequestedMode"] = $f3deeaf7274014cf$export$521dc6882b67f1aa;

});

parcelRegister("fQYiO", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $l6xCb = parcelRequire("l6xCb");

const $c5b446309c731371$export$82301f76a841b4dc = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).addStoreChatItem, ({ message: message, conversationId: conversationIdParam })=>({ getState: getState }, { setMessages: setMessages, getMessages: getMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        setMessages(conversationId, [
            ...getMessages(conversationId),
            message
        ]);
    });
module.exports["addStoreChatItem"] = $c5b446309c731371$export$82301f76a841b4dc;

});

parcelRegister("RwpfW", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $2yWJZ = parcelRequire("2yWJZ");

const $c455ea329737468a$export$f509fd4645870a6e = (args)=>{
    const mentionAgentsEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    const authorNamedId = args.agentAuthorId ?? args.agentNamedId;
    const authorIdentityAccountId = args.agentAuthorIdentityAccountId?.trim() || undefined;
    return {
        type: 'ASSISTANT',
        content: {
            type: 'FINAL_RESPONSE',
            message: {
                message: {
                    role: 'ASSISTANT',
                    id: args.id,
                    conversation_channel_id: args.conversationId,
                    content: args.content,
                    time_created: new Date().toISOString(),
                    user_ari: 'unknown',
                    plugin_invocations: [],
                    ...args.agentAuthorId ? {
                        agent_author: {
                            id: args.agentAuthorId
                        }
                    } : {},
                    author: {
                        ...mentionAgentsEnabled ? {} : {
                            // Remove this named-id control branch with `rovo_chat_mention_agents`.
                            named_id: authorNamedId || (0, $2yWJZ.ROVO_AGENT_NAMED_ID)
                        },
                        name: 'unknown',
                        actor_type: 'AGENT',
                        ari: authorIdentityAccountId ?? null,
                        identity_account_id: authorIdentityAccountId,
                        id: args.agentAuthorId ?? 'unknown'
                    }
                }
            }
        }
    };
};
module.exports["createStoreAssistant"] = $c455ea329737468a$export$f509fd4645870a6e;

});

parcelRegister("blqV9", function(module, exports) {

var $bkEBw = parcelRequire("bkEBw");

const $401ed0a05d5a948d$export$2250e3c2fe6e53e5 = (...args)=>({
        type: 'HUMAN',
        content: (0, $bkEBw.createHumanMessage)(...args)
    });
module.exports["createStoreHuman"] = $401ed0a05d5a948d$export$2250e3c2fe6e53e5;

});

parcelRegister("aXVnT", function(module, exports) {
/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing stream processing gates feature behavior from runtime flags. */ 
var $cXtTj = parcelRequire("cXtTj");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $aYC8J = parcelRequire("aYC8J");


var $6xccU = parcelRequire("6xccU");


var $irnO2 = parcelRequire("irnO2");


var $hlvTd = parcelRequire("hlvTd");


var $hRx4b = parcelRequire("hRx4b");


var $bxkJA = parcelRequire("bxkJA");


var $igOtY = parcelRequire("igOtY");


var $b6N3q = parcelRequire("b6N3q");


var $cYKsm = parcelRequire("cYKsm");


var $jyZaR = parcelRequire("jyZaR");


var $gibzw = parcelRequire("gibzw");


var $ijGER = parcelRequire("ijGER");


var $kncFb = parcelRequire("kncFb");


var $bbXwY = parcelRequire("bbXwY");


var $4BHwn = parcelRequire("4BHwn");


var $lS0Jk = parcelRequire("lS0Jk");


var $fANCm = parcelRequire("fANCm");


var $fIgxW = parcelRequire("fIgxW");


var $8DP4b = parcelRequire("8DP4b");


var $2DW0Q = parcelRequire("2DW0Q");


var $1Nzi3 = parcelRequire("1Nzi3");

const $f7ec02b36fd7102d$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED = 'chat-unmounted';
const $f7ec02b36fd7102d$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS = 120000;
const $f7ec02b36fd7102d$var$NO_FINAL_RESPONSE_ERROR_MESSAGE = 'The response took too long and timed out';
const $f7ec02b36fd7102d$export$d8454bf5b2ffdf29 = ({ conversationId: conversationId, messageId: messageId, answerIndex: _answerIndex, isDeepResearch: isDeepResearch, lastEventId: lastEventId, setConversationData: setConversationData, abortCurrentRequest: abortCurrentRequest, onComplete: onComplete })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, chatContextStoreActions: chatContextStoreActions, markIncompleteResearchesErrored: markIncompleteResearchesErrored, endReconnection: endReconnection, startReconnection: startReconnection, isReconnecting: isReconnecting, getIsChatMounted: getIsChatMounted, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, onHumanMessageIdReplaced: onHumanMessageIdReplaced, unifiedTasksActions: unifiedTasksActions })=>{
        const currentConversation = getState().conversations[conversationId];
        if (abortCurrentRequest && currentConversation?.storeAbortController) currentConversation.storeAbortController.abort();
        // Skip reconnection if there is another operation in progress
        if (currentConversation?.storeAbortController && !abortCurrentRequest || isReconnecting(conversationId)) return;
        startReconnection(conversationId, messageId);
        const reconnectionPerformanceMetrics = (0, $ijGER.createReconnectionMetrics)({
            isDeepResearchEnabled: isDeepResearch,
            thinkDeeperEnabled: false,
            fastModeEnabled: false
        });
        let totalAttempts = 0;
        const reconnectStartedAt = new Date().toISOString();
        // TODO not complete information, ideally the message in progress should indicate what was the requested mode even before message is completed
        const requestedModeAttributes = (0, $lS0Jk.interactionModeRequestedAttributes)(isDeepResearch ? 'deep_research' : 'auto');
        const metrics = {
            // Reconnection metrics
            onReconnectStarted: ()=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.start();
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    id: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    attributes: {
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        isAutoReconnect: true
                    }
                });
                trackAIMAUEvent({
                    type: 'initiated',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: reconnectStartedAt,
                    attributes: requestedModeAttributes
                });
            },
            // Was able to connect to active stream
            onReconnectEstablished: ()=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.stop();
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.start();
            },
            onReconnectFailed: (error)=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    error: error,
                    attributes: {
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        totalAttempts: totalAttempts
                    }
                });
                trackAIMAUEvent({
                    type: 'error',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
            },
            onReconnectChunkReceived: ()=>{
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.stop();
            },
            onReconnectAborted: ()=>{
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    reason: 'Aborted'
                });
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                trackAIMAUEvent({
                    type: 'dismissed',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
            },
            onReconnectSucceeded: ()=>{
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    attributes: {
                        totalAttempts: totalAttempts,
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        isAutoReconnect: true
                    }
                });
                const invokedFrom = streamMeta?.invokedFrom;
                trackAIMAUEvent({
                    type: 'viewed',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    citedProductList: streamMeta?.citedProductList ?? {},
                    connectorInfo: streamMeta?.connectorInfo,
                    sourceProducts: streamMeta?.sourceProducts ?? {},
                    pluginsInvoked: streamMeta?.pluginsInvoked,
                    skillsInvoked: streamMeta?.skillsInvoked,
                    executedStratusSkill: streamMeta?.executedStratusSkill,
                    responseSources: streamMeta?.responseSources,
                    usesJsm: streamMeta?.usesJsm,
                    messageActions: messageActions,
                    ...invokedFrom && (0, $4o0zT.isExperimentEnabled)('aifc_invokedfrom_on_reconnect') ? {
                        invokedFrom: invokedFrom
                    } : {},
                    conversationChannelId: conversationId,
                    timestamp: new Date().toISOString(),
                    attributes: {
                        ...streamMeta?.interactionModeExecuted ? {
                            interactionModeExecuted: streamMeta.interactionModeExecuted
                        } : {},
                        ...(0, $iDrrr.fg)('add_mci_kr_attributes_to_rovo_chat_analytics') ? (0, $hRx4b.mciKrAttributesFromSkillsAndPlugins)(streamMeta?.skillsInvoked ?? [], streamMeta?.pluginsInvoked ?? [], streamMeta?.agentExternalConfigReference) : {}
                    }
                });
                // Fire agentMessage received for funnel parity with processStream.
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'received',
                    actionSubject: 'agentMessage',
                    attributes: {
                        messageId: messageId,
                        humanMessageId: streamMeta?.humanMessageId,
                        pluginsInvoked: streamMeta?.pluginsInvoked ?? [],
                        // Non-UGC authoritative-answer descriptors (gated in extractStreamMeta).
                        ...streamMeta?.hasAuthoritativeSources ? {
                            hasAuthoritativeSources: true,
                            authorityLevel: streamMeta.authorityLevel,
                            isHighlyAuthoritative: streamMeta.isHighlyAuthoritative,
                            overallConfidence: streamMeta.overallConfidence,
                            authoritativeSourceCount: streamMeta.authoritativeSourceCount,
                            authoritativeExpertCount: streamMeta.authoritativeExpertCount
                        } : {},
                        citedProductList: streamMeta?.citedProductList,
                        sourceProducts: streamMeta?.sourceProducts,
                        has3pApps: Object.keys(streamMeta?.sourceProducts ?? {}).some((0, $6xccU.is3pApp)),
                        timestamp: new Date().toISOString(),
                        messageActions: streamMeta?.messageActions,
                        deepResearchEnabled: isDeepResearch ?? false,
                        initiator: 'rovoChat',
                        deepResearchInvoked: isDeepResearch ?? false,
                        scenarioId: streamMeta?.scenarioId,
                        isReconnect: true
                    }
                });
            }
        };
        const updateCurrentConversation = (data)=>{
            dispatch(setConversationData({
                conversationId: conversationId,
                data: data
            }));
        };
        const cancelMessageStream = ()=>{
            assistanceService.cancelMessageStream({
                conversationId: conversationId,
                messageId: messageId
            }).catch((err)=>{
                (0, $hlvTd.logException)({
                    name: 'rovoCancelMessageStream',
                    exception: err,
                    tags: {
                        conversationId: conversationId,
                        messageId: messageId
                    }
                });
            });
        };
        const messages = getMessages(conversationId);
        const answerIndex = _answerIndex ?? (0, $4BHwn.findStoreMessageIndex)(messages, messageId);
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $1Nzi3.createStoreAbortController)();
        let traceId;
        let streamMeta;
        let isBackendCreationRequest = false;
        let messageActions;
        const currentLastEventId = lastEventId;
        let reconnectSucceeded = false;
        //** CONNECT TO STREAM (with retry) */
        try {
            metrics.onReconnectStarted();
            updateCurrentConversation({
                status: (0, $igOtY.CHAT_STORE_STATUS).typingResponse,
                traces: [
                    {
                        messageContent: 'Resuming response...',
                        status: 'loading'
                    }
                ],
                storeAbortController: storeAbortController
            });
            const reconnect = (eventId)=>assistanceService.reconnectToMessageStream({
                    conversationId: conversationId,
                    messageId: messageId,
                    lastEventId: eventId,
                    controller: abortController
                });
            // Capture timestamp BEFORE the API call so that any live chunks
            // still in-flight during the round-trip are correctly identified
            // as live rather than replay.
            const reconnectTimestamp = Date.now();
            const { generator: initialGenerator, responseData: responseData } = await reconnect(currentLastEventId);
            traceId = responseData?.traceId;
            metrics.onReconnectEstablished();
            const wrappedGenerator = (0, $gibzw.createReconnectableStream)({
                initialGenerator: initialGenerator,
                canReconnect: ()=>!abortController.signal.aborted,
                getReconnectGenerator: (eventId)=>reconnect(eventId).then((r)=>r.generator),
                getEventId: (chunk)=>chunk.id ? chunk.id : undefined,
                onReconnecting: (attempt, maxAttempts, eventId)=>{
                    totalAttempts = attempt;
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'retrying',
                        actionSubject: 'rovoChatReconnection',
                        attributes: {
                            conversationId: conversationId,
                            messageId: messageId,
                            isDeepResearch: isDeepResearch,
                            attempt: attempt,
                            maxAttempts: maxAttempts,
                            hasLastEventId: !!eventId
                        }
                    });
                    updateCurrentConversation({
                        traces: [
                            {
                                messageContent: `Connection lost. Retrying... (${attempt}/${maxAttempts})`,
                                status: 'loading'
                            }
                        ]
                    });
                },
                onReconnected: ()=>{
                    metrics.onReconnectEstablished();
                },
                shouldContinueRetrying: ()=>{
                    if (!getIsChatMounted()) {
                        abortController.abort($f7ec02b36fd7102d$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED);
                        return false;
                    }
                    return true;
                },
                signal: abortController.signal
            });
            // Batch store updates and chunk-merge REASONING_PART during replay;
            // both flushed together via onFlush at the replay→live boundary.
            const reasoningChunkBuffer = (0, $8DP4b.createReasoningChunkBuffer)((mergedEvent)=>{
                processStreamResearch({
                    messageId: messageId,
                    streamMessage: mergedEvent,
                    isDeepResearch: isDeepResearch ?? false
                });
            });
            const { wrapGenerator: wrapGenerator, batchedSetMessages: batchedSetMessages, batchedGetMessages: batchedGetMessages, batchedProcessStreamResearch: batchedProcessStreamResearch, batchedUpdateCurrentConversation: batchedUpdateCurrentConversation, getIsReplaying: getIsReplaying, getCompletedStepIds: getCompletedStepIds } = (0, $2DW0Q.withReplayFlush)({
                conversationId: conversationId,
                reconnectTimestamp: reconnectTimestamp,
                getMessages: getMessages,
                setMessages: setMessages,
                processStreamResearch: processStreamResearch,
                updateCurrentConversation: updateCurrentConversation,
                // Use flushFiltered so reasoning chunks for already-completed steps
                // are dropped — this prevents spurious "Rovo is thinking" rounds
                // from appearing in the research expandable after reconnect replay.
                // Steps that are still in-progress (no STEP_COMPLETED seen) are
                // flushed normally so live streaming continues correctly.
                onFlush: ()=>reasoningChunkBuffer.flushFiltered((stepId)=>!getCompletedStepIds().has(stepId))
            });
            const isStreamTimeoutEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'isEnabled', false);
            const streamIdleTimeoutMs = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'timeoutMs', $f7ec02b36fd7102d$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS);
            // Tracks whether the stream completed its success path. Used to suppress
            // the timeout if a final response arrives in the same tick as the timer fires.
            let hasReceivedFinalResponse = false;
            const rawGenerator = wrapGenerator(wrappedGenerator);
            const generatorWithTimeout = isStreamTimeoutEnabled ? (0, $cYKsm.withAsyncGeneratorTimeout)(rawGenerator, {
                timeoutMs: streamIdleTimeoutMs,
                // Don't time out while offline – the reconnect layer waits for the
                // client to come back online, so timing out would lose the reconnect.
                isPaused: ()=>typeof navigator !== 'undefined' && !navigator.onLine,
                onTimeout: ()=>{
                    if (hasReceivedFinalResponse || abortController.signal.aborted) return undefined;
                    abortController.abort();
                    const timeoutError = new (0, $b6N3q.RovoChatStreamTimeoutError)($f7ec02b36fd7102d$var$NO_FINAL_RESPONSE_ERROR_MESSAGE, {
                        traceId: traceId
                    });
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'timedOut',
                        actionSubject: 'rovoChatStream',
                        attributes: {
                            conversationChannelId: conversationId,
                            experienceName: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                            timeoutMs: streamIdleTimeoutMs,
                            timeoutType: 'idle',
                            traceId: traceId
                        }
                    });
                    return timeoutError;
                }
            }) : rawGenerator;
            await (0, $fIgxW.processReconnectStreamMessage)({
                generator: generatorWithTimeout,
                traceId: responseData?.traceId,
                messageId: messageId,
                conversationId: conversationId,
                answerIndex: answerIndex,
                isStagingArea: chatContextStoreActions.getIsStagingArea(),
                isDeepResearch: isDeepResearch,
                getState: getState,
                setMessages: batchedSetMessages,
                getMessages: batchedGetMessages,
                processStreamResearch: batchedProcessStreamResearch,
                processMessageStreamAction: // skip batching for Stream Actions for now, since string accumulation is not guarnateed and vary based on the action type.
                // TODO: should be imrpoved in future snapshot event support.
                processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                processMessageStreamActionClassification: processMessageStreamActionClassification,
                onHumanMessageIdReplaced: onHumanMessageIdReplaced,
                sendAnalyticsEvent: sendAnalyticsEvent,
                updateCurrentConversation: batchedUpdateCurrentConversation,
                getIsReplaying: getIsReplaying,
                reasoningChunkBuffer: reasoningChunkBuffer,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                onStreamEnd: ()=>{
                    // Mirror onFlush: drop reasoning for completed steps.
                    reasoningChunkBuffer.flushFiltered((stepId)=>!getCompletedStepIds().has(stepId));
                },
                // Fired immediately when FINAL_RESPONSE arrives — sets the outer flag so
                // the timeout wrapper won't treat a same-tick timer fire as a real timeout.
                onFinalResponse: ()=>{
                    hasReceivedFinalResponse = true;
                },
                onTaskStatusDraft: ({ taskId: taskId, title: title, updatedAt: updatedAt, messageId: msgId })=>{
                    if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.createTaskFromStream({
                        conversationId: conversationId,
                        taskId: taskId,
                        title: title,
                        updatedAt: updatedAt,
                        messageId: msgId
                    });
                },
                onTaskStatusCompleted: ({ title: title, updatedAt: updatedAt, completionMessageId: completionMessageId })=>{
                    if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.setTaskProgressState({
                        conversationId: conversationId,
                        progressState: 'Completed',
                        title: title,
                        updatedAt: updatedAt,
                        seekingCompletedAck: true,
                        completionMessageId: completionMessageId
                    });
                },
                onTodoSnapshot: ({ todos: todos })=>{
                    if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.setTaskTodoSnapshot({
                        conversationId: conversationId,
                        todoSnapshot: {
                            todos: todos
                        }
                    });
                },
                onStreamEvent: (event, streamMessage, eventId)=>{
                    if (event === 'chunk') {
                        metrics.onReconnectChunkReceived();
                        if (streamMessage && (0, $bxkJA.isStreamActionComplete)(streamMessage)) {
                            const isBackendCreationAction = (0, $aYC8J.isServerSideExecutionAction)(streamMessage.message) && (0, $4o0zT.isExperimentEnabled)('cwr-be-based-multi-creation-v0');
                            isBackendCreationRequest || (isBackendCreationRequest = isBackendCreationAction);
                            if (isBackendCreationAction) messageActions = [
                                ...messageActions ?? [],
                                streamMessage.message.key
                            ];
                        }
                        if (streamMessage && (0, $bxkJA.isStreamResponse)(streamMessage)) {
                            streamMeta = (0, $bbXwY.extractStreamMeta)(streamMessage);
                            if (!isBackendCreationRequest) messageActions = streamMeta.messageActions;
                        }
                    }
                    if (event === 'error') {
                        if ((0, $bxkJA.isStreamAUPError)(streamMessage)) {
                            reconnectSucceeded = true;
                            metrics.onReconnectSucceeded();
                        }
                    }
                }
            });
            if (abortController.signal.aborted) throw new DOMException('Reconnect aborted', 'AbortError');
            if (!hasReceivedFinalResponse) throw new (0, $kncFb.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                traceId: traceId
            });
            metrics.onReconnectSucceeded();
            onComplete?.({
                success: true,
                streamMeta: streamMeta
            });
        } catch (error) {
            // Handle idle-stream timeout: abortController was already aborted inside onTimeout,
            // so check RovoChatStreamTimeoutError before the generic AbortError branch to distinguish
            // a timeout-triggered abort from a genuine user/system abort.
            if (error instanceof (0, $b6N3q.RovoChatStreamTimeoutError)) {
                updateCurrentConversation({
                    lastAgentMessageStatus: 'FAILED'
                });
                // Cancel the upstream HTTP stream — the server is still open and nobody else will close it.
                cancelMessageStream();
                metrics.onReconnectFailed(error);
                if (isDeepResearch) markIncompleteResearchesErrored({
                    messageId: messageId
                });
                onComplete?.({
                    success: false,
                    error: error instanceof Error ? error : new Error(String(error))
                });
                throw error;
            }
            if (error instanceof Error && error.name === 'AbortError' || abortController.signal.aborted) {
                confirmAbort();
                updateCurrentConversation({
                    lastAgentMessageStatus: 'FAILED'
                });
                metrics.onReconnectAborted();
                // Only cancel the message stream if the abort reason is not the chat unmounted reason
                if (abortController.signal.reason !== $f7ec02b36fd7102d$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED) cancelMessageStream();
                return;
            }
            if (!reconnectSucceeded) metrics.onReconnectFailed(error);
            if (isDeepResearch) markIncompleteResearchesErrored({
                messageId: messageId
            });
            onComplete?.({
                success: reconnectSucceeded,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        } finally{
            endReconnection(conversationId);
            updateCurrentConversation((0, $jyZaR.clearStatus)({}));
            setMessages(conversationId, (0, $fANCm.markStreamingMessagesAsComplete)(getMessages(conversationId)));
        }
    };
module.exports["reconnectToInProgressStreamProvider"] = $f7ec02b36fd7102d$export$d8454bf5b2ffdf29;

});

parcelRegister("hRx4b", function(module, exports) {

var $kFcQO = parcelRequire("kFcQO");


var $4O6Ds = parcelRequire("4O6Ds");

const $ed079ebed6bb7598$export$bb558012e0978515 = (skillsInvoked, pluginsInvoked, agentExternalConfigReference)=>(0, $4O6Ds.mciKrAttributes)((0, $kFcQO.getMciKrIdentifiersFromSkillsAndPlugins)(skillsInvoked, pluginsInvoked, agentExternalConfigReference));
module.exports["mciKrAttributesFromSkillsAndPlugins"] = $ed079ebed6bb7598$export$bb558012e0978515;

});

parcelRegister("cVUTD", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

const $cf64faf992f18e85$var$getSelectedAgentIdForSend = (inputSelectedAgentIds, allowSelectedAgentOverride = false)=>{
    const activeSelectedAgentDraftId = inputSelectedAgentIds?.at(-1)?.trim();
    if (activeSelectedAgentDraftId && allowSelectedAgentOverride) return activeSelectedAgentDraftId;
    return undefined;
};
const $cf64faf992f18e85$export$4413981bab4da984 = ({ conversationAgent: conversationAgent, defaultAgent: defaultAgent, explicitAgentId: explicitAgentId, omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields = false, inputSelectedAgentIds: inputSelectedAgentIds, allowSelectedAgentOverride: allowSelectedAgentOverride = false })=>{
    const mentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    if (!mentionAgentsExperimentEnabled) {
        // Preserve the former all-flags-off behavior for explicit caller-provided ids,
        // including empty and whitespace-only values.
        if (explicitAgentId !== undefined) {
            const isExplicitDefaultAgent = explicitAgentId === defaultAgent.id;
            return {
                routedSelectedAgentId: undefined,
                routingAgentId: explicitAgentId,
                agentIdForRequest: isExplicitDefaultAgent ? undefined : explicitAgentId,
                agentNamedIdForRequest: isExplicitDefaultAgent ? undefined : conversationAgent.named_id
            };
        }
        const shouldOmitConversationDefaultAgentRequestFields = omitConversationDefaultAgentRequestFields && conversationAgent.id === defaultAgent.id;
        return {
            routedSelectedAgentId: undefined,
            routingAgentId: conversationAgent.id,
            agentIdForRequest: shouldOmitConversationDefaultAgentRequestFields ? undefined : conversationAgent.id,
            agentNamedIdForRequest: shouldOmitConversationDefaultAgentRequestFields ? undefined : conversationAgent.named_id
        };
    }
    const normalizedExplicitAgentId = explicitAgentId || undefined;
    const routedSelectedAgentId = normalizedExplicitAgentId ? undefined : $cf64faf992f18e85$var$getSelectedAgentIdForSend(inputSelectedAgentIds, allowSelectedAgentOverride);
    const routingAgentId = normalizedExplicitAgentId ?? routedSelectedAgentId ?? conversationAgent.id;
    if (normalizedExplicitAgentId) return {
        routedSelectedAgentId: undefined,
        routingAgentId: routingAgentId,
        agentIdForRequest: normalizedExplicitAgentId
    };
    if (routedSelectedAgentId) return {
        routedSelectedAgentId: routedSelectedAgentId,
        routingAgentId: routingAgentId,
        agentIdForRequest: routedSelectedAgentId
    };
    return {
        routedSelectedAgentId: undefined,
        routingAgentId: routingAgentId,
        agentIdForRequest: conversationAgent.id
    };
};
module.exports["deriveAgentSendRequestIdentity"] = $cf64faf992f18e85$export$4413981bab4da984;

});

parcelRegister("bER8M", function(module, exports) {

var $iDdTC = parcelRequire("iDdTC");


var $gFYIV = parcelRequire("gFYIV");

const $548d18bad1818374$var$SEND_MESSAGE_METRICS_KEY = 'ai-mate.send-message';
const $548d18bad1818374$var$TIME_TO_FIRST_ANSWER_PART_METRICS_KEY = 'ai-mate.time-to-first-answer-part';
const $548d18bad1818374$var$TIME_TO_FIRST_ACTION_PART_METRICS_KEY = 'ai-mate.time-to-first-action-part';
const $548d18bad1818374$var$TIME_TO_ACTION_COMPLETION_METRICS_KEY = 'ai-mate.time-to-action-completion';
const $548d18bad1818374$export$1e4d1659c4209dbf = {
    createSendMessageMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $gFYIV.getMessageMetricsNameWithParams)($548d18bad1818374$var$SEND_MESSAGE_METRICS_KEY, params)
        });
    },
    createTimeToFirstAnswerPartMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $gFYIV.getMessageMetricsNameWithParams)($548d18bad1818374$var$TIME_TO_FIRST_ANSWER_PART_METRICS_KEY, params)
        });
    },
    createTimeToFirstActionPartMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $gFYIV.getMessageMetricsNameWithParams)($548d18bad1818374$var$TIME_TO_FIRST_ACTION_PART_METRICS_KEY, params)
        });
    },
    createTimeToActionCompletionMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $gFYIV.getMessageMetricsNameWithParams)($548d18bad1818374$var$TIME_TO_ACTION_COMPLETION_METRICS_KEY, params)
        });
    }
};
module.exports["messageLatencyMetrics"] = $548d18bad1818374$export$1e4d1659c4209dbf;

});

parcelRegister("baWyq", function(module, exports) {

var $7cSoR = parcelRequire("7cSoR");


var $1iIcq = parcelRequire("1iIcq");


var $8cKM4 = parcelRequire("8cKM4");


var $714Yd = parcelRequire("714Yd");

const $215b1e6b57acd53d$export$a100e5b47ee5ac9a = ()=>{
    const cur = (0, $8cKM4.readFromStorage)();
    if ((0, $7cSoR.isInCooldown)(cur)) return;
    if (cur.qualifyingConversations >= (0, $1iIcq.MIN_QUALIFYING_CONVERSATIONS)) return;
    (0, $714Yd.writeToStorage)({
        ...cur,
        qualifyingConversations: cur.qualifyingConversations + 1
    });
};
module.exports["recordValidMessage"] = $215b1e6b57acd53d$export$a100e5b47ee5ac9a;

});

parcelRegister("eMs38", function(module, exports) {
const $39d5e6d7f285ca24$export$bac56f3fc527f04b = (min, max)=>{
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
};
module.exports["randomIntFromInterval"] = $39d5e6d7f285ca24$export$bac56f3fc527f04b;

});

parcelRegister("biBci", function(module, exports) {

var $2yWJZ = parcelRequire("2yWJZ");

const $462ad3e4f945b271$export$c9b02612b90eeb6c = (agentId)=>{
    if (!agentId) return false;
    return !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: agentId,
        agentNamedId: agentId
    });
};
module.exports["isRovoCustomAgent"] = $462ad3e4f945b271$export$c9b02612b90eeb6c;

});

parcelRegister("3Bvlb", function(module, exports) {
const $7aee2421f1549c0a$export$6b58e85d865a8eef = (unifiedTasksActions)=>({
        createTaskFromStream: (args)=>unifiedTasksActions.createTaskFromStream(args),
        setTaskProgressState: (args)=>unifiedTasksActions.setTaskProgressState(args)
    });
module.exports["buildUnifiedStreamTaskTarget"] = $7aee2421f1549c0a$export$6b58e85d865a8eef;

});

parcelRegister("hMXhO", function(module, exports) {

var $iRmkX = parcelRequire("iRmkX");

const $4cfff63bf4f4d4b6$export$d30a5acf6cceb893 = (getState, conversationId, updateCurrentConversation)=>{
    const currentTraces = (0, $iRmkX.getConversationTraces)(getState(), conversationId);
    if (currentTraces.length > 0) updateCurrentConversation({
        traces: []
    });
};
module.exports["clearTracesIfNotEmpty"] = $4cfff63bf4f4d4b6$export$d30a5acf6cceb893;

});

parcelRegister("iMppo", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");

const $129c50d8ba82d9d6$export$b043b11900276452 = ({ broadcastStreamStatus: broadcastStreamStatus, chatContextStoreActions: chatContextStoreActions, contentContextValue: contentContextValue, targetId: targetId, assistantMessageId: assistantMessageId })=>{
    return (status)=>{
        let contentTarget;
        if ((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
            // Use targetId from sendMessage if provided, otherwise fall back to currentTargetId
            const activeTargetId = targetId ?? chatContextStoreActions.getCurrentTargetId();
            contentTarget = chatContextStoreActions.getTarget(contentContextValue, activeTargetId);
        } else contentTarget = chatContextStoreActions.getTarget(contentContextValue, targetId);
        broadcastStreamStatus?.(status, assistantMessageId, contentTarget ? {
            id: contentTarget.id,
            type: contentTarget.type
        } : undefined);
    };
};
module.exports["createBroadcastStreamLifecycle"] = $129c50d8ba82d9d6$export$b043b11900276452;

});

parcelRegister("j5JhI", function(module, exports) {

var $cqGOy = parcelRequire("cqGOy");

const $23567c2d6eaf1c81$export$eca740b13a7a3080 = (conversationId)=>String((0, $cqGOy.djb2Hash)(new Date().toISOString(), conversationId));
module.exports["generateTmpMessageId"] = $23567c2d6eaf1c81$export$eca740b13a7a3080;

});

parcelRegister("Q8n54", function(module, exports) {
/**
 * Util function to determine the page context where Rovo chat is being used.
 *
 * This uses the existing context objects (editorContext, whiteboardContext, databaseContext)
 * and AI feature context to determine the surface, and falls back to the browser URL when no
 * context is available.
 *
 * This attribute is used on unified AI events (aiResult viewed, aiInteraction initiated)
 * to distinguish which surface Rovo chat was used on (e.g. edit page, view page, whiteboard, database).
 *
 * This is exported only for testing purposes.
 */ const $f14d784696e75101$export$1303843c2f44065a = ({ editorContext: editorContext, whiteboardContext: whiteboardContext, databaseContext: databaseContext, aiFeatureContext: aiFeatureContext, browserUrl: browserUrl })=>{
    // Priority 1: Use existing context objects for reliable detection
    if (editorContext) return editorContext.isViewMode ? 'confluence-page-view' : 'confluence-page-edit';
    if (whiteboardContext) return whiteboardContext.isViewMode ? 'whiteboard-view' : 'whiteboard-edit';
    if (databaseContext) return 'database';
    if (aiFeatureContext?.jira_view_context) {
        const jiraContext = aiFeatureContext.jira_view_context;
        return typeof jiraContext.viewType === 'string' ? `jira-view-${jiraContext.viewType}` : 'jira-view';
    }
    // Priority 2: Fall back to URL-based detection when no context is available
    const url = browserUrl ?? (typeof window !== 'undefined' ? window.location.href : '');
    if (url.includes('/wiki/') && url.includes('/edit')) return 'confluence-page-edit';
    if (url.includes('/wiki/')) return 'confluence-page-view';
    if (url.includes('/whiteboard/')) return 'whiteboard';
    if (url.includes('/database/')) return 'database';
    return 'unknown';
};
module.exports["getPageContext"] = $f14d784696e75101$export$1303843c2f44065a;

});

parcelRegister("4cgYj", function(module, exports) {
/**
 * Util function to derive a generic view context attribute for analytics.
 *
 * Reads the AI feature context (populated by product-specific publishers, e.g. the Jira
 * Issue Navigator and Backlog views) and returns a flat record of scalar values that can
 * be attached to unified AI events (e.g. aiInteraction initiated) without leaking any
 * product-specific nested shape.
 *
 * Returns `undefined` when no known view context is available, in which case no
 * `viewContext` attribute is attached to the event.
 *
 * This is exported only for testing purposes.
 */ const $ac0e07e0dcb28459$export$20af16720c0f9c71 = ({ aiFeatureContext: aiFeatureContext })=>{
    if (!aiFeatureContext?.jira_view_context) return undefined;
    const jiraCtx = aiFeatureContext.jira_view_context;
    const ids = jiraCtx.selectedIssueIdentifiers;
    const projects = jiraCtx.projectIdentifiers;
    const filters = jiraCtx.filterIdentifiers;
    const jqlStrings = jiraCtx.jqlStrings;
    return {
        numberOfWorkItems: Array.isArray(ids) ? ids.length : 0,
        numberOfProjects: Array.isArray(projects) ? projects.length : 0,
        numberOfFilters: Array.isArray(filters) ? filters.length : 0,
        numberOfJqlStrings: Array.isArray(jqlStrings) ? jqlStrings.length : 0,
        viewType: typeof jiraCtx.viewType === 'string' ? jiraCtx.viewType : 'unknown'
    };
};
module.exports["getViewContext"] = $ac0e07e0dcb28459$export$20af16720c0f9c71;

});

parcelRegister("dCJIZ", function(module, exports) {
const $4aa09818c3d4f0b5$export$a2ff1144002a6147 = (state, id)=>{
    return state.conversations[id];
};
module.exports["getConversation"] = $4aa09818c3d4f0b5$export$a2ff1144002a6147;

});

parcelRegister("i9o8a", function(module, exports) {
const $a2488f01d739616b$export$9f198c0729e6b053 = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, taskModeEnabled: taskModeEnabled, fastModeEnabled: fastModeEnabled })=>{
    if (deepResearchEnabled) return 'deep_research';
    if (thinkDeeperEnabled || alphaExtendedThinkingMode) return 'think_deeper';
    if (taskModeEnabled) return 'max';
    if (fastModeEnabled) return 'fast';
    return 'auto';
};
module.exports["getInteractionModeRequested"] = $a2488f01d739616b$export$9f198c0729e6b053;

});

parcelRegister("gB8YL", function(module, exports) {

var $aYC8J = parcelRequire("aYC8J");

const $dc46cb9d819f569e$export$a0e3245ee56765fd = ({ messageActionKey: messageActionKey, messageActionData: messageActionData })=>{
    // WARNING: Changing the logic here can affect AIFC MAU and other AI metrics.
    // Please consult with the Create with Rovo team before making any changes.
    if (!messageActionKey) return undefined;
    if ((0, $aYC8J.isDynamicUiCreatableAction)({
        key: messageActionKey
    }) || (0, $aYC8J.isImageCreatableAction)({
        key: messageActionKey
    }) || (0, $aYC8J.isRemixGeneratedAction)(messageActionData)) return 'remix';
    if ((0, $aYC8J.isConfluenceCreatableAction)({
        key: messageActionKey
    })) // TODO All creatable actions should be as AIFC MAU here,
    // but we are temporarily changing this to Confluence only due to HOT-122605
    return 'AIFC';
    else if ((0, $aYC8J.isConfluencePageUpdateAction)({
        key: messageActionKey
    })) return 'Editor AI';
    else if ((0, $aYC8J.isConfluenceWhiteboardUpdateAction)({
        key: messageActionKey
    })) return 'Whiteboard AI';
    else if ((0, $aYC8J.isConfluenceSlidesUpdateAction)({
        key: messageActionKey
    })) return 'Slide AI';
    else if ((0, $aYC8J.isConfluenceDatabaseUpdateAction)({
        key: messageActionKey
    })) return 'Database AI';
    return undefined;
};
module.exports["getInvokedFrom"] = $dc46cb9d819f569e$export$a0e3245ee56765fd;

});

parcelRegister("lpYvl", function(module, exports) {
const $b016bb6f9c6bc818$export$e26ccd8a2d744904 = (metrics)=>{
    let called = false;
    return (result, customData)=>{
        if (!called) {
            if (result === 'stop') metrics.stop({
                customData: customData
            });
            else metrics.cancel();
            called = true;
        }
    };
};
module.exports["getMetricEndHelper"] = $b016bb6f9c6bc818$export$e26ccd8a2d744904;

});

parcelRegister("bETzY", function(module, exports) {
const $17f8fd46f090eaff$export$74253ae80f2bef05 = ({ creationContextParams: creationContextParams, messageSources: messageSources })=>{
    // A remix-create send originates from the remix menu (source === 'remix') and
    // is NOT a regenerate of an existing node (which uses inlineRovoFromRemix).
    const isRemixCreate = creationContextParams?.source === 'remix' && messageSources?.interactionSource !== 'inlineRovoFromRemix';
    if (!isRemixCreate) return {};
    return {
        isRemixCreate: true,
        contentMauiId: creationContextParams?.contentMauiId,
        mediaFileId: creationContextParams?.mediaFileId,
        remixType: creationContextParams?.dynamicUiType,
        remixSubtype: creationContextParams?.dynamicUiSubtype
    };
};
module.exports["getRemixCreateRequestAttributes"] = $17f8fd46f090eaff$export$74253ae80f2bef05;

});

parcelRegister("ks26f", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $00c83407afeee4cc$export$2632503e30ac5e44 = ({ creationContextParams: creationContextParams, messageSources: messageSources })=>{
    if ((0, $iDrrr.fg)('cc-maui-disable-edit-experience-tracker-fixes')) return {};
    const interactionSource = messageSources?.interactionSource;
    const isInlineExistingNodeEdit = interactionSource === 'inlineRovoFromRemix';
    const isExplicitRemixEditExperience = creationContextParams?.experience === 'remix_edit' || creationContextParams?.experience === 'remix_custom';
    const isSharedEditInteractionSource = interactionSource === 'editor' || interactionSource === 'remixStagingArea';
    const isSharedEdit = creationContextParams?.source === 'remix' && (isExplicitRemixEditExperience || isSharedEditInteractionSource && Boolean(creationContextParams.contentMauiId || creationContextParams.mediaFileId));
    if (!isInlineExistingNodeEdit && !isSharedEdit) return {};
    return {
        isRemixRegenerate: true,
        ...isInlineExistingNodeEdit ? {
            remixRegenerateSource: 'inline-existing-node'
        } : {},
        editSource: interactionSource === 'editor' ? 'typeSwitcher' : 'rovoBar',
        contentMauiId: creationContextParams?.contentMauiId,
        mediaFileId: creationContextParams?.mediaFileId,
        remixType: creationContextParams?.dynamicUiType,
        remixSubtype: creationContextParams?.dynamicUiSubtype
    };
};
module.exports["getRemixRegenerateRequestAttributes"] = $00c83407afeee4cc$export$2632503e30ac5e44;

});

parcelRegister("354x3", function(module, exports) {

var $lS0Jk = parcelRequire("lS0Jk");

const $afd6bdca30ecbc92$export$dd1b85436e4b4f2d = (trackingAttributes)=>({
        ...(0, $lS0Jk.interactionModeRequestedAttributes)(trackingAttributes.interactionModeRequested),
        ...trackingAttributes.aiFeatureName && {
            aiFeatureName: trackingAttributes.aiFeatureName
        }
    });
module.exports["getRequestedModeAttributes"] = $afd6bdca30ecbc92$export$dd1b85436e4b4f2d;

});

parcelRegister("3GbnU", function(module, exports) {
/**
 * Returns the given source-control value unless this send is actually routed by
 * a selected-agent override. Selected agents bring their own fixed source set,
 * but stale/whitespace selected-agent drafts and cross-surface handoffs that do
 * not use the draft must preserve the caller's source controls.
 * Exported for unit testing.
 */ function $d8e7db153f5f7161$export$7459a30868c458f({ routedSelectedAgentId: routedSelectedAgentId, value: value }) {
    return routedSelectedAgentId ? undefined : value;
}
module.exports["getSourceControlValueForBackend"] = $d8e7db153f5f7161$export$7459a30868c458f;

});

parcelRegister("aKQ2h", function(module, exports) {

var $9qJ1N = parcelRequire("9qJ1N");

const $86e81c25ee55514d$export$89a4ab1dea43d7ee = ({ conversationId: conversationId, taskMessage: taskMessage, messageId: messageId, target: target })=>{
    const executionSegments = (0, $9qJ1N.parseExecutionSegments)(taskMessage.execution_segments);
    switch(taskMessage.status){
        case 'DRAFT':
            target.createTaskFromStream({
                conversationId: conversationId,
                taskId: taskMessage.task_id,
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'COMPLETED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Completed',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                seekingCompletedAck: true,
                completionMessageId: taskMessage.completion_message_id ?? messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'FAILED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Failed',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'CANCELLED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Cancelled',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'RUNNING':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Running',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'AWAITING_ACTION_CONFIRMATION':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'AwaitingActionConfirmation',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        default:
            break;
    }
};
module.exports["handleStreamTaskStatus"] = $86e81c25ee55514d$export$89a4ab1dea43d7ee;

});

parcelRegister("fANCm", function(module, exports) {

var $igOtY = parcelRequire("igOtY");

const $112200485e4c7f0b$export$680d2bb5b9579c57 = (chat)=>chat.map((message)=>{
        if ((0, $igOtY.isStoreAssistant)(message) && !message.content.streamingComplete) return {
            ...message,
            content: {
                ...message.content,
                streamingComplete: true
            },
            // Clear answerNowStatus when streaming completes (success, error, or abort)
            answerNowStatus: undefined
        };
        return message;
    });
module.exports["markStreamingMessagesAsComplete"] = $112200485e4c7f0b$export$680d2bb5b9579c57;

});

parcelRegister("8P1Kw", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $irnO2 = parcelRequire("irnO2");


var $bxkJA = parcelRequire("bxkJA");


var $9vNm5 = parcelRequire("9vNm5");


var $foVqg = parcelRequire("foVqg");


var $igOtY = parcelRequire("igOtY");


var $b6N3q = parcelRequire("b6N3q");


var $cYKsm = parcelRequire("cYKsm");


var $iWbNp = parcelRequire("iWbNp");


var $9BBUU = parcelRequire("9BBUU");


var $bER8M = parcelRequire("bER8M");


var $kc9aB = parcelRequire("kc9aB");


var $fC0nb = parcelRequire("fC0nb");


var $eMs38 = parcelRequire("eMs38");


var $jb3zd = parcelRequire("jb3zd");


var $coqKO = parcelRequire("coqKO");


var $cv4dJ = parcelRequire("cv4dJ");


var $ayOmn = parcelRequire("ayOmn");


var $aPDnZ = parcelRequire("aPDnZ");


var $fCT7n = parcelRequire("fCT7n");


var $chBow = parcelRequire("chBow");


var $6CHtN = parcelRequire("6CHtN");


var $dh2SO = parcelRequire("dh2SO");


var $hMXhO = parcelRequire("hMXhO");


var $awqa1 = parcelRequire("awqa1");


var $kA5zM = parcelRequire("kA5zM");


var $lXC3X = parcelRequire("lXC3X");


var $6WeLa = parcelRequire("6WeLa");


var $3cJKb = parcelRequire("3cJKb");


var $7nZb0 = parcelRequire("7nZb0");


var $dxl4c = parcelRequire("dxl4c");


var $hwHCO = parcelRequire("hwHCO");


var $bQxqB = parcelRequire("bQxqB");


var $bbXwY = parcelRequire("bbXwY");


var $4BHwn = parcelRequire("4BHwn");


var $1psM9 = parcelRequire("1psM9");


var $dCJIZ = parcelRequire("dCJIZ");


var $iRmkX = parcelRequire("iRmkX");


var $iqkMb = parcelRequire("iqkMb");


var $P3Zwx = parcelRequire("P3Zwx");


var $3Cuhs = parcelRequire("3Cuhs");


var $ks26f = parcelRequire("ks26f");


var $354x3 = parcelRequire("354x3");


var $4Y0no = parcelRequire("4Y0no");


var $kZEW9 = parcelRequire("kZEW9");


var $kOM0B = parcelRequire("kOM0B");


var $bPaiw = parcelRequire("bPaiw");


var $2WWTW = parcelRequire("2WWTW");


var $k5njB = parcelRequire("k5njB");


var $3qJlQ = parcelRequire("3qJlQ");


var $cWQeI = parcelRequire("cWQeI");


var $55rUT = parcelRequire("55rUT");


var $8GeCh = parcelRequire("8GeCh");


var $cKBqb = parcelRequire("cKBqb");


var $fA89f = parcelRequire("fA89f");


var $l4fq3 = parcelRequire("l4fq3");


var $5tsq8 = parcelRequire("5tsq8");


var $6OcY6 = parcelRequire("6OcY6");


var $dnZkY = parcelRequire("dnZkY");


var $fS02I = parcelRequire("fS02I");


var $NbBdO = parcelRequire("NbBdO");

const $4964ca4cf6fe5338$var$getStreamStats = ()=>{
    const stats = {
        totalChunks: 0,
        traceChunks: 0,
        answerChunks: 0,
        actionChunks: 0,
        researchChunks: 0,
        otherChunks: 0,
        firstChunkAt: undefined,
        lastChunkAt: undefined,
        sumInterChunkMs: 0,
        pluginsObserved: new Set()
    };
    const update = (streamMessage)=>{
        const now = performance.now();
        stats.totalChunks += 1;
        if (stats.firstChunkAt === undefined) stats.firstChunkAt = now;
        if (stats.lastChunkAt !== undefined) stats.sumInterChunkMs += now - stats.lastChunkAt;
        stats.lastChunkAt = now;
        if ((0, $bxkJA.isStreamTrace)(streamMessage)) stats.traceChunks += 1;
        else if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) stats.answerChunks += 1;
        else if ((0, $bxkJA.isStreamResearchPayload)(streamMessage)) stats.researchChunks += 1;
        else if ((0, $bxkJA.isStreamActionPart)(streamMessage) || (0, $bxkJA.isStreamActionPrepare)(streamMessage)) // Count action-related chunks (prepare/part)
        stats.actionChunks += 1;
        else // Count unknown chunks
        stats.otherChunks += 1;
        // Observe plugin names if present early (often only present on final response)
        const invocations = (0, $bxkJA.isStreamResponse)(streamMessage) ? streamMessage.message?.message?.plugin_invocations : [];
        if (Array.isArray(invocations)) invocations.forEach((p)=>p?.plugin_name && stats.pluginsObserved.add(p.plugin_name));
    };
    const getStats = ()=>{
        const avgGapMs = stats.totalChunks > 1 ? Math.round(stats.sumInterChunkMs / (stats.totalChunks - 1)) : 0;
        return {
            ...stats,
            pluginsObserved: Array.from(stats.pluginsObserved),
            averageGapMs: avgGapMs
        };
    };
    return {
        update: update,
        getStats: getStats
    };
};
const $4964ca4cf6fe5338$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS = 120000;
const $4964ca4cf6fe5338$var$NO_FINAL_RESPONSE_ERROR_MESSAGE = 'The response took too long and timed out';
const $4964ca4cf6fe5338$export$efb69f1fe7577739 = async ({ prompt: prompt, generator: generator, productKey: productKey, answerIndex: answerIndex, tmpHumanMessageId: tmpHumanMessageId, tmpAssistantMessageId: tmpAssistantMessageId, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, sendMessageExperienceNameCompiled: sendMessageExperienceNameCompiled, traceId: traceId, updateCurrentConversation: updateCurrentConversation, trackingAttributes: trackingAttributes, conversationId: conversationId, getState: getState, promptStreamHook: promptStreamHook, openChat: openChat, openChatOnError: openChatOnError, experienceTracker: experienceTracker, setMessages: setMessages, getMessages: getMessages, onSpaceSourceRecommendations: onSpaceSourceRecommendations, processStreamResearch: processStreamResearch, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamError: processMessageStreamError, processMessageStreamActionClassification: processMessageStreamActionClassification, containerOnTempMessageIdReplaced: containerOnTempMessageIdReplaced, containerOnHumanMessageIdReplaced: containerOnHumanMessageIdReplaced, updateResearchMessageId: updateResearchMessageId, sendAnalyticsEvent: sendAnalyticsEvent, chatContextStoreActions: chatContextStoreActions, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart, stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart, stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion, broadcastStreamLifecycle: broadcastStreamLifecycle, sendMessageLatencyMetrics: sendMessageLatencyMetrics, cancelStreamingMetrics: cancelStreamingMetrics, onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride, streamActionInfo: streamActionInfo, trackAIMAUEvent: trackAIMAUEvent, messageSources: messageSources, additionalAnalyticAttributes: additionalAnalyticAttributes, unsupportedRemixNodeTypes: unsupportedRemixNodeTypes, hasLoggedInitiatedEvent: hasLoggedInitiatedEvent, clearMessageResearch: clearMessageResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, viewDeadAirBroker: viewDeadAirBroker, minionAlias: minionAlias, agentId: agentId, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId, creationContextParams: creationContextParams, storeUserMessages: storeUserMessages, skillSelectionSource: skillSelectionSource, assistanceService: assistanceService, abortController: abortController, getIsChatMounted: getIsChatMounted, metricsStartTime: metricsStartTime, onTaskStatusUpdate: onTaskStatusUpdate, onTodoSnapshot: onTodoSnapshot, onPromptRedacted: onPromptRedacted, onPromptBlocked: onPromptBlocked, onResponseRedacted: onResponseRedacted, onResponseBlocked: onResponseBlocked, onAttachmentBlocked: onAttachmentBlocked })=>{
    updateCurrentConversation({
        traces: []
    });
    const remixRegenerateRequestAttributes = (0, $ks26f.getRemixRegenerateRequestAttributes)({
        creationContextParams: creationContextParams,
        messageSources: messageSources
    });
    // Set to true when a guard event (PROMPT_REDACTION or PROMPT_BLOCKED) is received.
    // The backend always follows these events with an ERROR event to terminate the stream,
    // which should be treated as a successful end of the guard flow, not a real error.
    let guardEventReceived = false;
    let hasReceivedFinalResponse = false;
    let hasReceivedFollowUp = false;
    const actionCompleteInvocationIds = new Set();
    const actionClassificationInvocationIds = new Set();
    let isBackendCreationRequest = false;
    let agentMessageId;
    let isReconnectSupported = false;
    // Guards against repeated metric switches if multiple REASONING_PART messages arrive.
    let hasAbortedForImplicitThinkDeeper = false;
    // Think-deeper metrics started when implicit think-deeper is detected mid-stream. Null otherwise.
    let implicitThinkDeeperSendMessageMetrics = null;
    let implicitThinkDeeperTimeToFirstAnswerPartMetrics = null;
    // The experience name for the reliability SLO when implicit think-deeper is detected. Null otherwise.
    let implicitThinkDeeperExperienceName = null;
    // Client-side implicit round tracking for think deeper.
    // Passed by reference into processResearchStreamMessage so state is shared.
    const researchState = {
        clientRoundCounter: 0,
        hasAccumulatedAnswerContent: false
    };
    // Gate the details-tag preprocessor to 3P-agent conversations only.
    // Lazily initialised on the first chunk: the conversation's agent metadata
    // is set by `createConversationOptimistically` which may run after this
    // function is defined but before the first chunk arrives.
    let processStreamMarkdownMultiTagInstance = null;
    const getShouldPreprocessDetails = ()=>(0, $6OcY6.shouldPreprocessDetailsForConversation)(getState(), conversationId);
    const getProcessStreamMarkdownMultiTag = ()=>{
        if (!processStreamMarkdownMultiTagInstance) processStreamMarkdownMultiTagInstance = (0, $6WeLa.createStreamMarkdownMultiTagProcessor)({
            shouldPreprocessDetails: getShouldPreprocessDetails()
        });
        return processStreamMarkdownMultiTagInstance;
    };
    let latestStreamMessage;
    const streamStats = $4964ca4cf6fe5338$var$getStreamStats();
    // Between-chunks inactivity watchdog (logs once per stall, re-arms on chunks)
    const inactivity = (0, $kA5zM.createBetweenChunksInactivityLogger)({
        baseMs: 90000,
        sendAnalyticsEvent: (event)=>{
            sendAnalyticsEvent({
                ...event,
                attributes: {
                    ...event.attributes,
                    ...streamStats.getStats(),
                    isDeepResearchEnabled: deepResearchEnabled,
                    isThinkDeeperEnabled: thinkDeeperEnabled,
                    isFastModeEnabled: fastModeEnabled,
                    isWebSearchEnabled: webSearchEnabled,
                    isAIFCStreaminAction: streamActionInfo.isAction,
                    conversationId: conversationId,
                    instrumentationId: trackingAttributes.instrumentationId,
                    requestId: trackingAttributes.requestId,
                    interactionSource: trackingAttributes.interactionSource,
                    contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                    userAgent: navigator?.userAgent
                }
            });
        }
    });
    // Dead air tracking - monitors gaps between meaningful stream messages
    const deadAirTracker = (0, $7nZb0.createDeadAirTracker)({
        messageId: tmpAssistantMessageId,
        conversationId: conversationId,
        traceId: traceId ?? '',
        productKey: productKey ?? '',
        deepResearchEnabled: deepResearchEnabled ?? false,
        thinkDeeperEnabled: thinkDeeperEnabled ?? false,
        fastModeEnabled: fastModeEnabled ?? false,
        webSearchEnabled: webSearchEnabled ?? false,
        isAIFC: streamActionInfo.isAction,
        sendAnalyticsEvent: sendAnalyticsEvent
    });
    viewDeadAirBroker?.start({
        messageId: tmpAssistantMessageId,
        conversationId: conversationId,
        traceId: traceId ?? '',
        productKey: productKey ?? '',
        reasoningMode: deepResearchEnabled ? 'deep-research' : thinkDeeperEnabled ? 'think-deeper' : fastModeEnabled ? 'fast' : 'auto',
        isAIFCEnabled: streamActionInfo.isAction,
        isWebSearchEnabled: webSearchEnabled ?? false
    });
    // Reset the stream response recording for a new stream session.
    // Recording is always enabled so that network responses can be captured by default.
    const canRecordStreamResponses = true;
    if (canRecordStreamResponses) (0, $l4fq3.resetStreamResponseRecording)();
    // Arm the inactivity watchdog
    inactivity?.arm();
    /*****************************
   *
   * Stream processing START
   *
   *****************************/ const streamToIterate = (0, $lXC3X.createChatReconnectableStream)({
        generator: generator,
        conversationId: conversationId,
        abortController: abortController,
        assistanceService: assistanceService,
        sendAnalyticsEvent: sendAnalyticsEvent,
        experienceTracker: experienceTracker,
        getMessageId: ()=>agentMessageId,
        canReconnect: ()=>!!(agentMessageId && isReconnectSupported),
        updateCurrentConversation: updateCurrentConversation,
        getIsChatMounted: getIsChatMounted,
        analyticsAttributes: {
            isDeepResearch: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled
        },
        onBeforeFirstReconnect: ()=>{
            const chat = getMessages(conversationId);
            const alreadySwapped = (0, $4BHwn.findStoreMessageIndex)(chat, agentMessageId) >= 0;
            if (!alreadySwapped) {
                setMessages(conversationId, (0, $NbBdO.updateStoreAssistantMessageId)({
                    chat: chat,
                    oldId: tmpAssistantMessageId,
                    newId: agentMessageId
                }));
                if (tmpAssistantMessageId !== agentMessageId) updateResearchMessageId({
                    messageId: tmpAssistantMessageId,
                    newMessageId: agentMessageId
                });
            }
            tmpAssistantMessageId = agentMessageId;
        },
        onReconnected: ()=>{
            inactivity?.arm();
        },
        onFirstChunkAfterReconnect: ()=>{
            deadAirTracker?.resetTimestamp();
        }
    });
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- Preserve the existing timeout experiment while keeping this CSAT change scoped.
    const isStreamTimeoutEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'isEnabled', false);
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- Preserve the existing timeout experiment while keeping this CSAT change scoped.
    const streamIdleTimeoutMs = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'timeoutMs', $4964ca4cf6fe5338$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS);
    const streamWithTimeout = isStreamTimeoutEnabled ? (0, $cYKsm.withAsyncGeneratorTimeout)(streamToIterate, {
        timeoutMs: streamIdleTimeoutMs,
        // Don't time out while offline – the reconnect layer waits for the
        // client to come back online, so timing out would lose the reconnect.
        isPaused: ()=>typeof navigator !== 'undefined' && !navigator.onLine,
        onTimeout: ()=>{
            if (hasReceivedFinalResponse || guardEventReceived || abortController.signal.aborted) return undefined;
            abortController.abort();
            const timeoutError = new (0, $b6N3q.RovoChatStreamTimeoutError)($4964ca4cf6fe5338$var$NO_FINAL_RESPONSE_ERROR_MESSAGE, {
                requestId: trackingAttributes.requestId,
                traceId: traceId
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'timedOut',
                actionSubject: 'rovoChatStream',
                attributes: {
                    conversationChannelId: conversationId,
                    experienceName: sendMessageExperienceNameCompiled,
                    requestId: trackingAttributes.requestId,
                    timeoutMs: streamIdleTimeoutMs,
                    timeoutType: 'idle',
                    traceId: traceId
                }
            });
            return timeoutError;
        }
    }) : streamToIterate;
    try {
        for await (const streamObj of streamWithTimeout){
            const streamMessage = (0, $bxkJA.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
            // Record the raw stream message for debugging purposes
            // This allows developers to copy/paste SSE responses for examples/tests
            if (canRecordStreamResponses) (0, $cKBqb.recordStreamMessage)(streamMessage);
            latestStreamMessage = streamMessage;
            deadAirTracker?.update(streamMessage);
            streamStats.update(streamMessage);
            // any chunk = proof of life
            inactivity?.onChunk();
            // Note: We do NOT skip stream messages during SWITCHING.
            // Stream processing continues normally until FAST_MODE_ENABLED is received,
            // at which point research steps are cleared and status is set to SWITCHED.
            // Usually the first stream part
            if ((0, $bxkJA.isConversationChannelDataMessage)(streamMessage)) {
                agentMessageId = streamMessage.assistant_message_id;
                const streamConversationName = streamMessage.name?.trim();
                updateCurrentConversation({
                    ...streamConversationName ? {
                        name: streamConversationName
                    } : {},
                    lastMessageTimestamp: streamMessage.last_message_timestamp ?? new Date().toISOString(),
                    timeCreated: streamMessage.time_created,
                    ...streamMessage.scopes && {
                        scopes: streamMessage.scopes
                    }
                });
                trackingAttributes.instrumentationId = agentMessageId;
                trackingAttributes.messageId = agentMessageId;
                if (agentMessageId && agentMessageId !== tmpAssistantMessageId && (0, $iDrrr.fg)('cc-cwr-fix-finalizing-cancelled-request')) {
                    const oldTmpId = tmpAssistantMessageId;
                    setMessages(conversationId, (0, $NbBdO.updateStoreAssistantMessageId)({
                        chat: getMessages(conversationId),
                        oldId: oldTmpId,
                        newId: agentMessageId
                    }));
                    updateResearchMessageId({
                        messageId: oldTmpId,
                        newMessageId: agentMessageId
                    });
                    tmpAssistantMessageId = agentMessageId;
                    (onTempMessageIdReplacedOverride || containerOnTempMessageIdReplaced)?.(oldTmpId, agentMessageId);
                }
                trackingAttributes.invokedFrom = creationContextParams?.source === 'remix' ? 'remix' : (0, $P3Zwx.getInvokedFromInteractionSource)(messageSources?.interactionSource);
                const remixNodeTypes = creationContextParams?.dynamicUiSource ? (0, $fC0nb.getTopLevelNodeTypes)(creationContextParams.dynamicUiSource.fullAdf, creationContextParams.dynamicUiSource.startLocalId ?? '', creationContextParams.dynamicUiSource.endLocalId ?? '') : undefined;
                const remixWordCount = creationContextParams?.dynamicUiSource?.fragmentAdf ? (0, $kc9aB.countFragmentWords)(creationContextParams.dynamicUiSource.fragmentAdf) : undefined;
                if (remixNodeTypes) trackingAttributes.remixNodeTypes = remixNodeTypes;
                if (unsupportedRemixNodeTypes) trackingAttributes.unsupportedRemixNodeTypes = unsupportedRemixNodeTypes;
                if (remixWordCount !== undefined) trackingAttributes.remixWordCount = remixWordCount;
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: streamMessage.last_message_timestamp,
                    singleInstrumentationID: agentMessageId,
                    deepResearchEnabled: deepResearchEnabled ?? false,
                    thinkDeeperEnabled: thinkDeeperEnabled ?? false,
                    fastModeEnabled: fastModeEnabled ?? false,
                    webSearchEnabled: webSearchEnabled ?? false,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    invokedFrom: trackingAttributes.invokedFrom,
                    attributes: {
                        ...(0, $354x3.getRequestedModeAttributes)(trackingAttributes),
                        ...additionalAnalyticAttributes && additionalAnalyticAttributes,
                        ...remixNodeTypes !== undefined && {
                            remixNodeTypes: remixNodeTypes
                        },
                        ...trackingAttributes.unsupportedRemixNodeTypes !== undefined && {
                            unsupportedRemixNodeTypes: trackingAttributes.unsupportedRemixNodeTypes
                        },
                        ...remixWordCount !== undefined && {
                            remixWordCount: remixWordCount
                        },
                        ...trackingAttributes.chatEntryPoint && {
                            chatEntryPoint: trackingAttributes.chatEntryPoint
                        }
                    }
                });
                hasLoggedInitiatedEvent = true;
            } else if ((0, $bxkJA.isScopeDeterminedMessage)(streamMessage)) updateCurrentConversation({
                scopes: streamMessage.scopes
            });
            else if ((0, $bxkJA.isSpaceSourceRecommendationsMessage)(streamMessage)) // No analytics event here by design: this stream message only forwards
            // recommendations to the host via a generic callback. Surfacing/interaction
            // analytics are owned by the recommendations banner UI that consumes them.
            onSpaceSourceRecommendations?.(streamMessage.message.space_id, streamMessage.message.recommendations);
            else {
                const conversation = getState().conversations[getState().currentConversationId];
                if (conversation) {
                    if (conversation.status !== (0, $igOtY.CHAT_STORE_STATUS).typingResponse) updateCurrentConversation({
                        status: (0, $igOtY.CHAT_STORE_STATUS).typingResponse
                    });
                }
            }
            if ((0, $bxkJA.isStreamReconnectSupportPart)(streamMessage)) isReconnectSupported = true;
            {
                const { deepResearchInvoked: deepResearchInvoked } = (0, $55rUT.processResearchStreamMessage)({
                    streamMessage: streamMessage,
                    tmpAssistantMessageId: tmpAssistantMessageId,
                    conversationId: conversationId,
                    deepResearchEnabled: deepResearchEnabled,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    processStreamResearch: processStreamResearch,
                    addImplicitResearchPlan: addImplicitResearchPlan,
                    resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                    researchState: researchState
                });
                if (deepResearchInvoked) trackingAttributes.deepResearchInvoked = true;
            }
            // The backend autonomously triggered thinking mode (implicit think-deeper) even though
            // the user did not explicitly enable it. Cancel the auto-mode browser metrics so these
            // slow requests don't count against the <16s/<30s SLOs, and re-attribute them to the
            // think-deeper metrics instead.
            if (!thinkDeeperEnabled && !hasAbortedForImplicitThinkDeeper && (0, $bxkJA.isStreamThinkDeeperTriggered)(streamMessage)) {
                hasAbortedForImplicitThinkDeeper = true;
                // Cancel auto-mode metrics so they are not recorded in the SLOs
                stopInteractionMetricsTimeToFirstAnswerPart('cancel');
                sendMessageLatencyMetrics.cancel();
                // Re-attribute to think-deeper metrics (100s SLO target)
                implicitThinkDeeperSendMessageMetrics = (0, $bER8M.messageLatencyMetrics).createSendMessageMetrics({
                    thinkDeeperEnabled: true
                });
                implicitThinkDeeperTimeToFirstAnswerPartMetrics = (0, $bER8M.messageLatencyMetrics).createTimeToFirstAnswerPartMetrics({
                    thinkDeeperEnabled: true
                });
                implicitThinkDeeperSendMessageMetrics.start({
                    startTime: metricsStartTime
                });
                implicitThinkDeeperTimeToFirstAnswerPartMetrics.start({
                    startTime: metricsStartTime
                });
                // Abort the auto-mode reliability SLO experience and start the think-deeper one
                // so implicit think-deeper requests don't count against the auto-mode reliability SLO.
                implicitThinkDeeperExperienceName = (0, $irnO2.sendMessageExperienceName)({
                    thinkDeeperEnabled: true
                });
                experienceTracker.abort({
                    name: sendMessageExperienceNameCompiled,
                    reason: 'Re-attributed to think-deeper reliability SLO'
                });
                experienceTracker.start({
                    name: implicitThinkDeeperExperienceName,
                    id: conversationId,
                    startTime: metricsStartTime,
                    attributes: {
                        conversationId: conversationId,
                        interactionSource: trackingAttributes.interactionSource,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                    }
                });
            }
            // This is the first moment we have the network request id for E2E event tracking
            // Store requestId on human message for E2E event tracking
            if (!trackingAttributes.requestId && 'metadata' in streamMessage) trackingAttributes.requestId = streamMessage.metadata?.request_id ?? undefined;
            if ((0, $bxkJA.isStreamResponse)(streamMessage)) trackingAttributes.interactionModeExecuted = (0, $iqkMb.getInteractionModeExecutedFromStreamResponse)(streamMessage);
            // Handle MEMORY_UPDATE trace messages - create a persistent StoreMemoryUpdate message
            if ((0, $bxkJA.isStreamMemoryUpdate)(streamMessage) && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- This Statsig experiment is not registered in platform feature flags/editor experiments.
            (0, $cXtTj.default).getExperimentValue('memory_management_ux', 'isEnabled', false)) {
                const originalContent = streamMessage.message.content;
                const isMemoryTraceContentEmpty = !originalContent;
                let memoryContent = originalContent;
                let isMemoryContentAfterParsingEmpty = false;
                // Parse memory content: remove "Update memory:" prefix and trim
                if (memoryContent) {
                    memoryContent = memoryContent.replace(/^update\s+memory:\s*/i, '').trim();
                    isMemoryContentAfterParsingEmpty = !memoryContent;
                }
                const memoryUpdateMessage = {
                    type: 'MEMORY_UPDATE',
                    content: memoryContent || undefined // Use undefined instead of empty string
                };
                // Track memory update parsing events
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'parsed',
                    actionSubject: 'memoryUpdate',
                    attributes: {
                        isMemoryTraceContentEmpty: isMemoryTraceContentEmpty,
                        isMemoryContentAfterParsingEmpty: isMemoryContentAfterParsingEmpty,
                        conversationId: conversationId
                    }
                });
                setMessages(conversationId, (0, $aPDnZ.addMemorytoLatestAssistantMessage)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    memory: memoryUpdateMessage,
                    useIndex: answerIndex
                }));
            }
            // Usually the second stream part, before anything else occurs
            if ((0, $bxkJA.isStreamTrace)(streamMessage)) {
                if (!deepResearchEnabled) // we do not want traces that are not marked for deep research to be accumulated when starting research,
                // the ones that are marked are processed above in processResearchStreamMessage
                updateCurrentConversation({
                    traces: (0, $dxl4c.dedupeTraceMessagesWithLatest)([
                        ...(0, $iRmkX.getConversationTraces)(getState(), conversationId),
                        (0, $kZEW9.getTraceFromStreamMessage)(streamMessage)
                    ])
                });
                promptStreamHook?.onTraceMessage?.(streamMessage, tmpAssistantMessageId, openChat);
                setMessages(conversationId, (0, $fCT7n.addRequestIdToLatestHumanMessage)(getMessages(conversationId), trackingAttributes.requestId));
            }
            // Handle Answer Now fast mode traces for extended thinking
            // Answer Now feature - handle fast mode traces
            if ((0, $bxkJA.isStreamFastModeResponseAvailable)(streamMessage) && agentMessageId) // Fast mode response is available - show Answer Now button
            // Store both IDs in AVAILABLE status:
            // - tmpMessageId: for store operations (finding/updating the message)
            // - remoteMessageId: for the Answer Now API call
            setMessages(conversationId, (0, $fS02I.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpAssistantMessageId, {
                type: (0, $igOtY.AnswerNowStatusType).AVAILABLE,
                tmpMessageId: tmpAssistantMessageId,
                remoteMessageId: agentMessageId
            }));
            if ((0, $bxkJA.isStreamFastModeEnabled)(streamMessage)) {
                // Fast mode has been enabled:
                // 1. Set status to SWITCHED (hides button)
                // 2. Clear research steps for this message
                setMessages(conversationId, (0, $fS02I.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpAssistantMessageId, {
                    type: (0, $igOtY.AnswerNowStatusType).SWITCHED
                }));
                // Clear research steps when switching to fast mode
                clearMessageResearch({
                    messageId: tmpAssistantMessageId
                });
            }
            if ((0, $bxkJA.isStreamRemoveAnswerNow)(streamMessage)) (0, $dh2SO.clearAnswerNowStatusForMessageIfSet)(conversationId, tmpAssistantMessageId, getMessages, setMessages);
            // isStreamResearchPlan is handled by processResearchStreamMessage (called earlier in this loop)
            const aifcActionResult = (0, $3qJlQ.processAifcActionStreamMessage)({
                streamMessage: streamMessage,
                conversationId: conversationId,
                tmpAssistantMessageId: tmpAssistantMessageId,
                traceId: traceId,
                productKey: productKey,
                deepResearchEnabled: deepResearchEnabled,
                storeUserMessages: storeUserMessages,
                streamActionInfo: streamActionInfo,
                trackingAttributes: trackingAttributes,
                experienceTracker: experienceTracker,
                chatContextStoreActions: chatContextStoreActions,
                getMessages: getMessages,
                setMessages: setMessages,
                sendAnalyticsEvent: sendAnalyticsEvent,
                getIsChatMounted: getIsChatMounted,
                processMessageStreamAction: processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                processMessageStreamActionClassification: processMessageStreamActionClassification,
                promptStreamHook: promptStreamHook,
                openChat: openChat,
                messageSources: messageSources,
                creationContextParams: creationContextParams,
                agentId: agentId,
                agentName: agentName,
                agentIdentityAccountId: agentIdentityAccountId,
                stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart
            });
            if (aifcActionResult.actionClassificationInvocationId) actionClassificationInvocationIds.add(aifcActionResult.actionClassificationInvocationId);
            if (aifcActionResult.actionCompleteInvocationId) actionCompleteInvocationIds.add(aifcActionResult.actionCompleteInvocationId);
            isBackendCreationRequest || (isBackendCreationRequest = aifcActionResult.isBackendCreationAction);
            if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) {
                stopInteractionMetricsTimeToFirstAnswerPart('stop', {
                    answerType: 'stream-answer-part',
                    conversationId: conversationId
                });
                // Stop the implicit think-deeper time-to-first-answer-part metric if active
                implicitThinkDeeperTimeToFirstAnswerPartMetrics?.stop({
                    customData: {
                        answerType: 'stream-answer-part',
                        conversationId: conversationId
                    }
                });
                // Clear Answer Now status when ANSWER_PART is received
                // This handles the case where the stream starts answering without user clicking Answer Now
                (0, $dh2SO.clearAnswerNowStatusForMessageIfSet)(conversationId, tmpAssistantMessageId, getMessages, setMessages);
                // Sometimes an ANSWER_PART arrives with empty content, which clears traces
                // prematurely and makes the live "thinking" steps flash and disappear. Skip the
                // clear for empty answer parts so traces persist until real content arrives.
                const isEmptyAnswerPart = typeof streamMessage.message.content === 'string' && streamMessage.message.content.length === 0;
                if (!isEmptyAnswerPart) {
                    (0, $hMXhO.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                    // Mark hasReceivedAnswerPart on the chat store message atomically with the
                    // trace clear. This avoids a cross-store render gap (chat store vs research
                    // store) where the thinking indicator would briefly re-appear.
                    setMessages(conversationId, (getMessages(conversationId) ?? []).map((msg)=>{
                        if (msg.type === 'ASSISTANT' && msg.content.message?.message?.id === tmpAssistantMessageId) return {
                            ...msg,
                            hasReceivedAnswerPart: true
                        };
                        return msg;
                    }));
                }
                let processedStreamMessage = streamMessage;
                let hasMarkdownData = false;
                const result = getProcessStreamMarkdownMultiTag()(processedStreamMessage);
                processedStreamMessage = result.processedStreamMessage;
                if (Object.keys(result.markdownData).length > 0) {
                    hasMarkdownData = true;
                    setMessages(conversationId, (0, $ayOmn.addAnswerPartWithMarkdownDataMap)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        markdownData: result.markdownData,
                        useIndex: answerIndex
                    }));
                }
                promptStreamHook?.onAnswerPart?.(processedStreamMessage, tmpAssistantMessageId, conversationId, openChat);
                if (!hasMarkdownData) setMessages(conversationId, (0, $cv4dJ.addAnswerPart)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    answerPart: processedStreamMessage,
                    useIndex: answerIndex
                }));
            // hasAccumulatedAnswerContent tracking is handled by processResearchStreamMessage
            }
            if ((0, $bxkJA.isStreamEntityAnnotations)(streamMessage) && ((0, $iDrrr.fg)('rovo_chat_inferred_project_hover_cards') || (0, $iDrrr.fg)('rovo_chat_people_entity_hover_cards'))) setMessages(conversationId, (0, $6CHtN.appendEntityAnnotationBatch)({
                chat: getMessages(conversationId),
                answerId: tmpAssistantMessageId,
                entityAnnotationBatch: (0, $bxkJA.normalizeEntityAnnotationsMessage)(streamMessage.message)
            }));
            /**********************************************************
       *
       * FINAL_RESPONSE processing
       *
       **********************************************************/ if ((0, $bxkJA.isStreamResponse)(streamMessage)) {
                hasReceivedFinalResponse = true;
                // The turn ended. If it returned an action still awaiting the user's confirmation
                // (e.g. rename-page's "Confirm / Cancel"), the run needs input; otherwise it is done.
                (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, (0, $2WWTW.isFinalResponseAwaitingConfirmation)(streamMessage.message?.message?.actions) ? 'needs-input' : 'done');
                const shouldUseBackendCreationExperienceLifecycle = isBackendCreationRequest && (0, $4o0zT.isExperimentEnabled)('cwr-be-based-multi-creation-v0');
                // No completed actions falls through to abort this experience + others.
                if (shouldUseBackendCreationExperienceLifecycle && actionCompleteInvocationIds.size > 0) // Backend creation responses do not require opening a preview to reach a terminal state.
                (0, $9BBUU.completeAifcActionExperience)(experienceTracker, (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED, actionClassificationInvocationIds, actionCompleteInvocationIds, isBackendCreationRequest);
                // Always succeed AIFC_MESSAGE from FINAL_RESPONSE for backend multi-create events, or when
                // the parity experiment is enabled to streamline frontend and backend handling.
                if (actionCompleteInvocationIds.size > 0 && (shouldUseBackendCreationExperienceLifecycle || (0, $4o0zT.isExperimentEnabled)('cwr-fe-be-experience-analytics-streamline'))) (0, $9BBUU.completeAifcActionExperience)(experienceTracker, (0, $irnO2.ExperienceName).AIFC_MESSAGE, actionClassificationInvocationIds, actionCompleteInvocationIds, isBackendCreationRequest);
                const humanMessage = streamMessage?.message?.human_message;
                const humanMessageId = humanMessage?.id?.toString();
                const finalResponseAgentMessageId = streamMessage?.message?.message?.id.toString();
                agentMessageId = finalResponseAgentMessageId;
                // Record the backend-assigned conversation ID on the optimistic entry so the
                // space sidenav merge logic can dedupe between the local optimistic entry
                // (client UUID) and the API-returned entry (backend ID), and display the
                // correct name from the chat store rather than the timestamp fallback.
                const backendConversationId = streamMessage?.message?.message?.conversation_channel_id;
                if (backendConversationId) updateCurrentConversation({
                    backendConversationId: backendConversationId
                });
                const minionOrchestrationOutputs = streamMessage?.message?.message?.minion_outputs;
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $hMXhO.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                // INVARIANT: updateResearchMessageId MUST be called before replaceAnswerData (and the
                // setMessages call that wraps it). Both stores must agree on the same messageId key
                // before React re-renders — if the chat store ID flips to finalResponseAgentMessageId first,
                // the next render will call getMessageResearchById(finalResponseAgentMessageId) and get undefined
                // because the research store is still keyed under tmpAssistantMessageId, causing
                // completed traces to disappear.
                //
                // Nothing between this call and replaceAnswerData below should read the research
                // store using tmpAssistantMessageId (markdown processing and clearTracesIfNotEmpty
                // above do not touch the research store after this point).
                if (tmpAssistantMessageId !== finalResponseAgentMessageId) updateResearchMessageId({
                    messageId: tmpAssistantMessageId,
                    newMessageId: finalResponseAgentMessageId
                });
                const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = (0, $8GeCh.processStreamResponseMarkdown)({
                    streamMessage: streamMessage,
                    messageId: finalResponseAgentMessageId,
                    conversationId: conversationId,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    shouldPreprocessDetails: (0, $6OcY6.shouldPreprocessDetailsForConversation)(getState(), conversationId)
                });
                // Capture whether the final answer contained inline Lumina blocks so it
                // can be reported on the `agentMessage received` event. The markdown
                // extractor stores those blocks under `lumina-*` keys in `markdownData`.
                // Joined (on messageId) against the `luminaComponent shown` render
                // event to detect Lumina that was returned by BE but never rendered.
                const inlineLuminaCount = Object.keys(markdownData).filter((key)=>key.startsWith('lumina-')).length;
                if (inlineLuminaCount > 0) {
                    trackingAttributes.hasLumina = true;
                    trackingAttributes.luminaType = 'inline';
                    trackingAttributes.luminaCount = inlineLuminaCount;
                }
                // Finish view dead air tracking before rendering final response
                // This ensures the last tracked interval is up to FINAL_RESPONSE arrival,
                // and any DOM updates from replaceAnswerData are not tracked
                viewDeadAirBroker?.finish('completed');
                promptStreamHook?.onFinalResponse?.(processedStreamMessage, tmpAssistantMessageId);
                setMessages(conversationId, (0, $fA89f.replaceAnswerData)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    content: processedStreamMessage,
                    useIndex: answerIndex,
                    humanMessageId: humanMessageId,
                    markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined,
                    traceId: traceId,
                    onMessageIdChanged: onTempMessageIdReplacedOverride || containerOnTempMessageIdReplaced
                }));
                if (humanMessageId) setMessages(conversationId, (0, $dnZkY.updateHumanMessageId)({
                    chat: getMessages(conversationId),
                    oldId: tmpHumanMessageId,
                    newId: humanMessageId,
                    parentMessageId: humanMessage?.parent_message_id,
                    onMessageIdChanged: (oldId, newId)=>containerOnHumanMessageIdReplaced?.(conversationId, oldId, newId)
                }));
                if ((0, $iDrrr.fg)('aifc_create_enabled')) {
                    const allMessages = getMessages(conversationId);
                    const isValidAction = (0, $kOM0B.handleStagingAreaActionValidation)(allMessages, conversationId, traceId, chatContextStoreActions, experienceTracker, getMessages, setMessages, sendMessageLatencyMetrics, cancelStreamingMetrics, {
                        llmDebugLogsEnabled: storeUserMessages
                    }, productKey, minionOrchestrationOutputs);
                    if (!isValidAction) return {
                        hasReceivedFinalResponse: hasReceivedFinalResponse,
                        hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
                        guardEventReceived: guardEventReceived,
                        assistantMessageId: finalResponseAgentMessageId
                    };
                    const finalActions = processedStreamMessage.message.message.actions || [];
                    if (finalActions.length > 0) {
                        const firstActionData = finalActions[0]?.data;
                        stopInteractionMetricsTimeToActionCompletion('stop', {
                            conversationId: conversationId,
                            actionType: 'final-actions',
                            actionCount: finalActions.length,
                            actionKeys: finalActions.map((a)=>a.key),
                            actionPartKey: (0, $1psM9.getActionPartKeyForMetrics)(streamActionInfo.actionKey, creationContextParams?.source, firstActionData?.dynamicUiSubtype),
                            interactionSource: messageSources?.interactionSource,
                            remixType: creationContextParams?.dynamicUiType
                        });
                    } else stopInteractionMetricsTimeToActionCompletion('cancel');
                }
                // Update tracking attributes from FINAL_RESPONSE using the shared extractor.
                const streamMeta = (0, $bbXwY.extractStreamMeta)(streamMessage, skillSelectionSource, (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true));
                if (!hasLoggedInitiatedEvent) {
                    trackingAttributes.messageId = finalResponseAgentMessageId;
                    trackingAttributes.instrumentationId = finalResponseAgentMessageId;
                }
                trackingAttributes.humanMessageId = streamMeta.humanMessageId;
                trackingAttributes.hasSources = streamMeta.hasSources;
                trackingAttributes.hasAuthoritativeSources = streamMeta.hasAuthoritativeSources;
                // Only carry the detailed authority fields when authoritative sources are
                // present, matching the guarded spread in reconnectToInProgressStreamProvider
                // so the gate-off case does not populate trackingAttributes with undefined fields.
                if (streamMeta.hasAuthoritativeSources) {
                    trackingAttributes.authorityLevel = streamMeta.authorityLevel;
                    trackingAttributes.isHighlyAuthoritative = streamMeta.isHighlyAuthoritative;
                    trackingAttributes.overallConfidence = streamMeta.overallConfidence;
                    trackingAttributes.authoritativeSourceCount = streamMeta.authoritativeSourceCount;
                    trackingAttributes.authoritativeExpertCount = streamMeta.authoritativeExpertCount;
                }
                trackingAttributes.citedProductList = streamMeta.citedProductList;
                trackingAttributes.connectorInfo = streamMeta.connectorInfo;
                trackingAttributes.sourceProducts = streamMeta.sourceProducts;
                if (!shouldUseBackendCreationExperienceLifecycle) trackingAttributes.messageActions = streamMeta.messageActions;
                trackingAttributes.messageDynamicUIData = streamMeta.messageDynamicUIData;
                trackingAttributes.invokedFrom = streamMeta.invokedFrom ?? messageSources?.invokedFrom ?? trackingAttributes.invokedFrom;
                trackingAttributes.scenarioId = streamMeta.scenarioId;
                trackingAttributes.sources = streamMeta.responseSources;
                trackingAttributes.usesJsm = streamMeta.usesJsm;
                // Keep Set type for compatibility with downstream consumers that call Array.from()
                trackingAttributes.pluginsInvoked = new Set(streamMeta.pluginsInvoked);
                trackingAttributes.skillsInvoked = streamMeta.skillsInvoked;
                trackingAttributes.executedStratusSkill = streamMeta.executedStratusSkill;
                trackingAttributes.agentExternalConfigReference = streamMeta.agentExternalConfigReference;
                const flatMinionOutputs = minionOrchestrationOutputs?.flat() ?? [];
                // Analytics: Verify if minion alias matches minion id
                (0, $k5njB.minionVerificationAnalytics)({
                    minionAlias: minionAlias,
                    agentId: agentId,
                    minionsOutput: flatMinionOutputs,
                    sendAnalyticsEvent: sendAnalyticsEvent
                });
            }
            (0, $cWQeI.processInteractionConclusion)({
                streamObj: streamObj,
                streamMessage: streamMessage,
                conversationId: conversationId,
                answerIndex: answerIndex,
                requestId: trackingAttributes.requestId,
                getMessages: getMessages,
                setMessages: setMessages,
                sendAnalyticsEvent: sendAnalyticsEvent
            });
            if ((0, $bxkJA.isStreamAgenticUi)(streamObj) && (0, $iDrrr.fg)('jira_ai_rendering_a2ui')) {
                const normalizedAgenticUiMessage = {
                    ...streamObj.data,
                    type: 'AGENTIC_UI'
                };
                setMessages(conversationId, (0, $coqKO.addAgenticUiMessage)(getMessages(conversationId), tmpAssistantMessageId, normalizedAgenticUiMessage));
            }
            if ((0, $bxkJA.isFollowUpMessage)(streamMessage)) {
                hasReceivedFollowUp = true;
                const messages = getMessages(conversationId);
                const originatingAssistant = [
                    ...messages
                ].reverse().find((0, $igOtY.isStoreAssistant));
                const originatingAgentIdentity = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') && originatingAssistant ? (0, $foVqg.deriveFollowUpSendAgentIdentity)(originatingAssistant) : undefined;
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $hMXhO.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                const augmentedFollowUp = (0, $chBow.appendCreatePageFollowUpIfNeeded)(messages, streamMessage, productKey, chatContextStoreActions.getIsStagingArea());
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'FOLLOW_UP',
                        content: augmentedFollowUp,
                        id: (0, $eMs38.randomIntFromInterval)(0, 1000000),
                        agentMessageId: (0, $3Cuhs.getLastAgentMessageID)(messages),
                        ...originatingAgentIdentity ? {
                            originatingAgentIdentity: originatingAgentIdentity
                        } : {},
                        humanMessageId: trackingAttributes.humanMessageId
                    }
                ]);
            }
            /**
       * Task status processing
       */ if ((0, $bxkJA.isStreamTaskStatus)(streamMessage)) onTaskStatusUpdate?.(streamMessage);
            /**
       * Todo snapshot processing
       */ if ((0, $bxkJA.isStreamTodoSnapshot)(streamMessage)) onTodoSnapshot?.({
                todos: streamMessage.message.todos
            });
            if ((0, $bxkJA.isStreamActionError)(streamMessage)) {
                // Producers disagree on where the error text lives, so telemetry probes each known
                // location. Displayed copy keeps the original source so users see the same string.
                const displayedErrorMessage = streamMessage.message?.data?.message || (0, $awqa1.ACTION_EXECUTION_FAILED);
                const resolvedErrorMessage = streamMessage.message?.data?.message || streamMessage.message?.data?.content || streamMessage.message?.content || (0, $awqa1.ACTION_EXECUTION_FAILED);
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                processMessageStreamError?.({
                    actionKey: streamActionInfo.actionKey,
                    errorType: streamMessage?.message?.key,
                    errorMessage: resolvedErrorMessage,
                    traceId: traceId
                });
                promptStreamHook?.onError?.(streamMessage, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId
                });
                broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
                const actionError = new (0, $hwHCO.StreamErrorException)(displayedErrorMessage, {
                    detail: {
                        message: {
                            content: resolvedErrorMessage,
                            message_template: streamMessage?.message?.key
                        },
                        metadata: {
                            ...streamMessage.metadata,
                            isStagingArea: chatContextStoreActions.getIsStagingArea(),
                            productKey: productKey
                        }
                    },
                    traceId: traceId
                });
                experienceTracker.fail({
                    name: sendMessageExperienceNameCompiled,
                    error: actionError,
                    attributes: {
                        conversationId: conversationId,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        isDeepResearchEnabled: deepResearchEnabled,
                        isThinkDeeperEnabled: thinkDeeperEnabled,
                        isFastModeEnabled: fastModeEnabled,
                        isWebSearchEnabled: webSearchEnabled,
                        llmDebugLogsEnabled: storeUserMessages,
                        productKey: productKey,
                        isStreamAction: streamActionInfo.isAction,
                        actionKey: streamActionInfo.actionKey,
                        traceId: traceId,
                        ...remixRegenerateRequestAttributes
                    }
                });
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
                    error: actionError,
                    attributes: {
                        productKey: productKey,
                        isStreamAction: streamActionInfo.isAction,
                        actionKey: streamActionInfo.actionKey,
                        llmDebugLogsEnabled: storeUserMessages,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        latestStreamMessageMillisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                        latestStreamMessageType: latestStreamMessage?.type
                    }
                });
                if ((0, $iDrrr.fg)('aifc-experience-timeout')) {
                    const reason = streamActionInfo.isAction ? 'action_error_while_executing_action' : 'action_error_without_classification';
                    for (const name of [
                        (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                        (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED
                    ])experienceTracker.fail({
                        name: name,
                        error: actionError,
                        attributes: {
                            productKey: productKey,
                            actionKey: streamActionInfo.actionKey,
                            reason: reason
                        }
                    });
                }
                throw actionError;
            }
            if ((0, $bxkJA.isStreamPromptRedaction)(streamMessage)) {
                const redactingTypes = (0, $cXtTj.default).getExperiment('rovo_chat_redacting_guard_config').value?.value ?? [];
                if (redactingTypes.includes(streamMessage.type) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) // Do NOT set guardEventReceived — the stream continues with the actual response after redaction.
                onPromptRedacted?.(streamMessage);
            }
            if ((0, $bxkJA.isStreamReasoningPart)(streamMessage)) (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'thinking');
            if ((0, $bxkJA.isStreamPromptBlock)(streamMessage)) {
                const blockingTypes = (0, $cXtTj.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onPromptBlocked?.(streamMessage);
                }
            }
            if ((0, $bxkJA.isStreamResponseRedaction)(streamMessage)) {
                const redactingTypes = (0, $cXtTj.default).getExperiment('rovo_chat_redacting_guard_config').value?.value ?? [];
                if (redactingTypes.includes(streamMessage.type) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) // Do NOT set guardEventReceived — stream continues after response redaction.
                onResponseRedacted?.(streamMessage);
            }
            if ((0, $bxkJA.isStreamResponseBlock)(streamMessage)) {
                const blockingTypes = (0, $cXtTj.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onResponseBlocked?.(streamMessage);
                }
            }
            if ((0, $bxkJA.isStreamAttachmentBlock)(streamMessage)) {
                const blockingTypes = (0, $cXtTj.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onAttachmentBlocked?.(streamMessage);
                }
            }
            if ((0, $bxkJA.isStreamError)(streamMessage)) {
                processMessageStreamError?.({
                    actionKey: streamActionInfo.actionKey,
                    errorType: streamMessage?.message?.message_template,
                    errorMessage: streamMessage?.message?.content,
                    traceId: traceId
                });
                // If a guard event (PROMPT_REDACTION, PROMPT_BLOCKED, RESPONSE_BLOCKED, or ATTACHMENT_BLOCKED) was
                // already received, the backend always follows with an ERROR to terminate the stream.
                // Treat it as a normal end of the guard flow — break without throwing.
                if (guardEventReceived) {
                    // A guard block (prompt/response/attachment) is terminated by this backend error;
                    // surface it once here as the run's blocked state.
                    (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'blocked');
                    break;
                }
                const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                // AUP violations are still considered successful
                if ((0, $bxkJA.isStreamAUPError)(streamMessage)) {
                    experienceTracker.succeed({
                        name: sendMessageExperienceNameCompiled
                    });
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).AIFC_MESSAGE
                    });
                    // [MAUI-1070] In the remix flow, treat an AUP violation as non-fatal:
                    // keep reading so the friendly response (streamed right after the guard)
                    // arrives instead of being discarded by the throw below. `onSafetyViolation`
                    // lets the editor-remix UI surface it (dismiss thinking bar, open chat).
                    // Scoped to `source === 'remix'`; other flows keep the existing throw.
                    if (creationContextParams?.source === 'remix' && (0, $ieeJu.expValEquals)('cc_maui_polish_changes_batch_3', 'isEnabled', true)) {
                        promptStreamHook?.onSafetyViolation?.(conversationId);
                        continue;
                    }
                }
                sendMessageLatencyMetrics.cancel();
                deadAirTracker?.cancel();
                viewDeadAirBroker?.finish('errored');
                cancelStreamingMetrics();
                promptStreamHook?.onError?.(streamMessage, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId
                });
                broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
                // A genuine error that actually terminates the run. Placed after the AUP remix path
                // above, which continues rather than throwing, so that path is not marked failed.
                (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'failed');
                throw new (0, $hwHCO.StreamErrorException)(message?.content || 'Unknown', {
                    detail: {
                        message: message,
                        metadata: metadata,
                        millisOffset: millisOffset,
                        type: type
                    },
                    traceId: traceId
                });
            }
        }
    } catch (error) {
        /* for await catch block */ const err = error instanceof Error ? error : new Error(String(error));
        if (err instanceof (0, $hwHCO.StreamErrorException)) throw err;
        if (err instanceof (0, $b6N3q.RovoChatStreamTimeoutError)) {
            sendMessageLatencyMetrics.cancel();
            deadAirTracker?.cancel();
            viewDeadAirBroker?.finish('aborted');
            cancelStreamingMetrics();
            broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
            experienceTracker.fail({
                name: sendMessageExperienceNameCompiled,
                error: err,
                attributes: {
                    conversationId: conversationId,
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    fastModeEnabled: fastModeEnabled,
                    webSearchEnabled: webSearchEnabled,
                    llmDebugLogsEnabled: storeUserMessages,
                    productKey: productKey,
                    isStreamAction: streamActionInfo.isAction,
                    actionKey: streamActionInfo.actionKey,
                    featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                    traceId: traceId,
                    ...remixRegenerateRequestAttributes
                }
            });
            throw err;
        }
        // this is for any errors that happening during processing the stream
        // e.g. BE terminates streaming suddenly
        sendMessageLatencyMetrics.cancel();
        deadAirTracker?.cancel();
        viewDeadAirBroker?.finish('aborted');
        cancelStreamingMetrics();
        if ((0, $bPaiw.isClientSideStreamingError)(err)) {
            const isReconnectable = !!(agentMessageId && isReconnectSupported);
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: 'rovoChatStream',
                attributes: {
                    ...streamStats.getStats(),
                    isDeepResearchEnabled: deepResearchEnabled,
                    isThinkDeeperEnabled: thinkDeeperEnabled,
                    isFastModeEnabled: fastModeEnabled,
                    isWebSearchEnabled: webSearchEnabled,
                    isAIFCStreaminAction: streamActionInfo.isAction,
                    isReconnectable: isReconnectable,
                    conversationId: conversationId,
                    instrumentationId: trackingAttributes.instrumentationId,
                    requestId: trackingAttributes.requestId,
                    interactionSource: trackingAttributes.interactionSource,
                    contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                    userAgent: navigator?.userAgent,
                    error: err.message
                }
            });
        }
        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
        // When reconnect attempt fails
        if (!deepResearchEnabled && (0, $iDrrr.fg)('aifc-experience-timeout')) {
            const reason = streamActionInfo.isAction ? 'stream_error_during_action' : 'stream_error_before_classification';
            for (const name of [
                (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED
            ])experienceTracker.fail({
                name: name,
                error: err,
                attributes: {
                    productKey: productKey,
                    actionKey: streamActionInfo.actionKey,
                    reason: reason
                }
            });
        }
        throw new (0, $bQxqB.StreamGeneratorError)(err.message ?? 'Stream generator error', {
            traceId: traceId,
            detail: {
                millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                type: latestStreamMessage?.type ?? ''
            }
        }, err);
    } finally{
        inactivity?.stop();
        deadAirTracker?.complete();
        viewDeadAirBroker?.finish('completed');
        // Safety net for the agent-run bridge: if the turn ended without settling (abort, timeout,
        // dropped request), clear the run so its node does not stay active. No-op on the normal
        // paths, which have already reached done / needs-input / a terminal state.
        (0, $9vNm5.endActiveAgentRun)(conversationId);
    }
    /**********************************************************
   *
   * Stream processing END
   *
   **********************************************************/ if (actionClassificationInvocationIds.size > 0 && actionCompleteInvocationIds.size === 0 && hasReceivedFinalResponse) // In the case ACTION_COMPLETE was never sent, it's likely that `AdfEditorMinion` early-exits with "no operations returned by LLM". So we abort the experiences rather than letting them timeout. This can potentially happen when LLM needs clarification.
    (0, $iWbNp.abortGenerateContentChildExperiences)(experienceTracker, 'stream_completed_without_action_complete', {
        actionKey: streamActionInfo.actionKey,
        productKey: productKey
    });
    if (!hasReceivedFollowUp && hasReceivedFinalResponse) {
        const messages = getMessages(conversationId);
        if ((0, $5tsq8.shouldAppendCreatePageFollowUp)(messages, productKey, chatContextStoreActions.getIsStagingArea())) {
            const originatingAssistant = [
                ...messages
            ].reverse().find((0, $igOtY.isStoreAssistant));
            const originatingAgentIdentity = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') && originatingAssistant ? (0, $foVqg.deriveFollowUpSendAgentIdentity)(originatingAssistant) : undefined;
            setMessages(conversationId, [
                ...messages,
                {
                    type: 'FOLLOW_UP',
                    content: (0, $3cJKb.createSyntheticCreatePageFollowUp)(),
                    id: (0, $eMs38.randomIntFromInterval)(0, 1000000),
                    agentMessageId: (0, $3Cuhs.getLastAgentMessageID)(messages),
                    ...originatingAgentIdentity ? {
                        originatingAgentIdentity: originatingAgentIdentity
                    } : {},
                    humanMessageId: trackingAttributes.humanMessageId
                }
            ]);
        }
    }
    updateCurrentConversation({
        sourceAgentId: (0, $4Y0no.getSourceAgentId)(getMessages(conversationId), (0, $dCJIZ.getConversation)(getState(), conversationId))
    });
    return {
        hasReceivedFinalResponse: hasReceivedFinalResponse,
        hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
        hasAbortedForImplicitThinkDeeper: hasAbortedForImplicitThinkDeeper,
        implicitThinkDeeperSendMessageMetrics: implicitThinkDeeperSendMessageMetrics,
        implicitThinkDeeperExperienceName: implicitThinkDeeperExperienceName,
        guardEventReceived: guardEventReceived,
        assistantMessageId: hasReceivedFinalResponse && agentMessageId ? agentMessageId : tmpAssistantMessageId
    };
};
module.exports["processStream"] = $4964ca4cf6fe5338$export$efb69f1fe7577739;

});

parcelRegister("iX60o", function(module, exports) {
const $3f00b208cdf7b094$export$194fc39b7c9c983 = ({ resultAttributionContext: resultAttributionContext, routingAgentId: routingAgentId, messageSources: messageSources, additionalAnalyticAttributes: additionalAnalyticAttributes })=>{
    const sourceAgentId = resultAttributionContext?.sourceAgentId;
    const launchSource = resultAttributionContext?.launchSource;
    if (resultAttributionContext === undefined || launchSource === undefined) return {
        messageSources: messageSources,
        additionalAnalyticAttributes: additionalAnalyticAttributes
    };
    if (sourceAgentId !== undefined && sourceAgentId !== routingAgentId) return {
        messageSources: messageSources,
        additionalAnalyticAttributes: additionalAnalyticAttributes,
        shouldClearResultAttributionContext: true
    };
    const attributedMessageSources = messageSources?.followUpSource ? messageSources : {
        ...messageSources ?? {},
        followUpSource: launchSource
    };
    const attributedAdditionalAnalyticAttributes = {
        launchSource: launchSource,
        ...additionalAnalyticAttributes ?? {}
    };
    return {
        messageSources: attributedMessageSources,
        additionalAnalyticAttributes: attributedAdditionalAnalyticAttributes
    };
};
module.exports["applyResultAttributionContext"] = $3f00b208cdf7b094$export$194fc39b7c9c983;

});

parcelRegister("1Nzi3", function(module, exports) {
const $1206f352a14d8e9a$export$cb6128fc3a3c8081 = ()=>{
    const abortController = new AbortController();
    let resolveAbort;
    const confirmAbort = ()=>{
        resolveAbort();
    };
    const abort = ()=>{
        abortController.abort();
        return new Promise((resolve)=>{
            resolveAbort = resolve;
        });
    };
    return {
        abortController: abortController,
        storeAbortController: {
            abort: abort
        },
        confirmAbort: confirmAbort
    };
};
module.exports["createStoreAbortController"] = $1206f352a14d8e9a$export$cb6128fc3a3c8081;

});

parcelRegister("62wRL", function(module, exports) {
const $0612fd78d8462bd5$export$aa9d968a842359fd = ()=>{
    try {
        return Intl?.Segmenter ? new Intl.Segmenter(undefined, {
            granularity: 'word'
        }) : null;
    } catch  {
        return null;
    }
};
module.exports["createSegmenter"] = $0612fd78d8462bd5$export$aa9d968a842359fd;

});

parcelRegister("2YVJu", function(module, exports) {
const $0c5a9f05ef283ae7$export$3ac8b179c5bae1cb = (metadata)=>metadata?.interaction_mode_executed ?? undefined;
module.exports["getInteractionModeExecutedFromMetadata"] = $0c5a9f05ef283ae7$export$3ac8b179c5bae1cb;

});

parcelRegister("cYKsm", function(module, exports) {
const $0ac98c0a880a830b$var$STREAM_TIMEOUT = Symbol('STREAM_TIMEOUT');
async function* $0ac98c0a880a830b$export$44aab448715585b6(stream, { timeoutMs: timeoutMs, onTimeout: onTimeout, isPaused: isPaused }) {
    // Kept outstanding across timer re-arms; calling `next()` again while one is
    // pending is illegal on a generator.
    let nextPromise;
    while(true){
        if (!nextPromise) nextPromise = stream.next();
        let timeoutId;
        const timeout = new Promise((resolve)=>{
            timeoutId = setTimeout(()=>resolve($0ac98c0a880a830b$var$STREAM_TIMEOUT), timeoutMs);
        });
        let result;
        try {
            result = await Promise.race([
                nextPromise,
                timeout
            ]);
        } finally{
            clearTimeout(timeoutId);
            timeoutId = undefined;
        }
        if (result === $0ac98c0a880a830b$var$STREAM_TIMEOUT) {
            // Paused (e.g. reconnecting): re-arm with the same pending `next()`.
            if (isPaused?.()) continue;
            const error = onTimeout();
            // Clean up the source stream after timing out.
            const returnPromise = stream.return?.(undefined);
            returnPromise?.catch(()=>undefined);
            if (error) throw error;
            return;
        }
        // Chunk arrived – advance to the next one.
        nextPromise = undefined;
        if (result.done) return;
        yield result.value;
    }
}
module.exports["withAsyncGeneratorTimeout"] = $0ac98c0a880a830b$export$44aab448715585b6;

});

parcelRegister("gibzw", function(module, exports) {

var $gDqX2 = parcelRequire("gDqX2");


var $hwHCO = parcelRequire("hwHCO");


var $58LQ9 = parcelRequire("58LQ9");

const $bcd5e69edf2194aa$var$MAX_RECONNECT_ATTEMPTS = 5;
const $bcd5e69edf2194aa$var$RETRY_BASE_DELAY_MS = 1000;
const $bcd5e69edf2194aa$var$RECONNECT_JITTER_MS = 500;
const $bcd5e69edf2194aa$var$POST_ONLINE_DELAY_MS = 2000;
async function* $bcd5e69edf2194aa$export$a802bb7fa59dba39({ initialGenerator: initialGenerator, canReconnect: canReconnect, getReconnectGenerator: getReconnectGenerator, getEventId: getEventId, onBeforeFirstReconnect: onBeforeFirstReconnect, onReconnecting: onReconnecting, onReconnected: onReconnected, onFirstChunkAfterReconnect: onFirstChunkAfterReconnect, onStreamCompleted: onStreamCompleted, onStreamFailed: onStreamFailed, signal: signal, maxAttempts: maxAttempts = $bcd5e69edf2194aa$var$MAX_RECONNECT_ATTEMPTS, shouldContinueRetrying: shouldContinueRetrying }) {
    let currentGenerator = initialGenerator;
    let lastEventId;
    let reconnectCount = 0;
    let reconnectionAttempted = false;
    let awaitingFirstChunkAfterReconnect = false;
    while(true)try {
        for await (const chunk of currentGenerator){
            if (signal?.aborted) return;
            const eventId = getEventId(chunk);
            if (eventId) lastEventId = eventId;
            if (awaitingFirstChunkAfterReconnect) {
                awaitingFirstChunkAfterReconnect = false;
                onFirstChunkAfterReconnect?.();
            }
            yield chunk;
        }
        if (reconnectionAttempted) onStreamCompleted?.();
        return;
    } catch (error) {
        if (error instanceof (0, $hwHCO.StreamErrorException)) {
            if (reconnectionAttempted) onStreamFailed?.(error);
            throw error;
        }
        if (!(0, $58LQ9.isRetryableReconnectionError)(error) || !canReconnect() || reconnectCount >= maxAttempts || signal?.aborted) {
            if (reconnectionAttempted) onStreamFailed?.(error);
            throw error;
        }
        if (shouldContinueRetrying && !shouldContinueRetrying()) {
            if (reconnectionAttempted) onStreamFailed?.(error);
            throw error;
        }
        if (!reconnectionAttempted) {
            onBeforeFirstReconnect?.();
            reconnectionAttempted = true;
        }
        reconnectCount++;
        onReconnecting?.(reconnectCount, maxAttempts, lastEventId);
        currentGenerator = await (0, $gDqX2.exponentialRetry)({
            fn: async ()=>getReconnectGenerator(lastEventId),
            maxRetries: 2,
            delay: $bcd5e69edf2194aa$var$RETRY_BASE_DELAY_MS,
            jitter: $bcd5e69edf2194aa$var$RECONNECT_JITTER_MS,
            pauseWhileOffline: true,
            postOnlineDelay: $bcd5e69edf2194aa$var$POST_ONLINE_DELAY_MS,
            errorFilter: (0, $58LQ9.isRetryableReconnectionError),
            signal: signal
        });
        onReconnected?.();
        awaitingFirstChunkAfterReconnect = true;
    }
}
module.exports["createReconnectableStream"] = $bcd5e69edf2194aa$export$a802bb7fa59dba39;

});

parcelRegister("ijGER", function(module, exports) {

var $2H7fQ = parcelRequire("2H7fQ");

const $a7542f0d9855c517$export$4f5dbc9d3a9c9f98 = (params)=>{
    const timeToConnectToStreamMetrics = (0, $2H7fQ.reconnectionMetrics).createTimeToConnectToStreamMetrics({
        deepResearchEnabled: params.isDeepResearchEnabled,
        thinkDeeperEnabled: params.thinkDeeperEnabled,
        fastModeEnabled: params.fastModeEnabled
    });
    const timeToResumeStreamMetrics = (0, $2H7fQ.reconnectionMetrics).createTimeToResumeStreamMetrics({
        deepResearchEnabled: params.isDeepResearchEnabled,
        thinkDeeperEnabled: params.thinkDeeperEnabled,
        fastModeEnabled: params.fastModeEnabled
    });
    return {
        timeToConnectToStreamMetrics: timeToConnectToStreamMetrics,
        timeToResumeStreamMetrics: timeToResumeStreamMetrics
    };
};
module.exports["createReconnectionMetrics"] = $a7542f0d9855c517$export$4f5dbc9d3a9c9f98;

});

parcelRegister("bbXwY", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7GlM0 = parcelRequire("7GlM0");


var $cOfHE = parcelRequire("cOfHE");


var $3ArZy = parcelRequire("3ArZy");


var $gB8YL = parcelRequire("gB8YL");


var $4eyID = parcelRequire("4eyID");

/**
 * Derives non-UGC authority attributes from the response's authority_ui_metadata.
 * Only counts, booleans, and the coarse level/confidence are emitted — never
 * source titles, expert names, URLs, or reasoning text. Gated on the
 * authoritative-answer feature flag.
 */ const $577cc8ea0ec76152$var$extractAuthorityMeta = (response)=>{
    if (!(0, $iDrrr.fg)('rovo_authoritative_answer_attribution')) return {
        hasAuthoritativeSources: false
    };
    const message = response.message?.message;
    // Top level for streaming responses; nested under message_metadata for history.
    const authorityUiMetadata = message?.authority_ui_metadata ?? message?.message_metadata?.authority_ui_metadata;
    if (!authorityUiMetadata) return {
        hasAuthoritativeSources: false
    };
    return {
        hasAuthoritativeSources: true,
        authorityLevel: authorityUiMetadata.authorityLevel,
        isHighlyAuthoritative: authorityUiMetadata.isHighlyAuthoritative ?? authorityUiMetadata.highlyAuthoritative ?? false,
        overallConfidence: authorityUiMetadata.overallConfidence,
        authoritativeSourceCount: authorityUiMetadata.sources?.length ?? 0,
        authoritativeExpertCount: authorityUiMetadata.domainExperts?.length ?? 0
    };
};
const $577cc8ea0ec76152$export$2244b7838be162ca = (response, skillSelectionSource, includeDynamicUIData)=>{
    const sources = response.message?.message?.sources;
    const pluginInvocations = response.message?.message?.plugin_invocations;
    const minionOutputs = response.message?.message?.minion_outputs;
    const actions = response.message?.message?.actions;
    const humanMessageId = response.message?.human_message?.id.toString();
    const pluginsInvoked = [];
    const skillsInvoked = [];
    let usesJsm = false;
    pluginInvocations?.forEach((pi)=>{
        if (pi.plugin_name) pluginsInvoked.push(pi.plugin_name);
        if (pi.plugin_output && (0, $3ArZy.containsServiceDeskSource)(pi.plugin_output) && (0, $iDrrr.fg)('rovo_chat_analytics_source_extended')) usesJsm = true;
    });
    const flatMinionOutputs = minionOutputs?.flat() ?? [];
    const executedStratusSkill = flatMinionOutputs.some((output)=>output.skill_type === 'STRATUS') ?? false;
    flatMinionOutputs.forEach((output)=>{
        pluginsInvoked.push(output.minion_id);
        const isExplicit = output.directly_invoked;
        skillsInvoked.push({
            minionId: output.minion_id,
            skillName: output.skill_alias,
            skillType: output.skill_type,
            invocationType: isExplicit ? 'explicit' : 'implicit',
            internalTools: output.internal_tools?.map((tool)=>({
                    name: tool.name,
                    isConsequential: tool.is_consequential
                })) ?? [],
            skillSelectionSource: isExplicit ? skillSelectionSource : undefined
        });
        if (output.minion_output && (0, $3ArZy.containsServiceDeskSource)(output.minion_output) && (0, $iDrrr.fg)('rovo_chat_analytics_source_extended')) usesJsm = true;
    });
    return {
        humanMessageId: humanMessageId,
        citedProductList: (0, $7GlM0.constructCitedProductList)(sources),
        connectorInfo: (0, $iDrrr.fg)('rovo_chat_connector_info_analytics') ? (0, $4eyID.extractConnectorInfo)(sources) : undefined,
        sourceProducts: (0, $cOfHE.constructSourceProducts)(sources),
        hasSources: !!sources?.length,
        ...$577cc8ea0ec76152$var$extractAuthorityMeta(response),
        pluginsInvoked: pluginsInvoked,
        skillsInvoked: skillsInvoked,
        executedStratusSkill: executedStratusSkill,
        messageActions: actions?.map((action)=>action.key),
        messageDynamicUIData: includeDynamicUIData ? actions?.map((action)=>({
                subtype: action.data?.dynamicUiSubtype
            })) : undefined,
        invokedFrom: (0, $gB8YL.getInvokedFrom)({
            messageActionKey: actions?.[0]?.key,
            messageActionData: actions?.[0]?.data
        }),
        responseSources: (0, $iDrrr.fg)('rovo_chat_analytics_source_extended') ? sources?.map((x)=>x.ari).filter(Boolean) : undefined,
        usesJsm: (0, $iDrrr.fg)('rovo_chat_analytics_source_extended') ? usesJsm : undefined,
        scenarioId: response.message?.message?.scenario?.id,
        interactionModeExecuted: response.message?.message?.message_metadata?.interaction_mode_executed,
        agentExternalConfigReference: (0, $iDrrr.fg)('add_mci_kr_attributes_to_rovo_chat_analytics') ? response.message?.message?.author?.external_config_reference ?? response.message?.message?.author?.named_id : undefined
    };
};
module.exports["extractStreamMeta"] = $577cc8ea0ec76152$export$2244b7838be162ca;

});

parcelRegister("lS0Jk", function(module, exports) {
const $411a747b8da7f11a$export$2f438a4a7bbfabc = (interactionModeRequested)=>interactionModeRequested ? {
        interactionModeRequested: interactionModeRequested
    } : {};
module.exports["interactionModeRequestedAttributes"] = $411a747b8da7f11a$export$2f438a4a7bbfabc;

});

parcelRegister("fIgxW", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $aYC8J = parcelRequire("aYC8J");


var $bxkJA = parcelRequire("bxkJA");


var $foVqg = parcelRequire("foVqg");


var $igOtY = parcelRequire("igOtY");


var $b6N3q = parcelRequire("b6N3q");


var $eMs38 = parcelRequire("eMs38");


var $k2kly = parcelRequire("k2kly");


var $cv4dJ = parcelRequire("cv4dJ");


var $ayOmn = parcelRequire("ayOmn");


var $hMXhO = parcelRequire("hMXhO");


var $awqa1 = parcelRequire("awqa1");


var $6WeLa = parcelRequire("6WeLa");


var $hwHCO = parcelRequire("hwHCO");


var $bQxqB = parcelRequire("bQxqB");


var $kNXXO = parcelRequire("kNXXO");


var $k1kN6 = parcelRequire("k1kN6");


var $3Cuhs = parcelRequire("3Cuhs");


var $cWQeI = parcelRequire("cWQeI");


var $55rUT = parcelRequire("55rUT");


var $8GeCh = parcelRequire("8GeCh");


var $fA89f = parcelRequire("fA89f");


var $6OcY6 = parcelRequire("6OcY6");


var $dnZkY = parcelRequire("dnZkY");

const $2b1590a070c92522$export$f74ad34bb7f49ad1 = async ({ generator: generator, messageId: messageId, conversationId: conversationId, isDeepResearch: isDeepResearch, isStagingArea: isStagingArea, answerIndex: answerIndex, traceId: traceId, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, getState: getState, updateCurrentConversation: updateCurrentConversation, sendAnalyticsEvent: sendAnalyticsEvent, onStreamEvent: onStreamEvent, getIsReplaying: getIsReplaying, reasoningChunkBuffer: reasoningChunkBuffer, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, onStreamEnd: onStreamEnd, onFinalResponse: onFinalResponse, onTaskStatusDraft: onTaskStatusDraft, onTaskStatusCompleted: onTaskStatusCompleted, onTodoSnapshot: onTodoSnapshot, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, onHumanMessageIdReplaced: onHumanMessageIdReplaced })=>{
    // Gate the details-tag preprocessor to 3P-agent conversations only.
    const shouldPreprocessDetails = (0, $6OcY6.shouldPreprocessDetailsForConversation)(getState(), conversationId);
    const processStreamMarkdownMultiTag = (0, $6WeLa.createStreamMarkdownMultiTagProcessor)({
        shouldPreprocessDetails: shouldPreprocessDetails
    });
    let latestStreamMessage;
    let hasReceivedFinalResponse = false;
    // Research store state shared across stream messages
    const researchState = {
        clientRoundCounter: 0,
        hasAccumulatedAnswerContent: false
    };
    let requestId;
    // Tracks whether we've already seeded `previousAccumulatedData` onto the
    // first live (non-replay) AIFC create action chunk after a reconnect. Gated
    // behind aifc_fix_reconnect_stream_overlap_accumulate. When the overlap-fix
    // gate suppresses replayed chunks, the editor never receives the accumulated
    // pre-reconnect content; we hand it over once via previousAccumulatedData so
    // the editor can seed its document before appending live deltas.
    let hasSeededPreviousAccumulatedData = false;
    try {
        for await (const streamObj of generator){
            const streamMessage = streamObj.data;
            latestStreamMessage = streamMessage;
            onStreamEvent('chunk', streamMessage, streamObj.id);
            // TRACE events are not handled in reconnect; drop early to skip
            // the remaining type-checks below.
            if ((0, $bxkJA.isStreamTrace)(streamMessage)) continue;
            // This is the first moment we have the network request id for E2E event tracking
            // Store requestId on human message for E2E event tracking
            if (!requestId && 'metadata' in streamMessage) requestId = streamMessage.metadata?.request_id ?? undefined;
            (0, $cWQeI.processInteractionConclusion)({
                streamObj: streamObj,
                streamMessage: streamMessage,
                conversationId: conversationId,
                answerIndex: answerIndex,
                requestId: requestId,
                defaultTransport: 'sse',
                getMessages: getMessages,
                setMessages: setMessages,
                sendAnalyticsEvent: sendAnalyticsEvent
            });
            // Buffer REASONING_PART during replay; bufferEvent returns false for
            // orphan chunks (no stepId) so they fall through.
            if (reasoningChunkBuffer && getIsReplaying?.() && (0, $bxkJA.isStreamReasoningPart)(streamMessage) && reasoningChunkBuffer.bufferEvent(streamMessage)) continue;
            /**
       * Research store processing — handles think-deeper traces, implicit round
       * detection, and research plan updates for all message types.
       */ (0, $55rUT.processResearchStreamMessage)({
                streamMessage: streamMessage,
                tmpAssistantMessageId: messageId,
                conversationId: conversationId,
                deepResearchEnabled: isDeepResearch ?? false,
                getMessages: getMessages,
                setMessages: setMessages,
                processStreamResearch: processStreamResearch,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                researchState: researchState
            });
            /**
       * Task status processing
       */ if ((0, $bxkJA.isStreamTaskStatus)(streamMessage)) {
                const taskMessage = streamMessage.message;
                if (taskMessage.status === 'DRAFT') onTaskStatusDraft?.({
                    taskId: taskMessage.task_id,
                    title: taskMessage.title,
                    updatedAt: taskMessage.updated_at,
                    messageId: messageId
                });
                else if (taskMessage.status === 'COMPLETED') onTaskStatusCompleted?.({
                    title: taskMessage.title,
                    updatedAt: taskMessage.updated_at,
                    completionMessageId: messageId
                });
            }
            /**
       *  snapshot processing
       */ if ((0, $bxkJA.isStreamTodoSnapshot)(streamMessage)) onTodoSnapshot?.({
                todos: streamMessage.message.todos
            });
            /**
       *  ANSWER_PART  processing
       */ if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) {
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $hMXhO.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                let processedStreamMessage = streamMessage;
                let hasMarkdownData = false;
                const result = processStreamMarkdownMultiTag(processedStreamMessage);
                processedStreamMessage = result.processedStreamMessage;
                if (Object.keys(result.markdownData).length > 0) {
                    hasMarkdownData = true;
                    setMessages(conversationId, (0, $ayOmn.addAnswerPartWithMarkdownDataMap)({
                        chat: getMessages(conversationId),
                        answerId: messageId,
                        answerPart: processedStreamMessage,
                        markdownData: result.markdownData,
                        useIndex: answerIndex
                    }));
                }
                if (!hasMarkdownData) setMessages(conversationId, (0, $cv4dJ.addAnswerPart)({
                    chat: getMessages(conversationId),
                    answerId: messageId,
                    answerPart: processedStreamMessage,
                    useIndex: answerIndex
                }));
            }
            if (((0, $bxkJA.isStreamActionPart)(streamMessage) || (0, $bxkJA.isStreamActionPrepare)(streamMessage)) && (0, $iDrrr.fg)('aifc_create_enabled')) {
                const updatedMessages = (0, $k2kly.addActionPart)({
                    chat: getMessages(conversationId),
                    messageId: messageId,
                    actionPart: streamMessage,
                    useIndex: answerIndex,
                    // Gated behind aifc_fix_reconnect_stream_overlap_accumulate: mirror the
                    // live processor so replayed AIFC create chunks accumulate their primary
                    // field (e.g. adf) in the store instead of overwriting with the latest
                    // chunk. This is what makes the accumulated content available to seed
                    // previousAccumulatedData below.
                    ...(0, $iDrrr.fg)('aifc_fix_reconnect_stream_overlap_accumulate') ? {
                        actionUpdaterOverride: (0, $aYC8J.customActionUpdater)
                    } : {}
                });
                if ((0, $bxkJA.isStreamActionPrepare)(streamMessage)) {
                    const actionMessage = streamMessage.message;
                    setMessages(conversationId, [
                        ...updatedMessages,
                        {
                            type: 'ACTION_PREPARE',
                            action: actionMessage
                        }
                    ]);
                } else setMessages(conversationId, updatedMessages);
                // Gated behind aifc_fix_reconnect_stream_overlap so rollback is safe.
                if ((0, $iDrrr.fg)('aifc_fix_reconnect_stream_overlap')) {
                    if (!getIsReplaying?.()) {
                        // Gated behind aifc_fix_reconnect_stream_overlap_accumulate: on the
                        // first live chunk after replay, hand the accumulated pre-reconnect
                        // content to the editor via previousAccumulatedData. The overlap-fix
                        // gate suppresses replayed chunks from the editor, so without this the
                        // editor has no way to reconstruct what streamed before the reconnect.
                        if (!hasSeededPreviousAccumulatedData && (0, $bxkJA.isStreamActionPart)(streamMessage) && (0, $iDrrr.fg)('aifc_fix_reconnect_stream_overlap_accumulate')) {
                            const actionKey = streamMessage.message.key;
                            if ((0, $aYC8J.isAccumulatedAction)(actionKey)) {
                                const lastAction = (0, $kNXXO.findLastAssistantAction)(getMessages(conversationId), (action)=>action.key === actionKey);
                                const isAccumulatedActionType = (0, $aYC8J.getAccumulatedActionTypeGuard)(actionKey);
                                if (lastAction && isAccumulatedActionType(streamMessage.message.data)) {
                                    const primaryAccumulatedData = (0, $aYC8J.getPrimaryAccumulatedValue)(lastAction);
                                    if (primaryAccumulatedData?.value) {
                                        streamMessage.message.data.previousAccumulatedData = primaryAccumulatedData.value;
                                        hasSeededPreviousAccumulatedData = true;
                                    }
                                }
                            }
                        }
                        processMessageStreamAction?.(messageId, streamMessage, traceId, requestId, undefined, {
                            singleInstrumentationId: messageId
                        });
                    } else sendAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'suppressed',
                            actionSubject: 'streamActionPart',
                            actionSubjectId: 'reconnectReplay',
                            source: 'reconnectToInProgressStreamProvider',
                            attributes: {
                                messageId: messageId,
                                conversationId: conversationId,
                                reason: 'replay',
                                key: (0, $bxkJA.isStreamActionPart)(streamMessage) ? streamMessage.message?.key : 'prepare'
                            }
                        }
                    });
                } else processMessageStreamAction?.(messageId, streamMessage, traceId, requestId, undefined, {
                    singleInstrumentationId: messageId
                });
            }
            if ((0, $bxkJA.isStreamActionComplete)(streamMessage) && (0, $iDrrr.fg)('aifc_create_enabled')) {
                const actionMessage = streamMessage.message;
                setMessages(conversationId, [
                    ...getMessages(conversationId),
                    {
                        type: 'ACTION_COMPLETE',
                        action: actionMessage
                    }
                ]);
                // Gated behind aifc_fix_reconnect_stream_overlap so rollback is safe.
                if ((0, $iDrrr.fg)('aifc_fix_reconnect_stream_overlap')) {
                    if (!getIsReplaying?.()) processMessageStreamComplete?.(messageId, streamMessage, traceId, requestId, {
                        singleInstrumentationId: messageId
                    });
                    else sendAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'suppressed',
                            actionSubject: 'streamActionComplete',
                            actionSubjectId: 'reconnectReplay',
                            source: 'reconnectToInProgressStreamProvider',
                            attributes: {
                                messageId: messageId,
                                conversationId: conversationId,
                                reason: 'replay',
                                key: actionMessage?.key
                            }
                        }
                    });
                } else processMessageStreamComplete?.(messageId, streamMessage, traceId, requestId, {
                    singleInstrumentationId: messageId
                });
            }
            if ((0, $bxkJA.isStreamActionClassification)(streamMessage) && (0, $iDrrr.fg)('aifc_create_enabled')) {
                if ((0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics')) // Only call during live phase. If ACTION_CLASSIFICATION arrives during
                // replay it means the editor already received it before disconnect.
                {
                    if (!getIsReplaying?.()) processMessageStreamActionClassification?.(messageId, streamMessage, traceId, requestId, {
                        singleInstrumentationId: messageId
                    });
                }
            }
            /**
       * FINAL_RESPONSE processing
       */ if ((0, $bxkJA.isStreamResponse)(streamMessage)) {
                hasReceivedFinalResponse = true;
                onFinalResponse?.();
                const humanMessageId = streamMessage?.message?.human_message?.id.toString();
                const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = (0, $8GeCh.processStreamResponseMarkdown)({
                    streamMessage: streamMessage,
                    messageId: messageId,
                    conversationId: conversationId,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    shouldPreprocessDetails: shouldPreprocessDetails
                });
                setMessages(conversationId, (0, $fA89f.replaceAnswerData)({
                    chat: getMessages(conversationId),
                    answerId: messageId,
                    content: processedStreamMessage,
                    useIndex: answerIndex,
                    humanMessageId: humanMessageId,
                    markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined
                }));
                // Update the StoreHuman entry's ID from the temporary client-generated ID
                // to the real server-assigned ID. After a page reload this is a no-op because
                // the store already contains the real ID.
                if (humanMessageId) {
                    const currentHumanMessageId = (0, $k1kN6.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
                    if (currentHumanMessageId && currentHumanMessageId !== humanMessageId) setMessages(conversationId, (0, $dnZkY.updateHumanMessageId)({
                        chat: getMessages(conversationId),
                        oldId: currentHumanMessageId,
                        newId: humanMessageId,
                        onMessageIdChanged: (oldId, newId)=>onHumanMessageIdReplaced?.(conversationId, oldId, newId)
                    }));
                }
            }
            /**
       * Follow up processing
       */ if ((0, $bxkJA.isFollowUpMessage)(streamMessage)) {
                const messages = getMessages(conversationId);
                const originatingAssistant = [
                    ...messages
                ].reverse().find((0, $igOtY.isStoreAssistant));
                const originatingAgentIdentity = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') && originatingAssistant ? (0, $foVqg.deriveFollowUpSendAgentIdentity)(originatingAssistant) : undefined;
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $hMXhO.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'FOLLOW_UP',
                        content: streamMessage,
                        id: (0, $eMs38.randomIntFromInterval)(0, 1000000),
                        agentMessageId: (0, $3Cuhs.getLastAgentMessageID)(messages),
                        ...originatingAgentIdentity ? {
                            originatingAgentIdentity: originatingAgentIdentity
                        } : {}
                    }
                ]);
            }
            /**
       * Action error processing
       */ if ((0, $bxkJA.isStreamActionError)(streamMessage)) {
                // Producers disagree on where the error text lives, so telemetry probes each known
                // location. Displayed copy keeps the original source so users see the same string.
                const actionError = new (0, $hwHCO.StreamErrorException)(streamMessage.message?.data?.message || (0, $awqa1.ACTION_EXECUTION_FAILED), {
                    detail: {
                        message: {
                            content: streamMessage.message?.data?.message || streamMessage.message?.data?.content || streamMessage.message?.content || (0, $awqa1.ACTION_EXECUTION_FAILED),
                            message_template: streamMessage?.message?.key
                        },
                        metadata: {
                            ...streamMessage.metadata,
                            isStagingArea: isStagingArea
                        }
                    },
                    traceId: traceId
                });
                throw actionError;
            }
            if ((0, $bxkJA.isStreamError)(streamMessage)) {
                onStreamEvent('error', streamMessage, streamObj.id);
                const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                throw new (0, $hwHCO.StreamErrorException)(message?.content || 'Unknown', {
                    detail: {
                        message: message,
                        metadata: metadata,
                        millisOffset: millisOffset,
                        type: type
                    },
                    traceId: traceId
                });
            }
        }
        // Drain any remaining buffered chunks and clear the periodic timer.
        //cancelReasoningFlush();
        onStreamEnd?.();
    } catch (error) {
        if (error instanceof (0, $hwHCO.StreamErrorException)) throw error;
        // Let timeout errors propagate unwrapped so the outer catch can handle them correctly.
        if (error instanceof (0, $b6N3q.RovoChatStreamTimeoutError)) throw error;
        throw new (0, $bQxqB.StreamGeneratorError)((error instanceof Error ? error.message : undefined) ?? 'Stream generator error', {
            traceId: traceId,
            detail: {
                millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                type: latestStreamMessage?.type ?? ''
            }
        }, error);
    }
    return {
        hasReceivedFinalResponse: hasReceivedFinalResponse
    };
};
module.exports["processReconnectStreamMessage"] = $2b1590a070c92522$export$f74ad34bb7f49ad1;

});

parcelRegister("8DP4b", function(module, exports) {
const $21db7e5b2ba4fca2$export$6f349e5fd508c97f = (onMergedEvent)=>{
    const buffers = new Map();
    const bufferEvent = (event)=>{
        const stepId = event.message.stepId;
        if (!stepId) return false;
        const existing = buffers.get(stepId);
        if (existing) {
            existing.chunks.push(event.message.content);
            existing.lastEvent = event;
        } else buffers.set(stepId, {
            chunks: [
                event.message.content
            ],
            lastEvent: event
        });
        return true;
    };
    const flush = ()=>{
        if (buffers.size === 0) return;
        // Snapshot + clear before invoking the callback so re-entrant flushes are safe.
        const entries = Array.from(buffers.entries());
        buffers.clear();
        for (const [, { chunks: chunks, lastEvent: lastEvent }] of entries)onMergedEvent({
            ...lastEvent,
            message: {
                ...lastEvent.message,
                content: chunks.join('')
            }
        });
    };
    const flushFiltered = (predicate)=>{
        if (buffers.size === 0) return;
        // Snapshot + clear before invoking the callback so re-entrant flushes are safe.
        const entries = Array.from(buffers.entries());
        buffers.clear();
        for (const [stepId, { chunks: chunks, lastEvent: lastEvent }] of entries){
            if (!predicate(stepId)) continue;
            onMergedEvent({
                ...lastEvent,
                message: {
                    ...lastEvent.message,
                    content: chunks.join('')
                }
            });
        }
    };
    return {
        bufferEvent: bufferEvent,
        flush: flush,
        flushFiltered: flushFiltered,
        size: ()=>buffers.size
    };
};
module.exports["createReasoningChunkBuffer"] = $21db7e5b2ba4fca2$export$6f349e5fd508c97f;

});

parcelRegister("2DW0Q", function(module, exports) {

var $bxkJA = parcelRequire("bxkJA");

function $64525561cf381ad0$export$76ef465f684cfb18({ conversationId: conversationId, reconnectTimestamp: reconnectTimestamp, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, updateCurrentConversation: updateCurrentConversation, onFlush: onFlush }) {
    // Lazily initialised on first setMessages write — avoids copying the full
    // messages array upfront when multiple tabs reconnect simultaneously.
    // replayBuffering=true + replayBuffer=null → buffering, no write yet
    // replayBuffering=false + replayBuffer=null → flushed
    let replayBuffer = null;
    let replayBuffering = true;
    // Pre-seeded with { traces: [] } so flush always clears "Resuming response..."
    // even if no clearTracesIfNotEmpty call fires during replay.
    // null means flushed.
    let conversationPatch = {
        traces: []
    };
    // null means flushed.
    let researchQueue = [];
    // Per-step tracking for reconnect replay. Keyed by stepId.
    // stepTitleEvents: first STEP_TITLE seen (provides title + roundId).
    // stepCompletedEvents: last STEP_COMPLETED seen (marks step done).
    // Used by getCollapsedStepEvents() and getCompletedStepIds().
    const stepTitleEvents = new Map();
    const stepCompletedEvents = new Map();
    const trackStepEvent = (params)=>{
        const msg = params.streamMessage;
        if ((0, $bxkJA.isStreamResearchStepTitle)(msg) || (0, $bxkJA.isStreamResearchStepTitleShort)(msg)) {
            if (!stepTitleEvents.has(msg.message.stepId)) stepTitleEvents.set(msg.message.stepId, params);
        } else if ((0, $bxkJA.isStreamResearchStepCompleted)(msg)) stepCompletedEvents.set(msg.message.stepId, params);
    };
    const getCollapsedStepEvents = ()=>{
        const result = [];
        const allStepIds = new Set([
            ...Array.from(stepTitleEvents.keys()),
            ...Array.from(stepCompletedEvents.keys())
        ]);
        allStepIds.forEach((stepId)=>{
            const titleEvent = stepTitleEvents.get(stepId);
            const completedEvent = stepCompletedEvents.get(stepId);
            if (titleEvent) result.push(titleEvent);
            if (completedEvent) result.push(completedEvent);
        });
        return result;
    };
    const isBuffering = ()=>replayBuffering;
    const parseEventTime = (id)=>Number(id.split('-')[0]);
    const flush = ()=>{
        if (!isBuffering()) return;
        const buffered = replayBuffer;
        const patch = conversationPatch;
        const queued = researchQueue;
        // Mark flushed before dispatching so re-entrant calls go live.
        replayBuffering = false;
        replayBuffer = null;
        conversationPatch = null;
        researchQueue = null;
        if (buffered !== null) setMessages(conversationId, buffered);
        if (patch !== null) updateCurrentConversation(patch);
        // onFlush runs BEFORE the queued research dispatch so caller-side
        // buffers (e.g. reasoning chunks) populate step content first; the
        // collapse signals (ANSWER_PART, FINAL_RESPONSE) then fire on
        // already-populated steps, matching the source event order.
        onFlush?.();
        // react-sweet-state setState is synchronous — the research store reaches
        // its final state before React re-renders, giving one render with
        // researchCompleted=true and skipping intermediate spinner states.
        queued.forEach((params)=>processStreamResearch(params));
    };
    const batchedSetMessages = (convId, msgs)=>{
        if (replayBuffering && convId === conversationId) {
            replayBuffer = msgs;
            return;
        }
        setMessages(convId, msgs);
    };
    const batchedGetMessages = (convId)=>{
        if (replayBuffering && convId === conversationId) // Fall through to real store if no write has arrived yet.
        return replayBuffer ?? getMessages(convId);
        return getMessages(convId);
    };
    const batchedUpdateCurrentConversation = (patch)=>{
        if (conversationPatch !== null) {
            conversationPatch = {
                ...conversationPatch,
                ...patch
            };
            return;
        }
        updateCurrentConversation(patch);
    };
    const batchedProcessStreamResearch = (params)=>{
        if (researchQueue !== null) {
            if ((0, $bxkJA.isStreamResponse)(params.streamMessage)) {
                // Preserve ANSWER_PART if already queued so both hasReceivedAnswerPart
                // and researchCompleted are set at flush.
                const hasAnswerPart = researchQueue.some((p)=>(0, $bxkJA.isStreamAnswerPart)(p.streamMessage));
                researchQueue = hasAnswerPart ? [
                    ...researchQueue,
                    params
                ] : [
                    params
                ];
                return;
            }
            if ((0, $bxkJA.isStreamAnswerPart)(params.streamMessage)) {
                // Collapse to [STEP_TITLE, STEP_COMPLETED per step, ANSWER_PART] so
                // past rounds have steps in the store after flush — prevents "Rovo is
                // thinking" for completed rounds during mid-stream reload.
                researchQueue = [
                    ...getCollapsedStepEvents(),
                    params
                ];
                return;
            }
            trackStepEvent(params);
            researchQueue.push(params);
            return;
        }
        processStreamResearch(params);
    };
    async function* replayFlushGenerator(source) {
        let replayEventCount = 0;
        for await (const chunk of source){
            if (isBuffering() && chunk.id) {
                const eventTime = parseEventTime(chunk.id);
                if (!isNaN(eventTime) && eventTime >= reconnectTimestamp) flush();
            }
            // During replay, yield the event loop periodically to prevent the tab
            // from becoming unresponsive when processing large streams (e.g. 6K+ events).
            // This gives the browser a chance to handle user interactions and GC between batches.
            if (isBuffering()) {
                replayEventCount++;
                if (replayEventCount % 200 === 0) await new Promise((resolve)=>setTimeout(resolve, 0));
            }
            yield chunk;
        }
        // Stream ended while still in replay (response was complete on reconnect).
        flush();
    }
    return {
        wrapGenerator: replayFlushGenerator,
        batchedSetMessages: batchedSetMessages,
        batchedGetMessages: batchedGetMessages,
        batchedProcessStreamResearch: batchedProcessStreamResearch,
        batchedUpdateCurrentConversation: batchedUpdateCurrentConversation,
        getIsReplaying: isBuffering,
        getCompletedStepIds: ()=>new Set(stepCompletedEvents.keys())
    };
}
module.exports["withReplayFlush"] = $64525561cf381ad0$export$76ef465f684cfb18;

});

parcelRegister("kFcQO", function(module, exports) {
/**
 * The subset of @atlassian/conversation-assistant's SkillAttributes this package needs. Declared
 * locally (structurally compatible, not imported) to avoid a circular dependency, since
 * conversation-assistant depends on this package.
 */ const $23c21d37ccaaaaef$export$c32d31d35ce1fec4 = (skillsInvoked, pluginsInvoked, agentExternalConfigReference)=>[
        ...agentExternalConfigReference ? [
            agentExternalConfigReference
        ] : [],
        ...skillsInvoked.flatMap((skill)=>[
                skill.skillName,
                skill.minionId
            ].filter((value)=>Boolean(value))),
        ...Array.from(pluginsInvoked)
    ];
module.exports["getMciKrIdentifiersFromSkillsAndPlugins"] = $23c21d37ccaaaaef$export$c32d31d35ce1fec4;

});

parcelRegister("4O6Ds", function(module, exports) {

var $gDq7w = parcelRequire("gDq7w");

const $b313767b9a7bfd23$export$ec108b5b49e81171 = 'add_mci_kr_attributes_to_rovo_chat_analytics';
const $b313767b9a7bfd23$var$MCI_KR_SERVICE_OPS_CONFIG_ENTRIES = Object.entries((0, $gDq7w.MCI_KR_SERVICE_OPS_CONFIG));
const $b313767b9a7bfd23$export$98364b1a3d8542af = (identifiers)=>{
    const matchedEntries = identifiers.flatMap((identifier)=>$b313767b9a7bfd23$var$MCI_KR_SERVICE_OPS_CONFIG_ENTRIES.filter(([key])=>identifier.includes(key)).map(([, entry])=>entry));
    if (matchedEntries.length === 0) return {};
    return {
        ...matchedEntries.some((entry)=>entry.countsTowardMciPlusKr) && {
            eligible_for_mci_plus_kr: 1
        },
        ...matchedEntries.some((entry)=>entry.countsTowardAiAdoptedKr) && {
            eligible_for_ai_adopted_kr: 1
        },
        service_or_ops: matchedEntries[0].serviceOrOps
    };
};
module.exports["mciKrAttributes"] = $b313767b9a7bfd23$export$98364b1a3d8542af;

});

parcelRegister("gFYIV", function(module, exports) {
const $2dbdac089e2a67e6$export$72bdd99dfc759d06 = (baseName, { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, isRovoCustomAgent: isRovoCustomAgent })=>{
    if (isRovoCustomAgent) return `${baseName}.rovo-custom-agent`;
    if (deepResearchEnabled) return `${baseName}.deep-research`;
    if (thinkDeeperEnabled) return `${baseName}.think-deeper`;
    return baseName;
};
module.exports["getMessageMetricsNameWithParams"] = $2dbdac089e2a67e6$export$72bdd99dfc759d06;

});

parcelRegister("iRmkX", function(module, exports) {
const $74367cc14df82300$export$8567b8b6b4d41b2f = (state, conversationId)=>state.conversations[conversationId]?.traces ?? [];
module.exports["getConversationTraces"] = $74367cc14df82300$export$8567b8b6b4d41b2f;

});

parcelRegister("cqGOy", function(module, exports) {
// Used to generate a unique `singleInstrumentationID` for tracking Question & Answer pairings
// before a response has been received from the server
const $2910c05405c27146$export$25a2389a84d1a0a0 = (timeStamp, conversationId)=>{
    // More detail on djb2 hash function https://theartincode.stanis.me/008-djb2/
    let hash = 5381;
    if (!timeStamp || !conversationId) return hash;
    const concat = conversationId + timeStamp;
    for(let i = 0; i < concat.length; i++)// Update the hash value
    hash = (hash << 5) + hash + concat.charCodeAt(i); // hash * 33 + c
    // Ensure the hash is a positive integer
    return hash >>> 0;
};
module.exports["djb2Hash"] = $2910c05405c27146$export$25a2389a84d1a0a0;

});

parcelRegister("iWbNp", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");

const $cbc2db2fdddff710$export$a9ffe3cc687b4144 = (experienceTracker, reason, attributes)=>{
    [
        (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
        (0, $irnO2.ExperienceName).AIFC_MESSAGE
    ].forEach((experienceName)=>{
        experienceTracker.abort({
            name: experienceName,
            reason: reason,
            attributes: attributes
        });
    });
};
module.exports["abortGenerateContentChildExperiences"] = $cbc2db2fdddff710$export$a9ffe3cc687b4144;

});

parcelRegister("9BBUU", function(module, exports) {
const $08fd19559950f700$export$a70b98ad4be3bac5 = (experienceTracker, experienceName, actionClassificationInvocationIds, actionCompleteInvocationIds, isBackendCreationRequest)=>{
    const actionClassificationCount = actionClassificationInvocationIds.size;
    const actionCompleteCount = actionCompleteInvocationIds.size;
    const attributes = {
        isBackendCreationRequest: isBackendCreationRequest,
        actionClassificationCount: actionClassificationCount,
        actionCompleteCount: actionCompleteCount
    };
    // Matches our condition for abortGenerateContentChildExperiences elsewhere, for callers that don't fallthrough
    // This gives us an explicit abort rather than a timeout
    if (actionClassificationCount > 0 && actionCompleteCount === 0) {
        experienceTracker.abort({
            name: experienceName,
            reason: 'stream_completed_without_action_complete',
            attributes: attributes
        });
        return;
    }
    if (!isBackendCreationRequest || // Not all FE requests provide action_classification, so a single complete is sufficient
    actionClassificationCount === actionCompleteCount && [
        ...actionClassificationInvocationIds
    ].every((invocationId)=>actionCompleteInvocationIds.has(invocationId))) experienceTracker.succeed({
        name: experienceName,
        attributes: attributes
    });
    else {
        const missingCompletionCount = [
            ...actionClassificationInvocationIds
        ].filter((invocationId)=>!actionCompleteInvocationIds.has(invocationId)).length;
        const unexpectedCompletionCount = [
            ...actionCompleteInvocationIds
        ].filter((invocationId)=>!actionClassificationInvocationIds.has(invocationId)).length;
        experienceTracker.fail({
            name: experienceName,
            attributes: attributes,
            error: new Error(`Action completion invocation IDs did not match classifications (${missingCompletionCount} missing, ${unexpectedCompletionCount} unexpected)`)
        });
    }
};
module.exports["completeAifcActionExperience"] = $08fd19559950f700$export$a70b98ad4be3bac5;

});

parcelRegister("cv4dJ", function(module, exports) {

var $bkEBw = parcelRequire("bkEBw");


var $fMCXf = parcelRequire("fMCXf");

const $72779d19b192aa52$export$6e5609c05ab74cc7 = ({ chat: chat, answerId: answerId, answerPart: answerPart, useIndex: useIndex })=>(0, $fMCXf.updateStoreAssistant)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $bkEBw.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                }
            }),
        updateType: 'Add Answer Part',
        useIndex: useIndex
    });
module.exports["addAnswerPart"] = $72779d19b192aa52$export$6e5609c05ab74cc7;

});

parcelRegister("ayOmn", function(module, exports) {

var $bkEBw = parcelRequire("bkEBw");


var $fMCXf = parcelRequire("fMCXf");

const $ccf4709cceff6c1f$export$679615d953ba31c3 = ({ chat: chat, answerId: answerId, answerPart: answerPart, markdownData: markdownData, useIndex: useIndex })=>{
    return (0, $fMCXf.updateStoreAssistant)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>{
            const updatedMarkdownData = Object.entries(markdownData).reduce((acc, [key, { content: content, loading: loading }])=>{
                const loadingKey = `${key}-loading`;
                return {
                    ...acc,
                    [key]: (acc[key] || '') + content,
                    [loadingKey]: loading ? 'true' : 'false'
                };
            }, {
                ...storeAssistant.markdownData
            });
            return {
                ...storeAssistant,
                content: {
                    ...(0, $bkEBw.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                },
                markdownData: updatedMarkdownData
            };
        },
        updateType: 'Add Answer Part With Markdown Data',
        useIndex: useIndex
    });
};
module.exports["addAnswerPartWithMarkdownDataMap"] = $ccf4709cceff6c1f$export$679615d953ba31c3;

});

parcelRegister("aPDnZ", function(module, exports) {

var $fMCXf = parcelRequire("fMCXf");

const $35f48597532147ec$export$e3f334fc6effa531 = ({ chat: chat, answerId: answerId, useIndex: useIndex, memory: memory })=>(0, $fMCXf.updateStoreAssistant)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                memory: memory
            }),
        updateType: 'Add memory',
        useIndex: useIndex
    });
module.exports["addMemorytoLatestAssistantMessage"] = $35f48597532147ec$export$e3f334fc6effa531;

});

parcelRegister("fCT7n", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $2g97a = parcelRequire("2g97a");

const $8ebe5aac085e0e04$export$1cdaa2c4089128bd = (chat, requestId)=>{
    const lastHumanMessage = (0, $2g97a.findLast)(chat, (0, $igOtY.isStoreHuman));
    // Skip if there is no last human message or if the requestId is already set
    if (!lastHumanMessage || !requestId || !!lastHumanMessage.content.requestId) return chat;
    const newHumanMessage = {
        ...lastHumanMessage,
        content: {
            ...lastHumanMessage.content,
            requestId: requestId
        }
    };
    const newChat = [
        ...chat
    ];
    newChat[newChat.lastIndexOf(lastHumanMessage)] = newHumanMessage;
    return newChat;
};
module.exports["addRequestIdToLatestHumanMessage"] = $8ebe5aac085e0e04$export$1cdaa2c4089128bd;

});

parcelRegister("chBow", function(module, exports) {

var $gulpi = parcelRequire("gulpi");


var $5tsq8 = parcelRequire("5tsq8");

function $4effe361fadab1cf$export$c2722b1ddbddcce5(messages, streamFollowUp, productKey, isSmartCreationModalOpen = false) {
    if (!(0, $5tsq8.shouldAppendCreatePageFollowUp)(messages, productKey, isSmartCreationModalOpen)) return streamFollowUp;
    const existingFollowUps = streamFollowUp.message.follow_ups ?? [];
    if (existingFollowUps.some((f)=>f.text === (0, $gulpi.CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT))) return streamFollowUp;
    return {
        ...streamFollowUp,
        message: {
            ...streamFollowUp.message,
            follow_ups: [
                ...existingFollowUps,
                {
                    type: 'SYNTHETIC',
                    text: (0, $gulpi.CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT)
                }
            ]
        }
    };
}
module.exports["appendCreatePageFollowUpIfNeeded"] = $4effe361fadab1cf$export$c2722b1ddbddcce5;

});

parcelRegister("6CHtN", function(module, exports) {

var $fMCXf = parcelRequire("fMCXf");

const $9153b4ac17989006$export$94b1b79dc7d56f27 = ({ chat: chat, answerId: answerId, entityAnnotationBatch: entityAnnotationBatch })=>(0, $fMCXf.updateStoreAssistant)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                entityAnnotationBatches: [
                    ...storeAssistant.entityAnnotationBatches ?? [],
                    entityAnnotationBatch
                ]
            }),
        updateType: 'Append Entity Annotation Batch'
    });
module.exports["appendEntityAnnotationBatch"] = $9153b4ac17989006$export$94b1b79dc7d56f27;

});

parcelRegister("dh2SO", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $fjUOt = parcelRequire("fjUOt");


var $fS02I = parcelRequire("fS02I");

const $7e78f67f943224e0$export$ed23852026f99b3a = (conversationId, messageId, getMessages, setMessages)=>{
    const currentMessages = getMessages(conversationId);
    const assistantMessage = currentMessages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && (0, $fjUOt.getStoreMessageId)(msg) === messageId);
    if (assistantMessage && 'answerNowStatus' in assistantMessage && assistantMessage.answerNowStatus) setMessages(conversationId, (0, $fS02I.updateStoreAssistantMessageAnswerNowStatus)(currentMessages, messageId, undefined));
};
module.exports["clearAnswerNowStatusForMessageIfSet"] = $7e78f67f943224e0$export$ed23852026f99b3a;

});

parcelRegister("kA5zM", function(module, exports) {
const $e2cd33d1e2c5839a$export$23f1f8f522f4bdd = (config)=>{
    let armed = false;
    let firstChunkArrived = false;
    let timer;
    let stallCount = 0;
    const clearTimer = ()=>{
        if (timer !== undefined) {
            clearTimeout(timer);
            timer = undefined;
        }
    };
    const schedule = (stage)=>{
        clearTimer();
        const timeoutMs = config.baseMs;
        timer = setTimeout(()=>{
            stallCount += 1;
            config.sendAnalyticsEvent({
                eventType: 'track',
                action: 'timeout',
                actionSubject: 'rovoChatStream',
                attributes: {
                    stallCount: stallCount,
                    stage: stage,
                    timeoutMs: timeoutMs
                }
            });
            // Keep armed so we continue to detect subsequent stalls until chunks resume
            schedule('betweenChunks');
        }, timeoutMs);
    };
    return {
        arm: ()=>{
            if (armed) return;
            armed = true;
            // Start pre-first-chunk watchdog waiting for the first stream event
            schedule('newResponse');
        },
        onChunk: ()=>{
            if (!armed) return;
            if (firstChunkArrived === false) {
                firstChunkArrived = true;
                // After the first chunk, schedule timeout waiting for the next event
                schedule('firstGap');
                return;
            }
            // For subsequent chunks, re-arm the between-chunks watchdog
            schedule('betweenChunks');
        },
        stop: ()=>{
            clearTimer();
            armed = false;
        }
    };
};
module.exports["createBetweenChunksInactivityLogger"] = $e2cd33d1e2c5839a$export$23f1f8f522f4bdd;

});

parcelRegister("lXC3X", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $bxkJA = parcelRequire("bxkJA");


var $gibzw = parcelRequire("gibzw");


var $ijGER = parcelRequire("ijGER");

const $b5a6b627405136a2$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED = 'chat-unmounted';
function $b5a6b627405136a2$export$29bad1ab941da7cb({ generator: generator, conversationId: conversationId, abortController: abortController, assistanceService: assistanceService, sendAnalyticsEvent: sendAnalyticsEvent, experienceTracker: experienceTracker, getMessageId: getMessageId, canReconnect: canReconnect, updateCurrentConversation: updateCurrentConversation, getIsChatMounted: getIsChatMounted, analyticsAttributes: analyticsAttributes, onBeforeFirstReconnect: callerOnBeforeFirstReconnect, onReconnecting: callerOnReconnecting, onReconnected: callerOnReconnected, onFirstChunkAfterReconnect: callerOnFirstChunkAfterReconnect }) {
    let totalAttempts = 0;
    let perfMetrics;
    return (0, $gibzw.createReconnectableStream)({
        initialGenerator: generator,
        canReconnect: ()=>!!getMessageId() && canReconnect(),
        getReconnectGenerator: (lastEventId)=>{
            const messageId = getMessageId();
            if (!messageId) return Promise.reject(new Error('Cannot reconnect: messageId is not available'));
            return assistanceService.reconnectToMessageStream({
                conversationId: conversationId,
                messageId: messageId,
                lastEventId: lastEventId,
                controller: abortController
            }).then((r)=>r.generator);
        },
        getEventId: (chunk)=>(0, $bxkJA.isSSEMessage)(chunk) && chunk.id ? chunk.id : undefined,
        onBeforeFirstReconnect: ()=>{
            perfMetrics = (0, $ijGER.createReconnectionMetrics)({
                isDeepResearchEnabled: analyticsAttributes?.isDeepResearch,
                thinkDeeperEnabled: analyticsAttributes?.thinkDeeperEnabled,
                fastModeEnabled: analyticsAttributes?.fastModeEnabled
            });
            perfMetrics.timeToConnectToStreamMetrics.start();
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                id: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                attributes: {
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    ...analyticsAttributes
                }
            });
            callerOnBeforeFirstReconnect?.();
        },
        onReconnecting: (attempt, maxAttempts, lastEventId)=>{
            totalAttempts = attempt;
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'retrying',
                actionSubject: 'rovoChatReconnection',
                attributes: {
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    attempt: attempt,
                    maxAttempts: maxAttempts,
                    hasLastEventId: !!lastEventId,
                    ...analyticsAttributes
                }
            });
            updateCurrentConversation({
                traces: [
                    {
                        messageContent: `Connection lost. Retrying... (${attempt}/${maxAttempts})`,
                        status: 'loading'
                    }
                ]
            });
            callerOnReconnecting?.(attempt, maxAttempts);
        },
        onReconnected: ()=>{
            perfMetrics?.timeToConnectToStreamMetrics.stop();
            perfMetrics?.timeToResumeStreamMetrics.start();
            callerOnReconnected?.();
        },
        onFirstChunkAfterReconnect: ()=>{
            perfMetrics?.timeToResumeStreamMetrics.stop();
            callerOnFirstChunkAfterReconnect?.();
        },
        onStreamCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                attributes: {
                    totalAttempts: totalAttempts,
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    ...analyticsAttributes
                }
            });
        },
        onStreamFailed: (error)=>{
            perfMetrics?.timeToConnectToStreamMetrics.cancel();
            perfMetrics?.timeToResumeStreamMetrics.cancel();
            if (error instanceof Error && error.name === 'AbortError' || abortController.signal.aborted) experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                reason: 'Aborted'
            });
            else experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                error: error instanceof Error ? error : new Error(String(error)),
                attributes: {
                    totalAttempts: totalAttempts,
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    ...analyticsAttributes
                }
            });
        },
        shouldContinueRetrying: getIsChatMounted ? ()=>{
            if (!getIsChatMounted()) {
                abortController.abort($b5a6b627405136a2$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED);
                return false;
            }
            return true;
        } : undefined,
        signal: abortController.signal
    });
}
module.exports["createChatReconnectableStream"] = $b5a6b627405136a2$export$29bad1ab941da7cb;

});

parcelRegister("6WeLa", function(module, exports) {

var $l5TuZ = parcelRequire("l5TuZ");


var $f3OgL = parcelRequire("f3OgL");


var $7MYAM = parcelRequire("7MYAM");

const $94689fb12cc6f471$export$95c0abd604a2cca2 = (options)=>{
    // handles multiple tags in a single chunk (e.g. close tag + new open tag)
    // Returns markdownData as a MarkdownDataMap (keyed by component instance).
    const processor = (0, $f3OgL.createMarkdownProcessorMultiTags)((0, $7MYAM.getStreamableComponents));
    // Optional <details>/<summary> rewriter that runs upstream of the
    // multi-tag extractor so the existing `▞…▚` boundary-driven `expand`
    // component picks them up. See createStreamMarkdownProcessor.
    const detailsPreprocessor = options?.shouldPreprocessDetails ? (0, $l5TuZ.createDetailsPreprocessor)() : null;
    return (streamMessage)=>{
        const messageContent = streamMessage.message.content;
        const text = typeof messageContent === 'string' ? messageContent : '';
        const preprocessedText = detailsPreprocessor ? detailsPreprocessor.process(text) : text;
        const { processedText: processedText, markdownData: markdownData } = processor(preprocessedText);
        streamMessage.message.content = processedText;
        return {
            processedStreamMessage: streamMessage,
            markdownData: markdownData
        };
    };
};
module.exports["createStreamMarkdownMultiTagProcessor"] = $94689fb12cc6f471$export$95c0abd604a2cca2;

});

parcelRegister("3cJKb", function(module, exports) {

var $gulpi = parcelRequire("gulpi");

function $3bd4037c0469b685$export$b323db724925d16f() {
    return {
        type: 'FOLLOW_UP_QUERIES',
        message: {
            follow_ups: [
                {
                    type: 'SYNTHETIC',
                    text: (0, $gulpi.CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT)
                }
            ]
        },
        millisOffset: 0
    };
}
module.exports["createSyntheticCreatePageFollowUp"] = $3bd4037c0469b685$export$b323db724925d16f;

});

parcelRegister("7nZb0", function(module, exports) {

var $bxkJA = parcelRequire("bxkJA");


var $6KQVM = parcelRequire("6KQVM");


var $cWJWG = parcelRequire("cWJWG");

const $6895c59b08828bb0$export$4a48e8ee48123078 = (config)=>{
    let previousMessageTimestamp = performance.now();
    let previousMessageTemplate;
    let previousMessageType;
    let maxDeadAirMs = 0;
    let totalDeadAirMs = 0;
    let maxPreviousMessageTemplate;
    let maxCurrentMessageTemplate;
    let maxPreviousMessageType;
    let maxCurrentMessageType;
    let deadAirIntervalsMs = [];
    const shouldIgnoreMessage = (message)=>{
        return (0, $bxkJA.isConversationChannelDataMessage)(message) || (0, $bxkJA.isStreamHeartbeat)(message);
    };
    const shouldCountMessage = (message)=>{
        return (0, $bxkJA.isStreamResearchPayload)(message) || (0, $bxkJA.isStreamResearchPlan)(message) || (0, $bxkJA.isStreamTrace)(message) || (0, $bxkJA.isStreamThinkDeeperTriggered)(message) || (0, $bxkJA.isStreamAnswerPart)(message) || (0, $bxkJA.isStreamReasoningPart)(message) || (0, $bxkJA.isStreamActionPart)(message) || (0, $bxkJA.isStreamResponse)(message) || (0, $bxkJA.isFollowUpMessage)(message) || (0, $bxkJA.isStreamActionClassification)(message) || (0, $bxkJA.isStreamActionPrepare)(message) || (0, $bxkJA.isStreamActionComplete)(message) || (0, $bxkJA.isStreamActionError)(message) || (0, $bxkJA.isStreamError)(message) || (0, $bxkJA.isStreamTodoSnapshot)(message);
    };
    const getMessageTemplate = (message)=>{
        const nestedMessage = 'message' in message ? message.message : undefined;
        return nestedMessage && 'message_template' in nestedMessage ? nestedMessage.message_template : undefined;
    };
    const commonMetadata = {
        messageId: config.messageId,
        conversationId: config.conversationId,
        traceId: config.traceId,
        productKey: config.productKey,
        isExplicitDeepResearchEnabled: config.deepResearchEnabled,
        isExplicitThinkDeeperEnabled: config.thinkDeeperEnabled,
        isExplicitFastModeEnabled: config.fastModeEnabled,
        isWebSearchEnabled: config.webSearchEnabled,
        isAIFC: config.isAIFC,
        isExplicitThinkFasterEnabled: false,
        isImplicitThinkDeeper: false,
        hasSwitchedToFastThinking: false
    };
    const trackDeadAir = (deadAirMs, previousTemplate, currentTemplate, previousType, currentType)=>{
        const intervalMetric = (0, $6KQVM.deadAirMetrics).createDeadAirIntervalMetrics();
        const now = performance.now();
        intervalMetric.start({
            startTime: now - deadAirMs
        });
        intervalMetric.stop({
            stopTime: now,
            customData: {
                ...commonMetadata,
                previousMessageTemplate: previousTemplate ?? '',
                messageTemplate: currentTemplate ?? '',
                previousMessageType: previousType ?? '',
                messageType: currentType ?? ''
            }
        });
        totalDeadAirMs += deadAirMs;
        deadAirIntervalsMs.push(Math.round(deadAirMs)); // integer ms is enough accuray
        if (deadAirMs > maxDeadAirMs) {
            maxDeadAirMs = deadAirMs;
            maxPreviousMessageTemplate = previousTemplate;
            maxCurrentMessageTemplate = currentTemplate;
            maxPreviousMessageType = previousType;
            maxCurrentMessageType = currentType;
        }
    };
    const update = (streamMessage)=>{
        if (shouldIgnoreMessage(streamMessage)) return;
        if (!shouldCountMessage(streamMessage)) {
            config.sendAnalyticsEvent({
                eventType: 'operational',
                action: 'unrecognized',
                actionSubject: 'deadAirTrackerMessage',
                attributes: {
                    messageType: streamMessage.type ?? 'unknown',
                    messageTemplate: getMessageTemplate(streamMessage) ?? 'unknown',
                    conversationId: config.conversationId,
                    traceId: config.traceId
                }
            });
            return;
        }
        const currentTimestamp = performance.now();
        const currentTemplate = getMessageTemplate(streamMessage);
        if (currentTemplate === 'THINK_DEEPER_TRIGGERED') commonMetadata.isImplicitThinkDeeper = true;
        const currentMessageType = streamMessage.type;
        // Skip consecutive streaming messages (continuous token/content generation)
        // ANSWER_PART: Standard LLM response tokens
        // REASONING_PART: Think deeper extended reasoning phases (streamed thinking)
        // ACTION_PART: AIFC content generation chunks (whiteboards, documents, etc.)
        const isConsecutiveAnswerPart = previousMessageType === 'ANSWER_PART' && currentMessageType === 'ANSWER_PART';
        const isConsecutiveReasoningPart = previousMessageType === 'REASONING_PART' && currentMessageType === 'REASONING_PART';
        const isConsecutiveActionPart = previousMessageType === 'ACTION_PART' && currentMessageType === 'ACTION_PART';
        if (isConsecutiveAnswerPart || isConsecutiveReasoningPart || isConsecutiveActionPart) {
            previousMessageTimestamp = currentTimestamp;
            previousMessageTemplate = currentTemplate;
            previousMessageType = currentMessageType;
            return;
        }
        const deadAirMs = currentTimestamp - previousMessageTimestamp;
        // Skip negligible intervals (noise)
        if (!(0, $cWJWG.shouldExcludeInterval)(deadAirMs)) trackDeadAir(deadAirMs, previousMessageTemplate, currentTemplate, previousMessageType, currentMessageType);
        previousMessageTimestamp = currentTimestamp;
        previousMessageTemplate = currentTemplate;
        previousMessageType = currentMessageType;
    };
    const emitMaxDeadAir = ()=>{
        if (maxDeadAirMs === 0) return;
        const maxDeadAirMetric = (0, $6KQVM.deadAirMetrics).createDeadAirMaxMetrics();
        const now = performance.now();
        maxDeadAirMetric.start({
            startTime: now - maxDeadAirMs
        });
        maxDeadAirMetric.stop({
            stopTime: now,
            customData: {
                ...commonMetadata,
                maxDeadAirMs: maxDeadAirMs,
                totalDeadAirMs: Math.round(totalDeadAirMs),
                // integer ms is enough accuray
                deadAirIntervalsMs: JSON.stringify(deadAirIntervalsMs),
                previousMessageTemplate: maxPreviousMessageTemplate ?? '',
                messageTemplate: maxCurrentMessageTemplate ?? '',
                previousMessageType: maxPreviousMessageType ?? '',
                messageType: maxCurrentMessageType ?? ''
            }
        });
    };
    const complete = ()=>{
        emitMaxDeadAir();
    };
    const cancel = ()=>{
        emitMaxDeadAir();
    };
    return {
        update: update,
        complete: complete,
        cancel: cancel,
        resetTimestamp: ()=>{
            previousMessageTimestamp = performance.now();
        }
    };
};
module.exports["createDeadAirTracker"] = $6895c59b08828bb0$export$4a48e8ee48123078;

});

parcelRegister("dxl4c", function(module, exports) {
const $a81109ab453d215f$export$9ac25e0768639c5d = (traces)=>{
    const messages = traces.map((trace)=>trace.messageContent);
    return traces.filter((trace, i)=>messages.lastIndexOf(trace.messageContent) === i);
};
module.exports["dedupeTraceMessagesWithLatest"] = $a81109ab453d215f$export$9ac25e0768639c5d;

});

parcelRegister("1psM9", function(module, exports) {

var $aYC8J = parcelRequire("aYC8J");

const $2a6f93e9fee2ce65$var$WHITEBOARD_ACTION_KEYS = new Set([
    (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY),
    (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY)
]);
const $2a6f93e9fee2ce65$var$DIAGRAM_UI_SUBTYPES = new Set([
    'flowchart',
    'mindmap'
]);
const $2a6f93e9fee2ce65$export$f3b7160b60840213 = (actionKey, source, dynamicUiSubtype)=>{
    if (actionKey && $2a6f93e9fee2ce65$var$WHITEBOARD_ACTION_KEYS.has(actionKey)) {
        if (source === 'remix') return `${actionKey}-maui`;
        if (dynamicUiSubtype && $2a6f93e9fee2ce65$var$DIAGRAM_UI_SUBTYPES.has(dynamicUiSubtype)) return `${actionKey}-diagram`;
    }
    return actionKey;
};
module.exports["getActionPartKeyForMetrics"] = $2a6f93e9fee2ce65$export$f3b7160b60840213;

});

parcelRegister("P3Zwx", function(module, exports) {

var $1jIs1 = parcelRequire("1jIs1");

const $2bb2c0e92fe02e4f$export$9f2ec1867195888b = (interactionSource)=>{
    if (interactionSource !== undefined && (0, $1jIs1.REMIX_INTERACTION_SOURCES).has(interactionSource)) return 'remix';
    if (interactionSource === (0, $1jIs1.SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE)) return 0, $1jIs1.SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE;
    return undefined;
};
module.exports["getInvokedFromInteractionSource"] = $2bb2c0e92fe02e4f$export$9f2ec1867195888b;

});

parcelRegister("4Y0no", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $igOtY = parcelRequire("igOtY");

const $56454c3864f9431b$export$ab93cd1ecacda8ec = (messages, conversation)=>{
    const assistantMessage = messages.find((message)=>(0, $igOtY.isStoreAssistant)(message));
    if ((0, $iDrrr.fg)('rovo_chat_fix_agent_selection_after_cancel')) // fixing the fallback to correctly select an agent if a user cancels a session
    return conversation?.sourceAgentId ?? assistantMessage?.content.message.message.author_id ?? conversation?.agent?.agent_id;
    return conversation?.sourceAgentId ?? assistantMessage?.content.message.message.author_id;
};
module.exports["getSourceAgentId"] = $56454c3864f9431b$export$ab93cd1ecacda8ec;

});

parcelRegister("kZEW9", function(module, exports) {
const $f2c42700118b800b$export$a89606c68db527fb = (streamMessage)=>{
    return {
        messageContent: streamMessage.message?.content,
        messageTemplate: streamMessage.message?.message_template
    };
};
module.exports["getTraceFromStreamMessage"] = $f2c42700118b800b$export$a89606c68db527fb;

});

parcelRegister("kOM0B", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");


var $i7OAD = parcelRequire("i7OAD");


var $irnO2 = parcelRequire("irnO2");


var $dw75i = parcelRequire("dw75i");


var $igOtY = parcelRequire("igOtY");


var $jr1ne = parcelRequire("jr1ne");


var $iWbNp = parcelRequire("iWbNp");


var $eBgZa = parcelRequire("eBgZa");


var $9tiaQ = parcelRequire("9tiaQ");

// Only these classifications get the softer "no content" hint screen.
// Everything else (including missing or unknown) falls through to the error screen.
const $e3b868ed09efd836$var$ABORT_CLASSIFICATIONS = new Set([
    'BAD_USER_PROMPT',
    'GOOD_REPLY_NO_CREATE',
    'EXTERNAL_ERROR'
]);
const $e3b868ed09efd836$export$acbf6433e9af643f = (allMessages, conversationId, traceId, chatContextStoreActions, experienceTracker, getMessages, setMessages, sendMessageLatencyMetrics, cancelStreamingMetrics, commonExperienceAttributes, productKey, minionOutputs)=>{
    // Some products do not require first response to be an action,
    // so exit early when we're not within Confluence
    if (productKey !== 'confluence') return true;
    const humanMessageCount = allMessages.filter((0, $igOtY.isStoreHuman)).length;
    // Only execute on the first human message within the staging area
    if (chatContextStoreActions.getIsStagingArea() && humanMessageCount === 1) {
        const firstAssistantResponse = allMessages.find((0, $igOtY.isStoreAssistant));
        const firstAction = firstAssistantResponse?.content?.message?.message?.actions?.[0];
        const hasCreatableAction = firstAction ? (0, $i7OAD.isCreatableAction)(firstAction) : false;
        // An ask_question action is a valid first response (the agent is asking the user a
        // clarifying/disambiguation question), not a failed content creation. Treat it as
        // valid so the FINAL_RESPONSE is not misclassified as "no content created".
        const isAskQuestionAction = firstAction?.key === (0, $dw75i.ASK_QUESTION_KEY) && (0, $ieeJu.expValEquals)('cc-disambiguation-in-cwr', 'isEnabled', true);
        const authUrl = (0, $jr1ne.extractOutboundAuthLink)(firstAssistantResponse?.content?.message?.message?.content ?? '');
        // this experience has a timeout. since ask_question waits for the user, we cannot
        // bound the time. so we abort it now.
        // AIFC_GENERATE_CONTENT and its other sub experiences are intentionally left open.
        // content creation is still what we're waiting for, it just happens on a later turn.
        if (isAskQuestionAction) experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
            reason: 'ask_question - awaiting user response, cannot bound time',
            attributes: commonExperienceAttributes
        });
        // Experience handling for the scenario where there
        // should be an action returned but there was not
        if (!hasCreatableAction && !isAskQuestionAction) {
            // If authUrl is present, abort the experience
            if (authUrl) {
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
                    reason: 'authentication-required',
                    attributes: commonExperienceAttributes
                });
                (0, $iWbNp.abortGenerateContentChildExperiences)(experienceTracker, 'AIFC_GENERATE_CONTENT aborted - authentication required', commonExperienceAttributes);
            } else {
                // This error should have a user-friendly message, as it will be shown to the user.
                const noActionError = new (0, $9tiaQ.NoActionInvokedError)("Something went wrong on Rovo's end. Please try sending your message again.", {
                    traceId: traceId
                });
                const hasConfluenceCreationTool = minionOutputs?.flat().some((output)=>output.minion_id === 'ConfluenceCreationTool');
                const messageMetadata = firstAssistantResponse?.content?.message?.message?.message_metadata;
                const orchestratorDepthLimitReached = messageMetadata?.orchestrator_depth_limit_reached ?? false;
                const orchestratorContextWindowUsage = messageMetadata?.orchestrator_context_window_usage;
                const classification = messageMetadata?.aifc_no_create_classification;
                const noContentCreatedAttributes = {
                    orchestratorContextWindowUsage: orchestratorContextWindowUsage,
                    orchestratorDepthLimitReached: orchestratorDepthLimitReached,
                    hasConfluenceCreationTool: hasConfluenceCreationTool,
                    noContentCreatedClassification: classification ?? 'NO_CLASSIFICATION_PROVIDED'
                };
                if (!classification || !$e3b868ed09efd836$var$ABORT_CLASSIFICATIONS.has(classification)) {
                    experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
                        error: noActionError,
                        attributes: {
                            ...commonExperienceAttributes,
                            ...noContentCreatedAttributes
                        }
                    });
                    (0, $iWbNp.abortGenerateContentChildExperiences)(experienceTracker, classification ?? 'NO_CLASSIFICATION_PROVIDED', commonExperienceAttributes);
                    const messages = getMessages(conversationId);
                    setMessages(conversationId, [
                        ...messages,
                        (0, $eBgZa.createStoreError)(noActionError)
                    ]);
                    sendMessageLatencyMetrics.cancel();
                    cancelStreamingMetrics();
                    return false;
                }
                // Abort: user prompt or external issue — nudge user to fix the problem
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
                    reason: classification,
                    attributes: {
                        ...commonExperienceAttributes,
                        ...noContentCreatedAttributes
                    }
                });
                (0, $iWbNp.abortGenerateContentChildExperiences)(experienceTracker, classification, commonExperienceAttributes);
                // GOOD_REPLY_NO_CREATE is symptomatic of the user prompting non-creation, which we can also treat as a bad prompt
                const hintVariant = classification === 'EXTERNAL_ERROR' ? 'EXTERNAL_ERROR' : 'BAD_USER_INPUT';
                const messages = getMessages(conversationId);
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'USAGE_HINT',
                        topic: 'NoActionInvokedError',
                        variant: hintVariant
                    }
                ]);
                return true;
            }
        }
    }
    return true;
};
module.exports["handleStagingAreaActionValidation"] = $e3b868ed09efd836$export$acbf6433e9af643f;

});

parcelRegister("bPaiw", function(module, exports) {

var $8A2GO = parcelRequire("8A2GO");


var $hwHCO = parcelRequire("hwHCO");

const $7ccd7e68e8d56362$export$886a0387c1c465f5 = (error)=>{
    if (!error) return false;
    // Server-sent error chunks are wrapped as StreamErrorException and should be excluded
    if (error instanceof (0, $hwHCO.StreamErrorException)) return false;
    // Any ApiError (or object exposing errorAttributes.statusCode) comes from the HTTP layer, so exclude
    if (error instanceof (0, $8A2GO.ApiError) || error?.errorAttributes?.statusCode) return false;
    const message = error?.message;
    // When the backend terminates the stream abruptly we get a JSON parsing error, so we treat it as server-side
    // See onversation-assistant-service/src/services/assistance-service/read-json-stream/index.ts
    if (typeof message === 'string' && message.startsWith('Error Processing Stream Data')) return false;
    // Whatever remains is considered a client/network error
    return true;
};
module.exports["isClientSideStreamingError"] = $7ccd7e68e8d56362$export$886a0387c1c465f5;

});

parcelRegister("2WWTW", function(module, exports) {
const $86fda4fee88137f0$export$419ea2a7c4dc02c6 = (actions)=>Array.isArray(actions) && actions.some((action)=>action?.status === 'planned' || !!action?.confirmationMessage && action?.status !== 'started' && action?.status !== 'finished' && action?.status !== 'cancelled' && action?.status !== 'errored');
module.exports["isFinalResponseAwaitingConfirmation"] = $86fda4fee88137f0$export$419ea2a7c4dc02c6;

});

parcelRegister("k5njB", function(module, exports) {

var $2yWJZ = parcelRequire("2yWJZ");

// The General Agent runtime UUID (DEFAULT_AGENT_UUID) doubles as the Solution Architect Agent
// runtime identity, which is currently the only agent with minion verification implemented. Minion
// verification analytics are gated to this identity (and the default named-id) for that reason.
const $21b951f90b04db4f$var$possible_agents = [
    (0, $2yWJZ.DEFAULT_AGENT_UUID),
    (0, $2yWJZ.DEFAULT_AGENT_NAMED_ID)
];
const $21b951f90b04db4f$var$MINION_VERIFICATION_ITEMS = [
    {
        alias: 'design-solution',
        minionId: 'SolutionArchitectMinion'
    },
    {
        alias: 'rovo-agent-builder',
        minionId: 'AgentBuilderMinion'
    },
    {
        alias: 'build-agent',
        minionId: 'AgentBuilderMinion'
    },
    {
        alias: 'build-automation',
        minionId: 'AutomationWorkflowBuilderMinion'
    }
];
const $21b951f90b04db4f$export$8bfbf77736e8f6e2 = ({ minionAlias: minionAlias, agentId: agentId, minionsOutput: minionsOutput, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    if (!minionAlias) return;
    if (agentId && !$21b951f90b04db4f$var$possible_agents.includes(agentId)) return;
    $21b951f90b04db4f$var$MINION_VERIFICATION_ITEMS.forEach(({ alias: alias, minionId: minionId })=>{
        if (alias !== minionAlias) return;
        const hasAliasMatch = minionsOutput.some((output)=>output.minion_id === minionId);
        sendAnalyticsEvent({
            eventType: 'track',
            action: hasAliasMatch ? 'matched' : 'mismatched',
            actionSubject: 'aiMateMinionVerification',
            attributes: {
                name: minionId
            }
        });
    });
};
module.exports["minionVerificationAnalytics"] = $21b951f90b04db4f$export$8bfbf77736e8f6e2;

});

parcelRegister("3qJlQ", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $4o0zT = parcelRequire("4o0zT");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $i7OAD = parcelRequire("i7OAD");


var $aYC8J = parcelRequire("aYC8J");


var $irnO2 = parcelRequire("irnO2");


var $bxkJA = parcelRequire("bxkJA");


var $9vNm5 = parcelRequire("9vNm5");


var $4JZCe = parcelRequire("4JZCe");


var $401oR = parcelRequire("401oR");


var $k2kly = parcelRequire("k2kly");


var $kNXXO = parcelRequire("kNXXO");


var $1psM9 = parcelRequire("1psM9");


var $gB8YL = parcelRequire("gB8YL");


var $fjUOt = parcelRequire("fjUOt");

/**
 * Recorded when an action chunk carries no `status`, so that an absent status attribute can be
 * told apart from a stage that was never reached.
 */ const $1f5f2c21ff9586f2$var$MISSING_ACTION_STATUS = 'missing';
const $1f5f2c21ff9586f2$export$baa645f348bcec07 = ({ streamMessage: streamMessage, conversationId: conversationId, tmpAssistantMessageId: tmpAssistantMessageId, traceId: traceId, productKey: productKey, deepResearchEnabled: deepResearchEnabled, storeUserMessages: storeUserMessages, streamActionInfo: streamActionInfo, trackingAttributes: trackingAttributes, experienceTracker: experienceTracker, chatContextStoreActions: chatContextStoreActions, getMessages: getMessages, setMessages: setMessages, sendAnalyticsEvent: sendAnalyticsEvent, getIsChatMounted: getIsChatMounted, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, promptStreamHook: promptStreamHook, openChat: openChat, messageSources: messageSources, creationContextParams: creationContextParams, agentId: agentId, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart })=>{
    const isBackendCreationAction = (0, $bxkJA.isStreamMessageWithMessage)(streamMessage) && (0, $aYC8J.isServerSideExecutionAction)(streamMessage.message);
    let actionClassificationInvocationId;
    let actionCompleteInvocationId;
    let commonExperienceAttributes = {
        llmDebugLogsEnabled: storeUserMessages
    };
    if ((0, $bxkJA.isStreamActionClassification)(streamMessage)) {
        (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'working');
        promptStreamHook?.onActionClassification?.(streamMessage, tmpAssistantMessageId, conversationId);
        const actionKey = streamMessage.message.action_key;
        actionClassificationInvocationId = streamMessage.message.invocationId;
        const actualContentType = (0, $i7OAD.getAIFCContentType)({
            key: actionKey
        });
        commonExperienceAttributes = {
            ...commonExperienceAttributes,
            actionKey: actionKey,
            contentType: actualContentType,
            isStagingArea: chatContextStoreActions.getIsStagingArea(),
            humanMessageCount: getMessages(conversationId).filter((m)=>m.type === 'HUMAN').length,
            product: productKey
        };
        if (trackingAttributes.forcedContentType) sendAnalyticsEvent({
            eventType: 'track',
            action: 'compared',
            actionSubject: 'forcedContentType',
            actionSubjectId: 'contentTypeMatch',
            attributes: {
                forcedContentType: trackingAttributes.forcedContentType,
                actualContentType: actualContentType,
                matched: actualContentType.endsWith(`-${trackingAttributes.forcedContentType}`),
                actionKey: actionKey
            }
        });
        const isUpdateAction = (0, $i7OAD.isUpdatableAction)({
            key: actionKey
        });
        if (isUpdateAction && (!commonExperienceAttributes.isStagingArea || commonExperienceAttributes.humanMessageCount > 1)) {
            const rootExperienceName = commonExperienceAttributes.isStagingArea ? (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT : (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT;
            (0, $401oR.startUpdateActionExperiences)({
                experienceTracker: experienceTracker,
                conversationId: conversationId,
                rootExperienceName: rootExperienceName,
                commonExperienceAttributes: commonExperienceAttributes
            });
        }
        const isCreateAction = (0, $i7OAD.isCreatableAction)({
            key: actionKey
        });
        if (isCreateAction) {
            // initial prompt from staging area has its own AIFC_GENERATE_CONTENT experience - dont start this one
            if (!commonExperienceAttributes.isStagingArea || commonExperienceAttributes.humanMessageCount > 1) {
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
                    id: conversationId,
                    collect: (0, $4JZCe.createAifcCreateInChatExperienceCollect)(),
                    attributes: commonExperienceAttributes
                });
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
                    id: conversationId,
                    attributes: {
                        ...commonExperienceAttributes,
                        parentExperienceId: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                    }
                });
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
                    id: conversationId,
                    timeout: deepResearchEnabled ? undefined : 60000,
                    // 60 second timeout
                    attributes: {
                        ...commonExperienceAttributes,
                        parentExperienceId: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
                        [(0, $irnO2.PreviewCardRenderStage).STARTED_AT]: performance.now()
                    }
                });
                // Product AIFC integration is responsible for succeeding this experience.
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
                    id: conversationId,
                    attributes: {
                        ...commonExperienceAttributes,
                        parentExperienceId: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                    }
                });
            } else {
                // update AIFC_GENERATE_CONTENT now that intent detection is complete. This experience starts as the user sends the message on the initial prompt screen
                experienceTracker.updateAttributes({
                    name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
                    attributes: commonExperienceAttributes
                });
                experienceTracker.updateAttributes({
                    name: (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                    attributes: commonExperienceAttributes
                });
            }
        }
    }
    if ((0, $bxkJA.isStreamActionPart)(streamMessage) || (0, $bxkJA.isStreamActionPrepare)(streamMessage)) {
        (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'editing');
        // Update action tracking info
        if (!streamActionInfo.isAction) {
            streamActionInfo.isAction = true;
            streamActionInfo.actionKey = streamMessage.message.key;
        }
        // track attribute for action prepare
        if ((0, $bxkJA.isStreamActionPrepare)(streamMessage) && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
            const actionData = streamMessage.message.data;
            experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
                attributes: {
                    dynamicUiSubtype: actionData?.dynamicUiSubtype
                }
            });
            // Remix flows skip ACTION_CLASSIFICATION and go straight to ACTION_PREPARE,
            // so we start PREVIEW_CARD_RENDER here for remix flows.
            // Only start when rovo chat is mounted/visible to the user.
            const isRemixObjectFlow = creationContextParams?.experience === 'remix_object';
            if (getIsChatMounted?.() && ((0, $aYC8J.isRemixGeneratedFlow)({
                key: streamMessage.message.key,
                data: streamMessage.message.data
            }) || isRemixObjectFlow)) {
                const remixActionKey = streamMessage.message.key;
                const actualContentType = (0, $i7OAD.getAIFCContentType)({
                    key: remixActionKey
                });
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
                    id: conversationId,
                    timeout: 60000,
                    attributes: {
                        ...commonExperienceAttributes,
                        actionKey: remixActionKey,
                        isStagingArea: chatContextStoreActions.getIsStagingArea(),
                        humanMessageCount: getMessages(conversationId).filter((m)=>m.type === 'HUMAN').length,
                        product: productKey,
                        featureArea: 'remix',
                        remixType: (0, $aYC8J.getDynamicUiType)(streamMessage.message),
                        contentType: actualContentType,
                        ...trackingAttributes.forcedContentType && {
                            aifcObjectType: trackingAttributes.forcedContentType
                        },
                        [(0, $irnO2.PreviewCardRenderStage).STARTED_AT]: performance.now()
                    }
                });
            }
        }
        if ((0, $bxkJA.isStreamActionPart)(streamMessage)) {
            experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
                attributes: {
                    [(0, $irnO2.PreviewCardRenderStage).ACTION_PART_AT]: performance.now(),
                    [(0, $irnO2.PreviewCardRenderActionAttribute).ACTION_PART_STATUS]: streamMessage.message.status ?? $1f5f2c21ff9586f2$var$MISSING_ACTION_STATUS
                }
            });
            const actionData = streamMessage.message.data;
            stopInteractionMetricsTimeToFirstActionPart('stop', {
                actionType: 'action-part',
                conversationId: conversationId,
                actionPartKey: (0, $1psM9.getActionPartKeyForMetrics)(streamMessage.message.key, creationContextParams?.source, actionData?.dynamicUiSubtype),
                interactionSource: messageSources?.interactionSource,
                remixType: creationContextParams?.dynamicUiType
            });
        }
        const actionKey = streamMessage.message.key;
        const lastAction = (0, $kNXXO.findLastAssistantAction)(getMessages(conversationId), (action)=>action.key === actionKey);
        if (lastAction && (0, $aYC8J.isAccumulatedAction)(actionKey)) {
            const isAccumulatedActionType = (0, $aYC8J.getAccumulatedActionTypeGuard)(actionKey);
            if (isAccumulatedActionType(streamMessage.message.data)) {
                const primaryAccumulatedData = (0, $aYC8J.getPrimaryAccumulatedValue)(lastAction);
                if (primaryAccumulatedData?.value) streamMessage.message.data.previousAccumulatedData = primaryAccumulatedData.value;
            }
        }
        processMessageStreamAction?.(tmpAssistantMessageId, streamMessage, traceId, trackingAttributes.requestId, undefined, {
            singleInstrumentationId: trackingAttributes.instrumentationId,
            // Forward the originating experience so the editor receiver
            // can auto-open the Post Stream Review "Review moment" only for inline edits.
            experience: creationContextParams?.experience
        }, agentId ? {
            id: agentId,
            name: agentName ?? '',
            identityAccountId: agentIdentityAccountId ?? null
        } : undefined);
        promptStreamHook?.onActionPart?.(streamMessage, tmpAssistantMessageId, conversationId, openChat);
        const updatedMessages = (0, $k2kly.addActionPart)({
            chat: getMessages(conversationId),
            messageId: tmpAssistantMessageId,
            actionPart: streamMessage,
            actionUpdaterOverride: (0, $aYC8J.customActionUpdater)
        });
        if ((0, $bxkJA.isStreamActionPrepare)(streamMessage)) {
            const actionMessage = streamMessage.message;
            experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
                attributes: {
                    [(0, $irnO2.PreviewCardRenderActionAttribute).ACTION_PREPARE_STATUS]: actionMessage.status ?? $1f5f2c21ff9586f2$var$MISSING_ACTION_STATUS
                }
            });
            // Abort the remix-edit-existing UFO experience if the streamed action is not remix.
            if (!(0, $aYC8J.isRemixGeneratedFlow)(actionMessage)) (0, $irnO2.remixEditExistingExperience).abort({
                metadata: {
                    reason: 'non-remix-action'
                }
            });
            setMessages(conversationId, [
                ...updatedMessages,
                {
                    type: 'ACTION_PREPARE',
                    action: actionMessage
                }
            ]);
        } else setMessages(conversationId, updatedMessages);
    }
    const canHandleStreamActionClassification = (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics');
    if ((0, $bxkJA.isStreamActionClassification)(streamMessage) && canHandleStreamActionClassification && streamMessage.message.metadata) // Send ACTION_CLASSIFICATION metadata to the Editor Rovo bridge
    processMessageStreamActionClassification?.(tmpAssistantMessageId, streamMessage, traceId, trackingAttributes.requestId, {
        singleInstrumentationId: trackingAttributes.instrumentationId
    });
    if ((0, $bxkJA.isStreamActionComplete)(streamMessage)) {
        // A doc action completed, but the turn isn't over — more actions or a trailing answer may
        // follow, and the write is still being applied. Keep the node active; `done` fires at the
        // final response (the true turn end).
        (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'editing');
        actionCompleteInvocationId = streamMessage.message.invocationId;
        if (!trackingAttributes.invokedFrom && messageSources?.entryPoint === 'cwrBlankObject' && (0, $4o0zT.isExperimentEnabled)('aifc_invokedfrom_on_reconnect')) {
            const invokedFrom = (0, $gB8YL.getInvokedFrom)({
                messageActionKey: streamMessage.message.key,
                messageActionData: streamMessage.message.data
            });
            if (invokedFrom) trackingAttributes.invokedFrom = invokedFrom;
        }
        promptStreamHook?.onActionComplete?.(streamMessage, tmpAssistantMessageId);
        processMessageStreamComplete?.(tmpAssistantMessageId, streamMessage, traceId, trackingAttributes.requestId, {
            singleInstrumentationId: trackingAttributes.instrumentationId,
            // Forward the originating experience so the editor receiver
            // can auto-open the Post Stream Review "Review moment" only for inline edits.
            experience: creationContextParams?.experience
        });
        const actionMessage = streamMessage.message;
        const shouldTrackBackendCreation = (0, $2pQiO.UNSAFE_expValNoExposure)('cwr-be-based-multi-creation-v0', 'isEnabled', false) && isBackendCreationAction;
        // Match the existing single-create analytics emitted after the Confluence page editor
        // applies its initial content. Backend-created pages bypass that editor path, so emit the
        // same event from their successful ACTION_COMPLETE instead. Keep this page-specific so
        // createdContentType remains accurate; content features are unavailable because no editor
        // document is applied on the frontend, while the backend response supplies the content ID.
        if (shouldTrackBackendCreation && actionMessage.key === (0, $aYC8J.CONFLUENCE_AIFC_PAGE_CREATE_KEY) && (0, $aYC8J.isConfluenceAIFCPageCreateActionData)(actionMessage.data)) sendAnalyticsEvent({
            eventType: 'track',
            actionSubject: 'smartCreateContent',
            action: 'initialContentCreated',
            attributes: {
                createdContentProduct: 'confluence',
                createdContentType: 'page',
                createdContentFeatures: undefined,
                createdContentMetadata: {
                    contentId: actionMessage.data.contentId
                }
            }
        });
        if (isBackendCreationAction && (0, $4o0zT.isExperimentEnabled)('cwr-be-based-multi-creation-v0')) trackingAttributes.messageActions = [
            ...trackingAttributes.messageActions ?? [],
            actionMessage.key
        ];
        let messages = getMessages(conversationId);
        // Insert the completed action only when it isn't already on the message — those actions arrived
        // with no ACTION_PART chunks, so nothing has added them yet. When the action did stream,
        // re-running the accumulator on the completed snapshot would corrupt its accumulated content,
        // so leave it untouched.
        const { invocationId: invocationId } = actionMessage;
        const isActionAlreadyOnMessage = Boolean(invocationId && (0, $kNXXO.findLastAssistantAction)(messages, (action)=>action.invocationId === invocationId));
        if (!isActionAlreadyOnMessage && (0, $cXtTj.default).getExperimentValue('cwr-be-based-multi-creation-v0', 'isEnabled', false)) messages = (0, $k2kly.addActionPart)({
            chat: messages,
            messageId: tmpAssistantMessageId,
            actionPart: streamMessage,
            // The completed action is a full snapshot, so replace rather than accumulate — this avoids
            // double-appending the primary document if a match is ever found.
            actionUpdaterOverride: (_prevAction, nextAction)=>nextAction
        });
        // Stamp the trace ID on this action's assistant message so feedback can report it.
        const messagesWithTraceId = traceId ? messages.map((msg)=>msg.type === 'ASSISTANT' && (0, $fjUOt.getStoreMessageId)(msg) === tmpAssistantMessageId ? {
                ...msg,
                traceId: traceId
            } : msg) : messages;
        setMessages(conversationId, [
            ...messagesWithTraceId,
            {
                type: 'ACTION_COMPLETE',
                action: actionMessage
            }
        ]);
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
            attributes: {
                [(0, $irnO2.PreviewCardRenderStage).ACTION_COMPLETE_AT]: performance.now(),
                [(0, $irnO2.PreviewCardRenderActionAttribute).ACTION_COMPLETE_STATUS]: streamMessage.message.status ?? $1f5f2c21ff9586f2$var$MISSING_ACTION_STATUS,
                // Sanity check that one message did not stream chunks under multiple action keys.
                [(0, $irnO2.PreviewCardRenderActionAttribute).ACTION_COMPLETE_KEY]: streamMessage.message.key
            }
        });
        // Always succeed AIFC_MESSAGE from FINAL_RESPONSE instead for backend multi-create events, or when
        // the parity experiment is enabled to streamline frontend and backend handling.
        if (!((0, $4o0zT.isExperimentEnabled)('cwr-be-based-multi-creation-v0') && isBackendCreationAction || (0, $4o0zT.isExperimentEnabled)('cwr-fe-be-experience-analytics-streamline'))) // When enabled, action completion is handled from FINAL_RESPONSE for both frontend and
        // backend creation so the complete action set is known before the experience succeeds.
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).AIFC_MESSAGE
        });
    }
    return {
        actionClassificationInvocationId: actionClassificationInvocationId,
        actionCompleteInvocationId: actionCompleteInvocationId,
        isBackendCreationAction: isBackendCreationAction
    };
};
module.exports["processAifcActionStreamMessage"] = $1f5f2c21ff9586f2$export$baa645f348bcec07;

});

parcelRegister("cWQeI", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $bxkJA = parcelRequire("bxkJA");


var $igOtY = parcelRequire("igOtY");


var $fjUOt = parcelRequire("fjUOt");


var $fMCXf = parcelRequire("fMCXf");

const $0a4010078ae41b46$var$extractInteractionConclusion = (streamObj, streamMessage, defaultTransport)=>{
    if (typeof streamObj === 'object' && streamObj !== null && 'eventType' in streamObj && streamObj.eventType === 'INTERACTION_CONCLUSION') {
        const data = 'data' in streamObj ? streamObj.data : undefined;
        const normalizedInteractionConclusion = typeof data === 'object' && data !== null ? {
            ...data,
            type: 'INTERACTION_CONCLUSION'
        } : data;
        return (0, $bxkJA.isStreamInteractionConclusion)(normalizedInteractionConclusion) ? {
            kind: 'valid',
            transport: 'sse',
            value: normalizedInteractionConclusion
        } : {
            kind: 'invalid'
        };
    }
    if (typeof streamMessage === 'object' && streamMessage !== null && 'type' in streamMessage && streamMessage.type === 'INTERACTION_CONCLUSION') return (0, $bxkJA.isStreamInteractionConclusion)(streamMessage) ? {
        kind: 'valid',
        transport: defaultTransport,
        value: streamMessage
    } : {
        kind: 'invalid'
    };
    return {
        kind: 'not-present'
    };
};
const $0a4010078ae41b46$export$c68838490373407b = ({ streamObj: streamObj, streamMessage: streamMessage, conversationId: conversationId, answerIndex: answerIndex, requestId: requestId, defaultTransport: defaultTransport = 'direct', getMessages: getMessages, setMessages: setMessages, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    const extraction = $0a4010078ae41b46$var$extractInteractionConclusion(streamObj, streamMessage, defaultTransport);
    if (extraction.kind === 'not-present') return;
    if (!(0, $iDrrr.fg)('rovo_chat_csat_interaction_conclusion_signal') || extraction.kind !== 'valid') return;
    const interactionConclusion = extraction.value;
    const currentMessages = getMessages(conversationId);
    const targetMessage = currentMessages[answerIndex];
    if (!targetMessage || !(0, $igOtY.isStoreAssistant)(targetMessage) || targetMessage.interactionConclusionOutcome === interactionConclusion.message.outcome) return;
    const targetMessageId = (0, $fjUOt.getStoreMessageId)(targetMessage);
    setMessages(conversationId, (0, $fMCXf.updateStoreAssistant)({
        chat: currentMessages,
        promptId: targetMessageId,
        updateFunction: (storeMessage)=>({
                ...storeMessage,
                interactionConclusionOutcome: interactionConclusion.message.outcome
            }),
        updateType: 'Update Interaction Conclusion Outcome',
        useIndex: answerIndex
    }));
    sendAnalyticsEvent({
        eventType: 'track',
        action: 'received',
        actionSubject: 'interactionConclusionSignal',
        attributes: {
            conversationChannelId: conversationId,
            hasBackendMessageId: Boolean(interactionConclusion.metadata?.message_id),
            outcome: interactionConclusion.message.outcome,
            requestId: requestId ?? interactionConclusion.metadata?.request_id,
            transport: extraction.transport
        }
    });
};
module.exports["processInteractionConclusion"] = $0a4010078ae41b46$export$c68838490373407b;

});

parcelRegister("55rUT", function(module, exports) {

var $bxkJA = parcelRequire("bxkJA");


var $kNR5a = parcelRequire("kNR5a");


var $1j9cl = parcelRequire("1j9cl");

const $ec372ef5c573e842$export$5a07e6227eed9665 = ({ streamMessage: streamMessage, tmpAssistantMessageId: tmpAssistantMessageId, conversationId: conversationId, deepResearchEnabled: deepResearchEnabled, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, researchState: researchState })=>{
    let deepResearchInvoked = false;
    if ((0, $bxkJA.isStreamResearchStart)(streamMessage) && // The same message_template is used for thinking deeper + deep research
    // so we need to check the specific trace message to differentiate them
    streamMessage.message.content === 'Starting deep research execution') deepResearchInvoked = true;
    // Implicit round detection for think deeper:
    // When answer content has accumulated (from ANSWER_PART messages) and new
    // research step information arrives, we know a new round is starting.
    // We retroactively create a research plan for the completed round using
    // the accumulated answer content, clear the streamed content, and increment
    // the round counter so subsequent steps are grouped under the new round.
    if (researchState.hasAccumulatedAnswerContent && (0, $bxkJA.isStreamResearchPayload)(streamMessage)) {
        // Read the accumulated answer content from the assistant message
        const accumulatedContent = (0, $1j9cl.getStoreAssistantMessageContent)(getMessages(conversationId), tmpAssistantMessageId);
        // Create a research plan for the completed round with the accumulated content
        addImplicitResearchPlan({
            messageId: tmpAssistantMessageId,
            content: accumulatedContent,
            roundId: researchState.clientRoundCounter
        });
        // Increment round counter for the new incoming steps
        researchState.clientRoundCounter++;
        // Clear the assistant message content so the new round starts fresh
        const clearedMessages = (0, $kNR5a.clearStoreAssistantMessageContent)(getMessages(conversationId), tmpAssistantMessageId);
        setMessages(conversationId, clearedMessages);
        // Reset tracking flags
        researchState.hasAccumulatedAnswerContent = false;
        resetHasReceivedAnswerPart({
            messageId: tmpAssistantMessageId
        });
    }
    if ((0, $bxkJA.isStreamResearchPayload)(streamMessage) || (0, $bxkJA.isStreamResponse)(streamMessage) || (0, $bxkJA.isStreamAnswerPart)(streamMessage) || (0, $bxkJA.isStreamReasoningPart)(streamMessage) || (0, $bxkJA.isStreamSkill)(streamMessage) || (0, $bxkJA.isStreamThinkDeeperTriggered)(streamMessage)) {
        // When implicit rounds are active, override roundId on research step messages
        // so they are grouped under the current client-managed round
        if (researchState.clientRoundCounter > 0 && (0, $bxkJA.isStreamResearchPayload)(streamMessage) && 'message' in streamMessage && 'roundId' in streamMessage.message) streamMessage.message.roundId = researchState.clientRoundCounter;
        processStreamResearch({
            messageId: tmpAssistantMessageId,
            streamMessage: streamMessage,
            isDeepResearch: deepResearchEnabled ?? false
        });
    }
    if ((0, $bxkJA.isStreamResearchPlan)(streamMessage)) processStreamResearch({
        messageId: tmpAssistantMessageId,
        streamMessage: streamMessage,
        isDeepResearch: deepResearchEnabled ?? false
    });
    // Track that answer content has accumulated so implicit round detection
    // can detect a new round starting when the next research payload arrives
    if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) researchState.hasAccumulatedAnswerContent = true;
    return {
        deepResearchInvoked: deepResearchInvoked
    };
};
module.exports["processResearchStreamMessage"] = $ec372ef5c573e842$export$5a07e6227eed9665;

});

parcelRegister("8GeCh", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $3iEfv = parcelRequire("3iEfv");


var $5XX4K = parcelRequire("5XX4K");


var $8bsmP = parcelRequire("8bsmP");


var $eK93A = parcelRequire("eK93A");

const $d8a5551aed11b46f$export$82b32799d0ea512c = ({ streamMessage: streamMessage, messageId: messageId, conversationId: conversationId, sendAnalyticsEvent: sendAnalyticsEvent, shouldPreprocessDetails: shouldPreprocessDetails = false })=>{
    if ((0, $iDrrr.fg)('rovo_chat_history_lift')) {
        const normalizedPresentation = (0, $8bsmP.normalizeFinalizedMessagePresentation)({
            message: streamMessage,
            options: {
                shouldExtractA2UI: false,
                shouldExtractActionableFollowUps: (0, $iDrrr.fg)('rovo_chat_actionable_followups_enabled'),
                shouldExtractDataSculptor: (0, $iDrrr.fg)('rovo_enable_data_sculptor'),
                shouldExtractInlineLumina: (0, $iDrrr.fg)('rovo_chat_enable_inline_lumina'),
                shouldExtractLegacyChartBoundaries: false,
                shouldPreprocessDetails: shouldPreprocessDetails
            }
        });
        if (normalizedPresentation.extractionCounts.expand > 0) sendAnalyticsEvent({
            eventType: 'track',
            action: 'viewed',
            actionSubject: 'expandComponent',
            attributes: {
                messageId: messageId,
                conversationId: conversationId,
                expandCount: normalizedPresentation.extractionCounts.expand,
                timestamp: new Date().toISOString(),
                isFinalResponse: true
            }
        });
        if (normalizedPresentation.extractionCounts.unicodeChart > 0) sendAnalyticsEvent({
            eventType: 'track',
            action: 'extracted',
            actionSubject: 'vizPluginChart',
            attributes: {
                messageId: messageId,
                conversationId: conversationId,
                chartCount: normalizedPresentation.extractionCounts.unicodeChart,
                timestamp: new Date().toISOString()
            }
        });
        return {
            processedStreamMessage: normalizedPresentation.message,
            markdownData: normalizedPresentation.markdownData
        };
    } else {
        let processedStreamMessage = streamMessage;
        const markdownData = {};
        // Applies to the final-response path (non-streaming) and to reconnect replay.
        if (shouldPreprocessDetails) processedStreamMessage = (0, $eK93A.preprocessStreamResponseDetails)(processedStreamMessage);
        if ((0, $iDrrr.fg)('rovo_enable_data_sculptor')) {
            const dataSculptorMsg = (0, $5XX4K.extractMarkdownContent)({
                streamMessage: processedStreamMessage,
                boundaryStart: '[^sculptor:start^]',
                boundaryEnd: '[^sculptor:end^]',
                replacementContent: '[^sculptor^]'
            });
            processedStreamMessage = dataSculptorMsg.processedStreamMessage;
            dataSculptorMsg.boundaryContents.forEach((content, index)=>{
                markdownData[`sculptor-${index}`] = content;
            });
        }
        const expandOpenTag = "\u259E";
        const expandCloseTag = "\u259A";
        const expandPlaceholder = '[^expand^]';
        const expandMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedStreamMessage,
            boundaryStart: expandOpenTag,
            boundaryEnd: expandCloseTag,
            replacementContent: expandPlaceholder
        });
        processedStreamMessage = expandMsg.processedStreamMessage;
        expandMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`expand-${index}`] = content;
        });
        if (expandMsg?.boundaryContents && expandMsg.boundaryContents.length > 0) sendAnalyticsEvent({
            eventType: 'track',
            action: 'viewed',
            actionSubject: 'expandComponent',
            attributes: {
                messageId: messageId,
                conversationId: conversationId,
                expandCount: expandMsg.boundaryContents.length,
                timestamp: new Date().toISOString(),
                isFinalResponse: true
            }
        });
        const chartOpenTag = "\u25F4";
        const chartCloseTag = "\u25F6";
        const chartPlaceholder = '[^chart^]';
        const chartMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedStreamMessage,
            boundaryStart: chartOpenTag,
            boundaryEnd: chartCloseTag,
            replacementContent: chartPlaceholder
        });
        processedStreamMessage = chartMsg.processedStreamMessage;
        chartMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`chart-${index}`] = content;
        });
        if (chartMsg?.boundaryContents && chartMsg.boundaryContents.length > 0) sendAnalyticsEvent({
            eventType: 'track',
            action: 'extracted',
            actionSubject: 'vizPluginChart',
            attributes: {
                messageId: messageId,
                conversationId: conversationId,
                chartCount: chartMsg.boundaryContents.length,
                timestamp: new Date().toISOString()
            }
        });
        if ((0, $iDrrr.fg)('rovo_chat_enable_inline_lumina')) {
            const luminaMsg = (0, $5XX4K.extractMarkdownContent)({
                streamMessage: processedStreamMessage,
                boundaryStart: "\u25D0",
                boundaryEnd: "\u25D1",
                replacementContent: '\n\n[^lumina^]\n\n'
            });
            processedStreamMessage = luminaMsg.processedStreamMessage;
            luminaMsg.boundaryContents.forEach((content, index)=>{
                markdownData[`lumina-${index}`] = content;
            });
        }
        processedStreamMessage = (0, $3iEfv.extractActionableFollowUpsMarkdownData)({
            streamMessage: processedStreamMessage,
            markdownData: markdownData
        });
        return {
            processedStreamMessage: processedStreamMessage,
            markdownData: markdownData
        };
    }
};
module.exports["processStreamResponseMarkdown"] = $d8a5551aed11b46f$export$82b32799d0ea512c;

});

parcelRegister("cKBqb", function(module, exports) {


var $fKnVx = parcelRequire("fKnVx");

// Install `window.top.__rovoStreamResponseOutput__` at module load. This module is
// pulled into the runtime bundle because `processStream` imports the used
// `recordStreamMessage` binding below, so this top-level call is retained (the package
// is marked `sideEffects: ["*.compiled.css"]`, so a bare `import './x'` for effect would
// be tree-shaken away).
(0, $fKnVx.installStreamResponseOutputGetter)();
const $bd1b2048488e5a34$export$7d55b756f7f2ed43 = (message)=>{
    try {
        if (window.top) {
            if (!window.top.__rovoStreamResponseMessages__) window.top.__rovoStreamResponseMessages__ = [];
            const serialised = JSON.stringify(message);
            window.top.__rovoStreamResponseMessages__.push(serialised);
        }
    } catch  {
    // Ignore cross-origin frame access errors
    }
};
module.exports["recordStreamMessage"] = $bd1b2048488e5a34$export$7d55b756f7f2ed43;

});

parcelRegister("fA89f", function(module, exports) {

var $fjUOt = parcelRequire("fjUOt");


var $fMCXf = parcelRequire("fMCXf");

const $387377d6766e3a79$export$60e170089d1b35dd = ({ chat: chat, answerId: answerId, content: content, useIndex: useIndex, humanMessageId: humanMessageId, markdownData: markdownData, traceId: traceId, onMessageIdChanged: onMessageIdChanged })=>(0, $fMCXf.updateStoreAssistant)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeMessage)=>{
            const oldId = (0, $fjUOt.getStoreMessageId)(storeMessage);
            const newId = content.message.message.id;
            if (oldId !== newId) onMessageIdChanged?.(oldId, newId);
            return {
                ...storeMessage,
                content: {
                    ...content,
                    streamingComplete: false
                },
                humanMessageId: humanMessageId,
                markdownData: markdownData,
                traceId: traceId
            };
        },
        updateType: 'Replace Answer Data',
        useIndex: useIndex
    });
module.exports["replaceAnswerData"] = $387377d6766e3a79$export$60e170089d1b35dd;

});

parcelRegister("l4fq3", function(module, exports) {

const $ff8723ce29790d95$export$e3d8e4fb1ec788d1 = ()=>{
    try {
        if (window.top) window.top.__rovoStreamResponseMessages__ = [];
    } catch  {
    // Ignore cross-origin frame access errors
    }
};
module.exports["resetStreamResponseRecording"] = $ff8723ce29790d95$export$e3d8e4fb1ec788d1;

});

parcelRegister("5tsq8", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");


var $042Lk = parcelRequire("042Lk");


var $8Yvi4 = parcelRequire("8Yvi4");


var $kVNt4 = parcelRequire("kVNt4");

function $85a86afb88dde1c4$export$a5165b6c5017830(messages, productKey, isSmartCreationModalOpen = false) {
    if (productKey !== 'confluence' || !(0, $ieeJu.expValEquals)('confluence_fe_create_page_suggestion', 'isEnabled', true)) return false;
    // Already in a content-creation surface — the suggestion would be redundant.
    if (isSmartCreationModalOpen) return false;
    // An `ask_question` response is an interim clarifying step, not a final
    // answer, so there is nothing to "create a page from" yet — don't synthesize
    // the create-page follow-up for it.
    if ((0, $042Lk.lastAssistantHasAskQuestionAction)(messages) && (0, $ieeJu.expValEquals)('cc-disambiguation-in-cwr', 'isEnabled', true)) return false;
    if (!(0, $kVNt4.lastAssistantResponseIsSubstantive)(messages)) return false;
    return !(0, $8Yvi4.lastAssistantHasConfluencePageAction)(messages);
}
module.exports["shouldAppendCreatePageFollowUp"] = $85a86afb88dde1c4$export$a5165b6c5017830;

});

parcelRegister("6OcY6", function(module, exports) {

var $hq9Cp = parcelRequire("hq9Cp");


var $dCJIZ = parcelRequire("dCJIZ");

const $927c732e26323e49$export$de552dcf26f1e520 = (state, conversationId)=>{
    const creatorType = (0, $dCJIZ.getConversation)(state, conversationId)?.agent?.creator_type;
    return !!creatorType && (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType);
};
module.exports["shouldPreprocessDetailsForConversation"] = $927c732e26323e49$export$de552dcf26f1e520;

});

parcelRegister("dnZkY", function(module, exports) {

var $igOtY = parcelRequire("igOtY");

const $5bb7c976e002305a$export$ba29913b663b084c = ({ chat: chat, oldId: oldId, newId: newId, parentMessageId: parentMessageId, onMessageIdChanged: onMessageIdChanged })=>chat.map((message)=>{
        if ((0, $igOtY.isStoreHuman)(message) && message.content.id === oldId) {
            onMessageIdChanged?.(oldId, newId);
            return {
                ...message,
                content: {
                    ...message.content,
                    id: newId,
                    ...parentMessageId && {
                        parent_message_id: parentMessageId
                    }
                }
            };
        }
        return message;
    });
module.exports["updateHumanMessageId"] = $5bb7c976e002305a$export$ba29913b663b084c;

});

parcelRegister("fS02I", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $fjUOt = parcelRequire("fjUOt");

const $a9c77291ad58ec01$export$14aeb537f795ee1a = (messages, messageId, answerNowStatus)=>{
    return messages.map((chatItem)=>{
        if ((0, $igOtY.isStoreAssistant)(chatItem) && (0, $fjUOt.getStoreMessageId)(chatItem) === messageId) return {
            ...chatItem,
            answerNowStatus: answerNowStatus
        };
        return chatItem;
    });
};
module.exports["updateStoreAssistantMessageAnswerNowStatus"] = $a9c77291ad58ec01$export$14aeb537f795ee1a;

});

parcelRegister("NbBdO", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $fMCXf = parcelRequire("fMCXf");

const $822490bee3d17b8f$export$f279e50afd80e7d8 = ({ chat: chat, oldId: oldId, newId: newId })=>{
    const updatedChat = (0, $fMCXf.updateStoreAssistant)({
        chat: chat,
        promptId: oldId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...storeAssistant.content,
                    message: {
                        ...storeAssistant.content.message,
                        message: {
                            ...storeAssistant.content.message.message,
                            id: newId
                        }
                    }
                }
            }),
        updateType: 'Update Store Assistant Message ID'
    });
    return updatedChat.map((message)=>(0, $igOtY.isStoreFollowUp)(message) && message.agentMessageId === oldId ? {
            ...message,
            agentMessageId: newId
        } : message);
};
module.exports["updateStoreAssistantMessageId"] = $822490bee3d17b8f$export$f279e50afd80e7d8;

});

parcelRegister("gDqX2", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");

/**
 * Abort-aware sleep that resolves after `ms` or rejects early if the signal is aborted.
 * Falls back to a regular setTimeout when no signal is provided.
 */ const $e1432663f5f143d6$var$abortableSleep = (ms, signal)=>new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            return;
        }
        let cleanup = ()=>{};
        const timer = setTimeout(()=>{
            cleanup();
            resolve();
        }, ms);
        if (signal) {
            const onAbort = ()=>{
                clearTimeout(timer);
                cleanup();
                reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            };
            cleanup = (0, $cbY7C.bind)(signal, {
                type: 'abort',
                listener: onAbort,
                options: {
                    once: true
                }
            });
        }
    });
/**
 * Resolves when the browser reports it is online.
 * Returns immediately if already online, otherwise waits for the 'online' event.
 * Rejects if the signal is aborted while waiting.
 * @returns true if it had to wait for the 'online' event, false if already online.
 * Useful to distinguish between "was offline and recovered" vs "was already online".
 */ const $e1432663f5f143d6$var$waitForOnline = (signal)=>{
    if (typeof navigator === 'undefined' || navigator.onLine) return Promise.resolve(false);
    return new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            return;
        }
        const onOnline = ()=>{
            cleanup();
            resolve(true);
        };
        const onAbort = ()=>{
            cleanup();
            reject(signal?.reason ?? new DOMException('Aborted', 'AbortError'));
        };
        const unbindOnline = (0, $cbY7C.bind)(window, {
            type: 'online',
            listener: onOnline,
            options: {
                once: true
            }
        });
        const unbindAbort = signal ? (0, $cbY7C.bind)(signal, {
            type: 'abort',
            listener: onAbort,
            options: {
                once: true
            }
        }) : ()=>{};
        const cleanup = ()=>{
            unbindOnline();
            unbindAbort();
        };
    });
};
const $e1432663f5f143d6$export$4dfcad98182a1ece = async ({ fn: fn, maxRetries: maxRetries = 3, retryCount: retryCount = 0, delay: delay = 1000, jitter: jitter = false, minDelay: minDelay = 500, pauseWhileOffline: pauseWhileOffline = false, postOnlineDelay: postOnlineDelay = 0, errorFilter: errorFilter, signal: signal, onRetry: onRetry })=>{
    // Mutable counter shared across recursive calls so that resetRetries() can
    // reset it from within fn() without needing to re-enter the call stack.
    const counter = {
        retryCount: retryCount,
        delay: delay
    };
    const resetRetries = ()=>{
        counter.retryCount = 0;
        counter.delay = delay;
    };
    const attempt = async ()=>{
        try {
            return await fn(resetRetries);
        } catch (error) {
            if (errorFilter && !errorFilter(error)) throw error;
            if (counter.retryCount >= maxRetries) throw error;
            onRetry?.(counter.retryCount + 1, error);
            if (pauseWhileOffline) {
                const recoveredFromOffline = await $e1432663f5f143d6$var$waitForOnline(signal);
                if (recoveredFromOffline && postOnlineDelay > 0) await $e1432663f5f143d6$var$abortableSleep(postOnlineDelay, signal);
            }
            const effectiveDelay = typeof jitter === 'number' ? counter.delay + Math.random() * jitter : jitter ? Math.max(minDelay, Math.random() * counter.delay) : counter.delay;
            await $e1432663f5f143d6$var$abortableSleep(effectiveDelay, signal);
            counter.delay *= 2;
            counter.retryCount += 1;
            return attempt();
        }
    };
    return attempt();
};
module.exports["exponentialRetry"] = $e1432663f5f143d6$export$4dfcad98182a1ece;

});

parcelRegister("58LQ9", function(module, exports) {

var $bQxqB = parcelRequire("bQxqB");


var $bPaiw = parcelRequire("bPaiw");

const $0be159bbeccab38a$export$4eef7b24ec94bbe8 = (error)=>{
    if (error instanceof Error && error.name === 'AbortError') return false;
    // StreamGeneratorError wraps the original error as `cause` — check the underlying error
    if (error instanceof (0, $bQxqB.StreamGeneratorError)) return (0, $bPaiw.isClientSideStreamingError)(error.cause ?? error);
    return (0, $bPaiw.isClientSideStreamingError)(error);
};
module.exports["isRetryableReconnectionError"] = $0be159bbeccab38a$export$4eef7b24ec94bbe8;

});

parcelRegister("2H7fQ", function(module, exports) {

var $iDdTC = parcelRequire("iDdTC");


var $gFYIV = parcelRequire("gFYIV");

// Reconnection metrics
const $91c3421ad4d4e45f$var$TIME_TO_CONNECT_TO_STREAM_METRICS_KEY = 'ai-mate.reconnect.time-to-connect-to-stream';
const $91c3421ad4d4e45f$var$TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY = 'ai-mate.reconnect.time-to-first-chunk-received';
const $91c3421ad4d4e45f$export$924cdb4a6542ccd = {
    createTimeToConnectToStreamMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $gFYIV.getMessageMetricsNameWithParams)($91c3421ad4d4e45f$var$TIME_TO_CONNECT_TO_STREAM_METRICS_KEY, params)
        });
    },
    createTimeToResumeStreamMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $gFYIV.getMessageMetricsNameWithParams)($91c3421ad4d4e45f$var$TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY, params)
        });
    }
};
module.exports["reconnectionMetrics"] = $91c3421ad4d4e45f$export$924cdb4a6542ccd;

});

parcelRegister("7GlM0", function(module, exports) {

var $FLRLd = parcelRequire("FLRLd");

const $9e2a091fd8de78fd$export$9de2c1973de15b05 = (sources)=>{
    if (!sources) return {};
    const citedProductList = {};
    sources.forEach((source)=>{
        const productName = (0, $FLRLd.extractProductNameFromARI)(source.ari);
        if (productName) citedProductList[productName] = (citedProductList[productName] ?? 0) + 1;
    });
    return citedProductList;
};
module.exports["constructCitedProductList"] = $9e2a091fd8de78fd$export$9de2c1973de15b05;

});

parcelRegister("cOfHE", function(module, exports) {
const $748301a6da4ec55d$export$66fc5003b23b7a8c = (sources)=>{
    if (!sources) return {};
    const products = {};
    sources.forEach((source)=>{
        const productName = source.product;
        if (productName) products[productName] = (products[productName] ?? 0) + 1;
    });
    return products;
};
module.exports["constructSourceProducts"] = $748301a6da4ec55d$export$66fc5003b23b7a8c;

});

parcelRegister("3ArZy", function(module, exports) {
const $e592fdf33e58fb71$var$serviceDeskSourceRegex = /https:\/\/[a-zA-Z0-9_.-]+\/servicedesk\/customer\//g;
const $e592fdf33e58fb71$export$b9ac6250c4aba7c6 = (pluginOutput)=>{
    return $e592fdf33e58fb71$var$serviceDeskSourceRegex.test(pluginOutput);
};
module.exports["containsServiceDeskSource"] = $e592fdf33e58fb71$export$b9ac6250c4aba7c6;

});

parcelRegister("k2kly", function(module, exports) {

var $bkEBw = parcelRequire("bkEBw");


var $igOtY = parcelRequire("igOtY");


var $fMCXf = parcelRequire("fMCXf");

const $ce5a795e167dd10b$export$13b6a4e4e3704011 = ({ chat: chat, messageId: messageId, actionPart: actionPart, useIndex: useIndex, actionUpdaterOverride: actionUpdaterOverride })=>{
    const findMessage = chat.findIndex((message)=>(0, $igOtY.isStoreAssistant)(message) && (0, $bkEBw.getId)(message.content) === messageId);
    const actionIndex = findMessage > 0 ? findMessage : chat.length - 1;
    const index = useIndex || actionIndex;
    return (0, $fMCXf.updateStoreAssistant)({
        chat: chat,
        promptId: messageId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $bkEBw.addActionPart)(storeAssistant.content, actionPart, actionUpdaterOverride)
                }
            }),
        updateType: 'Add Action Part',
        useIndex: index
    });
};
module.exports["addActionPart"] = $ce5a795e167dd10b$export$13b6a4e4e3704011;

});

parcelRegister("gDq7w", function(module, exports) {
/**
 * Per the AI Feature Instrumentation for KRs contract with DE/DS. Two maps live here so JSM can
 * own eligibility in one file; they must stay separate:
 *
 * - MCI_KR_SERVICE_OPS_CONFIG tags `aiResult viewed` via substring match on skill/minion/plugin/
 *   agent identifiers.
 * - MCI_KR_ACTION_KEY_CONFIG tags `aiResult actioned` via exact `actionKey` match.
 *
 * Do not add action keys to MCI_KR_SERVICE_OPS_CONFIG (that would tag viewed). Do not feed action
 * keys through mciKrAttributes (substring).
 */ const $8000f26bd38f9a67$export$a5d1d4b2733f96ab = {
    // Agent example — matched via agentExternalConfigReference
    jsm_example_agent: {
        serviceOrOps: 'ops',
        countsTowardMciPlusKr: true
    },
    // Skill example — matches any skill/minion name containing this substring
    jsm_atlassian_work_item: {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    SurveysStratusMinion: {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    jsm_service_triage_agent: {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    }
};
const $8000f26bd38f9a67$export$2645f5d97480779e = {
    // Request type
    'jsm-atlassian-project-create-jsm-request-type': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-project-create-jsm-request-type-with-fields': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    SuggestAndAddFieldsToRequestType: {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-project-update-request-type-groups': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-request-type-update-workflow': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    // Queue
    'jsm-atlassian-project-create-jsm-queue': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-project-update-jsm-queue': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-project-create-jsm-queue-group': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-project-update-jsm-queue-group': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    }
};
module.exports["MCI_KR_SERVICE_OPS_CONFIG"] = $8000f26bd38f9a67$export$a5d1d4b2733f96ab;

});

parcelRegister("fMCXf", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $32ovr = parcelRequire("32ovr");

const $746b4e9283597e00$export$b59f7aedf84d58f7 = ({ chat: chat, promptId: promptId, updateFunction: updateFunction, updateType: updateType, useIndex: useIndex })=>(0, $32ovr.updateStoreMessage)({
        chat: chat,
        messageId: promptId,
        updateFunction: (storeMessage)=>{
            if (!(0, $igOtY.isStoreAssistant)(storeMessage)) throw new Error(`Attempting to update a non StoreAssistant (${updateType})`);
            return updateFunction(storeMessage);
        },
        updateType: updateType,
        useIndex: useIndex
    });
module.exports["updateStoreAssistant"] = $746b4e9283597e00$export$b59f7aedf84d58f7;

});

parcelRegister("7MYAM", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6Bfyn = parcelRequire("6Bfyn");


var $4vH8u = parcelRequire("4vH8u");

const $bcd61a1d71eeba44$export$c37d58cb6fcaff84 = ()=>[
        {
            key: 'expand',
            startTag: "\u259E",
            endTag: "\u259A",
            placeholderTag: '[^expand^]',
            isEnabled: true
        },
        {
            key: 'chart',
            startTag: "\u25F4",
            endTag: "\u25F6",
            placeholderTag: '[^chart^]',
            isEnabled: true
        },
        {
            key: 'lumina',
            startTag: "\u25D0",
            endTag: "\u25D1",
            placeholderTag: '\n\n[^lumina^]\n\n',
            isEnabled: (0, $iDrrr.fg)('rovo_chat_enable_inline_lumina')
        },
        {
            // Actionable follow-up questions: a single start marker with no end marker —
            // everything after `◈` to the end of the message is the follow-ups payload.
            // An empty endTag tells the parser to capture to end-of-message.
            key: (0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY),
            startTag: (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_MARKER),
            endTag: '',
            placeholderTag: `\n\n[^${(0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY)}^]\n\n`,
            isEnabled: (0, $iDrrr.fg)('rovo_chat_actionable_followups_enabled')
        }
    ];
module.exports["getStreamableComponents"] = $bcd61a1d71eeba44$export$c37d58cb6fcaff84;

});

parcelRegister("6KQVM", function(module, exports) {

var $iDdTC = parcelRequire("iDdTC");

const $a009f4a9a2158e28$export$4841ee9a7190fdf6 = {
    createDeadAirIntervalMetrics: ()=>{
        return (0, $iDdTC.metrics).interaction({
            key: 'ai-mate.dead-air-interval'
        });
    },
    createDeadAirMaxMetrics: ()=>{
        return (0, $iDdTC.metrics).interaction({
            key: 'ai-mate.dead-air-max'
        });
    }
};
module.exports["deadAirMetrics"] = $a009f4a9a2158e28$export$4841ee9a7190fdf6;

});

parcelRegister("9tiaQ", function(module, exports) {

var $64wzj = parcelRequire("64wzj");

class $bc8b43680017f30e$export$17fb3253ebc25334 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        this.errorAttributes = {
            traceId: params.traceId ?? `NoActionInvoked-${(0, $64wzj.generateTraceId)()}`
        };
    }
}
module.exports["NoActionInvokedError"] = $bc8b43680017f30e$export$17fb3253ebc25334;

});

parcelRegister("4JZCe", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $hpOyG = parcelRequire("hpOyG");


var $1Tpom = parcelRequire("1Tpom");

const $f133b76f1d89ee64$export$3ba003c3111d103f = ()=>{
    const subExperienceCollect = (0, $hpOyG.collectAllWithSubExperienceAttributes)([
        (0, $irnO2.ExperienceName).AIFC_MESSAGE,
        (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER
    ]);
    return (events, experience)=>{
        // these experiences only run if the user chooses to open the preview while streaming is in progress. if they fail, bubble it up, but we dont rely on them for success/abort, because they may not even start
        (0, $1Tpom.failExperienceOnSubExperienceFail)((0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED, experience, events);
        (0, $1Tpom.failExperienceOnSubExperienceFail)((0, $irnO2.ExperienceName).PREVIEW_CONTENT, experience, events);
        subExperienceCollect(events, experience);
    };
};
module.exports["createAifcCreateInChatExperienceCollect"] = $f133b76f1d89ee64$export$3ba003c3111d103f;

});

parcelRegister("401oR", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $irnO2 = parcelRequire("irnO2");


var $1dlVf = parcelRequire("1dlVf");

const $69e9e652c7b59edc$export$95d2102da86339f1 = ({ experienceTracker: experienceTracker, conversationId: conversationId, rootExperienceName: rootExperienceName, commonExperienceAttributes: commonExperienceAttributes })=>{
    experienceTracker.start({
        name: rootExperienceName,
        id: conversationId,
        collect: (0, $1dlVf.createAifcExperienceCollect)(),
        attributes: commonExperienceAttributes
    });
    // Start AIFC_ALL_DATA_HANDLED - this replaces all explicit AIFC_UPDATE_CONTENT succeed/fail/abort calls
    // Product AIFC integration is responsible for succeeding this experience.
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
        id: conversationId,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
        id: conversationId,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
    if ((0, $iDrrr.fg)('aifc-experience-timeout')) experienceTracker.start({
        name: (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        id: `${conversationId}-initial`,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
};
module.exports["startUpdateActionExperiences"] = $69e9e652c7b59edc$export$95d2102da86339f1;

});

parcelRegister("kNR5a", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $fjUOt = parcelRequire("fjUOt");

const $c4abac6b845cca29$export$bb0ca99caffb8502 = (messages, messageId)=>{
    return messages.map((chatItem)=>{
        if ((0, $igOtY.isStoreAssistant)(chatItem) && (0, $fjUOt.getStoreMessageId)(chatItem) === messageId) return {
            ...chatItem,
            content: {
                ...chatItem.content,
                message: {
                    ...chatItem.content.message,
                    message: {
                        ...chatItem.content.message.message,
                        content: ''
                    }
                },
                streamingComplete: false
            }
        };
        return chatItem;
    });
};
module.exports["clearStoreAssistantMessageContent"] = $c4abac6b845cca29$export$bb0ca99caffb8502;

});

parcelRegister("1j9cl", function(module, exports) {

var $bkEBw = parcelRequire("bkEBw");


var $igOtY = parcelRequire("igOtY");

const $b66867d306226491$export$9c657fdfae6b2020 = (messages, messageId)=>{
    const assistantMessage = messages.find((chatItem)=>(0, $igOtY.isStoreAssistant)(chatItem) && (0, $bkEBw.getId)(chatItem.content) === messageId);
    if (!assistantMessage) return '';
    const content = assistantMessage.content.message.message.content;
    return typeof content === 'string' ? content : '';
};
module.exports["getStoreAssistantMessageContent"] = $b66867d306226491$export$9c657fdfae6b2020;

});

parcelRegister("fKnVx", function(module, exports) {


var $527XM = parcelRequire("527XM");

const $6183d90d38791925$export$a50d66ef75a63fe5 = ()=>{
    try {
        if (window.top) window.top.__rovoStreamResponseOutput__ = (0, $527XM.getStreamResponseOutput);
    } catch  {
    // Ignore cross-origin frame access errors
    }
};
module.exports["installStreamResponseOutputGetter"] = $6183d90d38791925$export$a50d66ef75a63fe5;

});

parcelRegister("042Lk", function(module, exports) {

var $dw75i = parcelRequire("dw75i");


var $cHkvP = parcelRequire("cHkvP");

function $15425edb4a069f0c$export$daae0e815c1fe242(messages) {
    return (0, $cHkvP.getLastAssistantActions)(messages).some((action)=>action.key === (0, $dw75i.ASK_QUESTION_KEY));
}
module.exports["lastAssistantHasAskQuestionAction"] = $15425edb4a069f0c$export$daae0e815c1fe242;

});

parcelRegister("8Yvi4", function(module, exports) {

var $aYC8J = parcelRequire("aYC8J");


var $dw75i = parcelRequire("dw75i");


var $cHkvP = parcelRequire("cHkvP");

function $a6228cb40d8c3db2$export$12e85b2979bdbb52(messages) {
    return (0, $cHkvP.getLastAssistantActions)(messages).some((action)=>(0, $aYC8J.isConfluenceCreatableAction)({
            key: action.key
        }) || (0, $aYC8J.isConfluenceUpdatableAction)({
            key: action.key
        }) || action.key === (0, $dw75i.CONFLUENCE_PAGE_CREATE_KEY));
}
module.exports["lastAssistantHasConfluencePageAction"] = $a6228cb40d8c3db2$export$12e85b2979bdbb52;

});

parcelRegister("kVNt4", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $lkMfa = parcelRequire("lkMfa");


var $2g97a = parcelRequire("2g97a");

function $e4f1bb76d5176be7$export$d8415dc9fe63acbe(messages, minLength = (0, $lkMfa.CREATE_PAGE_FOLLOWUP_MIN_RESPONSE_LENGTH)) {
    const lastAssistant = (0, $2g97a.findLast)(messages, (0, $igOtY.isStoreAssistant));
    const content = lastAssistant?.content?.message?.message?.content;
    if (content == null) // No assistant response yet — nothing to create a page from.
    return false;
    if (typeof content !== 'string') // Rich/structured content can't be cheaply measured — treat as substantive.
    return true;
    return content.trim().length >= minLength;
}
module.exports["lastAssistantResponseIsSubstantive"] = $e4f1bb76d5176be7$export$d8415dc9fe63acbe;

});

parcelRegister("FLRLd", function(module, exports) {
const $448c18b127d2b815$export$ed5572b558d71438 = (ari)=>{
    if (!ari) return null;
    // see go/ari for possible values
    // Example:
    // ari:third-party:amplitude.amplitude::remote-link/org/{orgId}/chart/{chartId}
    // -> amplitude
    const ariParts = ari.split(':');
    if (ariParts.length < 3) return null;
    return ariParts[2];
};
module.exports["extractProductNameFromARI"] = $448c18b127d2b815$export$ed5572b558d71438;

});

parcelRegister("32ovr", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $4BHwn = parcelRequire("4BHwn");


var $fjUOt = parcelRequire("fjUOt");

const $dba47434e0afdee5$export$df3bbc746f48d870 = ({ chat: chat, messageId: messageId, updateFunction: updateFunction, updateType: updateType, useIndex: useIndex })=>{
    // If the chat is empty, return it as is - prevents the 'in' of 'undefined' errors we were seeing
    // TODO: Take this into account with upcoming refactor
    if (!chat.length) return chat;
    const targetIndex = useIndex || (0, $4BHwn.findStoreMessageIndex)(chat, messageId);
    const targetStoreMessage = chat[targetIndex];
    if (targetIndex < 0 || !(0, $igOtY.isStoreMessage)(targetStoreMessage)) throw new Error(`Attempting to update a non StoreMessage (${updateType})`);
    if ((0, $fjUOt.getStoreMessageId)(targetStoreMessage) !== messageId) throw new Error(`Attempting to update a store message at the wrong index (${updateType})`);
    const newStoreMessage = updateFunction(targetStoreMessage);
    const newChat = [
        ...chat
    ];
    newChat.splice(targetIndex, 1, newStoreMessage);
    return newChat;
};
module.exports["updateStoreMessage"] = $dba47434e0afdee5$export$df3bbc746f48d870;

});

parcelRegister("527XM", function(module, exports) {

const $c7a5ce35f595c3fa$export$e884abe68ebbc0aa = ()=>{
    try {
        const messages = window.top?.__rovoStreamResponseMessages__ ?? [];
        return messages.join('\n');
    } catch  {
        // Ignore cross-origin frame access errors
        return '';
    }
};
module.exports["getStreamResponseOutput"] = $c7a5ce35f595c3fa$export$e884abe68ebbc0aa;

});

parcelRegister("cHkvP", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $2g97a = parcelRequire("2g97a");

function $92531449a63cd135$export$61d3f10a1a228aae(messages) {
    const lastAssistant = (0, $2g97a.findLast)(messages, (0, $igOtY.isStoreAssistant));
    return lastAssistant?.content?.message?.message?.actions ?? [];
}
module.exports["getLastAssistantActions"] = $92531449a63cd135$export$61d3f10a1a228aae;

});

parcelRegister("lkMfa", function(module, exports) {
/** Min response length (trimmed chars) worth offering a page for; filters trivial answers like "2". */ const $4907e9c8fcfc5bb2$export$7fd604660ea8b00b = 200;
module.exports["CREATE_PAGE_FOLLOWUP_MIN_RESPONSE_LENGTH"] = $4907e9c8fcfc5bb2$export$7fd604660ea8b00b;

});


//# sourceMappingURL=FullPageEditorComponent.ac45ca16.js.map
